import { createContext as X5, useState as io, useCallback as aa, useEffect as so, createElement as Z5, useContext as vr, useMemo as G1 } from "react";
(function() {
  try {
    if (typeof document < "u") {
      var r = document.createElement("style");
      r.appendChild(document.createTextNode('@import"https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap";@keyframes _rotation_1lu6v_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1lu6v_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1lu6v_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1lu6v_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1lu6v_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1lu6v_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1lu6v_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._stack_1lu6v_81{align-items:flex-start;box-sizing:border-box;display:flex;flex-direction:row;justify-content:flex-start}._stack--align-center_1lu6v_88{align-items:center}._stack--align-end_1lu6v_91{align-items:flex-end}._stack--justify-between_1lu6v_94{justify-content:space-between}._stack--full-height_1lu6v_97{height:100%}._stack--full-width_1lu6v_100{width:100%}._stack--grow_1lu6v_103{flex-grow:1}._stack--justify-center_1lu6v_106{justify-content:center}._stack--justify-end_1lu6v_109{justify-content:flex-end}._stack--justify-evenly_1lu6v_112{justify-content:space-evenly}._stack--spacing-xs_1lu6v_115{gap:.325rem}._stack--spacing-sm_1lu6v_118{gap:.75rem}._stack--spacing-md_1lu6v_121{gap:1.5rem}._stack--spacing-lg_1lu6v_124{gap:2rem}._stack--spacing-xl_1lu6v_127{gap:2.5rem}._stack--vertical_1lu6v_130{flex-direction:column}@keyframes _rotation_1ou26_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1ou26_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1ou26_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1ou26_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1ou26_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1ou26_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1ou26_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._button_1ou26_90{transition:background-color .3s ease,border-color .3s ease,color .3s ease;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#8d029b;border-color:#8d029b;border-style:solid;border-radius:9999px;border-width:1px;color:#fff;cursor:pointer;display:inline-flex;font-family:Nunito,sans-serif;font-size:1rem;font-style:normal;font-weight:600;height:3rem;justify-content:center;line-height:1.2;min-width:3rem;padding-inline-end:1.5rem;padding-inline-start:1.5rem;text-align:center}._button_1ou26_90[data-color-mode=dark]{background-color:#e0b0ff;border-color:#e0b0ff;color:#1a202c}._button_1ou26_90:hover{background-color:#7b0285;border-color:#7b0285}._button_1ou26_90:hover[data-color-mode=dark]{background-color:#c875ff;border-color:#c875ff}._button--full-width_1ou26_128{width:100%}._button--disabled_1ou26_131,._button--disabled_1ou26_131[data-color-mode=dark],._button--disabled_1ou26_131:hover,._button--disabled_1ou26_131:hover[data-color-mode=dark]{background-color:#cbd5e0;border-color:#cbd5e0;color:#4a5568;cursor:not-allowed;opacity:.3}._button--secondary_1ou26_159{background-color:transparent;color:#8d029b}._button--secondary_1ou26_159[data-color-mode=dark]{background-color:transparent;color:#e0b0ff}._button--secondary_1ou26_159:hover{background-color:#edf2f7;border-color:#8d029b;color:#8d029b}._button--secondary_1ou26_159:hover[data-color-mode=dark]{background-color:#ffffff0f;border-color:#e0b0ff;color:#e0b0ff}._button--xs_1ou26_177{font-size:.625rem;height:1.5rem;line-height:.75;padding-inline-end:.625rem;padding-inline-start:.625rem}._button--sm_1ou26_184{font-size:.75rem;height:2rem;line-height:1;padding-inline-end:.75rem;padding-inline-start:.75rem}._button--lg_1ou26_191{font-size:1.5rem;height:4rem;line-height:2;padding-inline-end:1.5rem;padding-inline-start:1.5rem}._button--xl_1ou26_198{font-size:2rem;height:5rem;line-height:2.5;padding-inline-end:2rem;padding-inline-start:2rem}._icon_1ou26_206{height:1.5rem;width:1.5rem}._icon--xs_1ou26_210{height:.75rem;width:.75rem}._icon--sm_1ou26_214{height:1rem;width:1rem}._icon--lg_1ou26_218{height:2rem;width:2rem}._icon--xl_1ou26_222{height:2.5rem;width:2.5rem}@keyframes _rotation_1t9k0_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1t9k0_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1t9k0_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1t9k0_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1t9k0_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1t9k0_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1t9k0_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_1t9k0_66{align-items:center;display:flex;height:6rem;justify-content:center;position:relative;width:6rem}._container--xs_1t9k0_74{height:3rem;width:3rem}._container--sm_1t9k0_78{height:4rem;width:4rem}._container--lg_1t9k0_82{height:9rem;width:9rem}._container--xl_1t9k0_86{height:14rem;width:14rem}._icon_1t9k0_91{height:2rem;width:2rem}._icon--xs_1t9k0_95{height:1rem;width:1rem}._icon--sm_1t9k0_99{height:1.25rem;width:1.25rem}._icon--lg_1t9k0_103{height:3.5rem;width:3.5rem}._icon--xl_1t9k0_107{height:6rem;width:6rem}._loader_1t9k0_112{animation:_rotation_1t9k0_1 1s linear infinite;border-color:#8d029b;border-bottom-color:#cbd5e0;border-style:solid;border-width:3px;border-radius:50%;box-sizing:border-box;display:inline-block;height:100%;position:absolute;width:100%}._loader_1t9k0_112[data-color-mode=dark]{border-color:#e0b0ff;border-bottom-color:#ffffff3d}._loader--lg_1t9k0_129{border-width:5px}._loader--xl_1t9k0_132{border-width:8px}@keyframes _rotation_xvwg2_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_xvwg2_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_xvwg2_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_xvwg2_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_xvwg2_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_xvwg2_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_xvwg2_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._text_xvwg2_90{font-weight:400;margin:0;padding:0;color:#4a5568;font-family:Nunito,sans-serif;font-size:.875rem;font-style:normal;line-height:1.5rem;text-align:inherit}._text_xvwg2_90[data-color-mode=dark]{color:#fffc}._text__align--center_xvwg2_105{text-align:center}._text__align--initial_xvwg2_108{text-align:initial}._text__align--justify_xvwg2_111{text-align:justify}._text__align--justify-all_xvwg2_114{text-align:justify-all}._text__align--left_xvwg2_117{text-align:left}._text__align--right_xvwg2_120{text-align:right}._text--bold_xvwg2_123{font-weight:700}._text--full-width_xvwg2_126{width:100%}._text--xs_xvwg2_129{font-size:.625rem;line-height:1rem}._text--sm_xvwg2_133{font-size:.75rem;line-height:1.25rem}._text--lg_xvwg2_137{font-size:1rem}._text--xl_xvwg2_140{font-size:1.125rem}._text--truncate_xvwg2_143{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@keyframes _rotation_chktv_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_chktv_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_chktv_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_chktv_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_chktv_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_chktv_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_chktv_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_chktv_81{background-color:#ef4444;border-radius:14px;width:100%}._container_chktv_81[data-color-mode=dark]{background-color:#f87171}._icon_chktv_90{height:2rem;width:2rem}@keyframes _rotation_r51yu_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_r51yu_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_r51yu_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_r51yu_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_r51yu_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_r51yu_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_r51yu_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._link_r51yu_90{color:#8d029b;display:inline-flex}._link_r51yu_90[data-theme=dark]{color:#e0b0ff}._link_r51yu_90:hover,._link_r51yu_90:hover[data-theme=dark]{color:#c875ff}@keyframes _rotation_1arpp_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1arpp_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1arpp_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1arpp_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1arpp_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1arpp_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1arpp_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._footer__icon_1arpp_63{height:1rem}@keyframes _rotation_1eauo_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1eauo_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1eauo_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1eauo_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1eauo_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1eauo_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1eauo_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._heading_1eauo_90{font-weight:400;margin:0;padding:0;color:#4a5568;font-family:Nunito,sans-serif;font-size:1.25rem;font-style:normal;font-weight:600;line-height:1.5rem;text-align:center}._heading_1eauo_90[data-color-mode=dark]{color:#fffc}._heading--bold_1eauo_106{font-weight:700}._heading--full-width_1eauo_109{width:100%}._heading--left_1eauo_112{text-align:left}._heading--right_1eauo_115{text-align:right}._heading--xs_1eauo_118{font-size:.875rem}._heading--sm_1eauo_121{font-size:1rem}._heading--lg_1eauo_124{font-size:1.375rem;line-height:2rem}._heading--xl_1eauo_128{font-size:1.5rem;line-height:2.5rem}._heading--truncate_1eauo_132{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@keyframes _rotation_gmyq8_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_gmyq8_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_gmyq8_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_gmyq8_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_gmyq8_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_gmyq8_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_gmyq8_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._button_gmyq8_90{transition:background-color .3s ease,border-color .3s ease,color .3s ease;align-items:center;background-color:transparent;border:1px solid transparent;border-radius:10px;cursor:pointer;display:flex;height:auto;justify-content:center;min-width:auto;padding:.625rem;width:auto}._button_gmyq8_90:focus{border-color:#8d029b;outline:none}._button_gmyq8_90:focus[data-color-mode=dark]{border-color:#e0b0ff}._button_gmyq8_90:hover{background-color:#edf2f7}._button_gmyq8_90:hover[data-color-mode=dark]{background-color:#ffffff0f}._button--xs_gmyq8_117{padding:.525rem}._button--sm_gmyq8_120{padding:.575rem}._button--lg_gmyq8_123{padding:.7rem}._button--xl_gmyq8_126{padding:.75rem}._icon_gmyq8_130{height:1.25rem;width:1.25rem}._icon--xs_gmyq8_134{height:.75rem;width:.75rem}._icon--sm_gmyq8_138{height:1rem;width:1rem}._icon--lg_gmyq8_142{height:1.5rem;width:1.5rem}._icon--xl_gmyq8_146{height:2rem;width:2rem}@keyframes _rotation_1ialb_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1ialb_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1ialb_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1ialb_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1ialb_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1ialb_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1ialb_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._button_1ialb_81{border-radius:0 14px 14px 0;height:3rem;width:3rem}._container_1ialb_87{align-items:center;background:transparent;border-color:#cbd5e0;border-radius:14px;border-style:solid;border-width:1px;display:flex;flex-direction:row;width:100%}._container_1ialb_87[data-color-mode=dark]{border-color:#ffffff3d}._container_1ialb_87:focus-within{border-color:#8d029b}._container_1ialb_87:focus-within[data-color-mode=dark]{border-color:#e0b0ff}._container--error_1ialb_107{border-color:#ef4444}._container--error_1ialb_107[data-color-mode=dark]{border-color:#f87171}._error-text_1ialb_114{box-sizing:border-box;font-family:Nunito,sans-serif;font-size:.625rem;padding-inline:1rem;width:100%;color:#ef4444}._error-text_1ialb_114[data-color-mode=dark]{color:#f87171}._hint-text_1ialb_126{box-sizing:border-box;font-family:Nunito,sans-serif;font-size:.625rem;padding-inline:1rem;width:100%;color:#718096}._hint-text_1ialb_126[data-color-mode=dark]{color:#ffffffa3}._input_1ialb_138{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:none;border-radius:14px 0 0 14px;box-sizing:border-box;color:#4a5568;font-family:Nunito,sans-serif;font-size:.875rem;font-style:normal;line-height:1.5rem;height:3rem;outline:0;padding-inline:1rem;text-align:start;width:100%}._input_1ialb_138[data-color-mode=dark]{color:#fffc}._input_1ialb_138::placeholder{color:#718096}._input_1ialb_138::placeholder [data-color-mode=dark]{color:#ffffffa3}._input_1ialb_138::-ms-input-placeholder{color:#718096}._input_1ialb_138::-ms-input-placeholder [data-color-mode=dark]{color:#ffffffa3}._label_1ialb_171{box-sizing:border-box;color:#718096;font-family:Nunito,sans-serif;font-size:.825rem;padding-inline:1rem;width:100%}._label_1ialb_171[data-color-mode=dark]{color:#ffffffa3}._label--asterisk_1ialb_182{color:#ef4444;padding:0}._label--asterisk_1ialb_182[data-color-mode=dark]{color:#f87171}@keyframes _rotation_p7xuv_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_p7xuv_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_p7xuv_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_p7xuv_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_p7xuv_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_p7xuv_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_p7xuv_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_p7xuv_81{align-items:flex-end;bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:9999}@media (min-width: 768px){._container_p7xuv_81{align-items:center}}._modal_p7xuv_98{align-items:center;animation:_slideUpFadeIn_p7xuv_1 .3s ease forwards;background-color:#fff;border-radius:14px 14px 0 0;display:flex;flex-direction:column;height:auto;width:100%;z-index:0}@media (min-width: 768px){._modal_p7xuv_98{border-radius:14px;max-width:500px}}._modal_p7xuv_98[data-color-mode=dark]{background-color:#1a202c}._modal--close_p7xuv_118{animation-name:_slideDownFadeOut_p7xuv_1}._overlay_p7xuv_122{align-items:center;background-color:#000;bottom:0;display:flex;justify-content:center;left:0;opacity:.4;position:absolute;right:0;top:0;z-index:-1}@keyframes _rotation_m5f3o_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_m5f3o_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_m5f3o_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_m5f3o_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_m5f3o_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_m5f3o_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_m5f3o_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_m5f3o_81{background-color:#cbd5e0;border-radius:9999px;height:3px;margin:7px 0;position:relative;width:100%}._container_m5f3o_81[data-color-mode=dark]{background-color:#ffffff3d}._track_m5f3o_93{border-color:inherit;border-radius:9999px;height:inherit;transition:width .5s ease-in-out,background .25s;width:0}._track--weak-password_m5f3o_100{background:#ef4444;width:20%}._track--weak-password_m5f3o_100[data-color-mode=dark]{background:#f87171}._track--normal-password_m5f3o_107{background:#eab308;width:60%}._track--normal-password_m5f3o_107[data-color-mode=dark]{background:#eab308}._track--strong-password_m5f3o_114{background:#22c55e;width:100%}._track--strong-password_m5f3o_114[data-color-mode=dark]{background:#4ade80}@keyframes _rotation_15me7_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_15me7_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_15me7_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_15me7_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_15me7_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_15me7_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_15me7_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._item-container_15me7_81{box-sizing:border-box;min-height:2.5rem;padding-inline:.5rem;width:100%}._password-strength-text--weak-password_15me7_88{color:#ef4444}._password-strength-text--weak-password_15me7_88[data-color-mode=dark]{color:#f87171}._password-strength-text--normal-password_15me7_94,._password-strength-text--normal-password_15me7_94[data-color-mode=dark]{color:#eab308}._password-strength-text--strong-password_15me7_100{color:#22c55e}._password-strength-text--strong-password_15me7_100[data-color-mode=dark]{color:#4ade80}@keyframes _rotation_gfrnu_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_gfrnu_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_gfrnu_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_gfrnu_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_gfrnu_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_gfrnu_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_gfrnu_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._spacer_gfrnu_63{flex-grow:1}@keyframes _rotation_176bo_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_176bo_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_176bo_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_176bo_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_176bo_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_176bo_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_176bo_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._divider_176bo_66{background-color:#cbd5e0;height:1px;width:100%}._divider_176bo_66[data-color-mode=dark]{background-color:#ffffff3d}._passkey-icon_176bo_75{height:6rem;width:6rem}@keyframes _rotation_13lpc_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_13lpc_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_13lpc_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_13lpc_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_13lpc_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_13lpc_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_13lpc_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_13lpc_90{overflow:hidden;width:100%}._content_13lpc_95{max-height:0;overflow:hidden;transition:max-height .3s ease-in-out}._header_13lpc_101{transition:background-color .3s ease,border-color .3s ease,color .3s ease;align-items:center;background-color:transparent;border-color:transparent;border-style:solid;border-width:1px;cursor:pointer;display:flex;gap:.325rem;justify-content:space-between;margin:0;padding:.75rem;width:100%}._header_13lpc_101:focus{border-color:#8d029b;outline:none}._header_13lpc_101:focus[data-color-mode=dark]{border-color:#e0b0ff}._header_13lpc_101:hover{background-color:#edf2f7}._header_13lpc_101:hover[data-color-mode=dark]{background-color:#ffffff0f}._icon_13lpc_130{height:1rem;transition:transform .3s ease;width:1rem}._icon--open_13lpc_135{transform:rotate(180deg)}@keyframes _rotation_16xg2_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_16xg2_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_16xg2_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_16xg2_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_16xg2_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_16xg2_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_16xg2_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_16xg2_90{align-items:center;background-color:transparent;border-color:#cbd5e0;border-radius:14px;border-style:solid;border-width:1px;box-sizing:border-box;display:flex;justify-content:center;width:100%}._container_16xg2_90[data-color-mode=dark]{border-color:#ffffff3d}._content_16xg2_106{min-height:9rem;min-width:18.75rem}._footer__button_16xg2_111{height:3.125rem;padding:0 .75rem}._footer__button--closed_16xg2_115{border-bottom-left-radius:14px;border-bottom-right-radius:14px}._footer__content_16xg2_119{padding:.75rem}._header_16xg2_123{min-height:5.875rem;padding-left:.75rem;padding-right:.75rem;padding-top:.75rem}._circular-icon_16xg2_130{border-radius:9999px;max-height:1.5rem;max-width:1.5rem;min-height:1.5rem;min-width:1.5rem}._origin-icon_16xg2_138{height:.75rem;width:.75rem}@keyframes _rotation_13ubb_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_13ubb_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_13ubb_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_13ubb_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_13ubb_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_13ubb_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_13ubb_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._icon_13ubb_63{height:1.25rem;width:1.25rem}._icon--xs_13ubb_67{height:.75rem;width:.75rem}._icon--sm_13ubb_71{height:1rem;width:1rem}._icon--lg_13ubb_75{height:1.5rem;width:1.5rem}._icon--xl_13ubb_79{height:2rem;width:2rem}@keyframes _rotation_s58qk_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_s58qk_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_s58qk_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_s58qk_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_s58qk_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_s58qk_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_s58qk_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_s58qk_90{align-items:center;background-color:transparent;border-color:#cbd5e0;border-radius:14px;border-style:solid;border-width:1px;box-sizing:border-box;display:flex;justify-content:center;width:100%;border-style:dashed}._container_s58qk_90[data-color-mode=dark]{border-color:#ffffff3d}._container--clickable_s58qk_106{transition:background-color .3s ease,border-color .3s ease,color .3s ease;cursor:pointer}._container--clickable_s58qk_106:hover{background-color:#edf2f7}._container--clickable_s58qk_106:hover[data-color-mode=dark]{background-color:#ffffff0f}._content_s58qk_117{min-height:9rem;min-width:18.75rem;padding:.75rem}._icon_s58qk_123{height:2rem;width:2rem}@keyframes _rotation_xcdfe_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_xcdfe_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_xcdfe_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_xcdfe_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_xcdfe_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_xcdfe_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_xcdfe_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._button_xcdfe_90{transition:background-color .3s ease,border-color .3s ease,color .3s ease;background-color:transparent;border-color:#cbd5e0;border-radius:14px;border-style:solid;border-width:1px;cursor:pointer;display:flex;height:auto;margin:0;min-width:3rem;padding:.75rem;width:100%}@media (min-width: 768px){._button_xcdfe_90{width:auto}}._button_xcdfe_90[data-color-mode=dark]{border-color:#ffffff3d}._button_xcdfe_90:focus{border-color:#8d029b;outline:none}._button_xcdfe_90:focus[data-color-mode=dark]{border-color:#e0b0ff}._button_xcdfe_90:hover{background-color:#edf2f7}._button_xcdfe_90:hover[data-color-mode=dark]{background-color:#ffffff0f}._content_xcdfe_127{min-height:2.5rem;width:100%}@media (min-width: 768px){._content_xcdfe_127{height:7rem;width:7rem}}@media (min-width: 768px){._host_xcdfe_139{max-width:7rem}}._icon_xcdfe_144{border-radius:9999px;width:2.5rem}@media (min-width: 768px){._icon_xcdfe_144{height:2.5rem;width:auto}}@keyframes _rotation_1ypw5_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1ypw5_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1ypw5_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1ypw5_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1ypw5_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1ypw5_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1ypw5_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._divider_1ypw5_66{background-color:#cbd5e0;height:1px;width:100%}._divider_1ypw5_66[data-color-mode=dark]{background-color:#ffffff3d}@keyframes _rotation_16yzz_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_16yzz_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_16yzz_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_16yzz_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_16yzz_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_16yzz_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_16yzz_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_16yzz_90{align-items:center;background-color:transparent;border-color:#cbd5e0;border-radius:14px;border-style:solid;border-width:1px;box-sizing:border-box;display:flex;justify-content:center;width:100%}._container_16yzz_90[data-color-mode=dark]{border-color:#ffffff3d}._content_16yzz_106{min-height:4.125rem;padding:.75rem}@keyframes _rotation_rjlp0_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_rjlp0_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_rjlp0_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_rjlp0_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_rjlp0_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_rjlp0_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_rjlp0_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._icon_rjlp0_63{height:1.125rem;width:1.125rem}@keyframes _rotation_szrla_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_szrla_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_szrla_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_szrla_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_szrla_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_szrla_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_szrla_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_szrla_66{border-radius:.75rem;background:#cbd5e0;display:inline-block;height:calc(1.25rem + 4px);position:relative;transition:background .2s;width:2.5rem}._container_szrla_66[data-color-mode=dark]{background:#ffffff3d}._container--checked_szrla_80{background:#8d029b;box-shadow:0 0 2px #3c3c4326}._container--checked_szrla_80[data-color-mode=dark]{background:#e0b0ff}._container--xs_szrla_87{border-radius:.75rem;height:calc(.75rem + 4px);width:1.5rem;border-radius:.5rem}._container--sm_szrla_93{border-radius:.75rem;height:calc(1rem + 4px);width:2rem;border-radius:.625rem}._container--lg_szrla_99{border-radius:.75rem;height:calc(1.5rem + 4px);width:3rem;border-radius:.875rem}._container--xl_szrla_105{border-radius:.75rem;height:calc(1.75rem + 4px);width:3.5rem;border-radius:1rem}._input_szrla_112{display:none}._label_szrla_116{cursor:pointer;display:flex;-webkit-user-select:none;user-select:none}._label--disabled_szrla_121{cursor:not-allowed;opacity:.4}._knob_szrla_126{background:#fff;border-radius:50%;box-shadow:0 1px 4px #00000026;height:1.25rem;left:2px;position:absolute;top:2px;transition:left .2s;width:1.25rem}._knob_szrla_126[data-color-mode=dark]{background:#1a202c}._knob__checked--xs_szrla_142{left:calc(.75rem - 2px)}._knob__checked--sm_szrla_145{left:calc(1rem - 2px)}._knob__checked--md_szrla_148{left:calc(1.25rem - 2px)}._knob__checked--lg_szrla_151{left:calc(1.5rem - 2px)}._knob__checked--xl_szrla_154{left:calc(1.75rem - 2px)}._knob--xs_szrla_157{height:.75rem;width:.75rem}._knob--sm_szrla_161{height:1rem;width:1rem}._knob--lg_szrla_165{height:1.5rem;width:1.5rem}._knob--xl_szrla_169{height:1.75rem;width:1.75rem}@keyframes _rotation_1v743_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _slideDown_1v743_1{0%{transform:translateY(0)}to{transform:translateY(100%)}}@keyframes _slideDownFadeOut_1v743_1{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(30px)}}@keyframes _slideFromLeft_1v743_1{0%{transform:translate(350px)}to{transform:translate(0)}}@keyframes _slideToRight_1v743_1{0%{transform:translate(0)}to{transform:translate(350px)}}@keyframes _slideUp_1v743_1{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _slideUpFadeIn_1v743_1{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}._container_1v743_81{align-items:flex-end;bottom:0;display:flex;left:0;position:fixed;right:0;top:0;z-index:9998}@media (min-width: 768px){._container_1v743_81{align-items:center;justify-content:flex-end}}._modal_1v743_98{align-items:center;animation:_slideUp_1v743_1 .3s ease forwards;background-color:#fff;border-radius:14px 14px 0 0;display:flex;flex-direction:column;height:100dvh;width:100%;z-index:0}@media (min-width: 768px){._modal_1v743_98{animation-name:_slideFromLeft_1v743_1;border-radius:14px 0 0 14px;max-width:350px}}._modal_1v743_98[data-color-mode=dark]{background-color:#1a202c}._modal--close_1v743_119{animation-name:_slideDown_1v743_1}@media (min-width: 768px){._modal--close_1v743_119{animation-name:_slideToRight_1v743_1}}._overlay_1v743_128{align-items:center;background-color:#000;bottom:0;display:flex;justify-content:center;left:0;opacity:.4;position:absolute;right:0;top:0;z-index:-1}')), document.head.appendChild(r);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
var Q5 = Object.defineProperty, ep = (r, e, t) => e in r ? Q5(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, jd = (r, e, t) => ep(r, typeof e != "symbol" ? e + "" : e, t), tp = Object.defineProperty, rp = (r, e, t) => e in r ? tp(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, Fd = (r, e, t) => rp(r, typeof e != "symbol" ? e + "" : e, t), zd;
(function(r) {
  r[r.Include = 0] = "Include", r[r.None = 1] = "None";
})(zd || (zd = {}));
var Hd;
(function(r) {
  r[r.Required = 0] = "Required", r[r.Ignore = 1] = "Ignore";
})(Hd || (Hd = {}));
var qd;
(function(r) {
  r[r.Include = 0] = "Include", r[r.None = 1] = "None";
})(qd || (qd = {}));
var Wd;
(function(r) {
  r[r.Required = 0] = "Required", r[r.Ignore = 1] = "Ignore";
})(Wd || (Wd = {}));
function np(r) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  const e = new Uint8Array(256);
  for (let c = 0; c < e.length; c++)
    e[c] = 255;
  for (let c = 0; c < r.length; c++) {
    const u = r.charAt(c), d = u.charCodeAt(0);
    if (e[d] !== 255)
      throw new TypeError(u + " is ambiguous");
    e[d] = c;
  }
  const t = r.length, n = r.charAt(0), a = Math.log(t) / Math.log(256), o = Math.log(256) / Math.log(t);
  function i(c) {
    if (c instanceof Uint8Array || (ArrayBuffer.isView(c) ? c = new Uint8Array(c.buffer, c.byteOffset, c.byteLength) : Array.isArray(c) && (c = Uint8Array.from(c))), !(c instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (c.length === 0)
      return "";
    let u = 0, d = 0, w = 0;
    const f = c.length;
    for (; w !== f && c[w] === 0; )
      w++, u++;
    const A = (f - w) * o + 1 >>> 0, b = new Uint8Array(A);
    for (; w !== f; ) {
      let v = c[w], C = 0;
      for (let W = A - 1; (v !== 0 || C < d) && W !== -1; W--, C++)
        v += 256 * b[W] >>> 0, b[W] = v % t >>> 0, v = v / t >>> 0;
      if (v !== 0)
        throw new Error("Non-zero carry");
      d = C, w++;
    }
    let g = A - d;
    for (; g !== A && b[g] === 0; )
      g++;
    let k = n.repeat(u);
    for (; g < A; ++g)
      k += r.charAt(b[g]);
    return k;
  }
  function s(c) {
    if (typeof c != "string")
      throw new TypeError("Expected String");
    if (c.length === 0)
      return new Uint8Array();
    let u = 0, d = 0, w = 0;
    for (; c[u] === n; )
      d++, u++;
    const f = (c.length - u) * a + 1 >>> 0, A = new Uint8Array(f);
    for (; u < c.length; ) {
      const v = c.charCodeAt(u);
      if (v > 255)
        return;
      let C = e[v];
      if (C === 255)
        return;
      let W = 0;
      for (let Z = f - 1; (C !== 0 || W < w) && Z !== -1; Z--, W++)
        C += t * A[Z] >>> 0, A[Z] = C % 256 >>> 0, C = C / 256 >>> 0;
      if (C !== 0)
        throw new Error("Non-zero carry");
      w = W, u++;
    }
    let b = f - w;
    for (; b !== f && A[b] === 0; )
      b++;
    const g = new Uint8Array(d + (f - b));
    let k = d;
    for (; b !== f; )
      g[k++] = A[b++];
    return g;
  }
  function l(c) {
    const u = s(c);
    if (u)
      return u;
    throw new Error("Non-base" + t + " character");
  }
  return {
    encode: i,
    decodeUnsafe: s,
    decode: l
  };
}
var ap = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
np(ap);
function f2(r, e) {
  return function() {
    return r.apply(e, arguments);
  };
}
const { toString: op } = Object.prototype, { getPrototypeOf: J1 } = Object, { iterator: ql, toStringTag: p2 } = Symbol, Wl = /* @__PURE__ */ ((r) => (e) => {
  const t = op.call(e);
  return r[t] || (r[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), In = (r) => (r = r.toLowerCase(), (e) => Wl(e) === r), Kl = (r) => (e) => typeof e === r, { isArray: Pi } = Array, As = Kl("undefined");
function ic(r) {
  return r !== null && !As(r) && r.constructor !== null && !As(r.constructor) && Wr(r.constructor.isBuffer) && r.constructor.isBuffer(r);
}
const g2 = In("ArrayBuffer");
function ip(r) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && g2(r.buffer), e;
}
const sp = Kl("string"), Wr = Kl("function"), m2 = Kl("number"), sc = (r) => r !== null && typeof r == "object", cp = (r) => r === !0 || r === !1, Jc = (r) => {
  if (Wl(r) !== "object")
    return !1;
  const e = J1(r);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(p2 in r) && !(ql in r);
}, lp = (r) => {
  if (!sc(r) || ic(r))
    return !1;
  try {
    return Object.keys(r).length === 0 && Object.getPrototypeOf(r) === Object.prototype;
  } catch {
    return !1;
  }
}, up = In("Date"), dp = In("File"), hp = In("Blob"), fp = In("FileList"), pp = (r) => sc(r) && Wr(r.pipe), gp = (r) => {
  let e;
  return r && (typeof FormData == "function" && r instanceof FormData || Wr(r.append) && ((e = Wl(r)) === "formdata" || // detect form-data instance
  e === "object" && Wr(r.toString) && r.toString() === "[object FormData]"));
}, mp = In("URLSearchParams"), [yp, wp, vp, _p] = ["ReadableStream", "Request", "Response", "Headers"].map(In), bp = (r) => r.trim ? r.trim() : r.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function cc(r, e, { allOwnKeys: t = !1 } = {}) {
  if (r === null || typeof r > "u")
    return;
  let n, a;
  if (typeof r != "object" && (r = [r]), Pi(r))
    for (n = 0, a = r.length; n < a; n++)
      e.call(null, r[n], n, r);
  else {
    if (ic(r))
      return;
    const o = t ? Object.getOwnPropertyNames(r) : Object.keys(r), i = o.length;
    let s;
    for (n = 0; n < i; n++)
      s = o[n], e.call(null, r[s], s, r);
  }
}
function y2(r, e) {
  if (ic(r))
    return null;
  e = e.toLowerCase();
  const t = Object.keys(r);
  let n = t.length, a;
  for (; n-- > 0; )
    if (a = t[n], e === a.toLowerCase())
      return a;
  return null;
}
const eo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, w2 = (r) => !As(r) && r !== eo;
function n1() {
  const { caseless: r } = w2(this) && this || {}, e = {}, t = (n, a) => {
    const o = r && y2(e, a) || a;
    Jc(e[o]) && Jc(n) ? e[o] = n1(e[o], n) : Jc(n) ? e[o] = n1({}, n) : Pi(n) ? e[o] = n.slice() : e[o] = n;
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && cc(arguments[n], t);
  return e;
}
const Sp = (r, e, t, { allOwnKeys: n } = {}) => (cc(e, (a, o) => {
  t && Wr(a) ? r[o] = f2(a, t) : r[o] = a;
}, { allOwnKeys: n }), r), Ep = (r) => (r.charCodeAt(0) === 65279 && (r = r.slice(1)), r), xp = (r, e, t, n) => {
  r.prototype = Object.create(e.prototype, n), r.prototype.constructor = r, Object.defineProperty(r, "super", {
    value: e.prototype
  }), t && Object.assign(r.prototype, t);
}, kp = (r, e, t, n) => {
  let a, o, i;
  const s = {};
  if (e = e || {}, r == null) return e;
  do {
    for (a = Object.getOwnPropertyNames(r), o = a.length; o-- > 0; )
      i = a[o], (!n || n(i, r, e)) && !s[i] && (e[i] = r[i], s[i] = !0);
    r = t !== !1 && J1(r);
  } while (r && (!t || t(r, e)) && r !== Object.prototype);
  return e;
}, Ap = (r, e, t) => {
  r = String(r), (t === void 0 || t > r.length) && (t = r.length), t -= e.length;
  const n = r.indexOf(e, t);
  return n !== -1 && n === t;
}, Cp = (r) => {
  if (!r) return null;
  if (Pi(r)) return r;
  let e = r.length;
  if (!m2(e)) return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = r[e];
  return t;
}, Dp = /* @__PURE__ */ ((r) => (e) => r && e instanceof r)(typeof Uint8Array < "u" && J1(Uint8Array)), Mp = (r, e) => {
  const t = (r && r[ql]).call(r);
  let n;
  for (; (n = t.next()) && !n.done; ) {
    const a = n.value;
    e.call(r, a[0], a[1]);
  }
}, Rp = (r, e) => {
  let t;
  const n = [];
  for (; (t = r.exec(e)) !== null; )
    n.push(t);
  return n;
}, Ip = In("HTMLFormElement"), Tp = (r) => r.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, t, n) {
    return t.toUpperCase() + n;
  }
), Kd = (({ hasOwnProperty: r }) => (e, t) => r.call(e, t))(Object.prototype), Op = In("RegExp"), v2 = (r, e) => {
  const t = Object.getOwnPropertyDescriptors(r), n = {};
  cc(t, (a, o) => {
    let i;
    (i = e(a, o, r)) !== !1 && (n[o] = i || a);
  }), Object.defineProperties(r, n);
}, Pp = (r) => {
  v2(r, (e, t) => {
    if (Wr(r) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const n = r[t];
    if (Wr(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, Np = (r, e) => {
  const t = {}, n = (a) => {
    a.forEach((o) => {
      t[o] = !0;
    });
  };
  return Pi(r) ? n(r) : n(String(r).split(e)), t;
}, Bp = () => {
}, Lp = (r, e) => r != null && Number.isFinite(r = +r) ? r : e;
function Up(r) {
  return !!(r && Wr(r.append) && r[p2] === "FormData" && r[ql]);
}
const Vp = (r) => {
  const e = new Array(10), t = (n, a) => {
    if (sc(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (ic(n))
        return n;
      if (!("toJSON" in n)) {
        e[a] = n;
        const o = Pi(n) ? [] : {};
        return cc(n, (i, s) => {
          const l = t(i, a + 1);
          !As(l) && (o[s] = l);
        }), e[a] = void 0, o;
      }
    }
    return n;
  };
  return t(r, 0);
}, $p = In("AsyncFunction"), jp = (r) => r && (sc(r) || Wr(r)) && Wr(r.then) && Wr(r.catch), _2 = ((r, e) => r ? setImmediate : e ? ((t, n) => (eo.addEventListener("message", ({ source: a, data: o }) => {
  a === eo && o === t && n.length && n.shift()();
}, !1), (a) => {
  n.push(a), eo.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  Wr(eo.postMessage)
), Fp = typeof queueMicrotask < "u" ? queueMicrotask.bind(eo) : typeof process < "u" && process.nextTick || _2, zp = (r) => r != null && Wr(r[ql]), ve = {
  isArray: Pi,
  isArrayBuffer: g2,
  isBuffer: ic,
  isFormData: gp,
  isArrayBufferView: ip,
  isString: sp,
  isNumber: m2,
  isBoolean: cp,
  isObject: sc,
  isPlainObject: Jc,
  isEmptyObject: lp,
  isReadableStream: yp,
  isRequest: wp,
  isResponse: vp,
  isHeaders: _p,
  isUndefined: As,
  isDate: up,
  isFile: dp,
  isBlob: hp,
  isRegExp: Op,
  isFunction: Wr,
  isStream: pp,
  isURLSearchParams: mp,
  isTypedArray: Dp,
  isFileList: fp,
  forEach: cc,
  merge: n1,
  extend: Sp,
  trim: bp,
  stripBOM: Ep,
  inherits: xp,
  toFlatObject: kp,
  kindOf: Wl,
  kindOfTest: In,
  endsWith: Ap,
  toArray: Cp,
  forEachEntry: Mp,
  matchAll: Rp,
  isHTMLForm: Ip,
  hasOwnProperty: Kd,
  hasOwnProp: Kd,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: v2,
  freezeMethods: Pp,
  toObjectSet: Np,
  toCamelCase: Tp,
  noop: Bp,
  toFiniteNumber: Lp,
  findKey: y2,
  global: eo,
  isContextDefined: w2,
  isSpecCompliantForm: Up,
  toJSONObject: Vp,
  isAsyncFn: $p,
  isThenable: jp,
  setImmediate: _2,
  asap: Fp,
  isIterable: zp
};
function yt(r, e, t, n, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = r, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), n && (this.request = n), a && (this.response = a, this.status = a.status ? a.status : null);
}
ve.inherits(yt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ve.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const b2 = yt.prototype, S2 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((r) => {
  S2[r] = { value: r };
});
Object.defineProperties(yt, S2);
Object.defineProperty(b2, "isAxiosError", { value: !0 });
yt.from = (r, e, t, n, a, o) => {
  const i = Object.create(b2);
  return ve.toFlatObject(r, i, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), yt.call(i, r.message, e, t, n, a), i.cause = r, i.name = r.name, o && Object.assign(i, o), i;
};
const Hp = null;
function a1(r) {
  return ve.isPlainObject(r) || ve.isArray(r);
}
function E2(r) {
  return ve.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function Yd(r, e, t) {
  return r ? r.concat(e).map(function(n, a) {
    return n = E2(n), !t && a ? "[" + n + "]" : n;
  }).join(t ? "." : "") : e;
}
function qp(r) {
  return ve.isArray(r) && !r.some(a1);
}
const Wp = ve.toFlatObject(ve, {}, null, function(r) {
  return /^is[A-Z]/.test(r);
});
function Yl(r, e, t) {
  if (!ve.isObject(r))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = ve.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, A) {
    return !ve.isUndefined(A[f]);
  });
  const n = t.metaTokens, a = t.visitor || c, o = t.dots, i = t.indexes, s = (t.Blob || typeof Blob < "u" && Blob) && ve.isSpecCompliantForm(e);
  if (!ve.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(f) {
    if (f === null) return "";
    if (ve.isDate(f))
      return f.toISOString();
    if (ve.isBoolean(f))
      return f.toString();
    if (!s && ve.isBlob(f))
      throw new yt("Blob is not supported. Use a Buffer instead.");
    return ve.isArrayBuffer(f) || ve.isTypedArray(f) ? s && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, A, b) {
    let g = f;
    if (f && !b && typeof f == "object") {
      if (ve.endsWith(A, "{}"))
        A = n ? A : A.slice(0, -2), f = JSON.stringify(f);
      else if (ve.isArray(f) && qp(f) || (ve.isFileList(f) || ve.endsWith(A, "[]")) && (g = ve.toArray(f)))
        return A = E2(A), g.forEach(function(k, v) {
          !(ve.isUndefined(k) || k === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Yd([A], v, o) : i === null ? A : A + "[]",
            l(k)
          );
        }), !1;
    }
    return a1(f) ? !0 : (e.append(Yd(b, A, o), l(f)), !1);
  }
  const u = [], d = Object.assign(Wp, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: a1
  });
  function w(f, A) {
    if (!ve.isUndefined(f)) {
      if (u.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + A.join("."));
      u.push(f), ve.forEach(f, function(b, g) {
        (!(ve.isUndefined(b) || b === null) && a.call(
          e,
          b,
          ve.isString(g) ? g.trim() : g,
          A,
          d
        )) === !0 && w(b, A ? A.concat(g) : [g]);
      }), u.pop();
    }
  }
  if (!ve.isObject(r))
    throw new TypeError("data must be an object");
  return w(r), e;
}
function Gd(r) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(r).replace(/[!'()~]|%20|%00/g, function(t) {
    return e[t];
  });
}
function X1(r, e) {
  this._pairs = [], r && Yl(r, this, e);
}
const x2 = X1.prototype;
x2.append = function(r, e) {
  this._pairs.push([r, e]);
};
x2.toString = function(r) {
  const e = r ? function(t) {
    return r.call(this, t, Gd);
  } : Gd;
  return this._pairs.map(function(t) {
    return e(t[0]) + "=" + e(t[1]);
  }, "").join("&");
};
function Kp(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function k2(r, e, t) {
  if (!e)
    return r;
  const n = t && t.encode || Kp;
  ve.isFunction(t) && (t = {
    serialize: t
  });
  const a = t && t.serialize;
  let o;
  if (a ? o = a(e, t) : o = ve.isURLSearchParams(e) ? e.toString() : new X1(e, t).toString(n), o) {
    const i = r.indexOf("#");
    i !== -1 && (r = r.slice(0, i)), r += (r.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return r;
}
class Jd {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    ve.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}
const A2 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Yp = typeof URLSearchParams < "u" ? URLSearchParams : X1, Gp = typeof FormData < "u" ? FormData : null, Jp = typeof Blob < "u" ? Blob : null, Xp = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Yp,
    FormData: Gp,
    Blob: Jp
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Z1 = typeof window < "u" && typeof document < "u", o1 = typeof navigator == "object" && navigator || void 0, Zp = Z1 && (!o1 || ["ReactNative", "NativeScript", "NS"].indexOf(o1.product) < 0), Qp = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", eg = Z1 && window.location.href || "http://localhost", tg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Z1,
  hasStandardBrowserEnv: Zp,
  hasStandardBrowserWebWorkerEnv: Qp,
  navigator: o1,
  origin: eg
}, Symbol.toStringTag, { value: "Module" })), Pr = {
  ...tg,
  ...Xp
};
function rg(r, e) {
  return Yl(r, new Pr.classes.URLSearchParams(), {
    visitor: function(t, n, a, o) {
      return Pr.isNode && ve.isBuffer(t) ? (this.append(n, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function ng(r) {
  return ve.matchAll(/\w+|\[(\w*)]/g, r).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function ag(r) {
  const e = {}, t = Object.keys(r);
  let n;
  const a = t.length;
  let o;
  for (n = 0; n < a; n++)
    o = t[n], e[o] = r[o];
  return e;
}
function C2(r) {
  function e(t, n, a, o) {
    let i = t[o++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = o >= t.length;
    return i = !i && ve.isArray(a) ? a.length : i, l ? (ve.hasOwnProp(a, i) ? a[i] = [a[i], n] : a[i] = n, !s) : ((!a[i] || !ve.isObject(a[i])) && (a[i] = []), e(t, n, a[i], o) && ve.isArray(a[i]) && (a[i] = ag(a[i])), !s);
  }
  if (ve.isFormData(r) && ve.isFunction(r.entries)) {
    const t = {};
    return ve.forEachEntry(r, (n, a) => {
      e(ng(n), a, t, 0);
    }), t;
  }
  return null;
}
function og(r, e, t) {
  if (ve.isString(r))
    try {
      return (e || JSON.parse)(r), ve.trim(r);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (t || JSON.stringify)(r);
}
const lc = {
  transitional: A2,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(r, e) {
    const t = e.getContentType() || "", n = t.indexOf("application/json") > -1, a = ve.isObject(r);
    if (a && ve.isHTMLForm(r) && (r = new FormData(r)), ve.isFormData(r))
      return n ? JSON.stringify(C2(r)) : r;
    if (ve.isArrayBuffer(r) || ve.isBuffer(r) || ve.isStream(r) || ve.isFile(r) || ve.isBlob(r) || ve.isReadableStream(r))
      return r;
    if (ve.isArrayBufferView(r))
      return r.buffer;
    if (ve.isURLSearchParams(r))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), r.toString();
    let o;
    if (a) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return rg(r, this.formSerializer).toString();
      if ((o = ve.isFileList(r)) || t.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return Yl(
          o ? { "files[]": r } : r,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return a || n ? (e.setContentType("application/json", !1), og(r)) : r;
  }],
  transformResponse: [function(r) {
    const e = this.transitional || lc.transitional, t = e && e.forcedJSONParsing, n = this.responseType === "json";
    if (ve.isResponse(r) || ve.isReadableStream(r))
      return r;
    if (r && ve.isString(r) && (t && !this.responseType || n)) {
      const a = !(e && e.silentJSONParsing) && n;
      try {
        return JSON.parse(r);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? yt.from(o, yt.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return r;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Pr.classes.FormData,
    Blob: Pr.classes.Blob
  },
  validateStatus: function(r) {
    return r >= 200 && r < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ve.forEach(["delete", "get", "head", "post", "put", "patch"], (r) => {
  lc.headers[r] = {};
});
const ig = ve.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), sg = (r) => {
  const e = {};
  let t, n, a;
  return r && r.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), t = o.substring(0, a).trim().toLowerCase(), n = o.substring(a + 1).trim(), !(!t || e[t] && ig[t]) && (t === "set-cookie" ? e[t] ? e[t].push(n) : e[t] = [n] : e[t] = e[t] ? e[t] + ", " + n : n);
  }), e;
}, Xd = Symbol("internals");
function qi(r) {
  return r && String(r).trim().toLowerCase();
}
function Xc(r) {
  return r === !1 || r == null ? r : ve.isArray(r) ? r.map(Xc) : String(r);
}
function cg(r) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = t.exec(r); )
    e[n[1]] = n[2];
  return e;
}
const lg = (r) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(r.trim());
function mu(r, e, t, n, a) {
  if (ve.isFunction(n))
    return n.call(this, e, t);
  if (a && (e = t), !!ve.isString(e)) {
    if (ve.isString(n))
      return e.indexOf(n) !== -1;
    if (ve.isRegExp(n))
      return n.test(e);
  }
}
function ug(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function dg(r, e) {
  const t = ve.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(r, n + t, {
      value: function(a, o, i) {
        return this[n].call(this, e, a, o, i);
      },
      configurable: !0
    });
  });
}
let Kr = class {
  constructor(r) {
    r && this.set(r);
  }
  set(r, e, t) {
    const n = this;
    function a(i, s, l) {
      const c = qi(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = ve.findKey(n, c);
      (!u || n[u] === void 0 || l === !0 || l === void 0 && n[u] !== !1) && (n[u || s] = Xc(i));
    }
    const o = (i, s) => ve.forEach(i, (l, c) => a(l, c, s));
    if (ve.isPlainObject(r) || r instanceof this.constructor)
      o(r, e);
    else if (ve.isString(r) && (r = r.trim()) && !lg(r))
      o(sg(r), e);
    else if (ve.isObject(r) && ve.isIterable(r)) {
      let i = {}, s, l;
      for (const c of r) {
        if (!ve.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        i[l = c[0]] = (s = i[l]) ? ve.isArray(s) ? [...s, c[1]] : [s, c[1]] : c[1];
      }
      o(i, e);
    } else
      r != null && a(e, r, t);
    return this;
  }
  get(r, e) {
    if (r = qi(r), r) {
      const t = ve.findKey(this, r);
      if (t) {
        const n = this[t];
        if (!e)
          return n;
        if (e === !0)
          return cg(n);
        if (ve.isFunction(e))
          return e.call(this, n, t);
        if (ve.isRegExp(e))
          return e.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(r, e) {
    if (r = qi(r), r) {
      const t = ve.findKey(this, r);
      return !!(t && this[t] !== void 0 && (!e || mu(this, this[t], t, e)));
    }
    return !1;
  }
  delete(r, e) {
    const t = this;
    let n = !1;
    function a(o) {
      if (o = qi(o), o) {
        const i = ve.findKey(t, o);
        i && (!e || mu(t, t[i], i, e)) && (delete t[i], n = !0);
      }
    }
    return ve.isArray(r) ? r.forEach(a) : a(r), n;
  }
  clear(r) {
    const e = Object.keys(this);
    let t = e.length, n = !1;
    for (; t--; ) {
      const a = e[t];
      (!r || mu(this, this[a], a, r, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(r) {
    const e = this, t = {};
    return ve.forEach(this, (n, a) => {
      const o = ve.findKey(t, a);
      if (o) {
        e[o] = Xc(n), delete e[a];
        return;
      }
      const i = r ? ug(a) : String(a).trim();
      i !== a && delete e[a], e[i] = Xc(n), t[i] = !0;
    }), this;
  }
  concat(...r) {
    return this.constructor.concat(this, ...r);
  }
  toJSON(r) {
    const e = /* @__PURE__ */ Object.create(null);
    return ve.forEach(this, (t, n) => {
      t != null && t !== !1 && (e[n] = r && ve.isArray(t) ? t.join(", ") : t);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([r, e]) => r + ": " + e).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(r) {
    return r instanceof this ? r : new this(r);
  }
  static concat(r, ...e) {
    const t = new this(r);
    return e.forEach((n) => t.set(n)), t;
  }
  static accessor(r) {
    const e = (this[Xd] = this[Xd] = {
      accessors: {}
    }).accessors, t = this.prototype;
    function n(a) {
      const o = qi(a);
      e[o] || (dg(t, a), e[o] = !0);
    }
    return ve.isArray(r) ? r.forEach(n) : n(r), this;
  }
};
Kr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ve.reduceDescriptors(Kr.prototype, ({ value: r }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => r,
    set(n) {
      this[t] = n;
    }
  };
});
ve.freezeMethods(Kr);
function yu(r, e) {
  const t = this || lc, n = e || t, a = Kr.from(n.headers);
  let o = n.data;
  return ve.forEach(r, function(i) {
    o = i.call(t, o, a.normalize(), e ? e.status : void 0);
  }), a.normalize(), o;
}
function D2(r) {
  return !!(r && r.__CANCEL__);
}
function Ni(r, e, t) {
  yt.call(this, r ?? "canceled", yt.ERR_CANCELED, e, t), this.name = "CanceledError";
}
ve.inherits(Ni, yt, {
  __CANCEL__: !0
});
function M2(r, e, t) {
  const n = t.config.validateStatus;
  !t.status || !n || n(t.status) ? r(t) : e(new yt(
    "Request failed with status code " + t.status,
    [yt.ERR_BAD_REQUEST, yt.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function hg(r) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(r);
  return e && e[1] || "";
}
function fg(r, e) {
  r = r || 10;
  const t = new Array(r), n = new Array(r);
  let a = 0, o = 0, i;
  return e = e !== void 0 ? e : 1e3, function(s) {
    const l = Date.now(), c = n[o];
    i || (i = l), t[a] = s, n[a] = l;
    let u = o, d = 0;
    for (; u !== a; )
      d += t[u++], u = u % r;
    if (a = (a + 1) % r, a === o && (o = (o + 1) % r), l - i < e)
      return;
    const w = c && l - c;
    return w ? Math.round(d * 1e3 / w) : void 0;
  };
}
function pg(r, e) {
  let t = 0, n = 1e3 / e, a, o;
  const i = (s, l = Date.now()) => {
    t = l, a = null, o && (clearTimeout(o), o = null), r(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - t;
    c >= n ? i(s, l) : (a = s, o || (o = setTimeout(() => {
      o = null, i(a);
    }, n - c)));
  }, () => a && i(a)];
}
const ul = (r, e, t = 3) => {
  let n = 0;
  const a = fg(50, 250);
  return pg((o) => {
    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, l = i - n, c = a(l), u = i <= s;
    n = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: o,
      lengthComputable: s != null,
      [e ? "download" : "upload"]: !0
    };
    r(d);
  }, t);
}, Zd = (r, e) => {
  const t = r != null;
  return [(n) => e[0]({
    lengthComputable: t,
    total: r,
    loaded: n
  }), e[1]];
}, Qd = (r) => (...e) => ve.asap(() => r(...e)), gg = Pr.hasStandardBrowserEnv ? /* @__PURE__ */ ((r, e) => (t) => (t = new URL(t, Pr.origin), r.protocol === t.protocol && r.host === t.host && (e || r.port === t.port)))(
  new URL(Pr.origin),
  Pr.navigator && /(msie|trident)/i.test(Pr.navigator.userAgent)
) : () => !0, mg = Pr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(r, e, t, n, a, o) {
      const i = [r + "=" + encodeURIComponent(e)];
      ve.isNumber(t) && i.push("expires=" + new Date(t).toGMTString()), ve.isString(n) && i.push("path=" + n), ve.isString(a) && i.push("domain=" + a), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(r) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(r) {
      this.write(r, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function yg(r) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
}
function wg(r, e) {
  return e ? r.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : r;
}
function R2(r, e, t) {
  let n = !yg(e);
  return r && (n || t == !1) ? wg(r, e) : e;
}
const eh = (r) => r instanceof Kr ? { ...r } : r;
function co(r, e) {
  e = e || {};
  const t = {};
  function n(c, u, d, w) {
    return ve.isPlainObject(c) && ve.isPlainObject(u) ? ve.merge.call({ caseless: w }, c, u) : ve.isPlainObject(u) ? ve.merge({}, u) : ve.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d, w) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(c))
        return n(void 0, c, d, w);
    } else return n(c, u, d, w);
  }
  function o(c, u) {
    if (!ve.isUndefined(u))
      return n(void 0, u);
  }
  function i(c, u) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, u);
  }
  function s(c, u, d) {
    if (d in e)
      return n(c, u);
    if (d in r)
      return n(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => a(eh(c), eh(u), d, !0)
  };
  return ve.forEach(Object.keys({ ...r, ...e }), function(c) {
    const u = l[c] || a, d = u(r[c], e[c], c);
    ve.isUndefined(d) && u !== s || (t[c] = d);
  }), t;
}
const I2 = (r) => {
  const e = co({}, r);
  let { data: t, withXSRFToken: n, xsrfHeaderName: a, xsrfCookieName: o, headers: i, auth: s } = e;
  e.headers = i = Kr.from(i), e.url = k2(R2(e.baseURL, e.url, e.allowAbsoluteUrls), r.params, r.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (ve.isFormData(t)) {
    if (Pr.hasStandardBrowserEnv || Pr.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Pr.hasStandardBrowserEnv && (n && ve.isFunction(n) && (n = n(e)), n || n !== !1 && gg(e.url))) {
    const c = a && o && mg.read(o);
    c && i.set(a, c);
  }
  return e;
}, vg = typeof XMLHttpRequest < "u", _g = vg && function(r) {
  return new Promise(function(e, t) {
    const n = I2(r);
    let a = n.data;
    const o = Kr.from(n.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = n, c, u, d, w, f;
    function A() {
      w && w(), f && f(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let b = new XMLHttpRequest();
    b.open(n.method.toUpperCase(), n.url, !0), b.timeout = n.timeout;
    function g() {
      if (!b)
        return;
      const v = Kr.from(
        "getAllResponseHeaders" in b && b.getAllResponseHeaders()
      ), C = {
        data: !i || i === "text" || i === "json" ? b.responseText : b.response,
        status: b.status,
        statusText: b.statusText,
        headers: v,
        config: r,
        request: b
      };
      M2(function(W) {
        e(W), A();
      }, function(W) {
        t(W), A();
      }, C), b = null;
    }
    "onloadend" in b ? b.onloadend = g : b.onreadystatechange = function() {
      !b || b.readyState !== 4 || b.status === 0 && !(b.responseURL && b.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, b.onabort = function() {
      b && (t(new yt("Request aborted", yt.ECONNABORTED, r, b)), b = null);
    }, b.onerror = function() {
      t(new yt("Network Error", yt.ERR_NETWORK, r, b)), b = null;
    }, b.ontimeout = function() {
      let v = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const C = n.transitional || A2;
      n.timeoutErrorMessage && (v = n.timeoutErrorMessage), t(new yt(
        v,
        C.clarifyTimeoutError ? yt.ETIMEDOUT : yt.ECONNABORTED,
        r,
        b
      )), b = null;
    }, a === void 0 && o.setContentType(null), "setRequestHeader" in b && ve.forEach(o.toJSON(), function(v, C) {
      b.setRequestHeader(C, v);
    }), ve.isUndefined(n.withCredentials) || (b.withCredentials = !!n.withCredentials), i && i !== "json" && (b.responseType = n.responseType), l && ([d, f] = ul(l, !0), b.addEventListener("progress", d)), s && b.upload && ([u, w] = ul(s), b.upload.addEventListener("progress", u), b.upload.addEventListener("loadend", w)), (n.cancelToken || n.signal) && (c = (v) => {
      b && (t(!v || v.type ? new Ni(null, r, b) : v), b.abort(), b = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const k = hg(n.url);
    if (k && Pr.protocols.indexOf(k) === -1) {
      t(new yt("Unsupported protocol " + k + ":", yt.ERR_BAD_REQUEST, r));
      return;
    }
    b.send(a || null);
  });
}, bg = (r, e) => {
  const { length: t } = r = r ? r.filter(Boolean) : [];
  if (e || t) {
    let n = new AbortController(), a;
    const o = function(c) {
      if (!a) {
        a = !0, s();
        const u = c instanceof Error ? c : this.reason;
        n.abort(u instanceof yt ? u : new Ni(u instanceof Error ? u.message : u));
      }
    };
    let i = e && setTimeout(() => {
      i = null, o(new yt(`timeout ${e} of ms exceeded`, yt.ETIMEDOUT));
    }, e);
    const s = () => {
      r && (i && clearTimeout(i), i = null, r.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener("abort", o);
      }), r = null);
    };
    r.forEach((c) => c.addEventListener("abort", o));
    const { signal: l } = n;
    return l.unsubscribe = () => ve.asap(s), l;
  }
}, Sg = function* (r, e) {
  let t = r.byteLength;
  if (t < e) {
    yield r;
    return;
  }
  let n = 0, a;
  for (; n < t; )
    a = n + e, yield r.slice(n, a), n = a;
}, Eg = async function* (r, e) {
  for await (const t of xg(r))
    yield* Sg(t, e);
}, xg = async function* (r) {
  if (r[Symbol.asyncIterator]) {
    yield* r;
    return;
  }
  const e = r.getReader();
  try {
    for (; ; ) {
      const { done: t, value: n } = await e.read();
      if (t)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, th = (r, e, t, n) => {
  const a = Eg(r, e);
  let o = 0, i, s = (l) => {
    i || (i = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await a.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (t) {
          let w = o += d;
          t(w);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Gl = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", T2 = Gl && typeof ReadableStream == "function", kg = Gl && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((r) => (e) => r.encode(e))(new TextEncoder()) : async (r) => new Uint8Array(await new Response(r).arrayBuffer())), O2 = (r, ...e) => {
  try {
    return !!r(...e);
  } catch {
    return !1;
  }
}, Ag = T2 && O2(() => {
  let r = !1;
  const e = new Request(Pr.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return r = !0, "half";
    }
  }).headers.has("Content-Type");
  return r && !e;
}), rh = 64 * 1024, i1 = T2 && O2(() => ve.isReadableStream(new Response("").body)), dl = {
  stream: i1 && ((r) => r.body)
};
Gl && ((r) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !dl[e] && (dl[e] = ve.isFunction(r[e]) ? (t) => t[e]() : (t, n) => {
      throw new yt(`Response type '${e}' is not supported`, yt.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const Cg = async (r) => {
  if (r == null)
    return 0;
  if (ve.isBlob(r))
    return r.size;
  if (ve.isSpecCompliantForm(r))
    return (await new Request(Pr.origin, {
      method: "POST",
      body: r
    }).arrayBuffer()).byteLength;
  if (ve.isArrayBufferView(r) || ve.isArrayBuffer(r))
    return r.byteLength;
  if (ve.isURLSearchParams(r) && (r = r + ""), ve.isString(r))
    return (await kg(r)).byteLength;
}, Dg = async (r, e) => ve.toFiniteNumber(r.getContentLength()) ?? Cg(e), Mg = Gl && (async (r) => {
  let {
    url: e,
    method: t,
    data: n,
    signal: a,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: w
  } = I2(r);
  c = c ? (c + "").toLowerCase() : "text";
  let f = bg([a, o && o.toAbortSignal()], i), A;
  const b = f && f.unsubscribe && (() => {
    f.unsubscribe();
  });
  let g;
  try {
    if (l && Ag && t !== "get" && t !== "head" && (g = await Dg(u, n)) !== 0) {
      let Z = new Request(e, {
        method: "POST",
        body: n,
        duplex: "half"
      }), D;
      if (ve.isFormData(n) && (D = Z.headers.get("content-type")) && u.setContentType(D), Z.body) {
        const [H, y] = Zd(
          g,
          ul(Qd(l))
        );
        n = th(Z.body, rh, H, y);
      }
    }
    ve.isString(d) || (d = d ? "include" : "omit");
    const k = "credentials" in Request.prototype;
    A = new Request(e, {
      ...w,
      signal: f,
      method: t.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: k ? d : void 0
    });
    let v = await fetch(A, w);
    const C = i1 && (c === "stream" || c === "response");
    if (i1 && (s || C && b)) {
      const Z = {};
      ["status", "statusText", "headers"].forEach((S) => {
        Z[S] = v[S];
      });
      const D = ve.toFiniteNumber(v.headers.get("content-length")), [H, y] = s && Zd(
        D,
        ul(Qd(s), !0)
      ) || [];
      v = new Response(
        th(v.body, rh, H, () => {
          y && y(), b && b();
        }),
        Z
      );
    }
    c = c || "text";
    let W = await dl[ve.findKey(dl, c) || "text"](v, r);
    return !C && b && b(), await new Promise((Z, D) => {
      M2(Z, D, {
        data: W,
        headers: Kr.from(v.headers),
        status: v.status,
        statusText: v.statusText,
        config: r,
        request: A
      });
    });
  } catch (k) {
    throw b && b(), k && k.name === "TypeError" && /Load failed|fetch/i.test(k.message) ? Object.assign(
      new yt("Network Error", yt.ERR_NETWORK, r, A),
      {
        cause: k.cause || k
      }
    ) : yt.from(k, k && k.code, r, A);
  }
}), s1 = {
  http: Hp,
  xhr: _g,
  fetch: Mg
};
ve.forEach(s1, (r, e) => {
  if (r) {
    try {
      Object.defineProperty(r, "name", { value: e });
    } catch {
    }
    Object.defineProperty(r, "adapterName", { value: e });
  }
});
const nh = (r) => `- ${r}`, Rg = (r) => ve.isFunction(r) || r === null || r === !1, P2 = {
  getAdapter: (r) => {
    r = ve.isArray(r) ? r : [r];
    const { length: e } = r;
    let t, n;
    const a = {};
    for (let o = 0; o < e; o++) {
      t = r[o];
      let i;
      if (n = t, !Rg(t) && (n = s1[(i = String(t)).toLowerCase()], n === void 0))
        throw new yt(`Unknown adapter '${i}'`);
      if (n)
        break;
      a[i || "#" + o] = n;
    }
    if (!n) {
      const o = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = e ? o.length > 1 ? `since :
` + o.map(nh).join(`
`) : " " + nh(o[0]) : "as no adapter specified";
      throw new yt(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: s1
};
function wu(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new Ni(null, r);
}
function ah(r) {
  return wu(r), r.headers = Kr.from(r.headers), r.data = yu.call(
    r,
    r.transformRequest
  ), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), P2.getAdapter(r.adapter || lc.adapter)(r).then(function(e) {
    return wu(r), e.data = yu.call(
      r,
      r.transformResponse,
      e
    ), e.headers = Kr.from(e.headers), e;
  }, function(e) {
    return D2(e) || (wu(r), e && e.response && (e.response.data = yu.call(
      r,
      r.transformResponse,
      e.response
    ), e.response.headers = Kr.from(e.response.headers))), Promise.reject(e);
  });
}
const N2 = "1.11.0", Jl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((r, e) => {
  Jl[r] = function(t) {
    return typeof t === r || "a" + (e < 1 ? "n " : " ") + r;
  };
});
const oh = {};
Jl.transitional = function(r, e, t) {
  function n(a, o) {
    return "[Axios v" + N2 + "] Transitional option '" + a + "'" + o + (t ? ". " + t : "");
  }
  return (a, o, i) => {
    if (r === !1)
      throw new yt(
        n(o, " has been removed" + (e ? " in " + e : "")),
        yt.ERR_DEPRECATED
      );
    return e && !oh[o] && (oh[o] = !0, console.warn(
      n(
        o,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), r ? r(a, o, i) : !0;
  };
};
Jl.spelling = function(r) {
  return (e, t) => (console.warn(`${t} is likely a misspelling of ${r}`), !0);
};
function Ig(r, e, t) {
  if (typeof r != "object")
    throw new yt("options must be an object", yt.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(r);
  let a = n.length;
  for (; a-- > 0; ) {
    const o = n[a], i = e[o];
    if (i) {
      const s = r[o], l = s === void 0 || i(s, o, r);
      if (l !== !0)
        throw new yt("option " + o + " must be " + l, yt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new yt("Unknown option " + o, yt.ERR_BAD_OPTION);
  }
}
const Zc = {
  assertOptions: Ig,
  validators: Jl
}, Pn = Zc.validators;
let no = class {
  constructor(r) {
    this.defaults = r || {}, this.interceptors = {
      request: new Jd(),
      response: new Jd()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(r, e) {
    try {
      return await this._request(r, e);
    } catch (t) {
      if (t instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          t.stack ? a && !String(t.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (t.stack += `
` + a) : t.stack = a;
        } catch {
        }
      }
      throw t;
    }
  }
  _request(r, e) {
    typeof r == "string" ? (e = e || {}, e.url = r) : e = r || {}, e = co(this.defaults, e);
    const { transitional: t, paramsSerializer: n, headers: a } = e;
    t !== void 0 && Zc.assertOptions(t, {
      silentJSONParsing: Pn.transitional(Pn.boolean),
      forcedJSONParsing: Pn.transitional(Pn.boolean),
      clarifyTimeoutError: Pn.transitional(Pn.boolean)
    }, !1), n != null && (ve.isFunction(n) ? e.paramsSerializer = {
      serialize: n
    } : Zc.assertOptions(n, {
      encode: Pn.function,
      serialize: Pn.function
    }, !0)), e.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? e.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : e.allowAbsoluteUrls = !0), Zc.assertOptions(e, {
      baseUrl: Pn.spelling("baseURL"),
      withXsrfToken: Pn.spelling("withXSRFToken")
    }, !0), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let o = a && ve.merge(
      a.common,
      a[e.method]
    );
    a && ve.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete a[f];
      }
    ), e.headers = Kr.concat(o, a);
    const i = [];
    let s = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(e) === !1 || (s = s && f.synchronous, i.unshift(f.fulfilled, f.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(f) {
      l.push(f.fulfilled, f.rejected);
    });
    let c, u = 0, d;
    if (!s) {
      const f = [ah.bind(this), void 0];
      for (f.unshift(...i), f.push(...l), d = f.length, c = Promise.resolve(e); u < d; )
        c = c.then(f[u++], f[u++]);
      return c;
    }
    d = i.length;
    let w = e;
    for (u = 0; u < d; ) {
      const f = i[u++], A = i[u++];
      try {
        w = f(w);
      } catch (b) {
        A.call(this, b);
        break;
      }
    }
    try {
      c = ah.call(this, w);
    } catch (f) {
      return Promise.reject(f);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(r) {
    r = co(this.defaults, r);
    const e = R2(r.baseURL, r.url, r.allowAbsoluteUrls);
    return k2(e, r.params, r.paramsSerializer);
  }
};
ve.forEach(["delete", "get", "head", "options"], function(r) {
  no.prototype[r] = function(e, t) {
    return this.request(co(t || {}, {
      method: r,
      url: e,
      data: (t || {}).data
    }));
  };
});
ve.forEach(["post", "put", "patch"], function(r) {
  function e(t) {
    return function(n, a, o) {
      return this.request(co(o || {}, {
        method: r,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: a
      }));
    };
  }
  no.prototype[r] = e(), no.prototype[r + "Form"] = e(!0);
});
let Tg = class B2 {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(a) {
      t = a;
    });
    const n = this;
    this.promise.then((a) => {
      if (!n._listeners) return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](a);
      n._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((s) => {
        n.subscribe(s), o = s;
      }).then(a);
      return i.cancel = function() {
        n.unsubscribe(o);
      }, i;
    }, e(function(a, o, i) {
      n.reason || (n.reason = new Ni(a, o, i), t(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (n) => {
      e.abort(n);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new B2(function(t) {
        e = t;
      }),
      cancel: e
    };
  }
};
function Og(r) {
  return function(e) {
    return r.apply(null, e);
  };
}
function Pg(r) {
  return ve.isObject(r) && r.isAxiosError === !0;
}
const c1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(c1).forEach(([r, e]) => {
  c1[e] = r;
});
function L2(r) {
  const e = new no(r), t = f2(no.prototype.request, e);
  return ve.extend(t, no.prototype, e, { allOwnKeys: !0 }), ve.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(n) {
    return L2(co(r, n));
  }, t;
}
const dr = L2(lc);
dr.Axios = no;
dr.CanceledError = Ni;
dr.CancelToken = Tg;
dr.isCancel = D2;
dr.VERSION = N2;
dr.toFormData = Yl;
dr.AxiosError = yt;
dr.Cancel = dr.CanceledError;
dr.all = function(r) {
  return Promise.all(r);
};
dr.spread = Og;
dr.isAxiosError = Pg;
dr.mergeConfig = co;
dr.AxiosHeaders = Kr;
dr.formToJSON = (r) => C2(ve.isHTMLForm(r) ? new FormData(r) : r);
dr.getAdapter = P2.getAdapter;
dr.HttpStatusCode = c1;
dr.default = dr;
const {
  Axios: HE,
  AxiosError: qE,
  CanceledError: WE,
  isCancel: KE,
  CancelToken: YE,
  VERSION: GE,
  all: JE,
  Cancel: XE,
  isAxiosError: ZE,
  spread: QE,
  toFormData: ex,
  AxiosHeaders: tx,
  HttpStatusCode: rx,
  formToJSON: nx,
  getAdapter: ax,
  mergeConfig: ox
} = dr, ih = 65536;
class Ng {
  constructor() {
    Fd(this, "isAvailable", !1), Fd(this, "isInstantiated", !1), typeof crypto < "u" && "getRandomValues" in crypto && (this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    const t = new Uint8Array(e);
    for (let n = 0; n < t.length; n += ih)
      crypto.getRandomValues(t.subarray(n, n + Math.min(t.length - n, ih)));
    return t;
  }
}
new Ng();
var Ht = /* @__PURE__ */ ((r) => (r.Algorand = "algorand", r.AVM = "avm", r.EIP155 = "eip155", r))(Ht || {});
Ht.Algorand;
Ht.Algorand;
Ht.Algorand;
Ht.Algorand;
Ht.EIP155;
Ht.EIP155;
Ht.EIP155;
Ht.EIP155;
Ht.AVM;
Ht.AVM;
function Bg(r) {
  let e = "";
  for (let t = 0; t < r.length; t++)
    e += sh[r[t] >> 4], e += sh[r[t] & 15];
  return e;
}
function Lg(r) {
  let e = "";
  for (let t = 0; t < r.length; t++)
    e += ch[r[t] >> 4], e += ch[r[t] & 15];
  return e;
}
function Ug(r) {
  if (r.length % 2 !== 0)
    throw new Error("Invalid hex string");
  const e = new Uint8Array(r.length / 2);
  for (let t = 0; t < r.length; t += 2) {
    if (!(r[t] in wc))
      throw new Error("Invalid character");
    if (!(r[t + 1] in wc))
      throw new Error("Invalid character");
    e[t / 2] |= wc[r[t]] << 4, e[t / 2] |= wc[r[t + 1]];
  }
  return e;
}
const sh = "0123456789ABCDEF", ch = "0123456789abcdef", wc = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
function U2(r) {
  return $2(r, F2, Cs.Include);
}
function V2(r) {
  return $2(r, F2, Cs.None);
}
function Vg(r) {
  return U2(r);
}
function $g(r) {
  return V2(r);
}
function $2(r, e, t) {
  let n = "";
  for (let a = 0; a < r.byteLength; a += 5) {
    let o = 0n, i = 0;
    for (let s = 0; s < 5 && a + s < r.byteLength; s++)
      o = o << 8n | BigInt(r[a + s]), i += 8;
    i % 5 !== 0 && (o = o << BigInt(5 - i % 5), i += 5 - i % 5);
    for (let s = 0; s < 8; s++)
      i >= 5 ? (n += e[Number(o >> BigInt(i - 5) & 0x1fn)], i -= 5) : i > 0 ? (n += e[Number(o << BigInt(6 - i) & 0x3fn)], i = 0) : t === Cs.Include && (n += "=");
  }
  return n;
}
function jg(r) {
  return j2(r, z2, Go.Required);
}
function Fg(r) {
  return j2(r, z2, Go.Ignore);
}
function j2(r, e, t) {
  const n = new Uint8Array(Math.ceil(r.length / 8) * 5);
  let a = 0;
  for (let o = 0; o < r.length; o += 8) {
    let i = 0n, s = 0;
    for (let c = 0; c < 8; c++) {
      if (t === Go.Required) {
        if (r[o + c] === "=")
          continue;
        if (o + c >= r.length)
          throw new Error("Invalid padding");
      }
      if (!(t === Go.Ignore && (o + c >= r.length || r[o + c] === "="))) {
        if (c > 0 && r[o + c - 1] === "=")
          throw new Error("Invalid padding");
        if (!(r[o + c] in e))
          throw new Error("Invalid character");
        i |= BigInt(e[r[o + c]]) << BigInt((7 - c) * 5), s += 5;
      }
    }
    if (s < 40) {
      let c;
      if (s === 10)
        c = i & 0xffffffffn;
      else if (s === 20)
        c = i & 0xffffffn;
      else if (s === 25)
        c = i & 0xffffn;
      else if (s === 35)
        c = i & 0xffn;
      else
        throw new Error("Invalid padding");
      if (c !== 0n)
        throw new Error("Invalid padding");
    }
    const l = Math.floor(s / 8);
    for (let c = 0; c < l; c++)
      n[a] = Number(i >> BigInt(32 - c * 8) & 0xffn), a++;
  }
  return n.slice(0, a);
}
const F2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", z2 = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
  a: 0,
  b: 1,
  c: 2,
  d: 3,
  e: 4,
  f: 5,
  g: 6,
  h: 7,
  i: 8,
  j: 9,
  k: 10,
  l: 11,
  m: 12,
  n: 13,
  o: 14,
  p: 15,
  q: 16,
  r: 17,
  s: 18,
  t: 19,
  u: 20,
  v: 21,
  w: 22,
  x: 23,
  y: 24,
  z: 25,
  2: 26,
  3: 27,
  4: 28,
  5: 29,
  6: 30,
  7: 31
};
var Cs;
(function(r) {
  r[r.Include = 0] = "Include", r[r.None = 1] = "None";
})(Cs || (Cs = {}));
var Go;
(function(r) {
  r[r.Required = 0] = "Required", r[r.Ignore = 1] = "Ignore";
})(Go || (Go = {}));
function zg(r) {
  return Xl(r, H2, lo.Include);
}
function Hg(r) {
  return Xl(r, H2, lo.None);
}
function qg(r) {
  return Xl(r, q2, lo.Include);
}
function Wg(r) {
  return Xl(r, q2, lo.None);
}
function Xl(r, e, t) {
  let n = "";
  for (let a = 0; a < r.byteLength; a += 3) {
    let o = 0, i = 0;
    for (let s = 0; s < 3 && a + s < r.byteLength; s++)
      o = o << 8 | r[a + s], i += 8;
    for (let s = 0; s < 4; s++)
      i >= 6 ? (n += e[o >> i - 6 & 63], i -= 6) : i > 0 ? (n += e[o << 6 - i & 63], i = 0) : t === lo.Include && (n += "=");
  }
  return n;
}
const H2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", q2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
function Kg(r) {
  return Zl(r, W2, ja.Required);
}
function Yg(r) {
  return Zl(r, W2, ja.Ignore);
}
function Gg(r) {
  return Zl(r, K2, ja.Required);
}
function Jg(r) {
  return Zl(r, K2, ja.Ignore);
}
function Zl(r, e, t) {
  const n = new Uint8Array(Math.ceil(r.length / 4) * 3);
  let a = 0;
  for (let o = 0; o < r.length; o += 4) {
    let i = 0, s = 0;
    for (let c = 0; c < 4; c++)
      if (!(t === ja.Required && r[o + c] === "=") && !(t === ja.Ignore && (o + c >= r.length || r[o + c] === "="))) {
        if (c > 0 && r[o + c - 1] === "=")
          throw new Error("Invalid padding");
        if (!(r[o + c] in e))
          throw new Error("Invalid character");
        i |= e[r[o + c]] << (3 - c) * 6, s += 6;
      }
    if (s < 24) {
      let c;
      if (s === 12)
        c = i & 65535;
      else if (s === 18)
        c = i & 255;
      else
        throw new Error("Invalid padding");
      if (c !== 0)
        throw new Error("Invalid padding");
    }
    const l = Math.floor(s / 8);
    for (let c = 0; c < l; c++)
      n[a] = i >> 16 - c * 8 & 255, a++;
  }
  return n.slice(0, a);
}
var lo;
(function(r) {
  r[r.Include = 0] = "Include", r[r.None = 1] = "None";
})(lo || (lo = {}));
var ja;
(function(r) {
  r[r.Required = 0] = "Required", r[r.Ignore = 1] = "Ignore";
})(ja || (ja = {}));
const W2 = {
  0: 52,
  1: 53,
  2: 54,
  3: 55,
  4: 56,
  5: 57,
  6: 58,
  7: 59,
  8: 60,
  9: 61,
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
  a: 26,
  b: 27,
  c: 28,
  d: 29,
  e: 30,
  f: 31,
  g: 32,
  h: 33,
  i: 34,
  j: 35,
  k: 36,
  l: 37,
  m: 38,
  n: 39,
  o: 40,
  p: 41,
  q: 42,
  r: 43,
  s: 44,
  t: 45,
  u: 46,
  v: 47,
  w: 48,
  x: 49,
  y: 50,
  z: 51,
  "+": 62,
  "/": 63
}, K2 = {
  0: 52,
  1: 53,
  2: 54,
  3: 55,
  4: 56,
  5: 57,
  6: 58,
  7: 59,
  8: 60,
  9: 61,
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25,
  a: 26,
  b: 27,
  c: 28,
  d: 29,
  e: 30,
  f: 31,
  g: 32,
  h: 33,
  i: 34,
  j: 35,
  k: 36,
  l: 37,
  m: 38,
  n: 39,
  o: 40,
  p: 41,
  q: 42,
  r: 43,
  s: 44,
  t: 45,
  u: 46,
  v: 47,
  w: 48,
  x: 49,
  y: 50,
  z: 51,
  "-": 62,
  _: 63
};
function Xg(r, e) {
  return e != null && e.ignorePadding ? Fg(r) : jg(r);
}
function Zg(r, e) {
  return e != null && e.noPadding && e != null && e.uppercase ? V2(r) : e != null && e.noPadding ? $g(r) : e != null && e.uppercase ? U2(r) : Vg(r);
}
const vc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Xg,
  encode: Zg
}, Symbol.toStringTag, { value: "Module" }));
function Qg(r) {
  if (r.length >= 255)
    throw new TypeError("Alphabet too long");
  const e = new Uint8Array(256);
  for (let c = 0; c < e.length; c++)
    e[c] = 255;
  for (let c = 0; c < r.length; c++) {
    const u = r.charAt(c), d = u.charCodeAt(0);
    if (e[d] !== 255)
      throw new TypeError(u + " is ambiguous");
    e[d] = c;
  }
  const t = r.length, n = r.charAt(0), a = Math.log(t) / Math.log(256), o = Math.log(256) / Math.log(t);
  function i(c) {
    if (c instanceof Uint8Array || (ArrayBuffer.isView(c) ? c = new Uint8Array(c.buffer, c.byteOffset, c.byteLength) : Array.isArray(c) && (c = Uint8Array.from(c))), !(c instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (c.length === 0)
      return "";
    let u = 0, d = 0, w = 0;
    const f = c.length;
    for (; w !== f && c[w] === 0; )
      w++, u++;
    const A = (f - w) * o + 1 >>> 0, b = new Uint8Array(A);
    for (; w !== f; ) {
      let v = c[w], C = 0;
      for (let W = A - 1; (v !== 0 || C < d) && W !== -1; W--, C++)
        v += 256 * b[W] >>> 0, b[W] = v % t >>> 0, v = v / t >>> 0;
      if (v !== 0)
        throw new Error("Non-zero carry");
      d = C, w++;
    }
    let g = A - d;
    for (; g !== A && b[g] === 0; )
      g++;
    let k = n.repeat(u);
    for (; g < A; ++g)
      k += r.charAt(b[g]);
    return k;
  }
  function s(c) {
    if (typeof c != "string")
      throw new TypeError("Expected String");
    if (c.length === 0)
      return new Uint8Array();
    let u = 0, d = 0, w = 0;
    for (; c[u] === n; )
      d++, u++;
    const f = (c.length - u) * a + 1 >>> 0, A = new Uint8Array(f);
    for (; u < c.length; ) {
      const v = c.charCodeAt(u);
      if (v > 255)
        return;
      let C = e[v];
      if (C === 255)
        return;
      let W = 0;
      for (let Z = f - 1; (C !== 0 || W < w) && Z !== -1; Z--, W++)
        C += t * A[Z] >>> 0, A[Z] = C % 256 >>> 0, C = C / 256 >>> 0;
      if (C !== 0)
        throw new Error("Non-zero carry");
      w = W, u++;
    }
    let b = f - w;
    for (; b !== f && A[b] === 0; )
      b++;
    const g = new Uint8Array(d + (f - b));
    let k = d;
    for (; b !== f; )
      g[k++] = A[b++];
    return g;
  }
  function l(c) {
    const u = s(c);
    if (u)
      return u;
    throw new Error("Non-base" + t + " character");
  }
  return {
    encode: i,
    decodeUnsafe: s,
    decode: l
  };
}
var em = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const Y2 = Qg(em);
function tm(r) {
  return Y2.decode(r);
}
function rm(r) {
  return Y2.encode(r);
}
const Dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: tm,
  encode: rm
}, Symbol.toStringTag, { value: "Module" }));
function nm(r, e) {
  return e != null && e.ignorePadding && e != null && e.urlSafe ? Jg(r) : e != null && e.ignorePadding ? Yg(r) : e != null && e.urlSafe ? Gg(r) : Kg(r);
}
function am(r, e) {
  return e != null && e.noPadding && e != null && e.urlSafe ? Wg(r) : e != null && e.noPadding ? Hg(r) : e != null && e.urlSafe ? qg(r) : zg(r);
}
const cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: nm,
  encode: am
}, Symbol.toStringTag, { value: "Module" }));
function om(r) {
  return Ug(r);
}
function im(r, e) {
  return e != null && e.uppercase ? Bg(r) : Lg(r);
}
const Q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: om,
  encode: im
}, Symbol.toStringTag, { value: "Module" })), lh = "utf8: invalid string", Wn = "utf8: invalid source encoding";
function sm(r) {
  const e = new Uint8Array(cm(r));
  let t = 0;
  for (let n = 0; n < r.length; n++) {
    let a = r.charCodeAt(n);
    a >= 55296 && a <= 56319 && (a = (a - 55296 << 10) + (r.charCodeAt(++n) - 56320) + 65536), a < 128 ? e[t++] = a : a < 2048 ? (e[t++] = 192 | a >> 6, e[t++] = 128 | a & 63) : a < 65536 ? (e[t++] = 224 | a >> 12, e[t++] = 128 | a >> 6 & 63, e[t++] = 128 | a & 63) : (e[t++] = 240 | a >> 18, e[t++] = 128 | a >> 12 & 63, e[t++] = 128 | a >> 6 & 63, e[t++] = 128 | a & 63);
  }
  return e;
}
function cm(r) {
  let e = 0;
  for (let t = 0; t < r.length; t++) {
    let n = r.charCodeAt(t);
    if (n >= 55296 && n <= 56319) {
      if (t === r.length - 1)
        throw new Error(lh);
      t++;
      const a = r.charCodeAt(t);
      if (a < 56320 || a > 57343)
        throw new Error(lh);
      n = (n - 55296 << 10) + (a - 56320) + 65536;
    }
    n < 128 ? e += 1 : n < 2048 ? e += 2 : n < 65536 ? e += 3 : e += 4;
  }
  return e;
}
function lm(r) {
  const e = [];
  for (let t = 0; t < r.length; t++) {
    let n = r[t];
    if (n & 128) {
      let a;
      if (n < 224) {
        if (t >= r.length)
          throw new Error(Wn);
        const o = r[++t];
        if ((o & 192) !== 128)
          throw new Error(Wn);
        n = (n & 31) << 6 | o & 63, a = 128;
      } else if (n < 240) {
        if (t >= r.length - 1)
          throw new Error(Wn);
        const o = r[++t], i = r[++t];
        if ((o & 192) !== 128 || (i & 192) !== 128)
          throw new Error(Wn);
        n = (n & 15) << 12 | (o & 63) << 6 | i & 63, a = 2048;
      } else if (n < 248) {
        if (t >= r.length - 2)
          throw new Error(Wn);
        const o = r[++t], i = r[++t], s = r[++t];
        if ((o & 192) !== 128 || (i & 192) !== 128 || (s & 192) !== 128)
          throw new Error(Wn);
        n = (n & 15) << 18 | (o & 63) << 12 | (i & 63) << 6 | s & 63, a = 65536;
      } else
        throw new Error(Wn);
      if (n < a || n >= 55296 && n <= 57343)
        throw new Error(Wn);
      if (n >= 65536) {
        if (n > 1114111)
          throw new Error(Wn);
        n -= 65536, e.push(String.fromCharCode(55296 | n >> 10)), n = 56320 | n & 1023;
      }
    }
    e.push(String.fromCharCode(n));
  }
  return e.join("");
}
function um(r) {
  return sm(r);
}
function dm(r) {
  return lm(r);
}
const Vr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: um,
  encode: dm
}, Symbol.toStringTag, { value: "Module" })), uh = 65536;
class hm {
  constructor() {
    jd(this, "isAvailable", !1), jd(this, "isInstantiated", !1), typeof crypto < "u" && "getRandomValues" in crypto && (this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    const t = new Uint8Array(e);
    for (let n = 0; n < t.length; n += uh)
      crypto.getRandomValues(t.subarray(n, n + Math.min(t.length - n, uh)));
    return t;
  }
}
function G2(r) {
  for (let e = 0; e < r.length; e++)
    r[e] = 0;
  return r;
}
const J2 = new hm();
function X2(r, e = J2) {
  return e.randomBytes(r);
}
const fm = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
function pm(r, e = fm, t = J2) {
  if (e.length < 2)
    throw new Error("randomString charset is too short");
  if (e.length > 256)
    throw new Error("randomString charset is too long");
  let n = "";
  const a = e.length, o = 256 - 256 % a;
  for (; r > 0; ) {
    const i = X2(Math.ceil(r * 256 / o), t);
    for (let s = 0; s < i.length && r > 0; s++) {
      const l = i[s];
      l < o && (n += e.charAt(l % a), r--);
    }
    G2(i);
  }
  return n;
}
function gm(r) {
  let e = r + 48;
  return e += 9 - r >>> 8 & 7, String.fromCharCode(e);
}
function mm(r) {
  let e = r + 48;
  return e += 9 - r >>> 8 & 39, String.fromCharCode(e);
}
function ym(r, e = !1) {
  const t = e ? mm : gm;
  let n = "";
  for (let a = 0; a < r.length; a++)
    n += t(r[a] >>> 4), n += t(r[a] & 15);
  return n;
}
function Z2(r) {
  const e = X2(16, r);
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const t = ym(e, !0);
  return G2(e), t.substring(0, 8) + "-" + t.substring(8, 12) + "-" + t.substring(12, 16) + "-" + t.substring(16, 20) + "-" + t.substring(20, 32);
}
class qa {
  constructor({ logger: e }) {
    this._logger = e;
  }
}
const wm = 256, vm = 95, _m = 256, bm = 3664, Sm = 135, Em = 191, Q2 = 32, xm = 100, km = 15e3, Am = "ACCOUNT_DOES_NOT_EXIST_ERROR", Cm = "AUTHENTICATION_METHOD_NOT_SUPPORTED_ERROR", Dm = "FAILED_TO_AUTHENTICATE_PASSKEY_ERROR", Mm = "FAILED_TO_REGISTER_PASSKEY_ERROR", Rm = "INVALID_CREDENTIAL_ID_ERROR", e3 = "INVALID_PASSWORD_ERROR", Im = "NOT_AUTHENTICATED_ERROR", Tm = "PASSKEY_NOT_SUPPORTED_ERROR", Om = "PASSWORD_TOO_WEAK_ERROR", Pm = "USER_CANCELED_PASSKEY_REQUEST_ERROR", Nm = "INVALID_AVM_ADDRESS_ERROR", Bm = "CHAIN_NOT_SUPPORTED_ERROR", Lm = "FAILED_TO_FETCH_CHAIN_INFORMATION_ERROR", Um = "DECRYPTION_ERROR", Vm = "ENCRYPTION_ERROR", $m = "INVALID_PRIVATE_KEY_ERROR", jm = "FAILED_TO_SIGN_ERROR", Fm = "FAILED_TO_SEND_TRANSACTION_ERROR", zm = "FAILED_TO_RENDER_UI_ERROR", zo = "accounts", t3 = "katavault", hl = "passkey", bs = "password", fl = "settings";
class Ql {
  constructor({ logger: e, vault: t }) {
    this._logger = e, this._vault = t;
  }
  /**
   * public methods
   */
  /**
   * Gets the vault name.
   * @returns {string} The name of the vault.
   * @public
   */
  name() {
    return this._vault.name;
  }
  /**
   * Gets the vault version.
   * @returns {number} The vault version.
   * @public
   */
  version() {
    return this._vault.version;
  }
}
const r3 = class n3 extends Ql {
  constructor(e) {
    super(e);
  }
  /**
   * public methods
   */
  /**
   * Gets an account by public key. If no item exists, null is returned.
   * @param {string} key - The public key, encoded with base58.
   * @returns {Promise<ConnectedAccountStoreItem | EphemeralAccountStoreItem | null>} A promise that resolves to
   * the account or null if it doesn't exist.
   * @public
   */
  async accountByKey(e) {
    return await this._vault.get(zo, e) || null || null;
  }
  /**
   * Gets all accounts in the store.
   * @returns {Promise<(ConnectedAccountStoreItem | EphemeralAccountStoreItem)[]>} A promise that
   * resolves to all accounts.
   * @public
   */
  async accounts() {
    const e = this._vault.transaction(zo, "readonly"), t = await e.store.getAllKeys(), n = [];
    let a;
    for (const o of t)
      a = await e.store.get(o), n.push(a);
    return n;
  }
  /**
   * Removes a list of accounts via a set of base58 encoded public keys.
   * @param {[string, ...string[]]} keys - A list of base58 encoded public keys to remove.
   * @returns {Promise<string[]>} A promise that resolves to the list of the removed accounts.
   * @public
   */
  async remove(e) {
    const t = [], n = this._vault.transaction(zo, "readwrite");
    let a;
    for (const o of e)
      a = await n.store.getKey(o) || null, a && (await n.store.delete(o), t.push(o));
    return t;
  }
  /**
   * Upserts accounts into the database. If any of the public keys already exist, they will be overwritten with the new
   * account. If any of the accounts don't exist, they will be added.
   * @param {(ConnectedAccountStoreItem | EphemeralAccountStoreItem)[]} items - The accounts to
   * insert and/or update.
   * @returns {Promise<(ConnectedAccountStoreItem | EphemeralAccountStoreItem)[]>} A promise that
   * resolves to the inserted and/or updated accounts.
   * @public
   */
  async upsert(e) {
    const t = `${n3.displayName}#upsert`, n = this._vault.transaction(zo, "readwrite"), a = await n.store.getAllKeys(), o = e.filter(({ key: s }) => !a.some((l) => l === s)), i = e.filter(({ key: s }) => a.some((l) => l === s));
    for (const s of o)
      await n.store.add(s, s.key);
    for (const s of i)
      await n.store.put(s, s.key);
    return this._logger.debug(`${t}: added "${o.length}" and updated "${i.length}" accounts`), e;
  }
};
r3.displayName = "AccountStore";
let Ma = r3;
function Hm(...r) {
  let e = 0;
  for (let a = 0; a < r.length; a++)
    e += r[a].length;
  const t = new Uint8Array(e);
  let n = 0;
  for (let a = 0; a < r.length; a++) {
    const o = r[a];
    t.set(o, n), n += o.length;
  }
  return t;
}
function Ds(...r) {
  return Hm(...r);
}
function dh(r) {
  if (!Number.isSafeInteger(r) || r < 0)
    throw new Error("positive integer expected, got " + r);
}
function qm(r) {
  return r instanceof Uint8Array || ArrayBuffer.isView(r) && r.constructor.name === "Uint8Array";
}
function eu(r, ...e) {
  if (!qm(r))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(r.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + r.length);
}
function Wm(r) {
  if (typeof r != "function" || typeof r.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  dh(r.outputLen), dh(r.blockLen);
}
function pl(r, e = !0) {
  if (r.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && r.finished)
    throw new Error("Hash#digest() has already been called");
}
function Km(r, e) {
  eu(r);
  const t = e.outputLen;
  if (r.length < t)
    throw new Error("digestInto() expects output buffer of length at least " + t);
}
const Ro = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function vu(r) {
  return new DataView(r.buffer, r.byteOffset, r.byteLength);
}
function Nn(r, e) {
  return r << 32 - e | r >>> e;
}
function Ym(r) {
  if (typeof r != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof r);
  return new Uint8Array(new TextEncoder().encode(r));
}
function ed(r) {
  return typeof r == "string" && (r = Ym(r)), eu(r), r;
}
function Gm(...r) {
  let e = 0;
  for (let n = 0; n < r.length; n++) {
    const a = r[n];
    eu(a), e += a.length;
  }
  const t = new Uint8Array(e);
  for (let n = 0, a = 0; n < r.length; n++) {
    const o = r[n];
    t.set(o, a), a += o.length;
  }
  return t;
}
class a3 {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function td(r) {
  const e = (n) => r().update(ed(n)).digest(), t = r();
  return e.outputLen = t.outputLen, e.blockLen = t.blockLen, e.create = () => r(), e;
}
function Pa(r = 32) {
  if (Ro && typeof Ro.getRandomValues == "function")
    return Ro.getRandomValues(new Uint8Array(r));
  if (Ro && typeof Ro.randomBytes == "function")
    return Ro.randomBytes(r);
  throw new Error("crypto.getRandomValues must be defined");
}
function Jm(r, e, t, n) {
  if (typeof r.setBigUint64 == "function")
    return r.setBigUint64(e, t, n);
  const a = BigInt(32), o = BigInt(4294967295), i = Number(t >> a & o), s = Number(t & o), l = n ? 4 : 0, c = n ? 0 : 4;
  r.setUint32(e + l, i, n), r.setUint32(e + c, s, n);
}
function Xm(r, e, t) {
  return r & e ^ ~r & t;
}
function Zm(r, e, t) {
  return r & e ^ r & t ^ e & t;
}
class o3 extends a3 {
  constructor(e, t, n, a) {
    super(), this.blockLen = e, this.outputLen = t, this.padOffset = n, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = vu(this.buffer);
  }
  update(e) {
    pl(this);
    const { view: t, buffer: n, blockLen: a } = this;
    e = ed(e);
    const o = e.length;
    for (let i = 0; i < o; ) {
      const s = Math.min(a - this.pos, o - i);
      if (s === a) {
        const l = vu(e);
        for (; a <= o - i; i += a)
          this.process(l, i);
        continue;
      }
      n.set(e.subarray(i, i + s), this.pos), this.pos += s, i += s, this.pos === a && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    pl(this), Km(e, this), this.finished = !0;
    const { buffer: t, view: n, blockLen: a, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > a - i && (this.process(n, 0), i = 0);
    for (let d = i; d < a; d++)
      t[d] = 0;
    Jm(n, a - 8, BigInt(this.length * 8), o), this.process(n, 0);
    const s = vu(e), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const c = l / 4, u = this.get();
    if (c > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < c; d++)
      s.setUint32(4 * d, u[d], o);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const n = e.slice(0, t);
    return this.destroy(), n;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: n, length: a, finished: o, destroyed: i, pos: s } = this;
    return e.length = a, e.pos = s, e.finished = o, e.destroyed = i, a % t && e.buffer.set(n), e;
  }
}
const _c = /* @__PURE__ */ BigInt(2 ** 32 - 1), l1 = /* @__PURE__ */ BigInt(32);
function i3(r, e = !1) {
  return e ? { h: Number(r & _c), l: Number(r >> l1 & _c) } : { h: Number(r >> l1 & _c) | 0, l: Number(r & _c) | 0 };
}
function Qm(r, e = !1) {
  let t = new Uint32Array(r.length), n = new Uint32Array(r.length);
  for (let a = 0; a < r.length; a++) {
    const { h: o, l: i } = i3(r[a], e);
    [t[a], n[a]] = [o, i];
  }
  return [t, n];
}
const e6 = (r, e) => BigInt(r >>> 0) << l1 | BigInt(e >>> 0), t6 = (r, e, t) => r >>> t, r6 = (r, e, t) => r << 32 - t | e >>> t, n6 = (r, e, t) => r >>> t | e << 32 - t, a6 = (r, e, t) => r << 32 - t | e >>> t, o6 = (r, e, t) => r << 64 - t | e >>> t - 32, i6 = (r, e, t) => r >>> t - 32 | e << 64 - t, s6 = (r, e) => e, c6 = (r, e) => r, l6 = (r, e, t) => r << t | e >>> 32 - t, u6 = (r, e, t) => e << t | r >>> 32 - t, d6 = (r, e, t) => e << t - 32 | r >>> 64 - t, h6 = (r, e, t) => r << t - 32 | e >>> 64 - t;
function f6(r, e, t, n) {
  const a = (e >>> 0) + (n >>> 0);
  return { h: r + t + (a / 2 ** 32 | 0) | 0, l: a | 0 };
}
const p6 = (r, e, t) => (r >>> 0) + (e >>> 0) + (t >>> 0), g6 = (r, e, t, n) => e + t + n + (r / 2 ** 32 | 0) | 0, m6 = (r, e, t, n) => (r >>> 0) + (e >>> 0) + (t >>> 0) + (n >>> 0), y6 = (r, e, t, n, a) => e + t + n + a + (r / 2 ** 32 | 0) | 0, w6 = (r, e, t, n, a) => (r >>> 0) + (e >>> 0) + (t >>> 0) + (n >>> 0) + (a >>> 0), v6 = (r, e, t, n, a, o) => e + t + n + a + o + (r / 2 ** 32 | 0) | 0, _t = {
  fromBig: i3,
  split: Qm,
  toBig: e6,
  shrSH: t6,
  shrSL: r6,
  rotrSH: n6,
  rotrSL: a6,
  rotrBH: o6,
  rotrBL: i6,
  rotr32H: s6,
  rotr32L: c6,
  rotlSH: l6,
  rotlSL: u6,
  rotlBH: d6,
  rotlBL: h6,
  add: f6,
  add3L: p6,
  add3H: g6,
  add4L: m6,
  add4H: y6,
  add5H: v6,
  add5L: w6
}, [_6, b6] = _t.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((r) => BigInt(r))), ua = /* @__PURE__ */ new Uint32Array(80), da = /* @__PURE__ */ new Uint32Array(80);
class s3 extends o3 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: t, Bh: n, Bl: a, Ch: o, Cl: i, Dh: s, Dl: l, Eh: c, El: u, Fh: d, Fl: w, Gh: f, Gl: A, Hh: b, Hl: g } = this;
    return [e, t, n, a, o, i, s, l, c, u, d, w, f, A, b, g];
  }
  // prettier-ignore
  set(e, t, n, a, o, i, s, l, c, u, d, w, f, A, b, g) {
    this.Ah = e | 0, this.Al = t | 0, this.Bh = n | 0, this.Bl = a | 0, this.Ch = o | 0, this.Cl = i | 0, this.Dh = s | 0, this.Dl = l | 0, this.Eh = c | 0, this.El = u | 0, this.Fh = d | 0, this.Fl = w | 0, this.Gh = f | 0, this.Gl = A | 0, this.Hh = b | 0, this.Hl = g | 0;
  }
  process(e, t) {
    for (let C = 0; C < 16; C++, t += 4)
      ua[C] = e.getUint32(t), da[C] = e.getUint32(t += 4);
    for (let C = 16; C < 80; C++) {
      const W = ua[C - 15] | 0, Z = da[C - 15] | 0, D = _t.rotrSH(W, Z, 1) ^ _t.rotrSH(W, Z, 8) ^ _t.shrSH(W, Z, 7), H = _t.rotrSL(W, Z, 1) ^ _t.rotrSL(W, Z, 8) ^ _t.shrSL(W, Z, 7), y = ua[C - 2] | 0, S = da[C - 2] | 0, _ = _t.rotrSH(y, S, 19) ^ _t.rotrBH(y, S, 61) ^ _t.shrSH(y, S, 6), F = _t.rotrSL(y, S, 19) ^ _t.rotrBL(y, S, 61) ^ _t.shrSL(y, S, 6), M = _t.add4L(H, F, da[C - 7], da[C - 16]), j = _t.add4H(M, D, _, ua[C - 7], ua[C - 16]);
      ua[C] = j | 0, da[C] = M | 0;
    }
    let { Ah: n, Al: a, Bh: o, Bl: i, Ch: s, Cl: l, Dh: c, Dl: u, Eh: d, El: w, Fh: f, Fl: A, Gh: b, Gl: g, Hh: k, Hl: v } = this;
    for (let C = 0; C < 80; C++) {
      const W = _t.rotrSH(d, w, 14) ^ _t.rotrSH(d, w, 18) ^ _t.rotrBH(d, w, 41), Z = _t.rotrSL(d, w, 14) ^ _t.rotrSL(d, w, 18) ^ _t.rotrBL(d, w, 41), D = d & f ^ ~d & b, H = w & A ^ ~w & g, y = _t.add5L(v, Z, H, b6[C], da[C]), S = _t.add5H(y, k, W, D, _6[C], ua[C]), _ = y | 0, F = _t.rotrSH(n, a, 28) ^ _t.rotrBH(n, a, 34) ^ _t.rotrBH(n, a, 39), M = _t.rotrSL(n, a, 28) ^ _t.rotrBL(n, a, 34) ^ _t.rotrBL(n, a, 39), j = n & o ^ n & s ^ o & s, Y = a & i ^ a & l ^ i & l;
      k = b | 0, v = g | 0, b = f | 0, g = A | 0, f = d | 0, A = w | 0, { h: d, l: w } = _t.add(c | 0, u | 0, S | 0, _ | 0), c = s | 0, u = l | 0, s = o | 0, l = i | 0, o = n | 0, i = a | 0;
      const N = _t.add3L(_, M, Y);
      n = _t.add3H(N, S, F, j), a = N | 0;
    }
    ({ h: n, l: a } = _t.add(this.Ah | 0, this.Al | 0, n | 0, a | 0)), { h: o, l: i } = _t.add(this.Bh | 0, this.Bl | 0, o | 0, i | 0), { h: s, l } = _t.add(this.Ch | 0, this.Cl | 0, s | 0, l | 0), { h: c, l: u } = _t.add(this.Dh | 0, this.Dl | 0, c | 0, u | 0), { h: d, l: w } = _t.add(this.Eh | 0, this.El | 0, d | 0, w | 0), { h: f, l: A } = _t.add(this.Fh | 0, this.Fl | 0, f | 0, A | 0), { h: b, l: g } = _t.add(this.Gh | 0, this.Gl | 0, b | 0, g | 0), { h: k, l: v } = _t.add(this.Hh | 0, this.Hl | 0, k | 0, v | 0), this.set(n, a, o, i, s, l, c, u, d, w, f, A, b, g, k, v);
  }
  roundClean() {
    ua.fill(0), da.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class S6 extends s3 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
const Ms = /* @__PURE__ */ td(() => new s3()), E6 = /* @__PURE__ */ td(() => new S6());
class hr extends Error {
  constructor(e) {
    super(e.toLowerCase()), this.isKatavaultError = !0;
  }
}
class Qc extends hr {
  constructor() {
    super(...arguments), this.type = Am;
  }
}
class _u extends hr {
  constructor() {
    super(...arguments), this.type = Cm;
  }
}
class hh extends hr {
  constructor() {
    super(...arguments), this.type = Dm;
  }
}
class fh extends hr {
  constructor() {
    super(...arguments), this.type = Mm;
  }
}
class x6 extends hr {
  constructor() {
    super(...arguments), this.type = Rm;
  }
}
class k6 extends hr {
  constructor() {
    super(...arguments), this.type = e3;
  }
}
class yr extends hr {
  constructor() {
    super(...arguments), this.type = Im;
  }
}
class bu extends hr {
  constructor() {
    super(...arguments), this.type = Tm;
  }
}
class A6 extends hr {
  constructor() {
    super(...arguments), this.type = Om;
  }
}
class ph extends hr {
  constructor() {
    super(...arguments), this.type = Pm;
  }
}
class gh extends hr {
  constructor() {
    super(...arguments), this.type = Nm;
  }
}
class u1 extends hr {
  constructor() {
    super(...arguments), this.type = Lm;
  }
}
class Un extends hr {
  constructor() {
    super(...arguments), this.type = Bm;
  }
}
class C6 extends hr {
  constructor() {
    super(...arguments), this.type = Vm;
  }
}
class vs extends hr {
  constructor() {
    super(...arguments), this.type = Um;
  }
}
class D6 extends hr {
  constructor() {
    super(...arguments), this.type = $m;
  }
}
class M6 extends hr {
  constructor() {
    super(...arguments), this.type = jm;
  }
}
class R6 extends hr {
  constructor() {
    super(...arguments), this.type = Fm;
  }
}
class I6 extends hr {
  constructor() {
    super(...arguments), this.type = zm;
  }
}
const el = class bn {
  constructor(e) {
    this._publicKey = e;
  }
  /**
   * public static methods
   */
  /**
   * Initializes the AVMAddress instance from an AVM address.
   * @param {string} address - An AVM address.
   * @returns {AVMAddress} An initialized AVMAddress instance.
   * @throws {InvalidAVMAddressError} If the supplied address is not a valid AVM address.
   */
  static fromAddress(e) {
    let t;
    try {
      t = vc.decode(e, {
        ignorePadding: !0
      });
    } catch (n) {
      throw new gh(`invalid address: ${n.message}`);
    }
    if (t.length !== bn.addressByteLength)
      throw new gh(
        `expected a byte length of "${bn.addressByteLength}" but got "${t.length}"`
      );
    return new bn(t.slice(0, bn.addressByteLength - bn.checksumByteLength));
  }
  /**
   * Initializes the AVMAddress instance from a public key.
   * @param {Uint8Array} publicKey - A public key.
   * @returns {AVMAddress} An initialized AVMAddress instance.
   */
  static fromPublicKey(e) {
    return new bn(e);
  }
  /**
   * Validates whether a given AVM address is valid.
   * @param {string} address - The address to validate.
   * @returns {boolean} Returns true if the address is valid, otherwise false.
   * @public
   * @static
   */
  static isValid(e) {
    try {
      return vc.decode(e, {
        ignorePadding: !0
      }).length === bn.addressByteLength;
    } catch {
      return !1;
    }
  }
  /**
   * Generates and returns a zeroed-out AVM address.
   * @returns {string} A zeroed-out AVM address.
   * @public
   * @static
   */
  static zeroAddress() {
    return vc.encode(new Uint8Array(bn.addressByteLength + bn.checksumByteLength), {
      noPadding: !0,
      uppercase: !0
    });
  }
  /**
   * public methods
   */
  /**
   * Gets the AVM address.
   * @returns {string} The encoded address as a string.
   * @public
   */
  address() {
    return vc.encode(Ds(this._publicKey, this.checksum()), {
      noPadding: !0,
      uppercase: !0
    });
  }
  /**
   * Gets the checksum of the AVM address. The checksum is the last 4 bytes of the SHA 512/256 hash of the public key.
   * @returns {Uint8Array} The last 4 bytes of the SHA 512/256 hash of the public key.
   * @public
   */
  checksum() {
    const e = E6(this._publicKey);
    return e.slice(e.length - bn.checksumByteLength);
  }
  /**
   * The public key of the AVM address.
   * @returns {Uint8Array} The public key of the AVM address.
   * @public
   */
  publicKey() {
    return this._publicKey;
  }
};
el.addressByteLength = 36, el.checksumByteLength = 4, el.displayName = "AVMAddress";
let rd = el;
var Er = /* @__PURE__ */ ((r) => (r.Connected = "connected", r.Ephemeral = "ephemeral", r))(Er || {}), Vn = /* @__PURE__ */ ((r) => (r.Authentication = "authentication", r.Vault = "vault", r))(Vn || {}), wr = /* @__PURE__ */ ((r) => (r[r.Passkey = 0] = "Passkey", r[r.Password = 1] = "Password", r))(wr || {}), c3 = /* @__PURE__ */ ((r) => (r.AVMWebProvider = "avm-web-provider", r.Reown = "reown", r))(c3 || {}), d1 = /* @__PURE__ */ ((r) => (r.Credential = "credential", r))(d1 || {}), Gr = /* @__PURE__ */ ((r) => (r.AccountsUpdated = "kv:ev:accounts_updated", r.Logout = "kv:ev:logout", r.SettingsUpdated = "kv:ev:settings_updated", r))(Gr || {});
const tl = class Qr {
  constructor({ method: e, payload: t }) {
    this._method = e, this._payload = t;
  }
  /**
   * private static methods
   */
  static _encodePasskeyPayload(e) {
    return Dn.encode(Ms(cn.decode(e)));
  }
  static _encodePasswordPayload(e) {
    return Dn.encode(Ms(Vr.decode(e)));
  }
  /**
   * public static methods
   */
  /**
   * Generates a credential ID based on the authentication method.
   * * Passkeys: `passkey:base58(<SHA-512 of the credential ID>)`
   * * Passwords: `password:base58(<SHA-512 of the password>)`
   * @param {CredentialIDParameters} params - The parameters containing authentication method and credential details.
   * @return {CredentialID} An initialized instance of the credential ID.
   * @throws {AuthenticationMethodNotSupportedError} If the authentication method is not supported.
   * @public
   * @static
   */
  static create(e) {
    switch (e.method) {
      case wr.Passkey:
        return new Qr({
          method: wr.Passkey,
          payload: Qr._encodePasskeyPayload(e.passkeyCredentialID)
        });
      case wr.Password:
        return new Qr({
          method: wr.Password,
          payload: Qr._encodePasswordPayload(e.password)
        });
      default:
        throw new _u("invalid authentication method");
    }
  }
  /**
   * Initializes a credential ID from a credential ID string, i.e. `<method>:<payload>`.
   *
   * @param {string} credentialID - The stringified credential ID.
   * @returns {CredentialID} An initialized CredentialID instance.
   * @throws {InvalidCredentialIDError} If the credential ID is not valid.
   * @public
   * @static
   */
  static fromString(e) {
    const [t, n] = e.split(":");
    switch (t) {
      case Qr.passkeyCredentialIDPrefix:
        return new Qr({
          method: wr.Passkey,
          payload: n
        });
      case Qr.passwordCredentialIDPrefix:
        return new Qr({
          method: wr.Password,
          payload: n
        });
      default:
        throw new x6('invalid credential id should be in the format "<method>:<payload>"');
    }
  }
  /**
   * public methods
   */
  /**
   * Retrieves the authentication method.
   *
   * @return {AuthenticationMethodEnum} The authentication method.
   * @public
   */
  method() {
    return this._method;
  }
  /**
   * Retrieves the payload.
   *
   * @return {string} The payload.
   * @public
   */
  payload() {
    return this._payload;
  }
  /**
   * Converts the credential ID into a string representation in the format `<method>:<payload>`.
   *
   * @return {string} A string representation of the credential ID.
   * @throws {AuthenticationMethodNotSupportedError} If the authentication method is not supported.
   * @public
   */
  toString() {
    switch (this._method) {
      case wr.Passkey:
        return `${Qr.passkeyCredentialIDPrefix}:${this._payload}`;
      case wr.Password:
        return `${Qr.passwordCredentialIDPrefix}:${this._payload}`;
      default:
        throw new _u("invalid authentication method");
    }
  }
  /**
   * Verifies the provided claim against the credential ID payload for the credential ID authentication method.
   *
   * For passkeys, this will be the passkey credential ID encoded in base64.
   * For password, this will be the UTF-8 encoded password.
   *
   * @param {string} claim - The claim to be verified.
   * @throws {AuthenticationMethodNotSupportedError} If the authentication method is not supported.
   * @public
   */
  verify(e) {
    switch (this._method) {
      case wr.Passkey:
        return this._payload === Qr._encodePasskeyPayload(e);
      case wr.Password:
        return this._payload === Qr._encodePasswordPayload(e);
      default:
        throw new _u("invalid authentication method");
    }
  }
};
tl.displayName = "CredentialID", tl.passkeyCredentialIDPrefix = "passkey", tl.passwordCredentialIDPrefix = "password";
let gl = tl;
var T6 = Object.defineProperty, O6 = (r, e, t) => e in r ? T6(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, mh = (r, e, t) => O6(r, typeof e != "symbol" ? e + "" : e, t);
function P6(r) {
  let e = r + 48;
  return e += 9 - r >>> 8 & 7, String.fromCharCode(e);
}
function N6(r) {
  let e = r + 48;
  return e += 9 - r >>> 8 & 39, String.fromCharCode(e);
}
function B6(r, e = !1) {
  const t = e ? N6 : P6;
  let n = "";
  for (let a = 0; a < r.length; a++)
    n += t(r[a] >>> 4), n += t(r[a] & 15);
  return n;
}
const yh = 65536;
let L6 = class {
  constructor() {
    mh(this, "isAvailable", !1), mh(this, "isInstantiated", !1), typeof crypto < "u" && "getRandomValues" in crypto && (this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(r) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    const e = new Uint8Array(r);
    for (let t = 0; t < e.length; t += yh)
      crypto.getRandomValues(e.subarray(t, t + Math.min(e.length - t, yh)));
    return e;
  }
};
function U6(r) {
  for (let e = 0; e < r.length; e++)
    r[e] = 0;
  return r;
}
const V6 = new L6();
function $6(r, e = V6) {
  return e.randomBytes(r);
}
function j6(r) {
  const e = $6(16, r);
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const t = B6(e, !0);
  return U6(e), t.substring(0, 8) + "-" + t.substring(8, 12) + "-" + t.substring(12, 16) + "-" + t.substring(16, 20) + "-" + t.substring(20, 32);
}
function F6({ uppercase: r } = { uppercase: !1 }) {
  const e = j6();
  return r ? e.toUpperCase() : e.toLowerCase();
}
function z6({ account: r, chain: e }) {
  switch (e.namespace()) {
    case Ht.Algorand:
    case Ht.AVM:
      return rd.fromPublicKey(Dn.decode(r.key)).address();
    default:
      throw new Un(`namespace "${e.namespace()}" not supported`);
  }
}
async function l3({
  clientInformation: r,
  logger: e,
  username: t,
  vault: n
}) {
  const a = "utilities#authenticateWithPasskey", o = new Wo({
    hostname: r.hostname,
    logger: e,
    username: t,
    vault: n
  });
  let i, s = await o.passkey();
  return s || (e.debug(`${a}: no passkey exists, registering new credential`), s = await Wo.register({
    clientInformation: r,
    logger: e,
    username: t
  }), await o.setPasskey(s)), e.debug(`${a}: authenticating new credential "${s.credentialID}"`), i = await Wo.authenticate({
    logger: e,
    ...s
  }), o.setKeyMaterial(i), e.debug(`${a}: authenticated new credential "${s.credentialID}"`), o;
}
async function u3({
  clientInformation: r,
  logger: e,
  password: t,
  username: n,
  vault: a
}) {
  const o = "utilities#authenticateWithPassword", i = new S1({
    hostname: r.hostname,
    logger: e,
    username: n,
    vault: a
  });
  let s = await i.challenge(), l;
  if (i.setPassword(t), s) {
    if (e.debug(`${o}: password store exists`), l = await i.verify(), !l)
      throw new k6("incorrect password");
    return e.debug(`${o}: signed in with password`), i;
  }
  const { score: c } = ml(t);
  if (e.debug(`${o}: password score "${c}"`), c <= 0)
    throw new A6("password is too weak");
  return e.debug(`${o}: initializing new password store`), s = cn.encode(await i.encryptBytes(Vr.decode(S1.challenge))), await i.setChallenge(s), await i.setLastUsedAt(), e.debug(`${o}: created new credential with password`), i;
}
function Su(r) {
  return ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : new Uint8Array(r);
}
function H6() {
  var r;
  return ((r = document.querySelector('meta[name="application-name"]')) == null ? void 0 : r.getAttribute("content")) || document.title;
}
function q6() {
  const r = document.getElementsByTagName("link"), e = [];
  for (const t of Array.from(r)) {
    const n = t.getAttribute("rel");
    let a, o;
    if (!(!n || !n.toLowerCase().includes("icon")) && (a = t.getAttribute("href"), !!a)) {
      if (a.toLowerCase().indexOf("https:") === 0 || a.toLowerCase().indexOf("http:") === 0) {
        e.push(a);
        continue;
      }
      if (a.toLowerCase().indexOf("//") === 0) {
        e.push(`${window.location.protocol}${a}`);
        continue;
      }
      o = `${window.location.protocol}//${window.location.host}`, a.indexOf("/") === -1 && (a = window.location.pathname.split("/").map((i, s, l) => !a || s < l.length - 1 ? i : a).join("/")), e.push(`${o}${a}`);
    }
  }
  return e.find((t) => t.match(/\.(jpg|jpeg|png|gif)$/i)) || // favour image files over ico
  e[0] || null;
}
var d3 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bi(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function W6(r) {
  if (Object.prototype.hasOwnProperty.call(r, "__esModule")) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var wh = { exports: {} };
/*!
 * Fast "async" scrypt implementation in JavaScript.
 * Copyright (c) 2013-2016 Dmitry Chestnykh | BSD License
 * https://github.com/dchest/scrypt-async-js
 */
var vh;
function K6() {
  return vh || (vh = 1, function(r) {
    function e(t, n, a, o, i, s, l, c) {
      function u(te) {
        var B = [
          1116352408,
          1899447441,
          3049323471,
          3921009573,
          961987163,
          1508970993,
          2453635748,
          2870763221,
          3624381080,
          310598401,
          607225278,
          1426881987,
          1925078388,
          2162078206,
          2614888103,
          3248222580,
          3835390401,
          4022224774,
          264347078,
          604807628,
          770255983,
          1249150122,
          1555081692,
          1996064986,
          2554220882,
          2821834349,
          2952996808,
          3210313671,
          3336571891,
          3584528711,
          113926993,
          338241895,
          666307205,
          773529912,
          1294757372,
          1396182291,
          1695183700,
          1986661051,
          2177026350,
          2456956037,
          2730485921,
          2820302411,
          3259730800,
          3345764771,
          3516065817,
          3600352804,
          4094571909,
          275423344,
          430227734,
          506948616,
          659060556,
          883997877,
          958139571,
          1322822218,
          1537002063,
          1747873779,
          1955562222,
          2024104815,
          2227730452,
          2361852424,
          2428436474,
          2756734187,
          3204031479,
          3329325298
        ], oe = 1779033703, ce = 3144134277, Ce = 1013904242, he = 2773480762, ge = 1359893119, h = 2600822924, m = 528734635, E = 1541459225, $ = new Array(64);
        function R(re) {
          for (var le = 0, ee = re.length; ee >= 64; ) {
            var Se = oe, Re = ce, Ne = Ce, Ie = he, De = ge, Fe = h, lt = m, ft = E, it, Ue, nt, He, ze;
            for (Ue = 0; Ue < 16; Ue++)
              nt = le + Ue * 4, $[Ue] = (re[nt] & 255) << 24 | (re[nt + 1] & 255) << 16 | (re[nt + 2] & 255) << 8 | re[nt + 3] & 255;
            for (Ue = 16; Ue < 64; Ue++)
              it = $[Ue - 2], He = (it >>> 17 | it << 15) ^ (it >>> 19 | it << 13) ^ it >>> 10, it = $[Ue - 15], ze = (it >>> 7 | it << 25) ^ (it >>> 18 | it << 14) ^ it >>> 3, $[Ue] = (He + $[Ue - 7] | 0) + (ze + $[Ue - 16] | 0) | 0;
            for (Ue = 0; Ue < 64; Ue++)
              He = (((De >>> 6 | De << 26) ^ (De >>> 11 | De << 21) ^ (De >>> 25 | De << 7)) + (De & Fe ^ ~De & lt) | 0) + (ft + (B[Ue] + $[Ue] | 0) | 0) | 0, ze = ((Se >>> 2 | Se << 30) ^ (Se >>> 13 | Se << 19) ^ (Se >>> 22 | Se << 10)) + (Se & Re ^ Se & Ne ^ Re & Ne) | 0, ft = lt, lt = Fe, Fe = De, De = Ie + He | 0, Ie = Ne, Ne = Re, Re = Se, Se = He + ze | 0;
            oe = oe + Se | 0, ce = ce + Re | 0, Ce = Ce + Ne | 0, he = he + Ie | 0, ge = ge + De | 0, h = h + Fe | 0, m = m + lt | 0, E = E + ft | 0, le += 64, ee -= 64;
          }
        }
        R(te);
        var P, J = te.length % 64, I = te.length / 536870912 | 0, U = te.length << 3, K = J < 56 ? 56 : 120, z = te.slice(te.length - J, te.length);
        for (z.push(128), P = J + 1; P < K; P++) z.push(0);
        return z.push(I >>> 24 & 255), z.push(I >>> 16 & 255), z.push(I >>> 8 & 255), z.push(I >>> 0 & 255), z.push(U >>> 24 & 255), z.push(U >>> 16 & 255), z.push(U >>> 8 & 255), z.push(U >>> 0 & 255), R(z), [
          oe >>> 24 & 255,
          oe >>> 16 & 255,
          oe >>> 8 & 255,
          oe >>> 0 & 255,
          ce >>> 24 & 255,
          ce >>> 16 & 255,
          ce >>> 8 & 255,
          ce >>> 0 & 255,
          Ce >>> 24 & 255,
          Ce >>> 16 & 255,
          Ce >>> 8 & 255,
          Ce >>> 0 & 255,
          he >>> 24 & 255,
          he >>> 16 & 255,
          he >>> 8 & 255,
          he >>> 0 & 255,
          ge >>> 24 & 255,
          ge >>> 16 & 255,
          ge >>> 8 & 255,
          ge >>> 0 & 255,
          h >>> 24 & 255,
          h >>> 16 & 255,
          h >>> 8 & 255,
          h >>> 0 & 255,
          m >>> 24 & 255,
          m >>> 16 & 255,
          m >>> 8 & 255,
          m >>> 0 & 255,
          E >>> 24 & 255,
          E >>> 16 & 255,
          E >>> 8 & 255,
          E >>> 0 & 255
        ];
      }
      function d(te, B, oe) {
        te.length > 64 && (te = u(te.push ? te : Array.prototype.slice.call(te, 0)));
        var ce, Ce = 64 + B.length + 4, he = new Array(Ce), ge = new Array(64), h = [];
        for (ce = 0; ce < 64; ce++) he[ce] = 54;
        for (ce = 0; ce < te.length; ce++) he[ce] ^= te[ce];
        for (ce = 0; ce < B.length; ce++) he[64 + ce] = B[ce];
        for (ce = Ce - 4; ce < Ce; ce++) he[ce] = 0;
        for (ce = 0; ce < 64; ce++) ge[ce] = 92;
        for (ce = 0; ce < te.length; ce++) ge[ce] ^= te[ce];
        function m() {
          for (var E = Ce - 1; E >= Ce - 4; E--) {
            if (he[E]++, he[E] <= 255) return;
            he[E] = 0;
          }
        }
        for (; oe >= 32; )
          m(), h = h.concat(u(ge.concat(u(he)))), oe -= 32;
        return oe > 0 && (m(), h = h.concat(u(ge.concat(u(he))).slice(0, oe))), h;
      }
      function w(te, B, oe, ce) {
        var Ce = te[0] ^ B[oe++], he = te[1] ^ B[oe++], ge = te[2] ^ B[oe++], h = te[3] ^ B[oe++], m = te[4] ^ B[oe++], E = te[5] ^ B[oe++], $ = te[6] ^ B[oe++], R = te[7] ^ B[oe++], P = te[8] ^ B[oe++], J = te[9] ^ B[oe++], I = te[10] ^ B[oe++], U = te[11] ^ B[oe++], K = te[12] ^ B[oe++], z = te[13] ^ B[oe++], re = te[14] ^ B[oe++], le = te[15] ^ B[oe++], ee, Se, Re = Ce, Ne = he, Ie = ge, De = h, Fe = m, lt = E, ft = $, it = R, Ue = P, nt = J, He = I, ze = U, Be = K, Pt = z, kt = re, It = le;
        for (Se = 0; Se < 8; Se += 2)
          ee = Re + Be, Fe ^= ee << 7 | ee >>> 25, ee = Fe + Re, Ue ^= ee << 9 | ee >>> 23, ee = Ue + Fe, Be ^= ee << 13 | ee >>> 19, ee = Be + Ue, Re ^= ee << 18 | ee >>> 14, ee = lt + Ne, nt ^= ee << 7 | ee >>> 25, ee = nt + lt, Pt ^= ee << 9 | ee >>> 23, ee = Pt + nt, Ne ^= ee << 13 | ee >>> 19, ee = Ne + Pt, lt ^= ee << 18 | ee >>> 14, ee = He + ft, kt ^= ee << 7 | ee >>> 25, ee = kt + He, Ie ^= ee << 9 | ee >>> 23, ee = Ie + kt, ft ^= ee << 13 | ee >>> 19, ee = ft + Ie, He ^= ee << 18 | ee >>> 14, ee = It + ze, De ^= ee << 7 | ee >>> 25, ee = De + It, it ^= ee << 9 | ee >>> 23, ee = it + De, ze ^= ee << 13 | ee >>> 19, ee = ze + it, It ^= ee << 18 | ee >>> 14, ee = Re + De, Ne ^= ee << 7 | ee >>> 25, ee = Ne + Re, Ie ^= ee << 9 | ee >>> 23, ee = Ie + Ne, De ^= ee << 13 | ee >>> 19, ee = De + Ie, Re ^= ee << 18 | ee >>> 14, ee = lt + Fe, ft ^= ee << 7 | ee >>> 25, ee = ft + lt, it ^= ee << 9 | ee >>> 23, ee = it + ft, Fe ^= ee << 13 | ee >>> 19, ee = Fe + it, lt ^= ee << 18 | ee >>> 14, ee = He + nt, ze ^= ee << 7 | ee >>> 25, ee = ze + He, Ue ^= ee << 9 | ee >>> 23, ee = Ue + ze, nt ^= ee << 13 | ee >>> 19, ee = nt + Ue, He ^= ee << 18 | ee >>> 14, ee = It + kt, Be ^= ee << 7 | ee >>> 25, ee = Be + It, Pt ^= ee << 9 | ee >>> 23, ee = Pt + Be, kt ^= ee << 13 | ee >>> 19, ee = kt + Pt, It ^= ee << 18 | ee >>> 14;
        B[ce++] = te[0] = Re + Ce | 0, B[ce++] = te[1] = Ne + he | 0, B[ce++] = te[2] = Ie + ge | 0, B[ce++] = te[3] = De + h | 0, B[ce++] = te[4] = Fe + m | 0, B[ce++] = te[5] = lt + E | 0, B[ce++] = te[6] = ft + $ | 0, B[ce++] = te[7] = it + R | 0, B[ce++] = te[8] = Ue + P | 0, B[ce++] = te[9] = nt + J | 0, B[ce++] = te[10] = He + I | 0, B[ce++] = te[11] = ze + U | 0, B[ce++] = te[12] = Be + K | 0, B[ce++] = te[13] = Pt + z | 0, B[ce++] = te[14] = kt + re | 0, B[ce++] = te[15] = It + le | 0;
      }
      function f(te, B, oe, ce, Ce) {
        for (; Ce--; ) te[B++] = oe[ce++];
      }
      function A(te, B, oe, ce, Ce) {
        for (; Ce--; ) te[B++] ^= oe[ce++];
      }
      function b(te, B, oe, ce, Ce) {
        f(te, 0, B, oe + (2 * Ce - 1) * 16, 16);
        for (var he = 0; he < 2 * Ce; he += 2)
          w(te, B, oe + he * 16, ce + he * 8), w(te, B, oe + he * 16 + 16, ce + he * 8 + Ce * 16);
      }
      function g(te, B, oe) {
        return te[B + (2 * oe - 1) * 16];
      }
      function k(te) {
        for (var B = [], oe = 0; oe < te.length; oe++) {
          var ce = te.charCodeAt(oe);
          if (ce < 128)
            B.push(ce);
          else if (ce < 2048)
            B.push(192 | ce >> 6), B.push(128 | ce & 63);
          else if (ce < 55296)
            B.push(224 | ce >> 12), B.push(128 | ce >> 6 & 63), B.push(128 | ce & 63);
          else {
            if (oe >= te.length - 1)
              throw new Error("invalid string");
            oe++, ce = (ce & 1023) << 10, ce |= te.charCodeAt(oe) & 1023, ce += 65536, B.push(240 | ce >> 18), B.push(128 | ce >> 12 & 63), B.push(128 | ce >> 6 & 63), B.push(128 | ce & 63);
          }
        }
        return B;
      }
      function v(te) {
        for (var B = "0123456789abcdef".split(""), oe = te.length, ce = [], Ce = 0; Ce < oe; Ce++)
          ce.push(B[te[Ce] >>> 4 & 15]), ce.push(B[te[Ce] >>> 0 & 15]);
        return ce.join("");
      }
      function C(te) {
        for (var B = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), oe = te.length, ce = [], Ce = 0, he, ge, h, m; Ce < oe; )
          he = Ce < oe ? te[Ce++] : 0, ge = Ce < oe ? te[Ce++] : 0, h = Ce < oe ? te[Ce++] : 0, m = (he << 16) + (ge << 8) + h, ce.push(B[m >>> 3 * 6 & 63]), ce.push(B[m >>> 2 * 6 & 63]), ce.push(B[m >>> 1 * 6 & 63]), ce.push(B[m >>> 0 * 6 & 63]);
        return oe % 3 > 0 && (ce[ce.length - 1] = "=", oe % 3 === 1 && (ce[ce.length - 2] = "=")), ce.join("");
      }
      var W = -1 >>> 0, Z = 1;
      if (typeof a == "object") {
        if (arguments.length > 4)
          throw new Error("scrypt: incorrect number of arguments");
        var D = a;
        if (l = o, a = D.logN, typeof a > "u")
          if (typeof D.N < "u") {
            if (D.N < 2 || D.N > W)
              throw new Error("scrypt: N is out of range");
            if ((D.N & D.N - 1) !== 0)
              throw new Error("scrypt: N is not a power of 2");
            a = Math.log(D.N) / Math.LN2;
          } else
            throw new Error("scrypt: missing N parameter");
        Z = D.p || 1, o = D.r, i = D.dkLen || 32, s = D.interruptStep || 0, c = D.encoding;
      }
      if (Z < 1)
        throw new Error("scrypt: invalid p");
      if (o <= 0)
        throw new Error("scrypt: invalid r");
      if (a < 1 || a > 31)
        throw new Error("scrypt: logN must be between 1 and 31");
      var H = 1 << a >>> 0, y, S, _, F;
      if (o * Z >= 1 << 30 || o > W / 128 / Z || o > W / 256 || H > W / 128 / o)
        throw new Error("scrypt: parameters are too large");
      typeof t == "string" && (t = k(t)), typeof n == "string" && (n = k(n)), typeof Int32Array < "u" ? (y = new Int32Array(64 * o), S = new Int32Array(32 * H * o), F = new Int32Array(16)) : (y = [], S = [], F = new Array(16)), _ = d(t, n, Z * 128 * o);
      var M = 0, j = 32 * o;
      function Y(te) {
        for (var B = 0; B < 32 * o; B++) {
          var oe = te + B * 4;
          y[M + B] = (_[oe + 3] & 255) << 24 | (_[oe + 2] & 255) << 16 | (_[oe + 1] & 255) << 8 | (_[oe + 0] & 255) << 0;
        }
      }
      function N(te, B) {
        for (var oe = te; oe < B; oe += 2)
          f(S, oe * (32 * o), y, M, 32 * o), b(F, y, M, j, o), f(S, (oe + 1) * (32 * o), y, j, 32 * o), b(F, y, j, M, o);
      }
      function O(te, B) {
        for (var oe = te; oe < B; oe += 2) {
          var ce = g(y, M, o) & H - 1;
          A(y, M, S, ce * (32 * o), 32 * o), b(F, y, M, j, o), ce = g(y, j, o) & H - 1, A(y, j, S, ce * (32 * o), 32 * o), b(F, y, j, M, o);
        }
      }
      function G(te) {
        for (var B = 0; B < 32 * o; B++) {
          var oe = y[M + B];
          _[te + B * 4 + 0] = oe >>> 0 & 255, _[te + B * 4 + 1] = oe >>> 8 & 255, _[te + B * 4 + 2] = oe >>> 16 & 255, _[te + B * 4 + 3] = oe >>> 24 & 255;
        }
      }
      var Q = typeof setImmediate < "u" ? setImmediate : setTimeout;
      function ie(te, B, oe, ce, Ce) {
        (function he() {
          Q(function() {
            ce(te, te + oe < B ? te + oe : B), te += oe, te < B ? he() : Ce();
          });
        })();
      }
      function fe(te) {
        var B = d(t, _, i);
        return te === "base64" ? C(B) : te === "hex" ? v(B) : te === "binary" ? new Uint8Array(B) : B;
      }
      function pe() {
        for (var te = 0; te < Z; te++)
          Y(te * 128 * o), N(0, H), O(0, H), G(te * 128 * o);
        l(fe(c));
      }
      function ye(te) {
        Y(te * 128 * o), ie(0, H, s * 2, N, function() {
          ie(0, H, s * 2, O, function() {
            G(te * 128 * o), te + 1 < Z ? Q(function() {
              ye(te + 1);
            }) : l(fe(c));
          });
        });
      }
      typeof s == "function" && (c = l, l = s, s = 1e3), s <= 0 ? pe() : ye(0);
    }
    r.exports = e;
  }(wh)), wh.exports;
}
var Y6 = K6();
const G6 = /* @__PURE__ */ Bi(Y6);
async function Eu({
  keyLength: r,
  salt: e,
  secret: t
}) {
  return new Promise((n) => {
    const a = Ms(t);
    G6(
      a,
      e,
      {
        N: 16384,
        // cpu/memory cost parameter (must be power of two; alternatively, you can specify logN where N = 2^logN).
        r: 8,
        // block size parameter
        p: 1,
        // parallelization parameter
        dkLen: r,
        // derived key length
        encoding: "binary"
      },
      (o) => n(o)
    );
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const tu = /* @__PURE__ */ BigInt(0), ru = /* @__PURE__ */ BigInt(1), J6 = /* @__PURE__ */ BigInt(2);
function uo(r) {
  return r instanceof Uint8Array || ArrayBuffer.isView(r) && r.constructor.name === "Uint8Array";
}
function uc(r) {
  if (!uo(r))
    throw new Error("Uint8Array expected");
}
function ia(r, e) {
  if (typeof e != "boolean")
    throw new Error(r + " boolean expected, got " + e);
}
const X6 = /* @__PURE__ */ Array.from({ length: 256 }, (r, e) => e.toString(16).padStart(2, "0"));
function ho(r) {
  uc(r);
  let e = "";
  for (let t = 0; t < r.length; t++)
    e += X6[r[t]];
  return e;
}
function Ho(r) {
  const e = r.toString(16);
  return e.length & 1 ? "0" + e : e;
}
function nd(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  return r === "" ? tu : BigInt("0x" + r);
}
const Kn = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function _h(r) {
  if (r >= Kn._0 && r <= Kn._9)
    return r - Kn._0;
  if (r >= Kn.A && r <= Kn.F)
    return r - (Kn.A - 10);
  if (r >= Kn.a && r <= Kn.f)
    return r - (Kn.a - 10);
}
function Jo(r) {
  if (typeof r != "string")
    throw new Error("hex string expected, got " + typeof r);
  const e = r.length, t = e / 2;
  if (e % 2)
    throw new Error("hex string expected, got unpadded hex of length " + e);
  const n = new Uint8Array(t);
  for (let a = 0, o = 0; a < t; a++, o += 2) {
    const i = _h(r.charCodeAt(o)), s = _h(r.charCodeAt(o + 1));
    if (i === void 0 || s === void 0) {
      const l = r[o] + r[o + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + o);
    }
    n[a] = i * 16 + s;
  }
  return n;
}
function La(r) {
  return nd(ho(r));
}
function qo(r) {
  return uc(r), nd(ho(Uint8Array.from(r).reverse()));
}
function fo(r, e) {
  return Jo(r.toString(16).padStart(e * 2, "0"));
}
function Rs(r, e) {
  return fo(r, e).reverse();
}
function Z6(r) {
  return Jo(Ho(r));
}
function lr(r, e, t) {
  let n;
  if (typeof e == "string")
    try {
      n = Jo(e);
    } catch (o) {
      throw new Error(r + " must be hex string or Uint8Array, cause: " + o);
    }
  else if (uo(e))
    n = Uint8Array.from(e);
  else
    throw new Error(r + " must be hex string or Uint8Array");
  const a = n.length;
  if (typeof t == "number" && a !== t)
    throw new Error(r + " of length " + t + " expected, got " + a);
  return n;
}
function po(...r) {
  let e = 0;
  for (let n = 0; n < r.length; n++) {
    const a = r[n];
    uc(a), e += a.length;
  }
  const t = new Uint8Array(e);
  for (let n = 0, a = 0; n < r.length; n++) {
    const o = r[n];
    t.set(o, a), a += o.length;
  }
  return t;
}
function Q6(r, e) {
  if (r.length !== e.length)
    return !1;
  let t = 0;
  for (let n = 0; n < r.length; n++)
    t |= r[n] ^ e[n];
  return t === 0;
}
function e4(r) {
  if (typeof r != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(r));
}
const xu = (r) => typeof r == "bigint" && tu <= r;
function nu(r, e, t) {
  return xu(r) && xu(e) && xu(t) && e <= r && r < t;
}
function dn(r, e, t, n) {
  if (!nu(e, t, n))
    throw new Error("expected valid " + r + ": " + t + " <= n < " + n + ", got " + e);
}
function h3(r) {
  let e;
  for (e = 0; r > tu; r >>= ru, e += 1)
    ;
  return e;
}
function t4(r, e) {
  return r >> BigInt(e) & ru;
}
function r4(r, e, t) {
  return r | (t ? ru : tu) << BigInt(e);
}
const ad = (r) => (J6 << BigInt(r - 1)) - ru, ku = (r) => new Uint8Array(r), bh = (r) => Uint8Array.from(r);
function f3(r, e, t) {
  if (typeof r != "number" || r < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof t != "function")
    throw new Error("hmacFn must be a function");
  let n = ku(r), a = ku(r), o = 0;
  const i = () => {
    n.fill(1), a.fill(0), o = 0;
  }, s = (...u) => t(a, n, ...u), l = (u = ku()) => {
    a = s(bh([0]), u), n = s(), u.length !== 0 && (a = s(bh([1]), u), n = s());
  }, c = () => {
    if (o++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let u = 0;
    const d = [];
    for (; u < e; ) {
      n = s();
      const w = n.slice();
      d.push(w), u += n.length;
    }
    return po(...d);
  };
  return (u, d) => {
    i(), l(u);
    let w;
    for (; !(w = d(c())); )
      l();
    return i(), w;
  };
}
const n4 = {
  bigint: (r) => typeof r == "bigint",
  function: (r) => typeof r == "function",
  boolean: (r) => typeof r == "boolean",
  string: (r) => typeof r == "string",
  stringOrUint8Array: (r) => typeof r == "string" || uo(r),
  isSafeInteger: (r) => Number.isSafeInteger(r),
  array: (r) => Array.isArray(r),
  field: (r, e) => e.Fp.isValid(r),
  hash: (r) => typeof r == "function" && Number.isSafeInteger(r.outputLen)
};
function Li(r, e, t = {}) {
  const n = (a, o, i) => {
    const s = n4[o];
    if (typeof s != "function")
      throw new Error("invalid validator function");
    const l = r[a];
    if (!(i && l === void 0) && !s(l, r))
      throw new Error("param " + String(a) + " is invalid. Expected " + o + ", got " + l);
  };
  for (const [a, o] of Object.entries(e))
    n(a, o, !1);
  for (const [a, o] of Object.entries(t))
    n(a, o, !0);
  return r;
}
const a4 = () => {
  throw new Error("not implemented");
};
function Is(r) {
  const e = /* @__PURE__ */ new WeakMap();
  return (t, ...n) => {
    const a = e.get(t);
    if (a !== void 0)
      return a;
    const o = r(t, ...n);
    return e.set(t, o), o;
  };
}
const o4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aInRange: dn,
  abool: ia,
  abytes: uc,
  bitGet: t4,
  bitLen: h3,
  bitMask: ad,
  bitSet: r4,
  bytesToHex: ho,
  bytesToNumberBE: La,
  bytesToNumberLE: qo,
  concatBytes: po,
  createHmacDrbg: f3,
  ensureBytes: lr,
  equalBytes: Q6,
  hexToBytes: Jo,
  hexToNumber: nd,
  inRange: nu,
  isBytes: uo,
  memoized: Is,
  notImplemented: a4,
  numberToBytesBE: fo,
  numberToBytesLE: Rs,
  numberToHexUnpadded: Ho,
  numberToVarBytesBE: Z6,
  utf8ToBytes: e4,
  validateObject: Li
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const xr = BigInt(0), Jt = BigInt(1), Xa = /* @__PURE__ */ BigInt(2), i4 = /* @__PURE__ */ BigInt(3), h1 = /* @__PURE__ */ BigInt(4), Sh = /* @__PURE__ */ BigInt(5), Eh = /* @__PURE__ */ BigInt(8);
function Wt(r, e) {
  const t = r % e;
  return t >= xr ? t : e + t;
}
function s4(r, e, t) {
  if (e < xr)
    throw new Error("invalid exponent, negatives unsupported");
  if (t <= xr)
    throw new Error("invalid modulus");
  if (t === Jt)
    return xr;
  let n = Jt;
  for (; e > xr; )
    e & Jt && (n = n * r % t), r = r * r % t, e >>= Jt;
  return n;
}
function nr(r, e, t) {
  let n = r;
  for (; e-- > xr; )
    n *= n, n %= t;
  return n;
}
function f1(r, e) {
  if (r === xr)
    throw new Error("invert: expected non-zero number");
  if (e <= xr)
    throw new Error("invert: expected positive modulus, got " + e);
  let t = Wt(r, e), n = e, a = xr, o = Jt;
  for (; t !== xr; ) {
    const i = n / t, s = n % t, l = a - o * i;
    n = t, t = s, a = o, o = l;
  }
  if (n !== Jt)
    throw new Error("invert: does not exist");
  return Wt(a, e);
}
function c4(r) {
  const e = (r - Jt) / Xa;
  let t, n, a;
  for (t = r - Jt, n = 0; t % Xa === xr; t /= Xa, n++)
    ;
  for (a = Xa; a < r && s4(a, e, r) !== r - Jt; a++)
    if (a > 1e3)
      throw new Error("Cannot find square root: likely non-prime P");
  if (n === 1) {
    const i = (r + Jt) / h1;
    return function(s, l) {
      const c = s.pow(l, i);
      if (!s.eql(s.sqr(c), l))
        throw new Error("Cannot find square root");
      return c;
    };
  }
  const o = (t + Jt) / Xa;
  return function(i, s) {
    if (i.pow(s, e) === i.neg(i.ONE))
      throw new Error("Cannot find square root");
    let l = n, c = i.pow(i.mul(i.ONE, a), t), u = i.pow(s, o), d = i.pow(s, t);
    for (; !i.eql(d, i.ONE); ) {
      if (i.eql(d, i.ZERO))
        return i.ZERO;
      let w = 1;
      for (let A = i.sqr(d); w < l && !i.eql(A, i.ONE); w++)
        A = i.sqr(A);
      const f = i.pow(c, Jt << BigInt(l - w - 1));
      c = i.sqr(f), u = i.mul(u, f), d = i.mul(d, c), l = w;
    }
    return u;
  };
}
function l4(r) {
  if (r % h1 === i4) {
    const e = (r + Jt) / h1;
    return function(t, n) {
      const a = t.pow(n, e);
      if (!t.eql(t.sqr(a), n))
        throw new Error("Cannot find square root");
      return a;
    };
  }
  if (r % Eh === Sh) {
    const e = (r - Sh) / Eh;
    return function(t, n) {
      const a = t.mul(n, Xa), o = t.pow(a, e), i = t.mul(n, o), s = t.mul(t.mul(i, Xa), o), l = t.mul(i, t.sub(s, t.ONE));
      if (!t.eql(t.sqr(l), n))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return c4(r);
}
const u4 = (r, e) => (Wt(r, e) & Jt) === Jt, d4 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function h4(r) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, t = d4.reduce((n, a) => (n[a] = "function", n), e);
  return Li(r, t);
}
function f4(r, e, t) {
  if (t < xr)
    throw new Error("invalid exponent, negatives unsupported");
  if (t === xr)
    return r.ONE;
  if (t === Jt)
    return e;
  let n = r.ONE, a = e;
  for (; t > xr; )
    t & Jt && (n = r.mul(n, a)), a = r.sqr(a), t >>= Jt;
  return n;
}
function p4(r, e) {
  const t = new Array(e.length), n = e.reduce((o, i, s) => r.is0(i) ? o : (t[s] = o, r.mul(o, i)), r.ONE), a = r.inv(n);
  return e.reduceRight((o, i, s) => r.is0(i) ? o : (t[s] = r.mul(o, t[s]), r.mul(o, i)), a), t;
}
function p3(r, e) {
  const t = e !== void 0 ? e : r.toString(2).length, n = Math.ceil(t / 8);
  return { nBitLength: t, nByteLength: n };
}
function au(r, e, t = !1, n = {}) {
  if (r <= xr)
    throw new Error("invalid field: expected ORDER > 0, got " + r);
  const { nBitLength: a, nByteLength: o } = p3(r, e);
  if (o > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let i;
  const s = Object.freeze({
    ORDER: r,
    isLE: t,
    BITS: a,
    BYTES: o,
    MASK: ad(a),
    ZERO: xr,
    ONE: Jt,
    create: (l) => Wt(l, r),
    isValid: (l) => {
      if (typeof l != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof l);
      return xr <= l && l < r;
    },
    is0: (l) => l === xr,
    isOdd: (l) => (l & Jt) === Jt,
    neg: (l) => Wt(-l, r),
    eql: (l, c) => l === c,
    sqr: (l) => Wt(l * l, r),
    add: (l, c) => Wt(l + c, r),
    sub: (l, c) => Wt(l - c, r),
    mul: (l, c) => Wt(l * c, r),
    pow: (l, c) => f4(s, l, c),
    div: (l, c) => Wt(l * f1(c, r), r),
    // Same as above, but doesn't normalize
    sqrN: (l) => l * l,
    addN: (l, c) => l + c,
    subN: (l, c) => l - c,
    mulN: (l, c) => l * c,
    inv: (l) => f1(l, r),
    sqrt: n.sqrt || ((l) => (i || (i = l4(r)), i(s, l))),
    invertBatch: (l) => p4(s, l),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (l, c, u) => u ? c : l,
    toBytes: (l) => t ? Rs(l, o) : fo(l, o),
    fromBytes: (l) => {
      if (l.length !== o)
        throw new Error("Field.fromBytes: expected " + o + " bytes, got " + l.length);
      return t ? qo(l) : La(l);
    }
  });
  return Object.freeze(s);
}
function g3(r) {
  if (typeof r != "bigint")
    throw new Error("field order must be bigint");
  const e = r.toString(2).length;
  return Math.ceil(e / 8);
}
function m3(r) {
  const e = g3(r);
  return e + Math.ceil(e / 2);
}
function g4(r, e, t = !1) {
  const n = r.length, a = g3(e), o = m3(e);
  if (n < 16 || n < o || n > 1024)
    throw new Error("expected " + o + "-1024 bytes of input, got " + n);
  const i = t ? qo(r) : La(r), s = Wt(i, e - Jt) + Jt;
  return t ? Rs(s, a) : fo(s, a);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const xh = BigInt(0), bc = BigInt(1);
function Au(r, e) {
  const t = e.negate();
  return r ? t : e;
}
function y3(r, e) {
  if (!Number.isSafeInteger(r) || r <= 0 || r > e)
    throw new Error("invalid window size, expected [1.." + e + "], got W=" + r);
}
function Cu(r, e) {
  y3(r, e);
  const t = Math.ceil(e / r) + 1, n = 2 ** (r - 1);
  return { windows: t, windowSize: n };
}
function m4(r, e) {
  if (!Array.isArray(r))
    throw new Error("array expected");
  r.forEach((t, n) => {
    if (!(t instanceof e))
      throw new Error("invalid point at index " + n);
  });
}
function y4(r, e) {
  if (!Array.isArray(r))
    throw new Error("array of scalars expected");
  r.forEach((t, n) => {
    if (!e.isValid(t))
      throw new Error("invalid scalar at index " + n);
  });
}
const Du = /* @__PURE__ */ new WeakMap(), w3 = /* @__PURE__ */ new WeakMap();
function Mu(r) {
  return w3.get(r) || 1;
}
function v3(r, e) {
  return {
    constTimeNegate: Au,
    hasPrecomputes(t) {
      return Mu(t) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(t, n, a = r.ZERO) {
      let o = t;
      for (; n > xh; )
        n & bc && (a = a.add(o)), o = o.double(), n >>= bc;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(t, n) {
      const { windows: a, windowSize: o } = Cu(n, e), i = [];
      let s = t, l = s;
      for (let c = 0; c < a; c++) {
        l = s, i.push(l);
        for (let u = 1; u < o; u++)
          l = l.add(s), i.push(l);
        s = l.double();
      }
      return i;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(t, n, a) {
      const { windows: o, windowSize: i } = Cu(t, e);
      let s = r.ZERO, l = r.BASE;
      const c = BigInt(2 ** t - 1), u = 2 ** t, d = BigInt(t);
      for (let w = 0; w < o; w++) {
        const f = w * i;
        let A = Number(a & c);
        a >>= d, A > i && (A -= u, a += bc);
        const b = f, g = f + Math.abs(A) - 1, k = w % 2 !== 0, v = A < 0;
        A === 0 ? l = l.add(Au(k, n[b])) : s = s.add(Au(v, n[g]));
      }
      return { p: s, f: l };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(t, n, a, o = r.ZERO) {
      const { windows: i, windowSize: s } = Cu(t, e), l = BigInt(2 ** t - 1), c = 2 ** t, u = BigInt(t);
      for (let d = 0; d < i; d++) {
        const w = d * s;
        if (a === xh)
          break;
        let f = Number(a & l);
        if (a >>= u, f > s && (f -= c, a += bc), f === 0)
          continue;
        let A = n[w + Math.abs(f) - 1];
        f < 0 && (A = A.negate()), o = o.add(A);
      }
      return o;
    },
    getPrecomputes(t, n, a) {
      let o = Du.get(n);
      return o || (o = this.precomputeWindow(n, t), t !== 1 && Du.set(n, a(o))), o;
    },
    wNAFCached(t, n, a) {
      const o = Mu(t);
      return this.wNAF(o, this.getPrecomputes(o, t, a), n);
    },
    wNAFCachedUnsafe(t, n, a, o) {
      const i = Mu(t);
      return i === 1 ? this.unsafeLadder(t, n, o) : this.wNAFUnsafe(i, this.getPrecomputes(i, t, a), n, o);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(t, n) {
      y3(n, e), w3.set(t, n), Du.delete(t);
    }
  };
}
function _3(r, e, t, n) {
  if (m4(t, r), y4(n, e), t.length !== n.length)
    throw new Error("arrays of points and scalars must have equal length");
  const a = r.ZERO, o = h3(BigInt(t.length)), i = o > 12 ? o - 3 : o > 4 ? o - 2 : o ? 2 : 1, s = (1 << i) - 1, l = new Array(s + 1).fill(a), c = Math.floor((e.BITS - 1) / i) * i;
  let u = a;
  for (let d = c; d >= 0; d -= i) {
    l.fill(a);
    for (let f = 0; f < n.length; f++) {
      const A = n[f], b = Number(A >> BigInt(d) & BigInt(s));
      l[b] = l[b].add(t[f]);
    }
    let w = a;
    for (let f = l.length - 1, A = a; f > 0; f--)
      A = A.add(l[f]), w = w.add(A);
    if (u = u.add(w), d !== 0)
      for (let f = 0; f < i; f++)
        u = u.double();
  }
  return u;
}
function od(r) {
  return h4(r.Fp), Li(r, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...p3(r.n, r.nBitLength),
    ...r,
    p: r.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const vn = BigInt(0), Hr = BigInt(1), Sc = BigInt(2), w4 = BigInt(8), v4 = { zip215: !0 };
function _4(r) {
  const e = od(r);
  return Li(r, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...e });
}
function b4(r) {
  const e = _4(r), { Fp: t, n, prehash: a, hash: o, randomBytes: i, nByteLength: s, h: l } = e, c = Sc << BigInt(s * 8) - Hr, u = t.create, d = au(e.n, e.nBitLength), w = e.uvRatio || ((N, O) => {
    try {
      return { isValid: !0, value: t.sqrt(N * t.inv(O)) };
    } catch {
      return { isValid: !1, value: vn };
    }
  }), f = e.adjustScalarBytes || ((N) => N), A = e.domain || ((N, O, G) => {
    if (ia("phflag", G), O.length || G)
      throw new Error("Contexts/pre-hash are not supported");
    return N;
  });
  function b(N, O) {
    dn("coordinate " + N, O, vn, c);
  }
  function g(N) {
    if (!(N instanceof C))
      throw new Error("ExtendedPoint expected");
  }
  const k = Is((N, O) => {
    const { ex: G, ey: Q, ez: ie } = N, fe = N.is0();
    O == null && (O = fe ? w4 : t.inv(ie));
    const pe = u(G * O), ye = u(Q * O), te = u(ie * O);
    if (fe)
      return { x: vn, y: Hr };
    if (te !== Hr)
      throw new Error("invZ was invalid");
    return { x: pe, y: ye };
  }), v = Is((N) => {
    const { a: O, d: G } = e;
    if (N.is0())
      throw new Error("bad point: ZERO");
    const { ex: Q, ey: ie, ez: fe, et: pe } = N, ye = u(Q * Q), te = u(ie * ie), B = u(fe * fe), oe = u(B * B), ce = u(ye * O), Ce = u(B * u(ce + te)), he = u(oe + u(G * u(ye * te)));
    if (Ce !== he)
      throw new Error("bad point: equation left != right (1)");
    const ge = u(Q * ie), h = u(fe * pe);
    if (ge !== h)
      throw new Error("bad point: equation left != right (2)");
    return !0;
  });
  class C {
    constructor(O, G, Q, ie) {
      this.ex = O, this.ey = G, this.ez = Q, this.et = ie, b("x", O), b("y", G), b("z", Q), b("t", ie), Object.freeze(this);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(O) {
      if (O instanceof C)
        throw new Error("extended point not allowed");
      const { x: G, y: Q } = O || {};
      return b("x", G), b("y", Q), new C(G, Q, Hr, u(G * Q));
    }
    static normalizeZ(O) {
      const G = t.invertBatch(O.map((Q) => Q.ez));
      return O.map((Q, ie) => Q.toAffine(G[ie])).map(C.fromAffine);
    }
    // Multiscalar Multiplication
    static msm(O, G) {
      return _3(C, d, O, G);
    }
    // "Private method", don't use it directly
    _setWindowSize(O) {
      D.setWindowSize(this, O);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      v(this);
    }
    // Compare one point to another.
    equals(O) {
      g(O);
      const { ex: G, ey: Q, ez: ie } = this, { ex: fe, ey: pe, ez: ye } = O, te = u(G * ye), B = u(fe * ie), oe = u(Q * ye), ce = u(pe * ie);
      return te === B && oe === ce;
    }
    is0() {
      return this.equals(C.ZERO);
    }
    negate() {
      return new C(u(-this.ex), this.ey, this.ez, u(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: O } = e, { ex: G, ey: Q, ez: ie } = this, fe = u(G * G), pe = u(Q * Q), ye = u(Sc * u(ie * ie)), te = u(O * fe), B = G + Q, oe = u(u(B * B) - fe - pe), ce = te + pe, Ce = ce - ye, he = te - pe, ge = u(oe * Ce), h = u(ce * he), m = u(oe * he), E = u(Ce * ce);
      return new C(ge, h, E, m);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(O) {
      g(O);
      const { a: G, d: Q } = e, { ex: ie, ey: fe, ez: pe, et: ye } = this, { ex: te, ey: B, ez: oe, et: ce } = O;
      if (G === BigInt(-1)) {
        const K = u((fe - ie) * (B + te)), z = u((fe + ie) * (B - te)), re = u(z - K);
        if (re === vn)
          return this.double();
        const le = u(pe * Sc * ce), ee = u(ye * Sc * oe), Se = ee + le, Re = z + K, Ne = ee - le, Ie = u(Se * re), De = u(Re * Ne), Fe = u(Se * Ne), lt = u(re * Re);
        return new C(Ie, De, lt, Fe);
      }
      const Ce = u(ie * te), he = u(fe * B), ge = u(ye * Q * ce), h = u(pe * oe), m = u((ie + fe) * (te + B) - Ce - he), E = h - ge, $ = h + ge, R = u(he - G * Ce), P = u(m * E), J = u($ * R), I = u(m * R), U = u(E * $);
      return new C(P, J, U, I);
    }
    subtract(O) {
      return this.add(O.negate());
    }
    wNAF(O) {
      return D.wNAFCached(this, O, C.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(O) {
      const G = O;
      dn("scalar", G, Hr, n);
      const { p: Q, f: ie } = this.wNAF(G);
      return C.normalizeZ([Q, ie])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    // Accepts optional accumulator to merge with multiply (important for sparse scalars)
    multiplyUnsafe(O, G = C.ZERO) {
      const Q = O;
      return dn("scalar", Q, vn, n), Q === vn ? Z : this.is0() || Q === Hr ? this : D.wNAFCachedUnsafe(this, Q, C.normalizeZ, G);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(l).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return D.unsafeLadder(this, n).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(O) {
      return k(this, O);
    }
    clearCofactor() {
      const { h: O } = e;
      return O === Hr ? this : this.multiplyUnsafe(O);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(O, G = !1) {
      const { d: Q, a: ie } = e, fe = t.BYTES;
      O = lr("pointHex", O, fe), ia("zip215", G);
      const pe = O.slice(), ye = O[fe - 1];
      pe[fe - 1] = ye & -129;
      const te = qo(pe), B = G ? c : t.ORDER;
      dn("pointHex.y", te, vn, B);
      const oe = u(te * te), ce = u(oe - Hr), Ce = u(Q * oe - ie);
      let { isValid: he, value: ge } = w(ce, Ce);
      if (!he)
        throw new Error("Point.fromHex: invalid y coordinate");
      const h = (ge & Hr) === Hr, m = (ye & 128) !== 0;
      if (!G && ge === vn && m)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return m !== h && (ge = u(-ge)), C.fromAffine({ x: ge, y: te });
    }
    static fromPrivateKey(O) {
      return S(O).point;
    }
    toRawBytes() {
      const { x: O, y: G } = this.toAffine(), Q = Rs(G, t.BYTES);
      return Q[Q.length - 1] |= O & Hr ? 128 : 0, Q;
    }
    toHex() {
      return ho(this.toRawBytes());
    }
  }
  C.BASE = new C(e.Gx, e.Gy, Hr, u(e.Gx * e.Gy)), C.ZERO = new C(vn, Hr, Hr, vn);
  const { BASE: W, ZERO: Z } = C, D = v3(C, s * 8);
  function H(N) {
    return Wt(N, n);
  }
  function y(N) {
    return H(qo(N));
  }
  function S(N) {
    const O = t.BYTES;
    N = lr("private key", N, O);
    const G = lr("hashed private key", o(N), 2 * O), Q = f(G.slice(0, O)), ie = G.slice(O, 2 * O), fe = y(Q), pe = W.multiply(fe), ye = pe.toRawBytes();
    return { head: Q, prefix: ie, scalar: fe, point: pe, pointBytes: ye };
  }
  function _(N) {
    return S(N).pointBytes;
  }
  function F(N = new Uint8Array(), ...O) {
    const G = po(...O);
    return y(o(A(G, lr("context", N), !!a)));
  }
  function M(N, O, G = {}) {
    N = lr("message", N), a && (N = a(N));
    const { prefix: Q, scalar: ie, pointBytes: fe } = S(O), pe = F(G.context, Q, N), ye = W.multiply(pe).toRawBytes(), te = F(G.context, ye, fe, N), B = H(pe + te * ie);
    dn("signature.s", B, vn, n);
    const oe = po(ye, Rs(B, t.BYTES));
    return lr("result", oe, t.BYTES * 2);
  }
  const j = v4;
  function Y(N, O, G, Q = j) {
    const { context: ie, zip215: fe } = Q, pe = t.BYTES;
    N = lr("signature", N, 2 * pe), O = lr("message", O), G = lr("publicKey", G, pe), fe !== void 0 && ia("zip215", fe), a && (O = a(O));
    const ye = qo(N.slice(pe, 2 * pe));
    let te, B, oe;
    try {
      te = C.fromHex(G, fe), B = C.fromHex(N.slice(0, pe), fe), oe = W.multiplyUnsafe(ye);
    } catch {
      return !1;
    }
    if (!fe && te.isSmallOrder())
      return !1;
    const ce = F(ie, B.toRawBytes(), te.toRawBytes(), O);
    return B.add(te.multiplyUnsafe(ce)).subtract(oe).clearCofactor().equals(C.ZERO);
  }
  return W._setWindowSize(8), {
    CURVE: e,
    getPublicKey: _,
    sign: M,
    verify: Y,
    ExtendedPoint: C,
    utils: {
      getExtendedPublicKey: S,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => i(t.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(N = 8, O = C.BASE) {
        return O._setWindowSize(N), O.multiply(BigInt(3)), O;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const id = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), kh = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const S4 = BigInt(1), Ah = BigInt(2);
BigInt(3);
const E4 = BigInt(5), x4 = BigInt(8);
function k4(r) {
  const e = BigInt(10), t = BigInt(20), n = BigInt(40), a = BigInt(80), o = id, i = r * r % o * r % o, s = nr(i, Ah, o) * i % o, l = nr(s, S4, o) * r % o, c = nr(l, E4, o) * l % o, u = nr(c, e, o) * c % o, d = nr(u, t, o) * u % o, w = nr(d, n, o) * d % o, f = nr(w, a, o) * w % o, A = nr(f, a, o) * w % o, b = nr(A, e, o) * c % o;
  return { pow_p_5_8: nr(b, Ah, o) * r % o, b2: i };
}
function A4(r) {
  return r[0] &= 248, r[31] &= 127, r[31] |= 64, r;
}
function C4(r, e) {
  const t = id, n = Wt(e * e * e, t), a = Wt(n * n * e, t), o = k4(r * a).pow_p_5_8;
  let i = Wt(r * n * o, t);
  const s = Wt(e * i * i, t), l = i, c = Wt(i * kh, t), u = s === r, d = s === Wt(-r, t), w = s === Wt(-r * kh, t);
  return u && (i = l), (d || w) && (i = c), u4(i, t) && (i = Wt(-i, t)), { isValid: u || d, value: i };
}
const D4 = au(id, void 0, !0), M4 = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: D4,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: x4,
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: Ms,
  randomBytes: Pa,
  adjustScalarBytes: A4,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: C4
}, sd = b4(M4);
function ml(r) {
  let e, t, n = vm, a;
  return r.length <= 0 ? {
    entropy: 0,
    score: -1
  } : (/[\u0600-\u06FF]/.test(r) && (n += wm), /[\u0400-\u04FF]/.test(r) && (n += _m), new RegExp("\\p{Emoji}", "u").test(r) && (n += bm), /[\u0370-\u03FF]/.test(r) && (n += Sm), /[\xA0-\xFF]/.test(r) && (n += Em), a = new Intl.Segmenter("en", { granularity: "grapheme" }), t = Array.from(a.segment(r)), e = t.length * Math.log2(n), e > 256 ? {
    entropy: e,
    score: 2
  } : e >= 128 && e < 256 ? {
    entropy: e,
    score: 1
  } : {
    entropy: e,
    score: 0
  });
}
function Ch(r) {
  try {
    return sd.getPublicKey(r);
  } catch (e) {
    throw new D6(e.message);
  }
}
const R4 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), ha = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), fa = /* @__PURE__ */ new Uint32Array(64);
class I4 extends o3 {
  constructor() {
    super(64, 32, 8, !1), this.A = ha[0] | 0, this.B = ha[1] | 0, this.C = ha[2] | 0, this.D = ha[3] | 0, this.E = ha[4] | 0, this.F = ha[5] | 0, this.G = ha[6] | 0, this.H = ha[7] | 0;
  }
  get() {
    const { A: e, B: t, C: n, D: a, E: o, F: i, G: s, H: l } = this;
    return [e, t, n, a, o, i, s, l];
  }
  // prettier-ignore
  set(e, t, n, a, o, i, s, l) {
    this.A = e | 0, this.B = t | 0, this.C = n | 0, this.D = a | 0, this.E = o | 0, this.F = i | 0, this.G = s | 0, this.H = l | 0;
  }
  process(e, t) {
    for (let d = 0; d < 16; d++, t += 4)
      fa[d] = e.getUint32(t, !1);
    for (let d = 16; d < 64; d++) {
      const w = fa[d - 15], f = fa[d - 2], A = Nn(w, 7) ^ Nn(w, 18) ^ w >>> 3, b = Nn(f, 17) ^ Nn(f, 19) ^ f >>> 10;
      fa[d] = b + fa[d - 7] + A + fa[d - 16] | 0;
    }
    let { A: n, B: a, C: o, D: i, E: s, F: l, G: c, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const w = Nn(s, 6) ^ Nn(s, 11) ^ Nn(s, 25), f = u + w + Xm(s, l, c) + R4[d] + fa[d] | 0, A = (Nn(n, 2) ^ Nn(n, 13) ^ Nn(n, 22)) + Zm(n, a, o) | 0;
      u = c, c = l, l = s, s = i + f | 0, i = o, o = a, a = n, n = f + A | 0;
    }
    n = n + this.A | 0, a = a + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, s = s + this.E | 0, l = l + this.F | 0, c = c + this.G | 0, u = u + this.H | 0, this.set(n, a, o, i, s, l, c, u);
  }
  roundClean() {
    fa.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const T4 = /* @__PURE__ */ td(() => new I4());
class b3 extends a3 {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, Wm(e);
    const n = ed(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const a = this.blockLen, o = new Uint8Array(a);
    o.set(n.length > a ? e.create().update(n).digest() : n);
    for (let i = 0; i < o.length; i++)
      o[i] ^= 54;
    this.iHash.update(o), this.oHash = e.create();
    for (let i = 0; i < o.length; i++)
      o[i] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(e) {
    return pl(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    pl(this), eu(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: n, finished: a, destroyed: o, blockLen: i, outputLen: s } = this;
    return e = e, e.finished = a, e.destroyed = o, e.blockLen = i, e.outputLen = s, e.oHash = t._cloneInto(e.oHash), e.iHash = n._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const S3 = (r, e, t) => new b3(r, e).update(t).digest();
S3.create = (r, e) => new b3(r, e);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Dh(r) {
  r.lowS !== void 0 && ia("lowS", r.lowS), r.prehash !== void 0 && ia("prehash", r.prehash);
}
function O4(r) {
  const e = od(r);
  Li(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: t, Fp: n, a } = e;
  if (t) {
    if (!n.eql(a, n.ZERO))
      throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
    if (typeof t != "object" || typeof t.beta != "bigint" || typeof t.splitScalar != "function")
      throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: P4, hexToBytes: N4 } = o4;
class B4 extends Error {
  constructor(e = "") {
    super(e);
  }
}
const ea = {
  // asn.1 DER encoding utils
  Err: B4,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (r, e) => {
      const { Err: t } = ea;
      if (r < 0 || r > 256)
        throw new t("tlv.encode: wrong tag");
      if (e.length & 1)
        throw new t("tlv.encode: unpadded data");
      const n = e.length / 2, a = Ho(n);
      if (a.length / 2 & 128)
        throw new t("tlv.encode: long form length too big");
      const o = n > 127 ? Ho(a.length / 2 | 128) : "";
      return Ho(r) + o + a + e;
    },
    // v - value, l - left bytes (unparsed)
    decode(r, e) {
      const { Err: t } = ea;
      let n = 0;
      if (r < 0 || r > 256)
        throw new t("tlv.encode: wrong tag");
      if (e.length < 2 || e[n++] !== r)
        throw new t("tlv.decode: wrong tlv");
      const a = e[n++], o = !!(a & 128);
      let i = 0;
      if (!o)
        i = a;
      else {
        const l = a & 127;
        if (!l)
          throw new t("tlv.decode(long): indefinite length not supported");
        if (l > 4)
          throw new t("tlv.decode(long): byte length is too big");
        const c = e.subarray(n, n + l);
        if (c.length !== l)
          throw new t("tlv.decode: length bytes not complete");
        if (c[0] === 0)
          throw new t("tlv.decode(long): zero leftmost byte");
        for (const u of c)
          i = i << 8 | u;
        if (n += l, i < 128)
          throw new t("tlv.decode(long): not minimal encoding");
      }
      const s = e.subarray(n, n + i);
      if (s.length !== i)
        throw new t("tlv.decode: wrong value length");
      return { v: s, l: e.subarray(n + i) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(r) {
      const { Err: e } = ea;
      if (r < na)
        throw new e("integer: negative integers are not allowed");
      let t = Ho(r);
      if (Number.parseInt(t[0], 16) & 8 && (t = "00" + t), t.length & 1)
        throw new e("unexpected DER parsing assertion: unpadded hex");
      return t;
    },
    decode(r) {
      const { Err: e } = ea;
      if (r[0] & 128)
        throw new e("invalid signature integer: negative");
      if (r[0] === 0 && !(r[1] & 128))
        throw new e("invalid signature integer: unnecessary leading zero");
      return P4(r);
    }
  },
  toSig(r) {
    const { Err: e, _int: t, _tlv: n } = ea, a = typeof r == "string" ? N4(r) : r;
    uc(a);
    const { v: o, l: i } = n.decode(48, a);
    if (i.length)
      throw new e("invalid signature: left bytes after parsing");
    const { v: s, l } = n.decode(2, o), { v: c, l: u } = n.decode(2, l);
    if (u.length)
      throw new e("invalid signature: left bytes after parsing");
    return { r: t.decode(s), s: t.decode(c) };
  },
  hexFromSig(r) {
    const { _tlv: e, _int: t } = ea, n = e.encode(2, t.encode(r.r)), a = e.encode(2, t.encode(r.s)), o = n + a;
    return e.encode(48, o);
  }
}, na = BigInt(0), Sr = BigInt(1);
BigInt(2);
const Mh = BigInt(3);
BigInt(4);
function L4(r) {
  const e = O4(r), { Fp: t } = e, n = au(e.n, e.nBitLength), a = e.toBytes || ((b, g, k) => {
    const v = g.toAffine();
    return po(Uint8Array.from([4]), t.toBytes(v.x), t.toBytes(v.y));
  }), o = e.fromBytes || ((b) => {
    const g = b.subarray(1), k = t.fromBytes(g.subarray(0, t.BYTES)), v = t.fromBytes(g.subarray(t.BYTES, 2 * t.BYTES));
    return { x: k, y: v };
  });
  function i(b) {
    const { a: g, b: k } = e, v = t.sqr(b), C = t.mul(v, b);
    return t.add(t.add(C, t.mul(b, g)), k);
  }
  if (!t.eql(t.sqr(e.Gy), i(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function s(b) {
    return nu(b, Sr, e.n);
  }
  function l(b) {
    const { allowedPrivateKeyLengths: g, nByteLength: k, wrapPrivateKey: v, n: C } = e;
    if (g && typeof b != "bigint") {
      if (uo(b) && (b = ho(b)), typeof b != "string" || !g.includes(b.length))
        throw new Error("invalid private key");
      b = b.padStart(k * 2, "0");
    }
    let W;
    try {
      W = typeof b == "bigint" ? b : La(lr("private key", b, k));
    } catch {
      throw new Error("invalid private key, expected hex or " + k + " bytes, got " + typeof b);
    }
    return v && (W = Wt(W, C)), dn("private key", W, Sr, C), W;
  }
  function c(b) {
    if (!(b instanceof w))
      throw new Error("ProjectivePoint expected");
  }
  const u = Is((b, g) => {
    const { px: k, py: v, pz: C } = b;
    if (t.eql(C, t.ONE))
      return { x: k, y: v };
    const W = b.is0();
    g == null && (g = W ? t.ONE : t.inv(C));
    const Z = t.mul(k, g), D = t.mul(v, g), H = t.mul(C, g);
    if (W)
      return { x: t.ZERO, y: t.ZERO };
    if (!t.eql(H, t.ONE))
      throw new Error("invZ was invalid");
    return { x: Z, y: D };
  }), d = Is((b) => {
    if (b.is0()) {
      if (e.allowInfinityPoint && !t.is0(b.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: g, y: k } = b.toAffine();
    if (!t.isValid(g) || !t.isValid(k))
      throw new Error("bad point: x or y not FE");
    const v = t.sqr(k), C = i(g);
    if (!t.eql(v, C))
      throw new Error("bad point: equation left != right");
    if (!b.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  class w {
    constructor(g, k, v) {
      if (this.px = g, this.py = k, this.pz = v, g == null || !t.isValid(g))
        throw new Error("x required");
      if (k == null || !t.isValid(k))
        throw new Error("y required");
      if (v == null || !t.isValid(v))
        throw new Error("z required");
      Object.freeze(this);
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(g) {
      const { x: k, y: v } = g || {};
      if (!g || !t.isValid(k) || !t.isValid(v))
        throw new Error("invalid affine point");
      if (g instanceof w)
        throw new Error("projective point not allowed");
      const C = (W) => t.eql(W, t.ZERO);
      return C(k) && C(v) ? w.ZERO : new w(k, v, t.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(g) {
      const k = t.invertBatch(g.map((v) => v.pz));
      return g.map((v, C) => v.toAffine(k[C])).map(w.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(g) {
      const k = w.fromAffine(o(lr("pointHex", g)));
      return k.assertValidity(), k;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(g) {
      return w.BASE.multiply(l(g));
    }
    // Multiscalar Multiplication
    static msm(g, k) {
      return _3(w, n, g, k);
    }
    // "Private method", don't use it directly
    _setWindowSize(g) {
      A.setWindowSize(this, g);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      d(this);
    }
    hasEvenY() {
      const { y: g } = this.toAffine();
      if (t.isOdd)
        return !t.isOdd(g);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(g) {
      c(g);
      const { px: k, py: v, pz: C } = this, { px: W, py: Z, pz: D } = g, H = t.eql(t.mul(k, D), t.mul(W, C)), y = t.eql(t.mul(v, D), t.mul(Z, C));
      return H && y;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new w(this.px, t.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: g, b: k } = e, v = t.mul(k, Mh), { px: C, py: W, pz: Z } = this;
      let D = t.ZERO, H = t.ZERO, y = t.ZERO, S = t.mul(C, C), _ = t.mul(W, W), F = t.mul(Z, Z), M = t.mul(C, W);
      return M = t.add(M, M), y = t.mul(C, Z), y = t.add(y, y), D = t.mul(g, y), H = t.mul(v, F), H = t.add(D, H), D = t.sub(_, H), H = t.add(_, H), H = t.mul(D, H), D = t.mul(M, D), y = t.mul(v, y), F = t.mul(g, F), M = t.sub(S, F), M = t.mul(g, M), M = t.add(M, y), y = t.add(S, S), S = t.add(y, S), S = t.add(S, F), S = t.mul(S, M), H = t.add(H, S), F = t.mul(W, Z), F = t.add(F, F), S = t.mul(F, M), D = t.sub(D, S), y = t.mul(F, _), y = t.add(y, y), y = t.add(y, y), new w(D, H, y);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(g) {
      c(g);
      const { px: k, py: v, pz: C } = this, { px: W, py: Z, pz: D } = g;
      let H = t.ZERO, y = t.ZERO, S = t.ZERO;
      const _ = e.a, F = t.mul(e.b, Mh);
      let M = t.mul(k, W), j = t.mul(v, Z), Y = t.mul(C, D), N = t.add(k, v), O = t.add(W, Z);
      N = t.mul(N, O), O = t.add(M, j), N = t.sub(N, O), O = t.add(k, C);
      let G = t.add(W, D);
      return O = t.mul(O, G), G = t.add(M, Y), O = t.sub(O, G), G = t.add(v, C), H = t.add(Z, D), G = t.mul(G, H), H = t.add(j, Y), G = t.sub(G, H), S = t.mul(_, O), H = t.mul(F, Y), S = t.add(H, S), H = t.sub(j, S), S = t.add(j, S), y = t.mul(H, S), j = t.add(M, M), j = t.add(j, M), Y = t.mul(_, Y), O = t.mul(F, O), j = t.add(j, Y), Y = t.sub(M, Y), Y = t.mul(_, Y), O = t.add(O, Y), M = t.mul(j, O), y = t.add(y, M), M = t.mul(G, O), H = t.mul(N, H), H = t.sub(H, M), M = t.mul(N, j), S = t.mul(G, S), S = t.add(S, M), new w(H, y, S);
    }
    subtract(g) {
      return this.add(g.negate());
    }
    is0() {
      return this.equals(w.ZERO);
    }
    wNAF(g) {
      return A.wNAFCached(this, g, w.normalizeZ);
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(g) {
      const { endo: k, n: v } = e;
      dn("scalar", g, na, v);
      const C = w.ZERO;
      if (g === na)
        return C;
      if (this.is0() || g === Sr)
        return this;
      if (!k || A.hasPrecomputes(this))
        return A.wNAFCachedUnsafe(this, g, w.normalizeZ);
      let { k1neg: W, k1: Z, k2neg: D, k2: H } = k.splitScalar(g), y = C, S = C, _ = this;
      for (; Z > na || H > na; )
        Z & Sr && (y = y.add(_)), H & Sr && (S = S.add(_)), _ = _.double(), Z >>= Sr, H >>= Sr;
      return W && (y = y.negate()), D && (S = S.negate()), S = new w(t.mul(S.px, k.beta), S.py, S.pz), y.add(S);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(g) {
      const { endo: k, n: v } = e;
      dn("scalar", g, Sr, v);
      let C, W;
      if (k) {
        const { k1neg: Z, k1: D, k2neg: H, k2: y } = k.splitScalar(g);
        let { p: S, f: _ } = this.wNAF(D), { p: F, f: M } = this.wNAF(y);
        S = A.constTimeNegate(Z, S), F = A.constTimeNegate(H, F), F = new w(t.mul(F.px, k.beta), F.py, F.pz), C = S.add(F), W = _.add(M);
      } else {
        const { p: Z, f: D } = this.wNAF(g);
        C = Z, W = D;
      }
      return w.normalizeZ([C, W])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(g, k, v) {
      const C = w.BASE, W = (D, H) => H === na || H === Sr || !D.equals(C) ? D.multiplyUnsafe(H) : D.multiply(H), Z = W(this, k).add(W(g, v));
      return Z.is0() ? void 0 : Z;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(g) {
      return u(this, g);
    }
    isTorsionFree() {
      const { h: g, isTorsionFree: k } = e;
      if (g === Sr)
        return !0;
      if (k)
        return k(w, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: g, clearCofactor: k } = e;
      return g === Sr ? this : k ? k(w, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(g = !0) {
      return ia("isCompressed", g), this.assertValidity(), a(w, this, g);
    }
    toHex(g = !0) {
      return ia("isCompressed", g), ho(this.toRawBytes(g));
    }
  }
  w.BASE = new w(e.Gx, e.Gy, t.ONE), w.ZERO = new w(t.ZERO, t.ONE, t.ZERO);
  const f = e.nBitLength, A = v3(w, e.endo ? Math.ceil(f / 2) : f);
  return {
    CURVE: e,
    ProjectivePoint: w,
    normPrivateKeyToScalar: l,
    weierstrassEquation: i,
    isWithinCurveOrder: s
  };
}
function U4(r) {
  const e = od(r);
  return Li(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function V4(r) {
  const e = U4(r), { Fp: t, n } = e, a = t.BYTES + 1, o = 2 * t.BYTES + 1;
  function i(Y) {
    return Wt(Y, n);
  }
  function s(Y) {
    return f1(Y, n);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: c, weierstrassEquation: u, isWithinCurveOrder: d } = L4({
    ...e,
    toBytes(Y, N, O) {
      const G = N.toAffine(), Q = t.toBytes(G.x), ie = po;
      return ia("isCompressed", O), O ? ie(Uint8Array.from([N.hasEvenY() ? 2 : 3]), Q) : ie(Uint8Array.from([4]), Q, t.toBytes(G.y));
    },
    fromBytes(Y) {
      const N = Y.length, O = Y[0], G = Y.subarray(1);
      if (N === a && (O === 2 || O === 3)) {
        const Q = La(G);
        if (!nu(Q, Sr, t.ORDER))
          throw new Error("Point is not on curve");
        const ie = u(Q);
        let fe;
        try {
          fe = t.sqrt(ie);
        } catch (ye) {
          const te = ye instanceof Error ? ": " + ye.message : "";
          throw new Error("Point is not on curve" + te);
        }
        const pe = (fe & Sr) === Sr;
        return (O & 1) === 1 !== pe && (fe = t.neg(fe)), { x: Q, y: fe };
      } else if (N === o && O === 4) {
        const Q = t.fromBytes(G.subarray(0, t.BYTES)), ie = t.fromBytes(G.subarray(t.BYTES, 2 * t.BYTES));
        return { x: Q, y: ie };
      } else {
        const Q = a, ie = o;
        throw new Error("invalid Point, expected length of " + Q + ", or uncompressed " + ie + ", got " + N);
      }
    }
  }), w = (Y) => ho(fo(Y, e.nByteLength));
  function f(Y) {
    const N = n >> Sr;
    return Y > N;
  }
  function A(Y) {
    return f(Y) ? i(-Y) : Y;
  }
  const b = (Y, N, O) => La(Y.slice(N, O));
  class g {
    constructor(N, O, G) {
      this.r = N, this.s = O, this.recovery = G, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(N) {
      const O = e.nByteLength;
      return N = lr("compactSignature", N, O * 2), new g(b(N, 0, O), b(N, O, 2 * O));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(N) {
      const { r: O, s: G } = ea.toSig(lr("DER", N));
      return new g(O, G);
    }
    assertValidity() {
      dn("r", this.r, Sr, n), dn("s", this.s, Sr, n);
    }
    addRecoveryBit(N) {
      return new g(this.r, this.s, N);
    }
    recoverPublicKey(N) {
      const { r: O, s: G, recovery: Q } = this, ie = D(lr("msgHash", N));
      if (Q == null || ![0, 1, 2, 3].includes(Q))
        throw new Error("recovery id invalid");
      const fe = Q === 2 || Q === 3 ? O + e.n : O;
      if (fe >= t.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const pe = (Q & 1) === 0 ? "02" : "03", ye = l.fromHex(pe + w(fe)), te = s(fe), B = i(-ie * te), oe = i(G * te), ce = l.BASE.multiplyAndAddUnsafe(ye, B, oe);
      if (!ce)
        throw new Error("point at infinify");
      return ce.assertValidity(), ce;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return f(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new g(this.r, i(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return Jo(this.toDERHex());
    }
    toDERHex() {
      return ea.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return Jo(this.toCompactHex());
    }
    toCompactHex() {
      return w(this.r) + w(this.s);
    }
  }
  const k = {
    isValidPrivateKey(Y) {
      try {
        return c(Y), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: c,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const Y = m3(e.n);
      return g4(e.randomBytes(Y), e.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(Y = 8, N = l.BASE) {
      return N._setWindowSize(Y), N.multiply(BigInt(3)), N;
    }
  };
  function v(Y, N = !0) {
    return l.fromPrivateKey(Y).toRawBytes(N);
  }
  function C(Y) {
    const N = uo(Y), O = typeof Y == "string", G = (N || O) && Y.length;
    return N ? G === a || G === o : O ? G === 2 * a || G === 2 * o : Y instanceof l;
  }
  function W(Y, N, O = !0) {
    if (C(Y))
      throw new Error("first arg must be private key");
    if (!C(N))
      throw new Error("second arg must be public key");
    return l.fromHex(N).multiply(c(Y)).toRawBytes(O);
  }
  const Z = e.bits2int || function(Y) {
    if (Y.length > 8192)
      throw new Error("input is too large");
    const N = La(Y), O = Y.length * 8 - e.nBitLength;
    return O > 0 ? N >> BigInt(O) : N;
  }, D = e.bits2int_modN || function(Y) {
    return i(Z(Y));
  }, H = ad(e.nBitLength);
  function y(Y) {
    return dn("num < 2^" + e.nBitLength, Y, na, H), fo(Y, e.nByteLength);
  }
  function S(Y, N, O = _) {
    if (["recovered", "canonical"].some((he) => he in O))
      throw new Error("sign() legacy options not supported");
    const { hash: G, randomBytes: Q } = e;
    let { lowS: ie, prehash: fe, extraEntropy: pe } = O;
    ie == null && (ie = !0), Y = lr("msgHash", Y), Dh(O), fe && (Y = lr("prehashed msgHash", G(Y)));
    const ye = D(Y), te = c(N), B = [y(te), y(ye)];
    if (pe != null && pe !== !1) {
      const he = pe === !0 ? Q(t.BYTES) : pe;
      B.push(lr("extraEntropy", he));
    }
    const oe = po(...B), ce = ye;
    function Ce(he) {
      const ge = Z(he);
      if (!d(ge))
        return;
      const h = s(ge), m = l.BASE.multiply(ge).toAffine(), E = i(m.x);
      if (E === na)
        return;
      const $ = i(h * i(ce + E * te));
      if ($ === na)
        return;
      let R = (m.x === E ? 0 : 2) | Number(m.y & Sr), P = $;
      return ie && f($) && (P = A($), R ^= 1), new g(E, P, R);
    }
    return { seed: oe, k2sig: Ce };
  }
  const _ = { lowS: e.lowS, prehash: !1 }, F = { lowS: e.lowS, prehash: !1 };
  function M(Y, N, O = _) {
    const { seed: G, k2sig: Q } = S(Y, N, O), ie = e;
    return f3(ie.hash.outputLen, ie.nByteLength, ie.hmac)(G, Q);
  }
  l.BASE._setWindowSize(8);
  function j(Y, N, O, G = F) {
    var Q;
    const ie = Y;
    N = lr("msgHash", N), O = lr("publicKey", O);
    const { lowS: fe, prehash: pe, format: ye } = G;
    if (Dh(G), "strict" in G)
      throw new Error("options.strict was renamed to lowS");
    if (ye !== void 0 && ye !== "compact" && ye !== "der")
      throw new Error("format must be compact or der");
    const te = typeof ie == "string" || uo(ie), B = !te && !ye && typeof ie == "object" && ie !== null && typeof ie.r == "bigint" && typeof ie.s == "bigint";
    if (!te && !B)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let oe, ce;
    try {
      if (B && (oe = new g(ie.r, ie.s)), te) {
        try {
          ye !== "compact" && (oe = g.fromDER(ie));
        } catch (R) {
          if (!(R instanceof ea.Err))
            throw R;
        }
        !oe && ye !== "der" && (oe = g.fromCompact(ie));
      }
      ce = l.fromHex(O);
    } catch {
      return !1;
    }
    if (!oe || fe && oe.hasHighS())
      return !1;
    pe && (N = e.hash(N));
    const { r: Ce, s: he } = oe, ge = D(N), h = s(he), m = i(ge * h), E = i(Ce * h), $ = (Q = l.BASE.multiplyAndAddUnsafe(ce, m, E)) == null ? void 0 : Q.toAffine();
    return $ ? i($.x) === Ce : !1;
  }
  return {
    CURVE: e,
    getPublicKey: v,
    getSharedSecret: W,
    sign: M,
    verify: j,
    ProjectivePoint: l,
    Signature: g,
    utils: k
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function $4(r) {
  return {
    hash: r,
    hmac: (e, ...t) => S3(r, e, Gm(...t)),
    randomBytes: Pa
  };
}
function j4(r, e) {
  const t = (n) => V4({ ...r, ...$4(n) });
  return { ...t(e), create: t };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const E3 = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Rh = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), F4 = BigInt(1), p1 = BigInt(2), Ih = (r, e) => (r + e / p1) / e;
function z4(r) {
  const e = E3, t = BigInt(3), n = BigInt(6), a = BigInt(11), o = BigInt(22), i = BigInt(23), s = BigInt(44), l = BigInt(88), c = r * r * r % e, u = c * c * r % e, d = nr(u, t, e) * u % e, w = nr(d, t, e) * u % e, f = nr(w, p1, e) * c % e, A = nr(f, a, e) * f % e, b = nr(A, o, e) * A % e, g = nr(b, s, e) * b % e, k = nr(g, l, e) * g % e, v = nr(k, s, e) * b % e, C = nr(v, t, e) * u % e, W = nr(C, i, e) * A % e, Z = nr(W, n, e) * c % e, D = nr(Z, p1, e);
  if (!g1.eql(g1.sqr(D), r))
    throw new Error("Cannot find square root");
  return D;
}
const g1 = au(E3, void 0, void 0, { sqrt: z4 }), Th = j4({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  Fp: g1,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: Rh,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  endo: {
    // Endomorphism, see above
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (r) => {
      const e = Rh, t = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -F4 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), a = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), o = t, i = BigInt("0x100000000000000000000000000000000"), s = Ih(o * r, e), l = Ih(-n * r, e);
      let c = Wt(r - s * t - l * a, e), u = Wt(-s * n - l * o, e);
      const d = c > i, w = u > i;
      if (d && (c = e - c), w && (u = e - u), c > i || u > i)
        throw new Error("splitScalar: Endomorphism failed, k=" + r);
      return { k1neg: d, k1: c, k2neg: w, k2: u };
    }
  }
}, T4);
BigInt(0);
function x3(r) {
  let e;
  return Th.utils.isValidPrivateKey(r) ? r : (e = La(r), e = e % (Th.CURVE.n - 1n) + 1n, fo(e, Q2));
}
var H4 = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Ru = Math.ceil, on = Math.floor, qr = "[BigNumber Error] ", Oh = qr + "Number primitive has more than 15 significant digits: ", _n = 1e14, pt = 14, Ph = 9007199254740991, Iu = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], pa = 1e7, Zr = 1e9;
function k3(r) {
  var e, t, n, a = v.prototype = { constructor: v, toString: null, valueOf: null }, o = new v(1), i = 20, s = 4, l = -7, c = 21, u = -1e7, d = 1e7, w = !1, f = 1, A = 0, b = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, g = "0123456789abcdefghijklmnopqrstuvwxyz", k = !0;
  function v(y, S) {
    var _, F, M, j, Y, N, O, G, Q = this;
    if (!(Q instanceof v)) return new v(y, S);
    if (S == null) {
      if (y && y._isBigNumber === !0) {
        Q.s = y.s, !y.c || y.e > d ? Q.c = Q.e = null : y.e < u ? Q.c = [Q.e = 0] : (Q.e = y.e, Q.c = y.c.slice());
        return;
      }
      if ((N = typeof y == "number") && y * 0 == 0) {
        if (Q.s = 1 / y < 0 ? (y = -y, -1) : 1, y === ~~y) {
          for (j = 0, Y = y; Y >= 10; Y /= 10, j++) ;
          j > d ? Q.c = Q.e = null : (Q.e = j, Q.c = [y]);
          return;
        }
        G = String(y);
      } else {
        if (!H4.test(G = String(y))) return n(Q, G, N);
        Q.s = G.charCodeAt(0) == 45 ? (G = G.slice(1), -1) : 1;
      }
      (j = G.indexOf(".")) > -1 && (G = G.replace(".", "")), (Y = G.search(/e/i)) > 0 ? (j < 0 && (j = Y), j += +G.slice(Y + 1), G = G.substring(0, Y)) : j < 0 && (j = G.length);
    } else {
      if (Yt(S, 2, g.length, "Base"), S == 10 && k)
        return Q = new v(y), D(Q, i + Q.e + 1, s);
      if (G = String(y), N = typeof y == "number") {
        if (y * 0 != 0) return n(Q, G, N, S);
        if (Q.s = 1 / y < 0 ? (G = G.slice(1), -1) : 1, v.DEBUG && G.replace(/^0\.0*|\./, "").length > 15)
          throw Error(Oh + y);
      } else
        Q.s = G.charCodeAt(0) === 45 ? (G = G.slice(1), -1) : 1;
      for (_ = g.slice(0, S), j = Y = 0, O = G.length; Y < O; Y++)
        if (_.indexOf(F = G.charAt(Y)) < 0) {
          if (F == ".") {
            if (Y > j) {
              j = O;
              continue;
            }
          } else if (!M && (G == G.toUpperCase() && (G = G.toLowerCase()) || G == G.toLowerCase() && (G = G.toUpperCase()))) {
            M = !0, Y = -1, j = 0;
            continue;
          }
          return n(Q, String(y), N, S);
        }
      N = !1, G = t(G, S, 10, Q.s), (j = G.indexOf(".")) > -1 ? G = G.replace(".", "") : j = G.length;
    }
    for (Y = 0; G.charCodeAt(Y) === 48; Y++) ;
    for (O = G.length; G.charCodeAt(--O) === 48; ) ;
    if (G = G.slice(Y, ++O)) {
      if (O -= Y, N && v.DEBUG && O > 15 && (y > Ph || y !== on(y)))
        throw Error(Oh + Q.s * y);
      if ((j = j - Y - 1) > d)
        Q.c = Q.e = null;
      else if (j < u)
        Q.c = [Q.e = 0];
      else {
        if (Q.e = j, Q.c = [], Y = (j + 1) % pt, j < 0 && (Y += pt), Y < O) {
          for (Y && Q.c.push(+G.slice(0, Y)), O -= pt; Y < O; )
            Q.c.push(+G.slice(Y, Y += pt));
          Y = pt - (G = G.slice(Y)).length;
        } else
          Y -= O;
        for (; Y--; G += "0") ;
        Q.c.push(+G);
      }
    } else
      Q.c = [Q.e = 0];
  }
  v.clone = k3, v.ROUND_UP = 0, v.ROUND_DOWN = 1, v.ROUND_CEIL = 2, v.ROUND_FLOOR = 3, v.ROUND_HALF_UP = 4, v.ROUND_HALF_DOWN = 5, v.ROUND_HALF_EVEN = 6, v.ROUND_HALF_CEIL = 7, v.ROUND_HALF_FLOOR = 8, v.EUCLID = 9, v.config = v.set = function(y) {
    var S, _;
    if (y != null)
      if (typeof y == "object") {
        if (y.hasOwnProperty(S = "DECIMAL_PLACES") && (_ = y[S], Yt(_, 0, Zr, S), i = _), y.hasOwnProperty(S = "ROUNDING_MODE") && (_ = y[S], Yt(_, 0, 8, S), s = _), y.hasOwnProperty(S = "EXPONENTIAL_AT") && (_ = y[S], _ && _.pop ? (Yt(_[0], -1e9, 0, S), Yt(_[1], 0, Zr, S), l = _[0], c = _[1]) : (Yt(_, -1e9, Zr, S), l = -(c = _ < 0 ? -_ : _))), y.hasOwnProperty(S = "RANGE"))
          if (_ = y[S], _ && _.pop)
            Yt(_[0], -1e9, -1, S), Yt(_[1], 1, Zr, S), u = _[0], d = _[1];
          else if (Yt(_, -1e9, Zr, S), _)
            u = -(d = _ < 0 ? -_ : _);
          else
            throw Error(qr + S + " cannot be zero: " + _);
        if (y.hasOwnProperty(S = "CRYPTO"))
          if (_ = y[S], _ === !!_)
            if (_)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                w = _;
              else
                throw w = !_, Error(qr + "crypto unavailable");
            else
              w = _;
          else
            throw Error(qr + S + " not true or false: " + _);
        if (y.hasOwnProperty(S = "MODULO_MODE") && (_ = y[S], Yt(_, 0, 9, S), f = _), y.hasOwnProperty(S = "POW_PRECISION") && (_ = y[S], Yt(_, 0, Zr, S), A = _), y.hasOwnProperty(S = "FORMAT"))
          if (_ = y[S], typeof _ == "object") b = _;
          else throw Error(qr + S + " not an object: " + _);
        if (y.hasOwnProperty(S = "ALPHABET"))
          if (_ = y[S], typeof _ == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(_))
            k = _.slice(0, 10) == "0123456789", g = _;
          else
            throw Error(qr + S + " invalid: " + _);
      } else
        throw Error(qr + "Object expected: " + y);
    return {
      DECIMAL_PLACES: i,
      ROUNDING_MODE: s,
      EXPONENTIAL_AT: [l, c],
      RANGE: [u, d],
      CRYPTO: w,
      MODULO_MODE: f,
      POW_PRECISION: A,
      FORMAT: b,
      ALPHABET: g
    };
  }, v.isBigNumber = function(y) {
    if (!y || y._isBigNumber !== !0) return !1;
    if (!v.DEBUG) return !0;
    var S, _, F = y.c, M = y.e, j = y.s;
    e: if ({}.toString.call(F) == "[object Array]") {
      if ((j === 1 || j === -1) && M >= -1e9 && M <= Zr && M === on(M)) {
        if (F[0] === 0) {
          if (M === 0 && F.length === 1) return !0;
          break e;
        }
        if (S = (M + 1) % pt, S < 1 && (S += pt), String(F[0]).length == S) {
          for (S = 0; S < F.length; S++)
            if (_ = F[S], _ < 0 || _ >= _n || _ !== on(_)) break e;
          if (_ !== 0) return !0;
        }
      }
    } else if (F === null && M === null && (j === null || j === 1 || j === -1))
      return !0;
    throw Error(qr + "Invalid BigNumber: " + y);
  }, v.maximum = v.max = function() {
    return W(arguments, -1);
  }, v.minimum = v.min = function() {
    return W(arguments, 1);
  }, v.random = function() {
    var y = 9007199254740992, S = Math.random() * y & 2097151 ? function() {
      return on(Math.random() * y);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(_) {
      var F, M, j, Y, N, O = 0, G = [], Q = new v(o);
      if (_ == null ? _ = i : Yt(_, 0, Zr), Y = Ru(_ / pt), w)
        if (crypto.getRandomValues) {
          for (F = crypto.getRandomValues(new Uint32Array(Y *= 2)); O < Y; )
            N = F[O] * 131072 + (F[O + 1] >>> 11), N >= 9e15 ? (M = crypto.getRandomValues(new Uint32Array(2)), F[O] = M[0], F[O + 1] = M[1]) : (G.push(N % 1e14), O += 2);
          O = Y / 2;
        } else if (crypto.randomBytes) {
          for (F = crypto.randomBytes(Y *= 7); O < Y; )
            N = (F[O] & 31) * 281474976710656 + F[O + 1] * 1099511627776 + F[O + 2] * 4294967296 + F[O + 3] * 16777216 + (F[O + 4] << 16) + (F[O + 5] << 8) + F[O + 6], N >= 9e15 ? crypto.randomBytes(7).copy(F, O) : (G.push(N % 1e14), O += 7);
          O = Y / 7;
        } else
          throw w = !1, Error(qr + "crypto unavailable");
      if (!w)
        for (; O < Y; )
          N = S(), N < 9e15 && (G[O++] = N % 1e14);
      for (Y = G[--O], _ %= pt, Y && _ && (N = Iu[pt - _], G[O] = on(Y / N) * N); G[O] === 0; G.pop(), O--) ;
      if (O < 0)
        G = [j = 0];
      else {
        for (j = -1; G[0] === 0; G.splice(0, 1), j -= pt) ;
        for (O = 1, N = G[0]; N >= 10; N /= 10, O++) ;
        O < pt && (j -= pt - O);
      }
      return Q.e = j, Q.c = G, Q;
    };
  }(), v.sum = function() {
    for (var y = 1, S = arguments, _ = new v(S[0]); y < S.length; ) _ = _.plus(S[y++]);
    return _;
  }, t = /* @__PURE__ */ function() {
    var y = "0123456789";
    function S(_, F, M, j) {
      for (var Y, N = [0], O, G = 0, Q = _.length; G < Q; ) {
        for (O = N.length; O--; N[O] *= F) ;
        for (N[0] += j.indexOf(_.charAt(G++)), Y = 0; Y < N.length; Y++)
          N[Y] > M - 1 && (N[Y + 1] == null && (N[Y + 1] = 0), N[Y + 1] += N[Y] / M | 0, N[Y] %= M);
      }
      return N.reverse();
    }
    return function(_, F, M, j, Y) {
      var N, O, G, Q, ie, fe, pe, ye, te = _.indexOf("."), B = i, oe = s;
      for (te >= 0 && (Q = A, A = 0, _ = _.replace(".", ""), ye = new v(F), fe = ye.pow(_.length - te), A = Q, ye.c = S(
        Yn(tn(fe.c), fe.e, "0"),
        10,
        M,
        y
      ), ye.e = ye.c.length), pe = S(_, F, M, Y ? (N = g, y) : (N = y, g)), G = Q = pe.length; pe[--Q] == 0; pe.pop()) ;
      if (!pe[0]) return N.charAt(0);
      if (te < 0 ? --G : (fe.c = pe, fe.e = G, fe.s = j, fe = e(fe, ye, B, oe, M), pe = fe.c, ie = fe.r, G = fe.e), O = G + B + 1, te = pe[O], Q = M / 2, ie = ie || O < 0 || pe[O + 1] != null, ie = oe < 4 ? (te != null || ie) && (oe == 0 || oe == (fe.s < 0 ? 3 : 2)) : te > Q || te == Q && (oe == 4 || ie || oe == 6 && pe[O - 1] & 1 || oe == (fe.s < 0 ? 8 : 7)), O < 1 || !pe[0])
        _ = ie ? Yn(N.charAt(1), -B, N.charAt(0)) : N.charAt(0);
      else {
        if (pe.length = O, ie)
          for (--M; ++pe[--O] > M; )
            pe[O] = 0, O || (++G, pe = [1].concat(pe));
        for (Q = pe.length; !pe[--Q]; ) ;
        for (te = 0, _ = ""; te <= Q; _ += N.charAt(pe[te++])) ;
        _ = Yn(_, G, N.charAt(0));
      }
      return _;
    };
  }(), e = /* @__PURE__ */ function() {
    function y(F, M, j) {
      var Y, N, O, G, Q = 0, ie = F.length, fe = M % pa, pe = M / pa | 0;
      for (F = F.slice(); ie--; )
        O = F[ie] % pa, G = F[ie] / pa | 0, Y = pe * O + G * fe, N = fe * O + Y % pa * pa + Q, Q = (N / j | 0) + (Y / pa | 0) + pe * G, F[ie] = N % j;
      return Q && (F = [Q].concat(F)), F;
    }
    function S(F, M, j, Y) {
      var N, O;
      if (j != Y)
        O = j > Y ? 1 : -1;
      else
        for (N = O = 0; N < j; N++)
          if (F[N] != M[N]) {
            O = F[N] > M[N] ? 1 : -1;
            break;
          }
      return O;
    }
    function _(F, M, j, Y) {
      for (var N = 0; j--; )
        F[j] -= N, N = F[j] < M[j] ? 1 : 0, F[j] = N * Y + F[j] - M[j];
      for (; !F[0] && F.length > 1; F.splice(0, 1)) ;
    }
    return function(F, M, j, Y, N) {
      var O, G, Q, ie, fe, pe, ye, te, B, oe, ce, Ce, he, ge, h, m, E, $ = F.s == M.s ? 1 : -1, R = F.c, P = M.c;
      if (!R || !R[0] || !P || !P[0])
        return new v(
          // Return NaN if either NaN, or both Infinity or 0.
          !F.s || !M.s || (R ? P && R[0] == P[0] : !P) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            R && R[0] == 0 || !P ? $ * 0 : $ / 0
          )
        );
      for (te = new v($), B = te.c = [], G = F.e - M.e, $ = j + G + 1, N || (N = _n, G = sn(F.e / pt) - sn(M.e / pt), $ = $ / pt | 0), Q = 0; P[Q] == (R[Q] || 0); Q++) ;
      if (P[Q] > (R[Q] || 0) && G--, $ < 0)
        B.push(1), ie = !0;
      else {
        for (ge = R.length, m = P.length, Q = 0, $ += 2, fe = on(N / (P[0] + 1)), fe > 1 && (P = y(P, fe, N), R = y(R, fe, N), m = P.length, ge = R.length), he = m, oe = R.slice(0, m), ce = oe.length; ce < m; oe[ce++] = 0) ;
        E = P.slice(), E = [0].concat(E), h = P[0], P[1] >= N / 2 && h++;
        do {
          if (fe = 0, O = S(P, oe, m, ce), O < 0) {
            if (Ce = oe[0], m != ce && (Ce = Ce * N + (oe[1] || 0)), fe = on(Ce / h), fe > 1)
              for (fe >= N && (fe = N - 1), pe = y(P, fe, N), ye = pe.length, ce = oe.length; S(pe, oe, ye, ce) == 1; )
                fe--, _(pe, m < ye ? E : P, ye, N), ye = pe.length, O = 1;
            else
              fe == 0 && (O = fe = 1), pe = P.slice(), ye = pe.length;
            if (ye < ce && (pe = [0].concat(pe)), _(oe, pe, ce, N), ce = oe.length, O == -1)
              for (; S(P, oe, m, ce) < 1; )
                fe++, _(oe, m < ce ? E : P, ce, N), ce = oe.length;
          } else O === 0 && (fe++, oe = [0]);
          B[Q++] = fe, oe[0] ? oe[ce++] = R[he] || 0 : (oe = [R[he]], ce = 1);
        } while ((he++ < ge || oe[0] != null) && $--);
        ie = oe[0] != null, B[0] || B.splice(0, 1);
      }
      if (N == _n) {
        for (Q = 1, $ = B[0]; $ >= 10; $ /= 10, Q++) ;
        D(te, j + (te.e = Q + G * pt - 1) + 1, Y, ie);
      } else
        te.e = G, te.r = +ie;
      return te;
    };
  }();
  function C(y, S, _, F) {
    var M, j, Y, N, O;
    if (_ == null ? _ = s : Yt(_, 0, 8), !y.c) return y.toString();
    if (M = y.c[0], Y = y.e, S == null)
      O = tn(y.c), O = F == 1 || F == 2 && (Y <= l || Y >= c) ? xc(O, Y) : Yn(O, Y, "0");
    else if (y = D(new v(y), S, _), j = y.e, O = tn(y.c), N = O.length, F == 1 || F == 2 && (S <= j || j <= l)) {
      for (; N < S; O += "0", N++) ;
      O = xc(O, j);
    } else if (S -= Y + (F === 2 && j > Y), O = Yn(O, j, "0"), j + 1 > N) {
      if (--S > 0) for (O += "."; S--; O += "0") ;
    } else if (S += j - N, S > 0)
      for (j + 1 == N && (O += "."); S--; O += "0") ;
    return y.s < 0 && M ? "-" + O : O;
  }
  function W(y, S) {
    for (var _, F, M = 1, j = new v(y[0]); M < y.length; M++)
      F = new v(y[M]), (!F.s || (_ = Wa(j, F)) === S || _ === 0 && j.s === S) && (j = F);
    return j;
  }
  function Z(y, S, _) {
    for (var F = 1, M = S.length; !S[--M]; S.pop()) ;
    for (M = S[0]; M >= 10; M /= 10, F++) ;
    return (_ = F + _ * pt - 1) > d ? y.c = y.e = null : _ < u ? y.c = [y.e = 0] : (y.e = _, y.c = S), y;
  }
  n = /* @__PURE__ */ function() {
    var y = /^(-?)0([xbo])(?=\w[\w.]*$)/i, S = /^([^.]+)\.$/, _ = /^\.([^.]+)$/, F = /^-?(Infinity|NaN)$/, M = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(j, Y, N, O) {
      var G, Q = N ? Y : Y.replace(M, "");
      if (F.test(Q))
        j.s = isNaN(Q) ? null : Q < 0 ? -1 : 1;
      else {
        if (!N && (Q = Q.replace(y, function(ie, fe, pe) {
          return G = (pe = pe.toLowerCase()) == "x" ? 16 : pe == "b" ? 2 : 8, !O || O == G ? fe : ie;
        }), O && (G = O, Q = Q.replace(S, "$1").replace(_, "0.$1")), Y != Q))
          return new v(Q, G);
        if (v.DEBUG)
          throw Error(qr + "Not a" + (O ? " base " + O : "") + " number: " + Y);
        j.s = null;
      }
      j.c = j.e = null;
    };
  }();
  function D(y, S, _, F) {
    var M, j, Y, N, O, G, Q, ie = y.c, fe = Iu;
    if (ie) {
      e: {
        for (M = 1, N = ie[0]; N >= 10; N /= 10, M++) ;
        if (j = S - M, j < 0)
          j += pt, Y = S, O = ie[G = 0], Q = on(O / fe[M - Y - 1] % 10);
        else if (G = Ru((j + 1) / pt), G >= ie.length)
          if (F) {
            for (; ie.length <= G; ie.push(0)) ;
            O = Q = 0, M = 1, j %= pt, Y = j - pt + 1;
          } else
            break e;
        else {
          for (O = N = ie[G], M = 1; N >= 10; N /= 10, M++) ;
          j %= pt, Y = j - pt + M, Q = Y < 0 ? 0 : on(O / fe[M - Y - 1] % 10);
        }
        if (F = F || S < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        ie[G + 1] != null || (Y < 0 ? O : O % fe[M - Y - 1]), F = _ < 4 ? (Q || F) && (_ == 0 || _ == (y.s < 0 ? 3 : 2)) : Q > 5 || Q == 5 && (_ == 4 || F || _ == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (j > 0 ? Y > 0 ? O / fe[M - Y] : 0 : ie[G - 1]) % 10 & 1 || _ == (y.s < 0 ? 8 : 7)), S < 1 || !ie[0])
          return ie.length = 0, F ? (S -= y.e + 1, ie[0] = fe[(pt - S % pt) % pt], y.e = -S || 0) : ie[0] = y.e = 0, y;
        if (j == 0 ? (ie.length = G, N = 1, G--) : (ie.length = G + 1, N = fe[pt - j], ie[G] = Y > 0 ? on(O / fe[M - Y] % fe[Y]) * N : 0), F)
          for (; ; )
            if (G == 0) {
              for (j = 1, Y = ie[0]; Y >= 10; Y /= 10, j++) ;
              for (Y = ie[0] += N, N = 1; Y >= 10; Y /= 10, N++) ;
              j != N && (y.e++, ie[0] == _n && (ie[0] = 1));
              break;
            } else {
              if (ie[G] += N, ie[G] != _n) break;
              ie[G--] = 0, N = 1;
            }
        for (j = ie.length; ie[--j] === 0; ie.pop()) ;
      }
      y.e > d ? y.c = y.e = null : y.e < u && (y.c = [y.e = 0]);
    }
    return y;
  }
  function H(y) {
    var S, _ = y.e;
    return _ === null ? y.toString() : (S = tn(y.c), S = _ <= l || _ >= c ? xc(S, _) : Yn(S, _, "0"), y.s < 0 ? "-" + S : S);
  }
  return a.absoluteValue = a.abs = function() {
    var y = new v(this);
    return y.s < 0 && (y.s = 1), y;
  }, a.comparedTo = function(y, S) {
    return Wa(this, new v(y, S));
  }, a.decimalPlaces = a.dp = function(y, S) {
    var _, F, M, j = this;
    if (y != null)
      return Yt(y, 0, Zr), S == null ? S = s : Yt(S, 0, 8), D(new v(j), y + j.e + 1, S);
    if (!(_ = j.c)) return null;
    if (F = ((M = _.length - 1) - sn(this.e / pt)) * pt, M = _[M]) for (; M % 10 == 0; M /= 10, F--) ;
    return F < 0 && (F = 0), F;
  }, a.dividedBy = a.div = function(y, S) {
    return e(this, new v(y, S), i, s);
  }, a.dividedToIntegerBy = a.idiv = function(y, S) {
    return e(this, new v(y, S), 0, 1);
  }, a.exponentiatedBy = a.pow = function(y, S) {
    var _, F, M, j, Y, N, O, G, Q, ie = this;
    if (y = new v(y), y.c && !y.isInteger())
      throw Error(qr + "Exponent not an integer: " + H(y));
    if (S != null && (S = new v(S)), N = y.e > 14, !ie.c || !ie.c[0] || ie.c[0] == 1 && !ie.e && ie.c.length == 1 || !y.c || !y.c[0])
      return Q = new v(Math.pow(+H(ie), N ? y.s * (2 - Ec(y)) : +H(y))), S ? Q.mod(S) : Q;
    if (O = y.s < 0, S) {
      if (S.c ? !S.c[0] : !S.s) return new v(NaN);
      F = !O && ie.isInteger() && S.isInteger(), F && (ie = ie.mod(S));
    } else {
      if (y.e > 9 && (ie.e > 0 || ie.e < -1 || (ie.e == 0 ? ie.c[0] > 1 || N && ie.c[1] >= 24e7 : ie.c[0] < 8e13 || N && ie.c[0] <= 9999975e7)))
        return j = ie.s < 0 && Ec(y) ? -0 : 0, ie.e > -1 && (j = 1 / j), new v(O ? 1 / j : j);
      A && (j = Ru(A / pt + 2));
    }
    for (N ? (_ = new v(0.5), O && (y.s = 1), G = Ec(y)) : (M = Math.abs(+H(y)), G = M % 2), Q = new v(o); ; ) {
      if (G) {
        if (Q = Q.times(ie), !Q.c) break;
        j ? Q.c.length > j && (Q.c.length = j) : F && (Q = Q.mod(S));
      }
      if (M) {
        if (M = on(M / 2), M === 0) break;
        G = M % 2;
      } else if (y = y.times(_), D(y, y.e + 1, 1), y.e > 14)
        G = Ec(y);
      else {
        if (M = +H(y), M === 0) break;
        G = M % 2;
      }
      ie = ie.times(ie), j ? ie.c && ie.c.length > j && (ie.c.length = j) : F && (ie = ie.mod(S));
    }
    return F ? Q : (O && (Q = o.div(Q)), S ? Q.mod(S) : j ? D(Q, A, s, Y) : Q);
  }, a.integerValue = function(y) {
    var S = new v(this);
    return y == null ? y = s : Yt(y, 0, 8), D(S, S.e + 1, y);
  }, a.isEqualTo = a.eq = function(y, S) {
    return Wa(this, new v(y, S)) === 0;
  }, a.isFinite = function() {
    return !!this.c;
  }, a.isGreaterThan = a.gt = function(y, S) {
    return Wa(this, new v(y, S)) > 0;
  }, a.isGreaterThanOrEqualTo = a.gte = function(y, S) {
    return (S = Wa(this, new v(y, S))) === 1 || S === 0;
  }, a.isInteger = function() {
    return !!this.c && sn(this.e / pt) > this.c.length - 2;
  }, a.isLessThan = a.lt = function(y, S) {
    return Wa(this, new v(y, S)) < 0;
  }, a.isLessThanOrEqualTo = a.lte = function(y, S) {
    return (S = Wa(this, new v(y, S))) === -1 || S === 0;
  }, a.isNaN = function() {
    return !this.s;
  }, a.isNegative = function() {
    return this.s < 0;
  }, a.isPositive = function() {
    return this.s > 0;
  }, a.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, a.minus = function(y, S) {
    var _, F, M, j, Y = this, N = Y.s;
    if (y = new v(y, S), S = y.s, !N || !S) return new v(NaN);
    if (N != S)
      return y.s = -S, Y.plus(y);
    var O = Y.e / pt, G = y.e / pt, Q = Y.c, ie = y.c;
    if (!O || !G) {
      if (!Q || !ie) return Q ? (y.s = -S, y) : new v(ie ? Y : NaN);
      if (!Q[0] || !ie[0])
        return ie[0] ? (y.s = -S, y) : new v(Q[0] ? Y : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          s == 3 ? -0 : 0
        ));
    }
    if (O = sn(O), G = sn(G), Q = Q.slice(), N = O - G) {
      for ((j = N < 0) ? (N = -N, M = Q) : (G = O, M = ie), M.reverse(), S = N; S--; M.push(0)) ;
      M.reverse();
    } else
      for (F = (j = (N = Q.length) < (S = ie.length)) ? N : S, N = S = 0; S < F; S++)
        if (Q[S] != ie[S]) {
          j = Q[S] < ie[S];
          break;
        }
    if (j && (M = Q, Q = ie, ie = M, y.s = -y.s), S = (F = ie.length) - (_ = Q.length), S > 0) for (; S--; Q[_++] = 0) ;
    for (S = _n - 1; F > N; ) {
      if (Q[--F] < ie[F]) {
        for (_ = F; _ && !Q[--_]; Q[_] = S) ;
        --Q[_], Q[F] += _n;
      }
      Q[F] -= ie[F];
    }
    for (; Q[0] == 0; Q.splice(0, 1), --G) ;
    return Q[0] ? Z(y, Q, G) : (y.s = s == 3 ? -1 : 1, y.c = [y.e = 0], y);
  }, a.modulo = a.mod = function(y, S) {
    var _, F, M = this;
    return y = new v(y, S), !M.c || !y.s || y.c && !y.c[0] ? new v(NaN) : !y.c || M.c && !M.c[0] ? new v(M) : (f == 9 ? (F = y.s, y.s = 1, _ = e(M, y, 0, 3), y.s = F, _.s *= F) : _ = e(M, y, 0, f), y = M.minus(_.times(y)), !y.c[0] && f == 1 && (y.s = M.s), y);
  }, a.multipliedBy = a.times = function(y, S) {
    var _, F, M, j, Y, N, O, G, Q, ie, fe, pe, ye, te, B, oe = this, ce = oe.c, Ce = (y = new v(y, S)).c;
    if (!ce || !Ce || !ce[0] || !Ce[0])
      return !oe.s || !y.s || ce && !ce[0] && !Ce || Ce && !Ce[0] && !ce ? y.c = y.e = y.s = null : (y.s *= oe.s, !ce || !Ce ? y.c = y.e = null : (y.c = [0], y.e = 0)), y;
    for (F = sn(oe.e / pt) + sn(y.e / pt), y.s *= oe.s, O = ce.length, ie = Ce.length, O < ie && (ye = ce, ce = Ce, Ce = ye, M = O, O = ie, ie = M), M = O + ie, ye = []; M--; ye.push(0)) ;
    for (te = _n, B = pa, M = ie; --M >= 0; ) {
      for (_ = 0, fe = Ce[M] % B, pe = Ce[M] / B | 0, Y = O, j = M + Y; j > M; )
        G = ce[--Y] % B, Q = ce[Y] / B | 0, N = pe * G + Q * fe, G = fe * G + N % B * B + ye[j] + _, _ = (G / te | 0) + (N / B | 0) + pe * Q, ye[j--] = G % te;
      ye[j] = _;
    }
    return _ ? ++F : ye.splice(0, 1), Z(y, ye, F);
  }, a.negated = function() {
    var y = new v(this);
    return y.s = -y.s || null, y;
  }, a.plus = function(y, S) {
    var _, F = this, M = F.s;
    if (y = new v(y, S), S = y.s, !M || !S) return new v(NaN);
    if (M != S)
      return y.s = -S, F.minus(y);
    var j = F.e / pt, Y = y.e / pt, N = F.c, O = y.c;
    if (!j || !Y) {
      if (!N || !O) return new v(M / 0);
      if (!N[0] || !O[0]) return O[0] ? y : new v(N[0] ? F : M * 0);
    }
    if (j = sn(j), Y = sn(Y), N = N.slice(), M = j - Y) {
      for (M > 0 ? (Y = j, _ = O) : (M = -M, _ = N), _.reverse(); M--; _.push(0)) ;
      _.reverse();
    }
    for (M = N.length, S = O.length, M - S < 0 && (_ = O, O = N, N = _, S = M), M = 0; S; )
      M = (N[--S] = N[S] + O[S] + M) / _n | 0, N[S] = _n === N[S] ? 0 : N[S] % _n;
    return M && (N = [M].concat(N), ++Y), Z(y, N, Y);
  }, a.precision = a.sd = function(y, S) {
    var _, F, M, j = this;
    if (y != null && y !== !!y)
      return Yt(y, 1, Zr), S == null ? S = s : Yt(S, 0, 8), D(new v(j), y, S);
    if (!(_ = j.c)) return null;
    if (M = _.length - 1, F = M * pt + 1, M = _[M]) {
      for (; M % 10 == 0; M /= 10, F--) ;
      for (M = _[0]; M >= 10; M /= 10, F++) ;
    }
    return y && j.e + 1 > F && (F = j.e + 1), F;
  }, a.shiftedBy = function(y) {
    return Yt(y, -9007199254740991, Ph), this.times("1e" + y);
  }, a.squareRoot = a.sqrt = function() {
    var y, S, _, F, M, j = this, Y = j.c, N = j.s, O = j.e, G = i + 4, Q = new v("0.5");
    if (N !== 1 || !Y || !Y[0])
      return new v(!N || N < 0 && (!Y || Y[0]) ? NaN : Y ? j : 1 / 0);
    if (N = Math.sqrt(+H(j)), N == 0 || N == 1 / 0 ? (S = tn(Y), (S.length + O) % 2 == 0 && (S += "0"), N = Math.sqrt(+S), O = sn((O + 1) / 2) - (O < 0 || O % 2), N == 1 / 0 ? S = "5e" + O : (S = N.toExponential(), S = S.slice(0, S.indexOf("e") + 1) + O), _ = new v(S)) : _ = new v(N + ""), _.c[0]) {
      for (O = _.e, N = O + G, N < 3 && (N = 0); ; )
        if (M = _, _ = Q.times(M.plus(e(j, M, G, 1))), tn(M.c).slice(0, N) === (S = tn(_.c)).slice(0, N))
          if (_.e < O && --N, S = S.slice(N - 3, N + 1), S == "9999" || !F && S == "4999") {
            if (!F && (D(M, M.e + i + 2, 0), M.times(M).eq(j))) {
              _ = M;
              break;
            }
            G += 4, N += 4, F = 1;
          } else {
            (!+S || !+S.slice(1) && S.charAt(0) == "5") && (D(_, _.e + i + 2, 1), y = !_.times(_).eq(j));
            break;
          }
    }
    return D(_, _.e + i + 1, s, y);
  }, a.toExponential = function(y, S) {
    return y != null && (Yt(y, 0, Zr), y++), C(this, y, S, 1);
  }, a.toFixed = function(y, S) {
    return y != null && (Yt(y, 0, Zr), y = y + this.e + 1), C(this, y, S);
  }, a.toFormat = function(y, S, _) {
    var F, M = this;
    if (_ == null)
      y != null && S && typeof S == "object" ? (_ = S, S = null) : y && typeof y == "object" ? (_ = y, y = S = null) : _ = b;
    else if (typeof _ != "object")
      throw Error(qr + "Argument not an object: " + _);
    if (F = M.toFixed(y, S), M.c) {
      var j, Y = F.split("."), N = +_.groupSize, O = +_.secondaryGroupSize, G = _.groupSeparator || "", Q = Y[0], ie = Y[1], fe = M.s < 0, pe = fe ? Q.slice(1) : Q, ye = pe.length;
      if (O && (j = N, N = O, O = j, ye -= j), N > 0 && ye > 0) {
        for (j = ye % N || N, Q = pe.substr(0, j); j < ye; j += N) Q += G + pe.substr(j, N);
        O > 0 && (Q += G + pe.slice(j)), fe && (Q = "-" + Q);
      }
      F = ie ? Q + (_.decimalSeparator || "") + ((O = +_.fractionGroupSize) ? ie.replace(
        new RegExp("\\d{" + O + "}\\B", "g"),
        "$&" + (_.fractionGroupSeparator || "")
      ) : ie) : Q;
    }
    return (_.prefix || "") + F + (_.suffix || "");
  }, a.toFraction = function(y) {
    var S, _, F, M, j, Y, N, O, G, Q, ie, fe, pe = this, ye = pe.c;
    if (y != null && (N = new v(y), !N.isInteger() && (N.c || N.s !== 1) || N.lt(o)))
      throw Error(qr + "Argument " + (N.isInteger() ? "out of range: " : "not an integer: ") + H(N));
    if (!ye) return new v(pe);
    for (S = new v(o), G = _ = new v(o), F = O = new v(o), fe = tn(ye), j = S.e = fe.length - pe.e - 1, S.c[0] = Iu[(Y = j % pt) < 0 ? pt + Y : Y], y = !y || N.comparedTo(S) > 0 ? j > 0 ? S : G : N, Y = d, d = 1 / 0, N = new v(fe), O.c[0] = 0; Q = e(N, S, 0, 1), M = _.plus(Q.times(F)), M.comparedTo(y) != 1; )
      _ = F, F = M, G = O.plus(Q.times(M = G)), O = M, S = N.minus(Q.times(M = S)), N = M;
    return M = e(y.minus(_), F, 0, 1), O = O.plus(M.times(G)), _ = _.plus(M.times(F)), O.s = G.s = pe.s, j = j * 2, ie = e(G, F, j, s).minus(pe).abs().comparedTo(
      e(O, _, j, s).minus(pe).abs()
    ) < 1 ? [G, F] : [O, _], d = Y, ie;
  }, a.toNumber = function() {
    return +H(this);
  }, a.toPrecision = function(y, S) {
    return y != null && Yt(y, 1, Zr), C(this, y, S, 2);
  }, a.toString = function(y) {
    var S, _ = this, F = _.s, M = _.e;
    return M === null ? F ? (S = "Infinity", F < 0 && (S = "-" + S)) : S = "NaN" : (y == null ? S = M <= l || M >= c ? xc(tn(_.c), M) : Yn(tn(_.c), M, "0") : y === 10 && k ? (_ = D(new v(_), i + M + 1, s), S = Yn(tn(_.c), _.e, "0")) : (Yt(y, 2, g.length, "Base"), S = t(Yn(tn(_.c), M, "0"), 10, y, F, !0)), F < 0 && _.c[0] && (S = "-" + S)), S;
  }, a.valueOf = a.toJSON = function() {
    return H(this);
  }, a._isBigNumber = !0, a[Symbol.toStringTag] = "BigNumber", a[Symbol.for("nodejs.util.inspect.custom")] = a.valueOf, r != null && v.set(r), v;
}
function sn(r) {
  var e = r | 0;
  return r > 0 || r === e ? e : e - 1;
}
function tn(r) {
  for (var e, t, n = 1, a = r.length, o = r[0] + ""; n < a; ) {
    for (e = r[n++] + "", t = pt - e.length; t--; e = "0" + e) ;
    o += e;
  }
  for (a = o.length; o.charCodeAt(--a) === 48; ) ;
  return o.slice(0, a + 1 || 1);
}
function Wa(r, e) {
  var t, n, a = r.c, o = e.c, i = r.s, s = e.s, l = r.e, c = e.e;
  if (!i || !s) return null;
  if (t = a && !a[0], n = o && !o[0], t || n) return t ? n ? 0 : -s : i;
  if (i != s) return i;
  if (t = i < 0, n = l == c, !a || !o) return n ? 0 : !a ^ t ? 1 : -1;
  if (!n) return l > c ^ t ? 1 : -1;
  for (s = (l = a.length) < (c = o.length) ? l : c, i = 0; i < s; i++) if (a[i] != o[i]) return a[i] > o[i] ^ t ? 1 : -1;
  return l == c ? 0 : l > c ^ t ? 1 : -1;
}
function Yt(r, e, t, n) {
  if (r < e || r > t || r !== on(r))
    throw Error(qr + (n || "Argument") + (typeof r == "number" ? r < e || r > t ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(r));
}
function Ec(r) {
  var e = r.c.length - 1;
  return sn(r.e / pt) == e && r.c[e] % 2 != 0;
}
function xc(r, e) {
  return (r.length > 1 ? r.charAt(0) + "." + r.slice(1) : r) + (e < 0 ? "e" : "e+") + e;
}
function Yn(r, e, t) {
  var n, a;
  if (e < 0) {
    for (a = t + "."; ++e; a += t) ;
    r = a + r;
  } else if (n = r.length, ++e > n) {
    for (a = t, e -= n; --e; a += t) ;
    r += a;
  } else e < n && (r = r.slice(0, e) + "." + r.slice(e));
  return r;
}
var cd = k3(), q4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function W4(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Nh, Bh;
function K4() {
  return Bh || (Bh = 1, Nh = {
    languageTag: "en-US",
    delimiters: {
      thousands: ",",
      decimal: "."
    },
    abbreviations: {
      thousand: "k",
      million: "m",
      billion: "b",
      trillion: "t"
    },
    spaceSeparated: !1,
    ordinal: function(r) {
      let e = r % 10;
      return ~~(r % 100 / 10) === 1 ? "th" : e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th";
    },
    bytes: {
      binarySuffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
      decimalSuffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    },
    currency: {
      symbol: "$",
      position: "prefix",
      code: "USD"
    },
    currencyFormat: {
      thousandSeparated: !0,
      totalLength: 4,
      spaceSeparated: !0,
      spaceSeparatedCurrency: !0
    },
    formats: {
      fourDigits: {
        totalLength: 4,
        spaceSeparated: !0
      },
      fullWithTwoDecimals: {
        output: "currency",
        thousandSeparated: !0,
        mantissa: 2
      },
      fullWithTwoDecimalsNoCurrency: {
        thousandSeparated: !0,
        mantissa: 2
      },
      fullWithNoDecimals: {
        output: "currency",
        thousandSeparated: !0,
        mantissa: 0
      }
    }
  }), Nh;
}
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Tu, Lh;
function A3() {
  if (Lh) return Tu;
  Lh = 1;
  const r = [
    { key: "ZiB", factor: Math.pow(1024, 7) },
    { key: "ZB", factor: Math.pow(1e3, 7) },
    { key: "YiB", factor: Math.pow(1024, 8) },
    { key: "YB", factor: Math.pow(1e3, 8) },
    { key: "TiB", factor: Math.pow(1024, 4) },
    { key: "TB", factor: Math.pow(1e3, 4) },
    { key: "PiB", factor: Math.pow(1024, 5) },
    { key: "PB", factor: Math.pow(1e3, 5) },
    { key: "MiB", factor: Math.pow(1024, 2) },
    { key: "MB", factor: Math.pow(1e3, 2) },
    { key: "KiB", factor: Math.pow(1024, 1) },
    { key: "KB", factor: Math.pow(1e3, 1) },
    { key: "GiB", factor: Math.pow(1024, 3) },
    { key: "GB", factor: Math.pow(1e3, 3) },
    { key: "EiB", factor: Math.pow(1024, 6) },
    { key: "EB", factor: Math.pow(1e3, 6) },
    { key: "B", factor: 1 }
  ];
  function e(l) {
    return l.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  function t(l, c, u, d, w, f, A) {
    if (!isNaN(+l))
      return +l;
    let b = "", g = l.replace(/(^[^(]*)\((.*)\)([^)]*$)/, "$1$2$3");
    if (g !== l)
      return -1 * t(g, c, u, d, w, f);
    for (let D = 0; D < r.length; D++) {
      let H = r[D];
      if (b = l.replace(RegExp(`([0-9 ])(${H.key})$`), "$1"), b !== l)
        return t(b, c, u, d, w, f) * H.factor;
    }
    if (b = l.replace("%", ""), b !== l)
      return t(b, c, u, d, w, f) / 100;
    let k = parseFloat(l);
    if (isNaN(k))
      return;
    let v = d(k);
    if (v && v !== "." && (b = l.replace(new RegExp(`${e(v)}$`), ""), b !== l))
      return t(b, c, u, d, w, f);
    let C = {};
    Object.keys(f).forEach((D) => {
      C[f[D]] = D;
    });
    let W = Object.keys(C).sort().reverse(), Z = W.length;
    for (let D = 0; D < Z; D++) {
      let H = W[D], y = C[H];
      if (b = l.replace(H, ""), b !== l) {
        let S;
        switch (y) {
          // eslint-disable-line default-case
          case "thousand":
            S = Math.pow(10, 3);
            break;
          case "million":
            S = Math.pow(10, 6);
            break;
          case "billion":
            S = Math.pow(10, 9);
            break;
          case "trillion":
            S = Math.pow(10, 12);
            break;
        }
        return t(b, c, u, d, w, f) * S;
      }
    }
  }
  function n(l, c, u) {
    let d = l.replace(u, "");
    return d = d.replace(new RegExp(`([0-9])${e(c.thousands)}([0-9])`, "g"), "$1$2"), d = d.replace(c.decimal, "."), d;
  }
  function a(l, c, u = "", d, w, f, A) {
    if (l === "")
      return;
    if (l === w)
      return 0;
    let b = n(l, c, u);
    return t(b, c, u, d, w, f);
  }
  function o(l, c) {
    if (!(l.indexOf(":") && c.thousands !== ":"))
      return !1;
    let u = l.split(":");
    if (u.length !== 3)
      return !1;
    let d = +u[0], w = +u[1], f = +u[2];
    return !isNaN(d) && !isNaN(w) && !isNaN(f);
  }
  function i(l) {
    let c = l.split(":"), u = +c[0], d = +c[1];
    return +c[2] + 60 * d + 3600 * u;
  }
  function s(l, c) {
    const u = dd();
    let d = u.currentDelimiters(), w = u.currentCurrency().symbol, f = u.currentOrdinal(), A = u.getZeroFormat(), b = u.currentAbbreviations(), g;
    if (typeof l == "string")
      o(l, d) ? g = i(l) : g = a(l, d, w, f, A, b);
    else if (typeof l == "number")
      g = l;
    else
      return;
    if (g !== void 0)
      return g;
  }
  return Tu = {
    unformat: s
  }, Tu;
}
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Ou, Uh;
function ld() {
  if (Uh) return Ou;
  Uh = 1;
  let r = A3();
  const e = /^[a-z]{2,3}(-[a-zA-Z]{4})?(-([A-Z]{2}|[0-9]{3}))?$/, t = [
    "currency",
    "percent",
    "byte",
    "time",
    "ordinal",
    "number"
  ], n = [
    "trillion",
    "billion",
    "million",
    "thousand"
  ], a = [
    "prefix",
    "infix",
    "postfix"
  ], o = [
    "sign",
    "parenthesis"
  ], i = {
    type: "object",
    children: {
      thousand: {
        type: "string",
        mandatory: !0
      },
      million: {
        type: "string",
        mandatory: !0
      },
      billion: {
        type: "string",
        mandatory: !0
      },
      trillion: {
        type: "string",
        mandatory: !0
      }
    },
    mandatory: !0
  }, s = {
    output: {
      type: "string",
      validValues: t
    },
    base: {
      type: "string",
      validValues: [
        "decimal",
        "binary",
        "general"
      ],
      restriction: (A, b) => b.output === "byte",
      message: "`base` must be provided only when the output is `byte`",
      mandatory: (A) => A.output === "byte"
    },
    characteristic: {
      type: "number",
      restriction: (A) => A >= 0,
      message: "value must be positive"
    },
    prefix: "string",
    postfix: "string",
    forceAverage: {
      type: "string",
      validValues: n
    },
    average: "boolean",
    lowPrecision: {
      type: "boolean",
      restriction: (A, b) => b.average === !0,
      message: "`lowPrecision` must be provided only when the option `average` is set"
    },
    currencyPosition: {
      type: "string",
      validValues: a
    },
    currencySymbol: "string",
    totalLength: {
      type: "number",
      restrictions: [
        {
          restriction: (A) => A >= 0,
          message: "value must be positive"
        },
        {
          restriction: (A, b) => !b.exponential,
          message: "`totalLength` is incompatible with `exponential`"
        }
      ]
    },
    mantissa: {
      type: "number",
      restriction: (A) => A >= 0,
      message: "value must be positive"
    },
    optionalMantissa: "boolean",
    trimMantissa: "boolean",
    roundingFunction: "function",
    optionalCharacteristic: "boolean",
    thousandSeparated: "boolean",
    spaceSeparated: "boolean",
    spaceSeparatedCurrency: "boolean",
    spaceSeparatedAbbreviation: "boolean",
    abbreviations: {
      type: "object",
      children: {
        thousand: "string",
        million: "string",
        billion: "string",
        trillion: "string"
      }
    },
    negative: {
      type: "string",
      validValues: o
    },
    forceSign: "boolean",
    exponential: {
      type: "boolean"
    },
    prefixSymbol: {
      type: "boolean",
      restriction: (A, b) => b.output === "percent",
      message: "`prefixSymbol` can be provided only when the output is `percent`"
    }
  }, l = {
    languageTag: {
      type: "string",
      mandatory: !0,
      restriction: (A) => A.match(e),
      message: "the language tag must follow the BCP 47 specification (see https://tools.ieft.org/html/bcp47)"
    },
    delimiters: {
      type: "object",
      children: {
        thousands: "string",
        decimal: "string",
        thousandsSize: "number"
      },
      mandatory: !0
    },
    abbreviations: i,
    spaceSeparated: "boolean",
    spaceSeparatedCurrency: "boolean",
    ordinal: {
      type: "function",
      mandatory: !0
    },
    bytes: {
      type: "object",
      children: {
        binarySuffixes: "object",
        decimalSuffixes: "object"
      }
    },
    currency: {
      type: "object",
      children: {
        symbol: "string",
        position: "string",
        code: "string"
      },
      mandatory: !0
    },
    defaults: "format",
    ordinalFormat: "format",
    byteFormat: "format",
    percentageFormat: "format",
    currencyFormat: "format",
    timeDefaults: "format",
    formats: {
      type: "object",
      children: {
        fourDigits: {
          type: "format",
          mandatory: !0
        },
        fullWithTwoDecimals: {
          type: "format",
          mandatory: !0
        },
        fullWithTwoDecimalsNoCurrency: {
          type: "format",
          mandatory: !0
        },
        fullWithNoDecimals: {
          type: "format",
          mandatory: !0
        }
      }
    }
  };
  function c(A, b) {
    let g = u(A), k = w(b);
    return g && k;
  }
  function u(A) {
    return r.unformat(A) !== void 0;
  }
  function d(A, b, g, k = !1) {
    let v = Object.keys(A).map((C) => {
      if (!b[C])
        return console.error(`${g} Invalid key: ${C}`), !1;
      let W = A[C], Z = b[C];
      if (typeof Z == "string" && (Z = { type: Z }), Z.type === "format") {
        if (!d(W, s, `[Validate ${C}]`, !0))
          return !1;
      } else if (typeof W !== Z.type)
        return console.error(`${g} ${C} type mismatched: "${Z.type}" expected, "${typeof W}" provided`), !1;
      if (Z.restrictions && Z.restrictions.length) {
        let D = Z.restrictions.length;
        for (let H = 0; H < D; H++) {
          let { restriction: y, message: S } = Z.restrictions[H];
          if (!y(W, A))
            return console.error(`${g} ${C} invalid value: ${S}`), !1;
        }
      }
      return Z.restriction && !Z.restriction(W, A) ? (console.error(`${g} ${C} invalid value: ${Z.message}`), !1) : Z.validValues && Z.validValues.indexOf(W) === -1 ? (console.error(`${g} ${C} invalid value: must be among ${JSON.stringify(Z.validValues)}, "${W}" provided`), !1) : !(Z.children && !d(W, Z.children, `[Validate ${C}]`));
    });
    return k || v.push(...Object.keys(b).map((C) => {
      let W = b[C];
      if (typeof W == "string" && (W = { type: W }), W.mandatory) {
        let Z = W.mandatory;
        if (typeof Z == "function" && (Z = Z(A)), Z && A[C] === void 0)
          return console.error(`${g} Missing mandatory key "${C}"`), !1;
      }
      return !0;
    })), v.reduce((C, W) => C && W, !0);
  }
  function w(A) {
    return d(A, s, "[Validate format]");
  }
  function f(A) {
    return d(A, l, "[Validate language]");
  }
  return Ou = {
    validate: c,
    validateFormat: w,
    validateInput: u,
    validateLanguage: f
  }, Ou;
}
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
function Y4(r, e) {
  let t = r.match(/^{([^}]*)}/);
  return t ? (e.prefix = t[1], r.slice(t[0].length)) : r;
}
function G4(r, e) {
  let t = r.match(/{([^}]*)}$/);
  return t ? (e.postfix = t[1], r.slice(0, -t[0].length)) : r;
}
function J4(r, e) {
  if (r.indexOf("$") !== -1) {
    e.output = "currency";
    return;
  }
  if (r.indexOf("%") !== -1) {
    e.output = "percent";
    return;
  }
  if (r.indexOf("bd") !== -1) {
    e.output = "byte", e.base = "general";
    return;
  }
  if (r.indexOf("b") !== -1) {
    e.output = "byte", e.base = "binary";
    return;
  }
  if (r.indexOf("d") !== -1) {
    e.output = "byte", e.base = "decimal";
    return;
  }
  if (r.indexOf(":") !== -1) {
    e.output = "time";
    return;
  }
  r.indexOf("o") !== -1 && (e.output = "ordinal");
}
function X4(r, e) {
  r.indexOf(",") !== -1 && (e.thousandSeparated = !0);
}
function Z4(r, e) {
  r.indexOf(" ") !== -1 && (e.spaceSeparated = !0, e.spaceSeparatedCurrency = !0, (e.average || e.forceAverage) && (e.spaceSeparatedAbbreviation = !0));
}
function Q4(r, e) {
  let t = r.match(/[1-9]+[0-9]*/);
  t && (e.totalLength = +t[0]);
}
function e8(r, e) {
  let t = r.split(".")[0].match(/0+/);
  t && (e.characteristic = t[0].length);
}
function t8(r, e) {
  let t = r.split(".")[1];
  if (t) {
    let n = t.match(/0+/);
    n && (e.mantissa = n[0].length);
  }
}
function r8(r, e) {
  const t = r.split(".")[1];
  t && (e.trimMantissa = t.indexOf("[") !== -1);
}
function n8(r, e) {
  r.indexOf("a") !== -1 && (e.average = !0);
}
function a8(r, e) {
  r.indexOf("K") !== -1 ? e.forceAverage = "thousand" : r.indexOf("M") !== -1 ? e.forceAverage = "million" : r.indexOf("B") !== -1 ? e.forceAverage = "billion" : r.indexOf("T") !== -1 && (e.forceAverage = "trillion");
}
function o8(r, e) {
  r.match(/\[\.]/) ? e.optionalMantissa = !0 : r.match(/\./) && (e.optionalMantissa = !1);
}
function i8(r, e) {
  if (r.indexOf(".") !== -1) {
    let t = r.split(".")[0];
    e.optionalCharacteristic = t.indexOf("0") === -1;
  }
}
function s8(r, e) {
  r.match(/^\+?\([^)]*\)$/) && (e.negative = "parenthesis"), r.match(/^\+?-/) && (e.negative = "sign");
}
function c8(r, e) {
  r.match(/^\+/) && (e.forceSign = !0);
}
function l8(r, e = {}) {
  return typeof r != "string" ? r : (r = Y4(r, e), r = G4(r, e), J4(r, e), Q4(r, e), e8(r, e), i8(r, e), n8(r, e), a8(r, e), t8(r, e), o8(r, e), r8(r, e), X4(r, e), Z4(r, e), s8(r, e), c8(r, e), e);
}
var ud = {
  parseFormat: l8
};
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Pu, Vh;
function dd() {
  if (Vh) return Pu;
  Vh = 1;
  const r = K4(), e = ld(), t = ud;
  let n = {}, a, o = {}, i = null, s = {};
  function l(u) {
    a = u;
  }
  function c() {
    return o[a];
  }
  return n.languages = () => Object.assign({}, o), n.currentLanguage = () => a, n.currentBytes = () => c().bytes || {}, n.currentCurrency = () => c().currency, n.currentAbbreviations = () => c().abbreviations, n.currentDelimiters = () => c().delimiters, n.currentOrdinal = () => c().ordinal, n.currentDefaults = () => Object.assign({}, c().defaults, s), n.currentOrdinalDefaultFormat = () => Object.assign({}, n.currentDefaults(), c().ordinalFormat), n.currentByteDefaultFormat = () => Object.assign({}, n.currentDefaults(), c().byteFormat), n.currentPercentageDefaultFormat = () => Object.assign({}, n.currentDefaults(), c().percentageFormat), n.currentCurrencyDefaultFormat = () => Object.assign({}, n.currentDefaults(), c().currencyFormat), n.currentTimeDefaultFormat = () => Object.assign({}, n.currentDefaults(), c().timeFormat), n.setDefaults = (u) => {
    u = t.parseFormat(u), e.validateFormat(u) && (s = u);
  }, n.getZeroFormat = () => i, n.setZeroFormat = (u) => i = typeof u == "string" ? u : null, n.hasZeroFormat = () => i !== null, n.languageData = (u) => {
    if (u) {
      if (o[u])
        return o[u];
      throw new Error(`Unknown tag "${u}"`);
    }
    return c();
  }, n.registerLanguage = (u, d = !1) => {
    if (!e.validateLanguage(u))
      throw new Error("Invalid language data");
    o[u.languageTag] = u, d && l(u.languageTag);
  }, n.setLanguage = (u, d = r.languageTag) => {
    if (!o[u]) {
      let w = u.split("-")[0], f = Object.keys(o).find((A) => A.split("-")[0] === w);
      if (!o[f]) {
        l(d);
        return;
      }
      l(f);
      return;
    }
    l(u);
  }, n.registerLanguage(r), a = r.languageTag, Pu = n, Pu;
}
function u8(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
function d8(r, e) {
  r.forEach((t) => {
    let n;
    try {
      n = u8(`../languages/${t}`);
    } catch {
      console.error(`Unable to load "${t}". No matching language file found.`);
    }
    n && e.registerLanguage(n);
  });
}
var h8 = (r) => ({
  loadLanguagesInNode: (e) => d8(e, r)
}), C3 = { exports: {} };
(function(r) {
  (function(e) {
    var t, n = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, a = Math.ceil, o = Math.floor, i = "[BigNumber Error] ", s = i + "Number primitive has more than 15 significant digits: ", l = 1e14, c = 14, u = 9007199254740991, d = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], w = 1e7, f = 1e9;
    function A(D) {
      var H, y, S, _ = B.prototype = { constructor: B, toString: null, valueOf: null }, F = new B(1), M = 20, j = 4, Y = -7, N = 21, O = -1e7, G = 1e7, Q = !1, ie = 1, fe = 0, pe = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        // non-breaking space
        suffix: ""
      }, ye = "0123456789abcdefghijklmnopqrstuvwxyz", te = !0;
      function B(h, m) {
        var E, $, R, P, J, I, U, K, z = this;
        if (!(z instanceof B)) return new B(h, m);
        if (m == null) {
          if (h && h._isBigNumber === !0) {
            z.s = h.s, !h.c || h.e > G ? z.c = z.e = null : h.e < O ? z.c = [z.e = 0] : (z.e = h.e, z.c = h.c.slice());
            return;
          }
          if ((I = typeof h == "number") && h * 0 == 0) {
            if (z.s = 1 / h < 0 ? (h = -h, -1) : 1, h === ~~h) {
              for (P = 0, J = h; J >= 10; J /= 10, P++) ;
              P > G ? z.c = z.e = null : (z.e = P, z.c = [h]);
              return;
            }
            K = String(h);
          } else {
            if (!n.test(K = String(h))) return S(z, K, I);
            z.s = K.charCodeAt(0) == 45 ? (K = K.slice(1), -1) : 1;
          }
          (P = K.indexOf(".")) > -1 && (K = K.replace(".", "")), (J = K.search(/e/i)) > 0 ? (P < 0 && (P = J), P += +K.slice(J + 1), K = K.substring(0, J)) : P < 0 && (P = K.length);
        } else {
          if (v(m, 2, ye.length, "Base"), m == 10 && te)
            return z = new B(h), he(z, M + z.e + 1, j);
          if (K = String(h), I = typeof h == "number") {
            if (h * 0 != 0) return S(z, K, I, m);
            if (z.s = 1 / h < 0 ? (K = K.slice(1), -1) : 1, B.DEBUG && K.replace(/^0\.0*|\./, "").length > 15)
              throw Error(s + h);
          } else
            z.s = K.charCodeAt(0) === 45 ? (K = K.slice(1), -1) : 1;
          for (E = ye.slice(0, m), P = J = 0, U = K.length; J < U; J++)
            if (E.indexOf($ = K.charAt(J)) < 0) {
              if ($ == ".") {
                if (J > P) {
                  P = U;
                  continue;
                }
              } else if (!R && (K == K.toUpperCase() && (K = K.toLowerCase()) || K == K.toLowerCase() && (K = K.toUpperCase()))) {
                R = !0, J = -1, P = 0;
                continue;
              }
              return S(z, String(h), I, m);
            }
          I = !1, K = y(K, m, 10, z.s), (P = K.indexOf(".")) > -1 ? K = K.replace(".", "") : P = K.length;
        }
        for (J = 0; K.charCodeAt(J) === 48; J++) ;
        for (U = K.length; K.charCodeAt(--U) === 48; ) ;
        if (K = K.slice(J, ++U)) {
          if (U -= J, I && B.DEBUG && U > 15 && (h > u || h !== o(h)))
            throw Error(s + z.s * h);
          if ((P = P - J - 1) > G)
            z.c = z.e = null;
          else if (P < O)
            z.c = [z.e = 0];
          else {
            if (z.e = P, z.c = [], J = (P + 1) % c, P < 0 && (J += c), J < U) {
              for (J && z.c.push(+K.slice(0, J)), U -= c; J < U; )
                z.c.push(+K.slice(J, J += c));
              J = c - (K = K.slice(J)).length;
            } else
              J -= U;
            for (; J--; K += "0") ;
            z.c.push(+K);
          }
        } else
          z.c = [z.e = 0];
      }
      B.clone = A, B.ROUND_UP = 0, B.ROUND_DOWN = 1, B.ROUND_CEIL = 2, B.ROUND_FLOOR = 3, B.ROUND_HALF_UP = 4, B.ROUND_HALF_DOWN = 5, B.ROUND_HALF_EVEN = 6, B.ROUND_HALF_CEIL = 7, B.ROUND_HALF_FLOOR = 8, B.EUCLID = 9, B.config = B.set = function(h) {
        var m, E;
        if (h != null)
          if (typeof h == "object") {
            if (h.hasOwnProperty(m = "DECIMAL_PLACES") && (E = h[m], v(E, 0, f, m), M = E), h.hasOwnProperty(m = "ROUNDING_MODE") && (E = h[m], v(E, 0, 8, m), j = E), h.hasOwnProperty(m = "EXPONENTIAL_AT") && (E = h[m], E && E.pop ? (v(E[0], -1e9, 0, m), v(E[1], 0, f, m), Y = E[0], N = E[1]) : (v(E, -1e9, f, m), Y = -(N = E < 0 ? -E : E))), h.hasOwnProperty(m = "RANGE"))
              if (E = h[m], E && E.pop)
                v(E[0], -1e9, -1, m), v(E[1], 1, f, m), O = E[0], G = E[1];
              else if (v(E, -1e9, f, m), E)
                O = -(G = E < 0 ? -E : E);
              else
                throw Error(i + m + " cannot be zero: " + E);
            if (h.hasOwnProperty(m = "CRYPTO"))
              if (E = h[m], E === !!E)
                if (E)
                  if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                    Q = E;
                  else
                    throw Q = !E, Error(i + "crypto unavailable");
                else
                  Q = E;
              else
                throw Error(i + m + " not true or false: " + E);
            if (h.hasOwnProperty(m = "MODULO_MODE") && (E = h[m], v(E, 0, 9, m), ie = E), h.hasOwnProperty(m = "POW_PRECISION") && (E = h[m], v(E, 0, f, m), fe = E), h.hasOwnProperty(m = "FORMAT"))
              if (E = h[m], typeof E == "object") pe = E;
              else throw Error(i + m + " not an object: " + E);
            if (h.hasOwnProperty(m = "ALPHABET"))
              if (E = h[m], typeof E == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(E))
                te = E.slice(0, 10) == "0123456789", ye = E;
              else
                throw Error(i + m + " invalid: " + E);
          } else
            throw Error(i + "Object expected: " + h);
        return {
          DECIMAL_PLACES: M,
          ROUNDING_MODE: j,
          EXPONENTIAL_AT: [Y, N],
          RANGE: [O, G],
          CRYPTO: Q,
          MODULO_MODE: ie,
          POW_PRECISION: fe,
          FORMAT: pe,
          ALPHABET: ye
        };
      }, B.isBigNumber = function(h) {
        if (!h || h._isBigNumber !== !0) return !1;
        if (!B.DEBUG) return !0;
        var m, E, $ = h.c, R = h.e, P = h.s;
        e: if ({}.toString.call($) == "[object Array]") {
          if ((P === 1 || P === -1) && R >= -1e9 && R <= f && R === o(R)) {
            if ($[0] === 0) {
              if (R === 0 && $.length === 1) return !0;
              break e;
            }
            if (m = (R + 1) % c, m < 1 && (m += c), String($[0]).length == m) {
              for (m = 0; m < $.length; m++)
                if (E = $[m], E < 0 || E >= l || E !== o(E)) break e;
              if (E !== 0) return !0;
            }
          }
        } else if ($ === null && R === null && (P === null || P === 1 || P === -1))
          return !0;
        throw Error(i + "Invalid BigNumber: " + h);
      }, B.maximum = B.max = function() {
        return ce(arguments, -1);
      }, B.minimum = B.min = function() {
        return ce(arguments, 1);
      }, B.random = function() {
        var h = 9007199254740992, m = Math.random() * h & 2097151 ? function() {
          return o(Math.random() * h);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(E) {
          var $, R, P, J, I, U = 0, K = [], z = new B(F);
          if (E == null ? E = M : v(E, 0, f), J = a(E / c), Q)
            if (crypto.getRandomValues) {
              for ($ = crypto.getRandomValues(new Uint32Array(J *= 2)); U < J; )
                I = $[U] * 131072 + ($[U + 1] >>> 11), I >= 9e15 ? (R = crypto.getRandomValues(new Uint32Array(2)), $[U] = R[0], $[U + 1] = R[1]) : (K.push(I % 1e14), U += 2);
              U = J / 2;
            } else if (crypto.randomBytes) {
              for ($ = crypto.randomBytes(J *= 7); U < J; )
                I = ($[U] & 31) * 281474976710656 + $[U + 1] * 1099511627776 + $[U + 2] * 4294967296 + $[U + 3] * 16777216 + ($[U + 4] << 16) + ($[U + 5] << 8) + $[U + 6], I >= 9e15 ? crypto.randomBytes(7).copy($, U) : (K.push(I % 1e14), U += 7);
              U = J / 7;
            } else
              throw Q = !1, Error(i + "crypto unavailable");
          if (!Q)
            for (; U < J; )
              I = m(), I < 9e15 && (K[U++] = I % 1e14);
          for (J = K[--U], E %= c, J && E && (I = d[c - E], K[U] = o(J / I) * I); K[U] === 0; K.pop(), U--) ;
          if (U < 0)
            K = [P = 0];
          else {
            for (P = -1; K[0] === 0; K.splice(0, 1), P -= c) ;
            for (U = 1, I = K[0]; I >= 10; I /= 10, U++) ;
            U < c && (P -= c - U);
          }
          return z.e = P, z.c = K, z;
        };
      }(), B.sum = function() {
        for (var h = 1, m = arguments, E = new B(m[0]); h < m.length; ) E = E.plus(m[h++]);
        return E;
      }, y = /* @__PURE__ */ function() {
        var h = "0123456789";
        function m(E, $, R, P) {
          for (var J, I = [0], U, K = 0, z = E.length; K < z; ) {
            for (U = I.length; U--; I[U] *= $) ;
            for (I[0] += P.indexOf(E.charAt(K++)), J = 0; J < I.length; J++)
              I[J] > R - 1 && (I[J + 1] == null && (I[J + 1] = 0), I[J + 1] += I[J] / R | 0, I[J] %= R);
          }
          return I.reverse();
        }
        return function(E, $, R, P, J) {
          var I, U, K, z, re, le, ee, Se, Re = E.indexOf("."), Ne = M, Ie = j;
          for (Re >= 0 && (z = fe, fe = 0, E = E.replace(".", ""), Se = new B($), le = Se.pow(E.length - Re), fe = z, Se.c = m(
            Z(g(le.c), le.e, "0"),
            10,
            R,
            h
          ), Se.e = Se.c.length), ee = m(E, $, R, J ? (I = ye, h) : (I = h, ye)), K = z = ee.length; ee[--z] == 0; ee.pop()) ;
          if (!ee[0]) return I.charAt(0);
          if (Re < 0 ? --K : (le.c = ee, le.e = K, le.s = P, le = H(le, Se, Ne, Ie, R), ee = le.c, re = le.r, K = le.e), U = K + Ne + 1, Re = ee[U], z = R / 2, re = re || U < 0 || ee[U + 1] != null, re = Ie < 4 ? (Re != null || re) && (Ie == 0 || Ie == (le.s < 0 ? 3 : 2)) : Re > z || Re == z && (Ie == 4 || re || Ie == 6 && ee[U - 1] & 1 || Ie == (le.s < 0 ? 8 : 7)), U < 1 || !ee[0])
            E = re ? Z(I.charAt(1), -Ne, I.charAt(0)) : I.charAt(0);
          else {
            if (ee.length = U, re)
              for (--R; ++ee[--U] > R; )
                ee[U] = 0, U || (++K, ee = [1].concat(ee));
            for (z = ee.length; !ee[--z]; ) ;
            for (Re = 0, E = ""; Re <= z; E += I.charAt(ee[Re++])) ;
            E = Z(E, K, I.charAt(0));
          }
          return E;
        };
      }(), H = /* @__PURE__ */ function() {
        function h($, R, P) {
          var J, I, U, K, z = 0, re = $.length, le = R % w, ee = R / w | 0;
          for ($ = $.slice(); re--; )
            U = $[re] % w, K = $[re] / w | 0, J = ee * U + K * le, I = le * U + J % w * w + z, z = (I / P | 0) + (J / w | 0) + ee * K, $[re] = I % P;
          return z && ($ = [z].concat($)), $;
        }
        function m($, R, P, J) {
          var I, U;
          if (P != J)
            U = P > J ? 1 : -1;
          else
            for (I = U = 0; I < P; I++)
              if ($[I] != R[I]) {
                U = $[I] > R[I] ? 1 : -1;
                break;
              }
          return U;
        }
        function E($, R, P, J) {
          for (var I = 0; P--; )
            $[P] -= I, I = $[P] < R[P] ? 1 : 0, $[P] = I * J + $[P] - R[P];
          for (; !$[0] && $.length > 1; $.splice(0, 1)) ;
        }
        return function($, R, P, J, I) {
          var U, K, z, re, le, ee, Se, Re, Ne, Ie, De, Fe, lt, ft, it, Ue, nt, He = $.s == R.s ? 1 : -1, ze = $.c, Be = R.c;
          if (!ze || !ze[0] || !Be || !Be[0])
            return new B(
              // Return NaN if either NaN, or both Infinity or 0.
              !$.s || !R.s || (ze ? Be && ze[0] == Be[0] : !Be) ? NaN : (
                // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                ze && ze[0] == 0 || !Be ? He * 0 : He / 0
              )
            );
          for (Re = new B(He), Ne = Re.c = [], K = $.e - R.e, He = P + K + 1, I || (I = l, K = b($.e / c) - b(R.e / c), He = He / c | 0), z = 0; Be[z] == (ze[z] || 0); z++) ;
          if (Be[z] > (ze[z] || 0) && K--, He < 0)
            Ne.push(1), re = !0;
          else {
            for (ft = ze.length, Ue = Be.length, z = 0, He += 2, le = o(I / (Be[0] + 1)), le > 1 && (Be = h(Be, le, I), ze = h(ze, le, I), Ue = Be.length, ft = ze.length), lt = Ue, Ie = ze.slice(0, Ue), De = Ie.length; De < Ue; Ie[De++] = 0) ;
            nt = Be.slice(), nt = [0].concat(nt), it = Be[0], Be[1] >= I / 2 && it++;
            do {
              if (le = 0, U = m(Be, Ie, Ue, De), U < 0) {
                if (Fe = Ie[0], Ue != De && (Fe = Fe * I + (Ie[1] || 0)), le = o(Fe / it), le > 1)
                  for (le >= I && (le = I - 1), ee = h(Be, le, I), Se = ee.length, De = Ie.length; m(ee, Ie, Se, De) == 1; )
                    le--, E(ee, Ue < Se ? nt : Be, Se, I), Se = ee.length, U = 1;
                else
                  le == 0 && (U = le = 1), ee = Be.slice(), Se = ee.length;
                if (Se < De && (ee = [0].concat(ee)), E(Ie, ee, De, I), De = Ie.length, U == -1)
                  for (; m(Be, Ie, Ue, De) < 1; )
                    le++, E(Ie, Ue < De ? nt : Be, De, I), De = Ie.length;
              } else U === 0 && (le++, Ie = [0]);
              Ne[z++] = le, Ie[0] ? Ie[De++] = ze[lt] || 0 : (Ie = [ze[lt]], De = 1);
            } while ((lt++ < ft || Ie[0] != null) && He--);
            re = Ie[0] != null, Ne[0] || Ne.splice(0, 1);
          }
          if (I == l) {
            for (z = 1, He = Ne[0]; He >= 10; He /= 10, z++) ;
            he(Re, P + (Re.e = z + K * c - 1) + 1, J, re);
          } else
            Re.e = K, Re.r = +re;
          return Re;
        };
      }();
      function oe(h, m, E, $) {
        var R, P, J, I, U;
        if (E == null ? E = j : v(E, 0, 8), !h.c) return h.toString();
        if (R = h.c[0], J = h.e, m == null)
          U = g(h.c), U = $ == 1 || $ == 2 && (J <= Y || J >= N) ? W(U, J) : Z(U, J, "0");
        else if (h = he(new B(h), m, E), P = h.e, U = g(h.c), I = U.length, $ == 1 || $ == 2 && (m <= P || P <= Y)) {
          for (; I < m; U += "0", I++) ;
          U = W(U, P);
        } else if (m -= J, U = Z(U, P, "0"), P + 1 > I) {
          if (--m > 0) for (U += "."; m--; U += "0") ;
        } else if (m += P - I, m > 0)
          for (P + 1 == I && (U += "."); m--; U += "0") ;
        return h.s < 0 && R ? "-" + U : U;
      }
      function ce(h, m) {
        for (var E, $, R = 1, P = new B(h[0]); R < h.length; R++)
          $ = new B(h[R]), (!$.s || (E = k(P, $)) === m || E === 0 && P.s === m) && (P = $);
        return P;
      }
      function Ce(h, m, E) {
        for (var $ = 1, R = m.length; !m[--R]; m.pop()) ;
        for (R = m[0]; R >= 10; R /= 10, $++) ;
        return (E = $ + E * c - 1) > G ? h.c = h.e = null : E < O ? h.c = [h.e = 0] : (h.e = E, h.c = m), h;
      }
      S = /* @__PURE__ */ function() {
        var h = /^(-?)0([xbo])(?=\w[\w.]*$)/i, m = /^([^.]+)\.$/, E = /^\.([^.]+)$/, $ = /^-?(Infinity|NaN)$/, R = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(P, J, I, U) {
          var K, z = I ? J : J.replace(R, "");
          if ($.test(z))
            P.s = isNaN(z) ? null : z < 0 ? -1 : 1;
          else {
            if (!I && (z = z.replace(h, function(re, le, ee) {
              return K = (ee = ee.toLowerCase()) == "x" ? 16 : ee == "b" ? 2 : 8, !U || U == K ? le : re;
            }), U && (K = U, z = z.replace(m, "$1").replace(E, "0.$1")), J != z))
              return new B(z, K);
            if (B.DEBUG)
              throw Error(i + "Not a" + (U ? " base " + U : "") + " number: " + J);
            P.s = null;
          }
          P.c = P.e = null;
        };
      }();
      function he(h, m, E, $) {
        var R, P, J, I, U, K, z, re = h.c, le = d;
        if (re) {
          e: {
            for (R = 1, I = re[0]; I >= 10; I /= 10, R++) ;
            if (P = m - R, P < 0)
              P += c, J = m, U = re[K = 0], z = o(U / le[R - J - 1] % 10);
            else if (K = a((P + 1) / c), K >= re.length)
              if ($) {
                for (; re.length <= K; re.push(0)) ;
                U = z = 0, R = 1, P %= c, J = P - c + 1;
              } else
                break e;
            else {
              for (U = I = re[K], R = 1; I >= 10; I /= 10, R++) ;
              P %= c, J = P - c + R, z = J < 0 ? 0 : o(U / le[R - J - 1] % 10);
            }
            if ($ = $ || m < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            re[K + 1] != null || (J < 0 ? U : U % le[R - J - 1]), $ = E < 4 ? (z || $) && (E == 0 || E == (h.s < 0 ? 3 : 2)) : z > 5 || z == 5 && (E == 4 || $ || E == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (P > 0 ? J > 0 ? U / le[R - J] : 0 : re[K - 1]) % 10 & 1 || E == (h.s < 0 ? 8 : 7)), m < 1 || !re[0])
              return re.length = 0, $ ? (m -= h.e + 1, re[0] = le[(c - m % c) % c], h.e = -m || 0) : re[0] = h.e = 0, h;
            if (P == 0 ? (re.length = K, I = 1, K--) : (re.length = K + 1, I = le[c - P], re[K] = J > 0 ? o(U / le[R - J] % le[J]) * I : 0), $)
              for (; ; )
                if (K == 0) {
                  for (P = 1, J = re[0]; J >= 10; J /= 10, P++) ;
                  for (J = re[0] += I, I = 1; J >= 10; J /= 10, I++) ;
                  P != I && (h.e++, re[0] == l && (re[0] = 1));
                  break;
                } else {
                  if (re[K] += I, re[K] != l) break;
                  re[K--] = 0, I = 1;
                }
            for (P = re.length; re[--P] === 0; re.pop()) ;
          }
          h.e > G ? h.c = h.e = null : h.e < O && (h.c = [h.e = 0]);
        }
        return h;
      }
      function ge(h) {
        var m, E = h.e;
        return E === null ? h.toString() : (m = g(h.c), m = E <= Y || E >= N ? W(m, E) : Z(m, E, "0"), h.s < 0 ? "-" + m : m);
      }
      return _.absoluteValue = _.abs = function() {
        var h = new B(this);
        return h.s < 0 && (h.s = 1), h;
      }, _.comparedTo = function(h, m) {
        return k(this, new B(h, m));
      }, _.decimalPlaces = _.dp = function(h, m) {
        var E, $, R, P = this;
        if (h != null)
          return v(h, 0, f), m == null ? m = j : v(m, 0, 8), he(new B(P), h + P.e + 1, m);
        if (!(E = P.c)) return null;
        if ($ = ((R = E.length - 1) - b(this.e / c)) * c, R = E[R]) for (; R % 10 == 0; R /= 10, $--) ;
        return $ < 0 && ($ = 0), $;
      }, _.dividedBy = _.div = function(h, m) {
        return H(this, new B(h, m), M, j);
      }, _.dividedToIntegerBy = _.idiv = function(h, m) {
        return H(this, new B(h, m), 0, 1);
      }, _.exponentiatedBy = _.pow = function(h, m) {
        var E, $, R, P, J, I, U, K, z, re = this;
        if (h = new B(h), h.c && !h.isInteger())
          throw Error(i + "Exponent not an integer: " + ge(h));
        if (m != null && (m = new B(m)), I = h.e > 14, !re.c || !re.c[0] || re.c[0] == 1 && !re.e && re.c.length == 1 || !h.c || !h.c[0])
          return z = new B(Math.pow(+ge(re), I ? h.s * (2 - C(h)) : +ge(h))), m ? z.mod(m) : z;
        if (U = h.s < 0, m) {
          if (m.c ? !m.c[0] : !m.s) return new B(NaN);
          $ = !U && re.isInteger() && m.isInteger(), $ && (re = re.mod(m));
        } else {
          if (h.e > 9 && (re.e > 0 || re.e < -1 || (re.e == 0 ? re.c[0] > 1 || I && re.c[1] >= 24e7 : re.c[0] < 8e13 || I && re.c[0] <= 9999975e7)))
            return P = re.s < 0 && C(h) ? -0 : 0, re.e > -1 && (P = 1 / P), new B(U ? 1 / P : P);
          fe && (P = a(fe / c + 2));
        }
        for (I ? (E = new B(0.5), U && (h.s = 1), K = C(h)) : (R = Math.abs(+ge(h)), K = R % 2), z = new B(F); ; ) {
          if (K) {
            if (z = z.times(re), !z.c) break;
            P ? z.c.length > P && (z.c.length = P) : $ && (z = z.mod(m));
          }
          if (R) {
            if (R = o(R / 2), R === 0) break;
            K = R % 2;
          } else if (h = h.times(E), he(h, h.e + 1, 1), h.e > 14)
            K = C(h);
          else {
            if (R = +ge(h), R === 0) break;
            K = R % 2;
          }
          re = re.times(re), P ? re.c && re.c.length > P && (re.c.length = P) : $ && (re = re.mod(m));
        }
        return $ ? z : (U && (z = F.div(z)), m ? z.mod(m) : P ? he(z, fe, j, J) : z);
      }, _.integerValue = function(h) {
        var m = new B(this);
        return h == null ? h = j : v(h, 0, 8), he(m, m.e + 1, h);
      }, _.isEqualTo = _.eq = function(h, m) {
        return k(this, new B(h, m)) === 0;
      }, _.isFinite = function() {
        return !!this.c;
      }, _.isGreaterThan = _.gt = function(h, m) {
        return k(this, new B(h, m)) > 0;
      }, _.isGreaterThanOrEqualTo = _.gte = function(h, m) {
        return (m = k(this, new B(h, m))) === 1 || m === 0;
      }, _.isInteger = function() {
        return !!this.c && b(this.e / c) > this.c.length - 2;
      }, _.isLessThan = _.lt = function(h, m) {
        return k(this, new B(h, m)) < 0;
      }, _.isLessThanOrEqualTo = _.lte = function(h, m) {
        return (m = k(this, new B(h, m))) === -1 || m === 0;
      }, _.isNaN = function() {
        return !this.s;
      }, _.isNegative = function() {
        return this.s < 0;
      }, _.isPositive = function() {
        return this.s > 0;
      }, _.isZero = function() {
        return !!this.c && this.c[0] == 0;
      }, _.minus = function(h, m) {
        var E, $, R, P, J = this, I = J.s;
        if (h = new B(h, m), m = h.s, !I || !m) return new B(NaN);
        if (I != m)
          return h.s = -m, J.plus(h);
        var U = J.e / c, K = h.e / c, z = J.c, re = h.c;
        if (!U || !K) {
          if (!z || !re) return z ? (h.s = -m, h) : new B(re ? J : NaN);
          if (!z[0] || !re[0])
            return re[0] ? (h.s = -m, h) : new B(z[0] ? J : (
              // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
              j == 3 ? -0 : 0
            ));
        }
        if (U = b(U), K = b(K), z = z.slice(), I = U - K) {
          for ((P = I < 0) ? (I = -I, R = z) : (K = U, R = re), R.reverse(), m = I; m--; R.push(0)) ;
          R.reverse();
        } else
          for ($ = (P = (I = z.length) < (m = re.length)) ? I : m, I = m = 0; m < $; m++)
            if (z[m] != re[m]) {
              P = z[m] < re[m];
              break;
            }
        if (P && (R = z, z = re, re = R, h.s = -h.s), m = ($ = re.length) - (E = z.length), m > 0) for (; m--; z[E++] = 0) ;
        for (m = l - 1; $ > I; ) {
          if (z[--$] < re[$]) {
            for (E = $; E && !z[--E]; z[E] = m) ;
            --z[E], z[$] += l;
          }
          z[$] -= re[$];
        }
        for (; z[0] == 0; z.splice(0, 1), --K) ;
        return z[0] ? Ce(h, z, K) : (h.s = j == 3 ? -1 : 1, h.c = [h.e = 0], h);
      }, _.modulo = _.mod = function(h, m) {
        var E, $, R = this;
        return h = new B(h, m), !R.c || !h.s || h.c && !h.c[0] ? new B(NaN) : !h.c || R.c && !R.c[0] ? new B(R) : (ie == 9 ? ($ = h.s, h.s = 1, E = H(R, h, 0, 3), h.s = $, E.s *= $) : E = H(R, h, 0, ie), h = R.minus(E.times(h)), !h.c[0] && ie == 1 && (h.s = R.s), h);
      }, _.multipliedBy = _.times = function(h, m) {
        var E, $, R, P, J, I, U, K, z, re, le, ee, Se, Re, Ne, Ie = this, De = Ie.c, Fe = (h = new B(h, m)).c;
        if (!De || !Fe || !De[0] || !Fe[0])
          return !Ie.s || !h.s || De && !De[0] && !Fe || Fe && !Fe[0] && !De ? h.c = h.e = h.s = null : (h.s *= Ie.s, !De || !Fe ? h.c = h.e = null : (h.c = [0], h.e = 0)), h;
        for ($ = b(Ie.e / c) + b(h.e / c), h.s *= Ie.s, U = De.length, re = Fe.length, U < re && (Se = De, De = Fe, Fe = Se, R = U, U = re, re = R), R = U + re, Se = []; R--; Se.push(0)) ;
        for (Re = l, Ne = w, R = re; --R >= 0; ) {
          for (E = 0, le = Fe[R] % Ne, ee = Fe[R] / Ne | 0, J = U, P = R + J; P > R; )
            K = De[--J] % Ne, z = De[J] / Ne | 0, I = ee * K + z * le, K = le * K + I % Ne * Ne + Se[P] + E, E = (K / Re | 0) + (I / Ne | 0) + ee * z, Se[P--] = K % Re;
          Se[P] = E;
        }
        return E ? ++$ : Se.splice(0, 1), Ce(h, Se, $);
      }, _.negated = function() {
        var h = new B(this);
        return h.s = -h.s || null, h;
      }, _.plus = function(h, m) {
        var E, $ = this, R = $.s;
        if (h = new B(h, m), m = h.s, !R || !m) return new B(NaN);
        if (R != m)
          return h.s = -m, $.minus(h);
        var P = $.e / c, J = h.e / c, I = $.c, U = h.c;
        if (!P || !J) {
          if (!I || !U) return new B(R / 0);
          if (!I[0] || !U[0]) return U[0] ? h : new B(I[0] ? $ : R * 0);
        }
        if (P = b(P), J = b(J), I = I.slice(), R = P - J) {
          for (R > 0 ? (J = P, E = U) : (R = -R, E = I), E.reverse(); R--; E.push(0)) ;
          E.reverse();
        }
        for (R = I.length, m = U.length, R - m < 0 && (E = U, U = I, I = E, m = R), R = 0; m; )
          R = (I[--m] = I[m] + U[m] + R) / l | 0, I[m] = l === I[m] ? 0 : I[m] % l;
        return R && (I = [R].concat(I), ++J), Ce(h, I, J);
      }, _.precision = _.sd = function(h, m) {
        var E, $, R, P = this;
        if (h != null && h !== !!h)
          return v(h, 1, f), m == null ? m = j : v(m, 0, 8), he(new B(P), h, m);
        if (!(E = P.c)) return null;
        if (R = E.length - 1, $ = R * c + 1, R = E[R]) {
          for (; R % 10 == 0; R /= 10, $--) ;
          for (R = E[0]; R >= 10; R /= 10, $++) ;
        }
        return h && P.e + 1 > $ && ($ = P.e + 1), $;
      }, _.shiftedBy = function(h) {
        return v(h, -9007199254740991, u), this.times("1e" + h);
      }, _.squareRoot = _.sqrt = function() {
        var h, m, E, $, R, P = this, J = P.c, I = P.s, U = P.e, K = M + 4, z = new B("0.5");
        if (I !== 1 || !J || !J[0])
          return new B(!I || I < 0 && (!J || J[0]) ? NaN : J ? P : 1 / 0);
        if (I = Math.sqrt(+ge(P)), I == 0 || I == 1 / 0 ? (m = g(J), (m.length + U) % 2 == 0 && (m += "0"), I = Math.sqrt(+m), U = b((U + 1) / 2) - (U < 0 || U % 2), I == 1 / 0 ? m = "5e" + U : (m = I.toExponential(), m = m.slice(0, m.indexOf("e") + 1) + U), E = new B(m)) : E = new B(I + ""), E.c[0]) {
          for (U = E.e, I = U + K, I < 3 && (I = 0); ; )
            if (R = E, E = z.times(R.plus(H(P, R, K, 1))), g(R.c).slice(0, I) === (m = g(E.c)).slice(0, I))
              if (E.e < U && --I, m = m.slice(I - 3, I + 1), m == "9999" || !$ && m == "4999") {
                if (!$ && (he(R, R.e + M + 2, 0), R.times(R).eq(P))) {
                  E = R;
                  break;
                }
                K += 4, I += 4, $ = 1;
              } else {
                (!+m || !+m.slice(1) && m.charAt(0) == "5") && (he(E, E.e + M + 2, 1), h = !E.times(E).eq(P));
                break;
              }
        }
        return he(E, E.e + M + 1, j, h);
      }, _.toExponential = function(h, m) {
        return h != null && (v(h, 0, f), h++), oe(this, h, m, 1);
      }, _.toFixed = function(h, m) {
        return h != null && (v(h, 0, f), h = h + this.e + 1), oe(this, h, m);
      }, _.toFormat = function(h, m, E) {
        var $, R = this;
        if (E == null)
          h != null && m && typeof m == "object" ? (E = m, m = null) : h && typeof h == "object" ? (E = h, h = m = null) : E = pe;
        else if (typeof E != "object")
          throw Error(i + "Argument not an object: " + E);
        if ($ = R.toFixed(h, m), R.c) {
          var P, J = $.split("."), I = +E.groupSize, U = +E.secondaryGroupSize, K = E.groupSeparator || "", z = J[0], re = J[1], le = R.s < 0, ee = le ? z.slice(1) : z, Se = ee.length;
          if (U && (P = I, I = U, U = P, Se -= P), I > 0 && Se > 0) {
            for (P = Se % I || I, z = ee.substr(0, P); P < Se; P += I) z += K + ee.substr(P, I);
            U > 0 && (z += K + ee.slice(P)), le && (z = "-" + z);
          }
          $ = re ? z + (E.decimalSeparator || "") + ((U = +E.fractionGroupSize) ? re.replace(
            new RegExp("\\d{" + U + "}\\B", "g"),
            "$&" + (E.fractionGroupSeparator || "")
          ) : re) : z;
        }
        return (E.prefix || "") + $ + (E.suffix || "");
      }, _.toFraction = function(h) {
        var m, E, $, R, P, J, I, U, K, z, re, le, ee = this, Se = ee.c;
        if (h != null && (I = new B(h), !I.isInteger() && (I.c || I.s !== 1) || I.lt(F)))
          throw Error(i + "Argument " + (I.isInteger() ? "out of range: " : "not an integer: ") + ge(I));
        if (!Se) return new B(ee);
        for (m = new B(F), K = E = new B(F), $ = U = new B(F), le = g(Se), P = m.e = le.length - ee.e - 1, m.c[0] = d[(J = P % c) < 0 ? c + J : J], h = !h || I.comparedTo(m) > 0 ? P > 0 ? m : K : I, J = G, G = 1 / 0, I = new B(le), U.c[0] = 0; z = H(I, m, 0, 1), R = E.plus(z.times($)), R.comparedTo(h) != 1; )
          E = $, $ = R, K = U.plus(z.times(R = K)), U = R, m = I.minus(z.times(R = m)), I = R;
        return R = H(h.minus(E), $, 0, 1), U = U.plus(R.times(K)), E = E.plus(R.times($)), U.s = K.s = ee.s, P = P * 2, re = H(K, $, P, j).minus(ee).abs().comparedTo(
          H(U, E, P, j).minus(ee).abs()
        ) < 1 ? [K, $] : [U, E], G = J, re;
      }, _.toNumber = function() {
        return +ge(this);
      }, _.toPrecision = function(h, m) {
        return h != null && v(h, 1, f), oe(this, h, m, 2);
      }, _.toString = function(h) {
        var m, E = this, $ = E.s, R = E.e;
        return R === null ? $ ? (m = "Infinity", $ < 0 && (m = "-" + m)) : m = "NaN" : (h == null ? m = R <= Y || R >= N ? W(g(E.c), R) : Z(g(E.c), R, "0") : h === 10 && te ? (E = he(new B(E), M + R + 1, j), m = Z(g(E.c), E.e, "0")) : (v(h, 2, ye.length, "Base"), m = y(Z(g(E.c), R, "0"), 10, h, $, !0)), $ < 0 && E.c[0] && (m = "-" + m)), m;
      }, _.valueOf = _.toJSON = function() {
        return ge(this);
      }, _._isBigNumber = !0, D != null && B.set(D), B;
    }
    function b(D) {
      var H = D | 0;
      return D > 0 || D === H ? H : H - 1;
    }
    function g(D) {
      for (var H, y, S = 1, _ = D.length, F = D[0] + ""; S < _; ) {
        for (H = D[S++] + "", y = c - H.length; y--; H = "0" + H) ;
        F += H;
      }
      for (_ = F.length; F.charCodeAt(--_) === 48; ) ;
      return F.slice(0, _ + 1 || 1);
    }
    function k(D, H) {
      var y, S, _ = D.c, F = H.c, M = D.s, j = H.s, Y = D.e, N = H.e;
      if (!M || !j) return null;
      if (y = _ && !_[0], S = F && !F[0], y || S) return y ? S ? 0 : -j : M;
      if (M != j) return M;
      if (y = M < 0, S = Y == N, !_ || !F) return S ? 0 : !_ ^ y ? 1 : -1;
      if (!S) return Y > N ^ y ? 1 : -1;
      for (j = (Y = _.length) < (N = F.length) ? Y : N, M = 0; M < j; M++) if (_[M] != F[M]) return _[M] > F[M] ^ y ? 1 : -1;
      return Y == N ? 0 : Y > N ^ y ? 1 : -1;
    }
    function v(D, H, y, S) {
      if (D < H || D > y || D !== o(D))
        throw Error(i + (S || "Argument") + (typeof D == "number" ? D < H || D > y ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(D));
    }
    function C(D) {
      var H = D.c.length - 1;
      return b(D.e / c) == H && D.c[H] % 2 != 0;
    }
    function W(D, H) {
      return (D.length > 1 ? D.charAt(0) + "." + D.slice(1) : D) + (H < 0 ? "e" : "e+") + H;
    }
    function Z(D, H, y) {
      var S, _;
      if (H < 0) {
        for (_ = y + "."; ++H; _ += y) ;
        D = _ + D;
      } else if (S = D.length, ++H > S) {
        for (_ = y, H -= S; --H; _ += y) ;
        D += _;
      } else H < S && (D = D.slice(0, H) + "." + D.slice(H));
      return D;
    }
    t = A(), t.default = t.BigNumber = t, r.exports ? r.exports = t : (e || (e = typeof self < "u" && self ? self : window), e.BigNumber = t);
  })(q4);
})(C3);
var D3 = C3.exports;
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const xn = dd(), f8 = ld(), p8 = ud, g8 = D3, Ar = {
  trillion: Math.pow(10, 12),
  billion: Math.pow(10, 9),
  million: Math.pow(10, 6),
  thousand: Math.pow(10, 3)
}, dc = {
  totalLength: 0,
  characteristic: 0,
  forceAverage: !1,
  average: !1,
  mantissa: -1,
  optionalMantissa: !0,
  thousandSeparated: !1,
  spaceSeparated: !1,
  negative: "sign",
  forceSign: !1,
  roundingFunction: Math.round,
  spaceSeparatedAbbreviation: !1
}, { binarySuffixes: M3, decimalSuffixes: yl } = xn.currentBytes(), hd = {
  general: { scale: 1024, suffixes: yl },
  binary: { scale: 1024, suffixes: M3 },
  decimal: { scale: 1e3, suffixes: yl }
};
function m8(r, e = {}, t) {
  if (typeof e == "string" && (e = p8.parseFormat(e)), !f8.validateFormat(e))
    return "ERROR: invalid format";
  let n = e.prefix || "", a = e.postfix || "", o = y8(r, e, t);
  return o = B8(o, n), o = L8(o, a), o;
}
function y8(r, e, t) {
  switch (e.output) {
    case "currency":
      return e = Fo(e, xn.currentCurrencyDefaultFormat()), k8(r, e, xn);
    case "percent":
      return e = Fo(e, xn.currentPercentageDefaultFormat()), x8(r, e, xn, t);
    case "byte":
      return e = Fo(e, xn.currentByteDefaultFormat()), b8(r, e, xn, t);
    case "time":
      return e = Fo(e, xn.currentTimeDefaultFormat()), E8(r);
    case "ordinal":
      return e = Fo(e, xn.currentOrdinalDefaultFormat()), S8(r, e, xn);
    case "number":
    default:
      return hc({
        instance: r,
        providedFormat: e
      });
  }
}
function w8(r) {
  let e = hd.decimal;
  return ou(r._value, e.suffixes, e.scale).suffix;
}
function v8(r) {
  let e = hd.binary;
  return ou(r._value, e.suffixes, e.scale).suffix;
}
function _8(r) {
  let e = hd.general;
  return ou(r._value, e.suffixes, e.scale).suffix;
}
function ou(r, e, t) {
  let n = e[0], a = Math.abs(r);
  if (a >= t) {
    for (let o = 1; o < e.length; ++o) {
      let i = Math.pow(t, o), s = Math.pow(t, o + 1);
      if (a >= i && a < s) {
        n = e[o], r = r / i;
        break;
      }
    }
    n === e[0] && (r = r / Math.pow(t, e.length - 1), n = e[e.length - 1]);
  }
  return { value: r, suffix: n };
}
function b8(r, e, t, n) {
  let a = e.base || "binary", o = Object.assign({}, dc, e);
  const { binarySuffixes: i, decimalSuffixes: s } = t.currentBytes();
  let l = {
    general: { scale: 1024, suffixes: s || yl, marker: "bd" },
    binary: { scale: 1024, suffixes: i || M3, marker: "b" },
    decimal: { scale: 1e3, suffixes: s || yl, marker: "d" }
  }[a], { value: c, suffix: u } = ou(r._value, l.suffixes, l.scale);
  return `${hc({
    instance: n(c),
    providedFormat: e,
    state: t,
    defaults: t.currentByteDefaultFormat()
  })}${o.spaceSeparated ? " " : ""}${u}`;
}
function S8(r, e, t) {
  let n = t.currentOrdinal(), a = Object.assign({}, dc, e), o = hc({
    instance: r,
    providedFormat: e,
    state: t
  }), i = n(r._value);
  return `${o}${a.spaceSeparated ? " " : ""}${i}`;
}
function E8(r) {
  let e = Math.floor(r._value / 60 / 60), t = Math.floor((r._value - e * 60 * 60) / 60), n = Math.round(r._value - e * 60 * 60 - t * 60);
  return `${e}:${t < 10 ? "0" : ""}${t}:${n < 10 ? "0" : ""}${n}`;
}
function x8(r, e, t, n) {
  let a = e.prefixSymbol, o = hc({
    instance: n(r._value * 100),
    providedFormat: e,
    state: t
  }), i = Object.assign({}, dc, e);
  return a ? `%${i.spaceSeparated ? " " : ""}${o}` : `${o}${i.spaceSeparated ? " " : ""}%`;
}
function k8(r, e, t) {
  const n = t.currentCurrency();
  let a = Object.assign({}, e), o = Object.assign({}, dc, a), i, s = "", l = !!o.totalLength || !!o.forceAverage || o.average, c = a.currencyPosition || n.position, u = a.currencySymbol || n.symbol;
  const d = o.spaceSeparatedCurrency !== void 0 ? o.spaceSeparatedCurrency : o.spaceSeparated;
  a.lowPrecision === void 0 && (a.lowPrecision = !1), d && (s = " "), c === "infix" && (i = s + u + s);
  let w = hc({
    instance: r,
    providedFormat: a,
    state: t,
    decimalSeparator: i
  });
  return c === "prefix" && (r._value < 0 && o.negative === "sign" ? w = `-${s}${u}${w.slice(1)}` : r._value > 0 && o.forceSign ? w = `+${s}${u}${w.slice(1)}` : w = u + s + w), (!c || c === "postfix") && (s = !o.spaceSeparatedAbbreviation && l ? "" : s, w = w + s + u), w;
}
function A8({ value: r, forceAverage: e, lowPrecision: t = !0, abbreviations: n, spaceSeparated: a = !1, totalLength: o = 0, roundingFunction: i = Math.round }) {
  let s = "", l = Math.abs(r), c = -1;
  if (e && n[e] && Ar[e] ? (s = n[e], r = r / Ar[e]) : l >= Ar.trillion || t && i(l / Ar.trillion) === 1 ? (s = n.trillion, r = r / Ar.trillion) : l < Ar.trillion && l >= Ar.billion || t && i(l / Ar.billion) === 1 ? (s = n.billion, r = r / Ar.billion) : l < Ar.billion && l >= Ar.million || t && i(l / Ar.million) === 1 ? (s = n.million, r = r / Ar.million) : (l < Ar.million && l >= Ar.thousand || t && i(l / Ar.thousand) === 1) && (s = n.thousand, r = r / Ar.thousand), s && (s = (a ? " " : "") + s), o) {
    let u = r < 0, d = r.toString().split(".")[0], w = u ? d.length - 1 : d.length;
    c = Math.max(o - w, 0);
  }
  return { value: r, abbreviation: s, mantissaPrecision: c };
}
function C8({ value: r, characteristicPrecision: e }) {
  let [t, n] = r.toExponential().split("e"), a = +t;
  if (!e)
    return {
      value: a,
      abbreviation: `e${n}`
    };
  let o = 1;
  return o < e && (a = a * Math.pow(10, e - o), n = +n - (e - o), n = n >= 0 ? `+${n}` : n), {
    value: a,
    abbreviation: `e${n}`
  };
}
function kc(r) {
  let e = "";
  for (let t = 0; t < r; t++)
    e += "0";
  return e;
}
function D8(r, e) {
  let t = r.toString(), [n, a] = t.split("e"), [o, i = ""] = n.split(".");
  if (+a > 0)
    t = o + i + kc(a - i.length);
  else {
    let s = ".";
    +o < 0 ? s = `-0${s}` : s = `0${s}`;
    let l = (kc(-a - 1) + Math.abs(o) + i).substr(0, e);
    l.length < e && (l += kc(e - l.length)), t = s + l;
  }
  return +a > 0 && e > 0 && (t += `.${kc(e)}`), t;
}
function M8(r, e, t = Math.round) {
  return r.toString().indexOf("e") !== -1 ? D8(r, e) : new g8(t(+`${r}e+${e}`) / Math.pow(10, e)).toFixed(e);
}
function R8(r, e, t, n, a, o) {
  if (n === -1)
    return r;
  let i = M8(e, n, o), [s, l = ""] = i.toString().split(".");
  if (l.match(/^0+$/) && (t || a))
    return s;
  let c = l.match(/0+$/);
  return a && c ? `${s}.${l.toString().slice(0, c.index)}` : i.toString();
}
function I8(r, e, t, n) {
  let a = r, [o, i] = a.toString().split(".");
  if (o.match(/^-?0$/) && t)
    return i ? `${o.replace("0", "")}.${i}` : o.replace("0", "");
  const s = e < 0 && o.indexOf("-") === 0;
  if (s && (o = o.slice(1), a = a.slice(1)), o.length < n) {
    let l = n - o.length;
    for (let c = 0; c < l; c++)
      a = `0${a}`;
  }
  return s && (a = `-${a}`), a.toString();
}
function T8(r, e) {
  let t = [], n = 0;
  for (let a = r; a > 0; a--)
    n === e && (t.unshift(a), n = 0), n++;
  return t;
}
function O8(r, e, t, n, a) {
  let o = n.currentDelimiters(), i = o.thousands;
  a = a || o.decimal;
  let s = o.thousandsSize || 3, l = r.toString(), c = l.split(".")[0], u = l.split(".")[1];
  const d = e < 0 && c.indexOf("-") === 0;
  return t && (d && (c = c.slice(1)), T8(c.length, s).forEach((w, f) => {
    c = c.slice(0, w + f) + i + c.slice(w + f);
  }), d && (c = `-${c}`)), u ? l = c + a + u : l = c, l;
}
function P8(r, e) {
  return r + e;
}
function N8(r, e, t) {
  return e === 0 ? r : +r == 0 ? r.replace("-", "") : e > 0 ? `+${r}` : t === "sign" ? r : `(${r.replace("-", "")})`;
}
function B8(r, e) {
  return e + r;
}
function L8(r, e) {
  return r + e;
}
function hc({ instance: r, providedFormat: e, state: t = xn, decimalSeparator: n, defaults: a = t.currentDefaults() }) {
  let o = r._value;
  if (o === 0 && t.hasZeroFormat())
    return t.getZeroFormat();
  if (!isFinite(o))
    return o.toString();
  let i = Object.assign({}, dc, a, e), s = i.totalLength, l = s ? 0 : i.characteristic, c = i.optionalCharacteristic, u = i.forceAverage, d = i.lowPrecision, w = !!s || !!u || i.average, f = s ? -1 : w && e.mantissa === void 0 ? 0 : i.mantissa, A = s ? !1 : e.optionalMantissa === void 0 ? f === -1 : i.optionalMantissa, b = i.trimMantissa, g = i.thousandSeparated, k = i.spaceSeparated, v = i.negative, C = i.forceSign, W = i.exponential, Z = i.roundingFunction, D = "";
  if (w) {
    let y = A8({
      value: o,
      forceAverage: u,
      lowPrecision: d,
      abbreviations: t.currentAbbreviations(),
      spaceSeparated: k,
      roundingFunction: Z,
      totalLength: s
    });
    o = y.value, D += y.abbreviation, s && (f = y.mantissaPrecision);
  }
  if (W) {
    let y = C8({
      value: o,
      characteristicPrecision: l
    });
    o = y.value, D = y.abbreviation + D;
  }
  let H = R8(o.toString(), o, A, f, b, Z);
  return H = I8(H, o, c, l), H = O8(H, o, g, t, n), (w || W) && (H = P8(H, D)), (C || o < 0) && (H = N8(H, o, v)), H;
}
function Fo(r, e) {
  if (!r)
    return e;
  let t = Object.keys(r);
  return t.length === 1 && t[0] === "output" ? e : r;
}
var U8 = (r) => ({
  format: (...e) => m8(...e, r),
  getByteUnit: (...e) => _8(...e, r),
  getBinaryByteUnit: (...e) => v8(...e, r),
  getDecimalByteUnit: (...e) => w8(...e, r),
  formatOrDefault: Fo
});
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const sa = D3;
function V8(r, e, t) {
  let n = new sa(r._value), a = e;
  return t.isNumbro(e) && (a = e._value), a = new sa(a), r._value = n.plus(a).toNumber(), r;
}
function R3(r, e, t) {
  let n = new sa(r._value), a = e;
  return t.isNumbro(e) && (a = e._value), a = new sa(a), r._value = n.minus(a).toNumber(), r;
}
function $8(r, e, t) {
  let n = new sa(r._value), a = e;
  return t.isNumbro(e) && (a = e._value), a = new sa(a), r._value = n.times(a).toNumber(), r;
}
function j8(r, e, t) {
  let n = new sa(r._value), a = e;
  return t.isNumbro(e) && (a = e._value), a = new sa(a), r._value = n.dividedBy(a).toNumber(), r;
}
function F8(r, e, t) {
  let n = e;
  return t.isNumbro(e) && (n = e._value), r._value = n, r;
}
function z8(r, e, t) {
  let n = t(r._value);
  return R3(n, e, t), Math.abs(n._value);
}
var H8 = (r) => ({
  add: (e, t) => V8(e, t, r),
  subtract: (e, t) => R3(e, t, r),
  multiply: (e, t) => $8(e, t, r),
  divide: (e, t) => j8(e, t, r),
  set: (e, t) => F8(e, t, r),
  difference: (e, t) => z8(e, t, r),
  BigNumber: sa
});
/*!
 * Copyright (c) 2017 Benjamin Van Ryseghem<benjamin@vanryseghem.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const q8 = "2.5.0", Hn = dd(), W8 = ld(), K8 = h8(ar), Y8 = A3();
let Ka = U8(ar), Ya = H8(ar);
const G8 = ud;
class I3 {
  constructor(e) {
    this._value = e;
  }
  clone() {
    return ar(this._value);
  }
  format(e = {}) {
    return Ka.format(this, e);
  }
  formatCurrency(e) {
    return typeof e == "string" && (e = G8.parseFormat(e)), e = Ka.formatOrDefault(e, Hn.currentCurrencyDefaultFormat()), e.output = "currency", Ka.format(this, e);
  }
  formatTime(e = {}) {
    return e.output = "time", Ka.format(this, e);
  }
  binaryByteUnits() {
    return Ka.getBinaryByteUnit(this);
  }
  decimalByteUnits() {
    return Ka.getDecimalByteUnit(this);
  }
  byteUnits() {
    return Ka.getByteUnit(this);
  }
  difference(e) {
    return Ya.difference(this, e);
  }
  add(e) {
    return Ya.add(this, e);
  }
  subtract(e) {
    return Ya.subtract(this, e);
  }
  multiply(e) {
    return Ya.multiply(this, e);
  }
  divide(e) {
    return Ya.divide(this, e);
  }
  set(e) {
    return Ya.set(this, T3(e));
  }
  value() {
    return this._value;
  }
  valueOf() {
    return this._value;
  }
}
function T3(r) {
  let e = r;
  return ar.isNumbro(r) ? e = r._value : typeof r == "string" ? e = ar.unformat(r) : isNaN(r) && (e = NaN), e;
}
function ar(r) {
  return new I3(T3(r));
}
ar.version = q8;
ar.isNumbro = function(r) {
  return r instanceof I3;
};
ar.language = Hn.currentLanguage;
ar.registerLanguage = Hn.registerLanguage;
ar.setLanguage = Hn.setLanguage;
ar.languages = Hn.languages;
ar.languageData = Hn.languageData;
ar.zeroFormat = Hn.setZeroFormat;
ar.defaultFormat = Hn.currentDefaults;
ar.setDefaults = Hn.setDefaults;
ar.defaultCurrencyFormat = Hn.currentCurrencyDefaultFormat;
ar.validate = W8.validate;
ar.loadLanguagesInNode = K8.loadLanguagesInNode;
ar.unformat = Y8.unformat;
ar.BigNumber = Ya.BigNumber;
var J8 = ar, Nu = /* @__PURE__ */ W4(J8);
function $h(r, e) {
  const t = (e == null ? void 0 : e.decimals) || 2, n = (e == null ? void 0 : e.thousandSeparatedOnly) || !1;
  return r.gte(1) ? r.decimalPlaces(t).gte(new cd(1e6)) && !n ? Nu(r.toString()).format({
    average: !0,
    totalLength: 6,
    trimMantissa: !0
  }) : Nu(r.toString()).format({
    mantissa: t,
    thousandSeparated: !0,
    trimMantissa: !0
  }) : Nu(r.toString()).format({
    mantissa: t,
    trimMantissa: !0
  });
}
function X8({ decimals: r, value: e }) {
  const t = new cd(10).pow(r);
  return e.dividedBy(t);
}
var Z8 = Object.defineProperty, Q8 = (r, e, t) => e in r ? Z8(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, jh = (r, e, t) => Q8(r, typeof e != "symbol" ? e + "" : e, t);
const Fh = 65536;
class e7 {
  constructor() {
    jh(this, "isAvailable", !1), jh(this, "isInstantiated", !1), typeof crypto < "u" && "getRandomValues" in crypto && (this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    const t = new Uint8Array(e);
    for (let n = 0; n < t.length; n += Fh)
      crypto.getRandomValues(t.subarray(n, n + Math.min(t.length - n, Fh)));
    return t;
  }
}
new e7();
function O3(r = "error") {
  const e = (t) => {
    switch (r) {
      case "error":
        return t === "error";
      case "warn":
        return t === "error" || t === "warn";
      case "info":
        return t === "error" || t === "warn" || t === "info";
      case "debug":
        return !0;
      default:
        return !1;
    }
  };
  return {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    debug: (t, ...n) => e("debug") && console.log(`\x1B[34m[DEBUG]\x1B[0m ${t}`, ...n),
    error: (t, ...n) => e("error") && console.log(`\x1B[31m[ERROR]\x1B[0m ${t}`, ...n),
    info: (t, ...n) => e("info") && console.log(`\x1B[37m[INFO]\x1B[0m ${t}`, ...n),
    success: (t, ...n) => e("info") && console.log(`\x1B[32m[SUCCESS]\x1B[0m ${t}`, ...n),
    warn: (t, ...n) => e("warn") && console.log(`\x1B[33m[WARN]\x1B[0m ${t}`, ...n)
    /* eslint-enable @typescript-eslint/no-explicit-any */
  };
}
async function t7({
  debug: r = !1,
  chains: e,
  client: t
}) {
  const n = "createKatavault", a = O3(r ? "debug" : "error");
  let o, i = [];
  for (const s of e)
    try {
      switch (s.namespace) {
        case Ht.Algorand:
        case Ht.AVM:
          o = await s.initialize(), i.push(o);
          break;
        default:
          a.error(`${n}: chain "${s.namespace}" not supported`);
          break;
      }
    } catch (l) {
      a.error(`${n}: failed to add chain "${s.displayName}" - `, l);
    }
  return new UE({
    chains: i,
    clientInformation: {
      hostname: window.location.hostname,
      icon: (t == null ? void 0 : t.icon) || q6() || void 0,
      name: (t == null ? void 0 : t.name) ?? H6()
    },
    debug: r,
    logger: a
  });
}
function Ra(r) {
  return Vr.encode(Q1.decode(r.name.replace(`${t3}_`, "")));
}
const m1 = (r, e) => e.some((t) => r instanceof t);
let zh, Hh;
function r7() {
  return zh || (zh = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function n7() {
  return Hh || (Hh = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const y1 = /* @__PURE__ */ new WeakMap(), Bu = /* @__PURE__ */ new WeakMap(), iu = /* @__PURE__ */ new WeakMap();
function a7(r) {
  const e = new Promise((t, n) => {
    const a = () => {
      r.removeEventListener("success", o), r.removeEventListener("error", i);
    }, o = () => {
      t(ao(r.result)), a();
    }, i = () => {
      n(r.error), a();
    };
    r.addEventListener("success", o), r.addEventListener("error", i);
  });
  return iu.set(e, r), e;
}
function o7(r) {
  if (y1.has(r))
    return;
  const e = new Promise((t, n) => {
    const a = () => {
      r.removeEventListener("complete", o), r.removeEventListener("error", i), r.removeEventListener("abort", i);
    }, o = () => {
      t(), a();
    }, i = () => {
      n(r.error || new DOMException("AbortError", "AbortError")), a();
    };
    r.addEventListener("complete", o), r.addEventListener("error", i), r.addEventListener("abort", i);
  });
  y1.set(r, e);
}
let w1 = {
  get(r, e, t) {
    if (r instanceof IDBTransaction) {
      if (e === "done")
        return y1.get(r);
      if (e === "store")
        return t.objectStoreNames[1] ? void 0 : t.objectStore(t.objectStoreNames[0]);
    }
    return ao(r[e]);
  },
  set(r, e, t) {
    return r[e] = t, !0;
  },
  has(r, e) {
    return r instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in r;
  }
};
function P3(r) {
  w1 = r(w1);
}
function i7(r) {
  return n7().includes(r) ? function(...e) {
    return r.apply(v1(this), e), ao(this.request);
  } : function(...e) {
    return ao(r.apply(v1(this), e));
  };
}
function s7(r) {
  return typeof r == "function" ? i7(r) : (r instanceof IDBTransaction && o7(r), m1(r, r7()) ? new Proxy(r, w1) : r);
}
function ao(r) {
  if (r instanceof IDBRequest)
    return a7(r);
  if (Bu.has(r))
    return Bu.get(r);
  const e = s7(r);
  return e !== r && (Bu.set(r, e), iu.set(e, r)), e;
}
const v1 = (r) => iu.get(r);
function c7(r, e, { blocked: t, upgrade: n, blocking: a, terminated: o } = {}) {
  const i = indexedDB.open(r, e), s = ao(i);
  return n && i.addEventListener("upgradeneeded", (l) => {
    n(ao(i.result), l.oldVersion, l.newVersion, ao(i.transaction), l);
  }), t && i.addEventListener("blocked", (l) => t(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    l.oldVersion,
    l.newVersion,
    l
  )), s.then((l) => {
    o && l.addEventListener("close", () => o()), a && l.addEventListener("versionchange", (c) => a(c.oldVersion, c.newVersion, c));
  }).catch(() => {
  }), s;
}
const l7 = ["get", "getKey", "getAll", "getAllKeys", "count"], u7 = ["put", "add", "delete", "clear"], Lu = /* @__PURE__ */ new Map();
function qh(r, e) {
  if (!(r instanceof IDBDatabase && !(e in r) && typeof e == "string"))
    return;
  if (Lu.get(e))
    return Lu.get(e);
  const t = e.replace(/FromIndex$/, ""), n = e !== t, a = u7.includes(t);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(t in (n ? IDBIndex : IDBObjectStore).prototype) || !(a || l7.includes(t))
  )
    return;
  const o = async function(i, ...s) {
    const l = this.transaction(i, a ? "readwrite" : "readonly");
    let c = l.store;
    return n && (c = c.index(s.shift())), (await Promise.all([
      c[t](...s),
      a && l.done
    ]))[0];
  };
  return Lu.set(e, o), o;
}
P3((r) => ({
  ...r,
  get: (e, t, n) => qh(e, t) || r.get(e, t, n),
  has: (e, t) => !!qh(e, t) || r.has(e, t)
}));
const d7 = ["continue", "continuePrimaryKey", "advance"], Wh = {}, _1 = /* @__PURE__ */ new WeakMap(), N3 = /* @__PURE__ */ new WeakMap(), h7 = {
  get(r, e) {
    if (!d7.includes(e))
      return r[e];
    let t = Wh[e];
    return t || (t = Wh[e] = function(...n) {
      _1.set(this, N3.get(this)[e](...n));
    }), t;
  }
};
async function* f7(...r) {
  let e = this;
  if (e instanceof IDBCursor || (e = await e.openCursor(...r)), !e)
    return;
  e = e;
  const t = new Proxy(e, h7);
  for (N3.set(t, e), iu.set(t, v1(e)); e; )
    yield t, e = await (_1.get(t) || e.continue()), _1.delete(t);
}
function Kh(r, e) {
  return e === Symbol.asyncIterator && m1(r, [IDBIndex, IDBObjectStore, IDBCursor]) || e === "iterate" && m1(r, [IDBIndex, IDBObjectStore]);
}
P3((r) => ({
  ...r,
  get(e, t, n) {
    return Kh(e, t) ? f7 : r.get(e, t, n);
  },
  has(e, t) {
    return Kh(e, t) || r.has(e, t);
  }
}));
function p7(r) {
  return `${t3}_${Q1.encode(Vr.decode(r))}`;
}
async function b1({
  logger: r,
  username: e
}) {
  const t = "initializeVault", n = p7(e);
  return await c7(n, void 0, {
    upgrade: (a, o, i) => {
      o <= 0 && i && i > 0 && (a.createObjectStore(zo), a.createObjectStore(hl), a.createObjectStore(bs), a.createObjectStore(fl), r.debug(`${t}: created new vault "${n}"`));
    }
  });
}
const Jn = class br extends Ql {
  constructor({ hostname: e, username: t, ...n }) {
    super(n), this._keyMaterial = null, this._hostname = e, this._username = t;
  }
  /**
   * private static methods
   */
  /**
   * Generates an encryption key that can be used to decrypt/encrypt bytes. This function imports the key using the
   * input key material from the passkey.
   * @param {GenerateEncryptionKeyFromKeyMaterialParameters} params - The key material and the credential ID.
   * @returns {Promise<CryptoKey>} A promise that resolves to an encryption key that can be used to decrypt/encrypt
   * some bytes.
   * @private
   * @static
   * @async
   */
  static async _generateEncryptionKeyFromInputKeyMaterial({
    credentialID: e,
    keyMaterial: t
  }) {
    const n = await crypto.subtle.importKey(
      "raw",
      t,
      br._derivationKeyAlgorithm,
      !1,
      ["deriveKey"]
    );
    return await crypto.subtle.deriveKey(
      {
        name: br._derivationKeyAlgorithm,
        info: cn.decode(e),
        salt: new Uint8Array(),
        // use an empty salt
        hash: br._derivationKeyHashAlgorithm
      },
      n,
      {
        name: br._encryptionKeyAlgorithm,
        length: br._encryptionKeyBitSize
      },
      !1,
      ["decrypt", "encrypt"]
    );
  }
  /**
   * public static methods
   */
  /**
   * Authenticates with the passkey and fetches the key material that can be used for encryption.
   * @param {AuthenticatePasskeyParameters} params - The passkey credentials and a logger.
   * @returns {Promise<Uint8Array>} A promise that resolves to the key material returned from the authenticator.
   * @throws {FailedToAuthenticatePasskeyError} If the authenticator did not return the public key credentials.
   * @throws {PasskeyNotSupportedError} If the browser does not support WebAuthn or the authenticator does not support.
   * @throws {UserCanceledPasskeyRequestError} If the user canceled the request or the request timed out.
   * the PRF extension.
   * @public
   * @static
   * @async
   */
  static async authenticate({ logger: e, ...t }) {
    var n;
    const a = `${br.displayName}#authenticate`;
    let o, i, s;
    try {
      i = await navigator.credentials.get({
        publicKey: {
          allowCredentials: [
            {
              id: cn.decode(t.credentialID),
              transports: t.transports,
              type: "public-key"
            }
          ],
          challenge: Pa(br._challengeByteSize),
          extensions: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            prf: {
              eval: {
                first: cn.decode(t.salt)
              }
            }
          },
          userVerification: "discouraged"
        }
      });
    } catch (l) {
      throw e.error(`${a}:`, l), l.name === "NotAllowedError" ? new ph("authenticate canceled by user or timed out") : new hh(l.message);
    }
    if (!i)
      throw o = `failed to fetch passkey "${t.credentialID}"`, e.error(`${a}: ${o}`), new hh(o);
    if (s = i.getClientExtensionResults(), !((n = s.prf) != null && n.results))
      throw o = "authenticator does not support the prf extension for webauthn", e.error(`${a}: ${o}`), new bu(o);
    return Su(s.prf.results.first);
  }
  /**
   * Checks if the browser supports public key WebAuthn.
   * @returns {boolean} true of the browser supports public key WebAuthn, false otherwise.
   * @public
   * @static
   */
  static isSupported() {
    return !!(window != null && window.PublicKeyCredential);
  }
  /**
   * Registers a passkey with the authenticator and returns the credentials that are used to fetch the key material to
   * derive an encryption key.
   *
   * NOTE: this requires PRF extension support and will throw an error if the authenticator does not support it.
   *
   * @param {RegisterPasskeyParameters} params - The input parameters.
   * @param {ClientInformation} params.clientInformation - Information about the client.
   * @param {string} params.clientInformation.hostname - The hostname of the client i.e., example.com.
   * @param {string} [params.clientInformation.icon] - An icon URL for the client.
   * @param {string} params.clientInformation.name - A human-readable name for the client.
   * @param {string} params.username - A globally unique identifier for the user. This could be, for example, an email
   * address.
   * @returns {Promise<PasskeyStore>} A promise that resolves to an initialized passkey store.
   * @throws {FailedToRegisterPasskeyError} If the public key credentials failed to be created on the authenticator.
   * @throws {PasskeyNotSupportedError} If the browser does not support WebAuthn or the authenticator does not support.
   * @throws {UserCanceledPasskeyRequestError} If the user canceled the request or the request timed out.
   * the PRF extension.
   * @public
   * @static
   * @async
   */
  static async register({
    clientInformation: e,
    logger: t,
    username: n
  }) {
    var a;
    const o = `${br.displayName}#register`, i = Pa(br._saltByteSize);
    let s, l, c;
    if (!br.isSupported())
      throw new bu("webauthn not supported");
    try {
      l = await navigator.credentials.create({
        publicKey: {
          authenticatorSelection: {
            residentKey: "required",
            // make passkey discoverable on the device
            userVerification: "discouraged"
          },
          challenge: Pa(br._challengeByteSize),
          extensions: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            prf: {
              eval: {
                first: i
              }
            }
          },
          pubKeyCredParams: [
            { alg: -8, type: "public-key" },
            // Ed25519
            { alg: -7, type: "public-key" },
            // ES256
            { alg: -257, type: "public-key" }
            // RS256
          ],
          rp: {
            id: e.hostname,
            name: e.name
          },
          user: {
            id: Vr.decode(F6()),
            name: n,
            displayName: n
          }
        }
      });
    } catch (u) {
      throw t.error(`${o}:`, u), u.name === "NotAllowedError" ? new ph("register canceled by user or timed out") : new fh(u.message);
    }
    if (!l)
      throw s = "failed to register a passkey", t.error(`${o}: ${s}`), new fh(s);
    if (c = l.getClientExtensionResults(), !((a = c.prf) != null && a.enabled))
      throw s = "authenticator does not support the prf extension for webauthn", t.error(`${o}: ${s}`), new bu(s);
    return {
      credentialID: cn.encode(new Uint8Array(l.rawId)),
      initializationVector: cn.encode(Pa(br._initializationVectorByteSize)),
      salt: cn.encode(i),
      transports: l.response.getTransports()
    };
  }
  /**
   * public methods
   */
  /**
   * Decrypts some previously encrypted bytes using the input key material fetched from a passkey.
   * @param {Uint8Array} encryptedBytes - The encrypted bytes.
   * @returns {Promise<Uint8Array>} A promise that resolves to the decrypted bytes.
   * @throws {NotAuthenticatedError} If no passkey credentials are stored.
   * @public
   * @async
   */
  async decryptBytes(e) {
    const t = await this.passkey();
    let n, a;
    if (!this._keyMaterial || !t)
      throw new yr("no passkey credentials stored");
    return n = await br._generateEncryptionKeyFromInputKeyMaterial({
      credentialID: t.credentialID,
      keyMaterial: this._keyMaterial
    }), a = await crypto.subtle.decrypt(
      {
        name: br._encryptionKeyAlgorithm,
        iv: cn.decode(t.initializationVector)
      },
      n,
      e
    ), Su(a);
  }
  /**
   * Decrypts the ephemeral account's key data (private key).
   *
   * @param {EphemeralAccountStoreItem} account - The ephemeral account.
   * @returns {Promise<EphemeralAccountStoreItemWithDecryptedKeyData>} A promise that resolves to the ephemeral account
   * with the key data (private key) decrypted.
   * @throws {AuthenticationMethodNotSupportedError} If the authentication method is not supported.
   * @throws {DecryptionError} If there was an issue with decryption, or if the key was encrypted with the incorrect
   * credentials.
   * @public
   * @async
   */
  async decryptEphemeralAccount(e) {
    const t = `${br.displayName}#decryptEphemeralAccount`, n = gl.fromString(e.credentialID), a = await this.passkey();
    let o;
    if (!a || !n.verify(a.credentialID))
      throw o = `account "${e.key}" found is not encrypted using the supplied passkey`, this._logger.error(`${t}: ${o}`), new vs(o);
    return {
      ...e,
      keyData: await this.decryptBytes(Dn.decode(e.keyData))
    };
  }
  /**
   * Derives a private key from the acquired passkey key material.
   *
   * The derived key **SHOULD** be a valid secp256k1 and ed21559 key.
   *
   * @returns {Promise<Uint8Array>} A promise that resolves to a private key derived from the acquired passkey key
   * material.
   * @throws {NotAuthenticatedError} If no passkey credentials are stored.
   * @public
   * @async
   */
  async derivePrivateKey() {
    if (!this._keyMaterial)
      throw new yr("no passkey credentials stored");
    return x3(this._keyMaterial);
  }
  /**
   * Encrypts some arbitrary bytes using the input key material fetched from a passkey. This function uses the AES-GCM
   * algorithm to encrypt the bytes.
   *
   * @param {Uint8Array} bytes - The bytes to encrypt.
   * @returns {Promise<Uint8Array>} A promise that resolves to the encrypted bytes.
   * @throws {NotAuthenticatedError} If no passkey credentials are stored.
   * @public
   * @async
   */
  async encryptBytes(e) {
    const t = await this.passkey();
    let n, a;
    if (!this._keyMaterial || !t)
      throw new yr("no passkey credentials stored");
    return n = await br._generateEncryptionKeyFromInputKeyMaterial({
      credentialID: t.credentialID,
      keyMaterial: this._keyMaterial
    }), a = await crypto.subtle.encrypt(
      {
        name: br._encryptionKeyAlgorithm,
        iv: cn.decode(t.initializationVector)
      },
      n,
      e
    ), Su(a);
  }
  /**
   * Retrieves the key material associated with the current instance.
   *
   * @return {Uint8Array | null} A Uint8Array containing the key material if it is set, or null if no key material is
   * available.
   * @public
   */
  keyMaterial() {
    return this._keyMaterial;
  }
  /**
   * Gets the passkey.
   *
   * @returns {Promise<PasskeyStoreSchema | null>} A promise that resolves to the passkey or null if no passkey exists.
   * @public
   * @async
   */
  async passkey() {
    const e = this._vault.transaction(hl, "readonly"), t = {
      credentialID: await e.store.get("credentialID"),
      initializationVector: await e.store.get("initializationVector"),
      salt: await e.store.get("salt"),
      transports: await e.store.get("transports")
    };
    return typeof t.credentialID > "u" || typeof t.initializationVector > "u" || typeof t.salt > "u" || typeof t.transports > "u" ? null : t;
  }
  /**
   * Sets the key material from the authenticator used to derive an encryption key.
   *
   * **NOTE:** This does not set the key material to storage, only to runtime memory.
   *
   * @param {string} keyMaterial - The password to set.
   * @public
   */
  setKeyMaterial(e) {
    this._keyMaterial = e;
  }
  /**
   * Saves the passkey credential information returned from an authenticator register function.
   *
   * @param {PasskeyStoreSchema} passkey - The passkey to save.
   * @returns {Promise<PasskeyStoreSchema>} A promise that resolves to the saved passkey.
   * @public
   * @async
   */
  async setPasskey(e) {
    const t = this._vault.transaction(hl, "readwrite"), n = await t.store.get("credentialID") || null, a = await t.store.get("initializationVector") || null, o = await t.store.get("salt") || null, i = await t.store.get("transports") || null;
    return n ? await t.store.put(e.credentialID, "credentialID") : await t.store.add(e.credentialID, "credentialID"), a ? await t.store.put(e.initializationVector, "initializationVector") : await t.store.add(e.initializationVector, "initializationVector"), o ? await t.store.put(e.salt, "salt") : await t.store.add(e.salt, "salt"), i ? await t.store.put(e.transports, "transports") : await t.store.add(e.transports, "transports"), e;
  }
};
Jn._challengeByteSize = 32, Jn._derivationKeyAlgorithm = "HKDF", Jn._derivationKeyHashAlgorithm = "SHA-256", Jn._encryptionKeyAlgorithm = "AES-GCM", Jn._encryptionKeyBitSize = 256, Jn._initializationVectorByteSize = 12, Jn._saltByteSize = 32, Jn.displayName = "PasskeyStore";
let Wo = Jn;
function g7(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Yh = { exports: {} };
const m7 = {}, y7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m7
}, Symbol.toStringTag, { value: "Module" })), w7 = /* @__PURE__ */ W6(y7);
var Gh;
function v7() {
  return Gh || (Gh = 1, function(r) {
    (function(e) {
      var t = function(x) {
        var V, L = new Float64Array(16);
        if (x) for (V = 0; V < x.length; V++) L[V] = x[V];
        return L;
      }, n = function() {
        throw new Error("no PRNG");
      }, a = new Uint8Array(16), o = new Uint8Array(32);
      o[0] = 9;
      var i = t(), s = t([1]), l = t([56129, 1]), c = t([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), u = t([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), d = t([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), w = t([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), f = t([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
      function A(x, V, L, p) {
        x[V] = L >> 24 & 255, x[V + 1] = L >> 16 & 255, x[V + 2] = L >> 8 & 255, x[V + 3] = L & 255, x[V + 4] = p >> 24 & 255, x[V + 5] = p >> 16 & 255, x[V + 6] = p >> 8 & 255, x[V + 7] = p & 255;
      }
      function b(x, V, L, p, q) {
        var ue, de = 0;
        for (ue = 0; ue < q; ue++) de |= x[V + ue] ^ L[p + ue];
        return (1 & de - 1 >>> 8) - 1;
      }
      function g(x, V, L, p) {
        return b(x, V, L, p, 16);
      }
      function k(x, V, L, p) {
        return b(x, V, L, p, 32);
      }
      function v(x, V, L, p) {
        for (var q = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, ue = L[0] & 255 | (L[1] & 255) << 8 | (L[2] & 255) << 16 | (L[3] & 255) << 24, de = L[4] & 255 | (L[5] & 255) << 8 | (L[6] & 255) << 16 | (L[7] & 255) << 24, xe = L[8] & 255 | (L[9] & 255) << 8 | (L[10] & 255) << 16 | (L[11] & 255) << 24, Oe = L[12] & 255 | (L[13] & 255) << 8 | (L[14] & 255) << 16 | (L[15] & 255) << 24, Ge = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, Ve = V[0] & 255 | (V[1] & 255) << 8 | (V[2] & 255) << 16 | (V[3] & 255) << 24, xt = V[4] & 255 | (V[5] & 255) << 8 | (V[6] & 255) << 16 | (V[7] & 255) << 24, X = V[8] & 255 | (V[9] & 255) << 8 | (V[10] & 255) << 16 | (V[11] & 255) << 24, Ee = V[12] & 255 | (V[13] & 255) << 8 | (V[14] & 255) << 16 | (V[15] & 255) << 24, _e = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, je = L[16] & 255 | (L[17] & 255) << 8 | (L[18] & 255) << 16 | (L[19] & 255) << 24, Ze = L[20] & 255 | (L[21] & 255) << 8 | (L[22] & 255) << 16 | (L[23] & 255) << 24, qe = L[24] & 255 | (L[25] & 255) << 8 | (L[26] & 255) << 16 | (L[27] & 255) << 24, at = L[28] & 255 | (L[29] & 255) << 8 | (L[30] & 255) << 16 | (L[31] & 255) << 24, rt = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, Le = q, Qe = ue, Pe = de, Ye = xe, Je = Oe, $e = Ge, me = Ve, we = xt, Me = X, ke = Ee, Ae = _e, Te = je, st = Ze, gt = qe, wt = at, mt = rt, ae, bt = 0; bt < 20; bt += 2)
          ae = Le + st | 0, Je ^= ae << 7 | ae >>> 25, ae = Je + Le | 0, Me ^= ae << 9 | ae >>> 23, ae = Me + Je | 0, st ^= ae << 13 | ae >>> 19, ae = st + Me | 0, Le ^= ae << 18 | ae >>> 14, ae = $e + Qe | 0, ke ^= ae << 7 | ae >>> 25, ae = ke + $e | 0, gt ^= ae << 9 | ae >>> 23, ae = gt + ke | 0, Qe ^= ae << 13 | ae >>> 19, ae = Qe + gt | 0, $e ^= ae << 18 | ae >>> 14, ae = Ae + me | 0, wt ^= ae << 7 | ae >>> 25, ae = wt + Ae | 0, Pe ^= ae << 9 | ae >>> 23, ae = Pe + wt | 0, me ^= ae << 13 | ae >>> 19, ae = me + Pe | 0, Ae ^= ae << 18 | ae >>> 14, ae = mt + Te | 0, Ye ^= ae << 7 | ae >>> 25, ae = Ye + mt | 0, we ^= ae << 9 | ae >>> 23, ae = we + Ye | 0, Te ^= ae << 13 | ae >>> 19, ae = Te + we | 0, mt ^= ae << 18 | ae >>> 14, ae = Le + Ye | 0, Qe ^= ae << 7 | ae >>> 25, ae = Qe + Le | 0, Pe ^= ae << 9 | ae >>> 23, ae = Pe + Qe | 0, Ye ^= ae << 13 | ae >>> 19, ae = Ye + Pe | 0, Le ^= ae << 18 | ae >>> 14, ae = $e + Je | 0, me ^= ae << 7 | ae >>> 25, ae = me + $e | 0, we ^= ae << 9 | ae >>> 23, ae = we + me | 0, Je ^= ae << 13 | ae >>> 19, ae = Je + we | 0, $e ^= ae << 18 | ae >>> 14, ae = Ae + ke | 0, Te ^= ae << 7 | ae >>> 25, ae = Te + Ae | 0, Me ^= ae << 9 | ae >>> 23, ae = Me + Te | 0, ke ^= ae << 13 | ae >>> 19, ae = ke + Me | 0, Ae ^= ae << 18 | ae >>> 14, ae = mt + wt | 0, st ^= ae << 7 | ae >>> 25, ae = st + mt | 0, gt ^= ae << 9 | ae >>> 23, ae = gt + st | 0, wt ^= ae << 13 | ae >>> 19, ae = wt + gt | 0, mt ^= ae << 18 | ae >>> 14;
        Le = Le + q | 0, Qe = Qe + ue | 0, Pe = Pe + de | 0, Ye = Ye + xe | 0, Je = Je + Oe | 0, $e = $e + Ge | 0, me = me + Ve | 0, we = we + xt | 0, Me = Me + X | 0, ke = ke + Ee | 0, Ae = Ae + _e | 0, Te = Te + je | 0, st = st + Ze | 0, gt = gt + qe | 0, wt = wt + at | 0, mt = mt + rt | 0, x[0] = Le >>> 0 & 255, x[1] = Le >>> 8 & 255, x[2] = Le >>> 16 & 255, x[3] = Le >>> 24 & 255, x[4] = Qe >>> 0 & 255, x[5] = Qe >>> 8 & 255, x[6] = Qe >>> 16 & 255, x[7] = Qe >>> 24 & 255, x[8] = Pe >>> 0 & 255, x[9] = Pe >>> 8 & 255, x[10] = Pe >>> 16 & 255, x[11] = Pe >>> 24 & 255, x[12] = Ye >>> 0 & 255, x[13] = Ye >>> 8 & 255, x[14] = Ye >>> 16 & 255, x[15] = Ye >>> 24 & 255, x[16] = Je >>> 0 & 255, x[17] = Je >>> 8 & 255, x[18] = Je >>> 16 & 255, x[19] = Je >>> 24 & 255, x[20] = $e >>> 0 & 255, x[21] = $e >>> 8 & 255, x[22] = $e >>> 16 & 255, x[23] = $e >>> 24 & 255, x[24] = me >>> 0 & 255, x[25] = me >>> 8 & 255, x[26] = me >>> 16 & 255, x[27] = me >>> 24 & 255, x[28] = we >>> 0 & 255, x[29] = we >>> 8 & 255, x[30] = we >>> 16 & 255, x[31] = we >>> 24 & 255, x[32] = Me >>> 0 & 255, x[33] = Me >>> 8 & 255, x[34] = Me >>> 16 & 255, x[35] = Me >>> 24 & 255, x[36] = ke >>> 0 & 255, x[37] = ke >>> 8 & 255, x[38] = ke >>> 16 & 255, x[39] = ke >>> 24 & 255, x[40] = Ae >>> 0 & 255, x[41] = Ae >>> 8 & 255, x[42] = Ae >>> 16 & 255, x[43] = Ae >>> 24 & 255, x[44] = Te >>> 0 & 255, x[45] = Te >>> 8 & 255, x[46] = Te >>> 16 & 255, x[47] = Te >>> 24 & 255, x[48] = st >>> 0 & 255, x[49] = st >>> 8 & 255, x[50] = st >>> 16 & 255, x[51] = st >>> 24 & 255, x[52] = gt >>> 0 & 255, x[53] = gt >>> 8 & 255, x[54] = gt >>> 16 & 255, x[55] = gt >>> 24 & 255, x[56] = wt >>> 0 & 255, x[57] = wt >>> 8 & 255, x[58] = wt >>> 16 & 255, x[59] = wt >>> 24 & 255, x[60] = mt >>> 0 & 255, x[61] = mt >>> 8 & 255, x[62] = mt >>> 16 & 255, x[63] = mt >>> 24 & 255;
      }
      function C(x, V, L, p) {
        for (var q = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, ue = L[0] & 255 | (L[1] & 255) << 8 | (L[2] & 255) << 16 | (L[3] & 255) << 24, de = L[4] & 255 | (L[5] & 255) << 8 | (L[6] & 255) << 16 | (L[7] & 255) << 24, xe = L[8] & 255 | (L[9] & 255) << 8 | (L[10] & 255) << 16 | (L[11] & 255) << 24, Oe = L[12] & 255 | (L[13] & 255) << 8 | (L[14] & 255) << 16 | (L[15] & 255) << 24, Ge = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, Ve = V[0] & 255 | (V[1] & 255) << 8 | (V[2] & 255) << 16 | (V[3] & 255) << 24, xt = V[4] & 255 | (V[5] & 255) << 8 | (V[6] & 255) << 16 | (V[7] & 255) << 24, X = V[8] & 255 | (V[9] & 255) << 8 | (V[10] & 255) << 16 | (V[11] & 255) << 24, Ee = V[12] & 255 | (V[13] & 255) << 8 | (V[14] & 255) << 16 | (V[15] & 255) << 24, _e = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, je = L[16] & 255 | (L[17] & 255) << 8 | (L[18] & 255) << 16 | (L[19] & 255) << 24, Ze = L[20] & 255 | (L[21] & 255) << 8 | (L[22] & 255) << 16 | (L[23] & 255) << 24, qe = L[24] & 255 | (L[25] & 255) << 8 | (L[26] & 255) << 16 | (L[27] & 255) << 24, at = L[28] & 255 | (L[29] & 255) << 8 | (L[30] & 255) << 16 | (L[31] & 255) << 24, rt = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, Le = q, Qe = ue, Pe = de, Ye = xe, Je = Oe, $e = Ge, me = Ve, we = xt, Me = X, ke = Ee, Ae = _e, Te = je, st = Ze, gt = qe, wt = at, mt = rt, ae, bt = 0; bt < 20; bt += 2)
          ae = Le + st | 0, Je ^= ae << 7 | ae >>> 25, ae = Je + Le | 0, Me ^= ae << 9 | ae >>> 23, ae = Me + Je | 0, st ^= ae << 13 | ae >>> 19, ae = st + Me | 0, Le ^= ae << 18 | ae >>> 14, ae = $e + Qe | 0, ke ^= ae << 7 | ae >>> 25, ae = ke + $e | 0, gt ^= ae << 9 | ae >>> 23, ae = gt + ke | 0, Qe ^= ae << 13 | ae >>> 19, ae = Qe + gt | 0, $e ^= ae << 18 | ae >>> 14, ae = Ae + me | 0, wt ^= ae << 7 | ae >>> 25, ae = wt + Ae | 0, Pe ^= ae << 9 | ae >>> 23, ae = Pe + wt | 0, me ^= ae << 13 | ae >>> 19, ae = me + Pe | 0, Ae ^= ae << 18 | ae >>> 14, ae = mt + Te | 0, Ye ^= ae << 7 | ae >>> 25, ae = Ye + mt | 0, we ^= ae << 9 | ae >>> 23, ae = we + Ye | 0, Te ^= ae << 13 | ae >>> 19, ae = Te + we | 0, mt ^= ae << 18 | ae >>> 14, ae = Le + Ye | 0, Qe ^= ae << 7 | ae >>> 25, ae = Qe + Le | 0, Pe ^= ae << 9 | ae >>> 23, ae = Pe + Qe | 0, Ye ^= ae << 13 | ae >>> 19, ae = Ye + Pe | 0, Le ^= ae << 18 | ae >>> 14, ae = $e + Je | 0, me ^= ae << 7 | ae >>> 25, ae = me + $e | 0, we ^= ae << 9 | ae >>> 23, ae = we + me | 0, Je ^= ae << 13 | ae >>> 19, ae = Je + we | 0, $e ^= ae << 18 | ae >>> 14, ae = Ae + ke | 0, Te ^= ae << 7 | ae >>> 25, ae = Te + Ae | 0, Me ^= ae << 9 | ae >>> 23, ae = Me + Te | 0, ke ^= ae << 13 | ae >>> 19, ae = ke + Me | 0, Ae ^= ae << 18 | ae >>> 14, ae = mt + wt | 0, st ^= ae << 7 | ae >>> 25, ae = st + mt | 0, gt ^= ae << 9 | ae >>> 23, ae = gt + st | 0, wt ^= ae << 13 | ae >>> 19, ae = wt + gt | 0, mt ^= ae << 18 | ae >>> 14;
        x[0] = Le >>> 0 & 255, x[1] = Le >>> 8 & 255, x[2] = Le >>> 16 & 255, x[3] = Le >>> 24 & 255, x[4] = $e >>> 0 & 255, x[5] = $e >>> 8 & 255, x[6] = $e >>> 16 & 255, x[7] = $e >>> 24 & 255, x[8] = Ae >>> 0 & 255, x[9] = Ae >>> 8 & 255, x[10] = Ae >>> 16 & 255, x[11] = Ae >>> 24 & 255, x[12] = mt >>> 0 & 255, x[13] = mt >>> 8 & 255, x[14] = mt >>> 16 & 255, x[15] = mt >>> 24 & 255, x[16] = me >>> 0 & 255, x[17] = me >>> 8 & 255, x[18] = me >>> 16 & 255, x[19] = me >>> 24 & 255, x[20] = we >>> 0 & 255, x[21] = we >>> 8 & 255, x[22] = we >>> 16 & 255, x[23] = we >>> 24 & 255, x[24] = Me >>> 0 & 255, x[25] = Me >>> 8 & 255, x[26] = Me >>> 16 & 255, x[27] = Me >>> 24 & 255, x[28] = ke >>> 0 & 255, x[29] = ke >>> 8 & 255, x[30] = ke >>> 16 & 255, x[31] = ke >>> 24 & 255;
      }
      function W(x, V, L, p) {
        v(x, V, L, p);
      }
      function Z(x, V, L, p) {
        C(x, V, L, p);
      }
      var D = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
      function H(x, V, L, p, q, ue, de) {
        var xe = new Uint8Array(16), Oe = new Uint8Array(64), Ge, Ve;
        for (Ve = 0; Ve < 16; Ve++) xe[Ve] = 0;
        for (Ve = 0; Ve < 8; Ve++) xe[Ve] = ue[Ve];
        for (; q >= 64; ) {
          for (W(Oe, xe, de, D), Ve = 0; Ve < 64; Ve++) x[V + Ve] = L[p + Ve] ^ Oe[Ve];
          for (Ge = 1, Ve = 8; Ve < 16; Ve++)
            Ge = Ge + (xe[Ve] & 255) | 0, xe[Ve] = Ge & 255, Ge >>>= 8;
          q -= 64, V += 64, p += 64;
        }
        if (q > 0)
          for (W(Oe, xe, de, D), Ve = 0; Ve < q; Ve++) x[V + Ve] = L[p + Ve] ^ Oe[Ve];
        return 0;
      }
      function y(x, V, L, p, q) {
        var ue = new Uint8Array(16), de = new Uint8Array(64), xe, Oe;
        for (Oe = 0; Oe < 16; Oe++) ue[Oe] = 0;
        for (Oe = 0; Oe < 8; Oe++) ue[Oe] = p[Oe];
        for (; L >= 64; ) {
          for (W(de, ue, q, D), Oe = 0; Oe < 64; Oe++) x[V + Oe] = de[Oe];
          for (xe = 1, Oe = 8; Oe < 16; Oe++)
            xe = xe + (ue[Oe] & 255) | 0, ue[Oe] = xe & 255, xe >>>= 8;
          L -= 64, V += 64;
        }
        if (L > 0)
          for (W(de, ue, q, D), Oe = 0; Oe < L; Oe++) x[V + Oe] = de[Oe];
        return 0;
      }
      function S(x, V, L, p, q) {
        var ue = new Uint8Array(32);
        Z(ue, p, q, D);
        for (var de = new Uint8Array(8), xe = 0; xe < 8; xe++) de[xe] = p[xe + 16];
        return y(x, V, L, de, ue);
      }
      function _(x, V, L, p, q, ue, de) {
        var xe = new Uint8Array(32);
        Z(xe, ue, de, D);
        for (var Oe = new Uint8Array(8), Ge = 0; Ge < 8; Ge++) Oe[Ge] = ue[Ge + 16];
        return H(x, V, L, p, q, Oe, xe);
      }
      var F = function(x) {
        this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
        var V, L, p, q, ue, de, xe, Oe;
        V = x[0] & 255 | (x[1] & 255) << 8, this.r[0] = V & 8191, L = x[2] & 255 | (x[3] & 255) << 8, this.r[1] = (V >>> 13 | L << 3) & 8191, p = x[4] & 255 | (x[5] & 255) << 8, this.r[2] = (L >>> 10 | p << 6) & 7939, q = x[6] & 255 | (x[7] & 255) << 8, this.r[3] = (p >>> 7 | q << 9) & 8191, ue = x[8] & 255 | (x[9] & 255) << 8, this.r[4] = (q >>> 4 | ue << 12) & 255, this.r[5] = ue >>> 1 & 8190, de = x[10] & 255 | (x[11] & 255) << 8, this.r[6] = (ue >>> 14 | de << 2) & 8191, xe = x[12] & 255 | (x[13] & 255) << 8, this.r[7] = (de >>> 11 | xe << 5) & 8065, Oe = x[14] & 255 | (x[15] & 255) << 8, this.r[8] = (xe >>> 8 | Oe << 8) & 8191, this.r[9] = Oe >>> 5 & 127, this.pad[0] = x[16] & 255 | (x[17] & 255) << 8, this.pad[1] = x[18] & 255 | (x[19] & 255) << 8, this.pad[2] = x[20] & 255 | (x[21] & 255) << 8, this.pad[3] = x[22] & 255 | (x[23] & 255) << 8, this.pad[4] = x[24] & 255 | (x[25] & 255) << 8, this.pad[5] = x[26] & 255 | (x[27] & 255) << 8, this.pad[6] = x[28] & 255 | (x[29] & 255) << 8, this.pad[7] = x[30] & 255 | (x[31] & 255) << 8;
      };
      F.prototype.blocks = function(x, V, L) {
        for (var p = this.fin ? 0 : 2048, q, ue, de, xe, Oe, Ge, Ve, xt, X, Ee, _e, je, Ze, qe, at, rt, Le, Qe, Pe, Ye = this.h[0], Je = this.h[1], $e = this.h[2], me = this.h[3], we = this.h[4], Me = this.h[5], ke = this.h[6], Ae = this.h[7], Te = this.h[8], st = this.h[9], gt = this.r[0], wt = this.r[1], mt = this.r[2], ae = this.r[3], bt = this.r[4], Mt = this.r[5], Rt = this.r[6], vt = this.r[7], At = this.r[8], Ct = this.r[9]; L >= 16; )
          q = x[V + 0] & 255 | (x[V + 1] & 255) << 8, Ye += q & 8191, ue = x[V + 2] & 255 | (x[V + 3] & 255) << 8, Je += (q >>> 13 | ue << 3) & 8191, de = x[V + 4] & 255 | (x[V + 5] & 255) << 8, $e += (ue >>> 10 | de << 6) & 8191, xe = x[V + 6] & 255 | (x[V + 7] & 255) << 8, me += (de >>> 7 | xe << 9) & 8191, Oe = x[V + 8] & 255 | (x[V + 9] & 255) << 8, we += (xe >>> 4 | Oe << 12) & 8191, Me += Oe >>> 1 & 8191, Ge = x[V + 10] & 255 | (x[V + 11] & 255) << 8, ke += (Oe >>> 14 | Ge << 2) & 8191, Ve = x[V + 12] & 255 | (x[V + 13] & 255) << 8, Ae += (Ge >>> 11 | Ve << 5) & 8191, xt = x[V + 14] & 255 | (x[V + 15] & 255) << 8, Te += (Ve >>> 8 | xt << 8) & 8191, st += xt >>> 5 | p, X = 0, Ee = X, Ee += Ye * gt, Ee += Je * (5 * Ct), Ee += $e * (5 * At), Ee += me * (5 * vt), Ee += we * (5 * Rt), X = Ee >>> 13, Ee &= 8191, Ee += Me * (5 * Mt), Ee += ke * (5 * bt), Ee += Ae * (5 * ae), Ee += Te * (5 * mt), Ee += st * (5 * wt), X += Ee >>> 13, Ee &= 8191, _e = X, _e += Ye * wt, _e += Je * gt, _e += $e * (5 * Ct), _e += me * (5 * At), _e += we * (5 * vt), X = _e >>> 13, _e &= 8191, _e += Me * (5 * Rt), _e += ke * (5 * Mt), _e += Ae * (5 * bt), _e += Te * (5 * ae), _e += st * (5 * mt), X += _e >>> 13, _e &= 8191, je = X, je += Ye * mt, je += Je * wt, je += $e * gt, je += me * (5 * Ct), je += we * (5 * At), X = je >>> 13, je &= 8191, je += Me * (5 * vt), je += ke * (5 * Rt), je += Ae * (5 * Mt), je += Te * (5 * bt), je += st * (5 * ae), X += je >>> 13, je &= 8191, Ze = X, Ze += Ye * ae, Ze += Je * mt, Ze += $e * wt, Ze += me * gt, Ze += we * (5 * Ct), X = Ze >>> 13, Ze &= 8191, Ze += Me * (5 * At), Ze += ke * (5 * vt), Ze += Ae * (5 * Rt), Ze += Te * (5 * Mt), Ze += st * (5 * bt), X += Ze >>> 13, Ze &= 8191, qe = X, qe += Ye * bt, qe += Je * ae, qe += $e * mt, qe += me * wt, qe += we * gt, X = qe >>> 13, qe &= 8191, qe += Me * (5 * Ct), qe += ke * (5 * At), qe += Ae * (5 * vt), qe += Te * (5 * Rt), qe += st * (5 * Mt), X += qe >>> 13, qe &= 8191, at = X, at += Ye * Mt, at += Je * bt, at += $e * ae, at += me * mt, at += we * wt, X = at >>> 13, at &= 8191, at += Me * gt, at += ke * (5 * Ct), at += Ae * (5 * At), at += Te * (5 * vt), at += st * (5 * Rt), X += at >>> 13, at &= 8191, rt = X, rt += Ye * Rt, rt += Je * Mt, rt += $e * bt, rt += me * ae, rt += we * mt, X = rt >>> 13, rt &= 8191, rt += Me * wt, rt += ke * gt, rt += Ae * (5 * Ct), rt += Te * (5 * At), rt += st * (5 * vt), X += rt >>> 13, rt &= 8191, Le = X, Le += Ye * vt, Le += Je * Rt, Le += $e * Mt, Le += me * bt, Le += we * ae, X = Le >>> 13, Le &= 8191, Le += Me * mt, Le += ke * wt, Le += Ae * gt, Le += Te * (5 * Ct), Le += st * (5 * At), X += Le >>> 13, Le &= 8191, Qe = X, Qe += Ye * At, Qe += Je * vt, Qe += $e * Rt, Qe += me * Mt, Qe += we * bt, X = Qe >>> 13, Qe &= 8191, Qe += Me * ae, Qe += ke * mt, Qe += Ae * wt, Qe += Te * gt, Qe += st * (5 * Ct), X += Qe >>> 13, Qe &= 8191, Pe = X, Pe += Ye * Ct, Pe += Je * At, Pe += $e * vt, Pe += me * Rt, Pe += we * Mt, X = Pe >>> 13, Pe &= 8191, Pe += Me * bt, Pe += ke * ae, Pe += Ae * mt, Pe += Te * wt, Pe += st * gt, X += Pe >>> 13, Pe &= 8191, X = (X << 2) + X | 0, X = X + Ee | 0, Ee = X & 8191, X = X >>> 13, _e += X, Ye = Ee, Je = _e, $e = je, me = Ze, we = qe, Me = at, ke = rt, Ae = Le, Te = Qe, st = Pe, V += 16, L -= 16;
        this.h[0] = Ye, this.h[1] = Je, this.h[2] = $e, this.h[3] = me, this.h[4] = we, this.h[5] = Me, this.h[6] = ke, this.h[7] = Ae, this.h[8] = Te, this.h[9] = st;
      }, F.prototype.finish = function(x, V) {
        var L = new Uint16Array(10), p, q, ue, de;
        if (this.leftover) {
          for (de = this.leftover, this.buffer[de++] = 1; de < 16; de++) this.buffer[de] = 0;
          this.fin = 1, this.blocks(this.buffer, 0, 16);
        }
        for (p = this.h[1] >>> 13, this.h[1] &= 8191, de = 2; de < 10; de++)
          this.h[de] += p, p = this.h[de] >>> 13, this.h[de] &= 8191;
        for (this.h[0] += p * 5, p = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += p, p = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += p, L[0] = this.h[0] + 5, p = L[0] >>> 13, L[0] &= 8191, de = 1; de < 10; de++)
          L[de] = this.h[de] + p, p = L[de] >>> 13, L[de] &= 8191;
        for (L[9] -= 8192, q = (p ^ 1) - 1, de = 0; de < 10; de++) L[de] &= q;
        for (q = ~q, de = 0; de < 10; de++) this.h[de] = this.h[de] & q | L[de];
        for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, ue = this.h[0] + this.pad[0], this.h[0] = ue & 65535, de = 1; de < 8; de++)
          ue = (this.h[de] + this.pad[de] | 0) + (ue >>> 16) | 0, this.h[de] = ue & 65535;
        x[V + 0] = this.h[0] >>> 0 & 255, x[V + 1] = this.h[0] >>> 8 & 255, x[V + 2] = this.h[1] >>> 0 & 255, x[V + 3] = this.h[1] >>> 8 & 255, x[V + 4] = this.h[2] >>> 0 & 255, x[V + 5] = this.h[2] >>> 8 & 255, x[V + 6] = this.h[3] >>> 0 & 255, x[V + 7] = this.h[3] >>> 8 & 255, x[V + 8] = this.h[4] >>> 0 & 255, x[V + 9] = this.h[4] >>> 8 & 255, x[V + 10] = this.h[5] >>> 0 & 255, x[V + 11] = this.h[5] >>> 8 & 255, x[V + 12] = this.h[6] >>> 0 & 255, x[V + 13] = this.h[6] >>> 8 & 255, x[V + 14] = this.h[7] >>> 0 & 255, x[V + 15] = this.h[7] >>> 8 & 255;
      }, F.prototype.update = function(x, V, L) {
        var p, q;
        if (this.leftover) {
          for (q = 16 - this.leftover, q > L && (q = L), p = 0; p < q; p++)
            this.buffer[this.leftover + p] = x[V + p];
          if (L -= q, V += q, this.leftover += q, this.leftover < 16)
            return;
          this.blocks(this.buffer, 0, 16), this.leftover = 0;
        }
        if (L >= 16 && (q = L - L % 16, this.blocks(x, V, q), V += q, L -= q), L) {
          for (p = 0; p < L; p++)
            this.buffer[this.leftover + p] = x[V + p];
          this.leftover += L;
        }
      };
      function M(x, V, L, p, q, ue) {
        var de = new F(ue);
        return de.update(L, p, q), de.finish(x, V), 0;
      }
      function j(x, V, L, p, q, ue) {
        var de = new Uint8Array(16);
        return M(de, 0, L, p, q, ue), g(x, V, de, 0);
      }
      function Y(x, V, L, p, q) {
        var ue;
        if (L < 32) return -1;
        for (_(x, 0, V, 0, L, p, q), M(x, 16, x, 32, L - 32, x), ue = 0; ue < 16; ue++) x[ue] = 0;
        return 0;
      }
      function N(x, V, L, p, q) {
        var ue, de = new Uint8Array(32);
        if (L < 32 || (S(de, 0, 32, p, q), j(V, 16, V, 32, L - 32, de) !== 0)) return -1;
        for (_(x, 0, V, 0, L, p, q), ue = 0; ue < 32; ue++) x[ue] = 0;
        return 0;
      }
      function O(x, V) {
        var L;
        for (L = 0; L < 16; L++) x[L] = V[L] | 0;
      }
      function G(x) {
        var V, L, p = 1;
        for (V = 0; V < 16; V++)
          L = x[V] + p + 65535, p = Math.floor(L / 65536), x[V] = L - p * 65536;
        x[0] += p - 1 + 37 * (p - 1);
      }
      function Q(x, V, L) {
        for (var p, q = ~(L - 1), ue = 0; ue < 16; ue++)
          p = q & (x[ue] ^ V[ue]), x[ue] ^= p, V[ue] ^= p;
      }
      function ie(x, V) {
        var L, p, q, ue = t(), de = t();
        for (L = 0; L < 16; L++) de[L] = V[L];
        for (G(de), G(de), G(de), p = 0; p < 2; p++) {
          for (ue[0] = de[0] - 65517, L = 1; L < 15; L++)
            ue[L] = de[L] - 65535 - (ue[L - 1] >> 16 & 1), ue[L - 1] &= 65535;
          ue[15] = de[15] - 32767 - (ue[14] >> 16 & 1), q = ue[15] >> 16 & 1, ue[14] &= 65535, Q(de, ue, 1 - q);
        }
        for (L = 0; L < 16; L++)
          x[2 * L] = de[L] & 255, x[2 * L + 1] = de[L] >> 8;
      }
      function fe(x, V) {
        var L = new Uint8Array(32), p = new Uint8Array(32);
        return ie(L, x), ie(p, V), k(L, 0, p, 0);
      }
      function pe(x) {
        var V = new Uint8Array(32);
        return ie(V, x), V[0] & 1;
      }
      function ye(x, V) {
        var L;
        for (L = 0; L < 16; L++) x[L] = V[2 * L] + (V[2 * L + 1] << 8);
        x[15] &= 32767;
      }
      function te(x, V, L) {
        for (var p = 0; p < 16; p++) x[p] = V[p] + L[p];
      }
      function B(x, V, L) {
        for (var p = 0; p < 16; p++) x[p] = V[p] - L[p];
      }
      function oe(x, V, L) {
        var p, q, ue = 0, de = 0, xe = 0, Oe = 0, Ge = 0, Ve = 0, xt = 0, X = 0, Ee = 0, _e = 0, je = 0, Ze = 0, qe = 0, at = 0, rt = 0, Le = 0, Qe = 0, Pe = 0, Ye = 0, Je = 0, $e = 0, me = 0, we = 0, Me = 0, ke = 0, Ae = 0, Te = 0, st = 0, gt = 0, wt = 0, mt = 0, ae = L[0], bt = L[1], Mt = L[2], Rt = L[3], vt = L[4], At = L[5], Ct = L[6], or = L[7], Lt = L[8], Qt = L[9], er = L[10], tr = L[11], gr = L[12], Rr = L[13], Ir = L[14], Tr = L[15];
        p = V[0], ue += p * ae, de += p * bt, xe += p * Mt, Oe += p * Rt, Ge += p * vt, Ve += p * At, xt += p * Ct, X += p * or, Ee += p * Lt, _e += p * Qt, je += p * er, Ze += p * tr, qe += p * gr, at += p * Rr, rt += p * Ir, Le += p * Tr, p = V[1], de += p * ae, xe += p * bt, Oe += p * Mt, Ge += p * Rt, Ve += p * vt, xt += p * At, X += p * Ct, Ee += p * or, _e += p * Lt, je += p * Qt, Ze += p * er, qe += p * tr, at += p * gr, rt += p * Rr, Le += p * Ir, Qe += p * Tr, p = V[2], xe += p * ae, Oe += p * bt, Ge += p * Mt, Ve += p * Rt, xt += p * vt, X += p * At, Ee += p * Ct, _e += p * or, je += p * Lt, Ze += p * Qt, qe += p * er, at += p * tr, rt += p * gr, Le += p * Rr, Qe += p * Ir, Pe += p * Tr, p = V[3], Oe += p * ae, Ge += p * bt, Ve += p * Mt, xt += p * Rt, X += p * vt, Ee += p * At, _e += p * Ct, je += p * or, Ze += p * Lt, qe += p * Qt, at += p * er, rt += p * tr, Le += p * gr, Qe += p * Rr, Pe += p * Ir, Ye += p * Tr, p = V[4], Ge += p * ae, Ve += p * bt, xt += p * Mt, X += p * Rt, Ee += p * vt, _e += p * At, je += p * Ct, Ze += p * or, qe += p * Lt, at += p * Qt, rt += p * er, Le += p * tr, Qe += p * gr, Pe += p * Rr, Ye += p * Ir, Je += p * Tr, p = V[5], Ve += p * ae, xt += p * bt, X += p * Mt, Ee += p * Rt, _e += p * vt, je += p * At, Ze += p * Ct, qe += p * or, at += p * Lt, rt += p * Qt, Le += p * er, Qe += p * tr, Pe += p * gr, Ye += p * Rr, Je += p * Ir, $e += p * Tr, p = V[6], xt += p * ae, X += p * bt, Ee += p * Mt, _e += p * Rt, je += p * vt, Ze += p * At, qe += p * Ct, at += p * or, rt += p * Lt, Le += p * Qt, Qe += p * er, Pe += p * tr, Ye += p * gr, Je += p * Rr, $e += p * Ir, me += p * Tr, p = V[7], X += p * ae, Ee += p * bt, _e += p * Mt, je += p * Rt, Ze += p * vt, qe += p * At, at += p * Ct, rt += p * or, Le += p * Lt, Qe += p * Qt, Pe += p * er, Ye += p * tr, Je += p * gr, $e += p * Rr, me += p * Ir, we += p * Tr, p = V[8], Ee += p * ae, _e += p * bt, je += p * Mt, Ze += p * Rt, qe += p * vt, at += p * At, rt += p * Ct, Le += p * or, Qe += p * Lt, Pe += p * Qt, Ye += p * er, Je += p * tr, $e += p * gr, me += p * Rr, we += p * Ir, Me += p * Tr, p = V[9], _e += p * ae, je += p * bt, Ze += p * Mt, qe += p * Rt, at += p * vt, rt += p * At, Le += p * Ct, Qe += p * or, Pe += p * Lt, Ye += p * Qt, Je += p * er, $e += p * tr, me += p * gr, we += p * Rr, Me += p * Ir, ke += p * Tr, p = V[10], je += p * ae, Ze += p * bt, qe += p * Mt, at += p * Rt, rt += p * vt, Le += p * At, Qe += p * Ct, Pe += p * or, Ye += p * Lt, Je += p * Qt, $e += p * er, me += p * tr, we += p * gr, Me += p * Rr, ke += p * Ir, Ae += p * Tr, p = V[11], Ze += p * ae, qe += p * bt, at += p * Mt, rt += p * Rt, Le += p * vt, Qe += p * At, Pe += p * Ct, Ye += p * or, Je += p * Lt, $e += p * Qt, me += p * er, we += p * tr, Me += p * gr, ke += p * Rr, Ae += p * Ir, Te += p * Tr, p = V[12], qe += p * ae, at += p * bt, rt += p * Mt, Le += p * Rt, Qe += p * vt, Pe += p * At, Ye += p * Ct, Je += p * or, $e += p * Lt, me += p * Qt, we += p * er, Me += p * tr, ke += p * gr, Ae += p * Rr, Te += p * Ir, st += p * Tr, p = V[13], at += p * ae, rt += p * bt, Le += p * Mt, Qe += p * Rt, Pe += p * vt, Ye += p * At, Je += p * Ct, $e += p * or, me += p * Lt, we += p * Qt, Me += p * er, ke += p * tr, Ae += p * gr, Te += p * Rr, st += p * Ir, gt += p * Tr, p = V[14], rt += p * ae, Le += p * bt, Qe += p * Mt, Pe += p * Rt, Ye += p * vt, Je += p * At, $e += p * Ct, me += p * or, we += p * Lt, Me += p * Qt, ke += p * er, Ae += p * tr, Te += p * gr, st += p * Rr, gt += p * Ir, wt += p * Tr, p = V[15], Le += p * ae, Qe += p * bt, Pe += p * Mt, Ye += p * Rt, Je += p * vt, $e += p * At, me += p * Ct, we += p * or, Me += p * Lt, ke += p * Qt, Ae += p * er, Te += p * tr, st += p * gr, gt += p * Rr, wt += p * Ir, mt += p * Tr, ue += 38 * Qe, de += 38 * Pe, xe += 38 * Ye, Oe += 38 * Je, Ge += 38 * $e, Ve += 38 * me, xt += 38 * we, X += 38 * Me, Ee += 38 * ke, _e += 38 * Ae, je += 38 * Te, Ze += 38 * st, qe += 38 * gt, at += 38 * wt, rt += 38 * mt, q = 1, p = ue + q + 65535, q = Math.floor(p / 65536), ue = p - q * 65536, p = de + q + 65535, q = Math.floor(p / 65536), de = p - q * 65536, p = xe + q + 65535, q = Math.floor(p / 65536), xe = p - q * 65536, p = Oe + q + 65535, q = Math.floor(p / 65536), Oe = p - q * 65536, p = Ge + q + 65535, q = Math.floor(p / 65536), Ge = p - q * 65536, p = Ve + q + 65535, q = Math.floor(p / 65536), Ve = p - q * 65536, p = xt + q + 65535, q = Math.floor(p / 65536), xt = p - q * 65536, p = X + q + 65535, q = Math.floor(p / 65536), X = p - q * 65536, p = Ee + q + 65535, q = Math.floor(p / 65536), Ee = p - q * 65536, p = _e + q + 65535, q = Math.floor(p / 65536), _e = p - q * 65536, p = je + q + 65535, q = Math.floor(p / 65536), je = p - q * 65536, p = Ze + q + 65535, q = Math.floor(p / 65536), Ze = p - q * 65536, p = qe + q + 65535, q = Math.floor(p / 65536), qe = p - q * 65536, p = at + q + 65535, q = Math.floor(p / 65536), at = p - q * 65536, p = rt + q + 65535, q = Math.floor(p / 65536), rt = p - q * 65536, p = Le + q + 65535, q = Math.floor(p / 65536), Le = p - q * 65536, ue += q - 1 + 37 * (q - 1), q = 1, p = ue + q + 65535, q = Math.floor(p / 65536), ue = p - q * 65536, p = de + q + 65535, q = Math.floor(p / 65536), de = p - q * 65536, p = xe + q + 65535, q = Math.floor(p / 65536), xe = p - q * 65536, p = Oe + q + 65535, q = Math.floor(p / 65536), Oe = p - q * 65536, p = Ge + q + 65535, q = Math.floor(p / 65536), Ge = p - q * 65536, p = Ve + q + 65535, q = Math.floor(p / 65536), Ve = p - q * 65536, p = xt + q + 65535, q = Math.floor(p / 65536), xt = p - q * 65536, p = X + q + 65535, q = Math.floor(p / 65536), X = p - q * 65536, p = Ee + q + 65535, q = Math.floor(p / 65536), Ee = p - q * 65536, p = _e + q + 65535, q = Math.floor(p / 65536), _e = p - q * 65536, p = je + q + 65535, q = Math.floor(p / 65536), je = p - q * 65536, p = Ze + q + 65535, q = Math.floor(p / 65536), Ze = p - q * 65536, p = qe + q + 65535, q = Math.floor(p / 65536), qe = p - q * 65536, p = at + q + 65535, q = Math.floor(p / 65536), at = p - q * 65536, p = rt + q + 65535, q = Math.floor(p / 65536), rt = p - q * 65536, p = Le + q + 65535, q = Math.floor(p / 65536), Le = p - q * 65536, ue += q - 1 + 37 * (q - 1), x[0] = ue, x[1] = de, x[2] = xe, x[3] = Oe, x[4] = Ge, x[5] = Ve, x[6] = xt, x[7] = X, x[8] = Ee, x[9] = _e, x[10] = je, x[11] = Ze, x[12] = qe, x[13] = at, x[14] = rt, x[15] = Le;
      }
      function ce(x, V) {
        oe(x, V, V);
      }
      function Ce(x, V) {
        var L = t(), p;
        for (p = 0; p < 16; p++) L[p] = V[p];
        for (p = 253; p >= 0; p--)
          ce(L, L), p !== 2 && p !== 4 && oe(L, L, V);
        for (p = 0; p < 16; p++) x[p] = L[p];
      }
      function he(x, V) {
        var L = t(), p;
        for (p = 0; p < 16; p++) L[p] = V[p];
        for (p = 250; p >= 0; p--)
          ce(L, L), p !== 1 && oe(L, L, V);
        for (p = 0; p < 16; p++) x[p] = L[p];
      }
      function ge(x, V, L) {
        var p = new Uint8Array(32), q = new Float64Array(80), ue, de, xe = t(), Oe = t(), Ge = t(), Ve = t(), xt = t(), X = t();
        for (de = 0; de < 31; de++) p[de] = V[de];
        for (p[31] = V[31] & 127 | 64, p[0] &= 248, ye(q, L), de = 0; de < 16; de++)
          Oe[de] = q[de], Ve[de] = xe[de] = Ge[de] = 0;
        for (xe[0] = Ve[0] = 1, de = 254; de >= 0; --de)
          ue = p[de >>> 3] >>> (de & 7) & 1, Q(xe, Oe, ue), Q(Ge, Ve, ue), te(xt, xe, Ge), B(xe, xe, Ge), te(Ge, Oe, Ve), B(Oe, Oe, Ve), ce(Ve, xt), ce(X, xe), oe(xe, Ge, xe), oe(Ge, Oe, xt), te(xt, xe, Ge), B(xe, xe, Ge), ce(Oe, xe), B(Ge, Ve, X), oe(xe, Ge, l), te(xe, xe, Ve), oe(Ge, Ge, xe), oe(xe, Ve, X), oe(Ve, Oe, q), ce(Oe, xt), Q(xe, Oe, ue), Q(Ge, Ve, ue);
        for (de = 0; de < 16; de++)
          q[de + 16] = xe[de], q[de + 32] = Ge[de], q[de + 48] = Oe[de], q[de + 64] = Ve[de];
        var Ee = q.subarray(32), _e = q.subarray(16);
        return Ce(Ee, Ee), oe(_e, _e, Ee), ie(x, _e), 0;
      }
      function h(x, V) {
        return ge(x, V, o);
      }
      function m(x, V) {
        return n(V, 32), h(x, V);
      }
      function E(x, V, L) {
        var p = new Uint8Array(32);
        return ge(p, L, V), Z(x, a, p, D);
      }
      var $ = Y, R = N;
      function P(x, V, L, p, q, ue) {
        var de = new Uint8Array(32);
        return E(de, q, ue), $(x, V, L, p, de);
      }
      function J(x, V, L, p, q, ue) {
        var de = new Uint8Array(32);
        return E(de, q, ue), R(x, V, L, p, de);
      }
      var I = [
        1116352408,
        3609767458,
        1899447441,
        602891725,
        3049323471,
        3964484399,
        3921009573,
        2173295548,
        961987163,
        4081628472,
        1508970993,
        3053834265,
        2453635748,
        2937671579,
        2870763221,
        3664609560,
        3624381080,
        2734883394,
        310598401,
        1164996542,
        607225278,
        1323610764,
        1426881987,
        3590304994,
        1925078388,
        4068182383,
        2162078206,
        991336113,
        2614888103,
        633803317,
        3248222580,
        3479774868,
        3835390401,
        2666613458,
        4022224774,
        944711139,
        264347078,
        2341262773,
        604807628,
        2007800933,
        770255983,
        1495990901,
        1249150122,
        1856431235,
        1555081692,
        3175218132,
        1996064986,
        2198950837,
        2554220882,
        3999719339,
        2821834349,
        766784016,
        2952996808,
        2566594879,
        3210313671,
        3203337956,
        3336571891,
        1034457026,
        3584528711,
        2466948901,
        113926993,
        3758326383,
        338241895,
        168717936,
        666307205,
        1188179964,
        773529912,
        1546045734,
        1294757372,
        1522805485,
        1396182291,
        2643833823,
        1695183700,
        2343527390,
        1986661051,
        1014477480,
        2177026350,
        1206759142,
        2456956037,
        344077627,
        2730485921,
        1290863460,
        2820302411,
        3158454273,
        3259730800,
        3505952657,
        3345764771,
        106217008,
        3516065817,
        3606008344,
        3600352804,
        1432725776,
        4094571909,
        1467031594,
        275423344,
        851169720,
        430227734,
        3100823752,
        506948616,
        1363258195,
        659060556,
        3750685593,
        883997877,
        3785050280,
        958139571,
        3318307427,
        1322822218,
        3812723403,
        1537002063,
        2003034995,
        1747873779,
        3602036899,
        1955562222,
        1575990012,
        2024104815,
        1125592928,
        2227730452,
        2716904306,
        2361852424,
        442776044,
        2428436474,
        593698344,
        2756734187,
        3733110249,
        3204031479,
        2999351573,
        3329325298,
        3815920427,
        3391569614,
        3928383900,
        3515267271,
        566280711,
        3940187606,
        3454069534,
        4118630271,
        4000239992,
        116418474,
        1914138554,
        174292421,
        2731055270,
        289380356,
        3203993006,
        460393269,
        320620315,
        685471733,
        587496836,
        852142971,
        1086792851,
        1017036298,
        365543100,
        1126000580,
        2618297676,
        1288033470,
        3409855158,
        1501505948,
        4234509866,
        1607167915,
        987167468,
        1816402316,
        1246189591
      ];
      function U(x, V, L, p) {
        for (var q = new Int32Array(16), ue = new Int32Array(16), de, xe, Oe, Ge, Ve, xt, X, Ee, _e, je, Ze, qe, at, rt, Le, Qe, Pe, Ye, Je, $e, me, we, Me, ke, Ae, Te, st = x[0], gt = x[1], wt = x[2], mt = x[3], ae = x[4], bt = x[5], Mt = x[6], Rt = x[7], vt = V[0], At = V[1], Ct = V[2], or = V[3], Lt = V[4], Qt = V[5], er = V[6], tr = V[7], gr = 0; p >= 128; ) {
          for (Je = 0; Je < 16; Je++)
            $e = 8 * Je + gr, q[Je] = L[$e + 0] << 24 | L[$e + 1] << 16 | L[$e + 2] << 8 | L[$e + 3], ue[Je] = L[$e + 4] << 24 | L[$e + 5] << 16 | L[$e + 6] << 8 | L[$e + 7];
          for (Je = 0; Je < 80; Je++)
            if (de = st, xe = gt, Oe = wt, Ge = mt, Ve = ae, xt = bt, X = Mt, Ee = Rt, _e = vt, je = At, Ze = Ct, qe = or, at = Lt, rt = Qt, Le = er, Qe = tr, me = Rt, we = tr, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = (ae >>> 14 | Lt << 18) ^ (ae >>> 18 | Lt << 14) ^ (Lt >>> 9 | ae << 23), we = (Lt >>> 14 | ae << 18) ^ (Lt >>> 18 | ae << 14) ^ (ae >>> 9 | Lt << 23), Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, me = ae & bt ^ ~ae & Mt, we = Lt & Qt ^ ~Lt & er, Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, me = I[Je * 2], we = I[Je * 2 + 1], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, me = q[Je % 16], we = ue[Je % 16], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, Pe = Ae & 65535 | Te << 16, Ye = Me & 65535 | ke << 16, me = Pe, we = Ye, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = (st >>> 28 | vt << 4) ^ (vt >>> 2 | st << 30) ^ (vt >>> 7 | st << 25), we = (vt >>> 28 | st << 4) ^ (st >>> 2 | vt << 30) ^ (st >>> 7 | vt << 25), Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, me = st & gt ^ st & wt ^ gt & wt, we = vt & At ^ vt & Ct ^ At & Ct, Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, Ee = Ae & 65535 | Te << 16, Qe = Me & 65535 | ke << 16, me = Ge, we = qe, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = Pe, we = Ye, Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, Ge = Ae & 65535 | Te << 16, qe = Me & 65535 | ke << 16, gt = de, wt = xe, mt = Oe, ae = Ge, bt = Ve, Mt = xt, Rt = X, st = Ee, At = _e, Ct = je, or = Ze, Lt = qe, Qt = at, er = rt, tr = Le, vt = Qe, Je % 16 === 15)
              for ($e = 0; $e < 16; $e++)
                me = q[$e], we = ue[$e], Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = q[($e + 9) % 16], we = ue[($e + 9) % 16], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, Pe = q[($e + 1) % 16], Ye = ue[($e + 1) % 16], me = (Pe >>> 1 | Ye << 31) ^ (Pe >>> 8 | Ye << 24) ^ Pe >>> 7, we = (Ye >>> 1 | Pe << 31) ^ (Ye >>> 8 | Pe << 24) ^ (Ye >>> 7 | Pe << 25), Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, Pe = q[($e + 14) % 16], Ye = ue[($e + 14) % 16], me = (Pe >>> 19 | Ye << 13) ^ (Ye >>> 29 | Pe << 3) ^ Pe >>> 6, we = (Ye >>> 19 | Pe << 13) ^ (Pe >>> 29 | Ye << 3) ^ (Ye >>> 6 | Pe << 26), Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, q[$e] = Ae & 65535 | Te << 16, ue[$e] = Me & 65535 | ke << 16;
          me = st, we = vt, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[0], we = V[0], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[0] = st = Ae & 65535 | Te << 16, V[0] = vt = Me & 65535 | ke << 16, me = gt, we = At, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[1], we = V[1], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[1] = gt = Ae & 65535 | Te << 16, V[1] = At = Me & 65535 | ke << 16, me = wt, we = Ct, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[2], we = V[2], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[2] = wt = Ae & 65535 | Te << 16, V[2] = Ct = Me & 65535 | ke << 16, me = mt, we = or, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[3], we = V[3], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[3] = mt = Ae & 65535 | Te << 16, V[3] = or = Me & 65535 | ke << 16, me = ae, we = Lt, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[4], we = V[4], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[4] = ae = Ae & 65535 | Te << 16, V[4] = Lt = Me & 65535 | ke << 16, me = bt, we = Qt, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[5], we = V[5], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[5] = bt = Ae & 65535 | Te << 16, V[5] = Qt = Me & 65535 | ke << 16, me = Mt, we = er, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[6], we = V[6], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[6] = Mt = Ae & 65535 | Te << 16, V[6] = er = Me & 65535 | ke << 16, me = Rt, we = tr, Me = we & 65535, ke = we >>> 16, Ae = me & 65535, Te = me >>> 16, me = x[7], we = V[7], Me += we & 65535, ke += we >>> 16, Ae += me & 65535, Te += me >>> 16, ke += Me >>> 16, Ae += ke >>> 16, Te += Ae >>> 16, x[7] = Rt = Ae & 65535 | Te << 16, V[7] = tr = Me & 65535 | ke << 16, gr += 128, p -= 128;
        }
        return p;
      }
      function K(x, V, L) {
        var p = new Int32Array(8), q = new Int32Array(8), ue = new Uint8Array(256), de, xe = L;
        for (p[0] = 1779033703, p[1] = 3144134277, p[2] = 1013904242, p[3] = 2773480762, p[4] = 1359893119, p[5] = 2600822924, p[6] = 528734635, p[7] = 1541459225, q[0] = 4089235720, q[1] = 2227873595, q[2] = 4271175723, q[3] = 1595750129, q[4] = 2917565137, q[5] = 725511199, q[6] = 4215389547, q[7] = 327033209, U(p, q, V, L), L %= 128, de = 0; de < L; de++) ue[de] = V[xe - L + de];
        for (ue[L] = 128, L = 256 - 128 * (L < 112 ? 1 : 0), ue[L - 9] = 0, A(ue, L - 8, xe / 536870912 | 0, xe << 3), U(p, q, ue, L), de = 0; de < 8; de++) A(x, 8 * de, p[de], q[de]);
        return 0;
      }
      function z(x, V) {
        var L = t(), p = t(), q = t(), ue = t(), de = t(), xe = t(), Oe = t(), Ge = t(), Ve = t();
        B(L, x[1], x[0]), B(Ve, V[1], V[0]), oe(L, L, Ve), te(p, x[0], x[1]), te(Ve, V[0], V[1]), oe(p, p, Ve), oe(q, x[3], V[3]), oe(q, q, u), oe(ue, x[2], V[2]), te(ue, ue, ue), B(de, p, L), B(xe, ue, q), te(Oe, ue, q), te(Ge, p, L), oe(x[0], de, xe), oe(x[1], Ge, Oe), oe(x[2], Oe, xe), oe(x[3], de, Ge);
      }
      function re(x, V, L) {
        var p;
        for (p = 0; p < 4; p++)
          Q(x[p], V[p], L);
      }
      function le(x, V) {
        var L = t(), p = t(), q = t();
        Ce(q, V[2]), oe(L, V[0], q), oe(p, V[1], q), ie(x, p), x[31] ^= pe(L) << 7;
      }
      function ee(x, V, L) {
        var p, q;
        for (O(x[0], i), O(x[1], s), O(x[2], s), O(x[3], i), q = 255; q >= 0; --q)
          p = L[q / 8 | 0] >> (q & 7) & 1, re(x, V, p), z(V, x), z(x, x), re(x, V, p);
      }
      function Se(x, V) {
        var L = [t(), t(), t(), t()];
        O(L[0], d), O(L[1], w), O(L[2], s), oe(L[3], d, w), ee(x, L, V);
      }
      function Re(x, V, L) {
        var p = new Uint8Array(64), q = [t(), t(), t(), t()], ue;
        for (L || n(V, 32), K(p, V, 32), p[0] &= 248, p[31] &= 127, p[31] |= 64, Se(q, p), le(x, q), ue = 0; ue < 32; ue++) V[ue + 32] = x[ue];
        return 0;
      }
      var Ne = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
      function Ie(x, V) {
        var L, p, q, ue;
        for (p = 63; p >= 32; --p) {
          for (L = 0, q = p - 32, ue = p - 12; q < ue; ++q)
            V[q] += L - 16 * V[p] * Ne[q - (p - 32)], L = Math.floor((V[q] + 128) / 256), V[q] -= L * 256;
          V[q] += L, V[p] = 0;
        }
        for (L = 0, q = 0; q < 32; q++)
          V[q] += L - (V[31] >> 4) * Ne[q], L = V[q] >> 8, V[q] &= 255;
        for (q = 0; q < 32; q++) V[q] -= L * Ne[q];
        for (p = 0; p < 32; p++)
          V[p + 1] += V[p] >> 8, x[p] = V[p] & 255;
      }
      function De(x) {
        var V = new Float64Array(64), L;
        for (L = 0; L < 64; L++) V[L] = x[L];
        for (L = 0; L < 64; L++) x[L] = 0;
        Ie(x, V);
      }
      function Fe(x, V, L, p) {
        var q = new Uint8Array(64), ue = new Uint8Array(64), de = new Uint8Array(64), xe, Oe, Ge = new Float64Array(64), Ve = [t(), t(), t(), t()];
        K(q, p, 32), q[0] &= 248, q[31] &= 127, q[31] |= 64;
        var xt = L + 64;
        for (xe = 0; xe < L; xe++) x[64 + xe] = V[xe];
        for (xe = 0; xe < 32; xe++) x[32 + xe] = q[32 + xe];
        for (K(de, x.subarray(32), L + 32), De(de), Se(Ve, de), le(x, Ve), xe = 32; xe < 64; xe++) x[xe] = p[xe];
        for (K(ue, x, L + 64), De(ue), xe = 0; xe < 64; xe++) Ge[xe] = 0;
        for (xe = 0; xe < 32; xe++) Ge[xe] = de[xe];
        for (xe = 0; xe < 32; xe++)
          for (Oe = 0; Oe < 32; Oe++)
            Ge[xe + Oe] += ue[xe] * q[Oe];
        return Ie(x.subarray(32), Ge), xt;
      }
      function lt(x, V) {
        var L = t(), p = t(), q = t(), ue = t(), de = t(), xe = t(), Oe = t();
        return O(x[2], s), ye(x[1], V), ce(q, x[1]), oe(ue, q, c), B(q, q, x[2]), te(ue, x[2], ue), ce(de, ue), ce(xe, de), oe(Oe, xe, de), oe(L, Oe, q), oe(L, L, ue), he(L, L), oe(L, L, q), oe(L, L, ue), oe(L, L, ue), oe(x[0], L, ue), ce(p, x[0]), oe(p, p, ue), fe(p, q) && oe(x[0], x[0], f), ce(p, x[0]), oe(p, p, ue), fe(p, q) ? -1 : (pe(x[0]) === V[31] >> 7 && B(x[0], i, x[0]), oe(x[3], x[0], x[1]), 0);
      }
      function ft(x, V, L, p) {
        var q, ue = new Uint8Array(32), de = new Uint8Array(64), xe = [t(), t(), t(), t()], Oe = [t(), t(), t(), t()];
        if (L < 64 || lt(Oe, p)) return -1;
        for (q = 0; q < L; q++) x[q] = V[q];
        for (q = 0; q < 32; q++) x[q + 32] = p[q];
        if (K(de, x, L), De(de), ee(xe, Oe, de), Se(Oe, V.subarray(32)), z(xe, Oe), le(ue, xe), L -= 64, k(V, 0, ue, 0)) {
          for (q = 0; q < L; q++) x[q] = 0;
          return -1;
        }
        for (q = 0; q < L; q++) x[q] = V[q + 64];
        return L;
      }
      var it = 32, Ue = 24, nt = 32, He = 16, ze = 32, Be = 32, Pt = 32, kt = 32, It = 32, sr = Ue, Kt = nt, pr = He, wn = 64, Ft = 32, Xr = 64, Hi = 32, Do = 64;
      e.lowlevel = {
        crypto_core_hsalsa20: Z,
        crypto_stream_xor: _,
        crypto_stream: S,
        crypto_stream_salsa20_xor: H,
        crypto_stream_salsa20: y,
        crypto_onetimeauth: M,
        crypto_onetimeauth_verify: j,
        crypto_verify_16: g,
        crypto_verify_32: k,
        crypto_secretbox: Y,
        crypto_secretbox_open: N,
        crypto_scalarmult: ge,
        crypto_scalarmult_base: h,
        crypto_box_beforenm: E,
        crypto_box_afternm: $,
        crypto_box: P,
        crypto_box_open: J,
        crypto_box_keypair: m,
        crypto_hash: K,
        crypto_sign: Fe,
        crypto_sign_keypair: Re,
        crypto_sign_open: ft,
        crypto_secretbox_KEYBYTES: it,
        crypto_secretbox_NONCEBYTES: Ue,
        crypto_secretbox_ZEROBYTES: nt,
        crypto_secretbox_BOXZEROBYTES: He,
        crypto_scalarmult_BYTES: ze,
        crypto_scalarmult_SCALARBYTES: Be,
        crypto_box_PUBLICKEYBYTES: Pt,
        crypto_box_SECRETKEYBYTES: kt,
        crypto_box_BEFORENMBYTES: It,
        crypto_box_NONCEBYTES: sr,
        crypto_box_ZEROBYTES: Kt,
        crypto_box_BOXZEROBYTES: pr,
        crypto_sign_BYTES: wn,
        crypto_sign_PUBLICKEYBYTES: Ft,
        crypto_sign_SECRETKEYBYTES: Xr,
        crypto_sign_SEEDBYTES: Hi,
        crypto_hash_BYTES: Do,
        gf: t,
        D: c,
        L: Ne,
        pack25519: ie,
        unpack25519: ye,
        M: oe,
        A: te,
        S: ce,
        Z: B,
        pow2523: he,
        add: z,
        set25519: O,
        modL: Ie,
        scalarmult: ee,
        scalarbase: Se
      };
      function Mo(x, V) {
        if (x.length !== it) throw new Error("bad key size");
        if (V.length !== Ue) throw new Error("bad nonce size");
      }
      function mc(x, V) {
        if (x.length !== Pt) throw new Error("bad public key size");
        if (V.length !== kt) throw new Error("bad secret key size");
      }
      function Mr() {
        for (var x = 0; x < arguments.length; x++)
          if (!(arguments[x] instanceof Uint8Array))
            throw new TypeError("unexpected type, use Uint8Array");
      }
      function yc(x) {
        for (var V = 0; V < x.length; V++) x[V] = 0;
      }
      e.randomBytes = function(x) {
        var V = new Uint8Array(x);
        return n(V, x), V;
      }, e.secretbox = function(x, V, L) {
        Mr(x, V, L), Mo(L, V);
        for (var p = new Uint8Array(nt + x.length), q = new Uint8Array(p.length), ue = 0; ue < x.length; ue++) p[ue + nt] = x[ue];
        return Y(q, p, p.length, V, L), q.subarray(He);
      }, e.secretbox.open = function(x, V, L) {
        Mr(x, V, L), Mo(L, V);
        for (var p = new Uint8Array(He + x.length), q = new Uint8Array(p.length), ue = 0; ue < x.length; ue++) p[ue + He] = x[ue];
        return p.length < 32 || N(q, p, p.length, V, L) !== 0 ? null : q.subarray(nt);
      }, e.secretbox.keyLength = it, e.secretbox.nonceLength = Ue, e.secretbox.overheadLength = He, e.scalarMult = function(x, V) {
        if (Mr(x, V), x.length !== Be) throw new Error("bad n size");
        if (V.length !== ze) throw new Error("bad p size");
        var L = new Uint8Array(ze);
        return ge(L, x, V), L;
      }, e.scalarMult.base = function(x) {
        if (Mr(x), x.length !== Be) throw new Error("bad n size");
        var V = new Uint8Array(ze);
        return h(V, x), V;
      }, e.scalarMult.scalarLength = Be, e.scalarMult.groupElementLength = ze, e.box = function(x, V, L, p) {
        var q = e.box.before(L, p);
        return e.secretbox(x, V, q);
      }, e.box.before = function(x, V) {
        Mr(x, V), mc(x, V);
        var L = new Uint8Array(It);
        return E(L, x, V), L;
      }, e.box.after = e.secretbox, e.box.open = function(x, V, L, p) {
        var q = e.box.before(L, p);
        return e.secretbox.open(x, V, q);
      }, e.box.open.after = e.secretbox.open, e.box.keyPair = function() {
        var x = new Uint8Array(Pt), V = new Uint8Array(kt);
        return m(x, V), { publicKey: x, secretKey: V };
      }, e.box.keyPair.fromSecretKey = function(x) {
        if (Mr(x), x.length !== kt)
          throw new Error("bad secret key size");
        var V = new Uint8Array(Pt);
        return h(V, x), { publicKey: V, secretKey: new Uint8Array(x) };
      }, e.box.publicKeyLength = Pt, e.box.secretKeyLength = kt, e.box.sharedKeyLength = It, e.box.nonceLength = sr, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function(x, V) {
        if (Mr(x, V), V.length !== Xr)
          throw new Error("bad secret key size");
        var L = new Uint8Array(wn + x.length);
        return Fe(L, x, x.length, V), L;
      }, e.sign.open = function(x, V) {
        if (Mr(x, V), V.length !== Ft)
          throw new Error("bad public key size");
        var L = new Uint8Array(x.length), p = ft(L, x, x.length, V);
        if (p < 0) return null;
        for (var q = new Uint8Array(p), ue = 0; ue < q.length; ue++) q[ue] = L[ue];
        return q;
      }, e.sign.detached = function(x, V) {
        for (var L = e.sign(x, V), p = new Uint8Array(wn), q = 0; q < p.length; q++) p[q] = L[q];
        return p;
      }, e.sign.detached.verify = function(x, V, L) {
        if (Mr(x, V, L), V.length !== wn)
          throw new Error("bad signature size");
        if (L.length !== Ft)
          throw new Error("bad public key size");
        var p = new Uint8Array(wn + x.length), q = new Uint8Array(wn + x.length), ue;
        for (ue = 0; ue < wn; ue++) p[ue] = V[ue];
        for (ue = 0; ue < x.length; ue++) p[ue + wn] = x[ue];
        return ft(q, p, p.length, L) >= 0;
      }, e.sign.keyPair = function() {
        var x = new Uint8Array(Ft), V = new Uint8Array(Xr);
        return Re(x, V), { publicKey: x, secretKey: V };
      }, e.sign.keyPair.fromSecretKey = function(x) {
        if (Mr(x), x.length !== Xr)
          throw new Error("bad secret key size");
        for (var V = new Uint8Array(Ft), L = 0; L < V.length; L++) V[L] = x[32 + L];
        return { publicKey: V, secretKey: new Uint8Array(x) };
      }, e.sign.keyPair.fromSeed = function(x) {
        if (Mr(x), x.length !== Hi)
          throw new Error("bad seed size");
        for (var V = new Uint8Array(Ft), L = new Uint8Array(Xr), p = 0; p < 32; p++) L[p] = x[p];
        return Re(V, L, !0), { publicKey: V, secretKey: L };
      }, e.sign.publicKeyLength = Ft, e.sign.secretKeyLength = Xr, e.sign.seedLength = Hi, e.sign.signatureLength = wn, e.hash = function(x) {
        Mr(x);
        var V = new Uint8Array(Do);
        return K(V, x, x.length), V;
      }, e.hash.hashLength = Do, e.verify = function(x, V) {
        return Mr(x, V), x.length === 0 || V.length === 0 || x.length !== V.length ? !1 : b(x, 0, V, 0, x.length) === 0;
      }, e.setPRNG = function(x) {
        n = x;
      }, function() {
        var x = typeof self < "u" ? self.crypto || self.msCrypto : null;
        if (x && x.getRandomValues) {
          var V = 65536;
          e.setPRNG(function(L, p) {
            var q, ue = new Uint8Array(p);
            for (q = 0; q < p; q += V)
              x.getRandomValues(ue.subarray(q, q + Math.min(p - q, V)));
            for (q = 0; q < p; q++) L[q] = ue[q];
            yc(ue);
          });
        } else typeof g7 < "u" && (x = w7, x && x.randomBytes && e.setPRNG(function(L, p) {
          var q, ue = x.randomBytes(p);
          for (q = 0; q < p; q++) L[q] = ue[q];
          yc(ue);
        }));
      }();
    })(r.exports ? r.exports : self.nacl = self.nacl || {});
  }(Yh)), Yh.exports;
}
var Sn = v7();
const Ui = /* @__PURE__ */ Bi(Sn), rl = class Xn extends Ql {
  constructor({ hostname: e, username: t, ...n }) {
    super(n), this._password = null, this._hostname = e, this._username = t;
  }
  /**
   * public methods
   */
  /**
   * Gets the encrypted challenge encoded with base64.
   * @returns {Promise<string | null>} A promise that resolves to the encrypted challenge with base64 encoding or null
   * if no challenge exists.
   * @private
   */
  async challenge() {
    const e = await this._vault.transaction(bs, "readonly").store.get("challenge");
    return typeof e > "u" ? null : e;
  }
  /**
   * Decrypts some previously encrypted bytes using the password.
   * @param {Uint8Array} bytes - The encrypted bytes.
   * @returns {Promise<Uint8Array>} A promise that resolves to the decrypted bytes.
   * @throws {NotAuthenticatedError} If the password has not been set.
   * @throws {DecryptionError} If the supplied bytes are malformed, or there was a problem deriving a key from the
   * password.
   * @public
   */
  async decryptBytes(e) {
    const t = `${Xn.displayName}#decryptBytes`, [n, a, o] = [
      e.slice(0, Sn.secretbox.nonceLength),
      e.slice(Sn.secretbox.nonceLength, Sn.secretbox.nonceLength + Xn._saltByteSize),
      e.slice(Sn.secretbox.nonceLength + Xn._saltByteSize)
    ];
    let i, s, l;
    if (!this._password)
      throw new yr("no password found");
    if (!n || n.byteLength !== Sn.secretbox.nonceLength)
      throw new vs("invalid nonce");
    if (!a || a.byteLength !== Xn._saltByteSize)
      throw new vs("invalid salt");
    if (s = await Eu({
      keyLength: Sn.secretbox.keyLength,
      salt: a,
      secret: Vr.decode(this._password)
    }), l = Sn.secretbox.open(o, n, s), !l)
      throw i = "failed to decrypt bytes using password", this._logger.debug(`${t}: ${i}`), new vs(i);
    return l;
  }
  /**
   * Decrypts the ephemeral account's key data (private key).
   *
   * @param {EphemeralAccountStoreItem} account - The ephemeral account.
   * @returns {Promise<EphemeralAccountStoreItemWithDecryptedKeyData>} A promise that resolves to the ephemeral account
   * with the key data (private key) decrypted.
   * @throws {AuthenticationMethodNotSupportedError} If the authentication method is not supported.
   * @throws {DecryptionError} If there was an issue with decryption, or if the key was encrypted with the incorrect
   * credentials.
   * @private
   */
  async decryptEphemeralAccount(e) {
    const t = `${Xn.displayName}#decryptEphemeralAccount`, n = gl.fromString(e.credentialID), a = this.password();
    let o;
    if (!a || !n.verify(a))
      throw o = `account "${e.key}" found is not encrypted using the supplied password`, this._logger.debug(`${t}: ${o}`), new vs(o);
    return {
      ...e,
      keyData: await this.decryptBytes(Dn.decode(e.keyData))
    };
  }
  /**
   * Derives a private key from the provided password credentials.
   *
   * The key is derived using the scrypt key derivation function:
   * * salt = SHA512(hostname + username)
   * * secret = SHA512(username + password)
   *
   * The derived key **SHOULD** be a valid secp256k1 and ed21559 key.
   *
   * @returns {Promise<Uint8Array>} A promise that resolves to a private key derived from the password credentials.
   * @throws {NotAuthenticatedError} If no password is stored.
   * @public
   * @async
   */
  async derivePrivateKey() {
    let e;
    if (!this._password)
      throw new yr("no password found");
    return e = await Eu({
      keyLength: Q2,
      salt: Ms(Ds(Vr.decode(this._hostname), Vr.decode(this._username))),
      secret: Ds(Vr.decode(this._username), Vr.decode(this._password))
      // this is hashed in the function
    }), x3(e);
  }
  /**
   * Encrypts some arbitrary bytes using the password. This function uses the xsalsa20-poly1305
   * algorithm to encrypt the bytes.
   * @param {Uint8Array} bytes - The bytes to encrypt.
   * @returns {Promise<Uint8Array>} A promise that resolves to the encrypted bytes.
   * @throws {NotAuthenticatedError} If the password has not been set.
   * @throws {EncryptionError} If the bytes were failed to be encrypted.
   * @public
   */
  async encryptBytes(e) {
    const t = `${Xn.displayName}#encryptBytes`;
    let n, a, o, i, s;
    if (!this._password)
      throw new yr("no password found");
    s = Pa(Xn._saltByteSize), a = await Eu({
      keyLength: Sn.secretbox.keyLength,
      salt: s,
      secret: Vr.decode(this._password)
    }), o = Pa(Sn.secretbox.nonceLength);
    try {
      n = Sn.secretbox(e, o, a);
    } catch (l) {
      throw this._logger.error(`${t}:`, l), new C6(l.message);
    }
    return i = new Uint8Array(o.length + s.length + n.length), i.set(o, 0), i.set(s, o.length), i.set(new Uint8Array(n), o.length + s.length), i;
  }
  /**
   * Retrieves the stored password.
   * @return {string | null} The current password if available, otherwise null.
   * @public
   */
  password() {
    return this._password;
  }
  /**
   * Sets an encrypted challenge with base64 encoding.
   * @param {string} value - An encrypted challenge with base64 encoding.
   * @returns {string} The encrypted challenge with base64 encoding.
   * @public
   */
  async setChallenge(e) {
    const t = this._vault.transaction(bs, "readwrite");
    return await t.store.get("challenge") ? await t.store.put(e, "challenge") : await t.store.add(e, "challenge"), e;
  }
  /**
   * Sets the last used at timestamp. If the parameter is omitted, the current Unix timestamp, in milliseconds, is used.
   * @param {string} value - [optional] A Unix timestamp, in milliseconds. Defaults to the current Unix timestamp.
   * @returns {string} The last used at timestamp in milliseconds.
   * @public
   */
  async setLastUsedAt(e) {
    const t = this._vault.transaction(bs, "readwrite"), n = await t.store.get("lastUsedAt") || null, a = e ?? Date.now().toString();
    return n ? await t.store.put(a, "lastUsedAt") : await t.store.add(a, "lastUsedAt"), a;
  }
  /**
   * Sets the password.
   *
   * **NOTE:** This does not set the password to storage, only to runtime memory.
   * @param {string} password - The password to set.
   * @public
   */
  setPassword(e) {
    this._password = e;
  }
  /**
   * Verifies that the password is valid.
   * @returns {Promise<boolean>} A promise that resolves to true if the password successfully decrypts the challenge,
   * or false otherwise.
   * @throws {DecryptionError} If the stored challenge failed to be decrypted.
   * @public
   */
  async verify() {
    const e = await this.challenge();
    let t;
    if (!e)
      return !1;
    try {
      return t = await this.decryptBytes(cn.decode(e)), Vr.encode(t) === Xn.challenge;
    } catch {
      return !1;
    }
  }
};
rl._saltByteSize = 64, rl.challenge = "Katavault rules!", rl.displayName = "PasswordStore";
let S1 = rl;
const B3 = class extends Ql {
  constructor(e) {
    super(e);
  }
  /**
   * private methods
   */
  _defaultSettings() {
    return {
      colorMode: "light"
    };
  }
  async _settings(e) {
    const t = this._defaultSettings();
    return {
      ...t,
      colorMode: await e.store.get("colorMode") ?? t.colorMode
    };
  }
  /**
   * public methods
   */
  /**
   * Sets the configuration.
   * @param {Partial<SettingsStoreSchema>} settings - Values of the settings to be saved or updated.
   * @return {Promise<SettingsStoreSchema>} A promise that resolves to the updated settings.
   * @public
   */
  async setSettings(e) {
    const t = this._defaultSettings(), n = this._vault.transaction(fl, "readwrite"), a = await n.store.getAllKeys();
    for (const o of Object.keys(t)) {
      if (a.includes(o) && e[o]) {
        if (e[o]) {
          await n.store.put(e[o], o);
          continue;
        }
        continue;
      }
      await n.store.add(e[o] ?? t[o], o);
    }
    return await this._settings(n);
  }
  /**
   * Gets the settings.
   * @returns {Promise<SettingsStoreSchema>} A promise that resolves to the settings.
   * @public
   */
  async settings() {
    return await this._settings(this._vault.transaction(fl, "readonly"));
  }
};
B3.displayName = "ConfigStore";
let nl = B3;
class fd extends CustomEvent {
  constructor(e, t) {
    super(e, {
      detail: {
        id: Z2(),
        username: t
      }
    });
  }
}
class al extends fd {
  constructor(e) {
    super(Gr.AccountsUpdated, e);
  }
}
class _7 extends fd {
  constructor(e) {
    super(Gr.Logout, e);
  }
}
class b7 extends fd {
  constructor(e) {
    super(Gr.SettingsUpdated, e);
  }
}
const ut = (r) => typeof r == "string", Wi = () => {
  let r, e;
  const t = new Promise((n, a) => {
    r = n, e = a;
  });
  return t.resolve = r, t.reject = e, t;
}, Jh = (r) => r == null ? "" : "" + r, S7 = (r, e, t) => {
  r.forEach((n) => {
    e[n] && (t[n] = e[n]);
  });
}, E7 = /###/g, Xh = (r) => r && r.indexOf("###") > -1 ? r.replace(E7, ".") : r, Zh = (r) => !r || ut(r), Ss = (r, e, t) => {
  const n = ut(e) ? e.split(".") : e;
  let a = 0;
  for (; a < n.length - 1; ) {
    if (Zh(r)) return {};
    const o = Xh(n[a]);
    !r[o] && t && (r[o] = new t()), Object.prototype.hasOwnProperty.call(r, o) ? r = r[o] : r = {}, ++a;
  }
  return Zh(r) ? {} : {
    obj: r,
    k: Xh(n[a])
  };
}, Qh = (r, e, t) => {
  const {
    obj: n,
    k: a
  } = Ss(r, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[a] = t;
    return;
  }
  let o = e[e.length - 1], i = e.slice(0, e.length - 1), s = Ss(r, i, Object);
  for (; s.obj === void 0 && i.length; )
    o = `${i[i.length - 1]}.${o}`, i = i.slice(0, i.length - 1), s = Ss(r, i, Object), s != null && s.obj && typeof s.obj[`${s.k}.${o}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${o}`] = t;
}, x7 = (r, e, t, n) => {
  const {
    obj: a,
    k: o
  } = Ss(r, e, Object);
  a[o] = a[o] || [], a[o].push(t);
}, wl = (r, e) => {
  const {
    obj: t,
    k: n
  } = Ss(r, e);
  if (t && Object.prototype.hasOwnProperty.call(t, n))
    return t[n];
}, k7 = (r, e, t) => {
  const n = wl(r, t);
  return n !== void 0 ? n : wl(e, t);
}, L3 = (r, e, t) => {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in r ? ut(r[n]) || r[n] instanceof String || ut(e[n]) || e[n] instanceof String ? t && (r[n] = e[n]) : L3(r[n], e[n], t) : r[n] = e[n]);
  return r;
}, Io = (r) => r.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var A7 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const C7 = (r) => ut(r) ? r.replace(/[&<>"'\/]/g, (e) => A7[e]) : r;
class D7 {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const M7 = [" ", ",", "?", "!", ";"], R7 = new D7(20), I7 = (r, e, t) => {
  e = e || "", t = t || "";
  const n = M7.filter((i) => e.indexOf(i) < 0 && t.indexOf(i) < 0);
  if (n.length === 0) return !0;
  const a = R7.getRegExp(`(${n.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let o = !a.test(r);
  if (!o) {
    const i = r.indexOf(t);
    i > 0 && !a.test(r.substring(0, i)) && (o = !0);
  }
  return o;
}, E1 = (r, e, t = ".") => {
  if (!r) return;
  if (r[e])
    return Object.prototype.hasOwnProperty.call(r, e) ? r[e] : void 0;
  const n = e.split(t);
  let a = r;
  for (let o = 0; o < n.length; ) {
    if (!a || typeof a != "object")
      return;
    let i, s = "";
    for (let l = o; l < n.length; ++l)
      if (l !== o && (s += t), s += n[l], i = a[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < n.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    a = i;
  }
  return a;
}, Ts = (r) => r == null ? void 0 : r.replace("_", "-"), T7 = {
  type: "logger",
  log(r) {
    this.output("log", r);
  },
  warn(r) {
    this.output("warn", r);
  },
  error(r) {
    this.output("error", r);
  },
  output(r, e) {
    var t, n;
    (n = (t = console == null ? void 0 : console[r]) == null ? void 0 : t.apply) == null || n.call(t, console, e);
  }
};
let O7 = class x1 {
  constructor(e, t = {}) {
    this.init(e, t);
  }
  init(e, t = {}) {
    this.prefix = t.prefix || "i18next:", this.logger = e || T7, this.options = t, this.debug = t.debug;
  }
  log(...e) {
    return this.forward(e, "log", "", !0);
  }
  warn(...e) {
    return this.forward(e, "warn", "", !0);
  }
  error(...e) {
    return this.forward(e, "error", "");
  }
  deprecate(...e) {
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, n, a) {
    return a && !this.debug ? null : (ut(e[0]) && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new x1(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new x1(this.logger, e);
  }
};
var $n = new O7();
class su {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const a = this.observers[n].get(t) || 0;
      this.observers[n].set(t, a + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e, ...t) {
    this.observers[e] && Array.from(this.observers[e].entries()).forEach(([n, a]) => {
      for (let o = 0; o < a; o++)
        n(...t);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([n, a]) => {
      for (let o = 0; o < a; o++)
        n.apply(n, [e, ...t]);
    });
  }
}
class e0 extends su {
  constructor(e, t = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, n, a = {}) {
    var o, i;
    const s = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, l = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let c;
    e.indexOf(".") > -1 ? c = e.split(".") : (c = [e, t], n && (Array.isArray(n) ? c.push(...n) : ut(n) && s ? c.push(...n.split(s)) : c.push(n)));
    const u = wl(this.data, c);
    return !u && !t && !n && e.indexOf(".") > -1 && (e = c[0], t = c[1], n = c.slice(2).join(".")), u || !l || !ut(n) ? u : E1((i = (o = this.data) == null ? void 0 : o[e]) == null ? void 0 : i[t], n, s);
  }
  addResource(e, t, n, a, o = {
    silent: !1
  }) {
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let s = [e, t];
    n && (s = s.concat(i ? n.split(i) : n)), e.indexOf(".") > -1 && (s = e.split("."), a = t, t = s[1]), this.addNamespaces(t), Qh(this.data, s, a), o.silent || this.emit("added", e, t, n, a);
  }
  addResources(e, t, n, a = {
    silent: !1
  }) {
    for (const o in n)
      (ut(n[o]) || Array.isArray(n[o])) && this.addResource(e, t, o, n[o], {
        silent: !0
      });
    a.silent || this.emit("added", e, t, n);
  }
  addResourceBundle(e, t, n, a, o, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [e, t];
    e.indexOf(".") > -1 && (s = e.split("."), a = n, n = t, t = s[1]), this.addNamespaces(t);
    let l = wl(this.data, s) || {};
    i.skipCopy || (n = JSON.parse(JSON.stringify(n))), a ? L3(l, n, o) : l = {
      ...l,
      ...n
    }, Qh(this.data, s, l), i.silent || this.emit("added", e, t, n);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((n) => t[n] && Object.keys(t[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var U3 = {
  processors: {},
  addPostProcessor(r) {
    this.processors[r.name] = r;
  },
  handle(r, e, t, n, a) {
    return r.forEach((o) => {
      var i;
      e = ((i = this.processors[o]) == null ? void 0 : i.process(e, t, n, a)) ?? e;
    }), e;
  }
};
const t0 = {}, r0 = (r) => !ut(r) && typeof r != "boolean" && typeof r != "number";
class vl extends su {
  constructor(e, t = {}) {
    super(), S7(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = $n.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e, t = {
    interpolation: {}
  }) {
    const n = {
      ...t
    };
    if (e == null) return !1;
    const a = this.resolve(e, n);
    return (a == null ? void 0 : a.res) !== void 0;
  }
  extractFromKey(e, t) {
    let n = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const a = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let o = t.ns || this.options.defaultNS || [];
    const i = n && e.indexOf(n) > -1, s = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !I7(e, n, a);
    if (i && !s) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: ut(o) ? [o] : o
        };
      const c = e.split(n);
      (n !== a || n === a && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), e = c.join(a);
    }
    return {
      key: e,
      namespaces: ut(o) ? [o] : o
    };
  }
  translate(e, t, n) {
    let a = typeof t == "object" ? {
      ...t
    } : t;
    if (typeof a != "object" && this.options.overloadTranslationOptionHandler && (a = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (a = {
      ...a
    }), a || (a = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const o = a.returnDetails !== void 0 ? a.returnDetails : this.options.returnDetails, i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(e[e.length - 1], a), c = l[l.length - 1];
    let u = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = a.lng || this.language, w = a.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((d == null ? void 0 : d.toLowerCase()) === "cimode")
      return w ? o ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(a)
      } : `${c}${u}${s}` : o ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(a)
      } : s;
    const f = this.resolve(e, a);
    let A = f == null ? void 0 : f.res;
    const b = (f == null ? void 0 : f.usedKey) || s, g = (f == null ? void 0 : f.exactUsedKey) || s, k = ["[object Number]", "[object Function]", "[object RegExp]"], v = a.joinArrays !== void 0 ? a.joinArrays : this.options.joinArrays, C = !this.i18nFormat || this.i18nFormat.handleAsObject, W = a.count !== void 0 && !ut(a.count), Z = vl.hasDefaultValue(a), D = W ? this.pluralResolver.getSuffix(d, a.count, a) : "", H = a.ordinal && W ? this.pluralResolver.getSuffix(d, a.count, {
      ordinal: !1
    }) : "", y = W && !a.ordinal && a.count === 0, S = y && a[`defaultValue${this.options.pluralSeparator}zero`] || a[`defaultValue${D}`] || a[`defaultValue${H}`] || a.defaultValue;
    let _ = A;
    C && !A && Z && (_ = S);
    const F = r0(_), M = Object.prototype.toString.apply(_);
    if (C && _ && F && k.indexOf(M) < 0 && !(ut(v) && Array.isArray(_))) {
      if (!a.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const j = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, _, {
          ...a,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return o ? (f.res = j, f.usedParams = this.getUsedParamsDetails(a), f) : j;
      }
      if (i) {
        const j = Array.isArray(_), Y = j ? [] : {}, N = j ? g : b;
        for (const O in _)
          if (Object.prototype.hasOwnProperty.call(_, O)) {
            const G = `${N}${i}${O}`;
            Z && !A ? Y[O] = this.translate(G, {
              ...a,
              defaultValue: r0(S) ? S[O] : void 0,
              joinArrays: !1,
              ns: l
            }) : Y[O] = this.translate(G, {
              ...a,
              joinArrays: !1,
              ns: l
            }), Y[O] === G && (Y[O] = _[O]);
          }
        A = Y;
      }
    } else if (C && ut(v) && Array.isArray(A))
      A = A.join(v), A && (A = this.extendTranslation(A, e, a, n));
    else {
      let j = !1, Y = !1;
      !this.isValidLookup(A) && Z && (j = !0, A = S), this.isValidLookup(A) || (Y = !0, A = s);
      const N = (a.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && Y ? void 0 : A, O = Z && S !== A && this.options.updateMissing;
      if (Y || j || O) {
        if (this.logger.log(O ? "updateKey" : "missingKey", d, c, s, O ? S : A), i) {
          const fe = this.resolve(s, {
            ...a,
            keySeparator: !1
          });
          fe && fe.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let G = [];
        const Q = this.languageUtils.getFallbackCodes(this.options.fallbackLng, a.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Q && Q[0])
          for (let fe = 0; fe < Q.length; fe++)
            G.push(Q[fe]);
        else this.options.saveMissingTo === "all" ? G = this.languageUtils.toResolveHierarchy(a.lng || this.language) : G.push(a.lng || this.language);
        const ie = (fe, pe, ye) => {
          var te;
          const B = Z && ye !== A ? ye : N;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(fe, c, pe, B, O, a) : (te = this.backendConnector) != null && te.saveMissing && this.backendConnector.saveMissing(fe, c, pe, B, O, a), this.emit("missingKey", fe, c, pe, A);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && W ? G.forEach((fe) => {
          const pe = this.pluralResolver.getSuffixes(fe, a);
          y && a[`defaultValue${this.options.pluralSeparator}zero`] && pe.indexOf(`${this.options.pluralSeparator}zero`) < 0 && pe.push(`${this.options.pluralSeparator}zero`), pe.forEach((ye) => {
            ie([fe], s + ye, a[`defaultValue${ye}`] || S);
          });
        }) : ie(G, s, S));
      }
      A = this.extendTranslation(A, e, a, f, n), Y && A === s && this.options.appendNamespaceToMissingKey && (A = `${c}${u}${s}`), (Y || j) && this.options.parseMissingKeyHandler && (A = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, j ? A : void 0, a));
    }
    return o ? (f.res = A, f.usedParams = this.getUsedParamsDetails(a), f) : A;
  }
  extendTranslation(e, t, n, a, o) {
    var i, s;
    if ((i = this.i18nFormat) != null && i.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const u = ut(e) && (((s = n == null ? void 0 : n.interpolation) == null ? void 0 : s.skipOnVariables) !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (u) {
        const f = e.match(this.interpolator.nestingRegexp);
        d = f && f.length;
      }
      let w = n.replace && !ut(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (w = {
        ...this.options.interpolation.defaultVariables,
        ...w
      }), e = this.interpolator.interpolate(e, w, n.lng || this.language || a.usedLng, n), u) {
        const f = e.match(this.interpolator.nestingRegexp), A = f && f.length;
        d < A && (n.nest = !1);
      }
      !n.lng && a && a.res && (n.lng = this.language || a.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, (...f) => (o == null ? void 0 : o[0]) === f[0] && !n.context ? (this.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${t[0]}`), null) : this.translate(...f, t), n)), n.interpolation && this.interpolator.reset();
    }
    const l = n.postProcess || this.options.postProcess, c = ut(l) ? [l] : l;
    return e != null && c != null && c.length && n.applyPostProcessor !== !1 && (e = U3.handle(c, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e, t = {}) {
    let n, a, o, i, s;
    return ut(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n)) return;
      const c = this.extractFromKey(l, t), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const w = t.count !== void 0 && !ut(t.count), f = w && !t.ordinal && t.count === 0, A = t.context !== void 0 && (ut(t.context) || typeof t.context == "number") && t.context !== "", b = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((g) => {
        var k, v;
        this.isValidLookup(n) || (s = g, !t0[`${b[0]}-${g}`] && (k = this.utils) != null && k.hasLoadedNamespace && !((v = this.utils) != null && v.hasLoadedNamespace(s)) && (t0[`${b[0]}-${g}`] = !0, this.logger.warn(`key "${a}" for languages "${b.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach((C) => {
          var W;
          if (this.isValidLookup(n)) return;
          i = C;
          const Z = [u];
          if ((W = this.i18nFormat) != null && W.addLookupKeys)
            this.i18nFormat.addLookupKeys(Z, u, C, g, t);
          else {
            let H;
            w && (H = this.pluralResolver.getSuffix(C, t.count, t));
            const y = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (w && (Z.push(u + H), t.ordinal && H.indexOf(S) === 0 && Z.push(u + H.replace(S, this.options.pluralSeparator)), f && Z.push(u + y)), A) {
              const _ = `${u}${this.options.contextSeparator}${t.context}`;
              Z.push(_), w && (Z.push(_ + H), t.ordinal && H.indexOf(S) === 0 && Z.push(_ + H.replace(S, this.options.pluralSeparator)), f && Z.push(_ + y));
            }
          }
          let D;
          for (; D = Z.pop(); )
            this.isValidLookup(n) || (o = D, n = this.getResource(C, g, D, t));
        }));
      });
    }), {
      res: n,
      usedKey: a,
      exactUsedKey: o,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, n, a = {}) {
    var o;
    return (o = this.i18nFormat) != null && o.getResource ? this.i18nFormat.getResource(e, t, n, a) : this.resourceStore.getResource(e, t, n, a);
  }
  getUsedParamsDetails(e = {}) {
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && !ut(e.replace);
    let a = n ? e.replace : e;
    if (n && typeof e.count < "u" && (a.count = e.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !n) {
      a = {
        ...a
      };
      for (const o of t)
        delete a[o];
    }
    return a;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && t === n.substring(0, t.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
class n0 {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = $n.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Ts(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Ts(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (ut(e) && e.indexOf("-") > -1) {
      let t;
      try {
        t = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return t && this.options.lowerCaseLng && (t = t.toLowerCase()), t || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((n) => {
      if (t) return;
      const a = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (t = a);
    }), !t && this.options.supportedLngs && e.forEach((n) => {
      if (t) return;
      const a = this.getScriptPartFromCode(n);
      if (this.isSupportedCode(a)) return t = a;
      const o = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(o)) return t = o;
      t = this.options.supportedLngs.find((i) => {
        if (i === o || !(i.indexOf("-") < 0 && o.indexOf("-") < 0) && (i.indexOf("-") > 0 && o.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === o || i.indexOf(o) === 0 && o.length > 1))
          return i;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), ut(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let n = e[t];
    return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, t) {
    const n = this.getFallbackCodes((t === !1 ? [] : t) || this.options.fallbackLng || [], e), a = [], o = (i) => {
      i && (this.isSupportedCode(i) ? a.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return ut(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(e))) : ut(e) && o(this.formatLanguageCode(e)), n.forEach((i) => {
      a.indexOf(i) < 0 && o(this.formatLanguageCode(i));
    }), a;
  }
}
const a0 = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, o0 = {
  select: (r) => r === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class P7 {
  constructor(e, t = {}) {
    this.languageUtils = e, this.options = t, this.logger = $n.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e, t = {}) {
    const n = Ts(e === "dev" ? "en" : e), a = t.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
      cleanedCode: n,
      type: a
    });
    if (o in this.pluralRulesCache)
      return this.pluralRulesCache[o];
    let i;
    try {
      i = new Intl.PluralRules(n, {
        type: a
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), o0;
      if (!e.match(/-|_/)) return o0;
      const s = this.languageUtils.getLanguagePartFromCode(e);
      i = this.getRule(s, t);
    }
    return this.pluralRulesCache[o] = i, i;
  }
  needsPlural(e, t = {}) {
    let n = this.getRule(e, t);
    return n || (n = this.getRule("dev", t)), (n == null ? void 0 : n.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(e, t, n = {}) {
    return this.getSuffixes(e, n).map((a) => `${t}${a}`);
  }
  getSuffixes(e, t = {}) {
    let n = this.getRule(e, t);
    return n || (n = this.getRule("dev", t)), n ? n.resolvedOptions().pluralCategories.sort((a, o) => a0[a] - a0[o]).map((a) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : [];
  }
  getSuffix(e, t, n = {}) {
    const a = this.getRule(e, n);
    return a ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(t)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", t, n));
  }
}
const i0 = (r, e, t, n = ".", a = !0) => {
  let o = k7(r, e, t);
  return !o && a && ut(t) && (o = E1(r, t, n), o === void 0 && (o = E1(e, t, n))), o;
}, Uu = (r) => r.replace(/\$/g, "$$$$");
class N7 {
  constructor(e = {}) {
    var t;
    this.logger = $n.create("interpolator"), this.options = e, this.format = ((t = e == null ? void 0 : e.interpolation) == null ? void 0 : t.format) || ((n) => n), this.init(e);
  }
  init(e = {}) {
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: n,
      useRawValueToEscape: a,
      prefix: o,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: w,
      nestingPrefixEscaped: f,
      nestingSuffix: A,
      nestingSuffixEscaped: b,
      nestingOptionsSeparator: g,
      maxReplaces: k,
      alwaysFormat: v
    } = e.interpolation;
    this.escape = t !== void 0 ? t : C7, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = o ? Io(o) : i || "{{", this.suffix = s ? Io(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = w ? Io(w) : f || Io("$t("), this.nestingSuffix = A ? Io(A) : b || Io(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = k || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, n) => (t == null ? void 0 : t.source) === n ? (t.lastIndex = 0, t) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, n, a) {
    var o;
    let i, s, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const k = i0(t, c, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(k, void 0, n, {
          ...a,
          ...t,
          interpolationkey: f
        }) : k;
      }
      const A = f.split(this.formatSeparator), b = A.shift().trim(), g = A.join(this.formatSeparator).trim();
      return this.format(i0(t, c, b, this.options.keySeparator, this.options.ignoreJSONStructure), g, n, {
        ...a,
        ...t,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const d = (a == null ? void 0 : a.missingInterpolationHandler) || this.options.missingInterpolationHandler, w = ((o = a == null ? void 0 : a.interpolation) == null ? void 0 : o.skipOnVariables) !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => Uu(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? Uu(this.escape(f)) : Uu(f)
    }].forEach((f) => {
      for (l = 0; i = f.regex.exec(e); ) {
        const A = i[1].trim();
        if (s = u(A), s === void 0)
          if (typeof d == "function") {
            const g = d(e, i, a);
            s = ut(g) ? g : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, A))
            s = "";
          else if (w) {
            s = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${A} for interpolating ${e}`), s = "";
        else !ut(s) && !this.useRawValueToEscape && (s = Jh(s));
        const b = f.safeValue(s);
        if (e = e.replace(i[0], b), w ? (f.regex.lastIndex += s.length, f.regex.lastIndex -= i[0].length) : f.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t, n = {}) {
    let a, o, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let w = `{${d[1]}`;
      l = d[0], w = this.interpolate(w, i);
      const f = w.match(/'/g), A = w.match(/"/g);
      (((f == null ? void 0 : f.length) ?? 0) % 2 === 0 && !A || A.length % 2 !== 0) && (w = w.replace(/'/g, '"'));
      try {
        i = JSON.parse(w), c && (i = {
          ...c,
          ...i
        });
      } catch (b) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, b), `${l}${u}${w}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(e); ) {
      let l = [];
      i = {
        ...n
      }, i = i.replace && !ut(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(a[1]) ? a[1].lastIndexOf("}") + 1 : a[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = a[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), a[1] = a[1].slice(0, c)), o = t(s.call(this, a[1].trim(), i), i), o && a[0] === e && !ut(o)) return o;
      ut(o) || (o = Jh(o)), o || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${e}`), o = ""), l.length && (o = l.reduce((u, d) => this.format(u, d, n.lng, {
        ...n,
        interpolationkey: a[1].trim()
      }), o.trim())), e = e.replace(a[0], o), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const B7 = (r) => {
  let e = r.toLowerCase().trim();
  const t = {};
  if (r.indexOf("(") > -1) {
    const n = r.split("(");
    e = n[0].toLowerCase().trim();
    const a = n[1].substring(0, n[1].length - 1);
    e === "currency" && a.indexOf(":") < 0 ? t.currency || (t.currency = a.trim()) : e === "relativetime" && a.indexOf(":") < 0 ? t.range || (t.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [i, ...s] = o.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        t[c] || (t[c] = l), l === "false" && (t[c] = !1), l === "true" && (t[c] = !0), isNaN(l) || (t[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, s0 = (r) => {
  const e = {};
  return (t, n, a) => {
    let o = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (o = {
      ...o,
      [a.interpolationkey]: void 0
    });
    const i = n + JSON.stringify(o);
    let s = e[i];
    return s || (s = r(Ts(n), a), e[i] = s), s(t);
  };
}, L7 = (r) => (e, t, n) => r(Ts(t), n)(e);
class U7 {
  constructor(e = {}) {
    this.logger = $n.create("formatter"), this.options = e, this.init(e);
  }
  init(e, t = {
    interpolation: {}
  }) {
    this.formatSeparator = t.interpolation.formatSeparator || ",";
    const n = t.cacheInBuiltFormats ? s0 : L7;
    this.formats = {
      number: n((a, o) => {
        const i = new Intl.NumberFormat(a, {
          ...o
        });
        return (s) => i.format(s);
      }),
      currency: n((a, o) => {
        const i = new Intl.NumberFormat(a, {
          ...o,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: n((a, o) => {
        const i = new Intl.DateTimeFormat(a, {
          ...o
        });
        return (s) => i.format(s);
      }),
      relativetime: n((a, o) => {
        const i = new Intl.RelativeTimeFormat(a, {
          ...o
        });
        return (s) => i.format(s, o.range || "day");
      }),
      list: n((a, o) => {
        const i = new Intl.ListFormat(a, {
          ...o
        });
        return (s) => i.format(s);
      })
    };
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = s0(t);
  }
  format(e, t, n, a = {}) {
    const o = t.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((i) => i.indexOf(")") > -1)) {
      const i = o.findIndex((s) => s.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, i)].join(this.formatSeparator);
    }
    return o.reduce((i, s) => {
      var l;
      const {
        formatName: c,
        formatOptions: u
      } = B7(s);
      if (this.formats[c]) {
        let d = i;
        try {
          const w = ((l = a == null ? void 0 : a.formatParams) == null ? void 0 : l[a.interpolationkey]) || {}, f = w.locale || w.lng || a.locale || a.lng || n;
          d = this.formats[c](i, f, {
            ...u,
            ...a,
            ...w
          });
        } catch (w) {
          this.logger.warn(w);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return i;
    }, e);
  }
}
const V7 = (r, e) => {
  r.pending[e] !== void 0 && (delete r.pending[e], r.pendingCount--);
};
class $7 extends su {
  constructor(e, t, n, a = {}) {
    var o, i;
    super(), this.backend = e, this.store = t, this.services = n, this.languageUtils = n.languageUtils, this.options = a, this.logger = $n.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], (i = (o = this.backend) == null ? void 0 : o.init) == null || i.call(o, n, a.backend, a);
  }
  queueLoad(e, t, n, a) {
    const o = {}, i = {}, s = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      t.forEach((d) => {
        const w = `${c}|${d}`;
        !n.reload && this.store.hasResourceBundle(c, d) ? this.state[w] = 2 : this.state[w] < 0 || (this.state[w] === 1 ? i[w] === void 0 && (i[w] = !0) : (this.state[w] = 1, u = !1, i[w] === void 0 && (i[w] = !0), o[w] === void 0 && (o[w] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(o).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, n) {
    const a = e.split("|"), o = a[0], i = a[1];
    t && this.emit("failedLoading", o, i, t), !t && n && this.store.addResourceBundle(o, i, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && n && (this.state[e] = 0);
    const s = {};
    this.queue.forEach((l) => {
      x7(l.loaded, [o], i), V7(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, n, a = 0, o = this.retryTimeout, i) {
    if (!e.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: n,
        tried: a,
        wait: o,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, n, a + 1, o * 2, i);
        }, o);
        return;
      }
      i(c, u);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(e, t, s);
  }
  prepareLoading(e, t, n = {}, a) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    ut(e) && (e = this.languageUtils.toResolveHierarchy(e)), ut(t) && (t = [t]);
    const o = this.queueLoad(e, t, n, a);
    if (!o.toLoad.length)
      return o.pending.length || a(), null;
    o.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(e, t, n) {
    this.prepareLoading(e, t, {}, n);
  }
  reload(e, t, n) {
    this.prepareLoading(e, t, {
      reload: !0
    }, n);
  }
  loadOne(e, t = "") {
    const n = e.split("|"), a = n[0], o = n[1];
    this.read(a, o, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${t}loading namespace ${o} for language ${a} failed`, i), !i && s && this.logger.log(`${t}loaded namespace ${o} for language ${a}`, s), this.loaded(e, i, s);
    });
  }
  saveMissing(e, t, n, a, o, i = {}, s = () => {
  }) {
    var l, c, u, d, w;
    if ((c = (l = this.services) == null ? void 0 : l.utils) != null && c.hasLoadedNamespace && !((d = (u = this.services) == null ? void 0 : u.utils) != null && d.hasLoadedNamespace(t))) {
      this.logger.warn(`did not save key "${n}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if ((w = this.backend) != null && w.create) {
        const f = {
          ...i,
          isUpdate: o
        }, A = this.backend.create.bind(this.backend);
        if (A.length < 6)
          try {
            let b;
            A.length === 5 ? b = A(e, t, n, a, f) : b = A(e, t, n, a), b && typeof b.then == "function" ? b.then((g) => s(null, g)).catch(s) : s(null, b);
          } catch (b) {
            s(b);
          }
        else
          A(e, t, n, a, s, f);
      }
      !e || !e[0] || this.store.addResource(e[0], t, n, a);
    }
  }
}
const c0 = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (r) => {
    let e = {};
    if (typeof r[1] == "object" && (e = r[1]), ut(r[1]) && (e.defaultValue = r[1]), ut(r[2]) && (e.tDescription = r[2]), typeof r[2] == "object" || typeof r[3] == "object") {
      const t = r[3] || r[2];
      Object.keys(t).forEach((n) => {
        e[n] = t[n];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (r) => r,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), l0 = (r) => {
  var e, t;
  return ut(r.ns) && (r.ns = [r.ns]), ut(r.fallbackLng) && (r.fallbackLng = [r.fallbackLng]), ut(r.fallbackNS) && (r.fallbackNS = [r.fallbackNS]), ((t = (e = r.supportedLngs) == null ? void 0 : e.indexOf) == null ? void 0 : t.call(e, "cimode")) < 0 && (r.supportedLngs = r.supportedLngs.concat(["cimode"])), typeof r.initImmediate == "boolean" && (r.initAsync = r.initImmediate), r;
}, Ac = () => {
}, j7 = (r) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(r)).forEach((e) => {
    typeof r[e] == "function" && (r[e] = r[e].bind(r));
  });
};
class Os extends su {
  constructor(e = {}, t) {
    if (super(), this.options = l0(e), this.services = {}, this.logger = $n, this.modules = {
      external: []
    }, j7(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init(e = {}, t) {
    this.isInitializing = !0, typeof e == "function" && (t = e, e = {}), e.defaultNS == null && e.ns && (ut(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const n = c0();
    this.options = {
      ...n,
      ...this.options,
      ...l0(e)
    }, this.options.interpolation = {
      ...n.interpolation,
      ...this.options.interpolation
    }, e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const a = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? $n.init(a(this.modules.logger), this.options) : $n.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = U7;
      const l = new n0(this.options);
      this.store = new e0(this.options.resources, this.options);
      const c = this.services;
      c.logger = $n, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new P7(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== n.interpolation.format && this.logger.warn("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === n.interpolation.format) && (c.formatter = a(s), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new N7(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new $7(a(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = a(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = a(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new vl(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, t || (t = Ac), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const o = Wi(), i = () => {
      const s = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), o.resolve(c), t(l, c);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? i() : setTimeout(i, 0), o;
  }
  loadResources(e, t = Ac) {
    var n, a;
    let o = t;
    const i = ut(e) ? e : this.language;
    if (typeof e == "function" && (o = e), !this.options.resources || this.options.partialBundledLanguages) {
      if ((i == null ? void 0 : i.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const s = [], l = (c) => {
        !c || c === "cimode" || this.services.languageUtils.toResolveHierarchy(c).forEach((u) => {
          u !== "cimode" && s.indexOf(u) < 0 && s.push(u);
        });
      };
      i ? l(i) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => l(c)), (a = (n = this.options.preload) == null ? void 0 : n.forEach) == null || a.call(n, (c) => l(c)), this.services.backendConnector.load(s, this.options.ns, (c) => {
        !c && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(c);
      });
    } else
      o(null);
  }
  reloadResources(e, t, n) {
    const a = Wi();
    return typeof e == "function" && (n = e, e = void 0), typeof t == "function" && (n = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), n || (n = Ac), this.services.backendConnector.reload(e, t, (o) => {
      a.resolve(), n(o);
    }), a;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && U3.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1)) {
      for (let t = 0; t < this.languages.length; t++) {
        const n = this.languages[t];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(e) < 0 && this.store.hasLanguageSomeTranslations(e) && (this.resolvedLanguage = e, this.languages.unshift(e));
    }
  }
  changeLanguage(e, t) {
    this.isLanguageChangingTo = e;
    const n = Wi();
    this.emit("languageChanging", e);
    const a = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, o = (s, l) => {
      l ? this.isLanguageChangingTo === e && (a(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, n.resolve((...c) => this.t(...c)), t && t(s, (...c) => this.t(...c));
    }, i = (s) => {
      var l, c;
      !e && !s && this.services.languageDetector && (s = []);
      const u = ut(s) ? s : s && s[0], d = this.store.hasLanguageSomeTranslations(u) ? u : this.services.languageUtils.getBestMatchFromCodes(ut(s) ? [s] : s);
      d && (this.language || a(d), this.translator.language || this.translator.changeLanguage(d), (c = (l = this.services.languageDetector) == null ? void 0 : l.cacheUserLanguage) == null || c.call(l, d)), this.loadResources(d, (w) => {
        o(w, d);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(e), n;
  }
  getFixedT(e, t, n) {
    const a = (o, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([o, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || a.lng, l.lngs = l.lngs || a.lngs, l.ns = l.ns || a.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || a.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(o) ? u = o.map((d) => `${l.keyPrefix}${c}${d}`) : u = l.keyPrefix ? `${l.keyPrefix}${c}${o}` : o, this.t(u, l);
    };
    return ut(e) ? a.lng = e : a.lngs = e, a.ns = t, a.keyPrefix = n, a;
  }
  t(...e) {
    var t;
    return (t = this.translator) == null ? void 0 : t.translate(...e);
  }
  exists(...e) {
    var t;
    return (t = this.translator) == null ? void 0 : t.exists(...e);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e, t = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = t.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const s = t.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(n, e) && (!a || i(o, e)));
  }
  loadNamespaces(e, t) {
    const n = Wi();
    return this.options.ns ? (ut(e) && (e = [e]), e.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      n.resolve(), t && t(a);
    }), n) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const n = Wi();
    ut(e) && (e = [e]);
    const a = this.options.preload || [], o = e.filter((i) => a.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return o.length ? (this.options.preload = a.concat(o), this.loadResources((i) => {
      n.resolve(), t && t(i);
    }), n) : (t && t(), Promise.resolve());
  }
  dir(e) {
    var t, n;
    if (e || (e = this.resolvedLanguage || (((t = this.languages) == null ? void 0 : t.length) > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    try {
      const i = new Intl.Locale(e);
      if (i && i.getTextInfo) {
        const s = i.getTextInfo();
        if (s && s.direction) return s.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = ((n = this.services) == null ? void 0 : n.languageUtils) || new n0(c0());
    return e.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(e = {}, t) {
    return new Os(e, t);
  }
  cloneInstance(e = {}, t = Ac) {
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const a = {
      ...this.options,
      ...e,
      isClone: !0
    }, o = new Os(a);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (o.logger = o.logger.clone(e)), ["store", "services", "language"].forEach((i) => {
      o[i] = this[i];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, n) {
      const i = Object.keys(this.store.data).reduce((s, l) => (s[l] = {
        ...this.store.data[l]
      }, s[l] = Object.keys(s[l]).reduce((c, u) => (c[u] = {
        ...s[l][u]
      }, c), s[l]), s), {});
      o.store = new e0(i, a), o.services.resourceStore = o.store;
    }
    return o.translator = new vl(o.services, a), o.translator.on("*", (i, ...s) => {
      o.emit(i, ...s);
    }), o.init(a, t), o.translator.options = a, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Lr = Os.createInstance();
Lr.createInstance = Os.createInstance;
Lr.createInstance;
Lr.dir;
Lr.init;
Lr.loadResources;
Lr.reloadResources;
Lr.use;
Lr.changeLanguage;
Lr.getFixedT;
Lr.t;
Lr.exists;
Lr.setDefaultNamespace;
Lr.hasLoadedNamespace;
Lr.loadNamespaces;
Lr.loadLanguages;
var fc, jt, V3, Za, u0, $3, j3, F3, pd, k1, A1, z3, Ps = {}, H3 = [], F7 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, cu = Array.isArray;
function jn(r, e) {
  for (var t in e) r[t] = e[t];
  return r;
}
function gd(r) {
  r && r.parentNode && r.parentNode.removeChild(r);
}
function _l(r, e, t) {
  var n, a, o, i = {};
  for (o in e) o == "key" ? n = e[o] : o == "ref" ? a = e[o] : i[o] = e[o];
  if (arguments.length > 2 && (i.children = arguments.length > 3 ? fc.call(arguments, 2) : t), typeof r == "function" && r.defaultProps != null) for (o in r.defaultProps) i[o] === void 0 && (i[o] = r.defaultProps[o]);
  return Es(r, i, n, a, null);
}
function Es(r, e, t, n, a) {
  var o = { type: r, props: e, key: t, ref: n, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: a ?? ++V3, __i: -1, __u: 0 };
  return a == null && jt.vnode != null && jt.vnode(o), o;
}
function ln(r) {
  return r.children;
}
function ol(r, e) {
  this.props = r, this.context = e;
}
function Xo(r, e) {
  if (e == null) return r.__ ? Xo(r.__, r.__i + 1) : null;
  for (var t; e < r.__k.length; e++) if ((t = r.__k[e]) != null && t.__e != null) return t.__e;
  return typeof r.type == "function" ? Xo(r) : null;
}
function q3(r) {
  var e, t;
  if ((r = r.__) != null && r.__c != null) {
    for (r.__e = r.__c.base = null, e = 0; e < r.__k.length; e++) if ((t = r.__k[e]) != null && t.__e != null) {
      r.__e = r.__c.base = t.__e;
      break;
    }
    return q3(r);
  }
}
function C1(r) {
  (!r.__d && (r.__d = !0) && Za.push(r) && !bl.__r++ || u0 != jt.debounceRendering) && ((u0 = jt.debounceRendering) || $3)(bl);
}
function bl() {
  for (var r, e, t, n, a, o, i, s = 1; Za.length; ) Za.length > s && Za.sort(j3), r = Za.shift(), s = Za.length, r.__d && (t = void 0, a = (n = (e = r).__v).__e, o = [], i = [], e.__P && ((t = jn({}, n)).__v = n.__v + 1, jt.vnode && jt.vnode(t), md(e.__P, t, n, e.__n, e.__P.namespaceURI, 32 & n.__u ? [a] : null, o, a ?? Xo(n), !!(32 & n.__u), i), t.__v = n.__v, t.__.__k[t.__i] = t, Y3(o, t, i), t.__e != a && q3(t)));
  bl.__r = 0;
}
function W3(r, e, t, n, a, o, i, s, l, c, u) {
  var d, w, f, A, b, g, k = n && n.__k || H3, v = e.length;
  for (l = z7(t, e, k, l, v), d = 0; d < v; d++) (f = t.__k[d]) != null && (w = f.__i == -1 ? Ps : k[f.__i] || Ps, f.__i = d, g = md(r, f, w, a, o, i, s, l, c, u), A = f.__e, f.ref && w.ref != f.ref && (w.ref && yd(w.ref, null, f), u.push(f.ref, f.__c || A, f)), b == null && A != null && (b = A), 4 & f.__u || w.__k === f.__k ? l = K3(f, l, r) : typeof f.type == "function" && g !== void 0 ? l = g : A && (l = A.nextSibling), f.__u &= -7);
  return t.__e = b, l;
}
function z7(r, e, t, n, a) {
  var o, i, s, l, c, u = t.length, d = u, w = 0;
  for (r.__k = new Array(a), o = 0; o < a; o++) (i = e[o]) != null && typeof i != "boolean" && typeof i != "function" ? (l = o + w, (i = r.__k[o] = typeof i == "string" || typeof i == "number" || typeof i == "bigint" || i.constructor == String ? Es(null, i, null, null, null) : cu(i) ? Es(ln, { children: i }, null, null, null) : i.constructor == null && i.__b > 0 ? Es(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = r, i.__b = r.__b + 1, s = null, (c = i.__i = H7(i, t, l, d)) != -1 && (d--, (s = t[c]) && (s.__u |= 2)), s == null || s.__v == null ? (c == -1 && (a > u ? w-- : a < u && w++), typeof i.type != "function" && (i.__u |= 4)) : c != l && (c == l - 1 ? w-- : c == l + 1 ? w++ : (c > l ? w-- : w++, i.__u |= 4))) : r.__k[o] = null;
  if (d) for (o = 0; o < u; o++) (s = t[o]) != null && (2 & s.__u) == 0 && (s.__e == n && (n = Xo(s)), J3(s, s));
  return n;
}
function K3(r, e, t) {
  var n, a;
  if (typeof r.type == "function") {
    for (n = r.__k, a = 0; n && a < n.length; a++) n[a] && (n[a].__ = r, e = K3(n[a], e, t));
    return e;
  }
  r.__e != e && (e && r.type && !t.contains(e) && (e = Xo(r)), t.insertBefore(r.__e, e || null), e = r.__e);
  do
    e = e && e.nextSibling;
  while (e != null && e.nodeType == 8);
  return e;
}
function H7(r, e, t, n) {
  var a, o, i = r.key, s = r.type, l = e[t];
  if (l === null && r.key == null || l && i == l.key && s == l.type && (2 & l.__u) == 0) return t;
  if (n > (l != null && (2 & l.__u) == 0 ? 1 : 0)) for (a = t - 1, o = t + 1; a >= 0 || o < e.length; ) {
    if (a >= 0) {
      if ((l = e[a]) && (2 & l.__u) == 0 && i == l.key && s == l.type) return a;
      a--;
    }
    if (o < e.length) {
      if ((l = e[o]) && (2 & l.__u) == 0 && i == l.key && s == l.type) return o;
      o++;
    }
  }
  return -1;
}
function d0(r, e, t) {
  e[0] == "-" ? r.setProperty(e, t ?? "") : r[e] = t == null ? "" : typeof t != "number" || F7.test(e) ? t : t + "px";
}
function Cc(r, e, t, n, a) {
  var o, i;
  e: if (e == "style") if (typeof t == "string") r.style.cssText = t;
  else {
    if (typeof n == "string" && (r.style.cssText = n = ""), n) for (e in n) t && e in t || d0(r.style, e, "");
    if (t) for (e in t) n && t[e] == n[e] || d0(r.style, e, t[e]);
  }
  else if (e[0] == "o" && e[1] == "n") o = e != (e = e.replace(F3, "$1")), i = e.toLowerCase(), e = i in r || e == "onFocusOut" || e == "onFocusIn" ? i.slice(2) : e.slice(2), r.l || (r.l = {}), r.l[e + o] = t, t ? n ? t.u = n.u : (t.u = pd, r.addEventListener(e, o ? A1 : k1, o)) : r.removeEventListener(e, o ? A1 : k1, o);
  else {
    if (a == "http://www.w3.org/2000/svg") e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (e != "width" && e != "height" && e != "href" && e != "list" && e != "form" && e != "tabIndex" && e != "download" && e != "rowSpan" && e != "colSpan" && e != "role" && e != "popover" && e in r) try {
      r[e] = t ?? "";
      break e;
    } catch {
    }
    typeof t == "function" || (t == null || t === !1 && e[4] != "-" ? r.removeAttribute(e) : r.setAttribute(e, e == "popover" && t == 1 ? "" : t));
  }
}
function h0(r) {
  return function(e) {
    if (this.l) {
      var t = this.l[e.type + r];
      if (e.t == null) e.t = pd++;
      else if (e.t < t.u) return;
      return t(jt.event ? jt.event(e) : e);
    }
  };
}
function md(r, e, t, n, a, o, i, s, l, c) {
  var u, d, w, f, A, b, g, k, v, C, W, Z, D, H, y, S, _, F = e.type;
  if (e.constructor != null) return null;
  128 & t.__u && (l = !!(32 & t.__u), o = [s = e.__e = t.__e]), (u = jt.__b) && u(e);
  e: if (typeof F == "function") try {
    if (k = e.props, v = "prototype" in F && F.prototype.render, C = (u = F.contextType) && n[u.__c], W = u ? C ? C.props.value : u.__ : n, t.__c ? g = (d = e.__c = t.__c).__ = d.__E : (v ? e.__c = d = new F(k, W) : (e.__c = d = new ol(k, W), d.constructor = F, d.render = W7), C && C.sub(d), d.props = k, d.state || (d.state = {}), d.context = W, d.__n = n, w = d.__d = !0, d.__h = [], d._sb = []), v && d.__s == null && (d.__s = d.state), v && F.getDerivedStateFromProps != null && (d.__s == d.state && (d.__s = jn({}, d.__s)), jn(d.__s, F.getDerivedStateFromProps(k, d.__s))), f = d.props, A = d.state, d.__v = e, w) v && F.getDerivedStateFromProps == null && d.componentWillMount != null && d.componentWillMount(), v && d.componentDidMount != null && d.__h.push(d.componentDidMount);
    else {
      if (v && F.getDerivedStateFromProps == null && k !== f && d.componentWillReceiveProps != null && d.componentWillReceiveProps(k, W), !d.__e && d.shouldComponentUpdate != null && d.shouldComponentUpdate(k, d.__s, W) === !1 || e.__v == t.__v) {
        for (e.__v != t.__v && (d.props = k, d.state = d.__s, d.__d = !1), e.__e = t.__e, e.__k = t.__k, e.__k.some(function(M) {
          M && (M.__ = e);
        }), Z = 0; Z < d._sb.length; Z++) d.__h.push(d._sb[Z]);
        d._sb = [], d.__h.length && i.push(d);
        break e;
      }
      d.componentWillUpdate != null && d.componentWillUpdate(k, d.__s, W), v && d.componentDidUpdate != null && d.__h.push(function() {
        d.componentDidUpdate(f, A, b);
      });
    }
    if (d.context = W, d.props = k, d.__P = r, d.__e = !1, D = jt.__r, H = 0, v) {
      for (d.state = d.__s, d.__d = !1, D && D(e), u = d.render(d.props, d.state, d.context), y = 0; y < d._sb.length; y++) d.__h.push(d._sb[y]);
      d._sb = [];
    } else do
      d.__d = !1, D && D(e), u = d.render(d.props, d.state, d.context), d.state = d.__s;
    while (d.__d && ++H < 25);
    d.state = d.__s, d.getChildContext != null && (n = jn(jn({}, n), d.getChildContext())), v && !w && d.getSnapshotBeforeUpdate != null && (b = d.getSnapshotBeforeUpdate(f, A)), S = u, u != null && u.type === ln && u.key == null && (S = G3(u.props.children)), s = W3(r, cu(S) ? S : [S], e, t, n, a, o, i, s, l, c), d.base = e.__e, e.__u &= -161, d.__h.length && i.push(d), g && (d.__E = d.__ = null);
  } catch (M) {
    if (e.__v = null, l || o != null) if (M.then) {
      for (e.__u |= l ? 160 : 128; s && s.nodeType == 8 && s.nextSibling; ) s = s.nextSibling;
      o[o.indexOf(s)] = null, e.__e = s;
    } else for (_ = o.length; _--; ) gd(o[_]);
    else e.__e = t.__e, e.__k = t.__k;
    jt.__e(M, e, t);
  }
  else o == null && e.__v == t.__v ? (e.__k = t.__k, e.__e = t.__e) : s = e.__e = q7(t.__e, e, t, n, a, o, i, l, c);
  return (u = jt.diffed) && u(e), 128 & e.__u ? void 0 : s;
}
function Y3(r, e, t) {
  for (var n = 0; n < t.length; n++) yd(t[n], t[++n], t[++n]);
  jt.__c && jt.__c(e, r), r.some(function(a) {
    try {
      r = a.__h, a.__h = [], r.some(function(o) {
        o.call(a);
      });
    } catch (o) {
      jt.__e(o, a.__v);
    }
  });
}
function G3(r) {
  return typeof r != "object" || r == null || r.__b && r.__b > 0 ? r : cu(r) ? r.map(G3) : jn({}, r);
}
function q7(r, e, t, n, a, o, i, s, l) {
  var c, u, d, w, f, A, b, g = t.props, k = e.props, v = e.type;
  if (v == "svg" ? a = "http://www.w3.org/2000/svg" : v == "math" ? a = "http://www.w3.org/1998/Math/MathML" : a || (a = "http://www.w3.org/1999/xhtml"), o != null) {
    for (c = 0; c < o.length; c++) if ((f = o[c]) && "setAttribute" in f == !!v && (v ? f.localName == v : f.nodeType == 3)) {
      r = f, o[c] = null;
      break;
    }
  }
  if (r == null) {
    if (v == null) return document.createTextNode(k);
    r = document.createElementNS(a, v, k.is && k), s && (jt.__m && jt.__m(e, o), s = !1), o = null;
  }
  if (v == null) g === k || s && r.data == k || (r.data = k);
  else {
    if (o = o && fc.call(r.childNodes), g = t.props || Ps, !s && o != null) for (g = {}, c = 0; c < r.attributes.length; c++) g[(f = r.attributes[c]).name] = f.value;
    for (c in g) if (f = g[c], c != "children") {
      if (c == "dangerouslySetInnerHTML") d = f;
      else if (!(c in k)) {
        if (c == "value" && "defaultValue" in k || c == "checked" && "defaultChecked" in k) continue;
        Cc(r, c, null, f, a);
      }
    }
    for (c in k) f = k[c], c == "children" ? w = f : c == "dangerouslySetInnerHTML" ? u = f : c == "value" ? A = f : c == "checked" ? b = f : s && typeof f != "function" || g[c] === f || Cc(r, c, f, g[c], a);
    if (u) s || d && (u.__html == d.__html || u.__html == r.innerHTML) || (r.innerHTML = u.__html), e.__k = [];
    else if (d && (r.innerHTML = ""), W3(e.type == "template" ? r.content : r, cu(w) ? w : [w], e, t, n, v == "foreignObject" ? "http://www.w3.org/1999/xhtml" : a, o, i, o ? o[0] : t.__k && Xo(t, 0), s, l), o != null) for (c = o.length; c--; ) gd(o[c]);
    s || (c = "value", v == "progress" && A == null ? r.removeAttribute("value") : A != null && (A !== r[c] || v == "progress" && !A || v == "option" && A != g[c]) && Cc(r, c, A, g[c], a), c = "checked", b != null && b != r[c] && Cc(r, c, b, g[c], a));
  }
  return r;
}
function yd(r, e, t) {
  try {
    if (typeof r == "function") {
      var n = typeof r.__u == "function";
      n && r.__u(), n && e == null || (r.__u = r(e));
    } else r.current = e;
  } catch (a) {
    jt.__e(a, t);
  }
}
function J3(r, e, t) {
  var n, a;
  if (jt.unmount && jt.unmount(r), (n = r.ref) && (n.current && n.current != r.__e || yd(n, null, e)), (n = r.__c) != null) {
    if (n.componentWillUnmount) try {
      n.componentWillUnmount();
    } catch (o) {
      jt.__e(o, e);
    }
    n.base = n.__P = null;
  }
  if (n = r.__k) for (a = 0; a < n.length; a++) n[a] && J3(n[a], e, t || typeof r.type != "function");
  t || gd(r.__e), r.__c = r.__ = r.__e = void 0;
}
function W7(r, e, t) {
  return this.constructor(r, t);
}
function Vu(r, e, t) {
  var n, a, o, i;
  e == document && (e = document.documentElement), jt.__ && jt.__(r, e), a = (n = !1) ? null : e.__k, o = [], i = [], md(e, r = e.__k = _l(ln, null, [r]), a || Ps, Ps, e.namespaceURI, a ? null : e.firstChild ? fc.call(e.childNodes) : null, o, a ? a.__e : e.firstChild, n, i), Y3(o, r, i);
}
function go(r, e, t) {
  var n, a, o, i, s = jn({}, r.props);
  for (o in r.type && r.type.defaultProps && (i = r.type.defaultProps), e) o == "key" ? n = e[o] : o == "ref" ? a = e[o] : s[o] = e[o] === void 0 && i != null ? i[o] : e[o];
  return arguments.length > 2 && (s.children = arguments.length > 3 ? fc.call(arguments, 2) : t), Es(r.type, s, n || r.key, a || r.ref, null);
}
function Ao(r) {
  function e(t) {
    var n, a;
    return this.getChildContext || (n = /* @__PURE__ */ new Set(), (a = {})[e.__c] = this, this.getChildContext = function() {
      return a;
    }, this.componentWillUnmount = function() {
      n = null;
    }, this.shouldComponentUpdate = function(o) {
      this.props.value != o.value && n.forEach(function(i) {
        i.__e = !0, C1(i);
      });
    }, this.sub = function(o) {
      n.add(o);
      var i = o.componentWillUnmount;
      o.componentWillUnmount = function() {
        n && n.delete(o), i && i.call(o);
      };
    }), t.children;
  }
  return e.__c = "__cC" + z3++, e.__ = r, e.Provider = e.__l = (e.Consumer = function(t, n) {
    return t.children(n);
  }).contextType = e, e;
}
fc = H3.slice, jt = { __e: function(r, e, t, n) {
  for (var a, o, i; e = e.__; ) if ((a = e.__c) && !a.__) try {
    if ((o = a.constructor) && o.getDerivedStateFromError != null && (a.setState(o.getDerivedStateFromError(r)), i = a.__d), a.componentDidCatch != null && (a.componentDidCatch(r, n || {}), i = a.__d), i) return a.__E = a;
  } catch (s) {
    r = s;
  }
  throw r;
} }, V3 = 0, ol.prototype.setState = function(r, e) {
  var t;
  t = this.__s != null && this.__s != this.state ? this.__s : this.__s = jn({}, this.state), typeof r == "function" && (r = r(jn({}, t), this.props)), r && jn(t, r), r != null && this.__v && (e && this._sb.push(e), C1(this));
}, ol.prototype.forceUpdate = function(r) {
  this.__v && (this.__e = !0, r && this.__h.push(r), C1(this));
}, ol.prototype.render = ln, Za = [], $3 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, j3 = function(r, e) {
  return r.__v.__b - e.__v.__b;
}, bl.__r = 0, F3 = /(PointerCapture)$|Capture$/i, pd = 0, k1 = h0(!1), A1 = h0(!0), z3 = 0;
var K7 = 0;
function T(r, e, t, n, a, o) {
  e || (e = {});
  var i, s, l = e;
  if ("ref" in l) for (s in l = {}, e) s == "ref" ? i = e[s] : l[s] = e[s];
  var c = { type: r, props: l, key: t, ref: i, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --K7, __i: -1, __u: 0, __source: a, __self: o };
  if (typeof r == "function" && (i = r.defaultProps)) for (s in i) l[s] === void 0 && (l[s] = i[s]);
  return jt.vnode && jt.vnode(c), c;
}
var Zo, Gt, $u, f0, Ns = 0, X3 = [], cr = jt, p0 = cr.__b, g0 = cr.__r, m0 = cr.diffed, y0 = cr.__c, w0 = cr.unmount, v0 = cr.__;
function lu(r, e) {
  cr.__h && cr.__h(Gt, r, Ns || e), Ns = 0;
  var t = Gt.__H || (Gt.__H = { __: [], __h: [] });
  return r >= t.__.length && t.__.push({}), t.__[r];
}
function dt(r) {
  return Ns = 1, Y7(Q3, r);
}
function Y7(r, e, t) {
  var n = lu(Zo++, 2);
  if (n.t = r, !n.__c && (n.__ = [Q3(void 0, e), function(s) {
    var l = n.__N ? n.__N[0] : n.__[0], c = n.t(l, s);
    l !== c && (n.__N = [c, n.__[1]], n.__c.setState({}));
  }], n.__c = Gt, !Gt.__f)) {
    var a = function(s, l, c) {
      if (!n.__c.__H) return !0;
      var u = n.__c.__H.__.filter(function(w) {
        return !!w.__c;
      });
      if (u.every(function(w) {
        return !w.__N;
      })) return !o || o.call(this, s, l, c);
      var d = n.__c.props !== s;
      return u.forEach(function(w) {
        if (w.__N) {
          var f = w.__[0];
          w.__ = w.__N, w.__N = void 0, f !== w.__[0] && (d = !0);
        }
      }), o && o.call(this, s, l, c) || d;
    };
    Gt.__f = !0;
    var o = Gt.shouldComponentUpdate, i = Gt.componentWillUpdate;
    Gt.componentWillUpdate = function(s, l, c) {
      if (this.__e) {
        var u = o;
        o = void 0, a(s, l, c), o = u;
      }
      i && i.call(this, s, l, c);
    }, Gt.shouldComponentUpdate = a;
  }
  return n.__N || n.__;
}
function kr(r, e) {
  var t = lu(Zo++, 3);
  !cr.__s && Z3(t.__H, e) && (t.__ = r, t.u = e, Gt.__H.__h.push(t));
}
function G7(r) {
  return Ns = 5, Ut(function() {
    return { current: r };
  }, []);
}
function Ut(r, e) {
  var t = lu(Zo++, 7);
  return Z3(t.__H, e) && (t.__ = r(), t.__H = e, t.__h = r), t.__;
}
function ht(r, e) {
  return Ns = 8, Ut(function() {
    return r;
  }, e);
}
function Br(r) {
  var e = Gt.context[r.__c], t = lu(Zo++, 9);
  return t.c = r, e ? (t.__ == null && (t.__ = !0, e.sub(Gt)), e.props.value) : r.__;
}
function J7() {
  for (var r; r = X3.shift(); ) if (r.__P && r.__H) try {
    r.__H.__h.forEach(il), r.__H.__h.forEach(D1), r.__H.__h = [];
  } catch (e) {
    r.__H.__h = [], cr.__e(e, r.__v);
  }
}
cr.__b = function(r) {
  Gt = null, p0 && p0(r);
}, cr.__ = function(r, e) {
  r && e.__k && e.__k.__m && (r.__m = e.__k.__m), v0 && v0(r, e);
}, cr.__r = function(r) {
  g0 && g0(r), Zo = 0;
  var e = (Gt = r.__c).__H;
  e && ($u === Gt ? (e.__h = [], Gt.__h = [], e.__.forEach(function(t) {
    t.__N && (t.__ = t.__N), t.u = t.__N = void 0;
  })) : (e.__h.forEach(il), e.__h.forEach(D1), e.__h = [], Zo = 0)), $u = Gt;
}, cr.diffed = function(r) {
  m0 && m0(r);
  var e = r.__c;
  e && e.__H && (e.__H.__h.length && (X3.push(e) !== 1 && f0 === cr.requestAnimationFrame || ((f0 = cr.requestAnimationFrame) || X7)(J7)), e.__H.__.forEach(function(t) {
    t.u && (t.__H = t.u), t.u = void 0;
  })), $u = Gt = null;
}, cr.__c = function(r, e) {
  e.some(function(t) {
    try {
      t.__h.forEach(il), t.__h = t.__h.filter(function(n) {
        return !n.__ || D1(n);
      });
    } catch (n) {
      e.some(function(a) {
        a.__h && (a.__h = []);
      }), e = [], cr.__e(n, t.__v);
    }
  }), y0 && y0(r, e);
}, cr.unmount = function(r) {
  w0 && w0(r);
  var e, t = r.__c;
  t && t.__H && (t.__H.__.forEach(function(n) {
    try {
      il(n);
    } catch (a) {
      e = a;
    }
  }), t.__H = void 0, e && cr.__e(e, t.__v));
};
var _0 = typeof requestAnimationFrame == "function";
function X7(r) {
  var e, t = function() {
    clearTimeout(n), _0 && cancelAnimationFrame(e), setTimeout(r);
  }, n = setTimeout(t, 35);
  _0 && (e = requestAnimationFrame(t));
}
function il(r) {
  var e = Gt, t = r.__c;
  typeof t == "function" && (r.__c = void 0, t()), Gt = e;
}
function D1(r) {
  var e = Gt;
  r.__c = r.__(), Gt = e;
}
function Z3(r, e) {
  return !r || r.length !== e.length || e.some(function(t, n) {
    return t !== r[n];
  });
}
function Q3(r, e) {
  return typeof e == "function" ? e(r) : e;
}
function e5(r) {
  var e, t, n = "";
  if (typeof r == "string" || typeof r == "number") n += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var a = r.length;
    for (e = 0; e < a; e++) r[e] && (t = e5(r[e])) && (n && (n += " "), n += t);
  } else for (t in r) r[t] && (n && (n += " "), n += t);
  return n;
}
function Ke() {
  for (var r, e, t = 0, n = "", a = arguments.length; t < a; t++) (r = arguments[t]) && (e = e5(r)) && (n && (n += " "), n += e);
  return n;
}
const Z7 = "_stack_1lu6v_81", Q7 = "_stack--align-center_1lu6v_88", ey = "_stack--align-end_1lu6v_91", ty = "_stack--justify-between_1lu6v_94", ry = "_stack--full-height_1lu6v_97", ny = "_stack--full-width_1lu6v_100", ay = "_stack--grow_1lu6v_103", oy = "_stack--justify-center_1lu6v_106", iy = "_stack--justify-end_1lu6v_109", sy = "_stack--justify-evenly_1lu6v_112", cy = "_stack--spacing-xs_1lu6v_115", ly = "_stack--spacing-sm_1lu6v_118", uy = "_stack--spacing-md_1lu6v_121", dy = "_stack--spacing-lg_1lu6v_124", hy = "_stack--spacing-xl_1lu6v_127", fy = "_stack--vertical_1lu6v_130", mr = {
  stack: Z7,
  stackAlignCenter: Q7,
  stackAlignEnd: ey,
  stackJustifyBetween: ty,
  stackFullHeight: ry,
  stackFullWidth: ny,
  stackGrow: ay,
  stackJustifyCenter: oy,
  stackJustifyEnd: iy,
  stackJustifyEvenly: sy,
  stackSpacingXs: cy,
  stackSpacingSm: ly,
  stackSpacingMd: uy,
  stackSpacingLg: dy,
  stackSpacingXl: hy,
  stackVertical: fy
}, Vi = ({
  align: r = "start",
  className: e,
  direction: t = "horizontal",
  children: n,
  fullHeight: a = !1,
  fullWidth: o = !1,
  grow: i = !1,
  height: s,
  justify: l = "start",
  maxHeight: c,
  maxWidth: u,
  minHeight: d,
  minWidth: w,
  padding: f,
  paddingBottom: A,
  paddingLeft: b,
  paddingRight: g,
  paddingTop: k,
  paddingX: v,
  paddingY: C,
  spacing: W,
  width: Z
}) => {
  const D = Ut(() => {
    switch (r) {
      case "center":
        return mr.stackAlignCenter;
      case "end":
        return mr.stackAlignEnd;
      case "start":
      default:
        return mr.stackAlignStart;
    }
  }, [r]), H = Ut(() => {
    switch (l) {
      case "between":
        return mr.stackJustifyBetween;
      case "center":
        return mr.stackJustifyCenter;
      case "end":
        return mr.stackJustifyEnd;
      case "evenly":
        return mr.stackJustifyEvenly;
      case "start":
      default:
        return mr.stackJustifyStart;
    }
  }, [l]), y = Ut(() => {
    switch (W) {
      case "xs":
        return mr.stackSpacingXs;
      case "sm":
        return mr.stackSpacingSm;
      case "md":
        return mr.stackSpacingMd;
      case "lg":
        return mr.stackSpacingLg;
      case "xl":
        return mr.stackSpacingXl;
      default:
        return null;
    }
  }, [W]);
  return /* @__PURE__ */ T(
    "div",
    {
      className: Ke(
        e,
        mr.stack,
        D,
        H,
        y,
        t === "vertical" ? mr.stackVertical : mr.stackHorizontal,
        a && mr.stackFullHeight,
        o && mr.stackFullWidth,
        i && mr.stackGrow
      ),
      style: {
        ...s && {
          height: typeof s == "number" ? `${s}px` : s
        },
        ...c && {
          maxHeight: typeof c == "number" ? `${c}px` : c
        },
        ...u && {
          maxWidth: typeof u == "number" ? `${u}px` : u
        },
        ...d && {
          minHeight: typeof d == "number" ? `${d}px` : d
        },
        ...w && {
          minWidth: typeof w == "number" ? `${w}px` : w
        },
        ...f && {
          padding: typeof f == "number" ? `${f}px ${f}px ${f}px ${f}px` : `${f} ${f} ${f} ${f}`
        },
        ...A && {
          paddingBottom: typeof A == "number" ? `${A}px` : A
        },
        ...b && {
          paddingLeft: typeof b == "number" ? `${b}px` : b
        },
        ...g && {
          paddingRight: typeof g == "number" ? `${g}px` : g
        },
        ...k && {
          paddingTop: typeof k == "number" ? `${k}px` : k
        },
        ...v && {
          paddingLeft: typeof v == "number" ? `${v}px` : v,
          paddingRight: typeof v == "number" ? `${v}px` : v
        },
        ...C && {
          paddingBottom: typeof C == "number" ? `${C}px` : C,
          paddingTop: typeof C == "number" ? `${C}px` : C
        },
        ...Z && {
          width: typeof s == "number" ? `${Z}px` : Z
        }
      },
      children: n
    }
  );
}, $t = (r) => /* @__PURE__ */ T(Vi, { ...r, direction: "horizontal" });
function py(r) {
  return r === "dark" ? "#1A202C" : "#FFFFFF";
}
function gy(r) {
  return r === "dark" ? "#E0B0FF" : "#8D029B";
}
const my = "_button_1ou26_90", yy = "_button--full-width_1ou26_128", wy = "_button--disabled_1ou26_131", vy = "_button--secondary_1ou26_159", _y = "_button--xs_1ou26_177", by = "_button--sm_1ou26_184", Sy = "_button--lg_1ou26_191", Ey = "_button--xl_1ou26_198", xy = "_icon_1ou26_206", ky = "_icon--xs_1ou26_210", Ay = "_icon--lg_1ou26_218", Cy = "_icon--xl_1ou26_222", Cr = {
  button: my,
  buttonFullWidth: yy,
  buttonDisabled: wy,
  buttonSecondary: vy,
  buttonXs: _y,
  buttonSm: by,
  buttonLg: Sy,
  buttonXl: Ey,
  icon: xy,
  iconXs: ky,
  iconLg: Ay,
  iconXl: Cy
}, un = ({
  children: r,
  className: e,
  colorMode: t,
  disabled: n = !1,
  fullWidth: a = !1,
  leftIcon: o,
  rightIcon: i,
  size: s = "md",
  variant: l = "primary",
  ...c
}) => {
  const u = py(t), d = gy(t), [w, f] = Ut(() => l === "secondary" ? [Cr.buttonSecondary, d] : [Cr.buttonPrimary, u], [u, d, l]), [A, b] = Ut(() => {
    switch (s) {
      case "xs":
        return [Cr.buttonXs, Cr.iconXs];
      case "sm":
        return [Cr.buttonSm, Cr.iconXs];
      case "lg":
        return [Cr.buttonLg, Cr.iconLg];
      case "xl":
        return [Cr.buttonXl, Cr.iconXl];
      case "md":
      default:
        return [Cr.buttonMd, Cr.iconMd];
    }
  }, [s]);
  return /* @__PURE__ */ T(
    "button",
    {
      ...c,
      className: Ke(Cr.button, A, w, n && Cr.buttonDisabled, a && Cr.buttonFullWidth, e),
      "data-color-mode": t,
      children: o || i ? /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "center", spacing: "xs", children: [
        o && go(o, {
          className: Ke(Cr.icon, b),
          color: f
        }),
        r,
        i && go(i, {
          className: Ke(Cr.icon, b),
          color: f
        })
      ] }) : r
    }
  );
};
function Tn(r) {
  return r === "dark" ? "rgba(255, 255, 255, 0.80)" : "#4A5568";
}
const Dy = "_container_1t9k0_66", My = "_container--xs_1t9k0_74", Ry = "_container--sm_1t9k0_78", Iy = "_container--lg_1t9k0_82", Ty = "_container--xl_1t9k0_86", Oy = "_icon_1t9k0_91", Py = "_icon--xs_1t9k0_95", Ny = "_icon--sm_1t9k0_99", By = "_icon--lg_1t9k0_103", Ly = "_icon--xl_1t9k0_107", Uy = "_loader_1t9k0_112", Vy = "_loader--lg_1t9k0_129", $y = "_loader--xl_1t9k0_132", _r = {
  container: Dy,
  containerXs: My,
  containerSm: Ry,
  containerLg: Iy,
  containerXl: Ty,
  icon: Oy,
  iconXs: Py,
  iconSm: Ny,
  iconLg: By,
  iconXl: Ly,
  loader: Uy,
  loaderLg: Vy,
  loaderXl: $y
}, wd = ({ color: r, colorMode: e, icon: t, size: n = "md", trackColor: a }) => {
  const o = Tn(e), [i, s, l] = Ut(() => {
    switch (n) {
      case "xs":
        return [_r.containerXs, _r.iconXs, _r.loaderXs];
      case "sm":
        return [_r.containerSm, _r.iconSm, _r.loaderSm];
      case "lg":
        return [_r.containerLg, _r.iconLg, _r.loaderLg];
      case "xl":
        return [_r.containerXl, _r.iconXl, _r.loaderXl];
      case "md":
      default:
        return [_r.containerMd, _r.iconMd, _r.loaderMd];
    }
  }, [n]);
  return /* @__PURE__ */ T("div", { className: Ke(_r.container, i), children: [
    /* @__PURE__ */ T(
      "span",
      {
        className: Ke(_r.loader, l),
        "data-color-mode": e,
        style: {
          ...r && {
            borderColor: r
          },
          ...a && {
            borderBottomColor: a
          }
        }
      }
    ),
    go(t, {
      ...t.props,
      className: Ke(_r.icon, s),
      color: o
    })
  ] });
}, jy = "_text_xvwg2_90", Fy = "_text__align--center_xvwg2_105", zy = "_text__align--initial_xvwg2_108", Hy = "_text__align--justify_xvwg2_111", qy = "_text__align--justify-all_xvwg2_114", Wy = "_text__align--left_xvwg2_117", Ky = "_text__align--right_xvwg2_120", Yy = "_text--bold_xvwg2_123", Gy = "_text--full-width_xvwg2_126", Jy = "_text--xs_xvwg2_129", Xy = "_text--sm_xvwg2_133", Zy = "_text--lg_xvwg2_137", Qy = "_text--xl_xvwg2_140", e9 = "_text--truncate_xvwg2_143", Or = {
  text: jy,
  textAlignCenter: Fy,
  textAlignInitial: zy,
  textAlignJustify: Hy,
  textAlignJustifyAll: qy,
  textAlignLeft: Wy,
  textAlignRight: Ky,
  textBold: Yy,
  textFullWidth: Gy,
  textXs: Jy,
  textSm: Xy,
  textLg: Zy,
  textXl: Qy,
  textTruncate: e9
}, qt = ({
  bold: r = !1,
  children: e,
  color: t,
  colorMode: n,
  className: a,
  fullWidth: o = !1,
  height: i,
  maxHeight: s,
  maxWidth: l,
  minHeight: c,
  minWidth: u,
  size: d = "md",
  textAlign: w = "inherit",
  title: f,
  truncate: A = !1,
  width: b
}) => {
  const g = Ut(() => {
    switch (d) {
      case "xs":
        return Or.textXs;
      case "sm":
        return Or.textSm;
      case "lg":
        return Or.textLg;
      case "xl":
        return Or.textXl;
      case "md":
      default:
        return Or.textMd;
    }
  }, [d]), k = Ut(() => {
    switch (w) {
      case "center":
        return Or.textAlignCenter;
      case "initial":
        return Or.textAlignInitial;
      case "justify":
        return Or.textAlignJustify;
      case "justify-all":
        return Or.textAlignJustifyAll;
      case "left":
        return Or.textAlignLeft;
      case "right":
        return Or.textAlignRight;
      case "inherit":
      default:
        return Or.textAlignInherit;
    }
  }, [w]);
  return /* @__PURE__ */ T(
    "p",
    {
      className: Ke(
        Or.text,
        g,
        k,
        r && Or.textBold,
        o && Or.textFullWidth,
        A && Or.textTruncate,
        a
      ),
      "data-color-mode": n,
      style: {
        ...t && {
          color: t
        },
        ...i && {
          height: typeof i == "number" ? `${i}px` : i
        },
        ...s && {
          maxHeight: typeof s == "number" ? `${s}px` : s
        },
        ...l && {
          maxWidth: typeof l == "number" ? `${l}px` : l
        },
        ...c && {
          minHeight: typeof c == "number" ? `${c}px` : c
        },
        ...u && {
          minWidth: typeof u == "number" ? `${u}px` : u
        },
        ...b && {
          width: typeof i == "number" ? `${b}px` : b
        }
      },
      title: f || (typeof e == "string" ? e : void 0),
      children: e
    }
  );
}, t9 = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "#000000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("circle", { cx: "12", cy: "12", r: "10" }),
      /* @__PURE__ */ T("path", { d: "m15 9-6 6" }),
      /* @__PURE__ */ T("path", { d: "m9 9 6 6" })
    ]
  }
), r9 = "_container_chktv_81", n9 = "_icon_chktv_90", b0 = {
  container: r9,
  icon: n9
}, S0 = ({ colorMode: r, message: e }) => {
  const t = Tn("dark");
  return /* @__PURE__ */ T("div", { className: Ke(b0.container), "data-color-mode": r, children: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, padding: "0.75rem", spacing: "sm", children: [
    /* @__PURE__ */ T(t9, { className: b0.icon, color: t }),
    /* @__PURE__ */ T(qt, { colorMode: r, color: t, fullWidth: !0, size: "sm", textAlign: "left", children: e })
  ] }) });
}, a9 = "_link_r51yu_90", o9 = {
  link: a9
}, i9 = ({
  children: r,
  colorMode: e,
  isExternal: t = !1,
  ...n
}) => /* @__PURE__ */ T(
  "a",
  {
    ...n,
    className: Ke(o9.link),
    "data-color-mode": e,
    ...t && {
      target: "_blank"
    },
    children: r
  }
), Dt = (r) => /* @__PURE__ */ T(Vi, { ...r, direction: "vertical" }), Xt = "1.25rem", s9 = "https://docs.katavault.kibis.is", vd = Ao(null), uu = Ao({
  onUpdate: null,
  state: null,
  timestamp: 0
}), t5 = Ao({
  onUpdate: null,
  state: null,
  timestamp: 0
}), _d = Ao(null), bd = Ao([]), Sd = Ao(null), pc = Ao(null);
function On() {
  const { state: r } = Br(uu);
  return (r == null ? void 0 : r.i18n.t) || (() => "");
}
const c9 = ({ color: r, title: e, ...t }) => /* @__PURE__ */ T("svg", { viewBox: "0 0 4244 796", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e && /* @__PURE__ */ T("title", { children: e }),
  /* @__PURE__ */ T(
    "path",
    {
      d: "m 426,794.36832 c -3.66667,-0.69547 -7.87983,-1.48993 -9.36257,-1.76548 -1.48275,-0.27555 -9.27615,-6.37392 -17.31868,-13.55192 C 385.82572,767.00829 232.07355,628.62933 126.71997,533.70845 L 82,493.41691 81.306005,629.04179 c -0.480954,93.99128 -1.146172,136.87669 -2.167,139.70277 -2.534752,7.01725 -5.422366,11.76591 -9.9433,16.35167 -7.811425,7.92342 -9.984592,8.47165 -31.704046,7.99804 l -19.609511,-0.4276 -5.647877,-4.47716 C 9.1279395,785.72707 5.5544563,781.82707 4.2931976,779.52284 2.1511983,775.60956 1.9466659,755.99288 1.1910909,482 0.74619097,320.66667 0.75752649,150.26185 1.216281,103.32263 L 2.0503801,17.978596 5.0486715,13.127259 C 10.644782,4.0725628 19.763869,0.8741768 40,0.86859393 58.185801,0.86357672 65.13124,2.4645739 70.585555,7.9188883 c 2.659916,2.6599167 6.016314,7.2163147 7.458661,10.1253277 2.544,5.130893 2.642395,9.470779 3.289117,145.073704 L 82,302.90251 146,245.25337 C 365.46863,47.563145 406.23113,10.96769 411.16848,7.1924493 c 3.53865,-2.7057522 7.87416,-4.5680645 12.16485,-5.2253949 14.83299,-2.27240132 36.58783,-0.4596127 41.57942,3.4647311 3.77864,2.97073 33.20957,29.3336345 120.42058,107.8673145 320.94803,289.0143 288.20035,258.67725 291.41635,269.96461 2.92065,10.25072 1.93472,23.54992 -2.4556,33.12354 -3.85209,8.39999 -3.37119,7.9478 -122.37264,115.06416 -228.30409,205.50258 -262.82703,236.57496 -275.72077,248.16274 -7.58963,6.8209 -15.08963,12.63541 -16.66667,12.92113 -1.57703,0.28572 -6.50345,1.18217 -10.9476,1.99211 -9.15541,1.66856 -13.09707,1.6408 -22.5864,-0.15907 z M 79.675264,656.44435 c -0.268567,-77.14791 -0.699528,-98.3415 -2.008597,-98.77778 -0.933095,-0.31097 -1.65768,0.52044 -1.64625,1.88899 0.01725,2.06609 0.220471,2.13488 1.312916,0.44444 0.840862,-1.30113 1.292499,32.24419 1.292499,96 0,63.75581 -0.451637,97.30113 -1.292499,96 -1.104568,-1.7092 -1.295468,-1.66073 -1.312916,0.33333 -0.0112,1.28334 0.883452,2.33334 1.98818,2.33334 1.774159,0 1.968688,-11.46431 1.666667,-98.22232 z m 409.608246,-3.7276 c 84.32222,-75.83972 100.42661,-90.39486 118.04982,-106.69342 9.53334,-8.81674 40.34794,-36.72885 68.4769,-62.02689 L 726.95377,438 582.91683,437.66073 c -79.22034,-0.1866 -209.25422,-0.1866 -288.96419,0 L 149.02543,438 l 51.15394,45.98153 c 28.13468,25.28984 58.65396,52.91962 67.82063,61.39948 9.16667,8.47987 46.96667,42.6563 84,75.94762 37.03333,33.29132 71.43075,64.34566 76.43869,69.00966 7.89266,7.35059 9.39547,8.24794 11.28351,6.73752 1.19799,-0.95836 23.50057,-20.91994 49.56131,-44.35906 z M 340,615.41203 c 0,-0.32339 -0.6,-0.9588 -1.33333,-1.41203 -0.73334,-0.45323 -1.33334,-0.18864 -1.33334,0.58797 0,0.77662 0.6,1.41203 1.33334,1.41203 C 339.4,616 340,615.73541 340,615.41203 Z M 212,604 c 0,-0.73333 -0.63541,-1.33333 -1.41203,-1.33333 -0.77661,0 -1.0412,0.6 -0.58797,1.33333 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32338,0 0.58797,-0.6 0.58797,-1.33333 z m 101.33333,-12.58797 c 0,-0.32339 -0.6,-0.9588 -1.33333,-1.41203 -0.73333,-0.45323 -1.33333,-0.18864 -1.33333,0.58797 0,0.77662 0.6,1.41203 1.33333,1.41203 0.73333,0 1.33333,-0.26459 1.33333,-0.58797 z m -128,-12 c 0,-0.32339 -0.6,-0.9588 -1.33333,-1.41203 -0.73333,-0.45323 -1.33333,-0.18864 -1.33333,0.58797 0,0.77662 0.6,1.41203 1.33333,1.41203 0.73333,0 1.33333,-0.26459 1.33333,-0.58797 z m 101.33334,-12 c 0,-0.32339 -0.6,-0.9588 -1.33334,-1.41203 C 284.6,565.54677 284,565.81136 284,566.58797 c 0,0.77662 0.6,1.41203 1.33333,1.41203 0.73334,0 1.33334,-0.26459 1.33334,-0.58797 z M 157.33333,554.66667 c 0,-0.73334 -0.63541,-1.33334 -1.41202,-1.33334 -0.77662,0 -1.0412,0.6 -0.58798,1.33334 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32339,0 0.58797,-0.6 0.58797,-1.33333 z m 112,-2.66667 c 0,-0.73333 -0.63541,-1.33333 -1.41202,-1.33333 -0.77662,0 -1.0412,0.6 -0.58798,1.33333 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32339,0 0.58797,-0.6 0.58797,-1.33333 z m -14.66666,-14.58797 c 0,-1.57315 -2.60047,-3.256 -3.55556,-2.30092 -0.95508,0.95509 0.72777,3.55556 2.30092,3.55556 0.69005,0 1.25464,-0.56459 1.25464,-1.25464 z m -124,-6.74536 c 0,-0.73334 -0.63541,-1.33334 -1.41203,-1.33334 -0.77661,0 -1.0412,0.6 -0.58797,1.33334 C 129.11989,531.4 129.7553,532 130.07869,532 c 0.32339,0 0.58798,-0.6 0.58798,-1.33333 z M 240,525.33333 C 240,524.6 239.36459,524 238.58797,524 c -0.77661,0 -1.0412,0.6 -0.58797,1.33333 0.45323,0.73334 1.08864,1.33334 1.41203,1.33334 0.32338,0 0.58797,-0.6 0.58797,-1.33334 z M 227.14884,512.66667 C 226.33737,510.55203 224,509.89221 224,511.77777 c 0,1.41003 1.45745,2.8889 2.84704,2.8889 0.58809,0 0.72391,-0.9 0.3018,-2 z m -122.48217,-6 c -0.45323,-0.73334 -1.38864,-1.33334 -2.07869,-1.33334 -0.69006,0 -1.25465,0.6 -1.25465,1.33334 0,0.73333 0.93541,1.33333 2.07869,1.33333 1.14328,0 1.70787,-0.6 1.25465,-1.33333 z m 94.24444,-18.95556 c -0.95675,-0.95675 -1.57778,-1.03547 -1.57778,-0.2 0,1.7797 1.57682,3.35652 2.46667,2.46666 0.37889,-0.37888 -0.0211,-1.39888 -0.88889,-2.26666 z M 186.66667,476 c 0,-0.73333 -0.6,-1.33333 -1.33334,-1.33333 -0.73333,0 -1.33333,0.6 -1.33333,1.33333 0,0.73333 0.6,1.33333 1.33333,1.33333 0.73334,0 1.33334,-0.6 1.33334,-1.33333 z m -13.86111,-12.97223 c -1.35536,-1.35534 -2.47367,0.68519 -1.36163,2.48451 0.84004,1.35923 1.15411,1.36028 1.60574,0.005 0.3088,-0.92638 0.19894,-2.04684 -0.24411,-2.48989 z M 160,452.74536 c 0,-0.32339 -0.6,-0.9588 -1.33333,-1.41203 -0.73334,-0.45322 -1.33334,-0.18864 -1.33334,0.58798 0,0.77661 0.6,1.41202 1.33334,1.41202 0.73333,0 1.33333,-0.26458 1.33333,-0.58797 z M 146.66667,440 c 0,-0.73333 -0.6,-1.33333 -1.33334,-1.33333 -0.73333,0 -1.33333,0.6 -1.33333,1.33333 0,0.73333 0.6,1.33333 1.33333,1.33333 0.73334,0 1.33334,-0.6 1.33334,-1.33333 z m 135.27638,-5.2412 c 0.42192,-0.68267 0.12854,-1.63583 -0.65182,-2.11815 -1.97328,-1.21956 -5.64275,0.37855 -4.63039,2.0166 1.04213,1.68619 4.26456,1.74815 5.28221,0.1016 z m 439.34267,-83.25087 c -1.07381,-1.00397 -23.55239,-21.21881 -49.95239,-44.92186 -26.4,-23.70306 -54.9,-49.49098 -63.33333,-57.3065 C 571.05364,215.03989 439.47481,97.288857 438.53847,97.626988 437.97036,97.832145 424.1168,110.03661 407.75277,124.74802 332.47647,192.42213 278.80988,240.88152 258,259.97047 245.53333,271.40617 217.48333,296.83521 195.66667,316.47945 173.85,336.12369 156,352.45209 156,352.7648 c 0,0.31269 127.62857,0.56853 283.61905,0.56853 240.11086,0 283.31954,-0.28002 281.66667,-1.8254 z m -55.95239,-56.84126 c 0,-0.73334 -0.63541,-1.33334 -1.41202,-1.33334 -0.77662,0 -1.0412,0.6 -0.58798,1.33334 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32339,0 0.58797,-0.6 0.58797,-1.33333 z m 109.33334,-5.92131 c 0,-0.32339 -0.6,-0.9588 -1.33334,-1.41203 C 772.6,286.88011 772,287.14469 772,287.92131 c 0,0.77661 0.6,1.41202 1.33333,1.41202 0.73334,0 1.33334,-0.26458 1.33334,-0.58797 z m -123.75556,-7.70092 c -0.95675,-0.95675 -1.57778,-1.03547 -1.57778,-0.2 0,1.77971 1.57682,3.35652 2.46667,2.46667 0.37889,-0.37888 -0.0211,-1.39888 -0.88889,-2.26667 z m 110.42222,-4.29908 c 0,-0.32339 -0.6,-0.9588 -1.33333,-1.41203 -0.73333,-0.45322 -1.33333,-0.18864 -1.33333,0.58798 0,0.77661 0.6,1.41202 1.33333,1.41202 0.73333,0 1.33333,-0.26458 1.33333,-0.58797 z m -123.75556,-7.70092 c -0.95674,-0.95675 -1.57777,-1.03547 -1.57777,-0.2 0,1.77971 1.57681,3.35652 2.46667,2.46667 0.37889,-0.37888 -0.0211,-1.39888 -0.8889,-2.26667 z M 748,264 c 0,-0.73333 -0.6,-1.33333 -1.33333,-1.33333 -0.73334,0 -1.33334,0.6 -1.33334,1.33333 0,0.73333 0.6,1.33333 1.33334,1.33333 0.73333,0 1.33333,-0.6 1.33333,-1.33333 z m -122.66667,-5.25464 c 0,-1.57315 -2.60046,-3.256 -3.55556,-2.30092 -0.95508,0.95509 0.72778,3.55556 2.30092,3.55556 0.69006,0 1.25464,-0.56459 1.25464,-1.25464 z m 109.33334,-6 c 0,-0.32339 -0.6,-0.9588 -1.33334,-1.41203 C 732.6,250.88011 732,251.14469 732,251.92131 c 0,0.77661 0.6,1.41202 1.33333,1.41202 0.73334,0 1.33334,-0.26458 1.33334,-0.58797 z M 608.24444,242.37777 c -0.95675,-0.95674 -1.57777,-1.03546 -1.57777,-0.2 0,1.77971 1.57681,3.35652 2.46666,2.46667 0.3789,-0.37888 -0.0211,-1.39888 -0.88889,-2.26667 z M 721.33333,240 c 0,-0.73333 -0.93541,-1.33333 -2.07869,-1.33333 -1.14328,0 -1.70787,0.6 -1.25464,1.33333 0.45323,0.73333 1.38864,1.33333 2.07869,1.33333 0.69006,0 1.25464,-0.6 1.25464,-1.33333 z M 694,216 c -0.45323,-0.73333 -1.42404,-1.33333 -2.15737,-1.33333 -0.73334,0 -0.96252,0.6 -0.5093,1.33333 0.45323,0.73333 1.42404,1.33333 2.15738,1.33333 0.73333,0 0.96252,-0.6 0.50929,-1.33333 z m -27.33333,-24.58797 c 0,-0.32339 -0.6,-0.9588 -1.33334,-1.41203 C 664.6,189.54677 664,189.81136 664,190.58797 c 0,0.77662 0.6,1.41203 1.33333,1.41203 0.73334,0 1.33334,-0.26459 1.33334,-0.58797 z M 538.66667,180 c 0,-0.73333 -0.63542,-1.33333 -1.41203,-1.33333 -0.77661,0 -1.0412,0.6 -0.58797,1.33333 0.45322,0.73333 1.08864,1.33333 1.41202,1.33333 0.32339,0 0.58798,-0.6 0.58798,-1.33333 z M 512,156 c 0,-0.73333 -0.63541,-1.33333 -1.41203,-1.33333 -0.77661,0 -1.0412,0.6 -0.58797,1.33333 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32338,0 0.58797,-0.6 0.58797,-1.33333 z m 113.33333,-1.33333 c 0,-0.73334 -0.63541,-1.33334 -1.41202,-1.33334 -0.77662,0 -1.0412,0.6 -0.58798,1.33334 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32339,0 0.58797,-0.6 0.58797,-1.33333 z M 485.33333,132 c 0,-0.73333 -0.63541,-1.33333 -1.41202,-1.33333 -0.77662,0 -1.0412,0.6 -0.58798,1.33333 0.45323,0.73333 1.08864,1.33333 1.41203,1.33333 0.32339,0 0.58797,-0.6 0.58797,-1.33333 z m 73.33334,-37.921311 c 0,-0.323388 -0.6,-0.958797 -1.33334,-1.412022 C 556.6,92.213441 556,92.478032 556,93.254644 c 0,0.776612 0.6,1.412023 1.33333,1.412023 0.73334,0 1.33334,-0.26459 1.33334,-0.587978 z m -26.66667,-24 c 0,-0.323388 -0.6,-0.958797 -1.33333,-1.412022 -0.73334,-0.453226 -1.33334,-0.188635 -1.33334,0.587977 0,0.776612 0.6,1.412023 1.33334,1.412023 0.73333,0 1.33333,-0.26459 1.33333,-0.587978 z m -26.66667,-24 c 0,-0.323388 -0.6,-0.958797 -1.33333,-1.412022 -0.73333,-0.453226 -1.33333,-0.188635 -1.33333,0.587977 0,0.776612 0.6,1.412023 1.33333,1.412023 0.73333,0 1.33333,-0.26459 1.33333,-0.587978 z m -98,-28.745356 C 407.78656,16.6 407.55737,16 406.82404,16 c -0.73333,0 -1.70415,0.6 -2.15737,1.333333 -0.45323,0.733334 -0.22404,1.333334 0.50929,1.333334 0.73333,0 1.70415,-0.6 2.15737,-1.333334 z M 468,12.745356 c 0,-0.323388 -0.6,-0.958798 -1.33333,-1.412023 -0.73334,-0.453225 -1.33334,-0.188635 -1.33334,0.587978 0,0.776612 0.6,1.412022 1.33334,1.412022 0.73333,0 1.33333,-0.26459 1.33333,-0.587977 z M 1588.8464,665.24257 c -37.1291,-5.12804 -70.0305,-22.94096 -89.3276,-48.3621 -9.0144,-11.87514 -14.8705,-23.48434 -18.5075,-36.6891 -4.0528,-14.71448 -4.0053,-48.22036 0.089,-63.27664 9.7356,-35.79573 37.72,-57.18741 88.2324,-67.44617 29.7796,-6.04807 72.2222,-9.43371 118.537,-9.45567 l 27.2038,-0.0133 -0.8378,-14.33333 c -0.4608,-7.88334 -1.7722,-17.88842 -2.9142,-22.23352 -7.8226,-29.76092 -30.1032,-42.36694 -71.3222,-40.35272 -27.62,1.34969 -55.196,8.0352 -81.7502,19.81948 -10.3823,4.60745 -14.0078,5.53608 -23.7815,6.09144 -10.7071,0.60841 -12.0141,0.39276 -18.2756,-3.01518 C 1504.78,379.76464 1500,369.94315 1500,352.70523 c 0,-13.85846 2.606,-21.53306 10.1679,-29.94359 5.2668,-5.858 7.799,-7.32329 22.8772,-13.23755 42.3462,-16.60992 85.0262,-24.03634 128.9549,-22.43845 68.0633,2.4758 108.8369,23.4542 130.0548,66.91436 7.2041,14.75608 12.2495,32.41677 14.4745,50.66667 0.949,7.78264 1.4646,49.32118 1.467,118.19288 0,102.3415 -0.093,106.50521 -2.6562,114.80457 -3.3753,10.9282 -10.6798,19.4884 -20.2898,23.7778 -6.0095,2.68232 -9.2154,3.15019 -21.717,3.16945 -8.0666,0.012 -17.1914,-0.73637 -20.2773,-1.66401 -14.0997,-4.2386 -24.7932,-18.90655 -26.7335,-36.66976 l -0.9892,-9.05572 -6,8.28272 c -11.9678,16.52111 -34.9734,31.31267 -58,37.29131 -12.36,3.20918 -47.1136,4.56994 -62.4869,2.44666 z m 58.4395,-69.89425 c 24.4606,-4.35807 46.045,-20.90477 57.4153,-44.01499 6.0132,-12.22178 8.5384,-22.39722 9.5569,-38.5095 l 0.8328,-13.17618 -37.2121,0.7229 c -48.5333,0.94282 -67.0475,3.83628 -84.8509,13.26085 -14.7162,7.79031 -21.6871,22.96644 -18.2324,39.69344 4.5557,22.05849 21.4241,37.64763 45.4464,41.99989 12.5965,2.28218 14.3585,2.28371 27.044,0.0236 z m 385.5258,69.98295 c -58.9192,-7.35742 -95.3712,-36.07548 -109.2268,-86.05239 -5.7309,-20.67115 -6.2354,-30.55293 -6.2437,-122.27888 l -0.01,-87.66667 h -23.8324 c -17.9128,0 -25.2586,-0.50326 -29.575,-2.02616 -14.9127,-5.26149 -21.2299,-15.56484 -21.2388,-34.6405 -0.013,-15.3833 1.6078,-20.93303 8.16,-28.04123 8.0881,-8.77465 13.0888,-9.95877 42.057,-9.95877 h 24.4292 v -37.93438 c 0,-41.94104 0.7844,-48.30296 7.1152,-57.71078 8.891,-13.21243 22.3355,-18.33878 45.7195,-17.4327 17.8977,0.6935 25.848,3.73791 34.2945,13.13242 9.6022,10.67993 10.2042,14.22537 10.2042,60.09854 v 39.8469 h 44.1786 c 31.1259,0 45.7974,0.48498 49.6575,1.64149 7.3867,2.21312 17.4681,12.12187 19.3567,19.02517 0.8024,2.93334 1.4565,10.73334 1.4534,17.33334 -0.013,19.07566 -6.3261,29.37901 -21.2388,34.6405 -4.6922,1.65555 -13.7826,2.02616 -49.6969,2.02616 h -43.9541 l 0.5681,81 c 0.548,78.14956 0.6704,81.37538 3.476,91.66667 7.464,27.37845 23.98,40.06303 54.1995,41.62613 9.851,0.50956 16.2932,0.0712 24.6666,-1.6784 16.3704,-3.42058 28.1458,-3.352 32.9011,0.19164 7.8104,5.82022 9.0989,10.04879 9.0989,29.86063 0,36.50224 -6.4789,44.4318 -42,51.40404 -13.0618,2.56384 -50.4745,3.68133 -64.5216,1.92723 z m 238.7014,-0.0887 c -37.1291,-5.12804 -70.0306,-22.94096 -89.3276,-48.36211 -9.0144,-11.87513 -14.8706,-23.48433 -18.5075,-36.68909 -4.0528,-14.71448 -4.0053,-48.22036 0.089,-63.27664 9.7356,-35.79573 37.72,-57.18741 88.2324,-67.44617 29.7796,-6.04807 72.2223,-9.43371 118.5371,-9.45567 l 27.2037,-0.0133 -0.8377,-14.33334 c -0.4608,-7.88333 -1.7723,-17.88841 -2.9143,-22.23352 -7.8225,-29.76092 -30.1032,-42.36693 -71.3221,-40.35272 -27.62,1.3497 -55.196,8.0352 -81.7503,19.81948 -10.3822,4.60746 -14.0077,5.53608 -23.7814,6.09144 -10.7071,0.60842 -12.0142,0.39276 -18.2756,-3.01517 -11.4124,-6.21112 -16.1924,-16.03261 -16.1924,-33.27053 0,-13.85846 2.606,-21.53306 10.1678,-29.94359 5.2668,-5.858 7.7991,-7.32329 22.8772,-13.23755 42.3463,-16.60992 85.0263,-24.03634 128.955,-22.43845 68.0633,2.4758 108.8369,23.4542 130.0548,66.91436 7.2041,14.75608 12.2494,32.41677 14.4745,50.66667 0.9489,7.78264 1.4645,49.32118 1.4669,118.19288 0,102.3415 -0.093,106.50521 -2.6561,114.80457 -3.3753,10.9282 -10.6799,19.4884 -20.2899,23.7778 -6.0094,2.68232 -9.2153,3.15019 -21.7169,3.16945 -8.0667,0.012 -17.1915,-0.73637 -20.2773,-1.66401 -14.0998,-4.2386 -24.7932,-18.90655 -26.7335,-36.66976 l -0.9892,-9.05572 -6,8.28272 c -11.9679,16.52111 -34.9735,31.31267 -58,37.29131 -12.36,3.20918 -47.1136,4.56994 -62.4869,2.44666 z m 58.4394,-69.89425 c 24.4607,-4.35807 46.0451,-20.90478 57.4154,-44.01499 6.0132,-12.22179 8.5384,-22.39723 9.5569,-38.50951 l 0.8328,-13.17617 -37.2121,0.72289 c -48.5334,0.94283 -67.0475,3.83628 -84.851,13.26086 -14.7161,7.7903 -21.687,22.96644 -18.2324,39.69344 4.5558,22.05849 21.4242,37.64762 45.4464,41.99989 12.5966,2.28217 14.3586,2.28371 27.044,0.0236 z m 717.5606,69.89425 c -37.1291,-5.12804 -70.0306,-22.94096 -89.3276,-48.36211 -9.0144,-11.87513 -14.8706,-23.48433 -18.5075,-36.68909 -4.0528,-14.71448 -4.0053,-48.22036 0.089,-63.27664 9.7356,-35.79573 37.72,-57.18741 88.2324,-67.44617 29.7796,-6.04807 72.2223,-9.43371 118.5371,-9.45567 l 27.2037,-0.0133 -0.8377,-14.33334 c -0.4608,-7.88333 -1.7723,-17.88841 -2.9143,-22.23352 -7.8225,-29.76092 -30.1032,-42.36693 -71.3221,-40.35272 -27.62,1.3497 -55.196,8.0352 -81.7503,19.81948 -10.3822,4.60746 -14.0077,5.53608 -23.7814,6.09144 -10.7071,0.60842 -12.0142,0.39276 -18.2756,-3.01517 -11.4124,-6.21112 -16.1924,-16.03261 -16.1924,-33.27053 0,-13.85846 2.606,-21.53306 10.1678,-29.94359 5.2668,-5.858 7.7991,-7.32329 22.8772,-13.23755 42.3463,-16.60992 85.0263,-24.03634 128.955,-22.43845 68.0633,2.4758 108.8369,23.4542 130.0548,66.91436 7.2041,14.75608 12.2494,32.41677 14.4745,50.66667 0.9489,7.78264 1.4645,49.32118 1.4669,118.19288 0,102.3415 -0.093,106.50521 -2.6561,114.80457 -3.3753,10.9282 -10.6799,19.4884 -20.2899,23.7778 -6.0094,2.68232 -9.2153,3.15019 -21.7169,3.16945 -8.0667,0.012 -17.1915,-0.73637 -20.2773,-1.66401 -14.0998,-4.2386 -24.7932,-18.90655 -26.7335,-36.66976 l -0.9892,-9.05572 -6,8.28272 c -11.9679,16.52111 -34.9735,31.31267 -58,37.29131 -12.36,3.20918 -47.1136,4.56994 -62.4869,2.44666 z m 58.4394,-69.89425 c 24.4607,-4.35807 46.0451,-20.90478 57.4154,-44.01499 6.0132,-12.22179 8.5384,-22.39723 9.5569,-38.50951 l 0.8328,-13.17617 -37.2121,0.72289 c -48.5334,0.94283 -67.0475,3.83628 -84.851,13.26086 -14.7161,7.7903 -21.687,22.96644 -18.2324,39.69344 4.5558,22.05849 21.4242,37.64762 45.4464,41.99989 12.5966,2.28217 14.3586,2.28371 27.044,0.0236 z m 353.095,69.94021 c -61.2859,-7.69349 -95.9347,-43.85544 -105.0286,-109.61516 -1.7726,-12.81869 -2.0253,-31.42433 -1.7156,-126.35279 L 3352.6667,318 l 3.1858,-7.05024 c 3.8504,-8.52115 12.6122,-16.60443 21.2215,-19.57829 8.8031,-3.0408 25.8289,-4.02234 37.0224,-2.13432 15.8449,2.67258 26.2101,10.23874 32.1957,23.50129 2.1936,4.86075 2.4304,13.48871 3.1084,113.26156 0.7182,105.69623 0.7958,108.22255 3.6375,118.43269 7.0591,25.36264 20.6232,38.16383 44.8559,42.33276 32.8682,5.65459 66.3353,-11.22737 81.9689,-41.34797 10.3293,-19.901 9.8589,-14.46353 10.7924,-124.75081 0.9485,-112.07074 0.5167,-107.61923 11.5881,-119.45558 7.4698,-7.9857 16.7955,-11.75154 31.7079,-12.80393 20.7349,-1.46328 38.6485,4.23137 46.7588,14.86447 1.9493,2.55568 4.6871,8.31853 6.0837,12.80633 2.4352,7.82407 2.539,14.41939 2.5238,160.37416 -0.016,159.25559 10e-4,158.72853 -5.6627,169.54788 -2.5759,4.92069 -9.6311,11.68576 -15.0052,14.38807 -11.8053,5.93628 -38.382,6.38228 -51.22,0.85956 -13.1372,-5.6515 -21.5556,-18.53172 -23.5616,-36.0494 l -0.8552,-7.46844 -10.6699,11.11393 c -16.4765,17.16232 -33.9689,27.44889 -56.7672,33.38245 -10.6813,2.77995 -16.7056,3.43827 -34.909,3.81483 -12.1,0.25029 -26.3287,-0.0883 -31.6192,-0.75247 z M 3874,664.80864 c -20.4055,-3.42376 -33.3211,-8.21444 -47.5397,-17.63343 -24.0836,-15.954 -39.4418,-42.82326 -46.0175,-80.50854 C 3778.1497,553.52449 3778,540.73877 3778,358 c 0,-190.69309 0.053,-194.81193 2.6387,-201.78344 7.4212,-20.01537 28.1216,-29.58607 55.9409,-25.86389 18.7345,2.50666 30.6725,10.87313 36.3419,25.46945 2.258,5.8134 2.4402,17.30883 3.0896,194.84455 0.6544,178.94521 0.8169,189.04453 3.1548,196 5.9258,17.63034 13.2073,26.56598 26.8341,32.93032 7.8137,3.64937 8.5475,3.73634 31.5208,3.73634 26.8151,0 27.7357,0.32387 30.3416,10.67255 2.1595,8.57608 1.8747,38.89541 -0.4375,46.57828 -4.1161,13.67687 -11.7414,20.33132 -26.8269,23.41125 -11.2652,2.29996 -54.5845,2.82894 -66.598,0.81323 z m 265.4784,0.52263 c -58.9192,-7.35742 -95.3712,-36.07548 -109.2268,-86.05239 -5.7309,-20.67115 -6.2355,-30.55293 -6.2437,-122.27888 L 4024,369.33333 h -23.8324 c -17.9128,0 -25.2587,-0.50326 -29.5751,-2.02616 -14.9126,-5.26149 -21.2298,-15.56484 -21.2388,-34.6405 -0.013,-15.3833 1.6079,-20.93303 8.16,-28.04123 8.0882,-8.77465 13.0888,-9.95877 42.0571,-9.95877 H 4024 v -37.93438 c 0,-41.94104 0.7844,-48.30296 7.1152,-57.71078 8.8909,-13.21243 22.3355,-18.33878 45.7195,-17.4327 17.8977,0.6935 25.848,3.73791 34.2945,13.13242 9.6021,10.67993 10.2041,14.22537 10.2041,60.09854 v 39.8469 h 44.1787 c 31.1259,0 45.7973,0.48498 49.6575,1.64149 7.3866,2.21312 17.4681,12.12187 19.3566,19.02517 0.8024,2.93334 1.4566,10.73334 1.4535,17.33334 -0.013,19.07566 -6.3261,29.37901 -21.2388,34.6405 -4.6923,1.65555 -13.7827,2.02616 -49.6969,2.02616 h -43.9542 l 0.5682,81 c 0.548,78.14956 0.6704,81.37538 3.476,91.66667 7.464,27.37845 23.98,40.06303 54.1994,41.62613 9.8511,0.50956 16.2932,0.0712 24.6667,-1.6784 16.2669,-3.39897 28.1521,-3.34846 32.8252,0.13951 3.0963,2.31092 3.9871,4.45564 5.5381,13.33333 1.8092,10.35423 1.6242,20.32988 -0.787,42.43983 -0.9339,8.56319 -1.3772,9.52609 -6.4632,14.03953 -9.7551,8.65687 -31.923,13.52536 -64.4464,14.1537 -12.1,0.23376 -26.1347,-0.0913 -31.1883,-0.72236 z m -3091.1817,-1.32659 c -7.6429,-1.62347 -18.3972,-7.61859 -22.6201,-12.60995 -1.8899,-2.23377 -4.9903,-7.3614 -6.8897,-11.39473 l -3.4536,-7.33333 V 398 c 0,-226.84695 0.084,-234.90844 2.5254,-241.92219 6.8496,-19.67926 30.7098,-29.96476 59.2425,-25.53777 18.6752,2.89757 30.0092,11.94304 34.931,27.87797 2.5206,8.1608 2.6345,12.68768 2.6345,104.71123 v 96.18169 l 107.6666,-107.5321 c 69.6557,-69.56863 110.2557,-109.15338 115,-112.12438 11.4936,-7.19744 20.0527,-9.52109 35.3334,-9.59231 17.7306,-0.0826 24.9517,2.09588 32.7301,9.87437 7.6352,7.63516 9.8489,14.78784 8.9932,29.05766 -0.9823,16.37872 -4.0187,21.00399 -32.2145,49.07036 -13.2966,13.2355 -57.2385,56.80979 -97.6489,96.83178 l -73.4733,72.76722 103.4733,105.1921 c 78.8357,80.14516 104.4073,106.9286 107.3957,112.48505 3.1758,5.90499 4.0308,9.35987 4.4924,18.15336 0.9842,18.75359 -5.04,30.34905 -19.4419,37.42121 -7.1881,3.52979 -8.6651,3.75142 -25.0008,3.75142 -29.2156,0 -16.3045,10.59842 -151.6387,-124.47632 L 1114.6667,424.74537 v 101.38531 c 0,88.63576 -0.2657,102.27983 -2.1124,108.49853 -4.0302,13.57088 -12.6891,23.2777 -24.4796,27.44183 -7.1541,2.52665 -31.4305,3.70675 -39.778,1.93364 z m 1656.0376,-0.64248 c -15.1639,-4.2762 -26.7128,-13.47043 -34.7536,-27.66744 -6.6942,-11.81959 -123.8119,-285.21328 -125.414,-292.76039 -3.411,-16.06696 -0.8911,-31.59341 6.5966,-40.64694 8.3683,-10.11823 25.6067,-15.31607 46.0179,-13.87563 17.2241,1.21552 25.7511,5.81351 33.7147,18.17976 2.8864,4.48201 22.8474,52.41345 49.4901,118.83804 l 44.6528,111.32627 45.6927,-111.12754 c 25.1309,-61.12013 47.7345,-114.31948 50.2301,-118.22076 9.1784,-14.348 18.3605,-18.47236 41.4384,-18.61281 14.244,-0.0867 16.6991,0.24817 22.3697,3.05123 8.1463,4.02669 15.153,12.22802 17.6603,20.6711 2.2993,7.74243 2.5677,23.18052 0.536,30.81624 -0.7805,2.93334 -29.6596,69.90804 -64.1756,148.83268 -44.348,101.40639 -64.3101,145.60175 -68.0529,150.66667 -6.5191,8.82177 -14.6348,15.18068 -23.933,18.75216 -9.4333,3.62347 -32.1244,4.58209 -42.0702,1.77736 z",
      fill: r || "#000000"
    }
  )
] }), l9 = "_footer__icon_1arpp_63", u9 = {
  footerIcon: l9
}, r5 = ({ colorMode: r }) => {
  const e = Tn(r), t = On();
  return /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "center", padding: Xt, children: /* @__PURE__ */ T($t, { align: "center", justify: "center", spacing: "sm", children: [
    /* @__PURE__ */ T(qt, { colorMode: r, size: "xs", textAlign: "center", children: t("captions.poweredBy") }),
    /* @__PURE__ */ T(i9, { colorMode: r, href: s9, isExternal: !0, children: /* @__PURE__ */ T(c9, { className: u9.footerIcon, color: e }) })
  ] }) });
}, d9 = "_heading_1eauo_90", h9 = "_heading--bold_1eauo_106", f9 = "_heading--full-width_1eauo_109", p9 = "_heading--left_1eauo_112", g9 = "_heading--right_1eauo_115", m9 = "_heading--xs_1eauo_118", y9 = "_heading--sm_1eauo_121", w9 = "_heading--lg_1eauo_124", v9 = "_heading--xl_1eauo_128", _9 = "_heading--truncate_1eauo_132", rn = {
  heading: d9,
  headingBold: h9,
  headingFullWidth: f9,
  headingLeft: p9,
  headingRight: g9,
  headingXs: m9,
  headingSm: y9,
  headingLg: w9,
  headingXl: v9,
  headingTruncate: _9
}, fn = ({
  bold: r = !1,
  children: e,
  className: t,
  color: n,
  colorMode: a,
  fullWidth: o = !1,
  height: i,
  maxHeight: s,
  maxWidth: l,
  minHeight: c,
  minWidth: u,
  size: d = "md",
  title: w,
  textAlign: f = "center",
  truncate: A = !1,
  width: b
}) => {
  const g = Ut(() => {
    switch (d) {
      case "xs":
        return rn.headingXs;
      case "sm":
        return rn.headingSm;
      case "lg":
        return rn.headingLg;
      case "xl":
        return rn.headingXl;
      case "md":
      default:
        return rn.headingMd;
    }
  }, [d]), k = Ut(() => {
    switch (f) {
      case "left":
        return rn.headingLeft;
      case "right":
        return rn.headingRight;
      case "center":
      default:
        return rn.headingCenter;
    }
  }, [f]);
  return /* @__PURE__ */ T(
    "h1",
    {
      className: Ke(
        rn.heading,
        g,
        k,
        r && rn.headingBold,
        o && rn.headingFullWidth,
        A && rn.headingTruncate,
        t
      ),
      "data-color-mode": a,
      style: {
        ...n && {
          color: n
        },
        ...i && {
          height: typeof i == "number" ? `${i}px` : i
        },
        ...s && {
          maxHeight: typeof s == "number" ? `${s}px` : s
        },
        ...l && {
          maxWidth: typeof l == "number" ? `${l}px` : l
        },
        ...c && {
          minHeight: typeof c == "number" ? `${c}px` : c
        },
        ...u && {
          minWidth: typeof u == "number" ? `${u}px` : u
        },
        ...b && {
          width: typeof i == "number" ? `${b}px` : b
        }
      },
      title: w || (typeof e == "string" ? e : void 0),
      children: e
    }
  );
}, b9 = "_button_gmyq8_90", S9 = "_button--xs_gmyq8_117", E9 = "_button--sm_gmyq8_120", x9 = "_button--lg_gmyq8_123", k9 = "_button--xl_gmyq8_126", A9 = "_icon_gmyq8_130", C9 = "_icon--xs_gmyq8_134", D9 = "_icon--sm_gmyq8_138", M9 = "_icon--lg_gmyq8_142", R9 = "_icon--xl_gmyq8_146", nn = {
  button: b9,
  buttonXs: S9,
  buttonSm: E9,
  buttonLg: x9,
  buttonXl: k9,
  icon: A9,
  iconXs: C9,
  iconSm: D9,
  iconLg: M9,
  iconXl: R9
}, Yr = ({
  className: r,
  colorMode: e,
  icon: t,
  iconColor: n,
  size: a = "md",
  ...o
}) => {
  const i = Tn(e), [s, l] = Ut(() => {
    switch (a) {
      case "xs":
        return [nn.buttonXs, nn.iconXs];
      case "sm":
        return [nn.buttonSm, nn.iconSm];
      case "lg":
        return [nn.buttonLg, nn.iconLg];
      case "xl":
        return [nn.buttonXl, nn.iconXl];
      case "md":
      default:
        return [nn.buttonMd, nn.iconMd];
    }
  }, [a]);
  return /* @__PURE__ */ T("button", { ...o, className: Ke(nn.button, s, r), "data-color-mode": e, children: go(t, {
    ...t.props,
    className: Ke(nn.icon, l),
    color: n ?? i
  }) });
}, I9 = "_button_1ialb_81", T9 = "_container_1ialb_87", O9 = "_container--error_1ialb_107", P9 = "_error-text_1ialb_114", N9 = "_hint-text_1ialb_126", B9 = "_input_1ialb_138", L9 = "_label_1ialb_171", U9 = "_label--asterisk_1ialb_182", Gn = {
  button: I9,
  container: T9,
  containerError: O9,
  errorText: P9,
  hintText: N9,
  input: B9,
  label: L9,
  labelAsterisk: U9
}, Ed = ({
  colorMode: r,
  error: e,
  hint: t,
  label: n,
  rightButton: a,
  ...o
}) => /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "center", spacing: "xs", children: [
  n && /* @__PURE__ */ T("span", { className: Ke(Gn.label), "data-color-mode": r, children: [
    n,
    o.required && /* @__PURE__ */ T("span", { className: Ke(Gn.label, Gn.labelAsterisk), "data-color-mode": r, children: " *" })
  ] }),
  /* @__PURE__ */ T("div", { className: Ke(Gn.container, e && Gn.containerError), "data-color-mode": r, children: [
    /* @__PURE__ */ T(
      "input",
      {
        ...o,
        className: Ke(Gn.input),
        "data-color-mode": r
      }
    ),
    a && go(a, {
      className: Ke(Gn.button)
    })
  ] }),
  t && /* @__PURE__ */ T("span", { className: Ke(Gn.hintText), "data-color-mode": r, children: t }),
  e && /* @__PURE__ */ T("span", { className: Ke(Gn.errorText), "data-color-mode": r, children: e })
] }), V9 = "_container_p7xuv_81", $9 = "_modal_p7xuv_98", j9 = "_modal--close_p7xuv_118", F9 = "_overlay_p7xuv_122", Dc = {
  container: V9,
  modal: $9,
  modalClose: j9,
  overlay: F9
}, $i = ({ body: r, closeOnEscape: e, closeOnInteractOutside: t, colorMode: n, footer: a, header: o, onClose: i, onCloseAnimationEnd: s, open: l }) => {
  const [c, u] = dt(l), [d, w] = dt(!1), f = ht(() => i(), [i]), A = ht(({ key: b }) => {
    if (e && b === "Escape")
      return i();
  }, [e, i]);
  return kr(() => (document.addEventListener("keyup", A), () => document.removeEventListener("keyup", A)), []), kr(() => {
    if (!l && c) {
      w(!0), setTimeout(() => {
        w(!1), u(!1), s == null || s();
      }, 300);
      return;
    }
    u(l);
  }, [l]), c ? /* @__PURE__ */ T("div", { className: Ke(Dc.container), children: [
    /* @__PURE__ */ T(
      "div",
      {
        className: Ke(Dc.overlay),
        ...t && {
          onClick: f
        }
      }
    ),
    /* @__PURE__ */ T("div", { className: Ke(Dc.modal, d && Dc.modalClose), "data-color-mode": n, children: [
      o,
      /* @__PURE__ */ T(Dt, { fullWidth: !0, grow: !0, children: r }),
      a && /* @__PURE__ */ T(Dt, { fullWidth: !0, children: a })
    ] })
  ] }) : null;
};
$i.displayName = "Modal";
const z9 = "_container_m5f3o_81", H9 = "_track_m5f3o_93", q9 = "_track--weak-password_m5f3o_100", W9 = "_track--normal-password_m5f3o_107", K9 = "_track--strong-password_m5f3o_114", To = {
  container: z9,
  track: H9,
  trackWeakPassword: q9,
  trackNormalPassword: W9,
  trackStrongPassword: K9
}, Y9 = ({ colorMode: r, score: e }) => {
  const t = Ut(() => {
    switch (e) {
      case 0:
        return To.trackWeakPassword;
      case 1:
        return To.trackNormalPassword;
      case 2:
        return To.trackStrongPassword;
      case -1:
      default:
        return To.trackNoPassword;
    }
  }, [e]);
  return /* @__PURE__ */ T("div", { className: Ke(To.container), "data-color-mode": r, children: /* @__PURE__ */ T("div", { className: Ke(To.track, t), "data-color-mode": r }) });
};
function ji(r) {
  return r === "dark" ? "rgba(255, 255, 255, 0.64)" : "#718096";
}
const n5 = ({
  color: r = "#000000",
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
      /* @__PURE__ */ T("circle", { cx: "12", cy: "12", r: "3" })
    ]
  }
), a5 = ({
  color: r = "#000000",
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("path", { d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" }),
      /* @__PURE__ */ T("path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" }),
      /* @__PURE__ */ T("path", { d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" }),
      /* @__PURE__ */ T("path", { d: "m2 2 20 20" })
    ]
  }
), G9 = "_item-container_15me7_81", J9 = "_password-strength-text--weak-password_15me7_88", X9 = "_password-strength-text--normal-password_15me7_94", Z9 = "_password-strength-text--strong-password_15me7_100", Oo = {
  itemContainer: G9,
  passwordStrengthTextWeakPassword: J9,
  passwordStrengthTextNormalPassword: X9,
  passwordStrengthTextStrongPassword: Z9
}, Q9 = ({ colorMode: r, value: e, ...t }) => {
  const n = ji(r), a = On(), [o, i] = dt(!0), [s, l] = dt(ml((e == null ? void 0 : e.toString()) ?? "").score), c = Ut(() => {
    switch (s) {
      case 0:
        return Oo.passwordStrengthTextWeakPassword;
      case 1:
        return Oo.passwordStrengthTextNormalPassword;
      case 2:
        return Oo.passwordStrengthTextStrongPassword;
      case -1:
      default:
        return Oo.passwordStrengthTextNoPassword;
    }
  }, [s, n]), u = ht(() => i(!o), [o, i]);
  return kr(() => l(ml((e == null ? void 0 : e.toString()) ?? "").score), [e]), /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "center", spacing: "sm", children: [
    /* @__PURE__ */ T(
      Ed,
      {
        ...t,
        autocomplete: "new-password",
        colorMode: r,
        rightButton: /* @__PURE__ */ T(
          Yr,
          {
            colorMode: r,
            icon: o ? /* @__PURE__ */ T(a5, {}) : /* @__PURE__ */ T(n5, {}),
            onClick: u,
            type: "button"
          }
        ),
        type: o ? "password" : "text",
        value: e
      }
    ),
    /* @__PURE__ */ T("div", { className: Ke(Oo.itemContainer), children: /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "center", spacing: "xs", children: [
      /* @__PURE__ */ T(Y9, { colorMode: r, score: s }),
      s >= 0 && /* @__PURE__ */ T(qt, { className: Ke(c), colorMode: r, fullWidth: !0, size: "xs", textAlign: "justify", children: a("captions.passwordDescription", {
        context: s
      }) })
    ] }) }),
    /* @__PURE__ */ T("div", { className: Ke(Oo.itemContainer), children: /* @__PURE__ */ T(qt, { color: n, colorMode: r, fullWidth: !0, size: "sm", textAlign: "justify", children: a("captions.passwordHint") }) })
  ] });
}, ew = (r) => {
  const [e, t] = dt(!0), n = ht(() => t(!e), [e, t]);
  return /* @__PURE__ */ T(
    Ed,
    {
      ...r,
      autocomplete: "current-password",
      rightButton: /* @__PURE__ */ T(
        Yr,
        {
          colorMode: r.colorMode,
          icon: e ? /* @__PURE__ */ T(a5, {}) : /* @__PURE__ */ T(n5, {}),
          onClick: n,
          type: "button"
        }
      ),
      type: e ? "password" : "text"
    }
  );
}, tw = "_spacer_gfrnu_63", rw = {
  spacer: tw
}, hn = () => /* @__PURE__ */ T("div", { className: Ke(rw.spacer) });
function nw() {
  const { state: r, timestamp: e } = Br(uu), [t, n] = dt(
    (r == null ? void 0 : r.clientInformation) ?? null
  );
  return kr(() => {
    r && n(r.clientInformation);
  }, [e]), t;
}
function o5() {
  const { state: r, timestamp: e } = Br(uu), [t, n] = dt((r == null ? void 0 : r.logger) ?? null);
  return kr(() => {
    r && n(r.logger);
  }, [e]), t;
}
function ju({ required: r = !1, translate: e, validate: t, value: n }) {
  return n.length <= 0 && r ? e("errors.inputs.required") : t ? t(n) : null;
}
function E0({
  characterLimit: r,
  defaultValue: e,
  name: t,
  required: n,
  validate: a
}) {
  const o = On(), [i, s] = dt(r || null), [l, c] = dt(null), [u, d] = dt(e || ""), w = ht(() => {
    const g = ju({
      translate: o,
      required: n,
      value: u,
      validate: a
    });
    return c(g), g;
  }, [t, n, c, o, a, u]), f = ht(
    (g) => {
      c(
        ju({
          translate: o,
          required: n,
          value: g.currentTarget.value,
          validate: a
        })
      );
    },
    [t, n, c, o, a]
  ), A = ht(
    (g) => {
      const k = g.currentTarget.value;
      let v;
      typeof r == "number" && (v = new TextEncoder().encode(k).byteLength, s(r - v)), c(
        ju({
          translate: o,
          required: n,
          value: k,
          validate: a
        })
      ), d(k);
    },
    [r, t, n, s, c, d, o, a]
  ), b = ht(() => {
    s(r || null), c(null), d("");
  }, [s, c, d, r]);
  return {
    name: t,
    onBlur: f,
    onChange: A,
    reset: b,
    required: n,
    setCharactersRemaining: s,
    setError: c,
    setValue: d,
    validate: w,
    value: u,
    ...typeof i == "number" && {
      charactersRemaining: i
    },
    ...l && {
      error: l
    }
  };
}
const aw = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "#000000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T(
        "path",
        {
          d: "m12 19-7-7 7-7"
        }
      ),
      /* @__PURE__ */ T(
        "path",
        {
          d: "M19 12H5"
        }
      )
    ]
  }
), ow = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "#000000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T(
        "path",
        {
          d: "M5 12h14"
        }
      ),
      /* @__PURE__ */ T(
        "path",
        {
          d: "m12 5 7 7-7 7"
        }
      )
    ]
  }
), Fi = ({ color: r, title: e, ...t }) => /* @__PURE__ */ T("svg", { viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e && /* @__PURE__ */ T("title", { children: e }),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M368 368L144 144M368 144L144 368",
      fill: "none",
      stroke: r || "#000000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32"
    }
  )
] }), iw = ({ color: r, title: e, ...t }) => /* @__PURE__ */ T("svg", { viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e && /* @__PURE__ */ T("title", { children: e }),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216z",
      fill: "none",
      stroke: r || "#000000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32"
    }
  )
] }), sw = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T("svg", { viewBox: "0 0 1088 1088", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e && /* @__PURE__ */ T("title", { children: e }),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C2.5856998 2.03460484 4.89229196 4.27085061 7.1875 6.625 C7.79754883 7.24673096 8.40759766 7.86846191 9.03613281 8.5090332 C18.48215204 18.42428484 21.59276454 29.56482768 21.3203125 43.16796875 C20.0710553 54.2132306 14.94074311 63.53929675 7.15491492 71.21998191 C6.57057691 71.80840263 5.98623891 72.39682336 5.38419369 73.00307502 C3.42359435 74.97369938 1.45249127 76.93346357 -0.51872921 78.89345932 C-1.94654903 80.32410526 -3.37371074 81.75540825 -4.80027291 83.18730825 C-8.73755134 87.13547239 -12.6841568 91.07419779 -16.63229592 95.01149723 C-20.92011987 99.2908313 -25.19925778 103.57883596 -29.47949272 107.86575818 C-36.98739059 115.38296759 -44.50081964 122.89460835 -52.01799965 130.40253258 C-60.08422763 138.45888178 -68.14718603 146.51848226 -76.20616913 154.58207893 C-76.7150821 155.09127894 -77.22399506 155.60047894 -77.74832964 156.12510925 C-79.82101983 158.19899089 -81.89368617 160.27289636 -83.9663224 162.34683193 C-103.27403117 181.66664306 -122.58905488 200.97912531 -141.9086895 220.28701019 C-160.52774257 238.89475634 -179.14412993 257.50516198 -197.75679207 276.11930084 C-198.9250736 277.28766778 -200.0933554 278.45603446 -201.26163746 279.62440087 C-205.95629735 284.31940859 -210.65093861 289.01443494 -215.34555609 293.70948508 C-228.46932966 306.83445335 -241.59360967 319.95891514 -254.7182703 333.08299637 C-255.31596205 333.68066209 -255.9136538 334.27832782 -256.52945742 334.89410462 C-275.57795248 353.94170085 -294.62864685 372.98709582 -313.68090725 392.03092575 C-314.29896276 392.64870808 -314.91701828 393.2664904 -315.55380275 393.90299341 C-325.59105016 403.93578698 -335.62842797 413.9684501 -345.66581361 424.00110538 C-385.48066125 463.79720586 -425.28933883 503.59946691 -465.09204102 543.40771484 C-467.60745814 545.92347896 -470.12287596 548.43924239 -472.63829374 550.95500585 C-473.26021905 551.57701677 -473.88214437 552.19902769 -474.52291591 552.83988743 C-481.41030858 559.7282262 -488.29771844 566.61654778 -495.18514919 573.50484848 C-495.80276809 574.1225463 -496.42038699 574.74024412 -497.05672162 575.37666005 C-530.38398644 608.7081454 -563.71601127 642.03486968 -597.0497213 675.3599093 C-598.22456212 676.53444683 -599.39940274 677.70898456 -600.57424318 678.88352248 C-601.15500644 679.46413615 -601.73576971 680.04474983 -602.33413186 680.64295785 C-603.50582063 681.8143452 -604.67750918 682.98573276 -605.84919752 684.15712054 C-608.76825498 687.07542914 -611.68731601 689.99373418 -614.6063847 692.91203155 C-627.40990917 705.71220565 -640.21279112 718.51302149 -653.01396441 731.31554699 C-653.87983335 732.18150674 -653.87983335 732.18150674 -654.76319459 733.06496062 C-657.66970906 735.97178708 -660.57621282 738.87862425 -663.48271282 741.78546517 C-684.47182502 762.77702606 -705.46417645 783.76533849 -726.46232157 804.74786392 C-728.52903817 806.81307052 -730.59573979 808.87829211 -732.66242981 810.94352531 C-733.16964517 811.45037994 -733.67686054 811.95723456 -734.19944606 812.47944841 C-742.24384844 820.51830553 -750.28489999 828.56050577 -758.32458255 836.60408289 C-766.22222712 844.50540903 -774.12350835 852.4030836 -782.02846219 860.29709832 C-786.26017533 864.5231566 -790.49026211 868.75080968 -794.7160204 872.9828231 C-798.55504013 876.82745728 -802.3985733 880.6675165 -806.24586677 884.5038707 C-807.63325387 885.88893734 -809.01894479 887.27570546 -810.40278719 888.66431367 C-812.27382471 890.54131139 -814.15085694 892.4121 -816.02956575 894.28141475 C-816.56702531 894.82353766 -817.10448488 895.36566057 -817.65823109 895.92421145 C-825.80859656 903.9931633 -835.68148206 907.55174186 -847 908 C-847.67804688 908.0515625 -848.35609375 908.103125 -849.0546875 908.15625 C-857.69063739 908.57244036 -866.71960384 905.34112428 -873.4921875 900.0546875 C-888.44221905 886.37908487 -888.44221905 886.37908487 -891 879 C-891.28101563 878.195625 -891.56203125 877.39125 -891.8515625 876.5625 C-895.81736948 863.4232607 -894.61804217 851.86366935 -888.28632934 839.71085505 C-886.0553556 835.85661297 -883.30862983 832.88975308 -880.15310556 829.77475673 C-879.56857005 829.18576581 -878.98403454 828.59677489 -878.38178583 827.98993575 C-876.42050295 826.01737611 -874.44872376 824.05566141 -872.47682667 822.09371662 C-871.04851296 820.66166643 -869.62085627 819.22896068 -868.19379815 817.79565927 C-864.25511857 813.84359722 -860.30711391 809.90096584 -856.35757031 805.95976493 C-852.06818295 801.67616799 -847.78746199 797.38392535 -843.50563782 793.09277076 C-835.99486814 785.56806314 -828.47854851 778.04893964 -820.95845795 770.53355026 C-812.8890227 762.46911412 -804.82283931 754.40144629 -796.76060295 746.329813 C-796.25148196 745.82010354 -795.74236098 745.31039407 -795.21781208 744.78523887 C-793.14426787 742.70927812 -791.07074545 740.63329562 -788.99725103 738.55728515 C-767.94354659 717.47806648 -746.88007768 696.40862507 -725.81266384 675.34310912 C-722.90112763 672.43183252 -719.98960189 669.52054546 -717.07808709 666.60924745 C-716.49980209 666.03100648 -715.92151709 665.45276552 -715.3257083 664.8570021 C-702.51414639 652.04630335 -689.70541201 639.23277907 -676.89722639 626.41870483 C-673.97329095 623.49342842 -671.04933496 620.56817256 -668.12538144 617.64291423 C-666.95189699 616.46890526 -665.77841257 615.29489625 -664.60492819 614.12088721 C-664.02325636 613.53895561 -663.44158454 612.95702401 -662.8422863 612.35745812 C-661.665736 611.18038164 -660.48918645 610.00330441 -659.31263764 608.82622644 C-625.92448046 575.42307062 -592.533208 542.02303168 -559.13519001 508.62973499 C-558.51664306 508.01127391 -557.89809612 507.39281283 -557.26080533 506.7556105 C-550.36321015 499.85897474 -543.46557558 492.96237838 -536.56792948 486.06579355 C-534.68000495 484.17815854 -532.79208044 482.29052351 -530.90415597 480.40288844 C-529.64450297 479.14342944 -528.38484923 477.88397119 -527.12519473 476.62451369 C-487.28578431 436.79132015 -447.45692954 396.94760134 -407.63696289 357.0949707 C-397.60291254 347.0526973 -387.5688256 337.01046046 -377.53452778 326.96843433 C-376.91669783 326.35012819 -376.29886788 325.73182204 -375.66231581 325.09477935 C-356.624675 306.04255555 -337.583968 286.99340048 -318.54008007 267.94742107 C-317.94230983 267.34958452 -317.34453959 266.75174796 -316.7286551 266.13579514 C-303.60709387 253.01283995 -290.48478022 239.89063737 -277.36177552 226.76912566 C-272.6663371 222.07420936 -267.97095116 217.37924058 -263.27558936 212.68424766 C-262.10747995 211.51623147 -260.93936759 210.34821825 -259.77125225 209.18020799 C-241.14870835 190.55929003 -222.5334055 171.93115364 -203.92165258 153.29945055 C-185.18017391 134.53800067 -166.43060086 115.7846789 -147.66996282 97.04238654 C-145.07870205 94.45365964 -142.48752696 91.864847 -139.89640236 89.27598381 C-139.38845973 88.76849156 -138.8805171 88.26099931 -138.35718227 87.73812851 C-130.30837598 79.69600561 -122.2679909 71.64551748 -114.2310593 63.59152937 C-106.33181386 55.67587144 -98.42350231 47.76936388 -90.50604551 39.87191395 C-86.26950089 35.64556145 -82.03706449 31.41530243 -77.81546716 27.1740149 C-73.97723228 23.31803901 -70.12774298 19.47369006 -66.26883253 15.63840867 C-64.88128719 14.25532454 -63.49794272 12.86801031 -62.11929205 11.47605984 C-49.26605123 -1.49276943 -49.26605123 -1.49276943 -41 -4 C-39.60228268 -4.57880461 -38.206244 -5.16169215 -36.8125 -5.75 C-24.27796829 -9.73826009 -11.00225239 -6.59408237 0 0 Z",
      fill: r || "#000000",
      transform: "translate(981,94)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C19.76228303 -0.08287947 39.52449895 -0.14753154 59.28692847 -0.18220818 C60.10933955 -0.18365236 60.93175063 -0.18509653 61.77908325 -0.18658447 C62.59836435 -0.18800882 63.41764546 -0.18943317 64.26175326 -0.19090068 C70.00614299 -0.20154656 75.75048194 -0.21948755 81.49484253 -0.24041748 C88.52321017 -0.26580515 95.55149851 -0.27999423 102.57991362 -0.28035986 C106.16750384 -0.28078132 109.75491683 -0.28574374 113.34246445 -0.30400467 C143.56312627 -0.4501487 171.71215589 2.7346102 195.60803223 23.0435791 C196.63928223 23.8067041 197.67053223 24.5698291 198.73303223 25.3560791 C211.43432903 37.22903046 217.75317007 54.87744815 219.61730957 71.80895996 C219.69996756 72.54161796 219.78262554 73.27427595 219.86778831 74.0291357 C221.64646528 90.18579525 222.72332914 106.3603295 223.23303223 122.6060791 C223.26434612 123.56965584 223.29566002 124.53323257 223.32792282 125.52600861 C223.96324924 147.58595223 224.34621858 167.38667562 209.08215332 184.57502747 C200.66228984 193.14377672 191.05454387 201.05255073 180.60803223 207.0435791 C180.27803223 207.0435791 179.94803223 207.0435791 179.60803223 207.0435791 C179.60656567 206.43987991 179.60509911 205.83618073 179.6035881 205.21418762 C179.56636822 190.45412558 179.50715477 175.69427121 179.42412949 160.93440247 C179.38449534 153.7963122 179.35202424 146.65832969 179.33703613 139.5201416 C179.32393781 133.29095323 179.29676801 127.0620035 179.25341916 120.83294964 C179.23098566 117.54146818 179.21721157 114.25033803 179.21614838 110.95877075 C179.20514256 93.95829579 178.92554835 77.86681972 170.92053223 62.4185791 C170.57876953 61.75253662 170.23700684 61.08649414 169.8848877 60.40026855 C165.96736276 53.23884837 160.91254911 50.01626502 153.26544189 47.43388367 C146.41219309 45.4509469 139.54281774 45.60259166 132.46447754 45.61120605 C130.94779107 45.60217165 129.43111184 45.59184708 127.91444206 45.58034801 C123.78839305 45.5527923 119.66248173 45.54351116 115.53635263 45.5375061 C111.12382197 45.52792526 106.71138894 45.50141702 102.29891968 45.47705078 C93.76780061 45.43266755 85.2367013 45.40408873 76.70549977 45.38138783 C69.83116579 45.36277151 62.95687832 45.33806469 56.08258057 45.30905151 C55.10853858 45.30494497 54.13449659 45.30083842 53.13093817 45.29660743 C51.16032707 45.28827544 49.18971601 45.27993171 47.21910501 45.27157629 C28.5410486 45.19317705 9.8629739 45.13514615 -8.81518364 45.0874052 C-20.06413866 45.05859725 -31.31306038 45.02508613 -42.56198215 44.98536146 C-58.55045268 44.9289106 -74.53886805 44.88909052 -90.52742004 44.86324692 C-94.25128161 44.85610917 -97.97512285 44.84582211 -101.69897461 44.83474731 C-107.47533943 44.81826384 -113.25162419 44.81207421 -119.02801132 44.81419373 C-121.09160638 44.81348817 -123.15520375 44.80950475 -125.21878433 44.80174255 C-152.63536725 44.48742112 -152.63536725 44.48742112 -176.01696777 57.4810791 C-176.80071777 58.3267041 -177.58446777 59.1723291 -178.39196777 60.0435791 C-179.44384277 61.1573291 -179.44384277 61.1573291 -180.51696777 62.2935791 C-185.80063234 70.0429538 -186.55596936 79.28918952 -186.46918011 88.43539429 C-186.4654312 89.26978283 -186.4616823 90.10417137 -186.45781979 90.96384442 C-186.44406038 93.76634997 -186.42301527 96.56875489 -186.40214539 99.37121582 C-186.3909599 101.39836363 -186.38028286 103.42551429 -186.37007123 105.45266724 C-186.34699485 109.86386057 -186.32087444 114.27502173 -186.29246712 118.68618393 C-186.22221434 129.65415976 -186.16867978 140.62222584 -186.11322398 151.59028459 C-186.09315668 155.53075708 -186.07249726 159.4712262 -186.05181062 163.41169548 C-185.95223194 182.59492478 -185.88641921 201.778121 -185.83979797 220.96154785 C-185.838096 221.6544742 -185.83639402 222.34740054 -185.83464047 223.06132466 C-185.80128206 236.65072733 -185.77074009 250.24013575 -185.74331701 263.8295517 C-185.72546309 272.6688006 -185.70643444 281.50804636 -185.68615723 290.34729004 C-185.68366011 291.44810745 -185.68366011 291.44810745 -185.68111255 292.57116359 C-185.62670744 316.33766219 -185.50339788 340.10320998 -185.34524334 363.86922482 C-185.18289675 388.32342584 -185.09347496 412.77687059 -185.0936661 437.23163497 C-185.09365309 440.69175681 -185.09279916 444.15187796 -185.09142494 447.61199951 C-185.09117829 448.29291354 -185.09093163 448.97382757 -185.0906775 449.67537536 C-185.08457321 460.59707035 -185.00225203 471.51689916 -184.89058158 482.43796937 C-184.77972635 493.43624641 -184.75163994 504.4327249 -184.80062046 515.43150485 C-184.82472592 521.3826304 -184.81392213 527.32804262 -184.70553017 533.27835464 C-184.01749893 573.16015363 -184.01749893 573.16015363 -195.10030204 584.74224854 C-198.73300055 588.22000218 -202.68444754 591.21727852 -206.80136073 594.09889984 C-210.59338289 596.94543995 -213.4401194 600.36622068 -216.39196777 604.0435791 C-217.61243866 605.34056401 -218.84490218 606.62671527 -220.10290527 607.8873291 C-220.70747559 608.49318848 -221.3120459 609.09904785 -221.93493652 609.7232666 C-222.84179199 610.62432129 -222.84179199 610.62432129 -223.76696777 611.5435791 C-224.39474121 612.17521973 -225.02251465 612.80686035 -225.66931152 613.4576416 C-226.26614746 614.05318848 -226.8629834 614.64873535 -227.47790527 615.2623291 C-228.01463867 615.79793457 -228.55137207 616.33354004 -229.10437012 616.88537598 C-230.39196777 618.0435791 -230.39196777 618.0435791 -231.39196777 618.0435791 C-231.54427688 566.0711187 -231.68927674 514.09864196 -231.82521537 462.12613603 C-231.84147551 455.91176797 -231.85779278 449.69740005 -231.87414551 443.48303223 C-231.87739843 442.24648881 -231.88065136 441.0099454 -231.88400286 439.73593098 C-231.92958704 422.4527173 -231.9782366 405.16951469 -232.02939622 387.88631666 C-232.6036347 193.84069172 -232.6036347 193.84069172 -232.07276416 124.98176003 C-232.04473867 121.25660506 -232.0198113 117.53144012 -231.99551582 113.80625916 C-231.95772483 108.19433167 -231.90939786 102.58260295 -231.85125852 96.97084999 C-231.83186257 95.00387015 -231.81525611 93.03686013 -231.80190921 91.06982994 C-231.60278847 63.36459188 -225.96274536 44.6593468 -206.06091309 24.68225098 C-182.87571017 1.91761054 -153.38981264 0.76963301 -122.66149902 0.6295166 C-119.97391987 0.61048399 -117.28635323 0.59075147 -114.5987854 0.57028198 C-108.07406855 0.52250911 -101.54933416 0.48560143 -95.02452469 0.45315635 C-89.70371865 0.4266623 -84.38294079 0.39685435 -79.06216431 0.36499023 C-58.73724944 0.24410488 -38.41228757 0.15133225 -18.08716506 0.07349253 C-12.05810405 0.05033813 -6.02905151 0.02549804 0 0 Z",
      fill: r || "#000000",
      transform: "translate(549.3919677734375,32.9564208984375)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C0.15071862 38.00516295 0.29575065 76.0103436 0.4332476 114.01555677 C0.44951691 118.51118513 0.46583289 123.00681332 0.48217773 127.50244141 C0.48543066 128.39737024 0.48868358 129.29229908 0.49203508 130.21434698 C0.54468907 144.66970096 0.60111589 159.12503784 0.6589582 173.58037189 C0.71830684 188.43333794 0.77355186 203.28631525 0.82505554 218.1393106 C0.8569158 227.2906903 0.89190633 236.4420467 0.93101191 245.59339836 C0.95758766 251.88461459 0.98014662 258.17583758 0.99967117 264.46707961 C1.01101923 268.08670138 1.02401857 271.70629527 1.04183006 275.32589149 C1.16226541 300.22967759 1.16226541 300.22967759 0.57286072 312.3961792 C0.51650683 313.56070173 0.51650683 313.56070173 0.45901448 314.74874997 C-0.58742155 333.06445183 -7.54552159 345.20254028 -19.64892578 358.51123047 C-20.72951953 359.7019534 -21.78844876 360.91232394 -22.83984375 362.12890625 C-30.95941767 371.03357892 -42.77354643 377.0881917 -54 381 C-54.99515625 381.35707031 -55.9903125 381.71414063 -57.015625 382.08203125 C-76.03325101 388.2145266 -96.3955222 388.43300351 -116.18041992 388.19677734 C-118.44393295 388.18177377 -120.70745701 388.16836294 -122.97098827 388.15642357 C-127.65812505 388.12984555 -132.34509841 388.09531467 -137.0321312 388.05437469 C-143.71110102 387.99840531 -150.38982061 387.97469555 -157.06900024 387.9631958 C-158.66990661 387.96035967 -158.66990661 387.96035967 -160.30315453 387.95746624 C-162.46361174 387.95371111 -164.62406906 387.95001256 -166.78452647 387.94637036 C-172.30772693 387.93547708 -177.83090073 387.91733404 -183.3540802 387.89883423 C-184.47061114 387.89510359 -185.58714208 387.89137295 -186.73750728 387.88752925 C-202.60144291 387.83367525 -218.46536256 387.77493179 -234.32926655 387.71247292 C-248.47218182 387.65694616 -262.61509018 387.60791056 -276.75805503 387.56685698 C-286.83147122 387.53706114 -296.90484403 387.49984315 -306.97821397 387.45720994 C-312.94878959 387.43215068 -318.91933436 387.41030309 -324.88994789 387.39665604 C-330.47119597 387.38377103 -336.0523334 387.36164849 -341.63352013 387.33261681 C-343.6671364 387.32361289 -345.70077038 387.31786779 -347.73440552 387.31578636 C-378.72159676 387.27840324 -378.72159676 387.27840324 -383 383 C-382.11183594 382.03964844 -381.22367187 381.07929687 -380.30859375 380.08984375 C-379.70587961 379.43708056 -379.10316547 378.78431738 -378.48218727 378.11177349 C-377.1053717 376.64769943 -375.70702323 375.2036141 -374.28922081 373.77919483 C-370.01936813 369.44946665 -366.39840835 365.22214582 -363.14028931 360.08000183 C-356.72104125 350.90088595 -349.63064071 343.81616204 -338.28633881 341.7159462 C-322.64766957 339.60474937 -306.68013846 340.20707585 -290.93608107 340.55212514 C-283.66495894 340.7064287 -276.39524602 340.72309493 -269.12272795 340.73247185 C-256.14237607 340.75237322 -243.16499859 340.87132898 -230.18603516 341.05737305 C-217.62756709 341.23711752 -205.06973672 341.37973809 -192.51025391 341.46557617 C-191.73507996 341.47089343 -190.959906 341.47621069 -190.16124193 341.48168907 C-181.68604933 341.5389609 -173.21081497 341.58809945 -164.73555946 341.63498974 C-162.48364523 341.64759965 -160.23173137 341.660271 -157.97981791 341.67301706 C-156.49479433 341.68137996 -155.00977004 341.68961719 -153.52474506 341.69772687 C-144.12047046 341.74976765 -134.71739687 341.83635454 -125.31381488 341.96164286 C-119.92254385 342.03302454 -114.53111916 342.08585338 -109.13963318 342.13808441 C-106.64874082 342.16619661 -104.15791704 342.20148731 -101.66724014 342.24465752 C-84.47897419 342.53983936 -70.03190399 342.30860684 -56 331 C-43.35519932 318.09176597 -43.70082662 301.04821292 -43.69702148 284.21313477 C-43.6893494 282.20576133 -43.68080098 280.19839109 -43.67144775 278.19102478 C-43.65320888 273.87401037 -43.64114331 269.5570389 -43.63390923 265.23999214 C-43.62232458 258.3571276 -43.59680853 251.47435541 -43.56959534 244.59153748 C-43.52794013 233.64181855 -43.49556432 222.6920948 -43.46712118 211.74233431 C-43.41646604 192.30378538 -43.35256614 172.8652818 -43.28178078 153.42679638 C-43.26137531 147.73390701 -43.24300706 142.04102686 -43.22979546 136.34811592 C-43.20262867 124.7525811 -43.15181761 113.1579643 -43.05266553 101.56280327 C-43.001597 94.88024372 -43.01486001 88.20033818 -43.06099576 81.51777381 C-43.08498295 76.86051078 -43.07176395 72.20377985 -43.05145848 67.54652107 C-43.04989239 65.3397253 -43.06380241 63.13285317 -43.09472167 60.92627347 C-43.27829363 47.17023192 -42.51517751 37.56296167 -32.96875 27.05078125 C-29.36502824 23.52120886 -25.46654123 20.42290381 -21.5 17.3125 C-19.52647382 15.58245237 -17.56413552 13.83955778 -15.61328125 12.08398438 C-1.99891915 0 -1.99891915 0 0 0 Z",
      fill: r || "#000000",
      transform: "translate(771,438)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C6.46069802 4.52353573 13.58314093 9.70753285 15.04329205 17.88221455 C15.4646978 21.61696742 15.60694427 25.22102524 15.61982727 28.97831726 C15.62350396 29.67820245 15.62718065 30.37808764 15.63096875 31.09918147 C15.64191408 33.42639883 15.6458337 35.75357141 15.6496582 38.08081055 C15.65592972 39.75693399 15.66257712 41.43305605 15.66957092 43.10917664 C15.6905298 48.59751431 15.70096484 54.08585201 15.7109375 59.57421875 C15.71498794 61.46937385 15.71910495 63.3645288 15.72328758 65.25968361 C15.74232035 74.16466588 15.75655606 83.06963996 15.76489955 91.97463864 C15.77466866 102.22964775 15.80098775 112.48444084 15.84140044 122.73937386 C15.87162225 130.68273841 15.88637412 138.62604122 15.88968056 146.56946212 C15.89202383 151.30607166 15.90089005 156.04244991 15.92614174 160.77899742 C15.94953439 165.23851475 15.95361105 169.69765027 15.94338036 174.15721321 C15.94288762 175.78571218 15.94912995 177.41423069 15.9629364 179.0426712 C16.06044132 191.2338813 14.70178979 201.87561116 7.42578125 212.06640625 C1.3074581 217.14461447 -6.063961 217.14463209 -13.61694336 217.17724609 C-15.28290526 217.20165205 -15.28290526 217.20165205 -16.98252296 217.22655106 C-20.73571827 217.27739292 -24.48876515 217.30679871 -28.2421875 217.3359375 C-30.27036789 217.35819121 -32.29851189 217.38271509 -34.32666224 217.40754592 C-43.54387876 217.52025918 -52.76127778 217.59609495 -61.97889233 217.66739464 C-65.45990463 217.6948572 -68.94089736 217.72447792 -72.42189205 217.75407672 C-97.60814665 217.96781746 -122.79457911 218.12493055 -147.98135698 218.26145339 C-156.1777461 218.3063574 -164.37408552 218.35780428 -172.57042748 218.41053832 C-180.60321618 218.46196609 -188.63602229 218.50923138 -196.66885513 218.55322587 C-201.41186563 218.57925528 -206.15485323 218.60682905 -210.89782906 218.6385994 C-215.31362767 218.66802274 -219.72942535 218.69221747 -224.14527512 218.71249962 C-225.75082256 218.72072694 -227.35636211 218.73074368 -228.96188545 218.74278831 C-258.06384803 218.95722375 -258.06384803 218.95722375 -269.83984375 211.625 C-276.57969598 204.25818477 -278.64464061 195.3557885 -278.66778564 185.62373352 C-278.67075677 184.92414605 -278.67372789 184.22455858 -278.67678905 183.50377148 C-278.68544245 181.16566941 -278.68698145 178.82761875 -278.68847656 176.48950195 C-278.69310716 174.81042879 -278.69813215 173.13135667 -278.70352173 171.45228577 C-278.71662548 166.89420493 -278.72308687 162.33613881 -278.72753239 157.77804208 C-278.73046672 154.92775733 -278.73457223 152.07747657 -278.73903656 149.22719383 C-278.75270689 140.30191673 -278.76237551 131.37664879 -278.76623845 122.45136195 C-278.77071654 112.162392 -278.78825481 101.87355506 -278.81723905 91.58462554 C-278.83888641 83.62264814 -278.84894438 75.66070807 -278.85027957 67.69870156 C-278.85132552 62.94763997 -278.85718835 58.1967035 -278.87509918 53.44567299 C-278.89163249 48.97310182 -278.89370994 44.50074912 -278.88496017 40.02815819 C-278.88419258 38.3923776 -278.88849571 36.75658502 -278.89841843 35.12083435 C-278.96518584 23.42226339 -278.78624941 13.16264119 -270.29296875 4.3125 C-265.59782073 -0.00869817 -261.53814021 -1.01732388 -255.33984375 -1.625 C-248.72702444 -1.08296563 -242.79204903 1.0968526 -237.96484375 5.75 C-234.45701597 9.9773822 -234.4029113 12.78726261 -234.40708923 18.1224823 C-234.40623322 18.77683258 -234.4053772 19.43118286 -234.40449524 20.10536194 C-234.40283771 22.30879422 -234.40836747 24.51215081 -234.41381836 26.71557617 C-234.41412463 28.31791081 -234.41399132 29.92024557 -234.4134531 31.52258015 C-234.41322704 35.81947008 -234.41902932 40.11633226 -234.42606354 44.41321564 C-234.43175202 48.44299916 -234.43202631 52.47277587 -234.43273926 56.50256348 C-234.43798977 68.29337934 -234.45195089 80.08419002 -234.46484375 91.875 C-234.48546875 118.213125 -234.50609375 144.55125 -234.52734375 171.6875 C-167.20734375 171.6875 -99.88734375 171.6875 -30.52734375 171.6875 C-30.68559612 121.50125659 -30.68559612 121.50125659 -30.88769531 71.31518555 C-30.90576172 61.58947754 -30.90576172 61.58947754 -30.90911865 57.03059387 C-30.91283218 53.85929579 -30.92776926 50.68826791 -30.949646 47.51704407 C-30.97724836 43.46160946 -30.9852781 39.40656317 -30.97963285 35.35104334 C-30.98081188 33.86914918 -30.9886456 32.38724029 -31.00420427 30.90542734 C-31.10461659 20.86926379 -30.21608946 12.28011446 -24.58984375 3.75 C-17.31913068 -1.14660268 -8.16672124 -4.24114117 0 0 Z",
      fill: r || "#000000",
      transform: "translate(676.52734375,834.3125)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C1.37671875 1.22976563 1.37671875 1.22976563 2.78125 2.484375 C3.6578125 3.26296875 4.534375 4.0415625 5.4375 4.84375 C14.54876142 13.44883023 21.45970686 23.70704181 27.53125 34.609375 C27.89105957 35.23674561 28.25086914 35.86411621 28.62158203 36.51049805 C29.578125 38.3046875 29.578125 38.3046875 30.78125 41.484375 C29.62310099 44.69795343 27.74072184 46.76921591 25.34130859 49.15136719 C24.29044571 50.20200348 24.29044571 50.20200348 23.21835327 51.27386475 C22.46309357 52.01880188 21.70783386 52.76373901 20.9296875 53.53125 C20.15565582 54.30245178 19.38162415 55.07365356 18.58413696 55.8682251 C16.11283077 58.32834356 13.63465817 60.78141348 11.15625 63.234375 C9.47870948 64.90188394 7.80162055 66.56984732 6.125 68.23828125 C2.01564081 72.3255987 -2.09937647 76.40715196 -6.21875 80.484375 C-7.77368603 77.48523084 -8.7038509 74.77932496 -9.46875 71.484375 C-12.37872692 60.61177468 -17.80027539 51.8539361 -25.21875 43.484375 C-25.73824219 42.87078125 -26.25773438 42.2571875 -26.79296875 41.625 C-37.05310466 30.35694142 -51.81045012 23.54052225 -66.86621094 22.2590332 C-89.47082111 21.31543862 -107.15170782 26.75317367 -124.11328125 42.2109375 C-135.82312823 54.21154818 -141.40346745 73.0846529 -142.21875 89.484375 C-142.29351562 90.21011719 -142.36828125 90.93585938 -142.4453125 91.68359375 C-143.4674838 107.95763688 -134.06561813 124.42971386 -123.90625 136.359375 C-112.89748028 148.77844301 -100.49449604 154.39759558 -84.21875 157.484375 C-89.94109449 164.28994278 -96.02468713 170.68553818 -102.24975586 177.03027344 C-103.52706243 178.33947587 -104.7962358 179.65666007 -106.05737305 180.98144531 C-107.89304174 182.90812516 -109.75344137 184.80749664 -111.62109375 186.703125 C-112.17860825 187.29879272 -112.73612274 187.89446045 -113.31053162 188.50817871 C-114.89382169 190.08378656 -116.27979165 191.37392015 -118.21875 192.484375 C-133.99891729 192.08489003 -147.27029329 178.40829944 -157.75 167.9609375 C-173.40779862 151.48158772 -185.3828755 129.11166841 -188.21875 106.484375 C-188.33089844 105.58976563 -188.44304687 104.69515625 -188.55859375 103.7734375 C-191.50350298 76.26072384 -186.32399627 46.24654141 -169.98828125 23.359375 C-167.80680848 20.65600083 -165.5460878 18.06253896 -163.21875 15.484375 C-162.57164062 14.70707031 -161.92453125 13.92976563 -161.2578125 13.12890625 C-142.60978742 -8.98232348 -114.61059283 -22.367869 -86.0703125 -25.19921875 C-56.23591997 -27.65011712 -23.29174323 -19.32974567 0 0 Z",
      fill: r || "#000000",
      transform: "translate(622.21875,273.515625)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C1.0725 0.7425 2.145 1.485 3.25 2.25 C11.07606938 10.07606938 13.9919506 18.85438405 14.375 29.6875 C14.23011217 39.32254053 11.95581514 48.30277871 6 56 C3.87706271 57.75604443 1.92940267 59.23003098 -0.375 60.6875 C-0.98424316 61.07470215 -1.59348633 61.4619043 -2.22119141 61.86083984 C-9.59157517 66.28609462 -19.1590372 69.4424367 -27.8203125 67.6953125 C-39.56678098 63.94823116 -50.91982354 58.50752303 -58 48 C-58.78488445 45.38749651 -59.36908832 43.03926805 -59.8125 40.375 C-59.99631226 39.31321533 -59.99631226 39.31321533 -60.18383789 38.22998047 C-61.69960557 28.62539651 -60.95945884 19.54492512 -56 11 C-48.92255556 1.41245643 -40.8019198 -4.85836621 -28.8984375 -6.7734375 C-17.94036528 -7.6299984 -8.91749031 -6.96999242 0 0 Z",
      fill: r || "#000000",
      transform: "translate(568,133)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C0 29.04 0 58.08 0 88 C-15.51 88 -31.02 88 -47 88 C-51.84763643 51.15796317 -51.84763643 51.15796317 -43.17089844 39.11816406 C-33.2834475 26.9663917 -21.18582437 16.58992363 -9.08514404 6.70440674 C-7.19828845 5.16208193 -5.33670422 3.59425499 -3.47900391 2.01708984 C-1 0 -1 0 0 0 Z",
      fill: r || "#000000",
      transform: "translate(575,635)"
    }
  )
] }), Fu = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T("svg", { viewBox: "0 0 353 353", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e && /* @__PURE__ */ T("title", { children: e }),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C1.01693939 -0.0065712 2.03387878 -0.0131424 3.08163452 -0.01991272 C6.44293294 -0.03960202 9.80418674 -0.05129948 13.16552734 -0.0612793 C14.31666393 -0.06535482 15.46780052 -0.06943035 16.65382004 -0.07362938 C22.74837819 -0.09447284 28.84291394 -0.10878129 34.9375 -0.11816406 C41.21517005 -0.12921666 47.49248451 -0.16360873 53.77002907 -0.20333576 C58.61209752 -0.22954936 63.4540819 -0.2378602 68.29621506 -0.24144554 C70.609332 -0.24630024 72.92244547 -0.25788213 75.23549271 -0.27648354 C78.48279816 -0.3009723 81.72919194 -0.29989173 84.9765625 -0.29296875 C85.92033752 -0.30577881 86.86411255 -0.31858887 87.83648682 -0.33178711 C97.52411985 -0.25702665 106.12078562 2.48922498 113.22021484 9.23950195 C118.82828194 15.79988233 120.02568928 22.70119898 120.03709412 31.11277771 C120.04218194 32.03792413 120.04726976 32.96307056 120.05251175 33.91625172 C120.06826202 37.02977827 120.07676821 40.14328157 120.08520508 43.25683594 C120.09474168 45.48408659 120.10463276 47.71133575 120.11485291 49.93858337 C120.14626795 57.26673621 120.16651179 64.59490048 120.18505859 71.9230957 C120.18835592 73.16995187 120.19165324 74.41680804 120.19505048 75.70144773 C120.22583871 87.4623461 120.25270703 99.22324858 120.26946926 110.98417568 C120.27341855 113.70820054 120.27742156 116.43222532 120.28149414 119.15625 C120.2825025 119.83326594 120.28351086 120.51028188 120.28454978 121.20781345 C120.30153483 132.16039075 120.3426191 143.11274123 120.39351713 154.06520795 C120.44538908 165.32027761 120.47394248 176.57523563 120.48166615 187.83043724 C120.48661725 194.14555302 120.5016471 200.46026603 120.54141045 206.77526665 C120.57836016 212.72204403 120.58665865 218.66819002 120.57340431 224.61506081 C120.57345813 226.79183863 120.58369911 228.96864501 120.60515594 231.14531708 C120.8260782 254.83280789 120.8260782 254.83280789 111.7624445 264.4110508 C100.63759706 274.52614079 84.1402413 272.60563094 70.18115234 272.5402832 C67.98023479 272.5397636 65.77931676 272.54028517 63.57839966 272.54179382 C58.98416135 272.54170451 54.3901 272.53135681 49.79589844 272.51318359 C43.92758227 272.49047134 38.05952353 272.48996172 32.19117546 272.49670124 C27.65281921 272.50005301 23.11452092 272.49338882 18.57617569 272.48357201 C16.4129784 272.47974258 14.24977464 272.47856235 12.08657455 272.48015785 C9.05791829 272.48053151 6.0295841 272.46782551 3.00097656 272.45166016 C1.68057373 272.45537628 1.68057373 272.45537628 0.33349609 272.45916748 C-9.80464881 272.37343689 -18.29338643 270.92713017 -26.12353516 264.17700195 C-33.64345002 256.52573486 -35.58965983 247.1249502 -35.50448608 236.69642639 C-35.50916606 235.79726185 -35.51384603 234.8980973 -35.51866782 233.97168535 C-35.53054081 230.98796784 -35.52119084 228.00471622 -35.51171875 225.02099609 C-35.5157879 222.86990595 -35.5211317 220.71881789 -35.52764893 218.56773376 C-35.54128822 212.74540654 -35.53603759 206.92323938 -35.52651167 201.10090947 C-35.51889657 194.99617802 -35.52596591 188.89145992 -35.53067017 182.78672791 C-35.53612273 172.53536529 -35.52894959 162.28406759 -35.51464844 152.03271484 C-35.49832729 140.19704834 -35.50360863 128.36153693 -35.52012765 116.5258742 C-35.5337619 106.34807673 -35.53565256 96.17032583 -35.52781165 85.99252218 C-35.52314524 79.92081661 -35.52248178 73.84918382 -35.53242111 67.77748299 C-35.54111652 62.06710526 -35.53502178 56.35692654 -35.51773834 50.64657021 C-35.51378707 48.55647359 -35.51488413 46.46636009 -35.52152634 44.37627029 C-35.59877584 17.58913875 -35.59877584 17.58913875 -25.53369141 7.27856445 C-17.795938 0.53154446 -9.88734228 0.02781206 0 0 Z M-18.75744629 21.25302315 C-20.65207659 25.30829288 -20.54239224 28.8173177 -20.51121521 33.24180603 C-20.51660075 34.15656049 -20.52198629 35.07131495 -20.52753502 36.01378924 C-20.5418462 39.07996756 -20.53470301 42.14571609 -20.52758789 45.21191406 C-20.53328979 47.40978849 -20.54025335 49.60765995 -20.54838562 51.80552673 C-20.56635183 57.77656005 -20.56514212 63.7474467 -20.55944324 69.71849895 C-20.55635644 74.70127823 -20.56243815 79.68402913 -20.56848198 84.66680437 C-20.58334077 97.09268905 -20.57970411 109.51850842 -20.56761868 121.94438995 C-20.5576863 132.73271732 -20.57062693 143.52087319 -20.59455287 154.30917411 C-20.61894276 165.39027676 -20.62815225 176.47131028 -20.62190014 187.5524407 C-20.61852595 193.77220136 -20.62097646 199.99182031 -20.63815117 206.2115612 C-20.65359472 212.05978763 -20.64969328 217.90768608 -20.63084602 223.75589943 C-20.62715302 225.90292167 -20.63028923 228.04996806 -20.64073181 230.19696808 C-20.6538944 233.12676368 -20.64243582 236.05546594 -20.6247406 238.98521423 C-20.63434561 239.835899 -20.64395061 240.68658378 -20.65384668 241.56304687 C-20.58748763 246.89881814 -19.67167551 249.94699773 -16.12353516 254.17700195 C-10.96849367 257.83715508 -5.89029342 257.60957461 0.19287109 257.58105469 C1.21798798 257.58791794 2.24310486 257.59478119 3.29928589 257.60185242 C6.67932075 257.62011621 10.05889134 257.61628376 13.43896484 257.6105957 C15.79256338 257.61515731 18.14616059 257.62046282 20.49975586 257.6264801 C25.42909156 257.63541012 30.35826523 257.63298875 35.28759766 257.62304688 C41.60277516 257.61155068 47.91739405 257.63177982 54.23249817 257.66096401 C59.09154814 257.67931269 63.95046388 257.67903628 68.80953979 257.67332649 C71.13793726 257.67317315 73.46634375 257.67922792 75.79470825 257.69161797 C79.05018148 257.70650241 82.30461773 257.69586908 85.56005859 257.67871094 C86.52023895 257.68837891 87.48041931 257.69804687 88.46969604 257.70800781 C94.25824794 257.64415267 97.42839469 256.9566353 101.87646484 253.17700195 C106.13464885 248.33148222 106.024992 243.71024496 106.02363586 237.51802063 C106.02731255 236.62272036 106.03098924 235.7274201 106.03477734 234.80498952 C106.04582642 231.79267607 106.04966011 228.7803971 106.0534668 225.76806641 C106.05973053 223.6131428 106.06637725 221.45822028 106.07337952 219.30329895 C106.0907977 213.43949385 106.10134356 207.57569691 106.10958505 201.71187234 C106.11473357 198.04919242 106.12080938 194.38651503 106.12709618 190.7238369 C106.14615072 179.26663461 106.16038118 167.80943878 106.16870815 156.35222369 C106.1784819 143.12232963 106.20480408 129.89260283 106.24520904 116.66276771 C106.27535936 106.44016003 106.29017601 96.21760032 106.29348916 85.99494904 C106.2958409 79.88797382 106.30481766 73.78117722 106.32995033 67.67424965 C106.35321687 61.9278462 106.35746982 56.18173916 106.34718895 50.43530083 C106.34669314 48.32781107 106.35302692 46.2203068 106.366745 44.11286163 C106.38444698 41.23185335 106.3773658 38.35191076 106.36421204 35.47090149 C106.37518128 34.64024195 106.38615053 33.80958242 106.39745218 32.95375139 C106.3347519 27.25121116 105.02532269 22.96423589 101.87646484 18.17700195 C97.53179463 14.09311104 92.12362766 14.74713625 86.48999023 14.77294922 C85.44551224 14.76608597 84.40103424 14.75922272 83.3249054 14.75215149 C79.87450543 14.73385991 76.42455912 14.7377245 72.97412109 14.7434082 C70.57425285 14.73884755 68.17438591 14.73354233 65.77452087 14.7275238 C60.74505304 14.71858804 55.71574395 14.72102125 50.6862793 14.73095703 C44.24216174 14.74244713 37.79859211 14.72223631 31.35454655 14.69303989 C26.39855978 14.67469092 21.44270463 14.67496781 16.48669243 14.68067741 C14.11084665 14.68083079 11.73499204 14.67477332 9.35917854 14.66238594 C6.03654769 14.647503 2.71493311 14.65813427 -0.60766602 14.67529297 C-1.5881189 14.665625 -2.56857178 14.65595703 -3.57873535 14.64599609 C-10.21509869 14.71773322 -14.45249956 15.7832271 -18.75744629 21.25302315 Z",
      fill: r || "#000000",
      transform: "translate(134.12353515625,0.822998046875)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C8.75718764 6.11823715 13.98530082 15.00594352 16.1328125 25.39453125 C17.47914309 36.52980714 15.15427678 46.78453423 8.75 56.03515625 C2.6341639 63.43853679 -4.463173 67.48642225 -13.4921875 70.49609375 C-13.4921875 98.87609375 -13.4921875 127.25609375 -13.4921875 156.49609375 C-18.7721875 156.49609375 -24.0521875 156.49609375 -29.4921875 156.49609375 C-29.4921875 151.54609375 -29.4921875 146.59609375 -29.4921875 141.49609375 C-38.4021875 141.49609375 -47.3121875 141.49609375 -56.4921875 141.49609375 C-56.4921875 136.21609375 -56.4921875 130.93609375 -56.4921875 125.49609375 C-47.5821875 125.49609375 -38.6721875 125.49609375 -29.4921875 125.49609375 C-29.4921875 120.54609375 -29.4921875 115.59609375 -29.4921875 110.49609375 C-37.4121875 110.49609375 -45.3321875 110.49609375 -53.4921875 110.49609375 C-53.4921875 105.21609375 -53.4921875 99.93609375 -53.4921875 94.49609375 C-45.9021875 94.49609375 -38.3121875 94.49609375 -30.4921875 94.49609375 C-30.9871875 82.61609375 -30.9871875 82.61609375 -31.4921875 70.49609375 C-35.1221875 69.17609375 -38.7521875 67.85609375 -42.4921875 66.49609375 C-51.5851477 60.87985362 -57.50863164 52.718492 -60.83203125 42.546875 C-63.22000512 31.5113271 -61.96851005 20.97870394 -56.171875 11.2890625 C-42.68040114 -7.98973758 -19.79988683 -11.94820757 0 0 Z M-40.8671875 16.87109375 C-45.1188661 22.30955527 -46.54876806 28.66116264 -46.4921875 35.49609375 C-45.36523122 42.62136572 -41.74146881 47.68802359 -36.4921875 52.49609375 C-31.06691423 56.23350423 -24.59224264 57.13312711 -18.12890625 56.12890625 C-11.33742209 54.22869825 -5.98895074 50.28695399 -2.10546875 44.390625 C1.06864683 38.09808008 1.66749558 31.9246335 -0.1171875 25.109375 C-2.68299997 18.36266274 -7.39153579 13.52605213 -13.8515625 10.328125 C-23.96861252 7.14035628 -33.7311889 9.15326313 -40.8671875 16.87109375 Z",
      fill: r || "#000000",
      transform: "translate(200.4921875,81.50390625)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C2 2 2 2 2.24050903 4.3664856 C2.23606781 5.35687836 2.23162659 6.34727112 2.22705078 7.36767578 C2.22680908 8.50438721 2.22656738 9.64109863 2.22631836 10.81225586 C2.21608643 12.01116455 2.20585449 13.21007324 2.1953125 14.4453125 C2.19329834 15.54415771 2.19128418 16.64300293 2.18920898 17.77514648 C2.17872104 21.8918066 2.15079862 26.00840736 2.125 30.125 C2.08375 39.32375 2.0425 48.5225 2 58 C25.43 58 48.86 58 73 58 C72.92087839 40.40862991 72.92087839 40.40862991 72.81982422 22.81738281 C72.81398319 20.61263217 72.80888671 18.40787938 72.8046875 16.203125 C72.79445557 15.05763184 72.78422363 13.91213867 72.77368164 12.73193359 C72.77331909 11.08813721 72.77331909 11.08813721 72.77294922 9.41113281 C72.768508 8.46071106 72.76406677 7.51028931 72.75949097 6.53106689 C73.01549479 3.83693609 73.50898977 2.2484041 75 0 C77.8125 -1.4375 77.8125 -1.4375 81 -2 C84.56446721 -0.46079825 85.82847773 0.74271659 88 4 C88.26069641 6.71884155 88.26069641 6.71884155 88.2746582 10.04443359 C88.28419022 11.28937592 88.29372223 12.53431824 88.30354309 13.81698608 C88.30328163 15.17747018 88.30234443 16.53795428 88.30078125 17.8984375 C88.30466894 19.29464851 88.30900377 20.69085835 88.31376648 22.08706665 C88.3212285 25.0141381 88.32093803 27.94108895 88.31567383 30.86816406 C88.30988544 34.61304841 88.32679442 38.35743717 88.3500185 42.10223961 C88.36477695 44.98650992 88.36562459 47.87066154 88.36250877 50.75496292 C88.36302114 52.13521937 88.36824297 53.51548261 88.37832069 54.89570236 C88.39070435 56.82935541 88.38194039 58.76310861 88.37231445 60.69677734 C88.37294388 61.7958139 88.3735733 62.89485046 88.3742218 64.02719116 C87.94990454 67.3979571 87.00703838 69.28271351 85 72 C81.74781038 73.62609481 78.16567631 73.17444476 74.59057617 73.19287109 C73.28545326 73.20513733 73.28545326 73.20513733 71.95396423 73.21765137 C69.06697279 73.24251787 66.18003054 73.25902417 63.29296875 73.2734375 C62.30811304 73.27876118 61.32325733 73.28408485 60.30855751 73.28956985 C55.09625654 73.3163063 49.88397957 73.33568003 44.67163086 73.35009766 C39.28436019 73.36675105 33.89770061 73.41153332 28.51066113 73.4624691 C24.37139675 73.49610277 20.23227815 73.50767081 16.09288979 73.51332474 C14.10692993 73.52004744 12.12098 73.53529586 10.13515282 73.55921555 C7.35546236 73.59078824 4.57742966 73.5909159 1.79760742 73.58349609 C0.56693542 73.6081041 0.56693542 73.6081041 -0.68859863 73.63320923 C-4.7957957 73.58832866 -6.56423747 73.30861635 -10.01040649 70.8679657 C-12.3830606 67.44782456 -12.62758949 65.66344059 -12.63110352 61.52905273 C-12.64363663 60.24099228 -12.65616974 58.95293182 -12.66908264 57.62583923 C-12.65681525 56.22841375 -12.64339537 54.83099797 -12.62890625 53.43359375 C-12.62973541 51.99300457 -12.63219657 50.55241548 -12.63621521 49.11183167 C-12.63906901 46.0981079 -12.62441283 43.08512907 -12.59692383 40.0715332 C-12.56280954 36.21203636 -12.56887253 32.35386835 -12.5875864 28.49430752 C-12.59816242 25.52164158 -12.58921394 22.54928407 -12.57420158 19.5766468 C-12.56902569 18.15371682 -12.56949442 16.73075456 -12.57574654 15.3078289 C-12.58120608 13.31902769 -12.55795722 11.3302104 -12.53344727 9.34155273 C-12.52724869 8.21079819 -12.52105011 7.08004364 -12.5146637 5.9150238 C-11.884874 2.34793333 -10.83250532 1.19082524 -8 -1 C-4.34765818 -2.21744727 -3.37046678 -1.64202228 0 0 Z",
      fill: r || "#000000",
      transform: "translate(139,278)"
    }
  ),
  /* @__PURE__ */ T(
    "path",
    {
      d: "M0 0 C4.06610902 2.10835283 6.29054187 3.77663286 8 8 C8.8382746 12.85316873 8.49228037 16.15389312 6 20.4375 C2.43601866 23.48173407 -0.29699654 24.88376607 -5 25 C-9.58409235 23.6247723 -13.21489654 21.96341647 -16 18 C-17.12491289 13.35036006 -17.43816997 11.16115041 -15.75 6.6875 C-11.72788453 0.51067981 -7.42077649 -1.0240391 0 0 Z",
      fill: r || "#000000",
      transform: "translate(181,33)"
    }
  )
] }), cw = ({ color: r, title: e, ...t }) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "#000000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T(
        "path",
        {
          d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"
        }
      ),
      /* @__PURE__ */ T(
        "path",
        {
          d: "M21 3v5h-5"
        }
      )
    ]
  }
), x0 = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    viewBox: "0 0 1089 1089",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T(
        "path",
        {
          d: "m471.863 543.762 3.923-.03c4.175-.027 8.35-.038 12.526-.044l2.158-.004c33.72-.047 66.446 2.47 99.53 9.316l3.365.68C650.43 565.29 704.063 587.54 753 619l-.365 1.635a2182.63 2182.63 0 0 0-3.697 16.865l-.526 2.395c-7.035 32.94-1.607 67.753 14.588 97.105l1.973 3.715c6.954 12.79 16.311 22.887 26.595 33.058a1394.08 1394.08 0 0 1 5.278 5.258c1.13 1.126 2.26 2.25 3.392 3.375l1.576 1.572c2.077 2.05 4.067 3.942 6.49 5.58 2.278 1.937 2.324 3.156 2.602 6.102l.31 3.011.284 3.395.35 3.672c.415 4.42.782 8.842 1.15 13.265l.453 5.35c1.252 14.878 2.412 29.763 3.547 44.65l.282 3.695c.663 8.705 1.318 17.411 1.968 26.117l.27 3.59c.25 3.351.498 6.703.746 10.055l.226 3.02.204 2.792.18 2.416c.13 2.443.132 4.87.124 7.315-66.062.07-132.123.132-198.185.17l-2.963.002a748961.42 748961.42 0 0 1-95.02.05l-3.142.001c-33.61.017-67.221.047-100.832.084a120824.744 120824.744 0 0 1-118.263.075h-2.91c-15.455.005-30.91.024-46.365.047-15.54.024-31.08.033-46.62.027-9.23-.003-18.461.005-27.691.03-6.171.014-12.342.015-18.513.003-3.513-.006-7.026-.006-10.54.013-23.104.098-40.858-1.96-58.35-18.645-15.071-16.516-18.563-35.682-17.828-57.45C76.798 806.135 100.58 754.62 127 717l1.438-2.055c7.07-10.07 14.412-19.728 22.562-28.945l2.438-2.773a253.066 253.066 0 0 1 12.085-12.715c1.63-1.61 1.63-1.61 3.415-4.012 2.317-2.81 4.856-5.015 7.625-7.371 2.317-2.024 4.548-4.122 6.777-6.242 7.432-7.032 15.362-13.244 23.574-19.336a708.664 708.664 0 0 0 5.836-4.392c72.324-54.535 168.735-84.827 259.113-85.394ZM533 35l2.498.52c34.946 7.491 67.859 23.035 94.21 47.375 2.033 1.867 4.113 3.645 6.23 5.418 36.298 31.86 58.9 84.083 62.062 131.687 1.052 21.638 1.094 43.675-3 65l-.472 2.679C686.01 335.577 663.445 380.674 630 416l-1.786 1.889c-31.996 33.56-76.719 60.326-124.141 62.272-1.366.02-2.73.033-4.096.042l-2.24.021c-2.371.018-4.741.024-7.112.026l-2.454.002c-11.674-.015-22.796-.428-34.17-3.252l-4.583-1.031C420.02 469.058 392.934 454.529 370 435l-2.23-1.895C354.617 421.583 342.254 409.188 332 395l-2.352-3.23C320.486 378.844 312.79 365.295 306 351l-.996-2.056C295.236 328.664 289.043 307.101 285 285l-.496-2.544c-8.44-44.55-2.7-93.505 16.496-134.456l.988-2.135C310.812 126.97 322.612 110.102 337 95l1.645-1.728C346.885 84.677 355.248 76.855 365 70l1.748-1.244C413.528 35.69 476.825 22.994 533 35Z",
          fill: r || "#000000"
        }
      ),
      /* @__PURE__ */ T(
        "path",
        {
          d: "m895.438 542.813 3.662-.038c11.79-.019 22.831 1.542 34.087 5.038l2.618.802c6.086 1.92 11.67 4.17 17.195 7.385l2.8 1.445c8.664 4.652 15.257 10.721 22.2 17.555l3.5 3.383c13.99 13.631 23.546 28.959 29.063 47.804l.63 2.057c3.256 11.032 4.13 21.787 4.057 33.256l.023 3.723c-.043 20.546-5.918 41.07-16.859 58.52-1.274 2.033-2.449 4.09-3.6 6.194-1.508 2.546-2.73 4.07-4.814 6.063l-1.172 2.125c-2.434 3.828-5.404 6.962-8.515 10.25-.628.666-1.255 1.332-1.9 2.019C972.708 756.4 967.163 761.786 960 766l-3.016 1.902-3.234 2.035-1.718 1.1c-3.338 2.088-6.389 3.45-10.157 4.525-2.223.741-2.223.741-3.875 2.438-1.223 3.829-1.801 7.279-2.27 11.273-.962 4.908-2.857 8.13-6.668 11.38L927 801.936l-2.352 1.489a418.228 418.228 0 0 1-12.046 6.863c-2.664 1.75-4.086 2.92-5.602 5.71-.51 2.905-.51 2.905-.438 6l-.058 3.125c.63 3.65 1.54 4.676 4.496 6.875 3.203 1.412 3.203 1.412 6.75 2.5 15.422 5.27 15.422 5.27 19.348 10.477 3.66 8.207 2.304 19.24-.16 27.648-3.97 6.916-9.315 10.666-16.903 12.84L918 886c-4.479 1.425-7.157 3.182-10 7-.664 4.244-.354 7.937 1 12 2.3 1.157 2.3 1.157 5 2 8.206 2.825 14.96 6.14 19.695 13.71 1.551 3.911 1.802 7.394 1.742 11.54l-.027 2.277c-.305 9.849-3.266 16.07-10.41 22.88-1.946 1.55-3.771 2.51-6 3.593-7.316 4.862-7.316 4.862-12 12-.582 5.332.335 8.411 3 13 2.305 2.529 2.305 2.529 4.938 4.75l2.59 2.297c2.138 1.69 4.03 2.8 6.472 3.953 4.537 3.873 7.433 8.115 8.3 14.055.143 2.26.194 4.501.204 6.765l.03 2.49c.015 1.726.022 3.453.022 5.179.007 2.636.06 5.27.118 7.906.009 1.683.015 3.367.017 5.05l.066 2.374c-.067 5.307-.067 5.307-2.02 7.78-11.187 9.707-37.565 9.044-51.737 8.214-10.095-1.266-16.548-6.065-23-13.813-3.458-6.03-3.08-13.265-3.334-20.057a782.412 782.412 0 0 0-1.549-27.713l-.263-3.642a9222.333 9222.333 0 0 0-3.13-41.376l-.658-8.53c-.996-12.93-1.996-25.86-3.023-38.787l-.212-2.666c-.308-3.87-.617-7.742-.93-11.613a1099.966 1099.966 0 0 1-1.539-21.886c-.362-5.92-.85-11.823-1.362-17.73-.318-3.875-.627-7.75-.938-11.625l-.26-3.237a3752.811 3752.811 0 0 1-1.552-20.107 858.601 858.601 0 0 0-.524-6.541c-.432-5.168-.768-10.292-.84-15.478l-.103-2.857a85.698 85.698 0 0 1-.03-5.22c-.135-2.77-.458-4.468-1.753-6.935-2.404-2.018-4.883-3.725-7.54-5.391-7.119-4.491-12.68-10.357-18.523-16.36-1.11-1.12-2.22-2.242-3.333-3.362a3063.38 3063.38 0 0 1-3.202-3.246l-1.47-1.494c-4.85-4.985-8.602-10.06-11.932-16.147l-1.223-2.168c-15.758-27.998-20.967-59-12.965-90.457 8.83-31.244 29.624-59.962 57.375-77.375a275.85 275.85 0 0 1 3.813-2l3.02-1.621c12.795-6.678 25.833-10.584 39.98-13.38.595-.172 1.19-.346 1.804-.525 5.078-1.097 10.462-.66 15.634-.662ZM873 609l-2.813 2.813C865.69 618.365 863.915 626.12 865 634c1.864 9.741 6.211 15.923 14 22 6.959 4.387 14.56 5.863 22.625 4.25 1.465-.393 2.924-.808 4.375-1.25l3.5-1.063c7.487-3.473 12.884-10.372 15.844-17.894 2.702-8.412 2.566-16.99-1.344-25.043-5.832-7.948-12.11-14.086-22-16-12.292-.979-20.316 1.183-29 10Z",
          fill: r || "#000000"
        }
      )
    ]
  }
), lw = ({ color: r, title: e, ...t }) => {
  const n = r || "#000000";
  return /* @__PURE__ */ T("svg", { viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    e && /* @__PURE__ */ T("title", { children: e }),
    /* @__PURE__ */ T(
      "path",
      {
        d: "M256 48v48M256 416v48M403.08 108.92l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48M96 256H48M403.08 403.08l-33.94-33.94M142.86 142.86l-33.94-33.94",
        fill: "none",
        stroke: n,
        "stroke-linecap": "round",
        "stroke-miterlimit": "10",
        "stroke-width": "32"
      }
    ),
    /* @__PURE__ */ T(
      "circle",
      {
        fill: "none",
        cx: "256",
        cy: "256",
        r: "80",
        stroke: n,
        "stroke-miterlimit": "10",
        "stroke-linecap": "round",
        "stroke-width": "32"
      }
    )
  ] });
}, uw = "_divider_176bo_66", dw = "_passkey-icon_176bo_75", Ki = {
  divider: uw,
  passkeyIcon: dw
}, Sl = ({ colorMode: r, onClose: e, onSetColorMode: t, onSuccess: n }) => {
  const a = nw(), o = Tn(r), {
    validate: i,
    reset: s,
    setError: l,
    ...c
  } = E0({
    name: "password",
    required: !0
  }), { validate: u, ...d } = E0({
    name: "username",
    required: !0
  }), w = o5(), f = On(), [A, b] = dt(!1), [g, k] = dt(!1), [v, C] = dt(!1), [W, Z] = dt(!0), [D, H] = dt(null), [y, S] = dt(null), [_, F] = dt(null), M = Ut(() => !A && !g, [A, g]), j = ht(() => Z(!1), [Z]), Y = ht(async () => {
    const pe = `${Sl.displayName}#handleOnAuthenticateWithPasskeyClick`;
    let ye;
    if (H(null), !(!a || !w || !_)) {
      C(!0);
      try {
        ye = await l3({
          clientInformation: a,
          logger: w,
          username: d.value,
          vault: _
        }), await new nl({
          logger: w,
          vault: _
        }).setSettings({
          colorMode: r
        }), n({
          authenticationStore: {
            __type: wr.Passkey,
            store: ye
          },
          vault: _
        }), j();
      } catch (te) {
        w.error(`${pe}:`, te), H(te);
      }
    }
  }, [
    a,
    r,
    j,
    w,
    n,
    C,
    H,
    d.value,
    _
  ]), N = ht(async () => {
    const pe = `${Sl.displayName}#handleOnAuthenticateWithPasswordClick`;
    let ye;
    if (S(null), !(!w || !_ || !a) && !(i() || M && ml(c.value).score <= 0))
      try {
        ye = await u3({
          clientInformation: a,
          logger: w,
          password: c.value,
          username: d.value,
          vault: _
        }), await new nl({
          logger: w,
          vault: _
        }).setSettings({
          colorMode: r
        }), n({
          authenticationStore: {
            __type: wr.Password,
            store: ye
          },
          vault: _
        }), j();
      } catch (te) {
        if (w.error(`${pe}:`, te), te.isKatavaultError && te.type === e3)
          return l(f("errors.inputs.incorrectPassword"));
        S(te);
      }
  }, [
    a,
    r,
    j,
    M,
    w,
    n,
    c.value,
    l,
    S,
    f,
    i,
    _
  ]), O = ht(() => {
    if (v) {
      H(null), C(!1);
      return;
    }
    s(), S(null), b(!1), k(!1), F(null);
  }, [v, C, s, F, _]), G = ht(async () => {
    let pe, ye, te, B;
    !a || !w || u() || (B = await b1({
      logger: w,
      username: d.value
    }), pe = !!await new Wo({
      hostname: a.hostname,
      logger: w,
      username: d.value,
      vault: B
    }).passkey(), ye = !!await new S1({
      hostname: a.hostname,
      logger: w,
      username: d.value,
      vault: B
    }).challenge(), F(B), b(pe), k(ye), (pe || ye) && (te = await new nl({
      logger: w,
      vault: B
    }).settings(), t(te.colorMode)));
  }, [
    a,
    w,
    t,
    b,
    k,
    F,
    d.value,
    u
  ]), Q = ht(async (pe) => pe.key === "Enter" && await N(), [N]), ie = ht(() => t(r === "light" ? "dark" : "light"), [r, t]), fe = ht(async (pe) => pe.key === "Enter" && await G(), [G]);
  return /* @__PURE__ */ T(
    $i,
    {
      closeOnEscape: !0,
      closeOnInteractOutside: !0,
      colorMode: r,
      body: /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, grow: !0, minHeight: 250, paddingX: Xt, spacing: "md", children: _ ? v ? D ? /* @__PURE__ */ T(ln, { children: [
        /* @__PURE__ */ T(sw, { className: Ke(Ki.passkeyIcon), color: o }),
        /* @__PURE__ */ T(qt, { colorMode: r, textAlign: "center", children: f("errors.descriptions.type", {
          context: D.type
        }) }),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T(
          un,
          {
            colorMode: r,
            fullWidth: !0,
            onClick: Y,
            rightIcon: /* @__PURE__ */ T(cw, {}),
            children: f("buttons.retry")
          }
        )
      ] }) : /* @__PURE__ */ T(ln, { children: [
        /* @__PURE__ */ T(wd, { colorMode: r, icon: /* @__PURE__ */ T(Fu, {}), size: "lg" }),
        /* @__PURE__ */ T(qt, { colorMode: r, fullWidth: !0, textAlign: "center", children: f("captions.verifyPasskey") })
      ] }) : A || g ? /* @__PURE__ */ T(ln, { children: [
        /* @__PURE__ */ T(fn, { colorMode: r, children: f("headings.welcomeBack") }),
        g && /* @__PURE__ */ T(ln, { children: [
          /* @__PURE__ */ T(
            ew,
            {
              ...c,
              colorMode: r,
              onKeyUp: Q,
              placeholder: f("placeholders.password")
            }
          ),
          /* @__PURE__ */ T(hn, {}),
          y && /* @__PURE__ */ T(
            S0,
            {
              colorMode: r,
              message: f("errors.descriptions.type", {
                context: y.type
              })
            }
          ),
          /* @__PURE__ */ T(
            un,
            {
              colorMode: r,
              fullWidth: !0,
              onClick: N,
              rightIcon: /* @__PURE__ */ T(x0, {}),
              type: "submit",
              children: f("buttons.signInWithPassword")
            }
          )
        ] }),
        A && g && /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "center", spacing: "sm", children: [
          /* @__PURE__ */ T("div", { className: Ke(Ki.divider) }),
          /* @__PURE__ */ T(qt, { colorMode: r, size: "lg", children: f("captions.or") }),
          /* @__PURE__ */ T("div", { className: Ke(Ki.divider) })
        ] }),
        A && Wo.isSupported() && /* @__PURE__ */ T(
          un,
          {
            colorMode: r,
            fullWidth: !0,
            onClick: Y,
            rightIcon: /* @__PURE__ */ T(Fu, {}),
            children: f("buttons.signupWithPasskey")
          }
        )
      ] }) : /* @__PURE__ */ T(ln, { children: [
        /* @__PURE__ */ T(fn, { colorMode: r, children: f("headings.finishCreatingANewAccount") }),
        /* @__PURE__ */ T(
          Q9,
          {
            ...c,
            colorMode: r,
            onKeyUp: Q,
            placeholder: f("placeholders.password")
          }
        ),
        /* @__PURE__ */ T(hn, {}),
        y && /* @__PURE__ */ T(
          S0,
          {
            colorMode: r,
            message: f("errors.descriptions.type", {
              context: y.type
            })
          }
        ),
        /* @__PURE__ */ T(
          un,
          {
            colorMode: r,
            fullWidth: !0,
            onClick: N,
            rightIcon: /* @__PURE__ */ T(x0, {}),
            type: "submit",
            children: f("buttons.signupWithPassword")
          }
        ),
        Wo.isSupported() && /* @__PURE__ */ T(ln, { children: [
          /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "center", spacing: "sm", children: [
            /* @__PURE__ */ T("div", { className: Ke(Ki.divider) }),
            /* @__PURE__ */ T(qt, { colorMode: r, size: "lg", children: f("captions.or") }),
            /* @__PURE__ */ T("div", { className: Ke(Ki.divider) })
          ] }),
          /* @__PURE__ */ T(
            un,
            {
              colorMode: r,
              fullWidth: !0,
              onClick: Y,
              rightIcon: /* @__PURE__ */ T(Fu, {}),
              children: f("buttons.signupWithPasskey")
            }
          )
        ] })
      ] }) : /* @__PURE__ */ T(ln, { children: [
        /* @__PURE__ */ T(fn, { colorMode: r, children: f("headings.signInOrCreateANewAccount") }),
        /* @__PURE__ */ T(
          Ed,
          {
            ...d,
            autocomplete: "username email",
            colorMode: r,
            onKeyUp: fe,
            placeholder: f("placeholders.usernameEmail"),
            type: "text"
          }
        ),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "center", spacing: "sm", children: /* @__PURE__ */ T(
          un,
          {
            colorMode: r,
            fullWidth: !0,
            onClick: G,
            rightIcon: /* @__PURE__ */ T(ow, {}),
            children: f("buttons.continue")
          }
        ) })
      ] }) }),
      footer: /* @__PURE__ */ T(r5, { colorMode: r }),
      header: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, padding: Xt, spacing: "xs", children: [
        _ && /* @__PURE__ */ T($t, { align: "center", justify: "start", spacing: "xs", children: /* @__PURE__ */ T(Yr, { colorMode: r, icon: /* @__PURE__ */ T(aw, {}), onClick: O }) }),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T($t, { align: "center", justify: "end", spacing: "xs", children: [
          /* @__PURE__ */ T(
            Yr,
            {
              colorMode: r,
              icon: r === "dark" ? /* @__PURE__ */ T(iw, {}) : /* @__PURE__ */ T(lw, {}),
              onClick: ie
            }
          ),
          /* @__PURE__ */ T(Yr, { colorMode: r, icon: /* @__PURE__ */ T(Fi, {}), onClick: j })
        ] })
      ] }),
      onClose: j,
      onCloseAnimationEnd: e,
      open: W
    }
  );
};
Sl.displayName = "Root";
const i5 = ({ children: r, clientInformation: e, i18n: t, logger: n }) => {
  const [a, o] = dt(0), [i, s] = dt({
    clientInformation: e,
    i18n: t,
    logger: n
  }), l = ht(() => o(Date.now()), [o]);
  return kr(() => {
    s({
      clientInformation: e,
      i18n: t,
      logger: n
    }), l();
  }, [e, t, n]), /* @__PURE__ */ T(
    uu.Provider,
    {
      value: {
        onUpdate: l,
        state: i,
        timestamp: a
      },
      children: r
    }
  );
}, hw = ({ clientInformation: r, i18n: e, logger: t, ...n }) => {
  const [a, o] = dt("light"), i = ht((s) => o(s), [o]);
  return /* @__PURE__ */ T(
    i5,
    {
      clientInformation: r,
      i18n: e,
      logger: t,
      children: /* @__PURE__ */ T(
        Sl,
        {
          colorMode: a,
          onSetColorMode: i,
          ...n
        }
      )
    }
  );
}, fw = ({
  color: r = "#000000",
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("path", { d: "m6 9 6 6 6-6" })
    ]
  }
), pw = "_container_13lpc_90", gw = "_content_13lpc_95", mw = "_header_13lpc_101", yw = "_icon_13lpc_130", ww = "_icon--open_13lpc_135", Po = {
  container: pw,
  content: gw,
  header: mw,
  icon: yw,
  iconOpen: ww
}, vw = ({
  buttonClassName: r,
  containerClassName: e,
  content: t,
  colorMode: n,
  onClick: a,
  open: o,
  title: i
}) => {
  const s = G7(null), l = Tn(n);
  return /* @__PURE__ */ T("div", { className: Ke(Po.container, e), children: [
    /* @__PURE__ */ T(
      "button",
      {
        className: Ke(Po.header, r),
        "data-color-mode": n,
        onClick: a,
        children: [
          i,
          /* @__PURE__ */ T(
            fw,
            {
              className: Ke(
                Po.icon,
                o && Po.iconOpen
              ),
              color: l
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ T(
      "div",
      {
        className: Ke(
          Po.content,
          o && Po.contentOpen
        ),
        style: {
          maxHeight: o && s.current ? `${s.current.scrollHeight}px` : "0px"
        },
        ref: s,
        children: t
      }
    )
  ] });
}, xd = ({
  color: r = "#000000",
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("path", { d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" }),
      /* @__PURE__ */ T("path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" })
    ]
  }
), _w = "_container_16xg2_90", bw = "_content_16xg2_106", Sw = "_footer__button_16xg2_111", Ew = "_footer__button--closed_16xg2_115", xw = "_footer__content_16xg2_119", kw = "_header_16xg2_123", Aw = "_circular-icon_16xg2_130", Cn = {
  container: _w,
  content: bw,
  footerButton: Sw,
  footerButtonClosed: Ew,
  footerContent: xw,
  header: kw,
  circularIcon: Aw
};
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const {
  entries: s5,
  setPrototypeOf: k0,
  isFrozen: Cw,
  getPrototypeOf: Dw,
  getOwnPropertyDescriptor: Mw
} = Object;
let {
  freeze: jr,
  seal: pn,
  create: c5
} = Object, {
  apply: M1,
  construct: R1
} = typeof Reflect < "u" && Reflect;
jr || (jr = function(r) {
  return r;
});
pn || (pn = function(r) {
  return r;
});
M1 || (M1 = function(r, e, t) {
  return r.apply(e, t);
});
R1 || (R1 = function(r, e) {
  return new r(...e);
});
const Mc = Fr(Array.prototype.forEach), Rw = Fr(Array.prototype.lastIndexOf), A0 = Fr(Array.prototype.pop), Yi = Fr(Array.prototype.push), Iw = Fr(Array.prototype.splice), sl = Fr(String.prototype.toLowerCase), zu = Fr(String.prototype.toString), C0 = Fr(String.prototype.match), Gi = Fr(String.prototype.replace), Tw = Fr(String.prototype.indexOf), Ow = Fr(String.prototype.trim), kn = Fr(Object.prototype.hasOwnProperty), Ur = Fr(RegExp.prototype.test), Ji = Pw(TypeError);
function Fr(r) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      n[a - 1] = arguments[a];
    return M1(r, e, n);
  };
}
function Pw(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return R1(r, t);
  };
}
function St(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : sl;
  k0 && k0(r, null);
  let n = e.length;
  for (; n--; ) {
    let a = e[n];
    if (typeof a == "string") {
      const o = t(a);
      o !== a && (Cw(e) || (e[n] = o), a = o);
    }
    r[a] = !0;
  }
  return r;
}
function Nw(r) {
  for (let e = 0; e < r.length; e++)
    kn(r, e) || (r[e] = null);
  return r;
}
function Zn(r) {
  const e = c5(null);
  for (const [t, n] of s5(r))
    kn(r, t) && (Array.isArray(n) ? e[t] = Nw(n) : n && typeof n == "object" && n.constructor === Object ? e[t] = Zn(n) : e[t] = n);
  return e;
}
function Xi(r, e) {
  for (; r !== null; ) {
    const n = Mw(r, e);
    if (n) {
      if (n.get)
        return Fr(n.get);
      if (typeof n.value == "function")
        return Fr(n.value);
    }
    r = Dw(r);
  }
  function t() {
    return null;
  }
  return t;
}
const D0 = jr(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Hu = jr(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), qu = jr(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Bw = jr(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Wu = jr(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Lw = jr(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), M0 = jr(["#text"]), R0 = jr(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ku = jr(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), I0 = jr(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Rc = jr(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Uw = pn(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Vw = pn(/<%[\w\W]*|[\w\W]*%>/gm), $w = pn(/\$\{[\w\W]*/gm), jw = pn(/^data-[\-\w.\u00B7-\uFFFF]+$/), Fw = pn(/^aria-[\-\w]+$/), l5 = pn(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), zw = pn(/^(?:\w+script|data):/i), Hw = pn(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), u5 = pn(/^html$/i), qw = pn(/^[a-z][.\w]*(-[.\w]+)+$/i);
var T0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Fw,
  ATTR_WHITESPACE: Hw,
  CUSTOM_ELEMENT: qw,
  DATA_ATTR: jw,
  DOCTYPE_NAME: u5,
  ERB_EXPR: Vw,
  IS_ALLOWED_URI: l5,
  IS_SCRIPT_OR_DATA: zw,
  MUSTACHE_EXPR: Uw,
  TMPLIT_EXPR: $w
});
const Zi = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Ww = function() {
  return typeof window > "u" ? null : window;
}, Kw = function(r, e) {
  if (typeof r != "object" || typeof r.createPolicy != "function")
    return null;
  let t = null;
  const n = "data-tt-policy-suffix";
  e && e.hasAttribute(n) && (t = e.getAttribute(n));
  const a = "dompurify" + (t ? "#" + t : "");
  try {
    return r.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, O0 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function d5() {
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ww();
  const e = (X) => d5(X);
  if (e.version = "3.2.6", e.removed = [], !r || !r.document || r.document.nodeType !== Zi.document || !r.Element)
    return e.isSupported = !1, e;
  let {
    document: t
  } = r;
  const n = t, a = n.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: i,
    Node: s,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = r.NamedNodeMap || r.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: w,
    trustedTypes: f
  } = r, A = l.prototype, b = Xi(A, "cloneNode"), g = Xi(A, "remove"), k = Xi(A, "nextSibling"), v = Xi(A, "childNodes"), C = Xi(A, "parentNode");
  if (typeof i == "function") {
    const X = t.createElement("template");
    X.content && X.content.ownerDocument && (t = X.content.ownerDocument);
  }
  let W, Z = "";
  const {
    implementation: D,
    createNodeIterator: H,
    createDocumentFragment: y,
    getElementsByTagName: S
  } = t, {
    importNode: _
  } = n;
  let F = O0();
  e.isSupported = typeof s5 == "function" && typeof C == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: M,
    ERB_EXPR: j,
    TMPLIT_EXPR: Y,
    DATA_ATTR: N,
    ARIA_ATTR: O,
    IS_SCRIPT_OR_DATA: G,
    ATTR_WHITESPACE: Q,
    CUSTOM_ELEMENT: ie
  } = T0;
  let {
    IS_ALLOWED_URI: fe
  } = T0, pe = null;
  const ye = St({}, [...D0, ...Hu, ...qu, ...Wu, ...M0]);
  let te = null;
  const B = St({}, [...R0, ...Ku, ...I0, ...Rc]);
  let oe = Object.seal(c5(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ce = null, Ce = null, he = !0, ge = !0, h = !1, m = !0, E = !1, $ = !0, R = !1, P = !1, J = !1, I = !1, U = !1, K = !1, z = !0, re = !1;
  const le = "user-content-";
  let ee = !0, Se = !1, Re = {}, Ne = null;
  const Ie = St({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let De = null;
  const Fe = St({}, ["audio", "video", "img", "source", "image", "track"]);
  let lt = null;
  const ft = St({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), it = "http://www.w3.org/1998/Math/MathML", Ue = "http://www.w3.org/2000/svg", nt = "http://www.w3.org/1999/xhtml";
  let He = nt, ze = !1, Be = null;
  const Pt = St({}, [it, Ue, nt], zu);
  let kt = St({}, ["mi", "mo", "mn", "ms", "mtext"]), It = St({}, ["annotation-xml"]);
  const sr = St({}, ["title", "style", "font", "a", "script"]);
  let Kt = null;
  const pr = ["application/xhtml+xml", "text/html"], wn = "text/html";
  let Ft = null, Xr = null;
  const Hi = t.createElement("form"), Do = function(X) {
    return X instanceof RegExp || X instanceof Function;
  }, Mo = function() {
    let X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Xr && Xr === X)) {
      if ((!X || typeof X != "object") && (X = {}), X = Zn(X), Kt = // eslint-disable-next-line unicorn/prefer-includes
      pr.indexOf(X.PARSER_MEDIA_TYPE) === -1 ? wn : X.PARSER_MEDIA_TYPE, Ft = Kt === "application/xhtml+xml" ? zu : sl, pe = kn(X, "ALLOWED_TAGS") ? St({}, X.ALLOWED_TAGS, Ft) : ye, te = kn(X, "ALLOWED_ATTR") ? St({}, X.ALLOWED_ATTR, Ft) : B, Be = kn(X, "ALLOWED_NAMESPACES") ? St({}, X.ALLOWED_NAMESPACES, zu) : Pt, lt = kn(X, "ADD_URI_SAFE_ATTR") ? St(Zn(ft), X.ADD_URI_SAFE_ATTR, Ft) : ft, De = kn(X, "ADD_DATA_URI_TAGS") ? St(Zn(Fe), X.ADD_DATA_URI_TAGS, Ft) : Fe, Ne = kn(X, "FORBID_CONTENTS") ? St({}, X.FORBID_CONTENTS, Ft) : Ie, ce = kn(X, "FORBID_TAGS") ? St({}, X.FORBID_TAGS, Ft) : Zn({}), Ce = kn(X, "FORBID_ATTR") ? St({}, X.FORBID_ATTR, Ft) : Zn({}), Re = kn(X, "USE_PROFILES") ? X.USE_PROFILES : !1, he = X.ALLOW_ARIA_ATTR !== !1, ge = X.ALLOW_DATA_ATTR !== !1, h = X.ALLOW_UNKNOWN_PROTOCOLS || !1, m = X.ALLOW_SELF_CLOSE_IN_ATTR !== !1, E = X.SAFE_FOR_TEMPLATES || !1, $ = X.SAFE_FOR_XML !== !1, R = X.WHOLE_DOCUMENT || !1, I = X.RETURN_DOM || !1, U = X.RETURN_DOM_FRAGMENT || !1, K = X.RETURN_TRUSTED_TYPE || !1, J = X.FORCE_BODY || !1, z = X.SANITIZE_DOM !== !1, re = X.SANITIZE_NAMED_PROPS || !1, ee = X.KEEP_CONTENT !== !1, Se = X.IN_PLACE || !1, fe = X.ALLOWED_URI_REGEXP || l5, He = X.NAMESPACE || nt, kt = X.MATHML_TEXT_INTEGRATION_POINTS || kt, It = X.HTML_INTEGRATION_POINTS || It, oe = X.CUSTOM_ELEMENT_HANDLING || {}, X.CUSTOM_ELEMENT_HANDLING && Do(X.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (oe.tagNameCheck = X.CUSTOM_ELEMENT_HANDLING.tagNameCheck), X.CUSTOM_ELEMENT_HANDLING && Do(X.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (oe.attributeNameCheck = X.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), X.CUSTOM_ELEMENT_HANDLING && typeof X.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (oe.allowCustomizedBuiltInElements = X.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), E && (ge = !1), U && (I = !0), Re && (pe = St({}, M0), te = [], Re.html === !0 && (St(pe, D0), St(te, R0)), Re.svg === !0 && (St(pe, Hu), St(te, Ku), St(te, Rc)), Re.svgFilters === !0 && (St(pe, qu), St(te, Ku), St(te, Rc)), Re.mathMl === !0 && (St(pe, Wu), St(te, I0), St(te, Rc))), X.ADD_TAGS && (pe === ye && (pe = Zn(pe)), St(pe, X.ADD_TAGS, Ft)), X.ADD_ATTR && (te === B && (te = Zn(te)), St(te, X.ADD_ATTR, Ft)), X.ADD_URI_SAFE_ATTR && St(lt, X.ADD_URI_SAFE_ATTR, Ft), X.FORBID_CONTENTS && (Ne === Ie && (Ne = Zn(Ne)), St(Ne, X.FORBID_CONTENTS, Ft)), ee && (pe["#text"] = !0), R && St(pe, ["html", "head", "body"]), pe.table && (St(pe, ["tbody"]), delete ce.tbody), X.TRUSTED_TYPES_POLICY) {
        if (typeof X.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Ji('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof X.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Ji('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        W = X.TRUSTED_TYPES_POLICY, Z = W.createHTML("");
      } else
        W === void 0 && (W = Kw(f, a)), W !== null && typeof Z == "string" && (Z = W.createHTML(""));
      jr && jr(X), Xr = X;
    }
  }, mc = St({}, [...Hu, ...qu, ...Bw]), Mr = St({}, [...Wu, ...Lw]), yc = function(X) {
    let Ee = C(X);
    (!Ee || !Ee.tagName) && (Ee = {
      namespaceURI: He,
      tagName: "template"
    });
    const _e = sl(X.tagName), je = sl(Ee.tagName);
    return Be[X.namespaceURI] ? X.namespaceURI === Ue ? Ee.namespaceURI === nt ? _e === "svg" : Ee.namespaceURI === it ? _e === "svg" && (je === "annotation-xml" || kt[je]) : !!mc[_e] : X.namespaceURI === it ? Ee.namespaceURI === nt ? _e === "math" : Ee.namespaceURI === Ue ? _e === "math" && It[je] : !!Mr[_e] : X.namespaceURI === nt ? Ee.namespaceURI === Ue && !It[je] || Ee.namespaceURI === it && !kt[je] ? !1 : !Mr[_e] && (sr[_e] || !mc[_e]) : !!(Kt === "application/xhtml+xml" && Be[X.namespaceURI]) : !1;
  }, x = function(X) {
    Yi(e.removed, {
      element: X
    });
    try {
      C(X).removeChild(X);
    } catch {
      g(X);
    }
  }, V = function(X, Ee) {
    try {
      Yi(e.removed, {
        attribute: Ee.getAttributeNode(X),
        from: Ee
      });
    } catch {
      Yi(e.removed, {
        attribute: null,
        from: Ee
      });
    }
    if (Ee.removeAttribute(X), X === "is")
      if (I || U)
        try {
          x(Ee);
        } catch {
        }
      else
        try {
          Ee.setAttribute(X, "");
        } catch {
        }
  }, L = function(X) {
    let Ee = null, _e = null;
    if (J)
      X = "<remove></remove>" + X;
    else {
      const qe = C0(X, /^[\r\n\t ]+/);
      _e = qe && qe[0];
    }
    Kt === "application/xhtml+xml" && He === nt && (X = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + X + "</body></html>");
    const je = W ? W.createHTML(X) : X;
    if (He === nt)
      try {
        Ee = new w().parseFromString(je, Kt);
      } catch {
      }
    if (!Ee || !Ee.documentElement) {
      Ee = D.createDocument(He, "template", null);
      try {
        Ee.documentElement.innerHTML = ze ? Z : je;
      } catch {
      }
    }
    const Ze = Ee.body || Ee.documentElement;
    return X && _e && Ze.insertBefore(t.createTextNode(_e), Ze.childNodes[0] || null), He === nt ? S.call(Ee, R ? "html" : "body")[0] : R ? Ee.documentElement : Ze;
  }, p = function(X) {
    return H.call(
      X.ownerDocument || X,
      X,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, q = function(X) {
    return X instanceof d && (typeof X.nodeName != "string" || typeof X.textContent != "string" || typeof X.removeChild != "function" || !(X.attributes instanceof u) || typeof X.removeAttribute != "function" || typeof X.setAttribute != "function" || typeof X.namespaceURI != "string" || typeof X.insertBefore != "function" || typeof X.hasChildNodes != "function");
  }, ue = function(X) {
    return typeof s == "function" && X instanceof s;
  };
  function de(X, Ee, _e) {
    Mc(X, (je) => {
      je.call(e, Ee, _e, Xr);
    });
  }
  const xe = function(X) {
    let Ee = null;
    if (de(F.beforeSanitizeElements, X, null), q(X))
      return x(X), !0;
    const _e = Ft(X.nodeName);
    if (de(F.uponSanitizeElement, X, {
      tagName: _e,
      allowedTags: pe
    }), $ && X.hasChildNodes() && !ue(X.firstElementChild) && Ur(/<[/\w!]/g, X.innerHTML) && Ur(/<[/\w!]/g, X.textContent) || X.nodeType === Zi.progressingInstruction || $ && X.nodeType === Zi.comment && Ur(/<[/\w]/g, X.data))
      return x(X), !0;
    if (!pe[_e] || ce[_e]) {
      if (!ce[_e] && Ge(_e) && (oe.tagNameCheck instanceof RegExp && Ur(oe.tagNameCheck, _e) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(_e)))
        return !1;
      if (ee && !Ne[_e]) {
        const je = C(X) || X.parentNode, Ze = v(X) || X.childNodes;
        if (Ze && je) {
          const qe = Ze.length;
          for (let at = qe - 1; at >= 0; --at) {
            const rt = b(Ze[at], !0);
            rt.__removalCount = (X.__removalCount || 0) + 1, je.insertBefore(rt, k(X));
          }
        }
      }
      return x(X), !0;
    }
    return X instanceof l && !yc(X) || (_e === "noscript" || _e === "noembed" || _e === "noframes") && Ur(/<\/no(script|embed|frames)/i, X.innerHTML) ? (x(X), !0) : (E && X.nodeType === Zi.text && (Ee = X.textContent, Mc([M, j, Y], (je) => {
      Ee = Gi(Ee, je, " ");
    }), X.textContent !== Ee && (Yi(e.removed, {
      element: X.cloneNode()
    }), X.textContent = Ee)), de(F.afterSanitizeElements, X, null), !1);
  }, Oe = function(X, Ee, _e) {
    if (z && (Ee === "id" || Ee === "name") && (_e in t || _e in Hi))
      return !1;
    if (!(ge && !Ce[Ee] && Ur(N, Ee)) && !(he && Ur(O, Ee))) {
      if (!te[Ee] || Ce[Ee]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(Ge(X) && (oe.tagNameCheck instanceof RegExp && Ur(oe.tagNameCheck, X) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(X)) && (oe.attributeNameCheck instanceof RegExp && Ur(oe.attributeNameCheck, Ee) || oe.attributeNameCheck instanceof Function && oe.attributeNameCheck(Ee)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          Ee === "is" && oe.allowCustomizedBuiltInElements && (oe.tagNameCheck instanceof RegExp && Ur(oe.tagNameCheck, _e) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(_e)))
        ) return !1;
      } else if (!lt[Ee] && !Ur(fe, Gi(_e, Q, "")) && !((Ee === "src" || Ee === "xlink:href" || Ee === "href") && X !== "script" && Tw(_e, "data:") === 0 && De[X]) && !(h && !Ur(G, Gi(_e, Q, ""))) && _e)
        return !1;
    }
    return !0;
  }, Ge = function(X) {
    return X !== "annotation-xml" && C0(X, ie);
  }, Ve = function(X) {
    de(F.beforeSanitizeAttributes, X, null);
    const {
      attributes: Ee
    } = X;
    if (!Ee || q(X))
      return;
    const _e = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: te,
      forceKeepAttr: void 0
    };
    let je = Ee.length;
    for (; je--; ) {
      const Ze = Ee[je], {
        name: qe,
        namespaceURI: at,
        value: rt
      } = Ze, Le = Ft(qe), Qe = rt;
      let Pe = qe === "value" ? Qe : Ow(Qe);
      if (_e.attrName = Le, _e.attrValue = Pe, _e.keepAttr = !0, _e.forceKeepAttr = void 0, de(F.uponSanitizeAttribute, X, _e), Pe = _e.attrValue, re && (Le === "id" || Le === "name") && (V(qe, X), Pe = le + Pe), $ && Ur(/((--!?|])>)|<\/(style|title)/i, Pe)) {
        V(qe, X);
        continue;
      }
      if (_e.forceKeepAttr)
        continue;
      if (!_e.keepAttr) {
        V(qe, X);
        continue;
      }
      if (!m && Ur(/\/>/i, Pe)) {
        V(qe, X);
        continue;
      }
      E && Mc([M, j, Y], (Je) => {
        Pe = Gi(Pe, Je, " ");
      });
      const Ye = Ft(X.nodeName);
      if (!Oe(Ye, Le, Pe)) {
        V(qe, X);
        continue;
      }
      if (W && typeof f == "object" && typeof f.getAttributeType == "function" && !at)
        switch (f.getAttributeType(Ye, Le)) {
          case "TrustedHTML": {
            Pe = W.createHTML(Pe);
            break;
          }
          case "TrustedScriptURL": {
            Pe = W.createScriptURL(Pe);
            break;
          }
        }
      if (Pe !== Qe)
        try {
          at ? X.setAttributeNS(at, qe, Pe) : X.setAttribute(qe, Pe), q(X) ? x(X) : A0(e.removed);
        } catch {
          V(qe, X);
        }
    }
    de(F.afterSanitizeAttributes, X, null);
  }, xt = function X(Ee) {
    let _e = null;
    const je = p(Ee);
    for (de(F.beforeSanitizeShadowDOM, Ee, null); _e = je.nextNode(); )
      de(F.uponSanitizeShadowNode, _e, null), xe(_e), Ve(_e), _e.content instanceof o && X(_e.content);
    de(F.afterSanitizeShadowDOM, Ee, null);
  };
  return e.sanitize = function(X) {
    let Ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _e = null, je = null, Ze = null, qe = null;
    if (ze = !X, ze && (X = "<!-->"), typeof X != "string" && !ue(X))
      if (typeof X.toString == "function") {
        if (X = X.toString(), typeof X != "string")
          throw Ji("dirty is not a string, aborting");
      } else
        throw Ji("toString is not a function");
    if (!e.isSupported)
      return X;
    if (P || Mo(Ee), e.removed = [], typeof X == "string" && (Se = !1), Se) {
      if (X.nodeName) {
        const Le = Ft(X.nodeName);
        if (!pe[Le] || ce[Le])
          throw Ji("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (X instanceof s)
      _e = L("<!---->"), je = _e.ownerDocument.importNode(X, !0), je.nodeType === Zi.element && je.nodeName === "BODY" || je.nodeName === "HTML" ? _e = je : _e.appendChild(je);
    else {
      if (!I && !E && !R && // eslint-disable-next-line unicorn/prefer-includes
      X.indexOf("<") === -1)
        return W && K ? W.createHTML(X) : X;
      if (_e = L(X), !_e)
        return I ? null : K ? Z : "";
    }
    _e && J && x(_e.firstChild);
    const at = p(Se ? X : _e);
    for (; Ze = at.nextNode(); )
      xe(Ze), Ve(Ze), Ze.content instanceof o && xt(Ze.content);
    if (Se)
      return X;
    if (I) {
      if (U)
        for (qe = y.call(_e.ownerDocument); _e.firstChild; )
          qe.appendChild(_e.firstChild);
      else
        qe = _e;
      return (te.shadowroot || te.shadowrootmode) && (qe = _.call(n, qe, !0)), qe;
    }
    let rt = R ? _e.outerHTML : _e.innerHTML;
    return R && pe["!doctype"] && _e.ownerDocument && _e.ownerDocument.doctype && _e.ownerDocument.doctype.name && Ur(u5, _e.ownerDocument.doctype.name) && (rt = "<!DOCTYPE " + _e.ownerDocument.doctype.name + `>
` + rt), E && Mc([M, j, Y], (Le) => {
      rt = Gi(rt, Le, " ");
    }), W && K ? W.createHTML(rt) : rt;
  }, e.setConfig = function() {
    let X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Mo(X), P = !0;
  }, e.clearConfig = function() {
    Xr = null, P = !1;
  }, e.isValidAttribute = function(X, Ee, _e) {
    Xr || Mo({});
    const je = Ft(X), Ze = Ft(Ee);
    return Oe(je, Ze, _e);
  }, e.addHook = function(X, Ee) {
    typeof Ee == "function" && Yi(F[X], Ee);
  }, e.removeHook = function(X, Ee) {
    if (Ee !== void 0) {
      const _e = Rw(F[X], Ee);
      return _e === -1 ? void 0 : Iw(F[X], _e, 1)[0];
    }
    return A0(F[X]);
  }, e.removeHooks = function(X) {
    F[X] = [];
  }, e.removeAllHooks = function() {
    F = O0();
  }, e;
}
var Yw = d5();
function du({
  className: r,
  color: e,
  dataURI: t,
  title: n
}) {
  let a, o, i, s, l;
  if (t.indexOf("data:") !== 0 || t.indexOf(",") < 0 || (a = t.split(",").pop(), !a))
    return null;
  const [c, u] = t.substring(5, t.indexOf(",")).split(";");
  return c !== "image/svg+xml" || (u === "base64" && (a = window.atob(a)), s = new DOMParser(), l = decodeURIComponent(a), o = s.parseFromString(
    Yw.sanitize(l, { USE_PROFILES: { svg: !0, svgFilters: !0 } }),
    c
  ), i = o.getElementsByTagName("svg").item(0), !i) ? null : _l(i.tagName.toLowerCase(), {
    ...Array.from(i.attributes).reduce(
      (d, w) => ({
        ...d,
        [w.name]: w.value
      }),
      {}
    ),
    className: r,
    dangerouslySetInnerHTML: {
      __html: n ? `<title>${n}</title>${i.innerHTML}` : i.innerHTML
    },
    ...e && { fill: e }
  });
}
const Gw = ({ account: r }) => /* @__PURE__ */ T(Dt, { className: Ke(Cn.footerContent), children: /* @__PURE__ */ T($t, { spacing: "xs", children: r.connections.map(({ wallet: e }) => {
  const t = /* @__PURE__ */ T(xd, { className: Ke(Cn.circularIcon) });
  return e.iconURI ? du({
    className: Ke(Cn.circularIcon),
    dataURI: e.iconURI,
    title: e.name
  }) ?? t : t;
}) }) });
var P0, N0;
function Jw() {
  return N0 || (N0 = 1, P0 = function() {
    var r = document.getSelection();
    if (!r.rangeCount)
      return function() {
      };
    for (var e = document.activeElement, t = [], n = 0; n < r.rangeCount; n++)
      t.push(r.getRangeAt(n));
    switch (e.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        e.blur();
        break;
      default:
        e = null;
        break;
    }
    return r.removeAllRanges(), function() {
      r.type === "Caret" && r.removeAllRanges(), r.rangeCount || t.forEach(function(a) {
        r.addRange(a);
      }), e && e.focus();
    };
  }), P0;
}
var Yu, B0;
function Xw() {
  if (B0) return Yu;
  B0 = 1;
  var r = Jw(), e = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, t = "Copy to clipboard: #{key}, Enter";
  function n(o) {
    var i = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, i);
  }
  function a(o, i) {
    var s, l, c, u, d, w, f = !1;
    i || (i = {}), s = i.debug || !1;
    try {
      c = r(), u = document.createRange(), d = document.getSelection(), w = document.createElement("span"), w.textContent = o, w.ariaHidden = "true", w.style.all = "unset", w.style.position = "fixed", w.style.top = 0, w.style.clip = "rect(0, 0, 0, 0)", w.style.whiteSpace = "pre", w.style.webkitUserSelect = "text", w.style.MozUserSelect = "text", w.style.msUserSelect = "text", w.style.userSelect = "text", w.addEventListener("copy", function(b) {
        if (b.stopPropagation(), i.format)
          if (b.preventDefault(), typeof b.clipboardData > "u") {
            s && console.warn("unable to use e.clipboardData"), s && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var g = e[i.format] || e.default;
            window.clipboardData.setData(g, o);
          } else
            b.clipboardData.clearData(), b.clipboardData.setData(i.format, o);
        i.onCopy && (b.preventDefault(), i.onCopy(b.clipboardData));
      }), document.body.appendChild(w), u.selectNodeContents(w), d.addRange(u);
      var A = document.execCommand("copy");
      if (!A)
        throw new Error("copy command was unsuccessful");
      f = !0;
    } catch (b) {
      s && console.error("unable to copy using execCommand: ", b), s && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(i.format || "text", o), i.onCopy && i.onCopy(window.clipboardData), f = !0;
      } catch (g) {
        s && console.error("unable to copy using clipboardData: ", g), s && console.error("falling back to prompt"), l = n("message" in i ? i.message : t), window.prompt(l, o);
      }
    } finally {
      d && (typeof d.removeRange == "function" ? d.removeRange(u) : d.removeAllRanges()), w && document.body.removeChild(w), c();
    }
    return f;
  }
  return Yu = a, Yu;
}
var Zw = Xw();
const L0 = /* @__PURE__ */ Bi(Zw);
function Qw(r) {
  const e = Ut(() => 1500, []), [t, n] = dt(!1), [a, o] = dt(r), i = ht(() => {
    (async () => {
      if (!navigator.clipboard) {
        n(L0(a));
        return;
      }
      try {
        await navigator.clipboard.writeText(a), n(!0);
      } catch {
        n(L0(a));
      }
    })();
  }, [n, a]), s = ht(
    (l) => {
      s(l);
    },
    [o]
  );
  return kr(() => {
    let l = null;
    return t && (l = window.setTimeout(() => n(!1), e)), () => {
      l && window.clearTimeout(l);
    };
  }, [t]), {
    copied: t,
    onCopy: i,
    setValue: s,
    value: a
  };
}
const ev = ({
  color: r,
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "#000000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("path", { d: "M20 6 9 17l-5-5" })
    ]
  }
), tv = ({
  color: r,
  ...e
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "#000000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ T("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
      /* @__PURE__ */ T("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
    ]
  }
), h5 = ({
  text: r,
  ...e
}) => {
  const {
    copied: t,
    onCopy: n
  } = Qw(r);
  return /* @__PURE__ */ T(
    Yr,
    {
      ...e,
      icon: t ? /* @__PURE__ */ T(ev, {}) : /* @__PURE__ */ T(tv, {}),
      onClick: n,
      ...t && {
        iconColor: e.colorMode === "dark" ? "#4ade80" : "#22c55e"
      }
    }
  );
}, rv = "_icon_13ubb_63", nv = "_icon--xs_13ubb_67", av = "_icon--sm_13ubb_71", ov = "_icon--lg_13ubb_75", iv = "_icon--xl_13ubb_79", No = {
  icon: rv,
  iconXs: nv,
  iconSm: av,
  iconLg: ov,
  iconXl: iv
}, sv = ({
  chain: r,
  className: e,
  colorMode: t,
  color: n,
  key: a,
  size: o = "md"
}) => {
  const i = Tn(t), s = Ut(() => {
    switch (o) {
      case "xs":
        return No.iconXs;
      case "sm":
        return No.iconSm;
      case "lg":
        return No.iconLg;
      case "xl":
        return No.iconXl;
      case "md":
      default:
        return No.iconMd;
    }
  }, [o]), l = Ut(() => r.nativeCurrency().iconURI ?? null, [r]);
  return l ? du({
    className: Ke(No.icon, s, e),
    color: n ?? i,
    dataURI: l,
    title: r.displayName()
  }) : null;
};
function cv(r, e) {
  const t = e == null ? void 0 : e.end, n = e == null ? void 0 : e.start;
  let a = "", o = "";
  return t > r.length || n > r.length || n + t >= r.length ? r : (a = r.substring(r.length - t), o = r.substring(0, n), `${o}...${a}`);
}
const lv = ({ account: r, chains: e, colorMode: t }) => {
  const n = Tn(t), a = ji(t), o = On(), i = ht((s) => du({
    className: Ke(Cn.circularIcon),
    dataURI: s.iconURI(),
    key: `chain-icon-${s.chainID()}`,
    title: s.displayName()
  }) || null, []);
  return /* @__PURE__ */ T(Dt, { className: Ke(Cn.footerContent), spacing: "sm", children: e.map((s) => {
    const l = z6({
      account: r,
      chain: s
    }), c = r.balances[s.chainID()].amount ?? BigInt(0), u = s.nativeCurrency().decimals, d = X8({
      decimals: u,
      value: new cd(c)
    });
    return /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, spacing: "sm", children: [
      i(s),
      /* @__PURE__ */ T(Dt, { fullWidth: !0, grow: !0, justify: "evenly", children: [
        /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "end", children: [
          /* @__PURE__ */ T(qt, { bold: !0, colorMode: t, color: n, size: "md", title: l, children: `${s.shortName()}:` }),
          /* @__PURE__ */ T(qt, { colorMode: t, color: a, size: "md", title: l, children: cv(l, {
            end: 4,
            start: 6
          }) })
        ] }),
        /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "end", spacing: "xs", children: [
          /* @__PURE__ */ T(qt, { bold: !0, colorMode: t, color: a, title: `${$h(d, {
            decimals: u,
            thousandSeparatedOnly: !0
          })} ${s.nativeCurrency().symbol.toUpperCase()}`, children: $h(d, {
            decimals: d.gt(1) ? 2 : u
          }) }),
          /* @__PURE__ */ T(
            sv,
            {
              color: a,
              colorMode: t,
              chain: s,
              size: "xs"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ T(h5, { colorMode: t, size: "xs", text: l, title: o("captions.copyAddress") })
    ] }, "");
  }) });
}, U0 = ({ account: r, chains: e, colorMode: t }) => {
  const n = ji(t), a = On(), [o, i] = dt(!1), s = Ut(() => "12.5rem", []), l = ht(() => i(!o), [o, i]);
  return /* @__PURE__ */ T("div", { className: Ke(Cn.container), "data-color-mode": t, children: /* @__PURE__ */ T(Dt, { className: Ke(Cn.content), fullWidth: !0, children: [
    /* @__PURE__ */ T(Dt, { className: Ke(Cn.header), fullWidth: !0, spacing: "xs", children: [
      /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, spacing: "xs", children: r.name && /* @__PURE__ */ T(
        qt,
        {
          bold: !0,
          colorMode: t,
          maxWidth: s,
          textAlign: "left",
          title: a("labels.name"),
          truncate: !0,
          children: r.name
        }
      ) }),
      /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, spacing: "xs", children: [
        /* @__PURE__ */ T(
          qt,
          {
            colorMode: t,
            color: n,
            maxWidth: s,
            size: "sm",
            textAlign: "left",
            title: `${a("labels.accountID")}: ${r.key}`,
            truncate: !0,
            children: r.key
          }
        ),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T(h5, { colorMode: t, size: "xs", text: r.key, title: a("captions.copyAccountID") })
      ] })
    ] }),
    /* @__PURE__ */ T(
      vw,
      {
        buttonClassName: Ke(Cn.footerButton, !o && Cn.footerButtonClosed),
        colorMode: t,
        containerClassName: Ke(Cn.footer),
        content: r.__type === Er.Ephemeral ? /* @__PURE__ */ T(
          lv,
          {
            account: r,
            chains: e,
            colorMode: t
          }
        ) : /* @__PURE__ */ T(Gw, { account: r, colorMode: t }),
        onClick: l,
        open: o,
        title: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, spacing: "xs", children: [
          /* @__PURE__ */ T(qt, { colorMode: t, fullWidth: !0, textAlign: "left", children: r.__type === Er.Ephemeral ? a("headings.networks") : a("headings.connections") }),
          /* @__PURE__ */ T(qt, { colorMode: t, fullWidth: !0, textAlign: "right", children: `(${r.__type === Er.Ephemeral ? e.length : r.connections.length})` })
        ] })
      }
    )
  ] }) });
}, uv = "_container_s58qk_90", dv = "_container--clickable_s58qk_106", hv = "_content_s58qk_117", fv = "_icon_s58qk_123", Ic = {
  container: uv,
  containerClickable: dv,
  content: hv,
  icon: fv
}, pv = ({ colorMode: r, icon: e, onClick: t, text: n }) => {
  const a = ji(r);
  return /* @__PURE__ */ T("div", { className: Ke(Ic.container, t && Ic.containerClickable), "data-color-mode": r, onClick: t, children: /* @__PURE__ */ T(Dt, { align: "center", className: Ke(Ic.content), fullWidth: !0, justify: "center", spacing: "sm", children: [
    e && go(e, {
      ...e.props,
      className: Ke(Ic.icon),
      color: a
    }),
    /* @__PURE__ */ T(qt, { colorMode: r, color: a, size: e ? "md" : "lg", children: n })
  ] }) });
};
function gv() {
  const r = Br(vd), e = Br(pc), [t, n] = dt([]), a = ht(async () => {
    r && n(await r.accounts());
  }, [n, r]), o = ht(
    async (i) => {
      !e || e !== i.detail.username || await a();
    },
    [a, e]
  );
  return kr(() => {
    (async () => await a())();
  }, []), kr(() => (window.addEventListener(Gr.AccountsUpdated, o), () => window.removeEventListener(Gr.AccountsUpdated, o)), [o]), t;
}
function mv() {
  const { state: r, timestamp: e } = Br(t5), [t, n] = dt(r ?? []);
  return kr(() => {
    r && (async () => n(r))();
  }, [e]), t;
}
function yv() {
  const r = Br(Sd), e = Br(pc), [t, n] = dt("light"), a = ht(async () => {
    if (!r)
      return;
    const { colorMode: i } = await r.settings();
    n(i);
  }, [n, r]), o = ht(
    async (i) => {
      !e || e !== i.detail.username || await a();
    },
    [a, e]
  );
  return kr(() => {
    (async () => await a())();
  }, []), kr(() => (window.addEventListener(Gr.SettingsUpdated, o), () => window.removeEventListener(Gr.SettingsUpdated, o)), [o]), t;
}
const I1 = ({
  color: r = "#000000",
  title: e,
  ...t
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      e && /* @__PURE__ */ T("title", { children: e }),
      /* @__PURE__ */ T("path", { d: "M8 3 4 7l4 4" }),
      /* @__PURE__ */ T("path", { d: "M4 7h16" }),
      /* @__PURE__ */ T("path", { d: "m16 21 4-4-4-4" }),
      /* @__PURE__ */ T("path", { d: "M20 17H4" })
    ]
  }
), V0 = ({
  color: r = "#000000",
  ...e
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ T("path", { d: "M5 12h14" }),
      /* @__PURE__ */ T("path", { d: "M12 5v14" })
    ]
  }
), wv = ({
  color: r,
  ...e
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ T("path", { d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ T("circle", { cx: "12", cy: "12", r: "3" })
    ]
  }
), vv = ({
  closeOnEscape: r,
  closeOnInteractOutside: e,
  colorMode: t,
  message: n,
  onClose: a,
  onConfirm: o,
  open: i,
  title: s
}) => {
  const l = On();
  return /* @__PURE__ */ T(
    $i,
    {
      closeOnEscape: r,
      closeOnInteractOutside: e,
      colorMode: t,
      body: /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, grow: !0, paddingBottom: Xt, paddingX: Xt, children: /* @__PURE__ */ T(qt, { colorMode: t, fullWidth: !0, textAlign: "justify", children: n }) }),
      footer: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "center", padding: Xt, spacing: "xs", children: [
        /* @__PURE__ */ T(un, { colorMode: t, fullWidth: !0, onClick: a, variant: "secondary", children: l("buttons.cancel") }),
        /* @__PURE__ */ T(
          un,
          {
            colorMode: t,
            fullWidth: !0,
            onClick: o,
            children: l("buttons.confirm")
          }
        )
      ] }),
      header: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, padding: Xt, spacing: "xs", children: [
        /* @__PURE__ */ T(fn, { colorMode: t, textAlign: "left", children: s }),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T(Yr, { colorMode: t, icon: /* @__PURE__ */ T(Fi, {}), onClick: a })
      ] }),
      onClose: a,
      open: i
    }
  );
};
function _v(r) {
  const [e, t] = dt(!1), n = ht(({ matches: a }) => t(a), []);
  return kr(() => {
    const a = window.matchMedia(r);
    return a.matches !== e && t(a.matches), a.addEventListener("change", n), () => a.removeEventListener("change", n);
  }, [r]), e;
}
function kd() {
  return _v("(min-width: 768px)");
}
const bv = "_button_xcdfe_90", Sv = "_content_xcdfe_127", Ev = "_host_xcdfe_139", xv = "_icon_xcdfe_144", Qi = {
  button: bv,
  content: Sv,
  host: Ev,
  icon: xv
}, kv = ({ colorMode: r, connection: e, onClick: t }) => {
  const n = ji(r), a = kd(), o = Ut(() => {
    const s = /* @__PURE__ */ T(xd, { className: Ke(Qi.icon) });
    return e.iconURI ? du({
      className: Ke(Qi.icon),
      dataURI: e.iconURI,
      title: e.name
    }) ?? s : s;
  }, [e.iconURI, e.name]), i = ht(() => t(), [t]);
  return /* @__PURE__ */ T(
    "button",
    {
      className: Ke(Qi.button),
      "data-color-mode": r,
      onClick: i,
      children: /* @__PURE__ */ T(
        Vi,
        {
          align: "center",
          className: Ke(Qi.content),
          direction: a ? "vertical" : "horizontal",
          fullWidth: !0,
          justify: "center",
          spacing: "sm",
          children: [
            o,
            /* @__PURE__ */ T(
              Dt,
              {
                align: a ? "start" : "center",
                fullWidth: !0,
                justify: "evenly",
                children: [
                  /* @__PURE__ */ T(fn, { colorMode: r, fullWidth: !0, size: "sm", textAlign: a ? "center" : "left", children: e.name }),
                  e.host && /* @__PURE__ */ T(qt, { className: Ke(Qi.host), colorMode: r, fullWidth: !0, color: n, size: "xs", truncate: !0, textAlign: a ? "center" : "left", children: e.host })
                ]
              }
            )
          ]
        }
      )
    }
  );
};
function Av() {
  const r = Br(vd), e = Br(pc);
  return (t) => {
    (async () => !r || !e || (await r.upsert(t), window.dispatchEvent(new al(e))))();
  };
}
function Cv() {
  const r = Br(bd), [e, t] = dt([]);
  return kr(() => {
    (async () => {
      let n = [], a;
      for (const o of r)
        a = await o.availableConnections(), n = [
          ...n,
          ...a.map((i) => ({
            ...i,
            connectorID: o.id()
          }))
        ];
      t(n);
    })();
  }, [r.length]), e;
}
function Dv() {
  return Br(bd);
}
const Ad = ({
  colorMode: r,
  onClose: e,
  open: t
}) => {
  const n = Av(), a = Cv(), o = Dv(), i = o5(), s = kd(), l = On(), [c, u] = dt(null), d = Ut(() => ({
    fullWidth: !0,
    minHeight: 250,
    grow: !0,
    paddingBottom: Xt,
    paddingX: Xt,
    spacing: "md"
  }), []), w = ht((f, A) => async () => {
    const b = `${Ad.displayName}#handleOnConnectionClick`, g = o.find((v) => v.id() === f) ?? null;
    let k;
    if (!g) {
      i == null || i.error(`${b} - connector not found`);
      return;
    }
    u(A);
    try {
      k = await g.connect(A.id), n(k), e();
    } catch (v) {
      i == null || i.error(`${b} - `, v);
    } finally {
      u(null);
    }
  }, [n, o, i, e, u]);
  return /* @__PURE__ */ T(
    $i,
    {
      colorMode: r,
      body: c ? /* @__PURE__ */ T(Dt, { ...d, align: "center", children: [
        /* @__PURE__ */ T(wd, { colorMode: r, icon: /* @__PURE__ */ T(xd, {}), size: "lg" }),
        /* @__PURE__ */ T(qt, { colorMode: r, fullWidth: !0, textAlign: "center", children: l("captions.connectingWallet", {
          name: c.name
        }) })
      ] }) : /* @__PURE__ */ T(Dt, { ...d, align: s ? "start" : "center", children: [
        /* @__PURE__ */ T(qt, { colorMode: r, textAlign: s ? "left" : "center", children: l("captions.chooseConnectionMethod") }),
        /* @__PURE__ */ T(
          Vi,
          {
            align: "center",
            direction: s ? "horizontal" : "vertical",
            fullWidth: !0,
            justify: "center",
            spacing: "sm",
            children: a.map(({ connectorID: f, ...A }, b) => /* @__PURE__ */ T(
              kv,
              {
                colorMode: r,
                connection: A,
                onClick: w(f, A)
              },
              `${A.id}-${b}`
            ))
          }
        )
      ] }),
      footer: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "center", padding: Xt, spacing: "xs", children: /* @__PURE__ */ T(un, { colorMode: r, fullWidth: !0, onClick: e, variant: "secondary", children: l("buttons.cancel") }) }),
      header: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, padding: Xt, spacing: "xs", children: [
        /* @__PURE__ */ T(fn, { colorMode: r, textAlign: "left", children: l("headings.connectAnAccount") }),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T(Yr, { colorMode: r, icon: /* @__PURE__ */ T(Fi, {}), onClick: e })
      ] }),
      onClose: e,
      open: t
    }
  );
};
Ad.displayName = "ConnectAccountModal";
const Mv = "_divider_1ypw5_66", Rv = {
  divider: Mv
}, Iv = ({ colorMode: r }) => /* @__PURE__ */ T("div", { className: Ke(Rv.divider), "data-color-mode": r }), Tv = "_container_16yzz_90", Ov = "_content_16yzz_106", $0 = {
  container: Tv,
  content: Ov
}, Gu = ({
  colorMode: r,
  item: e,
  subtitle: t,
  title: n
}) => {
  const a = Tn(r), o = ji(r);
  return /* @__PURE__ */ T("div", { className: Ke($0.container), "data-color-mode": r, children: /* @__PURE__ */ T($t, { align: "center", className: Ke($0.content), fullWidth: !0, spacing: "xs", children: [
    /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "evenly", spacing: "xs", children: [
      /* @__PURE__ */ T(fn, { color: a, colorMode: r, fullWidth: !0, size: "xs", textAlign: "left", children: n }),
      t && /* @__PURE__ */ T(qt, { color: o, colorMode: r, fullWidth: !0, size: "xs", textAlign: "left", children: t })
    ] }),
    /* @__PURE__ */ T(Vi, { align: "center", maxWidth: "25%", justify: "center", children: e })
  ] }) });
}, Pv = "_icon_rjlp0_63", Nv = {
  icon: Pv
}, j0 = ({
  children: r,
  color: e,
  colorMode: t,
  icon: n
}) => {
  const a = Tn(t);
  return /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, spacing: "xs", children: [
    n && go(n, {
      ...n.props,
      className: Ke(Nv.icon),
      color: e ?? a
    }),
    /* @__PURE__ */ T(fn, { color: e ?? a, colorMode: t, fullWidth: !0, size: "sm", textAlign: "left", children: r })
  ] });
}, Bv = "_container_szrla_66", Lv = "_container--checked_szrla_80", Uv = "_container--xs_szrla_87", Vv = "_container--sm_szrla_93", $v = "_container--lg_szrla_99", jv = "_container--xl_szrla_105", Fv = "_input_szrla_112", zv = "_label_szrla_116", Hv = "_label--disabled_szrla_121", qv = "_knob_szrla_126", Wv = "_knob__checked--xs_szrla_142", Kv = "_knob__checked--sm_szrla_145", Yv = "_knob__checked--md_szrla_148", Gv = "_knob__checked--lg_szrla_151", Jv = "_knob__checked--xl_szrla_154", Xv = "_knob--xs_szrla_157", Zv = "_knob--sm_szrla_161", Qv = "_knob--lg_szrla_165", e_ = "_knob--xl_szrla_169", ir = {
  container: Bv,
  containerChecked: Lv,
  containerXs: Uv,
  containerSm: Vv,
  containerLg: $v,
  containerXl: jv,
  input: Fv,
  label: zv,
  labelDisabled: Hv,
  knob: qv,
  knobCheckedXs: Wv,
  knobCheckedSm: Kv,
  knobCheckedMd: Yv,
  knobCheckedLg: Gv,
  knobCheckedXl: Jv,
  knobXs: Xv,
  knobSm: Zv,
  knobLg: Qv,
  knobXl: e_
}, t_ = ({ checked: r, colorMode: e, disabled: t = !1, onChange: n, size: a = "md" }) => {
  const o = Ut(() => pm(8), []), [i, s, l] = Ut(() => {
    switch (a) {
      case "xs":
        return [ir.containerXs, ir.knobXs, ir.knobCheckedXs];
      case "sm":
        return [ir.containerSm, ir.knobSm, ir.knobCheckedSm];
      case "lg":
        return [ir.containerLg, ir.knobLg, ir.knobCheckedLg];
      case "xl":
        return [ir.containerXl, ir.knobXl, ir.knobCheckedXl];
      case "md":
      default:
        return [ir.containerMd, ir.knobMd, ir.knobCheckedMd];
    }
  }, [a]), c = ht((u) => {
    t || n(u);
  }, [r]);
  return /* @__PURE__ */ T(
    "label",
    {
      className: Ke(ir.label, t && ir.labelDisabled),
      htmlFor: o,
      children: [
        /* @__PURE__ */ T(
          "input",
          {
            checked: r,
            className: Ke(ir.input),
            disabled: t,
            id: o,
            onChange: c,
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ T(
          "span",
          {
            className: Ke(ir.container, i, r && ir.containerChecked),
            "data-color-mode": e,
            children: /* @__PURE__ */ T(
              "span",
              {
                className: Ke(ir.knob, s, r && l),
                "data-color-mode": e
              }
            )
          }
        )
      ]
    }
  );
};
function r_() {
  const r = Br(_d);
  return ({ message: e, onClose: t, onConfirm: n, title: a }) => {
    if (!r)
      return;
    const { setMessage: o, setOnClose: i, setOnConfirm: s, setOpen: l, setTitle: c } = r;
    o(e), i(t ?? null), s(n ?? null), c(a), l(!0);
  };
}
function n_() {
  const r = Br(Sd), e = Br(pc);
  return () => {
    (async () => {
      if (!r || !e)
        return;
      const { colorMode: t } = await r.settings();
      await r.setSettings({
        colorMode: t === "light" ? "dark" : "light"
      }), window.dispatchEvent(new b7(e));
    })();
  };
}
const a_ = ({
  color: r,
  ...e
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ T("circle", { cx: "12", cy: "12", r: "10" }),
      /* @__PURE__ */ T("path", { d: "M12 16v-4" }),
      /* @__PURE__ */ T("path", { d: "M12 8h.01" })
    ]
  }
), o_ = ({
  color: r,
  ...e
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ T("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
      /* @__PURE__ */ T("polyline", { points: "16 17 21 12 16 7" }),
      /* @__PURE__ */ T("line", { x1: "21", x2: "9", y1: "12", y2: "12" })
    ]
  }
), i_ = ({
  color: r,
  ...e
}) => /* @__PURE__ */ T(
  "svg",
  {
    fill: "none",
    stroke: r || "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ T("circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor" }),
      /* @__PURE__ */ T("circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor" }),
      /* @__PURE__ */ T("circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor" }),
      /* @__PURE__ */ T("circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor" }),
      /* @__PURE__ */ T("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" })
    ]
  }
), s_ = ({
  closeOnEscape: r = !0,
  closeOnInteractOutside: e = !0,
  colorMode: t,
  onClose: n,
  onLogout: a,
  open: o
}) => {
  const i = r_(), s = Tn(t), l = n_(), c = On(), u = Ut(() => 380, []), d = ht(() => i({
    message: c("captions.confirmLogout"),
    onConfirm: a,
    title: c("headings.confirmLogout")
  }), [i, c]), w = ht(() => l(), [l]);
  return /* @__PURE__ */ T(
    $i,
    {
      closeOnEscape: r,
      closeOnInteractOutside: e,
      colorMode: t,
      body: /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, grow: !0, paddingBottom: Xt, paddingX: Xt, spacing: "md", children: [
        /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, maxWidth: u, spacing: "sm", children: [
          /* @__PURE__ */ T(j0, { colorMode: t, icon: /* @__PURE__ */ T(i_, {}), children: c("headings.appearance") }),
          /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, spacing: "xs", children: /* @__PURE__ */ T(
            Gu,
            {
              colorMode: t,
              item: /* @__PURE__ */ T(t_, { colorMode: t, checked: t === "dark", onChange: w }),
              title: c("labels.darkMode")
            }
          ) })
        ] }),
        /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, maxWidth: u, spacing: "sm", children: [
          /* @__PURE__ */ T(j0, { colorMode: t, icon: /* @__PURE__ */ T(a_, {}), children: c("headings.about") }),
          /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, spacing: "xs", children: /* @__PURE__ */ T(
            Gu,
            {
              colorMode: t,
              item: /* @__PURE__ */ T(qt, { color: s, colorMode: t, fullWidth: !0, size: "sm", textAlign: "right", children: "1.6.0" }),
              title: c("labels.version")
            }
          ) })
        ] }),
        /* @__PURE__ */ T(Vi, { align: "center", fullWidth: !0, maxWidth: u, children: /* @__PURE__ */ T(Iv, { colorMode: t }) }),
        /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, maxWidth: u, spacing: "sm", children: /* @__PURE__ */ T(
          Gu,
          {
            colorMode: t,
            item: /* @__PURE__ */ T(Yr, { colorMode: t, icon: /* @__PURE__ */ T(o_, {}), onClick: d, title: c("buttons.logout") }),
            title: c("labels.logout")
          }
        ) })
      ] }),
      footer: /* @__PURE__ */ T(r5, { colorMode: t }),
      header: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, padding: Xt, spacing: "xs", children: [
        /* @__PURE__ */ T(fn, { colorMode: t, textAlign: "left", children: c("headings.settings") }),
        /* @__PURE__ */ T(hn, {}),
        /* @__PURE__ */ T(Yr, { colorMode: t, icon: /* @__PURE__ */ T(Fi, {}), onClick: n })
      ] }),
      onClose: n,
      open: o
    }
  );
}, c_ = ({
  colorMode: r,
  onClose: e,
  open: t
}) => {
  const n = kd(), a = On(), [o, i] = dt(null), [s, l] = dt(null), [c, u] = dt(!1), d = Ut(() => ({
    fullWidth: !0,
    minHeight: 250,
    grow: !0,
    paddingBottom: Xt,
    paddingX: Xt,
    spacing: "md"
  }), []), w = ht(() => () => {
    console.log("start transfer");
  }, []);
  return /* @__PURE__ */ T(
    $i,
    {
      closeOnEscape: !c,
      closeOnInteractOutside: !c,
      colorMode: r,
      body: c ? /* @__PURE__ */ T(Dt, { ...d, align: "center", children: [
        /* @__PURE__ */ T(wd, { colorMode: r, icon: /* @__PURE__ */ T(I1, {}), size: "lg" }),
        /* @__PURE__ */ T(qt, { colorMode: r, fullWidth: !0, textAlign: "center", children: a("captions.transferringFunds", {
          amount: "",
          sender: "",
          recipient: ""
        }) })
      ] }) : /* @__PURE__ */ T(Dt, { ...d, align: n ? "start" : "center", children: /* @__PURE__ */ T(qt, { colorMode: r, textAlign: n ? "left" : "center", children: a("captions.chooseConnectionMethod") }) }),
      footer: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, justify: "center", padding: Xt, spacing: "xs", children: [
        /* @__PURE__ */ T(un, { colorMode: r, fullWidth: !0, onClick: e, variant: "secondary", children: a("buttons.cancel") }),
        /* @__PURE__ */ T(
          un,
          {
            colorMode: r,
            fullWidth: !0,
            onClick: w,
            rightIcon: /* @__PURE__ */ T(I1, {}),
            children: a("buttons.transfer")
          }
        )
      ] }),
      header: /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, padding: Xt, spacing: "xs", children: [
        /* @__PURE__ */ T(fn, { colorMode: r, textAlign: "left", children: a("headings.transferFunds") }),
        /* @__PURE__ */ T(hn, {}),
        !c && /* @__PURE__ */ T(Yr, { colorMode: r, icon: /* @__PURE__ */ T(Fi, {}), onClick: e })
      ] }),
      onClose: e,
      open: t
    }
  );
}, l_ = "_container_1v743_81", u_ = "_modal_1v743_98", d_ = "_modal--close_1v743_119", h_ = "_overlay_1v743_128", Tc = {
  container: l_,
  modal: u_,
  modalClose: d_,
  overlay: h_
}, f_ = ({ onClose: r, onLogout: e, vault: t }) => {
  const n = Br(_d), a = gv(), o = mv(), i = yv(), s = On(), [l, c] = dt(!1), [u, d] = dt(!1), [w, f] = dt(!1), [A, b] = dt(!1), g = Ut(
    () => a.filter((M) => M.__type === Er.Connected),
    [a]
  ), k = Ut(
    () => a.filter((M) => M.__type === Er.Ephemeral),
    [a]
  ), v = Ut(() => Ra(t), [t]), C = ht(() => {
    c(!0), setTimeout(() => r(), 300);
  }, [l, r, c]), W = ht(() => {
    if (!n)
      return;
    const { onClose: M, reset: j } = n;
    M == null || M(), j();
  }, [n]), Z = ht(() => {
    if (!n)
      return;
    const { onConfirm: M, reset: j } = n;
    M == null || M(), j();
  }, [n]), D = ht(() => d(!0), [d]), H = ht(() => d(!1), [d]), y = ht(() => f(!0), [f]), S = ht(() => f(!1), [f]), _ = ht(() => b(!0), [b]), F = ht(() => b(!1), [b]);
  return /* @__PURE__ */ T(ln, { children: [
    /* @__PURE__ */ T(
      Ad,
      {
        colorMode: i,
        onClose: H,
        open: u
      }
    ),
    /* @__PURE__ */ T(
      c_,
      {
        colorMode: i,
        onClose: F,
        open: A
      }
    ),
    /* @__PURE__ */ T(
      s_,
      {
        colorMode: i,
        onClose: S,
        onLogout: e,
        open: w
      }
    ),
    /* @__PURE__ */ T(
      vv,
      {
        colorMode: i,
        message: (n == null ? void 0 : n.message) ?? "",
        onClose: W,
        onConfirm: Z,
        open: (n == null ? void 0 : n.open) ?? !1,
        title: (n == null ? void 0 : n.title) ?? ""
      }
    ),
    /* @__PURE__ */ T("div", { className: Ke(Tc.container), children: [
      /* @__PURE__ */ T("div", { className: Ke(Tc.overlay), onClick: C }),
      /* @__PURE__ */ T("div", { className: Ke(Tc.modal, l && Tc.modalClose), "data-color-mode": i, children: [
        /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, paddingX: Xt, paddingTop: Xt, spacing: "xs", children: [
          /* @__PURE__ */ T(Dt, { fullHeight: !0, justify: "evenly", spacing: "xs", children: /* @__PURE__ */ T(qt, { bold: !0, colorMode: i, textAlign: "left", children: v }) }),
          /* @__PURE__ */ T(hn, {}),
          /* @__PURE__ */ T($t, { align: "center", justify: "end", spacing: "xs", children: [
            /* @__PURE__ */ T(
              Yr,
              {
                colorMode: i,
                icon: /* @__PURE__ */ T(wv, {}),
                onClick: y
              }
            ),
            /* @__PURE__ */ T(Yr, { colorMode: i, icon: /* @__PURE__ */ T(Fi, {}), onClick: C })
          ] })
        ] }),
        /* @__PURE__ */ T(Dt, { align: "center", fullWidth: !0, justify: "center", paddingX: Xt, paddingTop: Xt, spacing: "xs", children: /* @__PURE__ */ T(
          un,
          {
            colorMode: i,
            fullWidth: !0,
            onClick: _,
            rightIcon: /* @__PURE__ */ T(I1, {}),
            size: "sm",
            variant: "secondary",
            children: s("buttons.transferFunds")
          }
        ) }),
        /* @__PURE__ */ T(Dt, { fullWidth: !0, grow: !0, padding: Xt, spacing: "md", children: [
          /* @__PURE__ */ T(Dt, { fullWidth: !0, justify: "center", spacing: "sm", children: [
            /* @__PURE__ */ T(fn, { colorMode: i, size: "sm", textAlign: "left", children: s("headings.holdingAccounts") }),
            /* @__PURE__ */ T(Dt, { fullWidth: !0, spacing: "xs", children: k.map((M) => /* @__PURE__ */ T(
              U0,
              {
                account: M,
                chains: o,
                colorMode: i
              },
              M.key
            )) })
          ] }),
          /* @__PURE__ */ T(Dt, { fullWidth: !0, justify: "center", spacing: "sm", children: [
            /* @__PURE__ */ T($t, { align: "center", fullWidth: !0, spacing: "xs", children: [
              /* @__PURE__ */ T(fn, { colorMode: i, size: "sm", textAlign: "left", children: s("headings.connectedAccounts") }),
              /* @__PURE__ */ T(hn, {}),
              g.length > 0 && /* @__PURE__ */ T(
                Yr,
                {
                  colorMode: i,
                  icon: /* @__PURE__ */ T(V0, {}),
                  onClick: D,
                  size: "xs",
                  title: s("captions.connectAnAccount")
                }
              )
            ] }),
            /* @__PURE__ */ T(Dt, { fullWidth: !0, spacing: "xs", children: g.length > 0 ? g.map((M) => /* @__PURE__ */ T(
              U0,
              {
                account: M,
                chains: o,
                colorMode: i
              },
              M.key
            )) : /* @__PURE__ */ T(
              pv,
              {
                colorMode: i,
                icon: /* @__PURE__ */ T(V0, {}),
                onClick: D,
                text: s("captions.connectAnAccount")
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
}, p_ = ({ accountsStore: r, children: e }) => {
  const [t, n] = dt(r);
  return kr(() => {
    n(r);
  }, [r]), /* @__PURE__ */ T(vd.Provider, { value: t, children: e });
}, g_ = ({ chains: r, children: e }) => {
  const [t, n] = dt(0), [a, o] = dt(r), i = ht(() => n(Date.now()), [n]);
  return kr(() => {
    o(r), i();
  }, [r]), /* @__PURE__ */ T(
    t5.Provider,
    {
      value: {
        onUpdate: i,
        state: a,
        timestamp: t
      },
      children: e
    }
  );
}, m_ = ({ children: r }) => {
  const [e, t] = dt(""), [n, a] = dt(null), [o, i] = dt(null), [s, l] = dt(!1), [c, u] = dt(""), d = ht(() => {
    t(""), a(null), i(null), l(!1), u("");
  }, [t, a, i, l, u]);
  return /* @__PURE__ */ T(
    _d.Provider,
    {
      value: {
        message: e,
        open: s,
        reset: d,
        setMessage: t,
        setOnClose: a,
        setOnConfirm: i,
        setOpen: l,
        setTitle: u,
        title: c,
        ...n && { onClose: n },
        ...o && { onConfirm: o }
      },
      children: r
    }
  );
};
class y_ {
  constructor({ debug: e = !1, supportedChains: t }) {
    this._debug = e, this._logger = O3(e ? "debug" : "error"), this._supportedChains = t;
  }
  /**
   * public methods
   */
  /**
   * Retrieves the hostname of the connector i.e., example.com.
   *
   * @return {string | null} The host as a string if defined, otherwise null.
   * @public
   */
  host() {
    return this.constructor.host;
  }
  /**
   * Retrieves the unique identifier for the current connector.
   *
   * @return {ConnectorIDEnum} The unique identifier of the connector.
   * @public
   */
  id() {
    return this.constructor.id;
  }
  /**
   * Retrieves the human-readable canonical name of the connector.
   *
   * @return {string} The human-readable canonical name.
   * @public
   */
  name() {
    return this.constructor.canonicalName;
  }
}
var Bo = {}, Lo = {}, Oc = {}, F0;
function w_() {
  return F0 || (F0 = 1, Object.defineProperty(Oc, "__esModule", { value: !0 }), Oc.ARC0027_PREFIX = void 0, Oc.ARC0027_PREFIX = "arc0027"), Oc;
}
var Pc = {}, z0;
function v_() {
  return z0 || (z0 = 1, Object.defineProperty(Pc, "__esModule", { value: !0 }), Pc.CHANNEL_NAME_SUFFIX = void 0, Pc.CHANNEL_NAME_SUFFIX = "channel"), Pc;
}
var ga = {}, H0;
function __() {
  return H0 || (H0 = 1, Object.defineProperty(ga, "__esModule", { value: !0 }), ga.UPPER_REQUEST_TIMEOUT = ga.LOWER_REQUEST_TIMEOUT = ga.DEFAULT_REQUEST_TIMEOUT = void 0, ga.DEFAULT_REQUEST_TIMEOUT = 18e4, ga.LOWER_REQUEST_TIMEOUT = 750, ga.UPPER_REQUEST_TIMEOUT = 3e5), ga;
}
var q0;
function Cd() {
  return q0 || (q0 = 1, function(r) {
    var e = Lo && Lo.__createBinding || (Object.create ? function(n, a, o, i) {
      i === void 0 && (i = o);
      var s = Object.getOwnPropertyDescriptor(a, o);
      (!s || ("get" in s ? !a.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return a[o];
      } }), Object.defineProperty(n, i, s);
    } : function(n, a, o, i) {
      i === void 0 && (i = o), n[i] = a[o];
    }), t = Lo && Lo.__exportStar || function(n, a) {
      for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && e(a, n, o);
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), t(w_(), r), t(v_(), r), t(__(), r);
  }(Lo)), Lo;
}
var Nc = {}, Bn = {}, W0 = {}, es = {}, Bc = {}, K0;
function f5() {
  if (K0) return Bc;
  K0 = 1, Object.defineProperty(Bc, "__esModule", {
    value: !0
  }), Bc.default = t;
  let r;
  const e = new Uint8Array(16);
  function t() {
    if (!r && (r = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !r))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return r(e);
  }
  return Bc;
}
var Uo = {}, ts = {}, rs = {}, Y0;
function b_() {
  if (Y0) return rs;
  Y0 = 1, Object.defineProperty(rs, "__esModule", {
    value: !0
  }), rs.default = void 0;
  var r = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return rs.default = r, rs;
}
var G0;
function hu() {
  if (G0) return ts;
  G0 = 1, Object.defineProperty(ts, "__esModule", {
    value: !0
  }), ts.default = void 0;
  var r = e(/* @__PURE__ */ b_());
  function e(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function t(a) {
    return typeof a == "string" && r.default.test(a);
  }
  var n = t;
  return ts.default = n, ts;
}
var J0;
function fu() {
  if (J0) return Uo;
  J0 = 1, Object.defineProperty(Uo, "__esModule", {
    value: !0
  }), Uo.default = void 0, Uo.unsafeStringify = n;
  var r = e(/* @__PURE__ */ hu());
  function e(i) {
    return i && i.__esModule ? i : { default: i };
  }
  const t = [];
  for (let i = 0; i < 256; ++i)
    t.push((i + 256).toString(16).slice(1));
  function n(i, s = 0) {
    return t[i[s + 0]] + t[i[s + 1]] + t[i[s + 2]] + t[i[s + 3]] + "-" + t[i[s + 4]] + t[i[s + 5]] + "-" + t[i[s + 6]] + t[i[s + 7]] + "-" + t[i[s + 8]] + t[i[s + 9]] + "-" + t[i[s + 10]] + t[i[s + 11]] + t[i[s + 12]] + t[i[s + 13]] + t[i[s + 14]] + t[i[s + 15]];
  }
  function a(i, s = 0) {
    const l = n(i, s);
    if (!(0, r.default)(l))
      throw TypeError("Stringified UUID is invalid");
    return l;
  }
  var o = a;
  return Uo.default = o, Uo;
}
var X0;
function S_() {
  if (X0) return es;
  X0 = 1, Object.defineProperty(es, "__esModule", {
    value: !0
  }), es.default = void 0;
  var r = t(/* @__PURE__ */ f5()), e = /* @__PURE__ */ fu();
  function t(c) {
    return c && c.__esModule ? c : { default: c };
  }
  let n, a, o = 0, i = 0;
  function s(c, u, d) {
    let w = u && d || 0;
    const f = u || new Array(16);
    c = c || {};
    let A = c.node || n, b = c.clockseq !== void 0 ? c.clockseq : a;
    if (A == null || b == null) {
      const Z = c.random || (c.rng || r.default)();
      A == null && (A = n = [Z[0] | 1, Z[1], Z[2], Z[3], Z[4], Z[5]]), b == null && (b = a = (Z[6] << 8 | Z[7]) & 16383);
    }
    let g = c.msecs !== void 0 ? c.msecs : Date.now(), k = c.nsecs !== void 0 ? c.nsecs : i + 1;
    const v = g - o + (k - i) / 1e4;
    if (v < 0 && c.clockseq === void 0 && (b = b + 1 & 16383), (v < 0 || g > o) && c.nsecs === void 0 && (k = 0), k >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    o = g, i = k, a = b, g += 122192928e5;
    const C = ((g & 268435455) * 1e4 + k) % 4294967296;
    f[w++] = C >>> 24 & 255, f[w++] = C >>> 16 & 255, f[w++] = C >>> 8 & 255, f[w++] = C & 255;
    const W = g / 4294967296 * 1e4 & 268435455;
    f[w++] = W >>> 8 & 255, f[w++] = W & 255, f[w++] = W >>> 24 & 15 | 16, f[w++] = W >>> 16 & 255, f[w++] = b >>> 8 | 128, f[w++] = b & 255;
    for (let Z = 0; Z < 6; ++Z)
      f[w + Z] = A[Z];
    return u || (0, e.unsafeStringify)(f);
  }
  var l = s;
  return es.default = l, es;
}
var ns = {}, ma = {}, as = {}, Z0;
function p5() {
  if (Z0) return as;
  Z0 = 1, Object.defineProperty(as, "__esModule", {
    value: !0
  }), as.default = void 0;
  var r = e(/* @__PURE__ */ hu());
  function e(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function t(a) {
    if (!(0, r.default)(a))
      throw TypeError("Invalid UUID");
    let o;
    const i = new Uint8Array(16);
    return i[0] = (o = parseInt(a.slice(0, 8), 16)) >>> 24, i[1] = o >>> 16 & 255, i[2] = o >>> 8 & 255, i[3] = o & 255, i[4] = (o = parseInt(a.slice(9, 13), 16)) >>> 8, i[5] = o & 255, i[6] = (o = parseInt(a.slice(14, 18), 16)) >>> 8, i[7] = o & 255, i[8] = (o = parseInt(a.slice(19, 23), 16)) >>> 8, i[9] = o & 255, i[10] = (o = parseInt(a.slice(24, 36), 16)) / 1099511627776 & 255, i[11] = o / 4294967296 & 255, i[12] = o >>> 24 & 255, i[13] = o >>> 16 & 255, i[14] = o >>> 8 & 255, i[15] = o & 255, i;
  }
  var n = t;
  return as.default = n, as;
}
var Q0;
function g5() {
  if (Q0) return ma;
  Q0 = 1, Object.defineProperty(ma, "__esModule", {
    value: !0
  }), ma.URL = ma.DNS = void 0, ma.default = i;
  var r = /* @__PURE__ */ fu(), e = t(/* @__PURE__ */ p5());
  function t(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function n(s) {
    s = unescape(encodeURIComponent(s));
    const l = [];
    for (let c = 0; c < s.length; ++c)
      l.push(s.charCodeAt(c));
    return l;
  }
  const a = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  ma.DNS = a;
  const o = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  ma.URL = o;
  function i(s, l, c) {
    function u(d, w, f, A) {
      var b;
      if (typeof d == "string" && (d = n(d)), typeof w == "string" && (w = (0, e.default)(w)), ((b = w) === null || b === void 0 ? void 0 : b.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let g = new Uint8Array(16 + d.length);
      if (g.set(w), g.set(d, w.length), g = c(g), g[6] = g[6] & 15 | l, g[8] = g[8] & 63 | 128, f) {
        A = A || 0;
        for (let k = 0; k < 16; ++k)
          f[A + k] = g[k];
        return f;
      }
      return (0, r.unsafeStringify)(g);
    }
    try {
      u.name = s;
    } catch {
    }
    return u.DNS = a, u.URL = o, u;
  }
  return ma;
}
var os = {}, ef;
function E_() {
  if (ef) return os;
  ef = 1, Object.defineProperty(os, "__esModule", {
    value: !0
  }), os.default = void 0;
  function r(f) {
    if (typeof f == "string") {
      const A = unescape(encodeURIComponent(f));
      f = new Uint8Array(A.length);
      for (let b = 0; b < A.length; ++b)
        f[b] = A.charCodeAt(b);
    }
    return e(n(a(f), f.length * 8));
  }
  function e(f) {
    const A = [], b = f.length * 32, g = "0123456789abcdef";
    for (let k = 0; k < b; k += 8) {
      const v = f[k >> 5] >>> k % 32 & 255, C = parseInt(g.charAt(v >>> 4 & 15) + g.charAt(v & 15), 16);
      A.push(C);
    }
    return A;
  }
  function t(f) {
    return (f + 64 >>> 9 << 4) + 14 + 1;
  }
  function n(f, A) {
    f[A >> 5] |= 128 << A % 32, f[t(A) - 1] = A;
    let b = 1732584193, g = -271733879, k = -1732584194, v = 271733878;
    for (let C = 0; C < f.length; C += 16) {
      const W = b, Z = g, D = k, H = v;
      b = l(b, g, k, v, f[C], 7, -680876936), v = l(v, b, g, k, f[C + 1], 12, -389564586), k = l(k, v, b, g, f[C + 2], 17, 606105819), g = l(g, k, v, b, f[C + 3], 22, -1044525330), b = l(b, g, k, v, f[C + 4], 7, -176418897), v = l(v, b, g, k, f[C + 5], 12, 1200080426), k = l(k, v, b, g, f[C + 6], 17, -1473231341), g = l(g, k, v, b, f[C + 7], 22, -45705983), b = l(b, g, k, v, f[C + 8], 7, 1770035416), v = l(v, b, g, k, f[C + 9], 12, -1958414417), k = l(k, v, b, g, f[C + 10], 17, -42063), g = l(g, k, v, b, f[C + 11], 22, -1990404162), b = l(b, g, k, v, f[C + 12], 7, 1804603682), v = l(v, b, g, k, f[C + 13], 12, -40341101), k = l(k, v, b, g, f[C + 14], 17, -1502002290), g = l(g, k, v, b, f[C + 15], 22, 1236535329), b = c(b, g, k, v, f[C + 1], 5, -165796510), v = c(v, b, g, k, f[C + 6], 9, -1069501632), k = c(k, v, b, g, f[C + 11], 14, 643717713), g = c(g, k, v, b, f[C], 20, -373897302), b = c(b, g, k, v, f[C + 5], 5, -701558691), v = c(v, b, g, k, f[C + 10], 9, 38016083), k = c(k, v, b, g, f[C + 15], 14, -660478335), g = c(g, k, v, b, f[C + 4], 20, -405537848), b = c(b, g, k, v, f[C + 9], 5, 568446438), v = c(v, b, g, k, f[C + 14], 9, -1019803690), k = c(k, v, b, g, f[C + 3], 14, -187363961), g = c(g, k, v, b, f[C + 8], 20, 1163531501), b = c(b, g, k, v, f[C + 13], 5, -1444681467), v = c(v, b, g, k, f[C + 2], 9, -51403784), k = c(k, v, b, g, f[C + 7], 14, 1735328473), g = c(g, k, v, b, f[C + 12], 20, -1926607734), b = u(b, g, k, v, f[C + 5], 4, -378558), v = u(v, b, g, k, f[C + 8], 11, -2022574463), k = u(k, v, b, g, f[C + 11], 16, 1839030562), g = u(g, k, v, b, f[C + 14], 23, -35309556), b = u(b, g, k, v, f[C + 1], 4, -1530992060), v = u(v, b, g, k, f[C + 4], 11, 1272893353), k = u(k, v, b, g, f[C + 7], 16, -155497632), g = u(g, k, v, b, f[C + 10], 23, -1094730640), b = u(b, g, k, v, f[C + 13], 4, 681279174), v = u(v, b, g, k, f[C], 11, -358537222), k = u(k, v, b, g, f[C + 3], 16, -722521979), g = u(g, k, v, b, f[C + 6], 23, 76029189), b = u(b, g, k, v, f[C + 9], 4, -640364487), v = u(v, b, g, k, f[C + 12], 11, -421815835), k = u(k, v, b, g, f[C + 15], 16, 530742520), g = u(g, k, v, b, f[C + 2], 23, -995338651), b = d(b, g, k, v, f[C], 6, -198630844), v = d(v, b, g, k, f[C + 7], 10, 1126891415), k = d(k, v, b, g, f[C + 14], 15, -1416354905), g = d(g, k, v, b, f[C + 5], 21, -57434055), b = d(b, g, k, v, f[C + 12], 6, 1700485571), v = d(v, b, g, k, f[C + 3], 10, -1894986606), k = d(k, v, b, g, f[C + 10], 15, -1051523), g = d(g, k, v, b, f[C + 1], 21, -2054922799), b = d(b, g, k, v, f[C + 8], 6, 1873313359), v = d(v, b, g, k, f[C + 15], 10, -30611744), k = d(k, v, b, g, f[C + 6], 15, -1560198380), g = d(g, k, v, b, f[C + 13], 21, 1309151649), b = d(b, g, k, v, f[C + 4], 6, -145523070), v = d(v, b, g, k, f[C + 11], 10, -1120210379), k = d(k, v, b, g, f[C + 2], 15, 718787259), g = d(g, k, v, b, f[C + 9], 21, -343485551), b = o(b, W), g = o(g, Z), k = o(k, D), v = o(v, H);
    }
    return [b, g, k, v];
  }
  function a(f) {
    if (f.length === 0)
      return [];
    const A = f.length * 8, b = new Uint32Array(t(A));
    for (let g = 0; g < A; g += 8)
      b[g >> 5] |= (f[g / 8] & 255) << g % 32;
    return b;
  }
  function o(f, A) {
    const b = (f & 65535) + (A & 65535);
    return (f >> 16) + (A >> 16) + (b >> 16) << 16 | b & 65535;
  }
  function i(f, A) {
    return f << A | f >>> 32 - A;
  }
  function s(f, A, b, g, k, v) {
    return o(i(o(o(A, f), o(g, v)), k), b);
  }
  function l(f, A, b, g, k, v, C) {
    return s(A & b | ~A & g, f, A, k, v, C);
  }
  function c(f, A, b, g, k, v, C) {
    return s(A & g | b & ~g, f, A, k, v, C);
  }
  function u(f, A, b, g, k, v, C) {
    return s(A ^ b ^ g, f, A, k, v, C);
  }
  function d(f, A, b, g, k, v, C) {
    return s(b ^ (A | ~g), f, A, k, v, C);
  }
  var w = r;
  return os.default = w, os;
}
var tf;
function x_() {
  if (tf) return ns;
  tf = 1, Object.defineProperty(ns, "__esModule", {
    value: !0
  }), ns.default = void 0;
  var r = t(/* @__PURE__ */ g5()), e = t(/* @__PURE__ */ E_());
  function t(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var n = (0, r.default)("v3", 48, e.default);
  return ns.default = n, ns;
}
var is = {}, ss = {}, rf;
function k_() {
  if (rf) return ss;
  rf = 1, Object.defineProperty(ss, "__esModule", {
    value: !0
  }), ss.default = void 0;
  var r = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return ss.default = r, ss;
}
var nf;
function A_() {
  if (nf) return is;
  nf = 1, Object.defineProperty(is, "__esModule", {
    value: !0
  }), is.default = void 0;
  var r = n(/* @__PURE__ */ k_()), e = n(/* @__PURE__ */ f5()), t = /* @__PURE__ */ fu();
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function a(i, s, l) {
    if (r.default.randomUUID && !s && !i)
      return r.default.randomUUID();
    i = i || {};
    const c = i.random || (i.rng || e.default)();
    if (c[6] = c[6] & 15 | 64, c[8] = c[8] & 63 | 128, s) {
      l = l || 0;
      for (let u = 0; u < 16; ++u)
        s[l + u] = c[u];
      return s;
    }
    return (0, t.unsafeStringify)(c);
  }
  var o = a;
  return is.default = o, is;
}
var cs = {}, ls = {}, af;
function C_() {
  if (af) return ls;
  af = 1, Object.defineProperty(ls, "__esModule", {
    value: !0
  }), ls.default = void 0;
  function r(a, o, i, s) {
    switch (a) {
      case 0:
        return o & i ^ ~o & s;
      case 1:
        return o ^ i ^ s;
      case 2:
        return o & i ^ o & s ^ i & s;
      case 3:
        return o ^ i ^ s;
    }
  }
  function e(a, o) {
    return a << o | a >>> 32 - o;
  }
  function t(a) {
    const o = [1518500249, 1859775393, 2400959708, 3395469782], i = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof a == "string") {
      const u = unescape(encodeURIComponent(a));
      a = [];
      for (let d = 0; d < u.length; ++d)
        a.push(u.charCodeAt(d));
    } else Array.isArray(a) || (a = Array.prototype.slice.call(a));
    a.push(128);
    const s = a.length / 4 + 2, l = Math.ceil(s / 16), c = new Array(l);
    for (let u = 0; u < l; ++u) {
      const d = new Uint32Array(16);
      for (let w = 0; w < 16; ++w)
        d[w] = a[u * 64 + w * 4] << 24 | a[u * 64 + w * 4 + 1] << 16 | a[u * 64 + w * 4 + 2] << 8 | a[u * 64 + w * 4 + 3];
      c[u] = d;
    }
    c[l - 1][14] = (a.length - 1) * 8 / Math.pow(2, 32), c[l - 1][14] = Math.floor(c[l - 1][14]), c[l - 1][15] = (a.length - 1) * 8 & 4294967295;
    for (let u = 0; u < l; ++u) {
      const d = new Uint32Array(80);
      for (let k = 0; k < 16; ++k)
        d[k] = c[u][k];
      for (let k = 16; k < 80; ++k)
        d[k] = e(d[k - 3] ^ d[k - 8] ^ d[k - 14] ^ d[k - 16], 1);
      let w = i[0], f = i[1], A = i[2], b = i[3], g = i[4];
      for (let k = 0; k < 80; ++k) {
        const v = Math.floor(k / 20), C = e(w, 5) + r(v, f, A, b) + g + o[v] + d[k] >>> 0;
        g = b, b = A, A = e(f, 30) >>> 0, f = w, w = C;
      }
      i[0] = i[0] + w >>> 0, i[1] = i[1] + f >>> 0, i[2] = i[2] + A >>> 0, i[3] = i[3] + b >>> 0, i[4] = i[4] + g >>> 0;
    }
    return [i[0] >> 24 & 255, i[0] >> 16 & 255, i[0] >> 8 & 255, i[0] & 255, i[1] >> 24 & 255, i[1] >> 16 & 255, i[1] >> 8 & 255, i[1] & 255, i[2] >> 24 & 255, i[2] >> 16 & 255, i[2] >> 8 & 255, i[2] & 255, i[3] >> 24 & 255, i[3] >> 16 & 255, i[3] >> 8 & 255, i[3] & 255, i[4] >> 24 & 255, i[4] >> 16 & 255, i[4] >> 8 & 255, i[4] & 255];
  }
  var n = t;
  return ls.default = n, ls;
}
var of;
function D_() {
  if (of) return cs;
  of = 1, Object.defineProperty(cs, "__esModule", {
    value: !0
  }), cs.default = void 0;
  var r = t(/* @__PURE__ */ g5()), e = t(/* @__PURE__ */ C_());
  function t(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var n = (0, r.default)("v5", 80, e.default);
  return cs.default = n, cs;
}
var us = {}, sf;
function M_() {
  if (sf) return us;
  sf = 1, Object.defineProperty(us, "__esModule", {
    value: !0
  }), us.default = void 0;
  var r = "00000000-0000-0000-0000-000000000000";
  return us.default = r, us;
}
var ds = {}, cf;
function R_() {
  if (cf) return ds;
  cf = 1, Object.defineProperty(ds, "__esModule", {
    value: !0
  }), ds.default = void 0;
  var r = e(/* @__PURE__ */ hu());
  function e(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function t(a) {
    if (!(0, r.default)(a))
      throw TypeError("Invalid UUID");
    return parseInt(a.slice(14, 15), 16);
  }
  var n = t;
  return ds.default = n, ds;
}
var lf;
function m5() {
  return lf || (lf = 1, function(r) {
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "NIL", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    }), Object.defineProperty(r, "parse", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(r, "stringify", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    }), Object.defineProperty(r, "v1", {
      enumerable: !0,
      get: function() {
        return e.default;
      }
    }), Object.defineProperty(r, "v3", {
      enumerable: !0,
      get: function() {
        return t.default;
      }
    }), Object.defineProperty(r, "v4", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(r, "v5", {
      enumerable: !0,
      get: function() {
        return a.default;
      }
    }), Object.defineProperty(r, "validate", {
      enumerable: !0,
      get: function() {
        return s.default;
      }
    }), Object.defineProperty(r, "version", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    });
    var e = u(/* @__PURE__ */ S_()), t = u(/* @__PURE__ */ x_()), n = u(/* @__PURE__ */ A_()), a = u(/* @__PURE__ */ D_()), o = u(/* @__PURE__ */ M_()), i = u(/* @__PURE__ */ R_()), s = u(/* @__PURE__ */ hu()), l = u(/* @__PURE__ */ fu()), c = u(/* @__PURE__ */ p5());
    function u(d) {
      return d && d.__esModule ? d : { default: d };
    }
  }(W0)), W0;
}
var Vo = {}, $o = {}, uf;
function y5() {
  if (uf) return $o;
  uf = 1;
  var r = $o && $o.__spreadArray || function(t, n, a) {
    if (a || arguments.length === 2) for (var o = 0, i = n.length, s; o < i; o++)
      (s || !(o in n)) && (s || (s = Array.prototype.slice.call(n, 0, o)), s[o] = n[o]);
    return t.concat(s || Array.prototype.slice.call(n));
  };
  Object.defineProperty($o, "__esModule", { value: !0 });
  var e = (
    /** @class */
    function() {
      function t(n) {
        this._level = n;
      }
      return t.prototype.canLog = function(n) {
        switch (this._level) {
          case "error":
            return n === "error";
          case "warn":
            return n === "error" || n === "warn";
          case "info":
            return n === "error" || n === "warn" || n === "info";
          case "debug":
            return !0;
          default:
            return !1;
        }
      }, t.prototype.debug = function(n) {
        for (var a = [], o = 1; o < arguments.length; o++)
          a[o - 1] = arguments[o];
        this.canLog("debug") && console.log.apply(console, r([n], a, !1));
      }, t.prototype.error = function(n) {
        for (var a = [], o = 1; o < arguments.length; o++)
          a[o - 1] = arguments[o];
        this.canLog("error") && console.error.apply(console, r([n], a, !1));
      }, t.prototype.info = function(n) {
        for (var a = [], o = 1; o < arguments.length; o++)
          a[o - 1] = arguments[o];
        this.canLog("info") && console.info.apply(console, r([n], a, !1));
      }, t.prototype.warn = function(n) {
        for (var a = [], o = 1; o < arguments.length; o++)
          a[o - 1] = arguments[o];
        this.canLog("warn") && console.warn.apply(console, r([n], a, !1));
      }, t;
    }()
  );
  return $o.default = e, $o;
}
var df;
function Dd() {
  if (df) return Vo;
  df = 1;
  var r = Vo && Vo.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(Vo, "__esModule", { value: !0 });
  var e = r(y5()), t = (
    /** @class */
    function() {
      function n(a) {
        this._config = a, this._listeners = /* @__PURE__ */ new Map(), this._logger = new e.default(a.debug ? "debug" : "error");
      }
      return n.prototype.getConfig = function() {
        return this._config;
      }, n.prototype.removeAllListeners = function() {
        this._listeners.forEach(function(a) {
          var o = a.listener, i = a.reference;
          return window.removeEventListener(i, o);
        }), this._listeners.clear();
      }, n.prototype.removeListener = function(a) {
        var o = this._listeners.get(a) || null;
        o && (window.removeEventListener(o.reference, o.listener), this._listeners.delete(a));
      }, n;
    }()
  );
  return Vo.default = t, Vo;
}
var Lc = {}, Uc = {}, hf;
function I_() {
  if (hf) return Uc;
  hf = 1, Object.defineProperty(Uc, "__esModule", { value: !0 });
  var r;
  return function(e) {
    e[e.UnknownError = 4e3] = "UnknownError", e[e.MethodCanceledError = 4001] = "MethodCanceledError", e[e.MethodTimedOutError = 4002] = "MethodTimedOutError", e[e.MethodNotSupportedError = 4003] = "MethodNotSupportedError", e[e.NetworkNotSupportedError = 4004] = "NetworkNotSupportedError", e[e.UnauthorizedSignerError = 4100] = "UnauthorizedSignerError", e[e.InvalidInputError = 4200] = "InvalidInputError", e[e.InvalidGroupIdError = 4201] = "InvalidGroupIdError", e[e.FailedToPostSomeTransactionsError = 4300] = "FailedToPostSomeTransactionsError";
  }(r || (r = {})), Uc.default = r, Uc;
}
var Vc = {}, ff;
function T_() {
  if (ff) return Vc;
  ff = 1, Object.defineProperty(Vc, "__esModule", { value: !0 });
  var r;
  return function(e) {
    e.Request = "request", e.Response = "response";
  }(r || (r = {})), Vc.default = r, Vc;
}
var $c = {}, pf;
function O_() {
  if (pf) return $c;
  pf = 1, Object.defineProperty($c, "__esModule", { value: !0 });
  var r;
  return function(e) {
    e.Disable = "disable", e.Discover = "discover", e.Enable = "enable", e.PostTransactions = "post_transactions", e.SignAndPostTransactions = "sign_and_post_transactions", e.SignMessage = "sign_message", e.SignTransactions = "sign_transactions";
  }(r || (r = {})), $c.default = r, $c;
}
var gf;
function yn() {
  return gf || (gf = 1, function(r) {
    var e = Lc && Lc.__importDefault || function(o) {
      return o && o.__esModule ? o : { default: o };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.ARC0027MethodEnum = r.ARC0027MessageTypeEnum = r.ARC0027ErrorCodeEnum = void 0;
    var t = I_();
    Object.defineProperty(r, "ARC0027ErrorCodeEnum", { enumerable: !0, get: function() {
      return e(t).default;
    } });
    var n = T_();
    Object.defineProperty(r, "ARC0027MessageTypeEnum", { enumerable: !0, get: function() {
      return e(n).default;
    } });
    var a = O_();
    Object.defineProperty(r, "ARC0027MethodEnum", { enumerable: !0, get: function() {
      return e(a).default;
    } });
  }(Lc)), Lc;
}
var jc = {}, ya = {}, Fc = {}, mf;
function qn() {
  if (mf) return Fc;
  mf = 1, Object.defineProperty(Fc, "__esModule", { value: !0 });
  var r = (
    /** @class */
    /* @__PURE__ */ function() {
      function e(t) {
        var n = t.message, a = t.providerId;
        this.message = n.toLowerCase(), this.providerId = a;
      }
      return e;
    }()
  );
  return Fc.default = r, Fc;
}
var yf;
function P_() {
  if (yf) return ya;
  yf = 1;
  var r = ya && ya.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = ya && ya.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(ya, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.providerId, u = s.successTxnIDs, d = o.call(this, {
          message: l || "failed to post some transactions",
          providerId: c
        }) || this;
        return d.code = t.ARC0027ErrorCodeEnum.FailedToPostSomeTransactionsError, d.name = "FailedToPostSomeTransactionsError", d.data = {
          successTxnIDs: u
        }, d;
      }
      return i;
    }(n.default)
  );
  return ya.default = a, ya;
}
var wa = {}, wf;
function N_() {
  if (wf) return wa;
  wf = 1;
  var r = wa && wa.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = wa && wa.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(wa, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.providerId, u = o.call(this, {
          message: l || "computed group id does not match the assigned id of one or more transactions",
          providerId: c
        }) || this;
        return u.code = t.ARC0027ErrorCodeEnum.InvalidGroupIdError, u.name = "InvalidGroupIdError", u;
      }
      return i;
    }(n.default)
  );
  return wa.default = a, wa;
}
var va = {}, vf;
function B_() {
  if (vf) return va;
  vf = 1;
  var r = va && va.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = va && va.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(va, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.providerId, u = o.call(this, {
          message: l || "invalid input in transaction(s)",
          providerId: c
        }) || this;
        return u.code = t.ARC0027ErrorCodeEnum.InvalidInputError, u.name = "InvalidInputError", u;
      }
      return i;
    }(n.default)
  );
  return va.default = a, va;
}
var _a = {}, _f;
function L_() {
  if (_f) return _a;
  _f = 1;
  var r = _a && _a.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = _a && _a.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(_a, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.method, u = s.providerId, d = o.call(this, {
          message: l || 'method "'.concat(c, '" canceled for provider "').concat(u, '"'),
          providerId: u
        }) || this;
        return d.code = t.ARC0027ErrorCodeEnum.MethodCanceledError, d.name = "MethodCanceledError", d.data = {
          method: c
        }, d;
      }
      return i;
    }(n.default)
  );
  return _a.default = a, _a;
}
var ba = {}, bf;
function U_() {
  if (bf) return ba;
  bf = 1;
  var r = ba && ba.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = ba && ba.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(ba, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.method, u = s.providerId, d = o.call(this, {
          message: l || 'method "'.concat(c, '" not supported for provider "').concat(u, '"'),
          providerId: u
        }) || this;
        return d.code = t.ARC0027ErrorCodeEnum.MethodNotSupportedError, d.name = "MethodNotSupportedError", d.data = {
          method: c
        }, d;
      }
      return i;
    }(n.default)
  );
  return ba.default = a, ba;
}
var Sa = {}, Sf;
function V_() {
  if (Sf) return Sa;
  Sf = 1;
  var r = Sa && Sa.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = Sa && Sa.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(Sa, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.method, u = s.providerId, d = o.call(this, {
          message: l || 'method "'.concat(c, '" timed out'),
          providerId: u
        }) || this;
        return d.code = t.ARC0027ErrorCodeEnum.MethodTimedOutError, d.name = "MethodTimedOutError", d.data = {
          method: c
        }, d;
      }
      return i;
    }(n.default)
  );
  return Sa.default = a, Sa;
}
var Ea = {}, Ef;
function $_() {
  if (Ef) return Ea;
  Ef = 1;
  var r = Ea && Ea.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = Ea && Ea.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(Ea, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.genesisHashes, c = s.message, u = s.providerId, d = o.call(this, {
          message: c || "provider does not support network with genesis hashes [".concat(l.map(function(w) {
            return '"'.concat(w, '"');
          }).join(","), "]"),
          providerId: u
        }) || this;
        return d.code = t.ARC0027ErrorCodeEnum.NetworkNotSupportedError, d.name = "NetworkNotSupportedError", d.data = {
          genesisHashes: l
        }, d;
      }
      return i;
    }(n.default)
  );
  return Ea.default = a, Ea;
}
var xa = {}, xf;
function j_() {
  if (xf) return xa;
  xf = 1;
  var r = xa && xa.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = xa && xa.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(xa, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i(s) {
        var l = s.message, c = s.providerId, u = s.signer, d = o.call(this, {
          message: l || "unauthorized signer".concat(u ? ' "'.concat(u, '"') : ""),
          providerId: c
        }) || this;
        return d.code = t.ARC0027ErrorCodeEnum.UnauthorizedSignerError, d.name = "UnauthorizedSignerError", d.data = {
          signer: u
        }, d;
      }
      return i;
    }(n.default)
  );
  return xa.default = a, xa;
}
var ka = {}, kf;
function F_() {
  if (kf) return ka;
  kf = 1;
  var r = ka && ka.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, c) {
        l.__proto__ = c;
      } || function(l, c) {
        for (var u in c) Object.prototype.hasOwnProperty.call(c, u) && (l[u] = c[u]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function l() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (l.prototype = s.prototype, new l());
    };
  }(), e = ka && ka.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(ka, "__esModule", { value: !0 });
  var t = yn(), n = e(qn()), a = (
    /** @class */
    function(o) {
      r(i, o);
      function i() {
        var s = o !== null && o.apply(this, arguments) || this;
        return s.code = t.ARC0027ErrorCodeEnum.UnknownError, s.name = "UnknownError", s;
      }
      return i;
    }(n.default)
  );
  return ka.default = a, ka;
}
var Af;
function Md() {
  return Af || (Af = 1, function(r) {
    var e = jc && jc.__importDefault || function(w) {
      return w && w.__esModule ? w : { default: w };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.BaseARC0027Error = r.ARC0027UnknownError = r.ARC0027UnauthorizedSignerError = r.ARC0027NetworkNotSupportedError = r.ARC0027MethodTimedOutError = r.ARC0027MethodNotSupportedError = r.ARC0027MethodCanceledError = r.ARC0027InvalidInputError = r.ARC0027InvalidGroupIdError = r.ARC0027FailedToPostSomeTransactionsError = void 0;
    var t = P_();
    Object.defineProperty(r, "ARC0027FailedToPostSomeTransactionsError", { enumerable: !0, get: function() {
      return e(t).default;
    } });
    var n = N_();
    Object.defineProperty(r, "ARC0027InvalidGroupIdError", { enumerable: !0, get: function() {
      return e(n).default;
    } });
    var a = B_();
    Object.defineProperty(r, "ARC0027InvalidInputError", { enumerable: !0, get: function() {
      return e(a).default;
    } });
    var o = L_();
    Object.defineProperty(r, "ARC0027MethodCanceledError", { enumerable: !0, get: function() {
      return e(o).default;
    } });
    var i = U_();
    Object.defineProperty(r, "ARC0027MethodNotSupportedError", { enumerable: !0, get: function() {
      return e(i).default;
    } });
    var s = V_();
    Object.defineProperty(r, "ARC0027MethodTimedOutError", { enumerable: !0, get: function() {
      return e(s).default;
    } });
    var l = $_();
    Object.defineProperty(r, "ARC0027NetworkNotSupportedError", { enumerable: !0, get: function() {
      return e(l).default;
    } });
    var c = j_();
    Object.defineProperty(r, "ARC0027UnauthorizedSignerError", { enumerable: !0, get: function() {
      return e(c).default;
    } });
    var u = F_();
    Object.defineProperty(r, "ARC0027UnknownError", { enumerable: !0, get: function() {
      return e(u).default;
    } });
    var d = qn();
    Object.defineProperty(r, "BaseARC0027Error", { enumerable: !0, get: function() {
      return e(d).default;
    } });
  }(jc)), jc;
}
var zc = {}, Hc = {}, Cf;
function Rd() {
  if (Cf) return Hc;
  Cf = 1, Object.defineProperty(Hc, "__esModule", { value: !0 });
  var r = (
    /** @class */
    /* @__PURE__ */ function() {
      function e(t) {
        var n = t.id, a = t.reference, o = t.requestId;
        this.id = n, this.reference = a, this.requestId = o;
      }
      return e;
    }()
  );
  return Hc.default = r, Hc;
}
var qc = {}, Df;
function z_() {
  if (Df) return qc;
  Df = 1, Object.defineProperty(qc, "__esModule", { value: !0 });
  var r = (
    /** @class */
    /* @__PURE__ */ function() {
      function e(t) {
        var n = t.id, a = t.params, o = t.reference;
        this.id = n, this.params = a, this.reference = o;
      }
      return e;
    }()
  );
  return qc.default = r, qc;
}
var Aa = {}, Mf;
function H_() {
  if (Mf) return Aa;
  Mf = 1;
  var r = Aa && Aa.__extends || /* @__PURE__ */ function() {
    var a = function(o, i) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, l) {
        s.__proto__ = l;
      } || function(s, l) {
        for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (s[c] = l[c]);
      }, a(o, i);
    };
    return function(o, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      a(o, i);
      function s() {
        this.constructor = o;
      }
      o.prototype = i === null ? Object.create(i) : (s.prototype = i.prototype, new s());
    };
  }(), e = Aa && Aa.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(Aa, "__esModule", { value: !0 });
  var t = e(Rd()), n = (
    /** @class */
    function(a) {
      r(o, a);
      function o(i) {
        var s = i.error, l = i.id, c = i.reference, u = i.requestId, d = a.call(this, { id: l, reference: c, requestId: u }) || this;
        return d.error = s, d;
      }
      return o;
    }(t.default)
  );
  return Aa.default = n, Aa;
}
var Ca = {}, Rf;
function q_() {
  if (Rf) return Ca;
  Rf = 1;
  var r = Ca && Ca.__extends || /* @__PURE__ */ function() {
    var a = function(o, i) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, l) {
        s.__proto__ = l;
      } || function(s, l) {
        for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (s[c] = l[c]);
      }, a(o, i);
    };
    return function(o, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
      a(o, i);
      function s() {
        this.constructor = o;
      }
      o.prototype = i === null ? Object.create(i) : (s.prototype = i.prototype, new s());
    };
  }(), e = Ca && Ca.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(Ca, "__esModule", { value: !0 });
  var t = e(Rd()), n = (
    /** @class */
    function(a) {
      r(o, a);
      function o(i) {
        var s = i.id, l = i.reference, c = i.requestId, u = i.result, d = a.call(this, { id: s, reference: l, requestId: c }) || this;
        return d.result = u, d;
      }
      return o;
    }(t.default)
  );
  return Ca.default = n, Ca;
}
var If;
function Id() {
  return If || (If = 1, function(r) {
    var e = zc && zc.__importDefault || function(i) {
      return i && i.__esModule ? i : { default: i };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.ResponseMessageWithResult = r.ResponseMessageWithError = r.RequestMessage = r.BaseResponseMessage = void 0;
    var t = Rd();
    Object.defineProperty(r, "BaseResponseMessage", { enumerable: !0, get: function() {
      return e(t).default;
    } });
    var n = z_();
    Object.defineProperty(r, "RequestMessage", { enumerable: !0, get: function() {
      return e(n).default;
    } });
    var a = H_();
    Object.defineProperty(r, "ResponseMessageWithError", { enumerable: !0, get: function() {
      return e(a).default;
    } });
    var o = q_();
    Object.defineProperty(r, "ResponseMessageWithResult", { enumerable: !0, get: function() {
      return e(o).default;
    } });
  }(zc)), zc;
}
var Wc = {}, Kc = {}, Tf;
function W_() {
  if (Tf) return Kc;
  Tf = 1, Object.defineProperty(Kc, "__esModule", { value: !0 });
  var r = Cd();
  function e(t, n) {
    return "".concat(r.ARC0027_PREFIX, ":").concat(t, ":").concat(n);
  }
  return Kc.default = e, Kc;
}
var Of;
function Td() {
  return Of || (Of = 1, function(r) {
    var e = Wc && Wc.__importDefault || function(n) {
      return n && n.__esModule ? n : { default: n };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.createMessageReference = void 0;
    var t = W_();
    Object.defineProperty(r, "createMessageReference", { enumerable: !0, get: function() {
      return e(t).default;
    } });
  }(Wc)), Wc;
}
var Pf;
function K_() {
  if (Pf) return Bn;
  Pf = 1;
  var r = Bn && Bn.__extends || /* @__PURE__ */ function() {
    var d = function(w, f) {
      return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, b) {
        A.__proto__ = b;
      } || function(A, b) {
        for (var g in b) Object.prototype.hasOwnProperty.call(b, g) && (A[g] = b[g]);
      }, d(w, f);
    };
    return function(w, f) {
      if (typeof f != "function" && f !== null)
        throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
      d(w, f);
      function A() {
        this.constructor = w;
      }
      w.prototype = f === null ? Object.create(f) : (A.prototype = f.prototype, new A());
    };
  }(), e = Bn && Bn.__assign || function() {
    return e = Object.assign || function(d) {
      for (var w, f = 1, A = arguments.length; f < A; f++) {
        w = arguments[f];
        for (var b in w) Object.prototype.hasOwnProperty.call(w, b) && (d[b] = w[b]);
      }
      return d;
    }, e.apply(this, arguments);
  }, t = Bn && Bn.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(Bn, "__esModule", { value: !0 });
  var n = /* @__PURE__ */ m5(), a = Cd(), o = t(Dd()), i = yn(), s = Md(), l = Id(), c = Td(), u = (
    /** @class */
    function(d) {
      r(w, d);
      function w(f) {
        var A = d.call(this, f) || this;
        return A._requestIds = [], A;
      }
      return w.init = function(f) {
        var A = f === void 0 ? { debug: !1 } : f, b = A.debug;
        return new w({
          debug: b || !1
        });
      }, w.prototype._addListener = function(f, A) {
        var b = this, g = "_addListener", k = function(W) {
          var Z;
          try {
            Z = JSON.parse(W.detail);
          } catch (D) {
            b._logger.error("".concat(w.name, "#").concat(g, ":"), D);
            return;
          }
          b._requestIds.includes(Z.requestId) && (b._logger.debug("".concat(w.name, "#").concat(g, ": received response event:"), Z), A(e(e({}, Z), { error: Z.error || null, method: f, result: Z.result || null })));
        }, v = (0, n.v4)(), C = (0, c.createMessageReference)(f, i.ARC0027MessageTypeEnum.Response);
        return window.addEventListener(C, k), this._listeners.set(v, {
          listener: k,
          reference: C
        }), v;
      }, w.prototype._sendRequestMessage = function(f) {
        var A = this, b = f.method, g = f.params, k = "_sendRequestMessage", v = (0, n.v4)(), C = (0, c.createMessageReference)(b, i.ARC0027MessageTypeEnum.Request);
        try {
          return window.dispatchEvent(new CustomEvent(C, {
            detail: new l.RequestMessage({
              id: v,
              params: g,
              reference: C
            })
          })), window.setTimeout(function() {
            A._requestIds = A._requestIds.filter(function(W) {
              return W !== v;
            });
          }, a.DEFAULT_REQUEST_TIMEOUT), this._logger.debug("".concat(w.name, "#").concat(k, ': posted request message "').concat(C, '" with id "').concat(v, '"')), this._requestIds.push(v), v;
        } catch (W) {
          throw this._logger.error(W), new s.ARC0027UnknownError(W.message);
        }
      }, w.prototype.disable = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.Disable,
          params: f
        });
      }, w.prototype.discover = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.Discover,
          params: f
        });
      }, w.prototype.enable = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.Enable,
          params: f
        });
      }, w.prototype.onDisable = function(f) {
        return this._addListener(i.ARC0027MethodEnum.Disable, f);
      }, w.prototype.onDiscover = function(f) {
        return this._addListener(i.ARC0027MethodEnum.Discover, f);
      }, w.prototype.onEnable = function(f) {
        return this._addListener(i.ARC0027MethodEnum.Enable, f);
      }, w.prototype.onPostTransactions = function(f) {
        return this._addListener(i.ARC0027MethodEnum.PostTransactions, f);
      }, w.prototype.onSignAndPostTransactions = function(f) {
        return this._addListener(i.ARC0027MethodEnum.SignAndPostTransactions, f);
      }, w.prototype.onSignMessage = function(f) {
        return this._addListener(i.ARC0027MethodEnum.SignMessage, f);
      }, w.prototype.onSignTransactions = function(f) {
        return this._addListener(i.ARC0027MethodEnum.SignTransactions, f);
      }, w.prototype.postTransactions = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.PostTransactions,
          params: f
        });
      }, w.prototype.signAndPostTransactions = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.SignAndPostTransactions,
          params: f
        });
      }, w.prototype.signMessage = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.SignMessage,
          params: f
        });
      }, w.prototype.signTransactions = function(f) {
        return this._sendRequestMessage({
          method: i.ARC0027MethodEnum.SignTransactions,
          params: f
        });
      }, w;
    }(o.default)
  );
  return Bn.default = u, Bn;
}
var an = {}, Nf;
function Y_() {
  if (Nf) return an;
  Nf = 1;
  var r = an && an.__extends || /* @__PURE__ */ function() {
    var d = function(w, f) {
      return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, b) {
        A.__proto__ = b;
      } || function(A, b) {
        for (var g in b) Object.prototype.hasOwnProperty.call(b, g) && (A[g] = b[g]);
      }, d(w, f);
    };
    return function(w, f) {
      if (typeof f != "function" && f !== null)
        throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
      d(w, f);
      function A() {
        this.constructor = w;
      }
      w.prototype = f === null ? Object.create(f) : (A.prototype = f.prototype, new A());
    };
  }(), e = an && an.__awaiter || function(d, w, f, A) {
    function b(g) {
      return g instanceof f ? g : new f(function(k) {
        k(g);
      });
    }
    return new (f || (f = Promise))(function(g, k) {
      function v(Z) {
        try {
          W(A.next(Z));
        } catch (D) {
          k(D);
        }
      }
      function C(Z) {
        try {
          W(A.throw(Z));
        } catch (D) {
          k(D);
        }
      }
      function W(Z) {
        Z.done ? g(Z.value) : b(Z.value).then(v, C);
      }
      W((A = A.apply(d, w || [])).next());
    });
  }, t = an && an.__generator || function(d, w) {
    var f = { label: 0, sent: function() {
      if (g[0] & 1) throw g[1];
      return g[1];
    }, trys: [], ops: [] }, A, b, g, k;
    return k = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (k[Symbol.iterator] = function() {
      return this;
    }), k;
    function v(W) {
      return function(Z) {
        return C([W, Z]);
      };
    }
    function C(W) {
      if (A) throw new TypeError("Generator is already executing.");
      for (; k && (k = 0, W[0] && (f = 0)), f; ) try {
        if (A = 1, b && (g = W[0] & 2 ? b.return : W[0] ? b.throw || ((g = b.return) && g.call(b), 0) : b.next) && !(g = g.call(b, W[1])).done) return g;
        switch (b = 0, g && (W = [W[0] & 2, g.value]), W[0]) {
          case 0:
          case 1:
            g = W;
            break;
          case 4:
            return f.label++, { value: W[1], done: !1 };
          case 5:
            f.label++, b = W[1], W = [0];
            continue;
          case 7:
            W = f.ops.pop(), f.trys.pop();
            continue;
          default:
            if (g = f.trys, !(g = g.length > 0 && g[g.length - 1]) && (W[0] === 6 || W[0] === 2)) {
              f = 0;
              continue;
            }
            if (W[0] === 3 && (!g || W[1] > g[0] && W[1] < g[3])) {
              f.label = W[1];
              break;
            }
            if (W[0] === 6 && f.label < g[1]) {
              f.label = g[1], g = W;
              break;
            }
            if (g && f.label < g[2]) {
              f.label = g[2], f.ops.push(W);
              break;
            }
            g[2] && f.ops.pop(), f.trys.pop();
            continue;
        }
        W = w.call(d, f);
      } catch (Z) {
        W = [6, Z], b = 0;
      } finally {
        A = g = 0;
      }
      if (W[0] & 5) throw W[1];
      return { value: W[0] ? W[1] : void 0, done: !0 };
    }
  }, n = an && an.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(an, "__esModule", { value: !0 });
  var a = /* @__PURE__ */ m5(), o = n(Dd()), i = yn(), s = Md(), l = Id(), c = Td(), u = (
    /** @class */
    function(d) {
      r(w, d);
      function w(f) {
        return d.call(this, f) || this;
      }
      return w.prototype._addListener = function(f, A) {
        var b = this, g = "_addListener", k = function(W) {
          return b._logger.debug("[".concat(b._config.providerId, "]").concat(w.name, "#").concat(g, ": received request event:"), W.detail), b._sendResponseMessage({
            callback: A,
            method: f,
            requestMessage: W.detail
          });
        }, v = (0, a.v4)(), C = (0, c.createMessageReference)(f, i.ARC0027MessageTypeEnum.Request);
        return window.addEventListener(C, k), this._listeners.set(v, {
          listener: k,
          reference: C
        }), v;
      }, w.prototype._sendResponseMessage = function(f) {
        var A, b = f.callback, g = f.method, k = f.requestMessage;
        return e(this, void 0, void 0, function() {
          var v, C, W, Z, D;
          return t(this, function(H) {
            switch (H.label) {
              case 0:
                if (v = "_sendResponseMessage", !((A = k.params) === null || A === void 0) && A.providerId && k.params.providerId !== this._config.providerId)
                  return this._logger.debug("[".concat(this._config.providerId, "]").concat(w.name, "#").concat(v, ': message "').concat(k.reference, '" is for provider "').concat(k.params.providerId, '", skipping')), [
                    2
                    /*return*/
                  ];
                C = (0, a.v4)(), W = (0, c.createMessageReference)(g, i.ARC0027MessageTypeEnum.Response), H.label = 1;
              case 1:
                return H.trys.push([1, 3, , 4]), [4, b({
                  id: k.id,
                  method: g,
                  params: k.params
                })];
              case 2:
                return Z = H.sent(), window.dispatchEvent(new CustomEvent(W, {
                  detail: JSON.stringify(new l.ResponseMessageWithResult({
                    id: C,
                    reference: W,
                    requestId: k.id,
                    result: Z
                  }))
                })), this._logger.debug("[".concat(this._config.providerId, "]").concat(w.name, "#").concat(v, ': posted response message "').concat(W, '" with id "').concat(C, '"')), [
                  2
                  /*return*/
                ];
              case 3:
                return D = H.sent(), this._logger.error(D), D.code ? (window.dispatchEvent(new CustomEvent(W, {
                  detail: JSON.stringify(new l.ResponseMessageWithError({
                    error: D,
                    id: C,
                    reference: W,
                    requestId: k.id
                  }))
                })), [
                  2
                  /*return*/
                ]) : (window.dispatchEvent(new CustomEvent(W, {
                  detail: JSON.stringify(new l.ResponseMessageWithError({
                    error: new s.ARC0027UnknownError({
                      message: D.message,
                      providerId: this._config.providerId
                    }),
                    id: C,
                    reference: W,
                    requestId: k.id
                  }))
                })), [
                  2
                  /*return*/
                ]);
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, w.init = function(f, A) {
        var b = A === void 0 ? { debug: !1 } : A, g = b.debug;
        return new w({
          debug: g || !1,
          providerId: f
        });
      }, w.prototype.onDisable = function(f) {
        return this._addListener(i.ARC0027MethodEnum.Disable, f);
      }, w.prototype.onDiscover = function(f) {
        return this._addListener(i.ARC0027MethodEnum.Discover, f);
      }, w.prototype.onEnable = function(f) {
        return this._addListener(i.ARC0027MethodEnum.Enable, f);
      }, w.prototype.onPostTransactions = function(f) {
        return this._addListener(i.ARC0027MethodEnum.PostTransactions, f);
      }, w.prototype.onSignAndPostTransactions = function(f) {
        return this._addListener(i.ARC0027MethodEnum.SignAndPostTransactions, f);
      }, w.prototype.onSignMessage = function(f) {
        return this._addListener(i.ARC0027MethodEnum.SignMessage, f);
      }, w.prototype.onSignTransactions = function(f) {
        return this._addListener(i.ARC0027MethodEnum.SignTransactions, f);
      }, w;
    }(o.default)
  );
  return an.default = u, an;
}
var Bf;
function G_() {
  return Bf || (Bf = 1, function(r) {
    var e = Nc && Nc.__importDefault || function(i) {
      return i && i.__esModule ? i : { default: i };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Logger = r.BaseController = r.AVMWebProvider = r.AVMWebClient = void 0;
    var t = K_();
    Object.defineProperty(r, "AVMWebClient", { enumerable: !0, get: function() {
      return e(t).default;
    } });
    var n = Y_();
    Object.defineProperty(r, "AVMWebProvider", { enumerable: !0, get: function() {
      return e(n).default;
    } });
    var a = Dd();
    Object.defineProperty(r, "BaseController", { enumerable: !0, get: function() {
      return e(a).default;
    } });
    var o = y5();
    Object.defineProperty(r, "Logger", { enumerable: !0, get: function() {
      return e(o).default;
    } });
  }(Nc)), Nc;
}
var Lf = {}, Uf;
function J_() {
  return Uf || (Uf = 1, Object.defineProperty(Lf, "__esModule", { value: !0 })), Lf;
}
var Vf;
function X_() {
  return Vf || (Vf = 1, function(r) {
    var e = Bo && Bo.__createBinding || (Object.create ? function(n, a, o, i) {
      i === void 0 && (i = o);
      var s = Object.getOwnPropertyDescriptor(a, o);
      (!s || ("get" in s ? !a.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return a[o];
      } }), Object.defineProperty(n, i, s);
    } : function(n, a, o, i) {
      i === void 0 && (i = o), n[i] = a[o];
    }), t = Bo && Bo.__exportStar || function(n, a) {
      for (var o in n) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && e(a, n, o);
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), t(Cd(), r), t(G_(), r), t(yn(), r), t(Md(), r), t(Id(), r), t(J_(), r), t(Td(), r);
  }(Bo)), Bo;
}
var Z_ = X_();
const _s = class T1 extends y_ {
  constructor(e) {
    super(e), this._discoverTimeout = 300, this._client = Z_.AVMWebClient.init();
  }
  /**
   * private methods
   */
  _mapDiscoverResultToAvailableConnection({
    host: e,
    icon: t,
    name: n,
    networks: a,
    providerId: o
  }) {
    return {
      chainIDs: this._supportedChains.reduce((i, s) => a.find(
        ({ genesisHash: l }) => l === s.networkInformation.genesisHash
      ) ?? null ? [...i, s.chainID()] : i, []),
      host: e,
      iconURI: t,
      id: o,
      name: n
    };
  }
  _supportedGenesisHashes() {
    return this._supportedChains.reduce((e, t) => "genesisHash" in t.networkInformation ? [...e, t.networkInformation.genesisHash] : e, []);
  }
  /**
   * public methods
   */
  async availableConnections() {
    const e = `${T1.displayName}#availableConnections`;
    return new Promise((t) => {
      let n = [], a;
      a = this._client.onDiscover(({ error: o, result: i }) => {
        let s;
        if (o) {
          this._logger.error(`${e}:`, o);
          return;
        }
        if (i) {
          if (this._logger.debug(
            `${e}: found "${i.name}" connection with provider id "${i.providerId}" and networks [${i.networks.map(({ genesisHash: l }) => l).join(",")}]`
          ), !i.networks.some(({ genesisHash: l }) => this._supportedGenesisHashes().includes(l))) {
            this._logger.debug(
              `${e}: "${i.name}" with networks [${i.networks.map(({ genesisHash: l }) => l).join(",")}] does not support any of the supported chains [${this._supportedGenesisHashes().join(",")}]`
            );
            return;
          }
          if (s = n.findIndex(({ id: l }) => l === i.providerId), s < 0) {
            n.push(this._mapDiscoverResultToAvailableConnection(i));
            return;
          }
          n = n.map(
            (l, c) => c === s ? this._mapDiscoverResultToAvailableConnection(i) : l
          );
          return;
        }
      }), window.setTimeout(() => {
        this._client.removeListener(a), t(n);
      }, this._discoverTimeout), this._client.discover();
    });
  }
  async connect(e) {
    const t = `${T1.displayName}#connect`, n = (await this.availableConnections()).find(({ id: a }) => a === e);
    if (!n)
      throw new Error(`connection "${e}" not available`);
    return new Promise((a, o) => {
      const i = this._client.onEnable(({ error: s, result: l }) => {
        s && (this._logger.error(`${t}:`, s), o(s)), l && a(
          l.accounts.map(({ address: c, name: u }) => ({
            __type: Er.Connected,
            connections: [
              {
                connectorID: this.id(),
                wallet: n,
                createdAt: (/* @__PURE__ */ new Date()).getTime() / 1e3,
                lastUsedAt: (/* @__PURE__ */ new Date()).getTime() / 1e3,
                sessionID: l.sessionId
              }
            ],
            key: Dn.encode(rd.fromAddress(c).publicKey()),
            name: u
          }))
        ), this._client.removeListener(i);
      });
      this._client.enable({
        providerId: e
      });
    });
  }
};
_s.canonicalName = "AVM Web Provider", _s.displayName = "AVMWebProviderConnector", _s.host = "avm-web-provider.agoralabs.sh", _s.id = c3.AVMWebProvider;
let Q_ = _s;
const eb = ({ chains: r, children: e, debug: t }) => /* @__PURE__ */ T(bd.Provider, { value: [
  new Q_({
    debug: t,
    supportedChains: r
  })
], children: e }), tb = ({ children: r, settingsStore: e }) => {
  const [t, n] = dt(e);
  return kr(() => {
    n(e);
  }, [e]), /* @__PURE__ */ T(Sd.Provider, { value: t, children: r });
}, rb = ({ children: r, username: e }) => {
  const [t, n] = dt(e);
  return kr(() => {
    n(e);
  }, [e]), /* @__PURE__ */ T(pc.Provider, { value: t, children: r });
}, nb = ({ chains: r, clientInformation: e, debug: t, i18n: n, logger: a, ...o }) => /* @__PURE__ */ T(
  i5,
  {
    clientInformation: e,
    i18n: n,
    logger: a,
    children: /* @__PURE__ */ T(rb, { username: Ra(o.vault), children: /* @__PURE__ */ T(
      tb,
      {
        settingsStore: new nl({
          logger: a,
          vault: o.vault
        }),
        children: /* @__PURE__ */ T(p_, { accountsStore: new Ma({
          logger: a,
          vault: o.vault
        }), children: /* @__PURE__ */ T(g_, { chains: r, children: /* @__PURE__ */ T(eb, { chains: r, debug: t, children: /* @__PURE__ */ T(m_, { children: /* @__PURE__ */ T(f_, { ...o }) }) }) }) })
      }
    ) })
  }
), ab = {
  buttons: {
    cancel: "Cancel",
    confirm: "Confirm",
    continue: "Continue",
    logout: "Logout",
    retry: "Retry",
    signInWithPasskey: "Sign in with a passkey",
    signupWithPasskey: "Sign-up with a passkey",
    signInWithPassword: "Sign in with a password",
    signupWithPassword: "Sign-up with a password",
    transfer: "Transfer",
    transferFunds: "Transfer funds"
  },
  captions: {
    chooseConnectionMethod: "Choose how you would like to connect a new account:",
    confirmLogout: "Are you sure you want to logout?",
    connectAnAccount: "Connect an account",
    connectingWallet: "Please follow the instructions on {{name}} to connect.",
    copyAccountID: "Copy account ID",
    copyAddress: "Copy address",
    or: "Or",
    passwordDescription: "Password too weak",
    passwordDescription_1: "Password is sufficient",
    passwordDescription_2: "Password very strong!",
    passwordHint: "The password must meet a certain level of security. Try a mix of letters, numbers, special characters (?!£%&*, e.t.c.) and especially emojis! 😉",
    poweredBy: "Powered by",
    verifyPasskey: "Please follow the instructions to verify your passkey."
  },
  errors: {
    descriptions: {
      type: "Something went wrong. Please try again.",
      type_FAILED_TO_AUTHENTICATE_PASSKEY_ERROR: "Failed to authenticate with the supplied passkey. Please try again.",
      type_FAILED_TO_REGISTER_PASSKEY_ERROR: "Failed to register the supplied passkey. Please try again.",
      type_PASSKEY_NOT_SUPPORTED_ERROR: "The supplied passkey device is not supported. Please try a different device.",
      type_USER_CANCELED_PASSKEY_REQUEST_ERROR: "The passkey request timed out or was canceled."
    },
    inputs: {
      incorrectPassword: "Incorrect password.",
      required: "This field required."
    }
  },
  headings: {
    about: "About",
    appearance: "Appearance",
    confirmLogout: "Logout",
    connectAnAccount: "Connect an account ",
    connectedAccounts: "Connected accounts",
    connections: "Connections",
    finishCreatingANewAccount: "Finish creating a new account",
    holdingAccounts: "Holding accounts",
    networks: "Networks",
    settings: "Settings",
    signInOrCreateANewAccount: "Sign in or create a new account",
    transferFunds: "Transfer funds",
    welcomeBack: "Welcome back!"
  },
  labels: {
    avm: "AVM",
    accountID: "Account ID",
    credentialAccount: "Credential account",
    darkMode: "Dark mode",
    logout: "Logout",
    name: "Name",
    version: "Version"
  },
  placeholders: {
    password: "Password",
    usernameEmail: "Username or email"
  }
}, w5 = class {
  constructor({ logger: e }) {
    this._i18n = null, this._logger = e;
  }
  /**
   * private methods
   */
  async _getOrInitializeI18n() {
    return this._i18n || (this._i18n = Lr.createInstance({
      fallbackLng: "en",
      interpolation: {
        escapeValue: !1
      },
      resources: {
        en: {
          translation: ab
        }
      }
    }), await this._i18n.init()), this._i18n;
  }
  _rootElement(e) {
    let t, n;
    if (!window)
      throw new I6("failed to get window object, is this being run in a browser context?");
    return n = this._rootElementID(e), t = window.document.getElementById(n), t || (t = window.document.createElement("div"), t.id = n, window.document.body.appendChild(t)), t;
  }
  _rootElementID(e) {
    return `katavault_${e}`;
  }
  /**
   * public methods
   */
  closeApp(e) {
    const t = window.document.getElementById(this._rootElementID(e));
    t && (Vu(null, t), t.remove());
  }
  async renderAuthenticationApp({
    clientInformation: e,
    debug: t
  }) {
    const n = await this._getOrInitializeI18n();
    return new Promise((a, o) => {
      Vu(
        _l(hw, {
          clientInformation: e,
          debug: t,
          i18n: n,
          logger: this._logger,
          onClose: () => this.closeApp(Vn.Authentication),
          onError: o,
          onSuccess: a
        }),
        this._rootElement(Vn.Authentication)
      );
    });
  }
  async renderVaultApp({
    authenticationStore: e,
    clientInformation: t,
    chains: n,
    debug: a,
    onLogout: o,
    vault: i
  }) {
    const s = await this._getOrInitializeI18n();
    return new Promise((l) => {
      Vu(
        _l(nb, {
          authenticationStore: e,
          clientInformation: t,
          chains: n,
          debug: a,
          i18n: s,
          logger: this._logger,
          onClose: () => {
            this.closeApp(Vn.Vault), l();
          },
          onLogout: () => {
            o(), this.closeApp(Vn.Vault), l();
          },
          vault: i
        }),
        this._rootElement(Vn.Vault)
      );
    });
  }
};
w5.displayName = "AppManager";
let ob = w5;
var $f = { exports: {} };
/*
 * [js-sha512]{@link https://github.com/emn178/js-sha512}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2018
 * @license MIT
 */
var jf;
function ib() {
  return jf || (jf = 1, function(r) {
    (function() {
      var e = "input is invalid type", t = "finalize already called", n = typeof window == "object", a = n ? window : {};
      a.JS_SHA512_NO_WINDOW && (n = !1);
      var o = !n && typeof self == "object", i = !a.JS_SHA512_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
      i ? a = d3 : o && (a = self);
      var s = !a.JS_SHA512_NO_COMMON_JS && !0 && r.exports, l = !a.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", c = "0123456789abcdef".split(""), u = [-2147483648, 8388608, 32768, 128], d = [24, 16, 8, 0], w = [
        1116352408,
        3609767458,
        1899447441,
        602891725,
        3049323471,
        3964484399,
        3921009573,
        2173295548,
        961987163,
        4081628472,
        1508970993,
        3053834265,
        2453635748,
        2937671579,
        2870763221,
        3664609560,
        3624381080,
        2734883394,
        310598401,
        1164996542,
        607225278,
        1323610764,
        1426881987,
        3590304994,
        1925078388,
        4068182383,
        2162078206,
        991336113,
        2614888103,
        633803317,
        3248222580,
        3479774868,
        3835390401,
        2666613458,
        4022224774,
        944711139,
        264347078,
        2341262773,
        604807628,
        2007800933,
        770255983,
        1495990901,
        1249150122,
        1856431235,
        1555081692,
        3175218132,
        1996064986,
        2198950837,
        2554220882,
        3999719339,
        2821834349,
        766784016,
        2952996808,
        2566594879,
        3210313671,
        3203337956,
        3336571891,
        1034457026,
        3584528711,
        2466948901,
        113926993,
        3758326383,
        338241895,
        168717936,
        666307205,
        1188179964,
        773529912,
        1546045734,
        1294757372,
        1522805485,
        1396182291,
        2643833823,
        1695183700,
        2343527390,
        1986661051,
        1014477480,
        2177026350,
        1206759142,
        2456956037,
        344077627,
        2730485921,
        1290863460,
        2820302411,
        3158454273,
        3259730800,
        3505952657,
        3345764771,
        106217008,
        3516065817,
        3606008344,
        3600352804,
        1432725776,
        4094571909,
        1467031594,
        275423344,
        851169720,
        430227734,
        3100823752,
        506948616,
        1363258195,
        659060556,
        3750685593,
        883997877,
        3785050280,
        958139571,
        3318307427,
        1322822218,
        3812723403,
        1537002063,
        2003034995,
        1747873779,
        3602036899,
        1955562222,
        1575990012,
        2024104815,
        1125592928,
        2227730452,
        2716904306,
        2361852424,
        442776044,
        2428436474,
        593698344,
        2756734187,
        3733110249,
        3204031479,
        2999351573,
        3329325298,
        3815920427,
        3391569614,
        3928383900,
        3515267271,
        566280711,
        3940187606,
        3454069534,
        4118630271,
        4000239992,
        116418474,
        1914138554,
        174292421,
        2731055270,
        289380356,
        3203993006,
        460393269,
        320620315,
        685471733,
        587496836,
        852142971,
        1086792851,
        1017036298,
        365543100,
        1126000580,
        2618297676,
        1288033470,
        3409855158,
        1501505948,
        4234509866,
        1607167915,
        987167468,
        1816402316,
        1246189591
      ], f = ["hex", "array", "digest", "arrayBuffer"], A = [];
      (a.JS_SHA512_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(D) {
        return Object.prototype.toString.call(D) === "[object Array]";
      }), l && (a.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(D) {
        return typeof D == "object" && D.buffer && D.buffer.constructor === ArrayBuffer;
      });
      var b = function(D, H) {
        return function(y) {
          return new C(H, !0).update(y)[D]();
        };
      }, g = function(D) {
        var H = b("hex", D);
        H.create = function() {
          return new C(D);
        }, H.update = function(_) {
          return H.create().update(_);
        };
        for (var y = 0; y < f.length; ++y) {
          var S = f[y];
          H[S] = b(S, D);
        }
        return H;
      }, k = function(D, H) {
        return function(y, S) {
          return new W(y, H, !0).update(S)[D]();
        };
      }, v = function(D) {
        var H = k("hex", D);
        H.create = function(_) {
          return new W(_, D);
        }, H.update = function(_, F) {
          return H.create(_).update(F);
        };
        for (var y = 0; y < f.length; ++y) {
          var S = f[y];
          H[S] = k(S, D);
        }
        return H;
      };
      function C(D, H) {
        H ? (A[0] = A[1] = A[2] = A[3] = A[4] = A[5] = A[6] = A[7] = A[8] = A[9] = A[10] = A[11] = A[12] = A[13] = A[14] = A[15] = A[16] = A[17] = A[18] = A[19] = A[20] = A[21] = A[22] = A[23] = A[24] = A[25] = A[26] = A[27] = A[28] = A[29] = A[30] = A[31] = A[32] = 0, this.blocks = A) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], D == 384 ? (this.h0h = 3418070365, this.h0l = 3238371032, this.h1h = 1654270250, this.h1l = 914150663, this.h2h = 2438529370, this.h2l = 812702999, this.h3h = 355462360, this.h3l = 4144912697, this.h4h = 1731405415, this.h4l = 4290775857, this.h5h = 2394180231, this.h5l = 1750603025, this.h6h = 3675008525, this.h6l = 1694076839, this.h7h = 1203062813, this.h7l = 3204075428) : D == 256 ? (this.h0h = 573645204, this.h0l = 4230739756, this.h1h = 2673172387, this.h1l = 3360449730, this.h2h = 596883563, this.h2l = 1867755857, this.h3h = 2520282905, this.h3l = 1497426621, this.h4h = 2519219938, this.h4l = 2827943907, this.h5h = 3193839141, this.h5l = 1401305490, this.h6h = 721525244, this.h6l = 746961066, this.h7h = 246885852, this.h7l = 2177182882) : D == 224 ? (this.h0h = 2352822216, this.h0l = 424955298, this.h1h = 1944164710, this.h1l = 2312950998, this.h2h = 502970286, this.h2l = 855612546, this.h3h = 1738396948, this.h3l = 1479516111, this.h4h = 258812777, this.h4l = 2077511080, this.h5h = 2011393907, this.h5l = 79989058, this.h6h = 1067287976, this.h6l = 1780299464, this.h7h = 286451373, this.h7l = 2446758561) : (this.h0h = 1779033703, this.h0l = 4089235720, this.h1h = 3144134277, this.h1l = 2227873595, this.h2h = 1013904242, this.h2l = 4271175723, this.h3h = 2773480762, this.h3l = 1595750129, this.h4h = 1359893119, this.h4l = 2917565137, this.h5h = 2600822924, this.h5l = 725511199, this.h6h = 528734635, this.h6l = 4215389547, this.h7h = 1541459225, this.h7l = 327033209), this.bits = D, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1;
      }
      C.prototype.update = function(D) {
        if (this.finalized)
          throw new Error(t);
        var H, y = typeof D;
        if (y !== "string") {
          if (y === "object") {
            if (D === null)
              throw new Error(e);
            if (l && D.constructor === ArrayBuffer)
              D = new Uint8Array(D);
            else if (!Array.isArray(D) && (!l || !ArrayBuffer.isView(D)))
              throw new Error(e);
          } else
            throw new Error(e);
          H = !0;
        }
        for (var S, _ = 0, F, M = D.length, j = this.blocks; _ < M; ) {
          if (this.hashed && (this.hashed = !1, j[0] = this.block, j[1] = j[2] = j[3] = j[4] = j[5] = j[6] = j[7] = j[8] = j[9] = j[10] = j[11] = j[12] = j[13] = j[14] = j[15] = j[16] = j[17] = j[18] = j[19] = j[20] = j[21] = j[22] = j[23] = j[24] = j[25] = j[26] = j[27] = j[28] = j[29] = j[30] = j[31] = j[32] = 0), H)
            for (F = this.start; _ < M && F < 128; ++_)
              j[F >> 2] |= D[_] << d[F++ & 3];
          else
            for (F = this.start; _ < M && F < 128; ++_)
              S = D.charCodeAt(_), S < 128 ? j[F >> 2] |= S << d[F++ & 3] : S < 2048 ? (j[F >> 2] |= (192 | S >> 6) << d[F++ & 3], j[F >> 2] |= (128 | S & 63) << d[F++ & 3]) : S < 55296 || S >= 57344 ? (j[F >> 2] |= (224 | S >> 12) << d[F++ & 3], j[F >> 2] |= (128 | S >> 6 & 63) << d[F++ & 3], j[F >> 2] |= (128 | S & 63) << d[F++ & 3]) : (S = 65536 + ((S & 1023) << 10 | D.charCodeAt(++_) & 1023), j[F >> 2] |= (240 | S >> 18) << d[F++ & 3], j[F >> 2] |= (128 | S >> 12 & 63) << d[F++ & 3], j[F >> 2] |= (128 | S >> 6 & 63) << d[F++ & 3], j[F >> 2] |= (128 | S & 63) << d[F++ & 3]);
          this.lastByteIndex = F, this.bytes += F - this.start, F >= 128 ? (this.block = j[32], this.start = F - 128, this.hash(), this.hashed = !0) : this.start = F;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }, C.prototype.finalize = function() {
        if (!this.finalized) {
          this.finalized = !0;
          var D = this.blocks, H = this.lastByteIndex;
          D[32] = this.block, D[H >> 2] |= u[H & 3], this.block = D[32], H >= 112 && (this.hashed || this.hash(), D[0] = this.block, D[1] = D[2] = D[3] = D[4] = D[5] = D[6] = D[7] = D[8] = D[9] = D[10] = D[11] = D[12] = D[13] = D[14] = D[15] = D[16] = D[17] = D[18] = D[19] = D[20] = D[21] = D[22] = D[23] = D[24] = D[25] = D[26] = D[27] = D[28] = D[29] = D[30] = D[31] = D[32] = 0), D[30] = this.hBytes << 3 | this.bytes >>> 29, D[31] = this.bytes << 3, this.hash();
        }
      }, C.prototype.hash = function() {
        var D = this.h0h, H = this.h0l, y = this.h1h, S = this.h1l, _ = this.h2h, F = this.h2l, M = this.h3h, j = this.h3l, Y = this.h4h, N = this.h4l, O = this.h5h, G = this.h5l, Q = this.h6h, ie = this.h6l, fe = this.h7h, pe = this.h7l, ye = this.blocks, te, B, oe, ce, Ce, he, ge, h, m, E, $, R, P, J, I, U, K, z, re, le, ee, Se, Re, Ne, Ie;
        for (te = 32; te < 160; te += 2)
          le = ye[te - 30], ee = ye[te - 29], B = (le >>> 1 | ee << 31) ^ (le >>> 8 | ee << 24) ^ le >>> 7, oe = (ee >>> 1 | le << 31) ^ (ee >>> 8 | le << 24) ^ (ee >>> 7 | le << 25), le = ye[te - 4], ee = ye[te - 3], ce = (le >>> 19 | ee << 13) ^ (ee >>> 29 | le << 3) ^ le >>> 6, Ce = (ee >>> 19 | le << 13) ^ (le >>> 29 | ee << 3) ^ (ee >>> 6 | le << 26), le = ye[te - 32], ee = ye[te - 31], Se = ye[te - 14], Re = ye[te - 13], he = (Re & 65535) + (ee & 65535) + (oe & 65535) + (Ce & 65535), ge = (Re >>> 16) + (ee >>> 16) + (oe >>> 16) + (Ce >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (B & 65535) + (ce & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (B >>> 16) + (ce >>> 16) + (h >>> 16), ye[te] = m << 16 | h & 65535, ye[te + 1] = ge << 16 | he & 65535;
        var De = D, Fe = H, lt = y, ft = S, it = _, Ue = F, nt = M, He = j, ze = Y, Be = N, Pt = O, kt = G, It = Q, sr = ie, Kt = fe, pr = pe;
        for (U = lt & it, K = ft & Ue, te = 0; te < 160; te += 8)
          B = (De >>> 28 | Fe << 4) ^ (Fe >>> 2 | De << 30) ^ (Fe >>> 7 | De << 25), oe = (Fe >>> 28 | De << 4) ^ (De >>> 2 | Fe << 30) ^ (De >>> 7 | Fe << 25), ce = (ze >>> 14 | Be << 18) ^ (ze >>> 18 | Be << 14) ^ (Be >>> 9 | ze << 23), Ce = (Be >>> 14 | ze << 18) ^ (Be >>> 18 | ze << 14) ^ (ze >>> 9 | Be << 23), E = De & lt, $ = Fe & ft, z = E ^ De & it ^ U, re = $ ^ Fe & Ue ^ K, Ne = ze & Pt ^ ~ze & It, Ie = Be & kt ^ ~Be & sr, le = ye[te], ee = ye[te + 1], Se = w[te], Re = w[te + 1], he = (Re & 65535) + (ee & 65535) + (Ie & 65535) + (Ce & 65535) + (pr & 65535), ge = (Re >>> 16) + (ee >>> 16) + (Ie >>> 16) + (Ce >>> 16) + (pr >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (Ne & 65535) + (ce & 65535) + (Kt & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (Ne >>> 16) + (ce >>> 16) + (Kt >>> 16) + (h >>> 16), le = m << 16 | h & 65535, ee = ge << 16 | he & 65535, he = (re & 65535) + (oe & 65535), ge = (re >>> 16) + (oe >>> 16) + (he >>> 16), h = (z & 65535) + (B & 65535) + (ge >>> 16), m = (z >>> 16) + (B >>> 16) + (h >>> 16), Se = m << 16 | h & 65535, Re = ge << 16 | he & 65535, he = (He & 65535) + (ee & 65535), ge = (He >>> 16) + (ee >>> 16) + (he >>> 16), h = (nt & 65535) + (le & 65535) + (ge >>> 16), m = (nt >>> 16) + (le >>> 16) + (h >>> 16), Kt = m << 16 | h & 65535, pr = ge << 16 | he & 65535, he = (Re & 65535) + (ee & 65535), ge = (Re >>> 16) + (ee >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (h >>> 16), nt = m << 16 | h & 65535, He = ge << 16 | he & 65535, B = (nt >>> 28 | He << 4) ^ (He >>> 2 | nt << 30) ^ (He >>> 7 | nt << 25), oe = (He >>> 28 | nt << 4) ^ (nt >>> 2 | He << 30) ^ (nt >>> 7 | He << 25), ce = (Kt >>> 14 | pr << 18) ^ (Kt >>> 18 | pr << 14) ^ (pr >>> 9 | Kt << 23), Ce = (pr >>> 14 | Kt << 18) ^ (pr >>> 18 | Kt << 14) ^ (Kt >>> 9 | pr << 23), R = nt & De, P = He & Fe, z = R ^ nt & lt ^ E, re = P ^ He & ft ^ $, Ne = Kt & ze ^ ~Kt & Pt, Ie = pr & Be ^ ~pr & kt, le = ye[te + 2], ee = ye[te + 3], Se = w[te + 2], Re = w[te + 3], he = (Re & 65535) + (ee & 65535) + (Ie & 65535) + (Ce & 65535) + (sr & 65535), ge = (Re >>> 16) + (ee >>> 16) + (Ie >>> 16) + (Ce >>> 16) + (sr >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (Ne & 65535) + (ce & 65535) + (It & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (Ne >>> 16) + (ce >>> 16) + (It >>> 16) + (h >>> 16), le = m << 16 | h & 65535, ee = ge << 16 | he & 65535, he = (re & 65535) + (oe & 65535), ge = (re >>> 16) + (oe >>> 16) + (he >>> 16), h = (z & 65535) + (B & 65535) + (ge >>> 16), m = (z >>> 16) + (B >>> 16) + (h >>> 16), Se = m << 16 | h & 65535, Re = ge << 16 | he & 65535, he = (Ue & 65535) + (ee & 65535), ge = (Ue >>> 16) + (ee >>> 16) + (he >>> 16), h = (it & 65535) + (le & 65535) + (ge >>> 16), m = (it >>> 16) + (le >>> 16) + (h >>> 16), It = m << 16 | h & 65535, sr = ge << 16 | he & 65535, he = (Re & 65535) + (ee & 65535), ge = (Re >>> 16) + (ee >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (h >>> 16), it = m << 16 | h & 65535, Ue = ge << 16 | he & 65535, B = (it >>> 28 | Ue << 4) ^ (Ue >>> 2 | it << 30) ^ (Ue >>> 7 | it << 25), oe = (Ue >>> 28 | it << 4) ^ (it >>> 2 | Ue << 30) ^ (it >>> 7 | Ue << 25), ce = (It >>> 14 | sr << 18) ^ (It >>> 18 | sr << 14) ^ (sr >>> 9 | It << 23), Ce = (sr >>> 14 | It << 18) ^ (sr >>> 18 | It << 14) ^ (It >>> 9 | sr << 23), J = it & nt, I = Ue & He, z = J ^ it & De ^ R, re = I ^ Ue & Fe ^ P, Ne = It & Kt ^ ~It & ze, Ie = sr & pr ^ ~sr & Be, le = ye[te + 4], ee = ye[te + 5], Se = w[te + 4], Re = w[te + 5], he = (Re & 65535) + (ee & 65535) + (Ie & 65535) + (Ce & 65535) + (kt & 65535), ge = (Re >>> 16) + (ee >>> 16) + (Ie >>> 16) + (Ce >>> 16) + (kt >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (Ne & 65535) + (ce & 65535) + (Pt & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (Ne >>> 16) + (ce >>> 16) + (Pt >>> 16) + (h >>> 16), le = m << 16 | h & 65535, ee = ge << 16 | he & 65535, he = (re & 65535) + (oe & 65535), ge = (re >>> 16) + (oe >>> 16) + (he >>> 16), h = (z & 65535) + (B & 65535) + (ge >>> 16), m = (z >>> 16) + (B >>> 16) + (h >>> 16), Se = m << 16 | h & 65535, Re = ge << 16 | he & 65535, he = (ft & 65535) + (ee & 65535), ge = (ft >>> 16) + (ee >>> 16) + (he >>> 16), h = (lt & 65535) + (le & 65535) + (ge >>> 16), m = (lt >>> 16) + (le >>> 16) + (h >>> 16), Pt = m << 16 | h & 65535, kt = ge << 16 | he & 65535, he = (Re & 65535) + (ee & 65535), ge = (Re >>> 16) + (ee >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (h >>> 16), lt = m << 16 | h & 65535, ft = ge << 16 | he & 65535, B = (lt >>> 28 | ft << 4) ^ (ft >>> 2 | lt << 30) ^ (ft >>> 7 | lt << 25), oe = (ft >>> 28 | lt << 4) ^ (lt >>> 2 | ft << 30) ^ (lt >>> 7 | ft << 25), ce = (Pt >>> 14 | kt << 18) ^ (Pt >>> 18 | kt << 14) ^ (kt >>> 9 | Pt << 23), Ce = (kt >>> 14 | Pt << 18) ^ (kt >>> 18 | Pt << 14) ^ (Pt >>> 9 | kt << 23), U = lt & it, K = ft & Ue, z = U ^ lt & nt ^ J, re = K ^ ft & He ^ I, Ne = Pt & It ^ ~Pt & Kt, Ie = kt & sr ^ ~kt & pr, le = ye[te + 6], ee = ye[te + 7], Se = w[te + 6], Re = w[te + 7], he = (Re & 65535) + (ee & 65535) + (Ie & 65535) + (Ce & 65535) + (Be & 65535), ge = (Re >>> 16) + (ee >>> 16) + (Ie >>> 16) + (Ce >>> 16) + (Be >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (Ne & 65535) + (ce & 65535) + (ze & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (Ne >>> 16) + (ce >>> 16) + (ze >>> 16) + (h >>> 16), le = m << 16 | h & 65535, ee = ge << 16 | he & 65535, he = (re & 65535) + (oe & 65535), ge = (re >>> 16) + (oe >>> 16) + (he >>> 16), h = (z & 65535) + (B & 65535) + (ge >>> 16), m = (z >>> 16) + (B >>> 16) + (h >>> 16), Se = m << 16 | h & 65535, Re = ge << 16 | he & 65535, he = (Fe & 65535) + (ee & 65535), ge = (Fe >>> 16) + (ee >>> 16) + (he >>> 16), h = (De & 65535) + (le & 65535) + (ge >>> 16), m = (De >>> 16) + (le >>> 16) + (h >>> 16), ze = m << 16 | h & 65535, Be = ge << 16 | he & 65535, he = (Re & 65535) + (ee & 65535), ge = (Re >>> 16) + (ee >>> 16) + (he >>> 16), h = (Se & 65535) + (le & 65535) + (ge >>> 16), m = (Se >>> 16) + (le >>> 16) + (h >>> 16), De = m << 16 | h & 65535, Fe = ge << 16 | he & 65535;
        he = (H & 65535) + (Fe & 65535), ge = (H >>> 16) + (Fe >>> 16) + (he >>> 16), h = (D & 65535) + (De & 65535) + (ge >>> 16), m = (D >>> 16) + (De >>> 16) + (h >>> 16), this.h0h = m << 16 | h & 65535, this.h0l = ge << 16 | he & 65535, he = (S & 65535) + (ft & 65535), ge = (S >>> 16) + (ft >>> 16) + (he >>> 16), h = (y & 65535) + (lt & 65535) + (ge >>> 16), m = (y >>> 16) + (lt >>> 16) + (h >>> 16), this.h1h = m << 16 | h & 65535, this.h1l = ge << 16 | he & 65535, he = (F & 65535) + (Ue & 65535), ge = (F >>> 16) + (Ue >>> 16) + (he >>> 16), h = (_ & 65535) + (it & 65535) + (ge >>> 16), m = (_ >>> 16) + (it >>> 16) + (h >>> 16), this.h2h = m << 16 | h & 65535, this.h2l = ge << 16 | he & 65535, he = (j & 65535) + (He & 65535), ge = (j >>> 16) + (He >>> 16) + (he >>> 16), h = (M & 65535) + (nt & 65535) + (ge >>> 16), m = (M >>> 16) + (nt >>> 16) + (h >>> 16), this.h3h = m << 16 | h & 65535, this.h3l = ge << 16 | he & 65535, he = (N & 65535) + (Be & 65535), ge = (N >>> 16) + (Be >>> 16) + (he >>> 16), h = (Y & 65535) + (ze & 65535) + (ge >>> 16), m = (Y >>> 16) + (ze >>> 16) + (h >>> 16), this.h4h = m << 16 | h & 65535, this.h4l = ge << 16 | he & 65535, he = (G & 65535) + (kt & 65535), ge = (G >>> 16) + (kt >>> 16) + (he >>> 16), h = (O & 65535) + (Pt & 65535) + (ge >>> 16), m = (O >>> 16) + (Pt >>> 16) + (h >>> 16), this.h5h = m << 16 | h & 65535, this.h5l = ge << 16 | he & 65535, he = (ie & 65535) + (sr & 65535), ge = (ie >>> 16) + (sr >>> 16) + (he >>> 16), h = (Q & 65535) + (It & 65535) + (ge >>> 16), m = (Q >>> 16) + (It >>> 16) + (h >>> 16), this.h6h = m << 16 | h & 65535, this.h6l = ge << 16 | he & 65535, he = (pe & 65535) + (pr & 65535), ge = (pe >>> 16) + (pr >>> 16) + (he >>> 16), h = (fe & 65535) + (Kt & 65535) + (ge >>> 16), m = (fe >>> 16) + (Kt >>> 16) + (h >>> 16), this.h7h = m << 16 | h & 65535, this.h7l = ge << 16 | he & 65535;
      }, C.prototype.hex = function() {
        this.finalize();
        var D = this.h0h, H = this.h0l, y = this.h1h, S = this.h1l, _ = this.h2h, F = this.h2l, M = this.h3h, j = this.h3l, Y = this.h4h, N = this.h4l, O = this.h5h, G = this.h5l, Q = this.h6h, ie = this.h6l, fe = this.h7h, pe = this.h7l, ye = this.bits, te = c[D >> 28 & 15] + c[D >> 24 & 15] + c[D >> 20 & 15] + c[D >> 16 & 15] + c[D >> 12 & 15] + c[D >> 8 & 15] + c[D >> 4 & 15] + c[D & 15] + c[H >> 28 & 15] + c[H >> 24 & 15] + c[H >> 20 & 15] + c[H >> 16 & 15] + c[H >> 12 & 15] + c[H >> 8 & 15] + c[H >> 4 & 15] + c[H & 15] + c[y >> 28 & 15] + c[y >> 24 & 15] + c[y >> 20 & 15] + c[y >> 16 & 15] + c[y >> 12 & 15] + c[y >> 8 & 15] + c[y >> 4 & 15] + c[y & 15] + c[S >> 28 & 15] + c[S >> 24 & 15] + c[S >> 20 & 15] + c[S >> 16 & 15] + c[S >> 12 & 15] + c[S >> 8 & 15] + c[S >> 4 & 15] + c[S & 15] + c[_ >> 28 & 15] + c[_ >> 24 & 15] + c[_ >> 20 & 15] + c[_ >> 16 & 15] + c[_ >> 12 & 15] + c[_ >> 8 & 15] + c[_ >> 4 & 15] + c[_ & 15] + c[F >> 28 & 15] + c[F >> 24 & 15] + c[F >> 20 & 15] + c[F >> 16 & 15] + c[F >> 12 & 15] + c[F >> 8 & 15] + c[F >> 4 & 15] + c[F & 15] + c[M >> 28 & 15] + c[M >> 24 & 15] + c[M >> 20 & 15] + c[M >> 16 & 15] + c[M >> 12 & 15] + c[M >> 8 & 15] + c[M >> 4 & 15] + c[M & 15];
        return ye >= 256 && (te += c[j >> 28 & 15] + c[j >> 24 & 15] + c[j >> 20 & 15] + c[j >> 16 & 15] + c[j >> 12 & 15] + c[j >> 8 & 15] + c[j >> 4 & 15] + c[j & 15]), ye >= 384 && (te += c[Y >> 28 & 15] + c[Y >> 24 & 15] + c[Y >> 20 & 15] + c[Y >> 16 & 15] + c[Y >> 12 & 15] + c[Y >> 8 & 15] + c[Y >> 4 & 15] + c[Y & 15] + c[N >> 28 & 15] + c[N >> 24 & 15] + c[N >> 20 & 15] + c[N >> 16 & 15] + c[N >> 12 & 15] + c[N >> 8 & 15] + c[N >> 4 & 15] + c[N & 15] + c[O >> 28 & 15] + c[O >> 24 & 15] + c[O >> 20 & 15] + c[O >> 16 & 15] + c[O >> 12 & 15] + c[O >> 8 & 15] + c[O >> 4 & 15] + c[O & 15] + c[G >> 28 & 15] + c[G >> 24 & 15] + c[G >> 20 & 15] + c[G >> 16 & 15] + c[G >> 12 & 15] + c[G >> 8 & 15] + c[G >> 4 & 15] + c[G & 15]), ye == 512 && (te += c[Q >> 28 & 15] + c[Q >> 24 & 15] + c[Q >> 20 & 15] + c[Q >> 16 & 15] + c[Q >> 12 & 15] + c[Q >> 8 & 15] + c[Q >> 4 & 15] + c[Q & 15] + c[ie >> 28 & 15] + c[ie >> 24 & 15] + c[ie >> 20 & 15] + c[ie >> 16 & 15] + c[ie >> 12 & 15] + c[ie >> 8 & 15] + c[ie >> 4 & 15] + c[ie & 15] + c[fe >> 28 & 15] + c[fe >> 24 & 15] + c[fe >> 20 & 15] + c[fe >> 16 & 15] + c[fe >> 12 & 15] + c[fe >> 8 & 15] + c[fe >> 4 & 15] + c[fe & 15] + c[pe >> 28 & 15] + c[pe >> 24 & 15] + c[pe >> 20 & 15] + c[pe >> 16 & 15] + c[pe >> 12 & 15] + c[pe >> 8 & 15] + c[pe >> 4 & 15] + c[pe & 15]), te;
      }, C.prototype.toString = C.prototype.hex, C.prototype.digest = function() {
        this.finalize();
        var D = this.h0h, H = this.h0l, y = this.h1h, S = this.h1l, _ = this.h2h, F = this.h2l, M = this.h3h, j = this.h3l, Y = this.h4h, N = this.h4l, O = this.h5h, G = this.h5l, Q = this.h6h, ie = this.h6l, fe = this.h7h, pe = this.h7l, ye = this.bits, te = [
          D >> 24 & 255,
          D >> 16 & 255,
          D >> 8 & 255,
          D & 255,
          H >> 24 & 255,
          H >> 16 & 255,
          H >> 8 & 255,
          H & 255,
          y >> 24 & 255,
          y >> 16 & 255,
          y >> 8 & 255,
          y & 255,
          S >> 24 & 255,
          S >> 16 & 255,
          S >> 8 & 255,
          S & 255,
          _ >> 24 & 255,
          _ >> 16 & 255,
          _ >> 8 & 255,
          _ & 255,
          F >> 24 & 255,
          F >> 16 & 255,
          F >> 8 & 255,
          F & 255,
          M >> 24 & 255,
          M >> 16 & 255,
          M >> 8 & 255,
          M & 255
        ];
        return ye >= 256 && te.push(j >> 24 & 255, j >> 16 & 255, j >> 8 & 255, j & 255), ye >= 384 && te.push(
          Y >> 24 & 255,
          Y >> 16 & 255,
          Y >> 8 & 255,
          Y & 255,
          N >> 24 & 255,
          N >> 16 & 255,
          N >> 8 & 255,
          N & 255,
          O >> 24 & 255,
          O >> 16 & 255,
          O >> 8 & 255,
          O & 255,
          G >> 24 & 255,
          G >> 16 & 255,
          G >> 8 & 255,
          G & 255
        ), ye == 512 && te.push(
          Q >> 24 & 255,
          Q >> 16 & 255,
          Q >> 8 & 255,
          Q & 255,
          ie >> 24 & 255,
          ie >> 16 & 255,
          ie >> 8 & 255,
          ie & 255,
          fe >> 24 & 255,
          fe >> 16 & 255,
          fe >> 8 & 255,
          fe & 255,
          pe >> 24 & 255,
          pe >> 16 & 255,
          pe >> 8 & 255,
          pe & 255
        ), te;
      }, C.prototype.array = C.prototype.digest, C.prototype.arrayBuffer = function() {
        this.finalize();
        var D = this.bits, H = new ArrayBuffer(D / 8), y = new DataView(H);
        return y.setUint32(0, this.h0h), y.setUint32(4, this.h0l), y.setUint32(8, this.h1h), y.setUint32(12, this.h1l), y.setUint32(16, this.h2h), y.setUint32(20, this.h2l), y.setUint32(24, this.h3h), D >= 256 && y.setUint32(28, this.h3l), D >= 384 && (y.setUint32(32, this.h4h), y.setUint32(36, this.h4l), y.setUint32(40, this.h5h), y.setUint32(44, this.h5l)), D == 512 && (y.setUint32(48, this.h6h), y.setUint32(52, this.h6l), y.setUint32(56, this.h7h), y.setUint32(60, this.h7l)), H;
      }, C.prototype.clone = function() {
        var D = new C(this.bits, !1);
        return this.copyTo(D), D;
      }, C.prototype.copyTo = function(D) {
        var H = 0, y = [
          "h0h",
          "h0l",
          "h1h",
          "h1l",
          "h2h",
          "h2l",
          "h3h",
          "h3l",
          "h4h",
          "h4l",
          "h5h",
          "h5l",
          "h6h",
          "h6l",
          "h7h",
          "h7l",
          "start",
          "bytes",
          "hBytes",
          "finalized",
          "hashed",
          "lastByteIndex"
        ];
        for (H = 0; H < y.length; ++H)
          D[y[H]] = this[y[H]];
        for (H = 0; H < this.blocks.length; ++H)
          D.blocks[H] = this.blocks[H];
      };
      function W(D, H, y) {
        var S, _ = typeof D;
        if (_ !== "string") {
          if (_ === "object") {
            if (D === null)
              throw new Error(e);
            if (l && D.constructor === ArrayBuffer)
              D = new Uint8Array(D);
            else if (!Array.isArray(D) && (!l || !ArrayBuffer.isView(D)))
              throw new Error(e);
          } else
            throw new Error(e);
          S = !0;
        }
        var F = D.length;
        if (!S) {
          for (var M = [], F = D.length, j = 0, Y, N = 0; N < F; ++N)
            Y = D.charCodeAt(N), Y < 128 ? M[j++] = Y : Y < 2048 ? (M[j++] = 192 | Y >> 6, M[j++] = 128 | Y & 63) : Y < 55296 || Y >= 57344 ? (M[j++] = 224 | Y >> 12, M[j++] = 128 | Y >> 6 & 63, M[j++] = 128 | Y & 63) : (Y = 65536 + ((Y & 1023) << 10 | D.charCodeAt(++N) & 1023), M[j++] = 240 | Y >> 18, M[j++] = 128 | Y >> 12 & 63, M[j++] = 128 | Y >> 6 & 63, M[j++] = 128 | Y & 63);
          D = M;
        }
        D.length > 128 && (D = new C(H, !0).update(D).array());
        for (var O = [], G = [], N = 0; N < 128; ++N) {
          var Q = D[N] || 0;
          O[N] = 92 ^ Q, G[N] = 54 ^ Q;
        }
        C.call(this, H, y), this.update(G), this.oKeyPad = O, this.inner = !0, this.sharedMemory = y;
      }
      W.prototype = new C(), W.prototype.finalize = function() {
        if (C.prototype.finalize.call(this), this.inner) {
          this.inner = !1;
          var D = this.array();
          C.call(this, this.bits, this.sharedMemory), this.update(this.oKeyPad), this.update(D), C.prototype.finalize.call(this);
        }
      }, W.prototype.clone = function() {
        var D = new W([], this.bits, !1);
        this.copyTo(D), D.inner = this.inner;
        for (var H = 0; H < this.oKeyPad.length; ++H)
          D.oKeyPad[H] = this.oKeyPad[H];
        return D;
      };
      var Z = g(512);
      Z.sha512 = Z, Z.sha384 = g(384), Z.sha512_256 = g(256), Z.sha512_224 = g(224), Z.sha512.hmac = v(512), Z.sha384.hmac = v(384), Z.sha512_256.hmac = v(256), Z.sha512_224.hmac = v(224), s ? r.exports = Z : (a.sha512 = Z.sha512, a.sha384 = Z.sha384, a.sha512_256 = Z.sha512_256, a.sha512_224 = Z.sha512_224);
    })();
  }($f)), $f.exports;
}
var sb = ib();
const cb = /* @__PURE__ */ Bi(sb);
var hs = { exports: {} }, Ff = { exports: {} }, O1 = { exports: {} }, lb = O1.exports, zf;
function v5() {
  return zf || (zf = 1, function(r) {
    (function(e) {
      var t, n = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, a = Math.ceil, o = Math.floor, i = "[BigNumber Error] ", s = i + "Number primitive has more than 15 significant digits: ", l = 1e14, c = 14, u = 9007199254740991, d = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], w = 1e7, f = 1e9;
      function A(D) {
        var H, y, S, _ = B.prototype = { constructor: B, toString: null, valueOf: null }, F = new B(1), M = 20, j = 4, Y = -7, N = 21, O = -1e7, G = 1e7, Q = !1, ie = 1, fe = 0, pe = {
          prefix: "",
          groupSize: 3,
          secondaryGroupSize: 0,
          groupSeparator: ",",
          decimalSeparator: ".",
          fractionGroupSize: 0,
          fractionGroupSeparator: " ",
          // non-breaking space
          suffix: ""
        }, ye = "0123456789abcdefghijklmnopqrstuvwxyz", te = !0;
        function B(h, m) {
          var E, $, R, P, J, I, U, K, z = this;
          if (!(z instanceof B)) return new B(h, m);
          if (m == null) {
            if (h && h._isBigNumber === !0) {
              z.s = h.s, !h.c || h.e > G ? z.c = z.e = null : h.e < O ? z.c = [z.e = 0] : (z.e = h.e, z.c = h.c.slice());
              return;
            }
            if ((I = typeof h == "number") && h * 0 == 0) {
              if (z.s = 1 / h < 0 ? (h = -h, -1) : 1, h === ~~h) {
                for (P = 0, J = h; J >= 10; J /= 10, P++) ;
                P > G ? z.c = z.e = null : (z.e = P, z.c = [h]);
                return;
              }
              K = String(h);
            } else {
              if (!n.test(K = String(h))) return S(z, K, I);
              z.s = K.charCodeAt(0) == 45 ? (K = K.slice(1), -1) : 1;
            }
            (P = K.indexOf(".")) > -1 && (K = K.replace(".", "")), (J = K.search(/e/i)) > 0 ? (P < 0 && (P = J), P += +K.slice(J + 1), K = K.substring(0, J)) : P < 0 && (P = K.length);
          } else {
            if (v(m, 2, ye.length, "Base"), m == 10 && te)
              return z = new B(h), he(z, M + z.e + 1, j);
            if (K = String(h), I = typeof h == "number") {
              if (h * 0 != 0) return S(z, K, I, m);
              if (z.s = 1 / h < 0 ? (K = K.slice(1), -1) : 1, B.DEBUG && K.replace(/^0\.0*|\./, "").length > 15)
                throw Error(s + h);
            } else
              z.s = K.charCodeAt(0) === 45 ? (K = K.slice(1), -1) : 1;
            for (E = ye.slice(0, m), P = J = 0, U = K.length; J < U; J++)
              if (E.indexOf($ = K.charAt(J)) < 0) {
                if ($ == ".") {
                  if (J > P) {
                    P = U;
                    continue;
                  }
                } else if (!R && (K == K.toUpperCase() && (K = K.toLowerCase()) || K == K.toLowerCase() && (K = K.toUpperCase()))) {
                  R = !0, J = -1, P = 0;
                  continue;
                }
                return S(z, String(h), I, m);
              }
            I = !1, K = y(K, m, 10, z.s), (P = K.indexOf(".")) > -1 ? K = K.replace(".", "") : P = K.length;
          }
          for (J = 0; K.charCodeAt(J) === 48; J++) ;
          for (U = K.length; K.charCodeAt(--U) === 48; ) ;
          if (K = K.slice(J, ++U)) {
            if (U -= J, I && B.DEBUG && U > 15 && (h > u || h !== o(h)))
              throw Error(s + z.s * h);
            if ((P = P - J - 1) > G)
              z.c = z.e = null;
            else if (P < O)
              z.c = [z.e = 0];
            else {
              if (z.e = P, z.c = [], J = (P + 1) % c, P < 0 && (J += c), J < U) {
                for (J && z.c.push(+K.slice(0, J)), U -= c; J < U; )
                  z.c.push(+K.slice(J, J += c));
                J = c - (K = K.slice(J)).length;
              } else
                J -= U;
              for (; J--; K += "0") ;
              z.c.push(+K);
            }
          } else
            z.c = [z.e = 0];
        }
        B.clone = A, B.ROUND_UP = 0, B.ROUND_DOWN = 1, B.ROUND_CEIL = 2, B.ROUND_FLOOR = 3, B.ROUND_HALF_UP = 4, B.ROUND_HALF_DOWN = 5, B.ROUND_HALF_EVEN = 6, B.ROUND_HALF_CEIL = 7, B.ROUND_HALF_FLOOR = 8, B.EUCLID = 9, B.config = B.set = function(h) {
          var m, E;
          if (h != null)
            if (typeof h == "object") {
              if (h.hasOwnProperty(m = "DECIMAL_PLACES") && (E = h[m], v(E, 0, f, m), M = E), h.hasOwnProperty(m = "ROUNDING_MODE") && (E = h[m], v(E, 0, 8, m), j = E), h.hasOwnProperty(m = "EXPONENTIAL_AT") && (E = h[m], E && E.pop ? (v(E[0], -1e9, 0, m), v(E[1], 0, f, m), Y = E[0], N = E[1]) : (v(E, -1e9, f, m), Y = -(N = E < 0 ? -E : E))), h.hasOwnProperty(m = "RANGE"))
                if (E = h[m], E && E.pop)
                  v(E[0], -1e9, -1, m), v(E[1], 1, f, m), O = E[0], G = E[1];
                else if (v(E, -1e9, f, m), E)
                  O = -(G = E < 0 ? -E : E);
                else
                  throw Error(i + m + " cannot be zero: " + E);
              if (h.hasOwnProperty(m = "CRYPTO"))
                if (E = h[m], E === !!E)
                  if (E)
                    if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                      Q = E;
                    else
                      throw Q = !E, Error(i + "crypto unavailable");
                  else
                    Q = E;
                else
                  throw Error(i + m + " not true or false: " + E);
              if (h.hasOwnProperty(m = "MODULO_MODE") && (E = h[m], v(E, 0, 9, m), ie = E), h.hasOwnProperty(m = "POW_PRECISION") && (E = h[m], v(E, 0, f, m), fe = E), h.hasOwnProperty(m = "FORMAT"))
                if (E = h[m], typeof E == "object") pe = E;
                else throw Error(i + m + " not an object: " + E);
              if (h.hasOwnProperty(m = "ALPHABET"))
                if (E = h[m], typeof E == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(E))
                  te = E.slice(0, 10) == "0123456789", ye = E;
                else
                  throw Error(i + m + " invalid: " + E);
            } else
              throw Error(i + "Object expected: " + h);
          return {
            DECIMAL_PLACES: M,
            ROUNDING_MODE: j,
            EXPONENTIAL_AT: [Y, N],
            RANGE: [O, G],
            CRYPTO: Q,
            MODULO_MODE: ie,
            POW_PRECISION: fe,
            FORMAT: pe,
            ALPHABET: ye
          };
        }, B.isBigNumber = function(h) {
          if (!h || h._isBigNumber !== !0) return !1;
          if (!B.DEBUG) return !0;
          var m, E, $ = h.c, R = h.e, P = h.s;
          e: if ({}.toString.call($) == "[object Array]") {
            if ((P === 1 || P === -1) && R >= -1e9 && R <= f && R === o(R)) {
              if ($[0] === 0) {
                if (R === 0 && $.length === 1) return !0;
                break e;
              }
              if (m = (R + 1) % c, m < 1 && (m += c), String($[0]).length == m) {
                for (m = 0; m < $.length; m++)
                  if (E = $[m], E < 0 || E >= l || E !== o(E)) break e;
                if (E !== 0) return !0;
              }
            }
          } else if ($ === null && R === null && (P === null || P === 1 || P === -1))
            return !0;
          throw Error(i + "Invalid BigNumber: " + h);
        }, B.maximum = B.max = function() {
          return ce(arguments, -1);
        }, B.minimum = B.min = function() {
          return ce(arguments, 1);
        }, B.random = function() {
          var h = 9007199254740992, m = Math.random() * h & 2097151 ? function() {
            return o(Math.random() * h);
          } : function() {
            return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
          };
          return function(E) {
            var $, R, P, J, I, U = 0, K = [], z = new B(F);
            if (E == null ? E = M : v(E, 0, f), J = a(E / c), Q)
              if (crypto.getRandomValues) {
                for ($ = crypto.getRandomValues(new Uint32Array(J *= 2)); U < J; )
                  I = $[U] * 131072 + ($[U + 1] >>> 11), I >= 9e15 ? (R = crypto.getRandomValues(new Uint32Array(2)), $[U] = R[0], $[U + 1] = R[1]) : (K.push(I % 1e14), U += 2);
                U = J / 2;
              } else if (crypto.randomBytes) {
                for ($ = crypto.randomBytes(J *= 7); U < J; )
                  I = ($[U] & 31) * 281474976710656 + $[U + 1] * 1099511627776 + $[U + 2] * 4294967296 + $[U + 3] * 16777216 + ($[U + 4] << 16) + ($[U + 5] << 8) + $[U + 6], I >= 9e15 ? crypto.randomBytes(7).copy($, U) : (K.push(I % 1e14), U += 7);
                U = J / 7;
              } else
                throw Q = !1, Error(i + "crypto unavailable");
            if (!Q)
              for (; U < J; )
                I = m(), I < 9e15 && (K[U++] = I % 1e14);
            for (J = K[--U], E %= c, J && E && (I = d[c - E], K[U] = o(J / I) * I); K[U] === 0; K.pop(), U--) ;
            if (U < 0)
              K = [P = 0];
            else {
              for (P = -1; K[0] === 0; K.splice(0, 1), P -= c) ;
              for (U = 1, I = K[0]; I >= 10; I /= 10, U++) ;
              U < c && (P -= c - U);
            }
            return z.e = P, z.c = K, z;
          };
        }(), B.sum = function() {
          for (var h = 1, m = arguments, E = new B(m[0]); h < m.length; ) E = E.plus(m[h++]);
          return E;
        }, y = /* @__PURE__ */ function() {
          var h = "0123456789";
          function m(E, $, R, P) {
            for (var J, I = [0], U, K = 0, z = E.length; K < z; ) {
              for (U = I.length; U--; I[U] *= $) ;
              for (I[0] += P.indexOf(E.charAt(K++)), J = 0; J < I.length; J++)
                I[J] > R - 1 && (I[J + 1] == null && (I[J + 1] = 0), I[J + 1] += I[J] / R | 0, I[J] %= R);
            }
            return I.reverse();
          }
          return function(E, $, R, P, J) {
            var I, U, K, z, re, le, ee, Se, Re = E.indexOf("."), Ne = M, Ie = j;
            for (Re >= 0 && (z = fe, fe = 0, E = E.replace(".", ""), Se = new B($), le = Se.pow(E.length - Re), fe = z, Se.c = m(
              Z(g(le.c), le.e, "0"),
              10,
              R,
              h
            ), Se.e = Se.c.length), ee = m(E, $, R, J ? (I = ye, h) : (I = h, ye)), K = z = ee.length; ee[--z] == 0; ee.pop()) ;
            if (!ee[0]) return I.charAt(0);
            if (Re < 0 ? --K : (le.c = ee, le.e = K, le.s = P, le = H(le, Se, Ne, Ie, R), ee = le.c, re = le.r, K = le.e), U = K + Ne + 1, Re = ee[U], z = R / 2, re = re || U < 0 || ee[U + 1] != null, re = Ie < 4 ? (Re != null || re) && (Ie == 0 || Ie == (le.s < 0 ? 3 : 2)) : Re > z || Re == z && (Ie == 4 || re || Ie == 6 && ee[U - 1] & 1 || Ie == (le.s < 0 ? 8 : 7)), U < 1 || !ee[0])
              E = re ? Z(I.charAt(1), -Ne, I.charAt(0)) : I.charAt(0);
            else {
              if (ee.length = U, re)
                for (--R; ++ee[--U] > R; )
                  ee[U] = 0, U || (++K, ee = [1].concat(ee));
              for (z = ee.length; !ee[--z]; ) ;
              for (Re = 0, E = ""; Re <= z; E += I.charAt(ee[Re++])) ;
              E = Z(E, K, I.charAt(0));
            }
            return E;
          };
        }(), H = /* @__PURE__ */ function() {
          function h($, R, P) {
            var J, I, U, K, z = 0, re = $.length, le = R % w, ee = R / w | 0;
            for ($ = $.slice(); re--; )
              U = $[re] % w, K = $[re] / w | 0, J = ee * U + K * le, I = le * U + J % w * w + z, z = (I / P | 0) + (J / w | 0) + ee * K, $[re] = I % P;
            return z && ($ = [z].concat($)), $;
          }
          function m($, R, P, J) {
            var I, U;
            if (P != J)
              U = P > J ? 1 : -1;
            else
              for (I = U = 0; I < P; I++)
                if ($[I] != R[I]) {
                  U = $[I] > R[I] ? 1 : -1;
                  break;
                }
            return U;
          }
          function E($, R, P, J) {
            for (var I = 0; P--; )
              $[P] -= I, I = $[P] < R[P] ? 1 : 0, $[P] = I * J + $[P] - R[P];
            for (; !$[0] && $.length > 1; $.splice(0, 1)) ;
          }
          return function($, R, P, J, I) {
            var U, K, z, re, le, ee, Se, Re, Ne, Ie, De, Fe, lt, ft, it, Ue, nt, He = $.s == R.s ? 1 : -1, ze = $.c, Be = R.c;
            if (!ze || !ze[0] || !Be || !Be[0])
              return new B(
                // Return NaN if either NaN, or both Infinity or 0.
                !$.s || !R.s || (ze ? Be && ze[0] == Be[0] : !Be) ? NaN : (
                  // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                  ze && ze[0] == 0 || !Be ? He * 0 : He / 0
                )
              );
            for (Re = new B(He), Ne = Re.c = [], K = $.e - R.e, He = P + K + 1, I || (I = l, K = b($.e / c) - b(R.e / c), He = He / c | 0), z = 0; Be[z] == (ze[z] || 0); z++) ;
            if (Be[z] > (ze[z] || 0) && K--, He < 0)
              Ne.push(1), re = !0;
            else {
              for (ft = ze.length, Ue = Be.length, z = 0, He += 2, le = o(I / (Be[0] + 1)), le > 1 && (Be = h(Be, le, I), ze = h(ze, le, I), Ue = Be.length, ft = ze.length), lt = Ue, Ie = ze.slice(0, Ue), De = Ie.length; De < Ue; Ie[De++] = 0) ;
              nt = Be.slice(), nt = [0].concat(nt), it = Be[0], Be[1] >= I / 2 && it++;
              do {
                if (le = 0, U = m(Be, Ie, Ue, De), U < 0) {
                  if (Fe = Ie[0], Ue != De && (Fe = Fe * I + (Ie[1] || 0)), le = o(Fe / it), le > 1)
                    for (le >= I && (le = I - 1), ee = h(Be, le, I), Se = ee.length, De = Ie.length; m(ee, Ie, Se, De) == 1; )
                      le--, E(ee, Ue < Se ? nt : Be, Se, I), Se = ee.length, U = 1;
                  else
                    le == 0 && (U = le = 1), ee = Be.slice(), Se = ee.length;
                  if (Se < De && (ee = [0].concat(ee)), E(Ie, ee, De, I), De = Ie.length, U == -1)
                    for (; m(Be, Ie, Ue, De) < 1; )
                      le++, E(Ie, Ue < De ? nt : Be, De, I), De = Ie.length;
                } else U === 0 && (le++, Ie = [0]);
                Ne[z++] = le, Ie[0] ? Ie[De++] = ze[lt] || 0 : (Ie = [ze[lt]], De = 1);
              } while ((lt++ < ft || Ie[0] != null) && He--);
              re = Ie[0] != null, Ne[0] || Ne.splice(0, 1);
            }
            if (I == l) {
              for (z = 1, He = Ne[0]; He >= 10; He /= 10, z++) ;
              he(Re, P + (Re.e = z + K * c - 1) + 1, J, re);
            } else
              Re.e = K, Re.r = +re;
            return Re;
          };
        }();
        function oe(h, m, E, $) {
          var R, P, J, I, U;
          if (E == null ? E = j : v(E, 0, 8), !h.c) return h.toString();
          if (R = h.c[0], J = h.e, m == null)
            U = g(h.c), U = $ == 1 || $ == 2 && (J <= Y || J >= N) ? W(U, J) : Z(U, J, "0");
          else if (h = he(new B(h), m, E), P = h.e, U = g(h.c), I = U.length, $ == 1 || $ == 2 && (m <= P || P <= Y)) {
            for (; I < m; U += "0", I++) ;
            U = W(U, P);
          } else if (m -= J + ($ === 2 && P > J), U = Z(U, P, "0"), P + 1 > I) {
            if (--m > 0) for (U += "."; m--; U += "0") ;
          } else if (m += P - I, m > 0)
            for (P + 1 == I && (U += "."); m--; U += "0") ;
          return h.s < 0 && R ? "-" + U : U;
        }
        function ce(h, m) {
          for (var E, $, R = 1, P = new B(h[0]); R < h.length; R++)
            $ = new B(h[R]), (!$.s || (E = k(P, $)) === m || E === 0 && P.s === m) && (P = $);
          return P;
        }
        function Ce(h, m, E) {
          for (var $ = 1, R = m.length; !m[--R]; m.pop()) ;
          for (R = m[0]; R >= 10; R /= 10, $++) ;
          return (E = $ + E * c - 1) > G ? h.c = h.e = null : E < O ? h.c = [h.e = 0] : (h.e = E, h.c = m), h;
        }
        S = /* @__PURE__ */ function() {
          var h = /^(-?)0([xbo])(?=\w[\w.]*$)/i, m = /^([^.]+)\.$/, E = /^\.([^.]+)$/, $ = /^-?(Infinity|NaN)$/, R = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
          return function(P, J, I, U) {
            var K, z = I ? J : J.replace(R, "");
            if ($.test(z))
              P.s = isNaN(z) ? null : z < 0 ? -1 : 1;
            else {
              if (!I && (z = z.replace(h, function(re, le, ee) {
                return K = (ee = ee.toLowerCase()) == "x" ? 16 : ee == "b" ? 2 : 8, !U || U == K ? le : re;
              }), U && (K = U, z = z.replace(m, "$1").replace(E, "0.$1")), J != z))
                return new B(z, K);
              if (B.DEBUG)
                throw Error(i + "Not a" + (U ? " base " + U : "") + " number: " + J);
              P.s = null;
            }
            P.c = P.e = null;
          };
        }();
        function he(h, m, E, $) {
          var R, P, J, I, U, K, z, re = h.c, le = d;
          if (re) {
            e: {
              for (R = 1, I = re[0]; I >= 10; I /= 10, R++) ;
              if (P = m - R, P < 0)
                P += c, J = m, U = re[K = 0], z = o(U / le[R - J - 1] % 10);
              else if (K = a((P + 1) / c), K >= re.length)
                if ($) {
                  for (; re.length <= K; re.push(0)) ;
                  U = z = 0, R = 1, P %= c, J = P - c + 1;
                } else
                  break e;
              else {
                for (U = I = re[K], R = 1; I >= 10; I /= 10, R++) ;
                P %= c, J = P - c + R, z = J < 0 ? 0 : o(U / le[R - J - 1] % 10);
              }
              if ($ = $ || m < 0 || // Are there any non-zero digits after the rounding digit?
              // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
              // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
              re[K + 1] != null || (J < 0 ? U : U % le[R - J - 1]), $ = E < 4 ? (z || $) && (E == 0 || E == (h.s < 0 ? 3 : 2)) : z > 5 || z == 5 && (E == 4 || $ || E == 6 && // Check whether the digit to the left of the rounding digit is odd.
              (P > 0 ? J > 0 ? U / le[R - J] : 0 : re[K - 1]) % 10 & 1 || E == (h.s < 0 ? 8 : 7)), m < 1 || !re[0])
                return re.length = 0, $ ? (m -= h.e + 1, re[0] = le[(c - m % c) % c], h.e = -m || 0) : re[0] = h.e = 0, h;
              if (P == 0 ? (re.length = K, I = 1, K--) : (re.length = K + 1, I = le[c - P], re[K] = J > 0 ? o(U / le[R - J] % le[J]) * I : 0), $)
                for (; ; )
                  if (K == 0) {
                    for (P = 1, J = re[0]; J >= 10; J /= 10, P++) ;
                    for (J = re[0] += I, I = 1; J >= 10; J /= 10, I++) ;
                    P != I && (h.e++, re[0] == l && (re[0] = 1));
                    break;
                  } else {
                    if (re[K] += I, re[K] != l) break;
                    re[K--] = 0, I = 1;
                  }
              for (P = re.length; re[--P] === 0; re.pop()) ;
            }
            h.e > G ? h.c = h.e = null : h.e < O && (h.c = [h.e = 0]);
          }
          return h;
        }
        function ge(h) {
          var m, E = h.e;
          return E === null ? h.toString() : (m = g(h.c), m = E <= Y || E >= N ? W(m, E) : Z(m, E, "0"), h.s < 0 ? "-" + m : m);
        }
        return _.absoluteValue = _.abs = function() {
          var h = new B(this);
          return h.s < 0 && (h.s = 1), h;
        }, _.comparedTo = function(h, m) {
          return k(this, new B(h, m));
        }, _.decimalPlaces = _.dp = function(h, m) {
          var E, $, R, P = this;
          if (h != null)
            return v(h, 0, f), m == null ? m = j : v(m, 0, 8), he(new B(P), h + P.e + 1, m);
          if (!(E = P.c)) return null;
          if ($ = ((R = E.length - 1) - b(this.e / c)) * c, R = E[R]) for (; R % 10 == 0; R /= 10, $--) ;
          return $ < 0 && ($ = 0), $;
        }, _.dividedBy = _.div = function(h, m) {
          return H(this, new B(h, m), M, j);
        }, _.dividedToIntegerBy = _.idiv = function(h, m) {
          return H(this, new B(h, m), 0, 1);
        }, _.exponentiatedBy = _.pow = function(h, m) {
          var E, $, R, P, J, I, U, K, z, re = this;
          if (h = new B(h), h.c && !h.isInteger())
            throw Error(i + "Exponent not an integer: " + ge(h));
          if (m != null && (m = new B(m)), I = h.e > 14, !re.c || !re.c[0] || re.c[0] == 1 && !re.e && re.c.length == 1 || !h.c || !h.c[0])
            return z = new B(Math.pow(+ge(re), I ? h.s * (2 - C(h)) : +ge(h))), m ? z.mod(m) : z;
          if (U = h.s < 0, m) {
            if (m.c ? !m.c[0] : !m.s) return new B(NaN);
            $ = !U && re.isInteger() && m.isInteger(), $ && (re = re.mod(m));
          } else {
            if (h.e > 9 && (re.e > 0 || re.e < -1 || (re.e == 0 ? re.c[0] > 1 || I && re.c[1] >= 24e7 : re.c[0] < 8e13 || I && re.c[0] <= 9999975e7)))
              return P = re.s < 0 && C(h) ? -0 : 0, re.e > -1 && (P = 1 / P), new B(U ? 1 / P : P);
            fe && (P = a(fe / c + 2));
          }
          for (I ? (E = new B(0.5), U && (h.s = 1), K = C(h)) : (R = Math.abs(+ge(h)), K = R % 2), z = new B(F); ; ) {
            if (K) {
              if (z = z.times(re), !z.c) break;
              P ? z.c.length > P && (z.c.length = P) : $ && (z = z.mod(m));
            }
            if (R) {
              if (R = o(R / 2), R === 0) break;
              K = R % 2;
            } else if (h = h.times(E), he(h, h.e + 1, 1), h.e > 14)
              K = C(h);
            else {
              if (R = +ge(h), R === 0) break;
              K = R % 2;
            }
            re = re.times(re), P ? re.c && re.c.length > P && (re.c.length = P) : $ && (re = re.mod(m));
          }
          return $ ? z : (U && (z = F.div(z)), m ? z.mod(m) : P ? he(z, fe, j, J) : z);
        }, _.integerValue = function(h) {
          var m = new B(this);
          return h == null ? h = j : v(h, 0, 8), he(m, m.e + 1, h);
        }, _.isEqualTo = _.eq = function(h, m) {
          return k(this, new B(h, m)) === 0;
        }, _.isFinite = function() {
          return !!this.c;
        }, _.isGreaterThan = _.gt = function(h, m) {
          return k(this, new B(h, m)) > 0;
        }, _.isGreaterThanOrEqualTo = _.gte = function(h, m) {
          return (m = k(this, new B(h, m))) === 1 || m === 0;
        }, _.isInteger = function() {
          return !!this.c && b(this.e / c) > this.c.length - 2;
        }, _.isLessThan = _.lt = function(h, m) {
          return k(this, new B(h, m)) < 0;
        }, _.isLessThanOrEqualTo = _.lte = function(h, m) {
          return (m = k(this, new B(h, m))) === -1 || m === 0;
        }, _.isNaN = function() {
          return !this.s;
        }, _.isNegative = function() {
          return this.s < 0;
        }, _.isPositive = function() {
          return this.s > 0;
        }, _.isZero = function() {
          return !!this.c && this.c[0] == 0;
        }, _.minus = function(h, m) {
          var E, $, R, P, J = this, I = J.s;
          if (h = new B(h, m), m = h.s, !I || !m) return new B(NaN);
          if (I != m)
            return h.s = -m, J.plus(h);
          var U = J.e / c, K = h.e / c, z = J.c, re = h.c;
          if (!U || !K) {
            if (!z || !re) return z ? (h.s = -m, h) : new B(re ? J : NaN);
            if (!z[0] || !re[0])
              return re[0] ? (h.s = -m, h) : new B(z[0] ? J : (
                // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                j == 3 ? -0 : 0
              ));
          }
          if (U = b(U), K = b(K), z = z.slice(), I = U - K) {
            for ((P = I < 0) ? (I = -I, R = z) : (K = U, R = re), R.reverse(), m = I; m--; R.push(0)) ;
            R.reverse();
          } else
            for ($ = (P = (I = z.length) < (m = re.length)) ? I : m, I = m = 0; m < $; m++)
              if (z[m] != re[m]) {
                P = z[m] < re[m];
                break;
              }
          if (P && (R = z, z = re, re = R, h.s = -h.s), m = ($ = re.length) - (E = z.length), m > 0) for (; m--; z[E++] = 0) ;
          for (m = l - 1; $ > I; ) {
            if (z[--$] < re[$]) {
              for (E = $; E && !z[--E]; z[E] = m) ;
              --z[E], z[$] += l;
            }
            z[$] -= re[$];
          }
          for (; z[0] == 0; z.splice(0, 1), --K) ;
          return z[0] ? Ce(h, z, K) : (h.s = j == 3 ? -1 : 1, h.c = [h.e = 0], h);
        }, _.modulo = _.mod = function(h, m) {
          var E, $, R = this;
          return h = new B(h, m), !R.c || !h.s || h.c && !h.c[0] ? new B(NaN) : !h.c || R.c && !R.c[0] ? new B(R) : (ie == 9 ? ($ = h.s, h.s = 1, E = H(R, h, 0, 3), h.s = $, E.s *= $) : E = H(R, h, 0, ie), h = R.minus(E.times(h)), !h.c[0] && ie == 1 && (h.s = R.s), h);
        }, _.multipliedBy = _.times = function(h, m) {
          var E, $, R, P, J, I, U, K, z, re, le, ee, Se, Re, Ne, Ie = this, De = Ie.c, Fe = (h = new B(h, m)).c;
          if (!De || !Fe || !De[0] || !Fe[0])
            return !Ie.s || !h.s || De && !De[0] && !Fe || Fe && !Fe[0] && !De ? h.c = h.e = h.s = null : (h.s *= Ie.s, !De || !Fe ? h.c = h.e = null : (h.c = [0], h.e = 0)), h;
          for ($ = b(Ie.e / c) + b(h.e / c), h.s *= Ie.s, U = De.length, re = Fe.length, U < re && (Se = De, De = Fe, Fe = Se, R = U, U = re, re = R), R = U + re, Se = []; R--; Se.push(0)) ;
          for (Re = l, Ne = w, R = re; --R >= 0; ) {
            for (E = 0, le = Fe[R] % Ne, ee = Fe[R] / Ne | 0, J = U, P = R + J; P > R; )
              K = De[--J] % Ne, z = De[J] / Ne | 0, I = ee * K + z * le, K = le * K + I % Ne * Ne + Se[P] + E, E = (K / Re | 0) + (I / Ne | 0) + ee * z, Se[P--] = K % Re;
            Se[P] = E;
          }
          return E ? ++$ : Se.splice(0, 1), Ce(h, Se, $);
        }, _.negated = function() {
          var h = new B(this);
          return h.s = -h.s || null, h;
        }, _.plus = function(h, m) {
          var E, $ = this, R = $.s;
          if (h = new B(h, m), m = h.s, !R || !m) return new B(NaN);
          if (R != m)
            return h.s = -m, $.minus(h);
          var P = $.e / c, J = h.e / c, I = $.c, U = h.c;
          if (!P || !J) {
            if (!I || !U) return new B(R / 0);
            if (!I[0] || !U[0]) return U[0] ? h : new B(I[0] ? $ : R * 0);
          }
          if (P = b(P), J = b(J), I = I.slice(), R = P - J) {
            for (R > 0 ? (J = P, E = U) : (R = -R, E = I), E.reverse(); R--; E.push(0)) ;
            E.reverse();
          }
          for (R = I.length, m = U.length, R - m < 0 && (E = U, U = I, I = E, m = R), R = 0; m; )
            R = (I[--m] = I[m] + U[m] + R) / l | 0, I[m] = l === I[m] ? 0 : I[m] % l;
          return R && (I = [R].concat(I), ++J), Ce(h, I, J);
        }, _.precision = _.sd = function(h, m) {
          var E, $, R, P = this;
          if (h != null && h !== !!h)
            return v(h, 1, f), m == null ? m = j : v(m, 0, 8), he(new B(P), h, m);
          if (!(E = P.c)) return null;
          if (R = E.length - 1, $ = R * c + 1, R = E[R]) {
            for (; R % 10 == 0; R /= 10, $--) ;
            for (R = E[0]; R >= 10; R /= 10, $++) ;
          }
          return h && P.e + 1 > $ && ($ = P.e + 1), $;
        }, _.shiftedBy = function(h) {
          return v(h, -9007199254740991, u), this.times("1e" + h);
        }, _.squareRoot = _.sqrt = function() {
          var h, m, E, $, R, P = this, J = P.c, I = P.s, U = P.e, K = M + 4, z = new B("0.5");
          if (I !== 1 || !J || !J[0])
            return new B(!I || I < 0 && (!J || J[0]) ? NaN : J ? P : 1 / 0);
          if (I = Math.sqrt(+ge(P)), I == 0 || I == 1 / 0 ? (m = g(J), (m.length + U) % 2 == 0 && (m += "0"), I = Math.sqrt(+m), U = b((U + 1) / 2) - (U < 0 || U % 2), I == 1 / 0 ? m = "5e" + U : (m = I.toExponential(), m = m.slice(0, m.indexOf("e") + 1) + U), E = new B(m)) : E = new B(I + ""), E.c[0]) {
            for (U = E.e, I = U + K, I < 3 && (I = 0); ; )
              if (R = E, E = z.times(R.plus(H(P, R, K, 1))), g(R.c).slice(0, I) === (m = g(E.c)).slice(0, I))
                if (E.e < U && --I, m = m.slice(I - 3, I + 1), m == "9999" || !$ && m == "4999") {
                  if (!$ && (he(R, R.e + M + 2, 0), R.times(R).eq(P))) {
                    E = R;
                    break;
                  }
                  K += 4, I += 4, $ = 1;
                } else {
                  (!+m || !+m.slice(1) && m.charAt(0) == "5") && (he(E, E.e + M + 2, 1), h = !E.times(E).eq(P));
                  break;
                }
          }
          return he(E, E.e + M + 1, j, h);
        }, _.toExponential = function(h, m) {
          return h != null && (v(h, 0, f), h++), oe(this, h, m, 1);
        }, _.toFixed = function(h, m) {
          return h != null && (v(h, 0, f), h = h + this.e + 1), oe(this, h, m);
        }, _.toFormat = function(h, m, E) {
          var $, R = this;
          if (E == null)
            h != null && m && typeof m == "object" ? (E = m, m = null) : h && typeof h == "object" ? (E = h, h = m = null) : E = pe;
          else if (typeof E != "object")
            throw Error(i + "Argument not an object: " + E);
          if ($ = R.toFixed(h, m), R.c) {
            var P, J = $.split("."), I = +E.groupSize, U = +E.secondaryGroupSize, K = E.groupSeparator || "", z = J[0], re = J[1], le = R.s < 0, ee = le ? z.slice(1) : z, Se = ee.length;
            if (U && (P = I, I = U, U = P, Se -= P), I > 0 && Se > 0) {
              for (P = Se % I || I, z = ee.substr(0, P); P < Se; P += I) z += K + ee.substr(P, I);
              U > 0 && (z += K + ee.slice(P)), le && (z = "-" + z);
            }
            $ = re ? z + (E.decimalSeparator || "") + ((U = +E.fractionGroupSize) ? re.replace(
              new RegExp("\\d{" + U + "}\\B", "g"),
              "$&" + (E.fractionGroupSeparator || "")
            ) : re) : z;
          }
          return (E.prefix || "") + $ + (E.suffix || "");
        }, _.toFraction = function(h) {
          var m, E, $, R, P, J, I, U, K, z, re, le, ee = this, Se = ee.c;
          if (h != null && (I = new B(h), !I.isInteger() && (I.c || I.s !== 1) || I.lt(F)))
            throw Error(i + "Argument " + (I.isInteger() ? "out of range: " : "not an integer: ") + ge(I));
          if (!Se) return new B(ee);
          for (m = new B(F), K = E = new B(F), $ = U = new B(F), le = g(Se), P = m.e = le.length - ee.e - 1, m.c[0] = d[(J = P % c) < 0 ? c + J : J], h = !h || I.comparedTo(m) > 0 ? P > 0 ? m : K : I, J = G, G = 1 / 0, I = new B(le), U.c[0] = 0; z = H(I, m, 0, 1), R = E.plus(z.times($)), R.comparedTo(h) != 1; )
            E = $, $ = R, K = U.plus(z.times(R = K)), U = R, m = I.minus(z.times(R = m)), I = R;
          return R = H(h.minus(E), $, 0, 1), U = U.plus(R.times(K)), E = E.plus(R.times($)), U.s = K.s = ee.s, P = P * 2, re = H(K, $, P, j).minus(ee).abs().comparedTo(
            H(U, E, P, j).minus(ee).abs()
          ) < 1 ? [K, $] : [U, E], G = J, re;
        }, _.toNumber = function() {
          return +ge(this);
        }, _.toPrecision = function(h, m) {
          return h != null && v(h, 1, f), oe(this, h, m, 2);
        }, _.toString = function(h) {
          var m, E = this, $ = E.s, R = E.e;
          return R === null ? $ ? (m = "Infinity", $ < 0 && (m = "-" + m)) : m = "NaN" : (h == null ? m = R <= Y || R >= N ? W(g(E.c), R) : Z(g(E.c), R, "0") : h === 10 && te ? (E = he(new B(E), M + R + 1, j), m = Z(g(E.c), E.e, "0")) : (v(h, 2, ye.length, "Base"), m = y(Z(g(E.c), R, "0"), 10, h, $, !0)), $ < 0 && E.c[0] && (m = "-" + m)), m;
        }, _.valueOf = _.toJSON = function() {
          return ge(this);
        }, _._isBigNumber = !0, D != null && B.set(D), B;
      }
      function b(D) {
        var H = D | 0;
        return D > 0 || D === H ? H : H - 1;
      }
      function g(D) {
        for (var H, y, S = 1, _ = D.length, F = D[0] + ""; S < _; ) {
          for (H = D[S++] + "", y = c - H.length; y--; H = "0" + H) ;
          F += H;
        }
        for (_ = F.length; F.charCodeAt(--_) === 48; ) ;
        return F.slice(0, _ + 1 || 1);
      }
      function k(D, H) {
        var y, S, _ = D.c, F = H.c, M = D.s, j = H.s, Y = D.e, N = H.e;
        if (!M || !j) return null;
        if (y = _ && !_[0], S = F && !F[0], y || S) return y ? S ? 0 : -j : M;
        if (M != j) return M;
        if (y = M < 0, S = Y == N, !_ || !F) return S ? 0 : !_ ^ y ? 1 : -1;
        if (!S) return Y > N ^ y ? 1 : -1;
        for (j = (Y = _.length) < (N = F.length) ? Y : N, M = 0; M < j; M++) if (_[M] != F[M]) return _[M] > F[M] ^ y ? 1 : -1;
        return Y == N ? 0 : Y > N ^ y ? 1 : -1;
      }
      function v(D, H, y, S) {
        if (D < H || D > y || D !== o(D))
          throw Error(i + (S || "Argument") + (typeof D == "number" ? D < H || D > y ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(D));
      }
      function C(D) {
        var H = D.c.length - 1;
        return b(D.e / c) == H && D.c[H] % 2 != 0;
      }
      function W(D, H) {
        return (D.length > 1 ? D.charAt(0) + "." + D.slice(1) : D) + (H < 0 ? "e" : "e+") + H;
      }
      function Z(D, H, y) {
        var S, _;
        if (H < 0) {
          for (_ = y + "."; ++H; _ += y) ;
          D = _ + D;
        } else if (S = D.length, ++H > S) {
          for (_ = y, H -= S; --H; _ += y) ;
          D += _;
        } else H < S && (D = D.slice(0, H) + "." + D.slice(H));
        return D;
      }
      t = A(), t.default = t.BigNumber = t, r.exports ? r.exports = t : (e || (e = typeof self < "u" && self ? self : window), e.BigNumber = t);
    })(lb);
  }(O1)), O1.exports;
}
var Hf;
function ub() {
  return Hf || (Hf = 1, function(r) {
    var e = v5(), t = r.exports;
    (function() {
      var n = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, a, o, i = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      }, s;
      function l(u) {
        return n.lastIndex = 0, n.test(u) ? '"' + u.replace(n, function(d) {
          var w = i[d];
          return typeof w == "string" ? w : "\\u" + ("0000" + d.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + u + '"';
      }
      function c(u, d) {
        var w, f, A, b, g = a, k, v = d[u], C = v != null && (v instanceof e || e.isBigNumber(v));
        switch (v && typeof v == "object" && typeof v.toJSON == "function" && (v = v.toJSON(u)), typeof s == "function" && (v = s.call(d, u, v)), typeof v) {
          case "string":
            return C ? v : l(v);
          case "number":
            return isFinite(v) ? String(v) : "null";
          case "boolean":
          case "null":
          case "bigint":
            return String(v);
          // If the type is 'object', we might be dealing with an object or an array or
          // null.
          case "object":
            if (!v)
              return "null";
            if (a += o, k = [], Object.prototype.toString.apply(v) === "[object Array]") {
              for (b = v.length, w = 0; w < b; w += 1)
                k[w] = c(w, v) || "null";
              return A = k.length === 0 ? "[]" : a ? `[
` + a + k.join(`,
` + a) + `
` + g + "]" : "[" + k.join(",") + "]", a = g, A;
            }
            if (s && typeof s == "object")
              for (b = s.length, w = 0; w < b; w += 1)
                typeof s[w] == "string" && (f = s[w], A = c(f, v), A && k.push(l(f) + (a ? ": " : ":") + A));
            else
              Object.keys(v).forEach(function(W) {
                var Z = c(W, v);
                Z && k.push(l(W) + (a ? ": " : ":") + Z);
              });
            return A = k.length === 0 ? "{}" : a ? `{
` + a + k.join(`,
` + a) + `
` + g + "}" : "{" + k.join(",") + "}", a = g, A;
        }
      }
      typeof t.stringify != "function" && (t.stringify = function(u, d, w) {
        var f;
        if (a = "", o = "", typeof w == "number")
          for (f = 0; f < w; f += 1)
            o += " ";
        else typeof w == "string" && (o = w);
        if (s = d, d && typeof d != "function" && (typeof d != "object" || typeof d.length != "number"))
          throw new Error("JSON.stringify");
        return c("", { "": u });
      });
    })();
  }(Ff)), Ff.exports;
}
var Ju, qf;
function db() {
  if (qf) return Ju;
  qf = 1;
  var r = null;
  const e = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/, t = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;
  var n = function(a) {
    var o = {
      strict: !1,
      // not being strict means do not generate syntax errors for "duplicate key"
      storeAsString: !1,
      // toggles whether the values should be stored as BigNumber (default) or a string
      alwaysParseAsBig: !1,
      // toggles whether all numbers should be Big
      useNativeBigInt: !1,
      // toggles whether to use native BigInt instead of bignumber.js
      protoAction: "error",
      constructorAction: "error"
    };
    if (a != null) {
      if (a.strict === !0 && (o.strict = !0), a.storeAsString === !0 && (o.storeAsString = !0), o.alwaysParseAsBig = a.alwaysParseAsBig === !0 ? a.alwaysParseAsBig : !1, o.useNativeBigInt = a.useNativeBigInt === !0 ? a.useNativeBigInt : !1, typeof a.constructorAction < "u")
        if (a.constructorAction === "error" || a.constructorAction === "ignore" || a.constructorAction === "preserve")
          o.constructorAction = a.constructorAction;
        else
          throw new Error(
            `Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${a.constructorAction}`
          );
      if (typeof a.protoAction < "u")
        if (a.protoAction === "error" || a.protoAction === "ignore" || a.protoAction === "preserve")
          o.protoAction = a.protoAction;
        else
          throw new Error(
            `Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${a.protoAction}`
          );
    }
    var i, s, l = {
      '"': '"',
      "\\": "\\",
      "/": "/",
      b: "\b",
      f: "\f",
      n: `
`,
      r: "\r",
      t: "	"
    }, c, u = function(C) {
      throw {
        name: "SyntaxError",
        message: C,
        at: i,
        text: c
      };
    }, d = function(C) {
      return C && C !== s && u("Expected '" + C + "' instead of '" + s + "'"), s = c.charAt(i), i += 1, s;
    }, w = function() {
      var C, W = "";
      for (s === "-" && (W = "-", d("-")); s >= "0" && s <= "9"; )
        W += s, d();
      if (s === ".")
        for (W += "."; d() && s >= "0" && s <= "9"; )
          W += s;
      if (s === "e" || s === "E")
        for (W += s, d(), (s === "-" || s === "+") && (W += s, d()); s >= "0" && s <= "9"; )
          W += s, d();
      if (C = +W, !isFinite(C))
        u("Bad number");
      else
        return r == null && (r = v5()), W.length > 15 ? o.storeAsString ? W : o.useNativeBigInt ? BigInt(W) : new r(W) : o.alwaysParseAsBig ? o.useNativeBigInt ? BigInt(C) : new r(C) : C;
    }, f = function() {
      var C, W, Z = "", D;
      if (s === '"')
        for (var H = i; d(); ) {
          if (s === '"')
            return i - 1 > H && (Z += c.substring(H, i - 1)), d(), Z;
          if (s === "\\") {
            if (i - 1 > H && (Z += c.substring(H, i - 1)), d(), s === "u") {
              for (D = 0, W = 0; W < 4 && (C = parseInt(d(), 16), !!isFinite(C)); W += 1)
                D = D * 16 + C;
              Z += String.fromCharCode(D);
            } else if (typeof l[s] == "string")
              Z += l[s];
            else
              break;
            H = i;
          }
        }
      u("Bad string");
    }, A = function() {
      for (; s && s <= " "; )
        d();
    }, b = function() {
      switch (s) {
        case "t":
          return d("t"), d("r"), d("u"), d("e"), !0;
        case "f":
          return d("f"), d("a"), d("l"), d("s"), d("e"), !1;
        case "n":
          return d("n"), d("u"), d("l"), d("l"), null;
      }
      u("Unexpected '" + s + "'");
    }, g, k = function() {
      var C = [];
      if (s === "[") {
        if (d("["), A(), s === "]")
          return d("]"), C;
        for (; s; ) {
          if (C.push(g()), A(), s === "]")
            return d("]"), C;
          d(","), A();
        }
      }
      u("Bad array");
    }, v = function() {
      var C, W = /* @__PURE__ */ Object.create(null);
      if (s === "{") {
        if (d("{"), A(), s === "}")
          return d("}"), W;
        for (; s; ) {
          if (C = f(), A(), d(":"), o.strict === !0 && Object.hasOwnProperty.call(W, C) && u('Duplicate key "' + C + '"'), e.test(C) === !0 ? o.protoAction === "error" ? u("Object contains forbidden prototype property") : o.protoAction === "ignore" ? g() : W[C] = g() : t.test(C) === !0 ? o.constructorAction === "error" ? u("Object contains forbidden constructor property") : o.constructorAction === "ignore" ? g() : W[C] = g() : W[C] = g(), A(), s === "}")
            return d("}"), W;
          d(","), A();
        }
      }
      u("Bad object");
    };
    return g = function() {
      switch (A(), s) {
        case "{":
          return v();
        case "[":
          return k();
        case '"':
          return f();
        case "-":
          return w();
        default:
          return s >= "0" && s <= "9" ? w() : b();
      }
    }, function(C, W) {
      var Z;
      return c = C + "", i = 0, s = " ", Z = g(), A(), s && u("Syntax error"), typeof W == "function" ? function D(H, y) {
        var S, _ = H[y];
        return _ && typeof _ == "object" && Object.keys(_).forEach(function(F) {
          S = D(_, F), S !== void 0 ? _[F] = S : delete _[F];
        }), W.call(H, y, _);
      }({ "": Z }, "") : Z;
    };
  };
  return Ju = n, Ju;
}
var Wf;
function hb() {
  if (Wf) return hs.exports;
  Wf = 1;
  var r = ub().stringify, e = db();
  return hs.exports = function(t) {
    return {
      parse: e(t),
      stringify: r
    };
  }, hs.exports.parse = e(), hs.exports.stringify = r, hs.exports;
}
var fb = hb();
const pb = /* @__PURE__ */ Bi(fb);
var P1;
(function(r) {
  r.UNSAFE = "unsafe", r.SAFE = "safe", r.MIXED = "mixed", r.BIGINT = "bigint";
})(P1 || (P1 = {}));
const Qn = P1, _5 = pb({
  useNativeBigInt: !0,
  strict: !0
});
function b5(r, { intDecoding: e }) {
  if (e !== Qn.SAFE && e !== Qn.UNSAFE && e !== Qn.BIGINT && e !== Qn.MIXED)
    throw new Error(`Invalid intDecoding option: ${e}`);
  return _5.parse(r, (t, n) => {
    if (n != null && typeof n == "object" && Object.getPrototypeOf(n) == null && Object.setPrototypeOf(n, Object.prototype), typeof n == "bigint") {
      if (e === Qn.SAFE && n > Number.MAX_SAFE_INTEGER)
        throw new Error(`Integer exceeds maximum safe integer: ${n.toString()}. Try parsing with a different intDecoding option.`);
      return e === Qn.BIGINT || e === Qn.MIXED && n > Number.MAX_SAFE_INTEGER ? n : Number(n);
    }
    return typeof n == "number" && e === Qn.BIGINT && Number.isInteger(n) ? BigInt(n) : n;
  });
}
function gb(r, e, t) {
  return _5.stringify(r, e, t);
}
function Fa(r, e) {
  return r.length !== e.length ? !1 : Array.from(r).every((t, n) => t === e[n]);
}
function oo(...r) {
  const e = r.reduce((a, o) => a + o.length, 0), t = new Uint8Array(e);
  let n = 0;
  for (let a = 0; a < r.length; a++)
    t.set(r[a], n), n += r[a].length;
  return t;
}
function Od() {
  return (
    // @ts-ignore
    typeof process == "object" && // @ts-ignore
    typeof process.versions == "object" && // @ts-ignore
    typeof process.versions.node < "u"
  );
}
function et(r) {
  if (typeof r > "u")
    throw new Error("Value is undefined");
  if (typeof r == "bigint") {
    if (r > BigInt(Number.MAX_SAFE_INTEGER) || r < BigInt(Number.MIN_SAFE_INTEGER))
      throw new Error(`BigInt value ${r} is not a safe integer`);
    return Number(r);
  }
  if (typeof r == "number") {
    if (Number.isSafeInteger(r))
      return r;
    throw new Error(`Value ${r} is not a safe integer`);
  }
  throw new Error(`Unexpected type ${typeof r}, ${r}`);
}
function An(r) {
  const e = et(r);
  if (e < 0)
    throw new Error(`Value ${e} is negative`);
  return e;
}
function ot(r) {
  if (typeof r > "u")
    throw new Error("Value is undefined");
  if (typeof r == "bigint")
    return r;
  if (typeof r == "number") {
    if (!Number.isSafeInteger(r))
      throw new Error(`Value ${r} is not a safe integer`);
    return BigInt(r);
  }
  throw new Error(`Unexpected type ${typeof r}, ${r}`);
}
function rr(r) {
  const e = ot(r);
  if (e < 0 || e > BigInt("0xffffffffffffffff"))
    throw new Error(`Value ${e} is not a uint64`);
  return e;
}
function Bs(r) {
  return cb.sha512_256.array(r);
}
function mb(r) {
  return r === Ui.sign.signatureLength;
}
function S5(r) {
  return Ui.sign.keyPair.fromSecretKey(r);
}
function E5(r, e) {
  return Ui.sign.detached(r, e);
}
function x5(r, e, t) {
  return Ui.sign.detached.verify(r, e, t);
}
const k5 = Ui.sign.publicKeyLength;
Ui.sign.secretKeyLength;
const Kf = 32;
var Yf = { exports: {} };
/*
 * [hi-base32]{@link https://github.com/emn178/hi-base32}
 *
 * @version 0.5.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
var Gf;
function yb() {
  return Gf || (Gf = 1, function(r) {
    (function() {
      var e = typeof window == "object" ? window : {}, t = !e.HI_BASE32_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
      t && (e = d3);
      var n = !e.HI_BASE32_NO_COMMON_JS && !0 && r.exports, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), o = {
        A: 0,
        B: 1,
        C: 2,
        D: 3,
        E: 4,
        F: 5,
        G: 6,
        H: 7,
        I: 8,
        J: 9,
        K: 10,
        L: 11,
        M: 12,
        N: 13,
        O: 14,
        P: 15,
        Q: 16,
        R: 17,
        S: 18,
        T: 19,
        U: 20,
        V: 21,
        W: 22,
        X: 23,
        Y: 24,
        Z: 25,
        2: 26,
        3: 27,
        4: 28,
        5: 29,
        6: 30,
        7: 31
      }, i = [0, 0, 0, 0, 0, 0, 0, 0], s = function(g, k) {
        k.length > 10 && (k = "..." + k.substr(-10));
        var v = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + g + " bytes: " + k + " <-");
        throw v.position = g, v;
      }, l = function(g) {
        for (var k = "", v = g.length, C = 0, W = 0, Z, D; C < v; ) {
          if (Z = g[C++], Z <= 127) {
            k += String.fromCharCode(Z);
            continue;
          } else Z > 191 && Z <= 223 ? (D = Z & 31, W = 1) : Z <= 239 ? (D = Z & 15, W = 2) : Z <= 247 ? (D = Z & 7, W = 3) : s(C, k);
          for (var H = 0; H < W; ++H)
            Z = g[C++], (Z < 128 || Z > 191) && s(C, k), D <<= 6, D += Z & 63;
          D >= 55296 && D <= 57343 && s(C, k), D > 1114111 && s(C, k), D <= 65535 ? k += String.fromCharCode(D) : (D -= 65536, k += String.fromCharCode((D >> 10) + 55296), k += String.fromCharCode((D & 1023) + 56320));
        }
        return k;
      }, c = function(g) {
        if (g === "")
          return [];
        if (!/^[A-Z2-7=]+$/.test(g))
          throw new Error("Invalid base32 characters");
        g = g.replace(/=/g, "");
        for (var k, v, C, W, Z, D, H, y, S = [], _ = 0, F = g.length, M = 0, j = F >> 3 << 3; M < j; )
          k = o[g.charAt(M++)], v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], D = o[g.charAt(M++)], H = o[g.charAt(M++)], y = o[g.charAt(M++)], S[_++] = (k << 3 | v >>> 2) & 255, S[_++] = (v << 6 | C << 1 | W >>> 4) & 255, S[_++] = (W << 4 | Z >>> 1) & 255, S[_++] = (Z << 7 | D << 2 | H >>> 3) & 255, S[_++] = (H << 5 | y) & 255;
        var Y = F - j;
        return Y === 2 ? (k = o[g.charAt(M++)], v = o[g.charAt(M++)], S[_++] = (k << 3 | v >>> 2) & 255) : Y === 4 ? (k = o[g.charAt(M++)], v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], S[_++] = (k << 3 | v >>> 2) & 255, S[_++] = (v << 6 | C << 1 | W >>> 4) & 255) : Y === 5 ? (k = o[g.charAt(M++)], v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], S[_++] = (k << 3 | v >>> 2) & 255, S[_++] = (v << 6 | C << 1 | W >>> 4) & 255, S[_++] = (W << 4 | Z >>> 1) & 255) : Y === 7 && (k = o[g.charAt(M++)], v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], D = o[g.charAt(M++)], H = o[g.charAt(M++)], S[_++] = (k << 3 | v >>> 2) & 255, S[_++] = (v << 6 | C << 1 | W >>> 4) & 255, S[_++] = (W << 4 | Z >>> 1) & 255, S[_++] = (Z << 7 | D << 2 | H >>> 3) & 255), S;
      }, u = function(g) {
        for (var k, v, C, W, Z, D = "", H = g.length, y = 0, S = parseInt(H / 5) * 5; y < S; )
          k = g.charCodeAt(y++), v = g.charCodeAt(y++), C = g.charCodeAt(y++), W = g.charCodeAt(y++), Z = g.charCodeAt(y++), D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[(C << 1 | W >>> 7) & 31] + a[W >>> 2 & 31] + a[(W << 3 | Z >>> 5) & 31] + a[Z & 31];
        var _ = H - S;
        return _ === 1 ? (k = g.charCodeAt(y), D += a[k >>> 3] + a[k << 2 & 31] + "======") : _ === 2 ? (k = g.charCodeAt(y++), v = g.charCodeAt(y), D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[v << 4 & 31] + "====") : _ === 3 ? (k = g.charCodeAt(y++), v = g.charCodeAt(y++), C = g.charCodeAt(y), D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[C << 1 & 31] + "===") : _ === 4 && (k = g.charCodeAt(y++), v = g.charCodeAt(y++), C = g.charCodeAt(y++), W = g.charCodeAt(y), D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[(C << 1 | W >>> 7) & 31] + a[W >>> 2 & 31] + a[W << 3 & 31] + "="), D;
      }, d = function(g) {
        var k, v, C, W, Z, D, H = !1, y = "", S = 0, _, F = 0, M = g.length;
        if (g === "")
          return y;
        do {
          for (i[0] = i[5], i[1] = i[6], i[2] = i[7], _ = F; S < M && _ < 5; ++S)
            D = g.charCodeAt(S), D < 128 ? i[_++] = D : D < 2048 ? (i[_++] = 192 | D >> 6, i[_++] = 128 | D & 63) : D < 55296 || D >= 57344 ? (i[_++] = 224 | D >> 12, i[_++] = 128 | D >> 6 & 63, i[_++] = 128 | D & 63) : (D = 65536 + ((D & 1023) << 10 | g.charCodeAt(++S) & 1023), i[_++] = 240 | D >> 18, i[_++] = 128 | D >> 12 & 63, i[_++] = 128 | D >> 6 & 63, i[_++] = 128 | D & 63);
          F = _ - 5, S === M && ++S, S > M && _ < 6 && (H = !0), k = i[0], _ > 4 ? (v = i[1], C = i[2], W = i[3], Z = i[4], y += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[(C << 1 | W >>> 7) & 31] + a[W >>> 2 & 31] + a[(W << 3 | Z >>> 5) & 31] + a[Z & 31]) : _ === 1 ? y += a[k >>> 3] + a[k << 2 & 31] + "======" : _ === 2 ? (v = i[1], y += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[v << 4 & 31] + "====") : _ === 3 ? (v = i[1], C = i[2], y += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[C << 1 & 31] + "===") : (v = i[1], C = i[2], W = i[3], y += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[(C << 1 | W >>> 7) & 31] + a[W >>> 2 & 31] + a[W << 3 & 31] + "=");
        } while (!H);
        return y;
      }, w = function(g) {
        for (var k, v, C, W, Z, D = "", H = g.length, y = 0, S = parseInt(H / 5) * 5; y < S; )
          k = g[y++], v = g[y++], C = g[y++], W = g[y++], Z = g[y++], D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[(C << 1 | W >>> 7) & 31] + a[W >>> 2 & 31] + a[(W << 3 | Z >>> 5) & 31] + a[Z & 31];
        var _ = H - S;
        return _ === 1 ? (k = g[y], D += a[k >>> 3] + a[k << 2 & 31] + "======") : _ === 2 ? (k = g[y++], v = g[y], D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[v << 4 & 31] + "====") : _ === 3 ? (k = g[y++], v = g[y++], C = g[y], D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[C << 1 & 31] + "===") : _ === 4 && (k = g[y++], v = g[y++], C = g[y++], W = g[y], D += a[k >>> 3] + a[(k << 2 | v >>> 6) & 31] + a[v >>> 1 & 31] + a[(v << 4 | C >>> 4) & 31] + a[(C << 1 | W >>> 7) & 31] + a[W >>> 2 & 31] + a[W << 3 & 31] + "="), D;
      }, f = function(g, k) {
        var v = typeof g != "string";
        return v && g.constructor === ArrayBuffer && (g = new Uint8Array(g)), v ? w(g) : k ? u(g) : d(g);
      }, A = function(g, k) {
        if (!k)
          return l(c(g));
        if (g === "")
          return "";
        if (!/^[A-Z2-7=]+$/.test(g))
          throw new Error("Invalid base32 characters");
        var v, C, W, Z, D, H, y, S, _ = "", F = g.indexOf("=");
        F === -1 && (F = g.length);
        for (var M = 0, j = F >> 3 << 3; M < j; )
          v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], D = o[g.charAt(M++)], H = o[g.charAt(M++)], y = o[g.charAt(M++)], S = o[g.charAt(M++)], _ += String.fromCharCode((v << 3 | C >>> 2) & 255) + String.fromCharCode((C << 6 | W << 1 | Z >>> 4) & 255) + String.fromCharCode((Z << 4 | D >>> 1) & 255) + String.fromCharCode((D << 7 | H << 2 | y >>> 3) & 255) + String.fromCharCode((y << 5 | S) & 255);
        var Y = F - j;
        return Y === 2 ? (v = o[g.charAt(M++)], C = o[g.charAt(M++)], _ += String.fromCharCode((v << 3 | C >>> 2) & 255)) : Y === 4 ? (v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], _ += String.fromCharCode((v << 3 | C >>> 2) & 255) + String.fromCharCode((C << 6 | W << 1 | Z >>> 4) & 255)) : Y === 5 ? (v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], D = o[g.charAt(M++)], _ += String.fromCharCode((v << 3 | C >>> 2) & 255) + String.fromCharCode((C << 6 | W << 1 | Z >>> 4) & 255) + String.fromCharCode((Z << 4 | D >>> 1) & 255)) : Y === 7 && (v = o[g.charAt(M++)], C = o[g.charAt(M++)], W = o[g.charAt(M++)], Z = o[g.charAt(M++)], D = o[g.charAt(M++)], H = o[g.charAt(M++)], y = o[g.charAt(M++)], _ += String.fromCharCode((v << 3 | C >>> 2) & 255) + String.fromCharCode((C << 6 | W << 1 | Z >>> 4) & 255) + String.fromCharCode((Z << 4 | D >>> 1) & 255) + String.fromCharCode((D << 7 | H << 2 | y >>> 3) & 255)), _;
      }, b = {
        encode: f,
        decode: A
      };
      A.asBytes = c, n ? r.exports = b : e.base32 = b;
    })();
  }(Yf)), Yf.exports;
}
var wb = yb();
const Ls = /* @__PURE__ */ Bi(wb);
function Tt(r) {
  if (Od())
    return new Uint8Array(Buffer.from(r, "base64"));
  const e = atob(r);
  return Uint8Array.from(e, (t) => t.codePointAt(0));
}
function Co(r) {
  if (Od())
    return Buffer.from(r).toString("base64");
  const e = Array.from(r, (t) => String.fromCodePoint(t)).join("");
  return btoa(e);
}
function Pd(r) {
  return new TextDecoder().decode(r);
}
function mo(r) {
  return typeof r == "string" ? new TextEncoder().encode(r) : r;
}
function vb(r) {
  return Od() ? Buffer.from(r).toString("hex") : Array.from(r).map((e) => e.toString(16).padStart(2, "0")).join("");
}
const Ga = 36, xs = 4, Xu = 58, fs = "address seems to be malformed", _b = "wrong checksum for address";
function Jf(r) {
  return Uint8Array.from(Bs(r).slice(Kf - xs, Kf));
}
class Bt {
  /**
   * Create a new Address object from its binary form.
   * @param publicKey - The binary form of the address. Must be 32 bytes.
   */
  constructor(e) {
    if (!(e instanceof Uint8Array))
      throw new Error(`${fs}: ${e} is not Uint8Array, type ${typeof e}`);
    if (e.length !== Ga - xs)
      throw new Error(`${fs}: 0x${vb(e)}, length ${e.length}`);
    this.publicKey = e;
  }
  /**
   * Check if the address is equal to another address.
   */
  equals(e) {
    return e instanceof Bt && Fa(this.publicKey, e.publicKey);
  }
  /**
   * Compute the 4 byte checksum of the address.
   */
  checksum() {
    return Jf(this.publicKey);
  }
  /**
   * Encode the address into a string form.
   */
  toString() {
    return Ls.encode(oo(this.publicKey, this.checksum())).slice(0, Xu);
  }
  /**
   * Decode an address from a string.
   * @param address - The address to decode. Must be 58 bytes long.
   * @returns An Address object corresponding to the input string.
   */
  static fromString(e) {
    if (typeof e != "string")
      throw new Error(`${fs}: expected string, got ${typeof e}, ${e}`);
    if (e.length !== Xu)
      throw new Error(`${fs}: expected length ${Xu}, got ${e.length}: ${e}`);
    const t = Ls.decode.asBytes(e);
    if (t.length !== Ga)
      throw new Error(`${fs}: expected byte length ${Ga}, got ${t.length}`);
    const n = new Uint8Array(t.slice(0, Ga - xs)), a = new Uint8Array(t.slice(k5, Ga)), o = Jf(n);
    if (!Fa(o, a))
      throw new Error(_b);
    return new Bt(n);
  }
  /**
   * Get the zero address.
   */
  static zeroAddress() {
    return new Bt(new Uint8Array(Ga - xs));
  }
}
function bb(r) {
  try {
    Bt.fromString(r);
  } catch {
    return !1;
  }
  return !0;
}
new TextEncoder().encode("appID");
class Sb extends Error {
  constructor(e, t) {
    super(e), this.response = t, this.name = "URLTokenBaseHTTPError", this.response = t;
  }
}
class Qa {
  constructor(e, t, n, a = {}) {
    this.defaultHeaders = a;
    const o = t.endsWith("/") ? t : `${t}/`, i = new URL(o);
    if (typeof n < "u" && (i.port = n.toString()), i.protocol.length === 0)
      throw new Error("Invalid base server URL, protocol must be defined.");
    this.baseURL = i, this.tokenHeader = e;
  }
  /**
   * Compute the URL for a path relative to the instance's address
   * @param relativePath - A path string
   * @param query - An optional key-value object of query parameters to add to the URL. If the
   *   relativePath already has query parameters on it, the additional parameters defined here will
   *   be added to the URL without modifying those (unless a key collision occurs).
   * @returns A URL string
   */
  getURL(e, t) {
    let n;
    e.startsWith("./") ? n = e : e.startsWith("/") ? n = `.${e}` : n = `./${e}`;
    const a = new URL(n, this.baseURL);
    if (t)
      for (const [o, i] of Object.entries(t))
        a.searchParams.set(o, i.toString());
    return a.toString();
  }
  static formatFetchResponseHeaders(e) {
    const t = {};
    return e.forEach((n, a) => {
      t[n] = a;
    }), t;
  }
  static async checkHttpError(e) {
    if (e.ok)
      return;
    let t, n;
    try {
      t = new Uint8Array(await e.arrayBuffer());
      const o = JSON.parse(new TextDecoder().decode(t));
      o.message && (n = o.message);
    } catch {
    }
    let a = `Network request error. Received status ${e.status} (${e.statusText})`;
    throw n && (a += `: ${n}`), new Sb(a, {
      body: t ?? new Uint8Array(),
      status: e.status,
      headers: Qa.formatFetchResponseHeaders(e.headers)
    });
  }
  static async formatFetchResponse(e) {
    return await this.checkHttpError(e), {
      body: new Uint8Array(await e.arrayBuffer()),
      status: e.status,
      headers: Qa.formatFetchResponseHeaders(e.headers)
    };
  }
  async get(e, t, n, a) {
    const o = {
      ...this.tokenHeader,
      ...this.defaultHeaders,
      ...n ?? {}
    }, i = await fetch(this.getURL(e, t), {
      headers: o,
      ...a ?? {}
    });
    return Qa.formatFetchResponse(i);
  }
  async post(e, t, n, a, o) {
    const i = {
      ...this.tokenHeader,
      ...this.defaultHeaders,
      ...a ?? {}
    }, s = await fetch(this.getURL(e, n), {
      method: "POST",
      body: t,
      headers: i,
      ...o ?? {}
    });
    return Qa.formatFetchResponse(s);
  }
  async delete(e, t, n, a, o) {
    const i = {
      ...this.tokenHeader,
      ...this.defaultHeaders,
      ...a ?? {}
    }, s = await fetch(this.getURL(e, n), {
      method: "DELETE",
      body: t,
      headers: i,
      ...o ?? {}
    });
    return Qa.formatFetchResponse(s);
  }
}
class Eb {
  constructor(e) {
    this.body = e.body, this.text = e.text, this.format = e.format, this.headers = e.headers, this.status = e.status, this.ok = e.ok;
  }
  /**
   * Returns the response body as a string, ready to be parsed as JSON.
   */
  getJSONText() {
    if (this.text === void 0)
      throw new Error(`Response body does not contain JSON data. Format is ${this.format}`);
    return this.text;
  }
  /**
   * Parses the response body as JSON with the given options.
   */
  parseBodyAsJSON(e) {
    if (this.text === void 0)
      throw new Error(`Response body does not contain JSON data. Format is ${this.format}`);
    return en.parseJSON(this.text, this.status, e);
  }
}
function xb(r) {
  for (const e in r)
    Object.prototype.hasOwnProperty.call(r, e) && (!r[e] || r[e].length === 0) && delete r[e];
  return r;
}
function Xf(r) {
  return Object.keys(r).reduce((e, t) => (e[t.toLowerCase()] = r[t], e), {});
}
function kb(r) {
  if (r !== void 0 && Object.prototype.hasOwnProperty.call(r, "format"))
    switch (r.format) {
      case "msgpack":
        return "application/msgpack";
      case "json":
      default:
        return "application/json";
    }
  else
    return "application/json";
}
class en {
  constructor(e, t, n, a = {}) {
    t !== void 0 ? this.bc = new Qa(e, t, n, a) : this.bc = e;
  }
  /**
   * Parse JSON using utils.parseJSON
   *
   * @param text - JSON data
   * @param status - Status of the response (used in case parseJSON fails)
   * @param jsonOptions - Options object to use to decode JSON responses. See
   *   utils.parseJSON for the options available.
   */
  static parseJSON(e, t, n) {
    try {
      return e ? b5(e, n) : null;
    } catch (a) {
      const o = a;
      throw o.rawResponse = e || null, o.statusCode = t, o;
    }
  }
  /**
   * Serialize the data according to the requestHeaders
   * Assumes that requestHeaders contain a key "content-type"
   * If the content-type is "application/json", data is JSON serialized
   * Otherwise, data needs to be either an UTF-8 string that is converted to an Uint8Array
   * or an Uint8Array
   * @private
   */
  static serializeData(e, t) {
    if (!e)
      return new Uint8Array(0);
    if (t["content-type"] === "application/json")
      return new TextEncoder().encode(gb(e));
    if (typeof e == "string")
      return new TextEncoder().encode(e);
    if (e instanceof Uint8Array)
      return e;
    throw new Error("provided data is neither a string nor a Uint8Array and content-type is not application/json");
  }
  /**
   * Convert a BaseHTTPClientResponse into a full HTTPClientResponse
   * Parse the body in
   * Modifies in place res and return the result
   */
  static prepareResponse(e, t) {
    const { body: n } = e;
    let a;
    return t !== "application/msgpack" && (a = n && new TextDecoder().decode(n) || ""), new Eb({
      ...e,
      format: t,
      text: a,
      ok: Math.trunc(e.status / 100) === 2
    });
  }
  /**
   * Prepare an error with a response
   * (the type of errors BaseHTTPClient are supposed to throw)
   * by adding the status and preparing the internal response
   * @private
   */
  static prepareResponseError(e) {
    return e.response && (e.response = en.prepareResponse(e.response, "application/json"), e.status = e.response.status), e;
  }
  /**
   * Send a GET request.
   *
   * @param options - The options to use for the request.
   * @param options.relativePath - The path of the request.
   * @param options.query - An object containing the query parameters of the request.
   * @param options.requestHeaders - An object containing additional request headers to use.
   *   or not.
   * @param options.customOptions - An object containing additional options to pass to the
   *   underlying BaseHTTPClient instance.
   * @returns Response object.
   */
  async get({ relativePath: e, query: t, requestHeaders: n, customOptions: a }) {
    const o = kb(t), i = { ...n ?? {}, accept: o };
    try {
      const s = await this.bc.get(e, t ? xb(t) : void 0, i, a);
      return en.prepareResponse(s, o);
    } catch (s) {
      throw en.prepareResponseError(s);
    }
  }
  /**
   * Send a POST request.
   * If no content-type present, adds the header "content-type: application/json"
   * and data is serialized in JSON (if not empty)
   * @param options - The options to use for the request.
   */
  async post({ relativePath: e, data: t, query: n, requestHeaders: a, customOptions: o }) {
    const i = {
      "content-type": "application/json",
      ...Xf(a ?? {})
    };
    try {
      const s = await this.bc.post(e, en.serializeData(t, i), n, i, o);
      return en.prepareResponse(s, "application/json");
    } catch (s) {
      throw en.prepareResponseError(s);
    }
  }
  /**
   * Send a DELETE request.
   * If no content-type present, adds the header "content-type: application/json"
   * and data is serialized in JSON (if not empty)
   * @param options - The options to use for the request.
   */
  async delete({ relativePath: e, data: t, requestHeaders: n, customOptions: a }) {
    const o = {
      "content-type": "application/json",
      ...Xf(n ?? {})
    };
    try {
      const i = await this.bc.delete(e, typeof t < "u" ? en.serializeData(t, o) : void 0, void 0, o, a);
      return en.prepareResponse(i, "application/json");
    } catch (i) {
      throw en.prepareResponseError(i);
    }
  }
}
function Ab(r, e = "") {
  const t = {};
  return e === "" || (t[r] = e), t;
}
function Cb(r) {
  return typeof r.get == "function";
}
class Db {
  constructor(e, t, n, a, o = {}) {
    if (Cb(t))
      this.c = new en(t);
    else {
      let i;
      typeof t == "string" ? i = Ab(e, t) : i = t, this.c = new en(i, n, a, o);
    }
  }
}
function Mb(r) {
  for (var e = r.length, t = 0, n = 0; n < e; ) {
    var a = r.charCodeAt(n++);
    if ((a & 4294967168) === 0) {
      t++;
      continue;
    } else if ((a & 4294965248) === 0)
      t += 2;
    else {
      if (a >= 55296 && a <= 56319 && n < e) {
        var o = r.charCodeAt(n);
        (o & 64512) === 56320 && (++n, a = ((a & 1023) << 10) + (o & 1023) + 65536);
      }
      (a & 4294901760) === 0 ? t += 3 : t += 4;
    }
  }
  return t;
}
function Rb(r, e, t) {
  for (var n = r.length, a = t, o = 0; o < n; ) {
    var i = r.charCodeAt(o++);
    if ((i & 4294967168) === 0) {
      e[a++] = i;
      continue;
    } else if ((i & 4294965248) === 0)
      e[a++] = i >> 6 & 31 | 192;
    else {
      if (i >= 55296 && i <= 56319 && o < n) {
        var s = r.charCodeAt(o);
        (s & 64512) === 56320 && (++o, i = ((i & 1023) << 10) + (s & 1023) + 65536);
      }
      (i & 4294901760) === 0 ? (e[a++] = i >> 12 & 15 | 224, e[a++] = i >> 6 & 63 | 128) : (e[a++] = i >> 18 & 7 | 240, e[a++] = i >> 12 & 63 | 128, e[a++] = i >> 6 & 63 | 128);
    }
    e[a++] = i & 63 | 128;
  }
}
var Ib = new TextEncoder(), Tb = 50;
function Ob(r, e, t) {
  Ib.encodeInto(r, e.subarray(t));
}
function Pb(r, e, t) {
  r.length > Tb ? Ob(r, e, t) : Rb(r, e, t);
}
var Nb = 4096;
function A5(r, e, t) {
  for (var n = e, a = n + t, o = [], i = ""; n < a; ) {
    var s = r[n++];
    if ((s & 128) === 0)
      o.push(s);
    else if ((s & 224) === 192) {
      var l = r[n++] & 63;
      o.push((s & 31) << 6 | l);
    } else if ((s & 240) === 224) {
      var l = r[n++] & 63, c = r[n++] & 63;
      o.push((s & 31) << 12 | l << 6 | c);
    } else if ((s & 248) === 240) {
      var l = r[n++] & 63, c = r[n++] & 63, u = r[n++] & 63, d = (s & 7) << 18 | l << 12 | c << 6 | u;
      d > 65535 && (d -= 65536, o.push(d >>> 10 & 1023 | 55296), d = 56320 | d & 1023), o.push(d);
    } else
      o.push(s);
    o.length >= Nb && (i += String.fromCharCode.apply(String, o), o.length = 0);
  }
  return o.length > 0 && (i += String.fromCharCode.apply(String, o)), i;
}
var Bb = new TextDecoder(), Lb = 200;
function Ub(r, e, t) {
  var n = r.subarray(e, e + t);
  return Bb.decode(n);
}
function Vb(r, e, t) {
  return t > Lb ? Ub(r, e, t) : A5(r, e, t);
}
var Yc = (
  /** @class */
  /* @__PURE__ */ function() {
    function r(e, t) {
      this.type = e, this.data = t;
    }
    return r;
  }()
), $b = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ln = (
  /** @class */
  function(r) {
    $b(e, r);
    function e(t) {
      var n = r.call(this, t) || this, a = Object.create(e.prototype);
      return Object.setPrototypeOf(n, a), Object.defineProperty(n, "name", {
        configurable: !0,
        enumerable: !1,
        value: e.name
      }), n;
    }
    return e;
  }(Error)
), Nr;
(function(r) {
  r[r.UNSAFE_NUMBER = 0] = "UNSAFE_NUMBER", r[r.SAFE_NUMBER = 1] = "SAFE_NUMBER", r[r.AS_ENCODED = 2] = "AS_ENCODED", r[r.MIXED = 3] = "MIXED", r[r.BIGINT = 4] = "BIGINT";
})(Nr || (Nr = {}));
var ps = 4294967295;
function jb(r, e, t) {
  var n = t / 4294967296, a = t;
  r.setUint32(e, n), r.setUint32(e + 4, a);
}
function C5(r, e, t) {
  var n = Math.floor(t / 4294967296), a = t;
  r.setUint32(e, n), r.setUint32(e + 4, a);
}
function D5(r, e, t) {
  if (t === Nr.UNSAFE_NUMBER || t === Nr.SAFE_NUMBER) {
    var n = r.getInt32(e), a = r.getUint32(e + 4);
    if (t === Nr.SAFE_NUMBER && (n < Math.floor(Number.MIN_SAFE_INTEGER / 4294967296) || n === Math.floor(Number.MIN_SAFE_INTEGER / 4294967296) && a === 0 || n > (Number.MAX_SAFE_INTEGER - a) / 4294967296)) {
      var o = "".concat(n < 0 ? "-" : "", "0x").concat(Math.abs(n).toString(16)).concat(a.toString(16).padStart(8, "0"));
      throw new Error("Mode is IntMode.SAFE_NUMBER and value is not a safe integer: ".concat(o));
    }
    return n * 4294967296 + a;
  }
  var i = r.getBigInt64(e);
  return t === Nr.MIXED && i >= Number.MIN_SAFE_INTEGER && i <= Number.MAX_SAFE_INTEGER ? Number(i) : i;
}
function Fb(r, e, t) {
  if (t === Nr.UNSAFE_NUMBER || t === Nr.SAFE_NUMBER) {
    var n = r.getUint32(e), a = r.getUint32(e + 4);
    if (t === Nr.SAFE_NUMBER && n > (Number.MAX_SAFE_INTEGER - a) / 4294967296) {
      var o = "0x".concat(n.toString(16)).concat(a.toString(16).padStart(8, "0"));
      throw new Error("Mode is IntMode.SAFE_NUMBER and value is not a safe integer: ".concat(o));
    }
    return n * 4294967296 + a;
  }
  var i = r.getBigUint64(e);
  return t === Nr.MIXED && i <= Number.MAX_SAFE_INTEGER ? Number(i) : i;
}
function zb(r, e) {
  return e === Nr.BIGINT ? BigInt(r) : Number(r);
}
var Hb = -1, qb = 4294967296 - 1, Wb = 17179869184 - 1;
function Kb(r) {
  var e = r.sec, t = r.nsec;
  if (e >= 0 && t >= 0 && e <= Wb)
    if (t === 0 && e <= qb) {
      var n = new Uint8Array(4), a = new DataView(n.buffer);
      return a.setUint32(0, e), n;
    } else {
      var o = e / 4294967296, i = e & 4294967295, n = new Uint8Array(8), a = new DataView(n.buffer);
      return a.setUint32(0, t << 2 | o & 3), a.setUint32(4, i), n;
    }
  else {
    var n = new Uint8Array(12), a = new DataView(n.buffer);
    return a.setUint32(0, t), C5(a, 4, e), n;
  }
}
function Yb(r) {
  var e = r.getTime(), t = Math.floor(e / 1e3), n = (e - t * 1e3) * 1e6, a = Math.floor(n / 1e9);
  return {
    sec: t + a,
    nsec: n - a * 1e9
  };
}
function Gb(r) {
  if (r instanceof Date) {
    var e = Yb(r);
    return Kb(e);
  } else
    return null;
}
function Jb(r) {
  var e = new DataView(r.buffer, r.byteOffset, r.byteLength);
  switch (r.byteLength) {
    case 4: {
      var t = e.getUint32(0), n = 0;
      return { sec: t, nsec: n };
    }
    case 8: {
      var a = e.getUint32(0), o = e.getUint32(4), t = (a & 3) * 4294967296 + o, n = a >>> 2;
      return { sec: t, nsec: n };
    }
    case 12: {
      var t = D5(e, 4, Nr.UNSAFE_NUMBER), n = e.getUint32(0);
      return { sec: t, nsec: n };
    }
    default:
      throw new Ln("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(r.length));
  }
}
function Xb(r) {
  var e = Jb(r);
  return new Date(e.sec * 1e3 + e.nsec / 1e6);
}
var Zb = {
  type: Hb,
  encode: Gb,
  decode: Xb
}, M5 = (
  /** @class */
  function() {
    function r() {
      this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(Zb);
    }
    return r.prototype.register = function(e) {
      var t = e.type, n = e.encode, a = e.decode;
      if (t >= 0)
        this.encoders[t] = n, this.decoders[t] = a;
      else {
        var o = 1 + t;
        this.builtInEncoders[o] = n, this.builtInDecoders[o] = a;
      }
    }, r.prototype.tryToEncode = function(e, t) {
      for (var n = 0; n < this.builtInEncoders.length; n++) {
        var a = this.builtInEncoders[n];
        if (a != null) {
          var o = a(e, t);
          if (o != null) {
            var i = -1 - n;
            return new Yc(i, o);
          }
        }
      }
      for (var n = 0; n < this.encoders.length; n++) {
        var a = this.encoders[n];
        if (a != null) {
          var o = a(e, t);
          if (o != null) {
            var i = n;
            return new Yc(i, o);
          }
        }
      }
      return e instanceof Yc ? e : null;
    }, r.prototype.decode = function(e, t, n) {
      var a = t < 0 ? this.builtInDecoders[-1 - t] : this.decoders[t];
      return a ? a(e, t, n) : new Yc(t, e);
    }, r.defaultCodec = new r(), r;
  }()
);
function Oa(r) {
  return r instanceof Uint8Array ? r : ArrayBuffer.isView(r) ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r instanceof ArrayBuffer ? new Uint8Array(r) : Uint8Array.from(r);
}
function Qb(r) {
  if (r instanceof ArrayBuffer)
    return new DataView(r);
  var e = Oa(r);
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function Zf(r, e) {
  for (var t = Math.min(r.length, e.length), n = 0; n < t; n++) {
    var a = r[n] - e[n];
    if (a !== 0)
      return a;
  }
  return r.length - e.length;
}
var $r = (
  /** @class */
  /* @__PURE__ */ function() {
    function r(e) {
      if (this.rawBinaryValue = e, !ArrayBuffer.isView(e))
        throw new TypeError("RawBinaryString: rawBinaryValue must be an ArrayBufferView");
    }
    return r;
  }()
), eS = 100, tS = 2048, rS = (
  /** @class */
  function() {
    function r(e) {
      var t, n, a, o, i, s, l, c;
      this.extensionCodec = (t = e == null ? void 0 : e.extensionCodec) !== null && t !== void 0 ? t : M5.defaultCodec, this.context = e == null ? void 0 : e.context, this.forceBigIntToInt64 = (n = e == null ? void 0 : e.forceBigIntToInt64) !== null && n !== void 0 ? n : !1, this.maxDepth = (a = e == null ? void 0 : e.maxDepth) !== null && a !== void 0 ? a : eS, this.initialBufferSize = (o = e == null ? void 0 : e.initialBufferSize) !== null && o !== void 0 ? o : tS, this.sortKeys = (i = e == null ? void 0 : e.sortKeys) !== null && i !== void 0 ? i : !1, this.forceFloat32 = (s = e == null ? void 0 : e.forceFloat32) !== null && s !== void 0 ? s : !1, this.ignoreUndefined = (l = e == null ? void 0 : e.ignoreUndefined) !== null && l !== void 0 ? l : !1, this.forceIntegerToFloat = (c = e == null ? void 0 : e.forceIntegerToFloat) !== null && c !== void 0 ? c : !1, this.pos = 0, this.view = new DataView(new ArrayBuffer(this.initialBufferSize)), this.bytes = new Uint8Array(this.view.buffer);
    }
    return r.prototype.reinitializeState = function() {
      this.pos = 0;
    }, r.prototype.encodeSharedRef = function(e) {
      return this.reinitializeState(), this.doEncode(e, 1), this.bytes.subarray(0, this.pos);
    }, r.prototype.encode = function(e) {
      return this.reinitializeState(), this.doEncode(e, 1), this.bytes.slice(0, this.pos);
    }, r.prototype.doEncode = function(e, t) {
      if (t > this.maxDepth)
        throw new Error("Too deep objects in depth ".concat(t));
      e == null ? this.encodeNil() : typeof e == "boolean" ? this.encodeBoolean(e) : typeof e == "number" ? this.encodeNumber(e) : typeof e == "string" ? this.encodeString(e) : this.encodeObject(e, t);
    }, r.prototype.ensureBufferSizeToWrite = function(e) {
      var t = this.pos + e;
      this.view.byteLength < t && this.resizeBuffer(t * 2);
    }, r.prototype.resizeBuffer = function(e) {
      var t = new ArrayBuffer(e), n = new Uint8Array(t), a = new DataView(t);
      n.set(this.bytes), this.view = a, this.bytes = n;
    }, r.prototype.encodeNil = function() {
      this.writeU8(192);
    }, r.prototype.encodeBoolean = function(e) {
      e === !1 ? this.writeU8(194) : this.writeU8(195);
    }, r.prototype.encodeNumber = function(e) {
      !this.forceIntegerToFloat && Number.isSafeInteger(e) ? e >= 0 ? e < 128 ? this.writeU8(e) : e < 256 ? (this.writeU8(204), this.writeU8(e)) : e < 65536 ? (this.writeU8(205), this.writeU16(e)) : e < 4294967296 ? (this.writeU8(206), this.writeU32(e)) : (this.writeU8(207), this.writeU64(e)) : e >= -32 ? this.writeU8(224 | e + 32) : e >= -128 ? (this.writeU8(208), this.writeI8(e)) : e >= -32768 ? (this.writeU8(209), this.writeI16(e)) : e >= -2147483648 ? (this.writeU8(210), this.writeI32(e)) : (this.writeU8(211), this.writeI64(e)) : this.encodeNumberAsFloat(e);
    }, r.prototype.encodeNumberAsFloat = function(e) {
      this.forceFloat32 ? (this.writeU8(202), this.writeF32(e)) : (this.writeU8(203), this.writeF64(e));
    }, r.prototype.encodeBigInt = function(e) {
      if (this.forceBigIntToInt64)
        this.encodeBigIntAsInt64(e);
      else if (e >= 0)
        if (e < 4294967296 || this.forceIntegerToFloat)
          this.encodeNumber(Number(e));
        else if (e < BigInt("0x10000000000000000"))
          this.encodeBigIntAsInt64(e);
        else
          throw new Error("Bigint is too large for uint64: ".concat(e));
      else if (e >= -2147483648 || this.forceIntegerToFloat)
        this.encodeNumber(Number(e));
      else if (e >= BigInt(-1) * BigInt("0x8000000000000000"))
        this.encodeBigIntAsInt64(e);
      else
        throw new Error("Bigint is too small for int64: ".concat(e));
    }, r.prototype.encodeBigIntAsInt64 = function(e) {
      e >= BigInt(0) ? (this.writeU8(207), this.writeBigUint64(e)) : (this.writeU8(211), this.writeBigInt64(e));
    }, r.prototype.writeStringHeader = function(e) {
      if (e < 32)
        this.writeU8(160 + e);
      else if (e < 256)
        this.writeU8(217), this.writeU8(e);
      else if (e < 65536)
        this.writeU8(218), this.writeU16(e);
      else if (e < 4294967296)
        this.writeU8(219), this.writeU32(e);
      else
        throw new Error("Too long string: ".concat(e, " bytes in UTF-8"));
    }, r.prototype.encodeString = function(e) {
      var t = 5, n = Mb(e);
      this.ensureBufferSizeToWrite(t + n), this.writeStringHeader(n), Pb(e, this.bytes, this.pos), this.pos += n;
    }, r.prototype.encodeObject = function(e, t) {
      var n = this.extensionCodec.tryToEncode(e, this.context);
      if (n != null)
        this.encodeExtension(n);
      else if (Array.isArray(e))
        this.encodeArray(e, t);
      else if (ArrayBuffer.isView(e))
        this.encodeBinary(e);
      else if (e instanceof $r)
        this.encodeBinaryAsString(e);
      else if (typeof e == "bigint")
        this.encodeBigInt(e);
      else if (e instanceof Map)
        this.encodeMap(e, t);
      else if (typeof e == "object")
        this.encodeMapObject(e, t);
      else
        throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(e)));
    }, r.prototype.encodeBinary = function(e) {
      var t = e.byteLength;
      if (t < 256)
        this.writeU8(196), this.writeU8(t);
      else if (t < 65536)
        this.writeU8(197), this.writeU16(t);
      else if (t < 4294967296)
        this.writeU8(198), this.writeU32(t);
      else
        throw new Error("Too large binary: ".concat(t));
      var n = Oa(e);
      this.writeU8a(n);
    }, r.prototype.encodeBinaryAsString = function(e) {
      var t = e.rawBinaryValue;
      this.writeStringHeader(t.byteLength);
      var n = Oa(t);
      this.writeU8a(n);
    }, r.prototype.encodeArray = function(e, t) {
      var n = e.length;
      if (n < 16)
        this.writeU8(144 + n);
      else if (n < 65536)
        this.writeU8(220), this.writeU16(n);
      else if (n < 4294967296)
        this.writeU8(221), this.writeU32(n);
      else
        throw new Error("Too large array: ".concat(n));
      for (var a = 0, o = e; a < o.length; a++) {
        var i = o[a];
        this.doEncode(i, t + 1);
      }
    }, r.prototype.countWithoutUndefined = function(e, t) {
      for (var n = 0, a = 0, o = t; a < o.length; a++) {
        var i = o[a];
        e.get(i) !== void 0 && n++;
      }
      return n;
    }, r.prototype.sortMapKeys = function(e) {
      for (var t = [], n = [], a = [], o = [], i = 0, s = e; i < s.length; i++) {
        var l = s[i];
        if (typeof l == "number") {
          if (isNaN(l))
            throw new Error("Cannot sort map keys with NaN value");
          t.push(l);
        } else if (typeof l == "bigint")
          t.push(l);
        else if (typeof l == "string")
          n.push(l);
        else if (ArrayBuffer.isView(l))
          o.push(Oa(l));
        else if (l instanceof $r)
          a.push(l);
        else
          throw new Error("Unsupported map key type: ".concat(Object.prototype.toString.apply(l)));
      }
      return t.sort(function(c, u) {
        return c < u ? -1 : c > u ? 1 : 0;
      }), n.sort(), a.sort(function(c, u) {
        return Zf(Oa(c.rawBinaryValue), Oa(u.rawBinaryValue));
      }), o.sort(Zf), [].concat(t, n, a, o);
    }, r.prototype.encodeMapObject = function(e, t) {
      this.encodeMap(new Map(Object.entries(e)), t);
    }, r.prototype.encodeMap = function(e, t) {
      var n = Array.from(e.keys());
      this.sortKeys && (n = this.sortMapKeys(n));
      var a = this.ignoreUndefined ? this.countWithoutUndefined(e, n) : n.length;
      if (a < 16)
        this.writeU8(128 + a);
      else if (a < 65536)
        this.writeU8(222), this.writeU16(a);
      else if (a < 4294967296)
        this.writeU8(223), this.writeU32(a);
      else
        throw new Error("Too large map object: ".concat(a));
      for (var o = 0, i = n; o < i.length; o++) {
        var s = i[o], l = e.get(s);
        if (!(this.ignoreUndefined && l === void 0)) {
          if (typeof s == "string")
            this.encodeString(s);
          else if (typeof s == "number")
            this.encodeNumber(s);
          else if (typeof s == "bigint")
            this.encodeBigInt(s);
          else if (ArrayBuffer.isView(s))
            this.encodeBinary(s);
          else if (s instanceof $r)
            this.encodeBinaryAsString(s);
          else
            throw new Error("Unsupported map key type: ".concat(Object.prototype.toString.apply(s)));
          this.doEncode(l, t + 1);
        }
      }
    }, r.prototype.encodeExtension = function(e) {
      var t = e.data.length;
      if (t === 1)
        this.writeU8(212);
      else if (t === 2)
        this.writeU8(213);
      else if (t === 4)
        this.writeU8(214);
      else if (t === 8)
        this.writeU8(215);
      else if (t === 16)
        this.writeU8(216);
      else if (t < 256)
        this.writeU8(199), this.writeU8(t);
      else if (t < 65536)
        this.writeU8(200), this.writeU16(t);
      else if (t < 4294967296)
        this.writeU8(201), this.writeU32(t);
      else
        throw new Error("Too large extension object: ".concat(t));
      this.writeI8(e.type), this.writeU8a(e.data);
    }, r.prototype.writeU8 = function(e) {
      this.ensureBufferSizeToWrite(1), this.view.setUint8(this.pos, e), this.pos++;
    }, r.prototype.writeU8a = function(e) {
      var t = e.length;
      this.ensureBufferSizeToWrite(t), this.bytes.set(e, this.pos), this.pos += t;
    }, r.prototype.writeI8 = function(e) {
      this.ensureBufferSizeToWrite(1), this.view.setInt8(this.pos, e), this.pos++;
    }, r.prototype.writeU16 = function(e) {
      this.ensureBufferSizeToWrite(2), this.view.setUint16(this.pos, e), this.pos += 2;
    }, r.prototype.writeI16 = function(e) {
      this.ensureBufferSizeToWrite(2), this.view.setInt16(this.pos, e), this.pos += 2;
    }, r.prototype.writeU32 = function(e) {
      this.ensureBufferSizeToWrite(4), this.view.setUint32(this.pos, e), this.pos += 4;
    }, r.prototype.writeI32 = function(e) {
      this.ensureBufferSizeToWrite(4), this.view.setInt32(this.pos, e), this.pos += 4;
    }, r.prototype.writeF32 = function(e) {
      this.ensureBufferSizeToWrite(4), this.view.setFloat32(this.pos, e), this.pos += 4;
    }, r.prototype.writeF64 = function(e) {
      this.ensureBufferSizeToWrite(8), this.view.setFloat64(this.pos, e), this.pos += 8;
    }, r.prototype.writeU64 = function(e) {
      this.ensureBufferSizeToWrite(8), jb(this.view, this.pos, e), this.pos += 8;
    }, r.prototype.writeI64 = function(e) {
      this.ensureBufferSizeToWrite(8), C5(this.view, this.pos, e), this.pos += 8;
    }, r.prototype.writeBigUint64 = function(e) {
      this.ensureBufferSizeToWrite(8), this.view.setBigUint64(this.pos, e), this.pos += 8;
    }, r.prototype.writeBigInt64 = function(e) {
      this.ensureBufferSizeToWrite(8), this.view.setBigInt64(this.pos, e), this.pos += 8;
    }, r;
  }()
);
function nS(r, e) {
  var t = new rS(e);
  return t.encodeSharedRef(r);
}
function Zu(r) {
  return "".concat(r < 0 ? "-" : "", "0x").concat(Math.abs(r).toString(16).padStart(2, "0"));
}
var aS = 16, oS = 16, iS = (
  /** @class */
  function() {
    function r(e, t) {
      e === void 0 && (e = aS), t === void 0 && (t = oS), this.maxKeyLength = e, this.maxLengthPerKey = t, this.hit = 0, this.miss = 0, this.caches = [];
      for (var n = 0; n < this.maxKeyLength; n++)
        this.caches.push([]);
    }
    return r.prototype.canBeCached = function(e) {
      return e > 0 && e <= this.maxKeyLength;
    }, r.prototype.find = function(e, t, n) {
      var a = this.caches[n - 1];
      e: for (var o = 0, i = a; o < i.length; o++) {
        for (var s = i[o], l = s.bytes, c = 0; c < n; c++)
          if (l[c] !== e[t + c])
            continue e;
        return s.str;
      }
      return null;
    }, r.prototype.store = function(e, t) {
      var n = this.caches[e.length - 1], a = { bytes: e, str: t };
      n.length >= this.maxLengthPerKey ? n[Math.random() * n.length | 0] = a : n.push(a);
    }, r.prototype.decode = function(e, t, n) {
      var a = this.find(e, t, n);
      if (a != null)
        return this.hit++, a;
      this.miss++;
      var o = A5(e, t, n), i = Uint8Array.prototype.slice.call(e, t, t + n);
      return this.store(i, o), o;
    }, r;
  }()
), sS = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, [])).next());
  });
}, Qu = function(r, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, a, o, i;
  return i = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, c[0] && (t = 0)), t; ) try {
      if (n = 1, a && (o = c[0] & 2 ? a.return : c[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, c[1])).done) return o;
      switch (a = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return t.label++, { value: c[1], done: !1 };
        case 5:
          t.label++, a = c[1], c = [0];
          continue;
        case 7:
          c = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            t = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            t.label = c[1];
            break;
          }
          if (c[0] === 6 && t.label < o[1]) {
            t.label = o[1], o = c;
            break;
          }
          if (o && t.label < o[2]) {
            t.label = o[2], t.ops.push(c);
            break;
          }
          o[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      c = e.call(r, t);
    } catch (u) {
      c = [6, u], a = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, Qf = function(r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = r[Symbol.asyncIterator], t;
  return e ? e.call(r) : (r = typeof __values == "function" ? __values(r) : r[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(o) {
    t[o] = r[o] && function(i) {
      return new Promise(function(s, l) {
        i = r[o](i), a(s, l, i.done, i.value);
      });
    };
  }
  function a(o, i, s, l) {
    Promise.resolve(l).then(function(c) {
      o({ value: c, done: s });
    }, i);
  }
}, Ko = function(r) {
  return this instanceof Ko ? (this.v = r, this) : new Ko(r);
}, cS = function(r, e, t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = t.apply(r, e || []), a, o = [];
  return a = {}, i("next"), i("throw"), i("return"), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function i(w) {
    n[w] && (a[w] = function(f) {
      return new Promise(function(A, b) {
        o.push([w, f, A, b]) > 1 || s(w, f);
      });
    });
  }
  function s(w, f) {
    try {
      l(n[w](f));
    } catch (A) {
      d(o[0][3], A);
    }
  }
  function l(w) {
    w.value instanceof Ko ? Promise.resolve(w.value.v).then(c, u) : d(o[0][2], w);
  }
  function c(w) {
    s("next", w);
  }
  function u(w) {
    s("throw", w);
  }
  function d(w, f) {
    w(f), o.shift(), o.length && s(o[0][0], o[0][1]);
  }
}, N1 = "array", ks = "map_key", R5 = "map_value";
function lS(r, e, t) {
  return e ? typeof r == "string" || typeof r == "number" || typeof r == "bigint" || r instanceof Uint8Array || r instanceof $r : typeof r == "string" || t && typeof r == "number";
}
var uS = (
  /** @class */
  function() {
    function r(e) {
      this.useMap = e, this.stack = [], this.stackHeadPosition = -1;
    }
    return Object.defineProperty(r.prototype, "length", {
      get: function() {
        return this.stackHeadPosition + 1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.top = function() {
      return this.stack[this.stackHeadPosition];
    }, r.prototype.pushArrayState = function(e) {
      var t = this.getUninitializedStateFromPool();
      t.type = N1, t.position = 0, t.size = e, t.array = new Array(e);
    }, r.prototype.pushMapState = function(e) {
      var t = this.getUninitializedStateFromPool();
      t.type = ks, t.readCount = 0, t.size = e, t.map = this.useMap ? /* @__PURE__ */ new Map() : {};
    }, r.prototype.getUninitializedStateFromPool = function() {
      if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
        var e = {
          type: void 0,
          size: 0,
          array: void 0,
          position: 0,
          readCount: 0,
          map: void 0,
          key: null
        };
        this.stack.push(e);
      }
      return this.stack[this.stackHeadPosition];
    }, r.prototype.release = function(e) {
      var t = this.stack[this.stackHeadPosition];
      if (t !== e)
        throw new Error("Invalid stack state. Released state is not on top of the stack.");
      if (e.type === N1) {
        var n = e;
        n.size = 0, n.array = void 0, n.position = 0, n.type = void 0;
      }
      if (e.type === ks || e.type === R5) {
        var n = e;
        n.size = 0, n.map = void 0, n.readCount = 0, n.type = void 0;
      }
      this.stackHeadPosition--;
    }, r.prototype.reset = function() {
      this.stack.length = 0, this.stackHeadPosition = -1;
    }, r;
  }()
), gs = -1, Nd = new DataView(new ArrayBuffer(0)), dS = new Uint8Array(Nd.buffer);
try {
  Nd.getInt8(0);
} catch (r) {
  if (!(r instanceof RangeError))
    throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
var B1 = RangeError, e2 = new B1("Insufficient data"), hS = new iS(), fS = (
  /** @class */
  function() {
    function r(e) {
      var t, n, a, o, i, s, l, c, u, d, w, f;
      if (this.totalPos = 0, this.pos = 0, this.view = Nd, this.bytes = dS, this.headByte = gs, this.extensionCodec = (t = e == null ? void 0 : e.extensionCodec) !== null && t !== void 0 ? t : M5.defaultCodec, this.context = e == null ? void 0 : e.context, this.intMode = (n = e == null ? void 0 : e.intMode) !== null && n !== void 0 ? n : e != null && e.useBigInt64 ? Nr.AS_ENCODED : Nr.UNSAFE_NUMBER, this.rawBinaryStringValues = (a = e == null ? void 0 : e.rawBinaryStringValues) !== null && a !== void 0 ? a : !1, this.rawBinaryStringKeys = (o = e == null ? void 0 : e.rawBinaryStringKeys) !== null && o !== void 0 ? o : !1, this.useRawBinaryStringClass = (i = e == null ? void 0 : e.useRawBinaryStringClass) !== null && i !== void 0 ? i : !1, this.useMap = (s = e == null ? void 0 : e.useMap) !== null && s !== void 0 ? s : !1, this.supportObjectNumberKeys = (l = e == null ? void 0 : e.supportObjectNumberKeys) !== null && l !== void 0 ? l : !1, this.maxStrLength = (c = e == null ? void 0 : e.maxStrLength) !== null && c !== void 0 ? c : ps, this.maxBinLength = (u = e == null ? void 0 : e.maxBinLength) !== null && u !== void 0 ? u : ps, this.maxArrayLength = (d = e == null ? void 0 : e.maxArrayLength) !== null && d !== void 0 ? d : ps, this.maxMapLength = (w = e == null ? void 0 : e.maxMapLength) !== null && w !== void 0 ? w : ps, this.maxExtLength = (f = e == null ? void 0 : e.maxExtLength) !== null && f !== void 0 ? f : ps, this.keyDecoder = (e == null ? void 0 : e.keyDecoder) !== void 0 ? e.keyDecoder : hS, this.rawBinaryStringKeys && !this.useMap)
        throw new Error("rawBinaryStringKeys is only supported when useMap is true");
      this.stack = new uS(this.useMap);
    }
    return r.prototype.reinitializeState = function() {
      this.totalPos = 0, this.headByte = gs, this.stack.reset();
    }, r.prototype.setBuffer = function(e) {
      this.bytes = Oa(e), this.view = Qb(this.bytes), this.pos = 0;
    }, r.prototype.appendBuffer = function(e) {
      if (this.headByte === gs && !this.hasRemaining(1))
        this.setBuffer(e);
      else {
        var t = this.bytes.subarray(this.pos), n = Oa(e), a = new Uint8Array(t.length + n.length);
        a.set(t), a.set(n, t.length), this.setBuffer(a);
      }
    }, r.prototype.hasRemaining = function(e) {
      return this.view.byteLength - this.pos >= e;
    }, r.prototype.createExtraByteError = function(e) {
      var t = this, n = t.view, a = t.pos;
      return new RangeError("Extra ".concat(n.byteLength - a, " of ").concat(n.byteLength, " byte(s) found at buffer[").concat(e, "]"));
    }, r.prototype.decode = function(e) {
      this.reinitializeState(), this.setBuffer(e);
      var t = this.doDecodeSync();
      if (this.hasRemaining(1))
        throw this.createExtraByteError(this.pos);
      return t;
    }, r.prototype.decodeMulti = function(e) {
      return Qu(this, function(t) {
        switch (t.label) {
          case 0:
            this.reinitializeState(), this.setBuffer(e), t.label = 1;
          case 1:
            return this.hasRemaining(1) ? [4, this.doDecodeSync()] : [3, 3];
          case 2:
            return t.sent(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, r.prototype.decodeAsync = function(e) {
      var t, n, a, o, i, s, l;
      return sS(this, void 0, void 0, function() {
        var c, u, d, w, f, A, b, g;
        return Qu(this, function(k) {
          switch (k.label) {
            case 0:
              c = !1, k.label = 1;
            case 1:
              k.trys.push([1, 6, 7, 12]), t = !0, n = Qf(e), k.label = 2;
            case 2:
              return [4, n.next()];
            case 3:
              if (a = k.sent(), o = a.done, !!o) return [3, 5];
              if (l = a.value, t = !1, d = l, c)
                throw this.createExtraByteError(this.totalPos);
              this.appendBuffer(d);
              try {
                u = this.doDecodeSync(), c = !0;
              } catch (v) {
                if (!(v instanceof B1))
                  throw v;
              }
              this.totalPos += this.pos, k.label = 4;
            case 4:
              return t = !0, [3, 2];
            case 5:
              return [3, 12];
            case 6:
              return w = k.sent(), i = { error: w }, [3, 12];
            case 7:
              return k.trys.push([7, , 10, 11]), !t && !o && (s = n.return) ? [4, s.call(n)] : [3, 9];
            case 8:
              k.sent(), k.label = 9;
            case 9:
              return [3, 11];
            case 10:
              if (i) throw i.error;
              return [
                7
                /*endfinally*/
              ];
            case 11:
              return [
                7
                /*endfinally*/
              ];
            case 12:
              if (c) {
                if (this.hasRemaining(1))
                  throw this.createExtraByteError(this.totalPos);
                return [2, u];
              }
              throw f = this, A = f.headByte, b = f.pos, g = f.totalPos, new RangeError("Insufficient data in parsing ".concat(Zu(A), " at ").concat(g, " (").concat(b, " in the current buffer)"));
          }
        });
      });
    }, r.prototype.decodeArrayStream = function(e) {
      return this.decodeMultiAsync(e, !0);
    }, r.prototype.decodeStream = function(e) {
      return this.decodeMultiAsync(e, !1);
    }, r.prototype.decodeMultiAsync = function(e, t) {
      return cS(this, arguments, function() {
        var n, a, o, i, s, l, c, u, d, w, f, A;
        return Qu(this, function(b) {
          switch (b.label) {
            case 0:
              n = t, a = -1, b.label = 1;
            case 1:
              b.trys.push([1, 13, 14, 19]), o = !0, i = Qf(e), b.label = 2;
            case 2:
              return [4, Ko(i.next())];
            case 3:
              if (s = b.sent(), d = s.done, !!d) return [3, 12];
              if (A = s.value, o = !1, l = A, t && a === 0)
                throw this.createExtraByteError(this.totalPos);
              this.appendBuffer(l), n && (a = this.readArraySize(), n = !1, this.complete()), b.label = 4;
            case 4:
              b.trys.push([4, 9, , 10]), b.label = 5;
            case 5:
              return [4, Ko(this.doDecodeSync())];
            case 6:
              return [4, b.sent()];
            case 7:
              return b.sent(), --a === 0 ? [3, 8] : [3, 5];
            case 8:
              return [3, 10];
            case 9:
              if (c = b.sent(), !(c instanceof B1))
                throw c;
              return [3, 10];
            case 10:
              this.totalPos += this.pos, b.label = 11;
            case 11:
              return o = !0, [3, 2];
            case 12:
              return [3, 19];
            case 13:
              return u = b.sent(), w = { error: u }, [3, 19];
            case 14:
              return b.trys.push([14, , 17, 18]), !o && !d && (f = i.return) ? [4, Ko(f.call(i))] : [3, 16];
            case 15:
              b.sent(), b.label = 16;
            case 16:
              return [3, 18];
            case 17:
              if (w) throw w.error;
              return [
                7
                /*endfinally*/
              ];
            case 18:
              return [
                7
                /*endfinally*/
              ];
            case 19:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.doDecodeSync = function() {
      e: for (; ; ) {
        var e = this.readHeadByte(), t = void 0;
        if (e >= 224)
          t = this.convertNumber(e - 256);
        else if (e < 192)
          if (e < 128)
            t = this.convertNumber(e);
          else if (e < 144) {
            var n = e - 128;
            if (n !== 0) {
              this.pushMapState(n), this.complete();
              continue e;
            } else
              t = this.useMap ? /* @__PURE__ */ new Map() : {};
          } else if (e < 160) {
            var n = e - 144;
            if (n !== 0) {
              this.pushArrayState(n), this.complete();
              continue e;
            } else
              t = [];
          } else {
            var a = e - 160;
            t = this.decodeString(a, 0);
          }
        else if (e === 192)
          t = null;
        else if (e === 194)
          t = !1;
        else if (e === 195)
          t = !0;
        else if (e === 202)
          t = this.readF32();
        else if (e === 203)
          t = this.readF64();
        else if (e === 204)
          t = this.convertNumber(this.readU8());
        else if (e === 205)
          t = this.convertNumber(this.readU16());
        else if (e === 206)
          t = this.convertNumber(this.readU32());
        else if (e === 207)
          t = this.readU64();
        else if (e === 208)
          t = this.convertNumber(this.readI8());
        else if (e === 209)
          t = this.convertNumber(this.readI16());
        else if (e === 210)
          t = this.convertNumber(this.readI32());
        else if (e === 211)
          t = this.readI64();
        else if (e === 217) {
          var a = this.lookU8();
          t = this.decodeString(a, 1);
        } else if (e === 218) {
          var a = this.lookU16();
          t = this.decodeString(a, 2);
        } else if (e === 219) {
          var a = this.lookU32();
          t = this.decodeString(a, 4);
        } else if (e === 220) {
          var n = this.readU16();
          if (n !== 0) {
            this.pushArrayState(n), this.complete();
            continue e;
          } else
            t = [];
        } else if (e === 221) {
          var n = this.readU32();
          if (n !== 0) {
            this.pushArrayState(n), this.complete();
            continue e;
          } else
            t = [];
        } else if (e === 222) {
          var n = this.readU16();
          if (n !== 0) {
            this.pushMapState(n), this.complete();
            continue e;
          } else
            t = {};
        } else if (e === 223) {
          var n = this.readU32();
          if (n !== 0) {
            this.pushMapState(n), this.complete();
            continue e;
          } else
            t = {};
        } else if (e === 196) {
          var n = this.lookU8();
          t = this.decodeBinary(n, 1);
        } else if (e === 197) {
          var n = this.lookU16();
          t = this.decodeBinary(n, 2);
        } else if (e === 198) {
          var n = this.lookU32();
          t = this.decodeBinary(n, 4);
        } else if (e === 212)
          t = this.decodeExtension(1, 0);
        else if (e === 213)
          t = this.decodeExtension(2, 0);
        else if (e === 214)
          t = this.decodeExtension(4, 0);
        else if (e === 215)
          t = this.decodeExtension(8, 0);
        else if (e === 216)
          t = this.decodeExtension(16, 0);
        else if (e === 199) {
          var n = this.lookU8();
          t = this.decodeExtension(n, 1);
        } else if (e === 200) {
          var n = this.lookU16();
          t = this.decodeExtension(n, 2);
        } else if (e === 201) {
          var n = this.lookU32();
          t = this.decodeExtension(n, 4);
        } else
          throw new Ln("Unrecognized type byte: ".concat(Zu(e)));
        this.complete();
        for (var o = this.stack; o.length > 0; ) {
          var i = o.top();
          if (i.type === N1)
            if (i.array[i.position] = t, i.position++, i.position === i.size)
              t = i.array, o.release(i);
            else
              continue e;
          else if (i.type === ks) {
            if (!lS(t, this.useMap, this.supportObjectNumberKeys)) {
              var s = this.useMap ? "string, number, bigint, or Uint8Array" : this.supportObjectNumberKeys ? "string or number" : "string";
              throw new Ln("The type of key must be ".concat(s, " but got ").concat(typeof t));
            }
            if (!this.useMap && t === "__proto__")
              throw new Ln("The key __proto__ is not allowed");
            i.key = t, i.type = R5;
            continue e;
          } else if (this.useMap ? i.map.set(i.key, t) : i.map[i.key] = t, i.readCount++, i.readCount === i.size)
            t = i.map, o.release(i);
          else {
            i.key = null, i.type = ks;
            continue e;
          }
        }
        return t;
      }
    }, r.prototype.readHeadByte = function() {
      return this.headByte === gs && (this.headByte = this.readU8()), this.headByte;
    }, r.prototype.complete = function() {
      this.headByte = gs;
    }, r.prototype.readArraySize = function() {
      var e = this.readHeadByte();
      switch (e) {
        case 220:
          return this.readU16();
        case 221:
          return this.readU32();
        default: {
          if (e < 160)
            return e - 144;
          throw new Ln("Unrecognized array type byte: ".concat(Zu(e)));
        }
      }
    }, r.prototype.pushMapState = function(e) {
      if (e > this.maxMapLength)
        throw new Ln("Max length exceeded: map length (".concat(e, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
      this.stack.pushMapState(e);
    }, r.prototype.pushArrayState = function(e) {
      if (e > this.maxArrayLength)
        throw new Ln("Max length exceeded: array length (".concat(e, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
      this.stack.pushArrayState(e);
    }, r.prototype.decodeString = function(e, t) {
      if (this.stateIsMapKey() ? this.rawBinaryStringKeys : this.rawBinaryStringValues) {
        var n = this.decodeBinary(e, t);
        return this.useRawBinaryStringClass ? new $r(n) : n;
      }
      return this.decodeUtf8String(e, t);
    }, r.prototype.decodeUtf8String = function(e, t) {
      var n;
      if (e > this.maxStrLength)
        throw new Ln("Max length exceeded: UTF-8 byte length (".concat(e, ") > maxStrLength (").concat(this.maxStrLength, ")"));
      if (this.bytes.byteLength < this.pos + t + e)
        throw e2;
      var a = this.pos + t, o;
      return this.stateIsMapKey() && !((n = this.keyDecoder) === null || n === void 0) && n.canBeCached(e) ? o = this.keyDecoder.decode(this.bytes, a, e) : o = Vb(this.bytes, a, e), this.pos += t + e, o;
    }, r.prototype.stateIsMapKey = function() {
      if (this.stack.length > 0) {
        var e = this.stack.top();
        return e.type === ks;
      }
      return !1;
    }, r.prototype.decodeBinary = function(e, t) {
      if (e > this.maxBinLength)
        throw new Ln("Max length exceeded: bin length (".concat(e, ") > maxBinLength (").concat(this.maxBinLength, ")"));
      if (!this.hasRemaining(e + t))
        throw e2;
      var n = this.pos + t, a = this.bytes.subarray(n, n + e);
      return this.pos += t + e, a;
    }, r.prototype.decodeExtension = function(e, t) {
      if (e > this.maxExtLength)
        throw new Ln("Max length exceeded: ext length (".concat(e, ") > maxExtLength (").concat(this.maxExtLength, ")"));
      var n = this.view.getInt8(this.pos + t), a = this.decodeBinary(
        e,
        t + 1
        /* extType */
      );
      return this.extensionCodec.decode(a, n, this.context);
    }, r.prototype.convertNumber = function(e) {
      return zb(e, this.intMode);
    }, r.prototype.lookU8 = function() {
      return this.view.getUint8(this.pos);
    }, r.prototype.lookU16 = function() {
      return this.view.getUint16(this.pos);
    }, r.prototype.lookU32 = function() {
      return this.view.getUint32(this.pos);
    }, r.prototype.readU8 = function() {
      var e = this.view.getUint8(this.pos);
      return this.pos++, e;
    }, r.prototype.readI8 = function() {
      var e = this.view.getInt8(this.pos);
      return this.pos++, e;
    }, r.prototype.readU16 = function() {
      var e = this.view.getUint16(this.pos);
      return this.pos += 2, e;
    }, r.prototype.readI16 = function() {
      var e = this.view.getInt16(this.pos);
      return this.pos += 2, e;
    }, r.prototype.readU32 = function() {
      var e = this.view.getUint32(this.pos);
      return this.pos += 4, e;
    }, r.prototype.readI32 = function() {
      var e = this.view.getInt32(this.pos);
      return this.pos += 4, e;
    }, r.prototype.readU64 = function() {
      var e = Fb(this.view, this.pos, this.intMode);
      return this.pos += 8, e;
    }, r.prototype.readI64 = function() {
      var e = D5(this.view, this.pos, this.intMode);
      return this.pos += 8, e;
    }, r.prototype.readF32 = function() {
      var e = this.view.getFloat32(this.pos);
      return this.pos += 4, e;
    }, r.prototype.readF64 = function() {
      var e = this.view.getFloat64(this.pos);
      return this.pos += 8, e;
    }, r;
  }()
);
function I5(r, e) {
  var t = new fS(e);
  return t.decode(r);
}
function T5(r) {
  return nS(r, { sortKeys: !0 });
}
function pS(r, e) {
  const t = {
    intMode: Nr.BIGINT,
    useMap: !0
  };
  return I5(r, t);
}
function gS(r, e) {
  const t = {
    intMode: Nr.BIGINT,
    useMap: !0,
    rawBinaryStringKeys: !0,
    rawBinaryStringValues: !0,
    useRawBinaryStringClass: !0
  };
  return I5(r, t);
}
function L1(r) {
  if (r == null)
    return r;
  if (r instanceof Uint8Array)
    return Co(r);
  if (Array.isArray(r))
    return r.map(L1);
  if (r instanceof Map) {
    const e = {};
    for (const [t, n] of r) {
      if (typeof t != "string")
        throw new Error(`JSON map key must be a string: ${t}`);
      e[t] = L1(n);
    }
    return e;
  }
  return r;
}
function U1(r) {
  if (r == null || typeof r == "string" || // Note, this will not convert base64 to Uint8Array
  typeof r == "number" || typeof r == "bigint" || typeof r == "boolean")
    return r;
  if (Array.isArray(r))
    return r.map(U1);
  if (typeof r == "object") {
    const e = /* @__PURE__ */ new Map();
    for (const [t, n] of Object.entries(r))
      e.set(t, U1(n));
    return e;
  }
  throw new Error(`Invalid JSON encoding data: ${r}`);
}
var Ia;
(function(r) {
  r[r.MAP_VALUE = 0] = "MAP_VALUE", r[r.ARRAY_ELEMENT = 1] = "ARRAY_ELEMENT";
})(Ia || (Ia = {}));
class El {
  constructor({ parent: e, segment: t, baseObjectBytes: n }) {
    this.resolvedCache = null, this.resolvedCachePresent = !1, this.parent = e, this.segment = t, this.baseObjectBytes = n;
  }
  /**
   * Create a new provider that resolves to the current provider's map value at the given key.
   */
  withMapValue(e) {
    return new El({
      parent: this,
      segment: {
        kind: Ia.MAP_VALUE,
        key: e
      }
    });
  }
  /**
   * Create a new provider that resolves to the current provider's array element at the given index.
   */
  withArrayElement(e) {
    return new El({
      parent: this,
      segment: {
        kind: Ia.ARRAY_ELEMENT,
        key: e
      }
    });
  }
  /**
   * Get the raw string at the current location. If the current location is not a raw string, an error is thrown.
   */
  getRawStringAtCurrentLocation() {
    const e = this.resolve();
    if (e instanceof $r)
      return e.rawBinaryValue;
    throw new Error(`Invalid type. Expected RawBinaryString, got ${e} (${typeof e})`);
  }
  /**
   * Get the raw string map keys and values at the current location. If the current location is not a map, an error is thrown.
   */
  getRawStringKeysAndValuesAtCurrentLocation() {
    const e = this.resolve();
    if (!(e instanceof Map))
      throw new Error(`Invalid type. Expected Map, got ${e} (${typeof e})`);
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of e)
      if (n instanceof $r)
        t.set(n.rawBinaryValue, a);
      else
        throw new Error(`Invalid type for map key. Expected RawBinaryString, got ${n} (${typeof n})`);
    return t;
  }
  /**
   * Resolve the provider by extracting the value it indicates from the base msgpack object.
   */
  resolve() {
    if (this.resolvedCachePresent)
      return this.resolvedCache;
    let e;
    if (this.parent ? e = this.parent.resolve() : e = gS(this.baseObjectBytes), !this.segment)
      return this.resolvedCache = e, this.resolvedCachePresent = !0, e;
    if (this.segment.kind === Ia.MAP_VALUE) {
      if (!(e instanceof Map))
        throw new Error(`Invalid type. Expected Map, got ${e} (${typeof e})`);
      if (typeof this.segment.key == "string" || this.segment.key instanceof Uint8Array || this.segment.key instanceof $r) {
        const t = this.segment.key instanceof $r ? (
          // Decoded rawBinaryValue will always be a Uint8Array
          this.segment.key.rawBinaryValue
        ) : mo(this.segment.key), n = typeof this.segment.key == "string" || this.segment.key instanceof $r;
        for (const [a, o] of e) {
          let i;
          if (n ? a instanceof $r && (i = a.rawBinaryValue) : a instanceof Uint8Array && (i = a), i && Fa(t, i)) {
            this.resolvedCache = o;
            break;
          }
        }
      } else
        this.resolvedCache = e.get(this.segment.key);
      return this.resolvedCachePresent = !0, this.resolvedCache;
    }
    if (this.segment.kind === Ia.ARRAY_ELEMENT) {
      if (!Array.isArray(e))
        throw new Error(`Invalid type. Expected Array, got ${e} (${typeof e})`);
      return this.resolvedCache = e[this.segment.key], this.resolvedCachePresent = !0, this.resolvedCache;
    }
    throw new Error(`Invalid segment kind: ${this.segment.kind}`);
  }
  /**
   * Get the path string of the current location indicated by the provider. Useful for debugging.
   */
  getPathString() {
    const e = this.parent ? this.parent.getPathString() : "root";
    return this.segment ? this.segment.kind === Ia.MAP_VALUE ? `${e} -> map key "${this.segment.key}" (${typeof this.segment.key})` : this.segment.kind === Ia.ARRAY_ELEMENT ? `${e} -> array index ${this.segment.key} (${typeof this.segment.key})` : `${e} -> unknown segment kind ${this.segment.kind}` : e;
  }
}
class zr {
}
function gn(r, e) {
  const t = pS(r), n = new El({
    baseObjectBytes: r
  });
  return e.fromEncodingData(e.encodingSchema.fromPreparedMsgpack(t, n));
}
function pu(r) {
  return T5(r.getEncodingSchema().prepareMsgpack(r.toEncodingData()));
}
function Zt(r, e) {
  const t = b5(r, {
    intDecoding: Qn.BIGINT
  });
  return e.fromEncodingData(e.encodingSchema.fromPreparedJSON(t));
}
class Ot extends zr {
  defaultValue() {
    return !1;
  }
  isDefaultValue(e) {
    return e === !1;
  }
  prepareMsgpack(e) {
    if (typeof e == "boolean")
      return e;
    throw new Error("Invalid boolean");
  }
  fromPreparedMsgpack(e, t) {
    if (typeof e == "boolean")
      return e;
    throw new Error("Invalid boolean");
  }
  prepareJSON(e, t) {
    if (typeof e == "boolean")
      return e;
    throw new Error("Invalid boolean");
  }
  fromPreparedJSON(e) {
    if (typeof e == "boolean")
      return e;
    throw new Error("Invalid boolean");
  }
}
class Xe extends zr {
  defaultValue() {
    return "";
  }
  isDefaultValue(e) {
    return e === "";
  }
  prepareMsgpack(e) {
    if (typeof e == "string")
      return e;
    throw new Error(`Invalid string: (${typeof e}) ${e}`);
  }
  fromPreparedMsgpack(e, t) {
    if (typeof e == "string")
      return e;
    throw new Error(`Invalid string: (${typeof e}) ${e}`);
  }
  prepareJSON(e, t) {
    if (typeof e == "string")
      return e;
    throw new Error(`Invalid string: (${typeof e}) ${e}`);
  }
  fromPreparedJSON(e) {
    if (typeof e == "string")
      return e;
    throw new Error(`Invalid string: (${typeof e}) ${e}`);
  }
}
class se extends zr {
  defaultValue() {
    return BigInt(0);
  }
  isDefaultValue(e) {
    return typeof e == "bigint" ? e === BigInt(0) : typeof e == "number" ? e === 0 : !1;
  }
  prepareMsgpack(e) {
    return rr(e);
  }
  fromPreparedMsgpack(e, t) {
    return rr(e);
  }
  prepareJSON(e, t) {
    return rr(e);
  }
  fromPreparedJSON(e) {
    return rr(e);
  }
}
class Nt extends zr {
  defaultValue() {
    return Bt.zeroAddress();
  }
  isDefaultValue(e) {
    return Bt.zeroAddress().equals(e);
  }
  prepareMsgpack(e) {
    if (e instanceof Bt)
      return e.publicKey;
    throw new Error(`Invalid address: (${typeof e}) ${e}`);
  }
  fromPreparedMsgpack(e, t) {
    return new Bt(e);
  }
  prepareJSON(e, t) {
    if (e instanceof Bt)
      return e.toString();
    throw new Error(`Invalid address: (${typeof e}) ${e}`);
  }
  fromPreparedJSON(e) {
    return Bt.fromString(e);
  }
}
class ct extends zr {
  defaultValue() {
    return new Uint8Array();
  }
  isDefaultValue(e) {
    return e instanceof Uint8Array && e.byteLength === 0;
  }
  prepareMsgpack(e) {
    if (e instanceof Uint8Array)
      return e;
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
  fromPreparedMsgpack(e, t) {
    if (e instanceof Uint8Array)
      return e;
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
  prepareJSON(e, t) {
    if (e instanceof Uint8Array)
      return Co(e);
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
  fromPreparedJSON(e) {
    if (typeof e == "string")
      return Tt(e);
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
}
class Vt extends zr {
  constructor(e) {
    super(), this.length = e;
  }
  defaultValue() {
    return new Uint8Array(this.length);
  }
  isDefaultValue(e) {
    return e instanceof Uint8Array && e.byteLength === this.length && e.every((t) => t === 0);
  }
  prepareMsgpack(e) {
    if (e instanceof Uint8Array) {
      if (e.byteLength === this.length)
        return e;
      throw new Error(`Invalid byte array length: wanted ${this.length}, got ${e.byteLength}`);
    }
    throw new Error("Invalid byte array");
  }
  fromPreparedMsgpack(e, t) {
    if (e instanceof Uint8Array) {
      if (e.byteLength === this.length)
        return e;
      throw new Error(`Invalid byte array length: wanted ${this.length}, got ${e.byteLength}`);
    }
    throw new Error("Invalid byte array");
  }
  prepareJSON(e) {
    if (e instanceof Uint8Array) {
      if (e.byteLength === this.length)
        return Co(e);
      throw new Error(`Invalid byte array length: wanted ${this.length}, got ${e.byteLength}`);
    }
    throw new Error("Invalid byte array");
  }
  fromPreparedJSON(e) {
    if (typeof e == "string") {
      const t = Tt(e);
      if (t.byteLength === this.length)
        return t;
      throw new Error(`Invalid byte array length: wanted ${this.length}, got ${t.byteLength}`);
    }
    throw new Error("Invalid base64 byte array");
  }
}
const ms = 32, t2 = 52;
class mS extends zr {
  defaultValue() {
    return new Uint8Array(ms);
  }
  isDefaultValue(e) {
    return e instanceof Uint8Array && e.byteLength === ms && e.every((t) => t === 0);
  }
  prepareMsgpack(e) {
    if (e instanceof Uint8Array && e.byteLength === ms)
      return e;
    throw new Error(`Invalid block hash: (${typeof e}) ${e}`);
  }
  fromPreparedMsgpack(e, t) {
    if (e instanceof Uint8Array && e.byteLength === ms)
      return e;
    throw new Error(`Invalid block hash: (${typeof e}) ${e}`);
  }
  prepareJSON(e, t) {
    if (e instanceof Uint8Array && e.byteLength === ms)
      return `blk-${Ls.encode(e).slice(0, t2)}`;
    throw new Error(`Invalid block hash: (${typeof e}) ${e}`);
  }
  fromPreparedJSON(e) {
    if (typeof e == "string" && e.length === t2 + 4 && e.startsWith("blk-"))
      return Uint8Array.from(Ls.decode.asBytes(e.slice(4)));
    throw new Error(`Invalid block hash: (${typeof e}) ${e}`);
  }
}
class Yo extends zr {
  defaultValue() {
    return new Uint8Array();
  }
  isDefaultValue(e) {
    return e instanceof Uint8Array && e.byteLength === 0;
  }
  prepareMsgpack(e) {
    if (e instanceof Uint8Array)
      return new $r(e);
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
  fromPreparedMsgpack(e, t) {
    return t.getRawStringAtCurrentLocation();
  }
  prepareJSON(e, t) {
    if (e instanceof Uint8Array) {
      const n = Pd(e);
      if (!t.lossyBinaryStringConversion && !Fa(mo(n), e))
        throw new Error(`Invalid UTF-8 byte array encountered. Encode with lossyBinaryStringConversion enabled to bypass this check. Base64 value: ${Co(e)}`);
      return n;
    }
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
  fromPreparedJSON(e) {
    if (typeof e == "string")
      return mo(e);
    throw new Error(`Invalid byte array: (${typeof e}) ${e}`);
  }
}
class We extends zr {
  constructor(e) {
    super(), this.itemSchema = e;
  }
  defaultValue() {
    return [];
  }
  isDefaultValue(e) {
    return Array.isArray(e) && e.length === 0;
  }
  prepareMsgpack(e) {
    if (Array.isArray(e))
      return e.map((t) => this.itemSchema.prepareMsgpack(t));
    throw new Error("ArraySchema data must be an array");
  }
  fromPreparedMsgpack(e, t) {
    if (Array.isArray(e))
      return e.map((n, a) => this.itemSchema.fromPreparedMsgpack(n, t.withArrayElement(a)));
    throw new Error(`ArraySchema encoded data must be an array: ${e} (${typeof e})`);
  }
  prepareJSON(e, t) {
    if (Array.isArray(e))
      return e.map((n) => this.itemSchema.prepareJSON(n, t));
    throw new Error("ArraySchema data must be an array");
  }
  fromPreparedJSON(e) {
    if (Array.isArray(e))
      return e.map((t) => this.itemSchema.fromPreparedJSON(t));
    throw new Error(`ArraySchema encoded data must be an array: ${e} (${typeof e})`);
  }
}
function tt(r) {
  return r.map((e) => ({ ...e, omitEmpty: !0 }));
}
class be extends zr {
  constructor(e) {
    super(), this.entries = e, this.checkEntries();
  }
  /**
   * Adds new entries to the map schema. WARNING: this is a mutable operation, and you should be very
   * careful when using it. Any error that happens here is non-recoverable and will corrupt the
   * NamedMapSchema object;
   * @param entries - The entries to add.
   */
  pushEntries(...e) {
    this.entries.push(...e), this.checkEntries();
  }
  checkEntries() {
    for (const t of this.entries)
      if (t.embedded) {
        if (t.key !== "")
          throw new Error("Embedded entries must have an empty key");
        if (!(t.valueSchema instanceof be))
          throw new Error("Embedded entry valueSchema must be a NamedMapSchema");
      }
    const e = /* @__PURE__ */ new Set();
    for (const t of this.getEntries()) {
      if (e.has(t.key))
        throw new Error(`Duplicate key: ${t.key}`);
      e.add(t.key);
    }
  }
  /**
   * Returns all top-level entries, properly accounting for fields from embedded entries.
   * @returns An array of all top-level entries for this map.
   */
  getEntries() {
    const e = [];
    for (const t of this.entries)
      if (t.embedded) {
        const n = t.valueSchema;
        e.push(...n.getEntries());
      } else
        e.push(t);
    return e;
  }
  defaultValue() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this.getEntries())
      e.set(t.key, t.valueSchema.defaultValue());
    return e;
  }
  isDefaultValue(e) {
    if (!(e instanceof Map))
      return !1;
    for (const t of this.getEntries())
      if (!t.valueSchema.isDefaultValue(e.get(t.key)))
        return !1;
    return !0;
  }
  prepareMsgpack(e) {
    if (!(e instanceof Map))
      throw new Error(`NamedMapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const t = /* @__PURE__ */ new Map();
    for (const n of this.getEntries()) {
      const a = e.get(n.key);
      n.omitEmpty && n.valueSchema.isDefaultValue(a) || t.set(n.key, n.valueSchema.prepareMsgpack(a));
    }
    return t;
  }
  fromPreparedMsgpack(e, t) {
    if (!(e instanceof Map))
      throw new Error("NamedMapSchema data must be a Map");
    const n = /* @__PURE__ */ new Map();
    for (const a of this.getEntries())
      if (e.has(a.key))
        n.set(a.key, a.valueSchema.fromPreparedMsgpack(e.get(a.key), t.withMapValue(a.key)));
      else if (a.omitEmpty)
        n.set(a.key, a.valueSchema.defaultValue());
      else
        throw new Error(`Missing key: ${a.key}`);
    return n;
  }
  prepareJSON(e, t) {
    if (!(e instanceof Map))
      throw new Error("NamedMapSchema data must be a Map");
    const n = {};
    for (const a of this.getEntries()) {
      const o = e.get(a.key);
      a.omitEmpty && a.valueSchema.isDefaultValue(o) || (n[a.key] = a.valueSchema.prepareJSON(o, t));
    }
    return n;
  }
  fromPreparedJSON(e) {
    if (e == null || typeof e != "object" || Array.isArray(e))
      throw new Error("NamedMapSchema data must be an object");
    const t = /* @__PURE__ */ new Map();
    for (const n of this.getEntries())
      if (Object.prototype.hasOwnProperty.call(e, n.key))
        t.set(n.key, n.valueSchema.fromPreparedJSON(e[n.key]));
      else if (n.omitEmpty)
        t.set(n.key, n.valueSchema.defaultValue());
      else
        throw new Error(`Missing key: ${n.key}`);
    return t;
  }
}
function zi(...r) {
  const e = /* @__PURE__ */ new Map();
  for (const t of r)
    for (const [n, a] of t) {
      if (e.has(n))
        throw new Error(`Duplicate key: ${n}`);
      e.set(n, a);
    }
  return e;
}
function ur(r, e) {
  const t = /* @__PURE__ */ new Map();
  for (const [n, a] of r) {
    const [o, i] = e(n, a);
    t.set(o, i);
  }
  return t;
}
class gu extends zr {
  constructor(e) {
    super(), this.valueSchema = e;
  }
  defaultValue() {
    return /* @__PURE__ */ new Map();
  }
  isDefaultValue(e) {
    return e instanceof Map && e.size === 0;
  }
  prepareMsgpack(e) {
    if (!(e instanceof Map))
      throw new Error(`Uint64MapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of e) {
      const o = rr(n);
      if (t.has(o))
        throw new Error(`Duplicate key: ${o}`);
      t.set(o, this.valueSchema.prepareMsgpack(a));
    }
    return t;
  }
  fromPreparedMsgpack(e, t) {
    if (!(e instanceof Map))
      throw new Error("Uint64MapSchema data must be a Map");
    const n = /* @__PURE__ */ new Map();
    for (const [a, o] of e) {
      const i = rr(a);
      if (n.has(i))
        throw new Error(`Duplicate key: ${i}`);
      n.set(i, this.valueSchema.fromPreparedMsgpack(o, t.withMapValue(a)));
    }
    return n;
  }
  prepareJSON(e, t) {
    if (!(e instanceof Map))
      throw new Error(`Uint64MapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const n = /* @__PURE__ */ new Map();
    for (const [o, i] of e) {
      const s = rr(o);
      if (n.has(s))
        throw new Error(`Duplicate key: ${s}`);
      n.set(s, this.valueSchema.prepareJSON(i, t));
    }
    const a = {};
    for (const [o, i] of n)
      a[o.toString()] = i;
    return a;
  }
  fromPreparedJSON(e) {
    if (e == null || typeof e != "object" || Array.isArray(e))
      throw new Error("Uint64MapSchema data must be an object");
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of Object.entries(e)) {
      const o = BigInt(n);
      if (t.has(o))
        throw new Error(`Duplicate key: ${o}`);
      t.set(o, this.valueSchema.fromPreparedJSON(a));
    }
    return t;
  }
}
class yS extends zr {
  constructor(e) {
    super(), this.valueSchema = e;
  }
  defaultValue() {
    return /* @__PURE__ */ new Map();
  }
  isDefaultValue(e) {
    return e instanceof Map && e.size === 0;
  }
  prepareMsgpack(e) {
    if (!(e instanceof Map))
      throw new Error(`ByteArrayMapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of e) {
      if (!(n instanceof Uint8Array))
        throw new Error(`Invalid key: ${n} (${typeof n})`);
      t.set(n, this.valueSchema.prepareMsgpack(a));
    }
    return t;
  }
  fromPreparedMsgpack(e, t) {
    if (!(e instanceof Map))
      throw new Error("ByteArrayMapSchema data must be a Map");
    const n = /* @__PURE__ */ new Map();
    for (const [a, o] of e) {
      if (!(a instanceof Uint8Array))
        throw new Error(`Invalid key: ${a} (${typeof a})`);
      n.set(a, this.valueSchema.fromPreparedMsgpack(o, t.withMapValue(a)));
    }
    return n;
  }
  prepareJSON(e, t) {
    if (!(e instanceof Map))
      throw new Error(`ByteArrayMapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const n = /* @__PURE__ */ new Map();
    for (const [o, i] of e) {
      if (!(o instanceof Uint8Array))
        throw new Error(`Invalid key: ${o} (${typeof o})`);
      const s = Co(o);
      if (n.has(s))
        throw new Error(`Duplicate key (base64): ${s}`);
      n.set(s, this.valueSchema.prepareJSON(i, t));
    }
    const a = {};
    for (const [o, i] of n)
      a[o] = i;
    return a;
  }
  fromPreparedJSON(e) {
    if (e == null || typeof e != "object" || Array.isArray(e))
      throw new Error("ByteArrayMapSchema data must be an object");
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of Object.entries(e))
      t.set(Tt(n), this.valueSchema.fromPreparedJSON(a));
    return t;
  }
}
function cl(r) {
  if (r instanceof $r)
    return Pd(r.rawBinaryValue);
  if (r instanceof Map) {
    const e = /* @__PURE__ */ new Map();
    for (const [t, n] of r)
      e.set(cl(t), cl(n));
    return e;
  }
  return Array.isArray(r) ? r.map(cl) : r;
}
class Us extends zr {
  constructor(e) {
    super(), this.valueSchema = e;
  }
  defaultValue() {
    return /* @__PURE__ */ new Map();
  }
  isDefaultValue(e) {
    return e instanceof Map && e.size === 0;
  }
  prepareMsgpack(e) {
    if (!(e instanceof Map))
      throw new Error(`SpecialCaseBinaryStringMapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of e) {
      if (!(n instanceof Uint8Array))
        throw new Error(`Invalid key: ${n} (${typeof n})`);
      t.set(new $r(n), this.valueSchema.prepareMsgpack(a));
    }
    return t;
  }
  fromPreparedMsgpack(e, t) {
    const n = /* @__PURE__ */ new Map(), a = t.getRawStringKeysAndValuesAtCurrentLocation();
    for (const [o, i] of a)
      n.set(o, this.valueSchema.fromPreparedMsgpack(cl(i), t.withMapValue(new $r(o))));
    return n;
  }
  prepareJSON(e, t) {
    if (!(e instanceof Map))
      throw new Error(`SpecialCaseBinaryStringMapSchema data must be a Map. Got (${typeof e}) ${e}`);
    const n = /* @__PURE__ */ new Map();
    for (const [o, i] of e) {
      if (!(o instanceof Uint8Array))
        throw new Error(`Invalid key: ${o}`);
      const s = Pd(o);
      if (!t.lossyBinaryStringConversion && !Fa(mo(s), o))
        throw new Error(`Invalid UTF-8 byte array encountered. Encode with lossyBinaryStringConversion enabled to bypass this check. Base64 value: ${Co(o)}`);
      n.set(s, this.valueSchema.prepareJSON(i, t));
    }
    const a = {};
    for (const [o, i] of n)
      a[o] = i;
    return a;
  }
  fromPreparedJSON(e) {
    if (e == null || typeof e != "object" || Array.isArray(e))
      throw new Error("SpecialCaseBinaryStringMapSchema data must be an object");
    const t = /* @__PURE__ */ new Map();
    for (const [n, a] of Object.entries(e))
      t.set(mo(n), this.valueSchema.fromPreparedJSON(a));
    return t;
  }
}
class ne extends zr {
  constructor(e) {
    super(), this.valueSchema = e;
  }
  defaultValue() {
  }
  isDefaultValue(e) {
    return e === void 0 || this.valueSchema.isDefaultValue(e);
  }
  prepareMsgpack(e) {
    if (e !== void 0)
      return this.valueSchema.prepareMsgpack(e);
  }
  fromPreparedMsgpack(e, t) {
    if (e != null)
      return this.valueSchema.fromPreparedMsgpack(e, t);
  }
  prepareJSON(e, t) {
    return e === void 0 ? null : this.valueSchema.prepareJSON(e, t);
  }
  fromPreparedJSON(e) {
    if (e != null)
      return this.valueSchema.fromPreparedJSON(e);
  }
}
class O5 extends zr {
  defaultValue() {
  }
  isDefaultValue(e) {
    return e === void 0;
  }
  prepareMsgpack(e) {
    return e;
  }
  fromPreparedMsgpack(e, t) {
    return e;
  }
  prepareJSON(e, t) {
    return L1(e);
  }
  fromPreparedJSON(e) {
    return U1(e);
  }
}
function wS(r, e, t) {
  const n = BigInt(r.appIndex), a = r.name, o = n === BigInt(0) || n === t, i = e.indexOf(n) + 1;
  if (i === 0 && !o)
    throw new Error(`Box ref with appId ${n} not in foreign-apps`);
  return /* @__PURE__ */ new Map([
    ["i", i],
    ["n", a]
  ]);
}
function vS(r, e, t) {
  const n = BigInt(t), a = e.map(BigInt);
  return r.map((o) => wS(o, a, n));
}
var zt;
(function(r) {
  r.pay = "pay", r.keyreg = "keyreg", r.acfg = "acfg", r.axfer = "axfer", r.afrz = "afrz", r.appl = "appl", r.stpf = "stpf", r.hb = "hb";
})(zt || (zt = {}));
function r2(r) {
  return r === zt.pay || r === zt.keyreg || r === zt.acfg || r === zt.axfer || r === zt.afrz || r === zt.appl || r === zt.stpf || r === zt.hb;
}
var Ta;
(function(r) {
  r[r.NoOpOC = 0] = "NoOpOC", r[r.OptInOC = 1] = "OptInOC", r[r.CloseOutOC = 2] = "CloseOutOC", r[r.ClearStateOC = 3] = "ClearStateOC", r[r.UpdateApplicationOC = 4] = "UpdateApplicationOC", r[r.DeleteApplicationOC = 5] = "DeleteApplicationOC";
})(Ta || (Ta = {}));
function _S(r) {
  return r === Ta.NoOpOC || r === Ta.OptInOC || r === Ta.CloseOutOC || r === Ta.ClearStateOC || r === Ta.UpdateApplicationOC || r === Ta.DeleteApplicationOC;
}
class Qo {
  constructor(e) {
    this.hashType = e.hashType;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Qo.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["t", this.hashType]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded HashFactory: ${e}`);
    return new Qo({
      hashType: Number(e.get("t"))
    });
  }
}
Qo.encodingSchema = new be(tt([
  { key: "t", valueSchema: new se() }
  // hashType
]));
class zn {
  constructor(e) {
    this.path = e.path, this.hashFactory = e.hashFactory, this.treeDepth = e.treeDepth;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return zn.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["pth", this.path],
      ["hsh", this.hashFactory.toEncodingData()],
      ["td", this.treeDepth]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded MerkleArrayProof: ${e}`);
    return new zn({
      path: e.get("pth"),
      hashFactory: Qo.fromEncodingData(e.get("hsh")),
      treeDepth: Number(e.get("td"))
    });
  }
}
zn.encodingSchema = new be(tt([
  {
    key: "pth",
    // path
    valueSchema: new We(new ct())
  },
  {
    key: "hsh",
    // hashFactory
    valueSchema: Qo.encodingSchema
  },
  {
    key: "td",
    // treeDepth
    valueSchema: new se()
  }
]));
class ei {
  constructor(e) {
    this.commitment = e.commitment, this.keyLifetime = e.keyLifetime;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ei.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["cmt", this.commitment],
      ["lf", this.keyLifetime]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded MerkleSignatureVerifier: ${e}`);
    return new ei({
      commitment: e.get("cmt"),
      keyLifetime: e.get("lf")
    });
  }
}
ei.encodingSchema = new be(tt([
  {
    key: "cmt",
    // commitment
    valueSchema: new Vt(64)
  },
  {
    key: "lf",
    // keyLifetime
    valueSchema: new se()
  }
]));
class ti {
  constructor(e) {
    this.pk = e.pk, this.weight = e.weight;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ti.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["p", this.pk.toEncodingData()],
      ["w", this.weight]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Participant: ${e}`);
    return new ti({
      pk: ei.fromEncodingData(e.get("p")),
      weight: e.get("w")
    });
  }
}
ti.encodingSchema = new be(tt([
  {
    key: "p",
    // pk
    valueSchema: ei.encodingSchema
  },
  {
    key: "w",
    // weight
    valueSchema: new se()
  }
]));
class ri {
  constructor(e) {
    this.publicKey = e.publicKey;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ri.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["k", this.publicKey]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded FalconVerifier: ${e}`);
    return new ri({
      publicKey: e.get("k")
    });
  }
}
ri.encodingSchema = new be(tt([
  { key: "k", valueSchema: new Vt(1793) }
  // publicKey
]));
class ni {
  constructor(e) {
    this.signature = e.signature, this.vectorCommitmentIndex = e.index, this.proof = e.proof, this.verifyingKey = e.verifyingKey;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ni.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["sig", this.signature],
      ["idx", this.vectorCommitmentIndex],
      ["prf", this.proof.toEncodingData()],
      ["vkey", this.verifyingKey.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded FalconSignatureStruct: ${e}`);
    return new ni({
      signature: e.get("sig"),
      index: e.get("idx"),
      proof: zn.fromEncodingData(e.get("prf")),
      verifyingKey: ri.fromEncodingData(e.get("vkey"))
    });
  }
}
ni.encodingSchema = new be(tt([
  { key: "sig", valueSchema: new ct() },
  // signature
  { key: "idx", valueSchema: new se() },
  // index
  { key: "prf", valueSchema: zn.encodingSchema },
  // proof
  { key: "vkey", valueSchema: ri.encodingSchema }
  // verifyingKey
]));
class ai {
  constructor(e) {
    this.sig = e.sig, this.l = e.l;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ai.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["s", this.sig.toEncodingData()],
      ["l", this.l]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SigslotCommit: ${e}`);
    return new ai({
      sig: ni.fromEncodingData(e.get("s")),
      l: e.get("l")
    });
  }
}
ai.encodingSchema = new be(tt([
  { key: "s", valueSchema: ni.encodingSchema },
  // sigslot
  { key: "l", valueSchema: new se() }
  // l
]));
class oi {
  constructor(e) {
    this.sigslot = e.sigslot, this.participant = e.participant;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return oi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["s", this.sigslot.toEncodingData()],
      ["p", this.participant.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Reveal: ${e}`);
    return new oi({
      sigslot: ai.fromEncodingData(e.get("s")),
      participant: ti.fromEncodingData(e.get("p"))
    });
  }
}
oi.encodingSchema = new be(tt([
  { key: "s", valueSchema: ai.encodingSchema },
  // sigslotCommit
  { key: "p", valueSchema: ti.encodingSchema }
  // participant
]));
let Bd = class V1 {
  constructor(e) {
    this.sigCommit = e.sigCommit, this.signedWeight = e.signedWeight, this.sigProofs = e.sigProofs, this.partProofs = e.partProofs, this.merkleSignatureSaltVersion = e.merkleSignatureSaltVersion, this.reveals = e.reveals, this.positionsToReveal = e.positionsToReveal;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return V1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["c", this.sigCommit],
      ["w", this.signedWeight],
      ["S", this.sigProofs.toEncodingData()],
      ["P", this.partProofs.toEncodingData()],
      ["v", this.merkleSignatureSaltVersion],
      [
        "r",
        ur(this.reveals, (e, t) => [e, t.toEncodingData()])
      ],
      ["pr", this.positionsToReveal]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded StateProof: ${e}`);
    return new V1({
      sigCommit: e.get("c"),
      signedWeight: e.get("w"),
      sigProofs: zn.fromEncodingData(e.get("S")),
      partProofs: zn.fromEncodingData(e.get("P")),
      merkleSignatureSaltVersion: Number(e.get("v")),
      reveals: ur(e.get("r"), (t, n) => [
        t,
        oi.fromEncodingData(n)
      ]),
      positionsToReveal: e.get("pr")
    });
  }
};
Bd.encodingSchema = new be(tt([
  {
    key: "c",
    // sigCommit
    valueSchema: new ct()
  },
  {
    key: "w",
    // signedWeight
    valueSchema: new se()
  },
  {
    key: "S",
    // sigProofs
    valueSchema: zn.encodingSchema
  },
  {
    key: "P",
    // partProofs
    valueSchema: zn.encodingSchema
  },
  {
    key: "v",
    // merkleSignatureSaltVersion
    valueSchema: new se()
  },
  {
    key: "r",
    // reveals
    valueSchema: new gu(oi.encodingSchema)
  },
  {
    key: "pr",
    // positionsToReveal
    valueSchema: new We(new se())
  }
]));
let Ld = class ll {
  constructor(e) {
    this.blockHeadersCommitment = e.blockHeadersCommitment, this.votersCommitment = e.votersCommitment, this.lnProvenWeight = e.lnProvenWeight, this.firstAttestedRound = e.firstAttestedRound, this.lastAttestedRound = e.lastAttestedRound;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ll.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["b", this.blockHeadersCommitment],
      ["v", this.votersCommitment],
      ["P", this.lnProvenWeight],
      ["f", this.firstAttestedRound],
      ["l", this.lastAttestedRound]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded StateProofMessage: ${e}`);
    return new ll({
      blockHeadersCommitment: e.get("b"),
      votersCommitment: e.get("v"),
      lnProvenWeight: e.get("P"),
      firstAttestedRound: e.get("f"),
      lastAttestedRound: e.get("l")
    });
  }
  static fromMap(e) {
    return new ll({
      blockHeadersCommitment: e.get("b"),
      votersCommitment: e.get("v"),
      lnProvenWeight: e.get("P"),
      firstAttestedRound: e.get("f"),
      lastAttestedRound: e.get("l")
    });
  }
};
Ld.encodingSchema = new be(tt([
  { key: "b", valueSchema: new ct() },
  // blockHeadersCommitment
  { key: "v", valueSchema: new ct() },
  // votersCommitment
  { key: "P", valueSchema: new se() },
  // lnProvenWeight
  { key: "f", valueSchema: new se() },
  // firstAttestedRound
  { key: "l", valueSchema: new se() }
  // lastAttestedRound
]));
class ii {
  constructor(e) {
    this.sig = e.sig, this.pk = e.pk, this.pk2 = e.pk2, this.pk1Sig = e.pk1Sig, this.pk2Sig = e.pk2Sig;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ii.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["s", this.sig],
      ["p", this.pk],
      ["p2", this.pk2],
      ["p1s", this.pk1Sig],
      ["p2s", this.pk2Sig]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded HeartbeatProof: ${e}`);
    return new ii({
      sig: e.get("s"),
      pk: e.get("p"),
      pk2: e.get("p2"),
      pk1Sig: e.get("p1s"),
      pk2Sig: e.get("p2s")
    });
  }
}
ii.encodingSchema = new be(tt([
  {
    key: "s",
    // Sig
    valueSchema: new Vt(64)
  },
  {
    key: "p",
    // PK
    valueSchema: new Vt(32)
  },
  {
    key: "p2",
    // PK2
    valueSchema: new Vt(32)
  },
  {
    key: "p1s",
    // PK1Sig
    valueSchema: new Vt(64)
  },
  {
    key: "p2s",
    // PK2Sig
    valueSchema: new Vt(64)
  }
]));
class Ua {
  constructor(e) {
    this.address = e.address, this.proof = e.proof, this.seed = e.seed, this.voteID = e.voteID, this.keyDilution = e.keyDilution;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ua.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["a", this.address],
      ["prf", this.proof.toEncodingData()],
      ["sd", this.seed],
      ["vid", this.voteID],
      ["kd", this.keyDilution]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Heartbeat: ${e}`);
    return new Ua({
      address: e.get("a"),
      proof: ii.fromEncodingData(e.get("prf")),
      seed: e.get("sd"),
      voteID: e.get("vid"),
      keyDilution: e.get("kd")
    });
  }
}
Ua.encodingSchema = new be(tt([
  {
    key: "a",
    // HbAddress
    valueSchema: new Nt()
  },
  {
    key: "prf",
    // HbProof
    valueSchema: ii.encodingSchema
  },
  {
    key: "sd",
    // HbSeed
    valueSchema: new ct()
  },
  {
    key: "vid",
    // HbVoteID
    valueSchema: new Vt(32)
  },
  {
    key: "kd",
    // HbKeyDilution
    valueSchema: new se()
  }
]));
const bS = 52, SS = 32, ES = 75, xS = 32, kS = 32, AS = 32, CS = 64, DS = 32;
function P5(r) {
  return r.every((e) => e === 0);
}
function e1(r, e, t) {
  if (r == null)
    return;
  let n;
  if (r instanceof Uint8Array && (n = r), n == null || n.byteLength !== t)
    throw Error(`${e} must be a ${t} byte Uint8Array`);
  return n;
}
function jo(r) {
  if (r == null)
    throw new Error("Address must not be null or undefined");
  if (typeof r == "string")
    return Bt.fromString(r);
  if (r instanceof Bt)
    return r;
  throw new Error(`Not an address: ${r}`);
}
function Da(r) {
  if (r == null)
    return;
  let e;
  if (r instanceof Bt)
    e = r;
  else if (typeof r == "string")
    e = Bt.fromString(r);
  else
    throw new Error(`Not an address: ${r}`);
  if (P5(e.publicKey))
    throw new Error("Invalid use of the zero address. To omit this value, pass in undefined");
  return e;
}
function N5(r) {
  if (!(typeof r > "u")) {
    if (r instanceof Uint8Array)
      return r;
    throw new Error(`Not a Uint8Array: ${r}`);
  }
}
function Ja(r) {
  if (r instanceof Uint8Array)
    return r;
  throw new Error(`Not a Uint8Array: ${r}`);
}
function t1(r) {
  if (!(typeof r > "u"))
    return rr(r);
}
function Gc(r) {
  if (r === !0 || r === !1)
    return r;
  throw new Error(`Not a boolean: ${r}`);
}
function ys(r) {
  if (Array.isArray(r))
    return r.slice();
  throw new Error(`Not an array: ${r}`);
}
function n2(r, e, t) {
  const n = N5(r);
  if (!(typeof n > "u")) {
    if (n.byteLength !== e)
      throw new Error(`${t} must be ${e} bytes long, was ${n.byteLength}`);
    if (!P5(n))
      return n;
  }
}
function MS(r) {
  if (r != null && typeof r == "object") {
    const { appIndex: e, name: t } = r;
    return {
      appIndex: rr(e),
      name: Ja(t)
    };
  }
  throw new Error(`Not a box reference: ${r}`);
}
const a2 = new TextEncoder().encode("TX");
class Va {
  constructor(e) {
    if (!r2(e.type))
      throw new Error(`Invalid transaction type: ${e.type}`);
    if (this.type = e.type, this.sender = jo(e.sender), this.note = Ja(e.note ?? new Uint8Array()), this.lease = n2(e.lease, SS, "lease"), this.rekeyTo = Da(e.rekeyTo), this.group = void 0, this.firstValid = rr(e.suggestedParams.firstValid), this.lastValid = rr(e.suggestedParams.lastValid), e.suggestedParams.genesisID) {
      if (typeof e.suggestedParams.genesisID != "string")
        throw new Error("Genesis ID must be a string if present");
      this.genesisID = e.suggestedParams.genesisID;
    }
    this.genesisHash = N5(e.suggestedParams.genesisHash);
    const t = [];
    if (e.paymentParams && t.push(zt.pay), e.keyregParams && t.push(zt.keyreg), e.assetConfigParams && t.push(zt.acfg), e.assetTransferParams && t.push(zt.axfer), e.assetFreezeParams && t.push(zt.afrz), e.appCallParams && t.push(zt.appl), e.stateProofParams && t.push(zt.stpf), e.heartbeatParams && t.push(zt.hb), t.length !== 1)
      throw new Error(`Transaction has wrong number of type fields present (${t.length}): ${t}`);
    if (this.type !== t[0])
      throw new Error(`Transaction has type ${this.type} but fields present for ${t[0]}`);
    if (e.paymentParams && (this.payment = {
      receiver: jo(e.paymentParams.receiver),
      amount: rr(e.paymentParams.amount),
      closeRemainderTo: Da(e.paymentParams.closeRemainderTo)
    }), e.keyregParams) {
      if (this.keyreg = {
        voteKey: e1(e.keyregParams.voteKey, "voteKey", kS),
        selectionKey: e1(e.keyregParams.selectionKey, "selectionKey", AS),
        stateProofKey: e1(e.keyregParams.stateProofKey, "stateProofKey", CS),
        voteFirst: t1(e.keyregParams.voteFirst),
        voteLast: t1(e.keyregParams.voteLast),
        voteKeyDilution: t1(e.keyregParams.voteKeyDilution),
        nonParticipation: Gc(e.keyregParams.nonParticipation ?? !1)
      }, this.keyreg.nonParticipation && (this.keyreg.voteKey || this.keyreg.selectionKey || this.keyreg.stateProofKey || typeof this.keyreg.voteFirst < "u" || typeof this.keyreg.voteLast < "u" || typeof this.keyreg.voteKeyDilution < "u"))
        throw new Error("nonParticipation is true but participation params are present.");
      if (
        // If we are participating
        !this.keyreg.nonParticipation && // And *ANY* participating fields are present
        (this.keyreg.voteKey || this.keyreg.selectionKey || this.keyreg.stateProofKey || typeof this.keyreg.voteFirst < "u" || typeof this.keyreg.voteLast < "u" || typeof this.keyreg.voteKeyDilution < "u") && // Then *ALL* participating fields must be present (with an exception for stateProofKey,
        // which was introduced later so for backwards compatibility we don't require it)
        !(this.keyreg.voteKey && this.keyreg.selectionKey && typeof this.keyreg.voteFirst < "u" && typeof this.keyreg.voteLast < "u" && typeof this.keyreg.voteKeyDilution < "u")
      )
        throw new Error("Online key registration missing at least one of the following fields: voteKey, selectionKey, voteFirst, voteLast, voteKeyDilution");
    }
    if (e.assetConfigParams && (this.assetConfig = {
      assetIndex: rr(e.assetConfigParams.assetIndex ?? 0),
      total: rr(e.assetConfigParams.total ?? 0),
      decimals: An(e.assetConfigParams.decimals ?? 0),
      defaultFrozen: Gc(e.assetConfigParams.defaultFrozen ?? !1),
      manager: Da(e.assetConfigParams.manager),
      reserve: Da(e.assetConfigParams.reserve),
      freeze: Da(e.assetConfigParams.freeze),
      clawback: Da(e.assetConfigParams.clawback),
      unitName: e.assetConfigParams.unitName,
      assetName: e.assetConfigParams.assetName,
      assetURL: e.assetConfigParams.assetURL,
      assetMetadataHash: n2(e.assetConfigParams.assetMetadataHash, xS, "assetMetadataHash")
    }), e.assetTransferParams && (this.assetTransfer = {
      assetIndex: rr(e.assetTransferParams.assetIndex),
      amount: rr(e.assetTransferParams.amount),
      assetSender: Da(e.assetTransferParams.assetSender),
      receiver: jo(e.assetTransferParams.receiver),
      closeRemainderTo: Da(e.assetTransferParams.closeRemainderTo)
    }), e.assetFreezeParams && (this.assetFreeze = {
      assetIndex: rr(e.assetFreezeParams.assetIndex),
      freezeAccount: jo(e.assetFreezeParams.freezeTarget),
      frozen: Gc(e.assetFreezeParams.frozen)
    }), e.appCallParams) {
      const { onComplete: n } = e.appCallParams;
      if (!_S(n))
        throw new Error(`Invalid onCompletion value: ${n}`);
      this.applicationCall = {
        appIndex: rr(e.appCallParams.appIndex),
        onComplete: n,
        numLocalInts: An(e.appCallParams.numLocalInts ?? 0),
        numLocalByteSlices: An(e.appCallParams.numLocalByteSlices ?? 0),
        numGlobalInts: An(e.appCallParams.numGlobalInts ?? 0),
        numGlobalByteSlices: An(e.appCallParams.numGlobalByteSlices ?? 0),
        extraPages: An(e.appCallParams.extraPages ?? 0),
        approvalProgram: Ja(e.appCallParams.approvalProgram ?? new Uint8Array()),
        clearProgram: Ja(e.appCallParams.clearProgram ?? new Uint8Array()),
        appArgs: ys(e.appCallParams.appArgs ?? []).map(Ja),
        accounts: ys(e.appCallParams.accounts ?? []).map(jo),
        foreignApps: ys(e.appCallParams.foreignApps ?? []).map(rr),
        foreignAssets: ys(e.appCallParams.foreignAssets ?? []).map(rr),
        boxes: ys(e.appCallParams.boxes ?? []).map(MS)
      };
    }
    if (e.stateProofParams && (this.stateProof = {
      stateProofType: An(e.stateProofParams.stateProofType ?? 0),
      stateProof: e.stateProofParams.stateProof,
      message: e.stateProofParams.message
    }), e.heartbeatParams && (this.heartbeat = new Ua({
      address: e.heartbeatParams.address,
      proof: e.heartbeatParams.proof,
      seed: e.heartbeatParams.seed,
      voteID: e.heartbeatParams.voteID,
      keyDilution: e.heartbeatParams.keyDilution
    })), this.fee = rr(e.suggestedParams.fee), !Gc(e.suggestedParams.flatFee ?? !1)) {
      const n = rr(e.suggestedParams.minFee);
      this.fee *= BigInt(this.estimateSize()), this.fee < n && (this.fee = n);
    }
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Va.encodingSchema;
  }
  toEncodingData() {
    const e = /* @__PURE__ */ new Map([
      ["type", this.type],
      ["fv", this.firstValid],
      ["lv", this.lastValid],
      ["snd", this.sender],
      ["gen", this.genesisID],
      ["gh", this.genesisHash],
      ["fee", this.fee],
      ["note", this.note],
      ["lx", this.lease],
      ["rekey", this.rekeyTo],
      ["grp", this.group]
    ]);
    if (this.payment)
      return e.set("amt", this.payment.amount), e.set("rcv", this.payment.receiver), e.set("close", this.payment.closeRemainderTo), e;
    if (this.keyreg)
      return e.set("votekey", this.keyreg.voteKey), e.set("selkey", this.keyreg.selectionKey), e.set("sprfkey", this.keyreg.stateProofKey), e.set("votefst", this.keyreg.voteFirst), e.set("votelst", this.keyreg.voteLast), e.set("votekd", this.keyreg.voteKeyDilution), e.set("nonpart", this.keyreg.nonParticipation), e;
    if (this.assetConfig) {
      e.set("caid", this.assetConfig.assetIndex);
      const t = /* @__PURE__ */ new Map([
        ["t", this.assetConfig.total],
        ["dc", this.assetConfig.decimals],
        ["df", this.assetConfig.defaultFrozen],
        ["m", this.assetConfig.manager],
        ["r", this.assetConfig.reserve],
        ["f", this.assetConfig.freeze],
        ["c", this.assetConfig.clawback],
        ["un", this.assetConfig.unitName],
        ["an", this.assetConfig.assetName],
        ["au", this.assetConfig.assetURL],
        ["am", this.assetConfig.assetMetadataHash]
      ]);
      return e.set("apar", t), e;
    }
    if (this.assetTransfer)
      return e.set("xaid", this.assetTransfer.assetIndex), e.set("aamt", this.assetTransfer.amount), e.set("arcv", this.assetTransfer.receiver), e.set("aclose", this.assetTransfer.closeRemainderTo), e.set("asnd", this.assetTransfer.assetSender), e;
    if (this.assetFreeze)
      return e.set("faid", this.assetFreeze.assetIndex), e.set("afrz", this.assetFreeze.frozen), e.set("fadd", this.assetFreeze.freezeAccount), e;
    if (this.applicationCall)
      return e.set("apid", this.applicationCall.appIndex), e.set("apan", this.applicationCall.onComplete), e.set("apaa", this.applicationCall.appArgs), e.set("apat", this.applicationCall.accounts), e.set("apas", this.applicationCall.foreignAssets), e.set("apfa", this.applicationCall.foreignApps), e.set("apbx", vS(this.applicationCall.boxes, this.applicationCall.foreignApps, this.applicationCall.appIndex)), e.set("apap", this.applicationCall.approvalProgram), e.set("apsu", this.applicationCall.clearProgram), e.set("apls", /* @__PURE__ */ new Map([
        ["nui", this.applicationCall.numLocalInts],
        ["nbs", this.applicationCall.numLocalByteSlices]
      ])), e.set("apgs", /* @__PURE__ */ new Map([
        ["nui", this.applicationCall.numGlobalInts],
        ["nbs", this.applicationCall.numGlobalByteSlices]
      ])), e.set("apep", this.applicationCall.extraPages), e;
    if (this.stateProof)
      return e.set("sptype", this.stateProof.stateProofType), e.set("sp", this.stateProof.stateProof ? this.stateProof.stateProof.toEncodingData() : void 0), e.set("spmsg", this.stateProof.message ? this.stateProof.message.toEncodingData() : void 0), e;
    if (this.heartbeat) {
      const t = new Ua({
        address: this.heartbeat.address,
        proof: this.heartbeat.proof,
        seed: this.heartbeat.seed,
        voteID: this.heartbeat.voteID,
        keyDilution: this.heartbeat.keyDilution
      });
      return e.set("hb", t.toEncodingData()), e;
    }
    throw new Error(`Unexpected transaction type: ${this.type}`);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded logic sig account: ${e}`);
    const t = {
      minFee: BigInt(0),
      flatFee: !0,
      fee: e.get("fee") ?? 0,
      firstValid: e.get("fv") ?? 0,
      lastValid: e.get("lv") ?? 0,
      genesisHash: e.get("gh"),
      genesisID: e.get("gen")
    }, n = e.get("type");
    if (!r2(n))
      throw new Error(`Unrecognized transaction type: ${n}`);
    const a = {
      type: n,
      sender: e.get("snd") ?? Bt.zeroAddress(),
      note: e.get("note"),
      lease: e.get("lx"),
      suggestedParams: t
    };
    if (e.get("rekey") && (a.rekeyTo = e.get("rekey")), a.type === zt.pay) {
      const i = {
        amount: e.get("amt") ?? 0,
        receiver: e.get("rcv") ?? Bt.zeroAddress()
      };
      e.get("close") && (i.closeRemainderTo = e.get("close")), a.paymentParams = i;
    } else if (a.type === zt.keyreg) {
      const i = {
        voteKey: e.get("votekey"),
        selectionKey: e.get("selkey"),
        stateProofKey: e.get("sprfkey"),
        voteFirst: e.get("votefst"),
        voteLast: e.get("votelst"),
        voteKeyDilution: e.get("votekd"),
        nonParticipation: e.get("nonpart")
      };
      a.keyregParams = i;
    } else if (a.type === zt.acfg) {
      const i = {
        assetIndex: e.get("caid")
      };
      if (e.get("apar")) {
        const s = e.get("apar");
        i.total = s.get("t"), i.decimals = s.get("dc"), i.defaultFrozen = s.get("df"), i.unitName = s.get("un"), i.assetName = s.get("an"), i.assetURL = s.get("au"), i.assetMetadataHash = s.get("am"), s.get("m") && (i.manager = s.get("m")), s.get("r") && (i.reserve = s.get("r")), s.get("f") && (i.freeze = s.get("f")), s.get("c") && (i.clawback = s.get("c"));
      }
      a.assetConfigParams = i;
    } else if (a.type === zt.axfer) {
      const i = {
        assetIndex: e.get("xaid") ?? 0,
        amount: e.get("aamt") ?? 0,
        receiver: e.get("arcv") ?? Bt.zeroAddress()
      };
      e.get("aclose") && (i.closeRemainderTo = e.get("aclose")), e.get("asnd") && (i.assetSender = e.get("asnd")), a.assetTransferParams = i;
    } else if (a.type === zt.afrz) {
      const i = {
        assetIndex: e.get("faid") ?? 0,
        freezeTarget: e.get("fadd") ?? Bt.zeroAddress(),
        frozen: e.get("afrz") ?? !1
      };
      a.assetFreezeParams = i;
    } else if (a.type === zt.appl) {
      const i = {
        appIndex: e.get("apid") ?? 0,
        onComplete: An(e.get("apan") ?? 0),
        appArgs: e.get("apaa"),
        accounts: e.get("apat"),
        foreignAssets: e.get("apas"),
        foreignApps: e.get("apfa"),
        approvalProgram: e.get("apap"),
        clearProgram: e.get("apsu"),
        extraPages: e.get("apep")
      }, s = e.get("apls");
      s && (i.numLocalInts = s.get("nui"), i.numLocalByteSlices = s.get("nbs"));
      const l = e.get("apgs");
      l && (i.numGlobalInts = l.get("nui"), i.numGlobalByteSlices = l.get("nbs"));
      const c = e.get("apbx");
      c && (i.boxes = c.map((u) => {
        const d = An(u.get("i") ?? 0), w = Ja(u.get("n") ?? new Uint8Array());
        if (d === 0)
          return {
            appIndex: 0,
            name: w
          };
        if (!i.foreignApps || d > i.foreignApps.length)
          throw new Error(`Cannot find foreign app index ${d} in ${i.foreignApps}`);
        return {
          appIndex: i.foreignApps[d - 1],
          name: w
        };
      })), a.appCallParams = i;
    } else if (a.type === zt.stpf) {
      const i = {
        stateProofType: e.get("sptype"),
        stateProof: e.get("sp") ? Bd.fromEncodingData(e.get("sp")) : void 0,
        message: e.get("spmsg") ? Ld.fromEncodingData(e.get("spmsg")) : void 0
      };
      a.stateProofParams = i;
    } else if (a.type === zt.hb) {
      const i = Ua.fromEncodingData(e.get("hb")), s = {
        address: i.address,
        proof: i.proof,
        seed: i.seed,
        voteID: i.voteID,
        keyDilution: i.keyDilution
      };
      a.heartbeatParams = s;
    } else {
      const i = a.type;
      throw new Error(`Unexpected transaction type: ${i}`);
    }
    const o = new Va(a);
    if (e.get("grp")) {
      const i = Ja(e.get("grp"));
      if (i.byteLength !== DS)
        throw new Error(`Invalid group length: ${i.byteLength}`);
      o.group = i;
    }
    return o;
  }
  estimateSize() {
    return this.toByte().length + ES;
  }
  bytesToSign() {
    const e = this.toByte();
    return oo(a2, e);
  }
  toByte() {
    return pu(this);
  }
  // returns the raw signature
  rawSignTxn(e) {
    const t = this.bytesToSign();
    return E5(t, e);
  }
  signTxn(e) {
    const t = S5(e), n = new Bt(t.publicKey), a = this.rawSignTxn(e);
    return this.attachSignature(n, a);
  }
  attachSignature(e, t) {
    if (!mb(t.length))
      throw new Error("Invalid signature length");
    const n = /* @__PURE__ */ new Map([
      ["sig", t],
      ["txn", this.toEncodingData()]
    ]), a = jo(e);
    this.sender.equals(a) || n.set("sgnr", a);
    const o = new be(tt([
      {
        key: "txn",
        valueSchema: Va.encodingSchema
      },
      {
        key: "sig",
        valueSchema: new Vt(64)
      },
      {
        key: "sgnr",
        valueSchema: new ne(new Nt())
      }
    ]));
    return T5(o.prepareMsgpack(n));
  }
  rawTxID() {
    const e = this.toByte(), t = oo(a2, e);
    return Uint8Array.from(Bs(t));
  }
  txID() {
    const e = this.rawTxID();
    return Ls.encode(e).slice(0, bS);
  }
}
Va.encodingSchema = new be(tt([
  // Common
  { key: "type", valueSchema: new Xe() },
  { key: "snd", valueSchema: new Nt() },
  { key: "lv", valueSchema: new se() },
  { key: "gen", valueSchema: new ne(new Xe()) },
  {
    key: "gh",
    valueSchema: new ne(new Vt(32))
  },
  { key: "fee", valueSchema: new se() },
  { key: "fv", valueSchema: new se() },
  { key: "note", valueSchema: new ct() },
  {
    key: "lx",
    valueSchema: new ne(new Vt(32))
  },
  { key: "rekey", valueSchema: new ne(new Nt()) },
  {
    key: "grp",
    valueSchema: new ne(new Vt(32))
  },
  // We mark all top-level type-specific fields optional because they will not be present when
  // the transaction is not that type.
  // Payment
  { key: "amt", valueSchema: new ne(new se()) },
  { key: "rcv", valueSchema: new ne(new Nt()) },
  { key: "close", valueSchema: new ne(new Nt()) },
  // Keyreg
  {
    key: "votekey",
    valueSchema: new ne(new Vt(32))
  },
  {
    key: "selkey",
    valueSchema: new ne(new Vt(32))
  },
  {
    key: "sprfkey",
    valueSchema: new ne(new Vt(64))
  },
  { key: "votefst", valueSchema: new ne(new se()) },
  { key: "votelst", valueSchema: new ne(new se()) },
  { key: "votekd", valueSchema: new ne(new se()) },
  { key: "nonpart", valueSchema: new ne(new Ot()) },
  // AssetConfig
  { key: "caid", valueSchema: new ne(new se()) },
  {
    key: "apar",
    valueSchema: new ne(new be(tt([
      { key: "t", valueSchema: new se() },
      { key: "dc", valueSchema: new se() },
      { key: "df", valueSchema: new Ot() },
      {
        key: "m",
        valueSchema: new ne(new Nt())
      },
      {
        key: "r",
        valueSchema: new ne(new Nt())
      },
      {
        key: "f",
        valueSchema: new ne(new Nt())
      },
      {
        key: "c",
        valueSchema: new ne(new Nt())
      },
      {
        key: "un",
        valueSchema: new ne(new Xe())
      },
      {
        key: "an",
        valueSchema: new ne(new Xe())
      },
      {
        key: "au",
        valueSchema: new ne(new Xe())
      },
      {
        key: "am",
        valueSchema: new ne(new Vt(32))
      }
    ])))
  },
  // AssetTransfer
  { key: "xaid", valueSchema: new ne(new se()) },
  { key: "aamt", valueSchema: new ne(new se()) },
  { key: "arcv", valueSchema: new ne(new Nt()) },
  { key: "aclose", valueSchema: new ne(new Nt()) },
  { key: "asnd", valueSchema: new ne(new Nt()) },
  // AssetFreeze
  { key: "faid", valueSchema: new ne(new se()) },
  { key: "afrz", valueSchema: new ne(new Ot()) },
  { key: "fadd", valueSchema: new ne(new Nt()) },
  // Application
  { key: "apid", valueSchema: new ne(new se()) },
  { key: "apan", valueSchema: new ne(new se()) },
  {
    key: "apaa",
    valueSchema: new ne(new We(new ct()))
  },
  {
    key: "apat",
    valueSchema: new ne(new We(new Nt()))
  },
  {
    key: "apas",
    valueSchema: new ne(new We(new se()))
  },
  {
    key: "apfa",
    valueSchema: new ne(new We(new se()))
  },
  {
    key: "apbx",
    valueSchema: new ne(new We(new be(tt([
      {
        key: "i",
        valueSchema: new se()
      },
      {
        key: "n",
        valueSchema: new ct()
      }
    ]))))
  },
  { key: "apap", valueSchema: new ne(new ct()) },
  { key: "apsu", valueSchema: new ne(new ct()) },
  {
    key: "apls",
    valueSchema: new ne(new be(tt([
      {
        key: "nui",
        valueSchema: new se()
      },
      {
        key: "nbs",
        valueSchema: new se()
      }
    ])))
  },
  {
    key: "apgs",
    valueSchema: new ne(new be(tt([
      {
        key: "nui",
        valueSchema: new se()
      },
      {
        key: "nbs",
        valueSchema: new se()
      }
    ])))
  },
  { key: "apep", valueSchema: new ne(new se()) },
  // StateProof
  { key: "sptype", valueSchema: new ne(new se()) },
  { key: "sp", valueSchema: new ne(Bd.encodingSchema) },
  {
    key: "spmsg",
    valueSchema: new ne(Ld.encodingSchema)
  },
  // Heartbeat
  { key: "hb", valueSchema: new ne(Ua.encodingSchema) }
]));
function RS(r) {
  return gn(r, Va);
}
const ws = new Uint8Array([
  77,
  117,
  108,
  116,
  105,
  115,
  105,
  103,
  65,
  100,
  100,
  114
]), IS = "invalid multisig version", TS = "bad multisig threshold", OS = "bad multisig public key - wrong length", PS = "nacl public key length is not 32 bytes";
function NS(r) {
  return r.map((e) => typeof e == "string" ? Bt.fromString(e).publicKey : e.publicKey);
}
function BS({ version: r, threshold: e, pks: t }) {
  if (r !== 1 || r > 255 || r < 0)
    throw new Error(IS);
  if (e === 0 || t.length === 0 || e > t.length || e > 255)
    throw new Error(TS);
  const n = Ga - xs;
  if (n !== k5)
    throw new Error(PS);
  const a = new Uint8Array(ws.length + 2 + n * t.length);
  a.set(ws, 0), a.set([r], ws.length), a.set([e], ws.length + 1);
  for (let o = 0; o < t.length; o++) {
    if (t[o].length !== n)
      throw new Error(OS);
    a.set(t[o], ws.length + 2 + o * n);
  }
  return new Bt(Uint8Array.from(Bs(a)));
}
function LS(r, e, t) {
  const n = e.v, a = e.thr, o = e.subsig, i = o.map((u) => u.pk);
  if (e.subsig.length < a)
    return !1;
  let s;
  try {
    s = BS({ version: n, threshold: a, pks: i }).publicKey;
  } catch {
    return !1;
  }
  if (!Fa(s, t))
    return !1;
  let l = 0;
  for (const u of o)
    u.s !== void 0 && (l += 1);
  if (l < a)
    return !1;
  let c = 0;
  for (const u of o)
    u.s !== void 0 && x5(r, u.s, u.pk) && (c += 1);
  return !(c < a);
}
const US = new be(tt([
  {
    key: "pk",
    valueSchema: new Vt(32)
  },
  {
    key: "s",
    valueSchema: new ne(new Vt(64))
  }
]));
function VS(r) {
  if (!(r instanceof Map))
    throw new Error(`Invalid decoded EncodedSubsig: ${r}`);
  const e = {
    pk: r.get("pk")
  };
  return r.get("s") && (e.s = r.get("s")), e;
}
function $S(r) {
  const e = /* @__PURE__ */ new Map([["pk", r.pk]]);
  return r.s && e.set("s", r.s), e;
}
const B5 = new be(tt([
  {
    key: "v",
    valueSchema: new se()
  },
  {
    key: "thr",
    valueSchema: new se()
  },
  {
    key: "subsig",
    valueSchema: new We(US)
  }
]));
function L5(r) {
  if (!(r instanceof Map))
    throw new Error(`Invalid decoded EncodedMultiSig: ${r}`);
  return {
    v: An(r.get("v")),
    thr: An(r.get("thr")),
    subsig: r.get("subsig").map(VS)
  };
}
function U5(r) {
  return /* @__PURE__ */ new Map([
    ["v", r.v],
    ["thr", r.thr],
    ["subsig", r.subsig.map($S)]
  ]);
}
const jS = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
function o2(r) {
  if (!r || r.length === 0)
    throw new Error("empty program");
  const e = 10, t = 32, n = 126, a = (o) => t <= o && o <= n;
  if (r.every((o) => o === e || a(o))) {
    const o = new TextDecoder().decode(r);
    throw bb(o) ? new Error("requesting program bytes, get Algorand address") : jS.test(o) ? new Error("program should not be b64 encoded") : new Error("program bytes are all ASCII printable characters, not looking like Teal byte code");
  }
}
const r1 = new TextEncoder().encode("Program");
class $a {
  constructor(e, t) {
    if (t && (!Array.isArray(t) || !t.every((a) => a.constructor === Uint8Array)))
      throw new TypeError("Invalid arguments");
    let n = [];
    t != null && (n = t.map((a) => new Uint8Array(a))), o2(e), this.logic = e, this.args = n, this.sig = void 0, this.msig = void 0;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return $a.encodingSchema;
  }
  toEncodingData() {
    const e = /* @__PURE__ */ new Map([
      ["l", this.logic],
      ["arg", this.args],
      ["sig", this.sig]
    ]);
    return this.msig && e.set("msig", U5(this.msig)), e;
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded logic sig: ${e}`);
    const t = new $a(e.get("l"), e.get("arg"));
    return t.sig = e.get("sig"), e.get("msig") && (t.msig = L5(e.get("msig"))), t;
  }
  /**
   * Performs signature verification
   * @param publicKey - Verification key (derived from sender address or escrow address)
   */
  verify(e) {
    if (this.sig && this.msig)
      return !1;
    try {
      o2(this.logic);
    } catch {
      return !1;
    }
    const t = oo(r1, this.logic);
    if (!this.sig && !this.msig) {
      const n = Bs(t);
      return Fa(n, e);
    }
    return this.sig ? x5(t, this.sig, e) : LS(t, this.msig, e);
  }
  /**
   * Compute hash of the logic sig program (that is the same as escrow account address) as string address
   * @returns String representation of the address
   */
  address() {
    const e = oo(r1, this.logic), t = Bs(e);
    return new Bt(Uint8Array.from(t));
  }
  /**
   * Creates signature (if no msig provided) or multi signature otherwise
   * @param secretKey - Secret key to sign with
   * @param msig - Multisig account as \{version, threshold, addrs\}
   */
  sign(e, t) {
    if (t == null)
      this.sig = this.signProgram(e);
    else {
      const n = NS(t.addrs).map((i) => ({ pk: i }));
      this.msig = {
        v: t.version,
        thr: t.threshold,
        subsig: n
      };
      const [a, o] = this.singleSignMultisig(e, this.msig);
      this.msig.subsig[o].s = a;
    }
  }
  /**
   * Appends a signature to multi signature
   * @param secretKey - Secret key to sign with
   */
  appendToMultisig(e) {
    if (this.msig === void 0)
      throw new Error("no multisig present");
    const [t, n] = this.singleSignMultisig(e, this.msig);
    this.msig.subsig[n].s = t;
  }
  signProgram(e) {
    const t = oo(r1, this.logic);
    return E5(t, e);
  }
  singleSignMultisig(e, t) {
    let n = -1;
    const a = S5(e).publicKey;
    for (let o = 0; o < t.subsig.length; o++) {
      const { pk: i } = t.subsig[o];
      if (Fa(i, a)) {
        n = o;
        break;
      }
    }
    if (n === -1)
      throw new Error("invalid secret key");
    return [this.signProgram(e), n];
  }
  toByte() {
    return pu(this);
  }
  static fromByte(e) {
    return gn(e, $a);
  }
}
$a.encodingSchema = new be(tt([
  {
    key: "l",
    valueSchema: new ct()
  },
  {
    key: "arg",
    valueSchema: new We(new ct())
  },
  {
    key: "sig",
    valueSchema: new ne(new Vt(64))
  },
  {
    key: "msig",
    valueSchema: new ne(B5)
  }
]));
new be(tt([
  {
    key: "lsig",
    valueSchema: $a.encodingSchema
  },
  {
    key: "sigkey",
    valueSchema: new ne(new Vt(32))
  }
]));
new TextEncoder().encode("ProgData");
class Jr {
  constructor({ txn: e, sig: t, msig: n, lsig: a, sgnr: o }) {
    this.txn = e, this.sig = t, this.msig = n, this.lsig = a, this.sgnr = o;
    let i = 0;
    if (t && (i += 1), n && (i += 1), a && (i += 1), i > 1)
      throw new Error(`SignedTransaction must not have more than 1 signature. Got ${i}`);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Jr.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["txn", this.txn.toEncodingData()],
      ["sig", this.sig],
      [
        "msig",
        this.msig ? U5(this.msig) : void 0
      ],
      ["lsig", this.lsig ? this.lsig.toEncodingData() : void 0],
      ["sgnr", this.sgnr]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SignedTransaction: ${e}`);
    return new Jr({
      txn: Va.fromEncodingData(e.get("txn")),
      sig: e.get("sig"),
      msig: e.get("msig") ? L5(e.get("msig")) : void 0,
      lsig: e.get("lsig") ? $a.fromEncodingData(e.get("lsig")) : void 0,
      sgnr: e.get("sgnr")
    });
  }
}
Jr.encodingSchema = new be(tt([
  {
    key: "txn",
    valueSchema: Va.encodingSchema
  },
  {
    key: "sig",
    valueSchema: new ne(new Vt(64))
  },
  {
    key: "msig",
    valueSchema: new ne(B5)
  },
  {
    key: "lsig",
    valueSchema: new ne($a.encodingSchema)
  },
  {
    key: "sgnr",
    valueSchema: new ne(new Nt())
  }
]));
class si {
  constructor(e) {
    this.stateProofVotersCommitment = e.stateProofVotersCommitment, this.stateProofOnlineTotalWeight = e.stateProofOnlineTotalWeight, this.stateProofNextRound = e.stateProofNextRound;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return si.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["v", this.stateProofVotersCommitment],
      ["t", this.stateProofOnlineTotalWeight],
      ["n", this.stateProofNextRound]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded StateProofTrackingData: ${e}`);
    return new si({
      stateProofVotersCommitment: e.get("v"),
      stateProofOnlineTotalWeight: e.get("t"),
      stateProofNextRound: e.get("n")
    });
  }
}
si.encodingSchema = new be(tt([
  {
    key: "v",
    // stateProofVotersCommitment
    valueSchema: new ct()
  },
  {
    key: "t",
    // stateProofOnlineTotalWeight
    valueSchema: new se()
  },
  {
    key: "n",
    // stateProofNextRound
    valueSchema: new se()
  }
]));
class ci {
  constructor(e) {
    this.nativeSha512_256Commitment = e.nativeSha512_256Commitment, this.sha256Commitment = e.sha256Commitment;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ci.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["txn", this.nativeSha512_256Commitment],
      ["txn256", this.sha256Commitment]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TxnCommitments: ${e}`);
    return new ci({
      nativeSha512_256Commitment: e.get("txn"),
      sha256Commitment: e.get("txn256")
    });
  }
}
ci.encodingSchema = new be(tt([
  {
    key: "txn",
    // nativeSha512_256Commitment
    valueSchema: new Vt(32)
  },
  {
    key: "txn256",
    // sha256Commitment
    valueSchema: new Vt(32)
  }
]));
class li {
  constructor(e) {
    this.feeSink = e.feeSink, this.rewardsPool = e.rewardsPool, this.rewardsLevel = e.rewardsLevel, this.rewardsRate = e.rewardsRate, this.rewardsResidue = e.rewardsResidue, this.rewardsRecalculationRound = e.rewardsRecalculationRound;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return li.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["fees", this.feeSink],
      ["rwd", this.rewardsPool],
      ["earn", this.rewardsLevel],
      ["rate", this.rewardsRate],
      ["frac", this.rewardsResidue],
      ["rwcalr", this.rewardsRecalculationRound]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded RewardState: ${e}`);
    return new li({
      feeSink: e.get("fees"),
      rewardsPool: e.get("rwd"),
      rewardsLevel: e.get("earn"),
      rewardsRate: e.get("rate"),
      rewardsResidue: e.get("frac"),
      rewardsRecalculationRound: e.get("rwcalr")
    });
  }
}
li.encodingSchema = new be(tt([
  {
    key: "fees",
    // feeSink
    valueSchema: new Nt()
  },
  {
    key: "rwd",
    // rewardsPool
    valueSchema: new Nt()
  },
  {
    key: "earn",
    // rewardsLevel
    valueSchema: new se()
  },
  {
    key: "rate",
    // rewardsRate
    valueSchema: new se()
  },
  {
    key: "frac",
    // rewardsResidue
    valueSchema: new se()
  },
  {
    key: "rwcalr",
    // rewardsRecalculationRound
    valueSchema: new se()
  }
]));
class ui {
  constructor(e) {
    this.currentProtocol = e.currentProtocol, this.nextProtocol = e.nextProtocol, this.nextProtocolApprovals = e.nextProtocolApprovals, this.nextProtocolVoteBefore = e.nextProtocolVoteBefore, this.nextProtocolSwitchOn = e.nextProtocolSwitchOn;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ui.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["proto", this.currentProtocol],
      ["nextproto", this.nextProtocol],
      ["nextyes", this.nextProtocolApprovals],
      ["nextbefore", this.nextProtocolVoteBefore],
      ["nextswitch", this.nextProtocolSwitchOn]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded UpgradeState: ${e}`);
    return new ui({
      currentProtocol: e.get("proto"),
      nextProtocol: e.get("nextproto"),
      nextProtocolApprovals: e.get("nextyes"),
      nextProtocolVoteBefore: e.get("nextbefore"),
      nextProtocolSwitchOn: e.get("nextswitch")
    });
  }
}
ui.encodingSchema = new be(tt([
  {
    key: "proto",
    // currentProtocol
    valueSchema: new Xe()
  },
  {
    key: "nextproto",
    // nextProtocol
    valueSchema: new Xe()
  },
  {
    key: "nextyes",
    // nextProtocolApprovals
    valueSchema: new se()
  },
  {
    key: "nextbefore",
    // nextProtocolVoteBefore
    valueSchema: new se()
  },
  {
    key: "nextswitch",
    // nextProtocolSwitchOn
    valueSchema: new se()
  }
]));
class di {
  constructor(e) {
    this.upgradePropose = e.upgradePropose, this.upgradeDelay = e.upgradeDelay, this.upgradeApprove = e.upgradeApprove;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return di.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["upgradeprop", this.upgradePropose],
      ["upgradedelay", this.upgradeDelay],
      ["upgradeyes", this.upgradeApprove]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded UpgradeVote: ${e}`);
    return new di({
      upgradePropose: e.get("upgradeprop"),
      upgradeDelay: e.get("upgradedelay"),
      upgradeApprove: e.get("upgradeyes")
    });
  }
}
di.encodingSchema = new be(tt([
  {
    key: "upgradeprop",
    // upgradePropose
    valueSchema: new Xe()
  },
  {
    key: "upgradedelay",
    // upgradeDelay
    valueSchema: new se()
  },
  {
    key: "upgradeyes",
    // upgradeApprove
    valueSchema: new Ot()
  }
]));
class hi {
  constructor(e) {
    this.expiredParticipationAccounts = e.expiredParticipationAccounts, this.absentParticipationAccounts = e.absentParticipationAccounts;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return hi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["partupdrmv", this.expiredParticipationAccounts],
      ["partupdabs", this.absentParticipationAccounts]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ParticipationUpdates: ${e}`);
    return new hi({
      expiredParticipationAccounts: e.get("partupdrmv"),
      absentParticipationAccounts: e.get("partupdabs")
    });
  }
}
hi.encodingSchema = new be(tt([
  {
    key: "partupdrmv",
    // expiredParticipationAccounts
    valueSchema: new We(new Nt())
  },
  {
    key: "partupdabs",
    // absentParticipationAccounts
    valueSchema: new We(new Nt())
  }
]));
class za {
  constructor(e) {
    this.round = e.round, this.branch = e.branch, this.seed = e.seed, this.txnCommitments = e.txnCommitments, this.timestamp = e.timestamp, this.genesisID = e.genesisID, this.genesisHash = e.genesisHash, this.proposer = e.proposer, this.feesCollected = e.feesCollected, this.bonus = e.bonus, this.proposerPayout = e.proposerPayout, this.rewardState = e.rewardState, this.upgradeState = e.upgradeState, this.upgradeVote = e.upgradeVote, this.txnCounter = e.txnCounter, this.stateproofTracking = e.stateproofTracking, this.participationUpdates = e.participationUpdates;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return za.encodingSchema;
  }
  toEncodingData() {
    const e = /* @__PURE__ */ new Map([
      ["rnd", this.round],
      ["prev", this.branch],
      ["seed", this.seed],
      ["ts", this.timestamp],
      ["gen", this.genesisID],
      ["gh", this.genesisHash],
      ["prp", this.proposer],
      ["fc", this.feesCollected],
      ["bi", this.bonus],
      ["pp", this.proposerPayout],
      ["tc", this.txnCounter],
      [
        "spt",
        ur(this.stateproofTracking, (t, n) => [
          t,
          n.toEncodingData()
        ])
      ]
    ]);
    return zi(e, this.txnCommitments.toEncodingData(), this.rewardState.toEncodingData(), this.upgradeState.toEncodingData(), this.upgradeVote.toEncodingData(), this.participationUpdates.toEncodingData());
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BlockHeader: ${e}`);
    return new za({
      round: e.get("rnd"),
      branch: e.get("prev"),
      seed: e.get("seed"),
      txnCommitments: ci.fromEncodingData(e),
      timestamp: e.get("ts"),
      genesisID: e.get("gen"),
      genesisHash: e.get("gh"),
      proposer: e.get("prp"),
      feesCollected: e.get("fc"),
      bonus: e.get("bi"),
      proposerPayout: e.get("pp"),
      rewardState: li.fromEncodingData(e),
      upgradeState: ui.fromEncodingData(e),
      upgradeVote: di.fromEncodingData(e),
      txnCounter: e.get("tc"),
      stateproofTracking: ur(e.get("spt"), (t, n) => [
        Number(t),
        si.fromEncodingData(n)
      ]),
      participationUpdates: hi.fromEncodingData(e)
    });
  }
}
za.encodingSchema = new be(tt([
  {
    key: "rnd",
    // round
    valueSchema: new se()
  },
  {
    key: "prev",
    // branch
    valueSchema: new mS()
  },
  {
    key: "seed",
    // seed
    valueSchema: new ct()
  },
  {
    key: "",
    valueSchema: ci.encodingSchema,
    embedded: !0
  },
  {
    key: "ts",
    // timestamp
    valueSchema: new se()
  },
  {
    key: "gen",
    // genesisID
    valueSchema: new Xe()
  },
  {
    key: "gh",
    // genesisHash
    valueSchema: new Vt(32)
  },
  {
    key: "prp",
    // proposer
    valueSchema: new Nt()
  },
  {
    key: "fc",
    // feesCollected
    valueSchema: new se()
  },
  {
    key: "bi",
    // bonus
    valueSchema: new se()
  },
  {
    key: "pp",
    // proposerPayout
    valueSchema: new se()
  },
  {
    key: "",
    valueSchema: li.encodingSchema,
    embedded: !0
  },
  {
    key: "",
    valueSchema: ui.encodingSchema,
    embedded: !0
  },
  {
    key: "",
    valueSchema: di.encodingSchema,
    embedded: !0
  },
  {
    key: "tc",
    // txnCounter
    valueSchema: new se()
  },
  {
    key: "spt",
    // stateproofTracking
    valueSchema: new gu(si.encodingSchema)
  },
  {
    key: "",
    valueSchema: hi.encodingSchema,
    embedded: !0
  }
]));
class Na {
  constructor(e) {
    this.action = e.action, this.bytes = e.bytes, this.uint = e.uint;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Na.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["at", this.action],
      ["bs", this.bytes],
      ["ui", this.uint]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ValueDelta: ${e}`);
    return new Na({
      action: Number(e.get("at")),
      bytes: e.get("bs"),
      uint: e.get("ui")
    });
  }
}
Na.encodingSchema = new be(tt([
  {
    key: "at",
    // action
    valueSchema: new se()
  },
  {
    key: "bs",
    // bytes
    valueSchema: new Yo()
  },
  {
    key: "ui",
    // uint
    valueSchema: new se()
  }
]));
let i2 = class $1 {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries(...tt([
      {
        key: "gd",
        // globalDelta
        valueSchema: new ne(new Us(Na.encodingSchema))
      },
      {
        key: "ld",
        // localDeltas
        valueSchema: new ne(new gu(new Us(Na.encodingSchema)))
      },
      {
        key: "sa",
        // sharedAccts
        valueSchema: new ne(new We(new Nt()))
      },
      {
        key: "lg",
        // logs
        valueSchema: new ne(new We(new Yo()))
      },
      {
        key: "itx",
        // innerTxns
        valueSchema: new ne(
          // eslint-disable-next-line no-use-before-define
          new We(yo.encodingSchema)
        )
      }
    ]))), this.encodingSchemaValue;
  }
  constructor(e) {
    this.globalDelta = e.globalDelta ?? /* @__PURE__ */ new Map(), this.localDeltas = e.localDeltas ?? /* @__PURE__ */ new Map(), this.sharedAccts = e.sharedAccts ?? [], this.logs = e.logs ?? [], this.innerTxns = e.innerTxns ?? [];
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return $1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      [
        "gd",
        ur(this.globalDelta, (e, t) => [
          e,
          t.toEncodingData()
        ])
      ],
      [
        "ld",
        ur(this.localDeltas, (e, t) => [
          e,
          ur(t, (n, a) => [n, a.toEncodingData()])
        ])
      ],
      ["sa", this.sharedAccts],
      ["lg", this.logs],
      ["itx", this.innerTxns.map((e) => e.toEncodingData())]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded EvalDelta: ${e}`);
    return new $1({
      globalDelta: e.get("gd") ? ur(e.get("gd"), (t, n) => [t, Na.fromEncodingData(n)]) : void 0,
      localDeltas: e.get("ld") ? ur(e.get("ld"), (t, n) => [
        Number(t),
        ur(n, (a, o) => [a, Na.fromEncodingData(o)])
      ]) : void 0,
      sharedAccts: e.get("sa"),
      logs: e.get("lg"),
      // eslint-disable-next-line no-use-before-define
      innerTxns: (e.get("itx") ?? []).map(yo.fromEncodingData)
    });
  }
};
class Vs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries(...tt([
      {
        key: "ca",
        // closingAmount
        valueSchema: new ne(new se())
      },
      {
        key: "aca",
        // assetClosingAmount
        valueSchema: new ne(new se())
      },
      {
        key: "rs",
        // senderRewards
        valueSchema: new ne(new se())
      },
      {
        key: "rr",
        // receiverRewards
        valueSchema: new ne(new se())
      },
      {
        key: "rc",
        // closeRewards
        valueSchema: new ne(new se())
      },
      {
        key: "dt",
        // evalDelta
        valueSchema: new ne(i2.encodingSchema)
      },
      {
        key: "caid",
        // configAsset
        valueSchema: new ne(new se())
      },
      {
        key: "apid",
        // applicationID
        valueSchema: new ne(new se())
      }
    ]))), this.encodingSchemaValue;
  }
  constructor(e) {
    this.closingAmount = e.closingAmount, this.assetClosingAmount = e.assetClosingAmount, this.senderRewards = e.senderRewards, this.receiverRewards = e.receiverRewards, this.closeRewards = e.closeRewards, this.evalDelta = e.evalDelta, this.configAsset = e.configAsset, this.applicationID = e.applicationID;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Vs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["ca", this.closingAmount],
      ["aca", this.assetClosingAmount],
      ["rs", this.senderRewards],
      ["rr", this.receiverRewards],
      ["rc", this.closeRewards],
      ["dt", this.evalDelta ? this.evalDelta.toEncodingData() : void 0],
      ["caid", this.configAsset],
      ["apid", this.applicationID]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplyData: ${e}`);
    return new Vs({
      closingAmount: e.get("ca"),
      assetClosingAmount: e.get("aca"),
      senderRewards: e.get("rs"),
      receiverRewards: e.get("rr"),
      closeRewards: e.get("rc"),
      evalDelta: e.get("dt") ? i2.fromEncodingData(e.get("dt")) : void 0,
      configAsset: e.get("caid"),
      applicationID: e.get("apid")
    });
  }
}
class yo {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries(...tt([
      {
        key: "",
        valueSchema: Jr.encodingSchema,
        embedded: !0
      },
      {
        key: "",
        valueSchema: Vs.encodingSchema,
        embedded: !0
      }
    ]))), this.encodingSchemaValue;
  }
  constructor(e) {
    this.signedTxn = e.signedTxn, this.applyData = e.applyData;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return yo.encodingSchema;
  }
  toEncodingData() {
    return zi(this.signedTxn.toEncodingData(), this.applyData.toEncodingData());
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SignedTxnWithAD: ${e}`);
    return new yo({
      signedTxn: Jr.fromEncodingData(e),
      applyData: Vs.fromEncodingData(e)
    });
  }
}
class fi {
  constructor(e) {
    this.signedTxn = e.signedTxn, this.hasGenesisID = e.hasGenesisID, this.hasGenesisHash = e.hasGenesisHash;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return fi.encodingSchema;
  }
  toEncodingData() {
    const e = /* @__PURE__ */ new Map([
      ["hgi", this.hasGenesisID],
      ["hgh", this.hasGenesisHash]
    ]);
    return zi(e, this.signedTxn.toEncodingData());
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SignedTxnInBlock: ${e}`);
    return new fi({
      signedTxn: yo.fromEncodingData(e),
      hasGenesisID: e.get("hgi"),
      hasGenesisHash: e.get("hgh")
    });
  }
}
fi.encodingSchema = new be(tt([
  {
    key: "",
    valueSchema: yo.encodingSchema,
    embedded: !0
  },
  {
    key: "hgi",
    // hasGenesisID
    valueSchema: new Ot()
  },
  {
    key: "hgh",
    // hasGenesisHash
    valueSchema: new Ot()
  }
]));
let j1 = class F1 {
  constructor(e) {
    this.header = e.header, this.payset = e.payset;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return F1.encodingSchema;
  }
  toEncodingData() {
    const e = /* @__PURE__ */ new Map([
      ["txns", this.payset.map((t) => t.toEncodingData())]
    ]);
    return zi(e, this.header.toEncodingData());
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BlockHeader: ${e}`);
    return new F1({
      header: za.fromEncodingData(e),
      payset: e.get("txns").map(fi.fromEncodingData)
    });
  }
};
j1.encodingSchema = new be(tt([
  {
    key: "",
    valueSchema: za.encodingSchema,
    embedded: !0
  },
  {
    key: "txns",
    // payset
    valueSchema: new We(fi.encodingSchema)
  }
]));
class ca {
  constructor(e) {
    this.data = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ca.encodingSchema;
  }
  toEncodingData() {
    return this.data;
  }
  static fromEncodingData(e) {
    return new ca(e);
  }
}
ca.encodingSchema = new O5();
let gc = class z1 {
  constructor(e) {
    this.type = e.type, this.bytes = e.bytes, this.uint = e.uint;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return z1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["tt", this.type],
      ["tb", this.bytes],
      ["ui", this.uint]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TealValue: ${e}`);
    return new z1({
      type: Number(e.get("tt")),
      bytes: e.get("tb"),
      uint: e.get("ui")
    });
  }
};
gc.encodingSchema = new be(tt([
  { key: "tt", valueSchema: new se() },
  // type
  {
    key: "tb",
    // bytes
    valueSchema: new ne(new Yo())
  },
  { key: "ui", valueSchema: new ne(new se()) }
  // uint
]));
class mn {
  constructor(e) {
    this.numUints = e.numUints, this.numByteSlices = e.numByteSlices;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return mn.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["nui", this.numUints],
      ["nbs", this.numByteSlices]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded StateSchema: ${e}`);
    return new mn({
      numUints: Number(e.get("nui")),
      numByteSlices: Number(e.get("nbs"))
    });
  }
}
mn.encodingSchema = new be(tt([
  {
    key: "nui",
    // numUints
    valueSchema: new se()
  },
  {
    key: "nbs",
    // numByteSlices
    valueSchema: new se()
  }
]));
class pi {
  constructor(e) {
    this.approvalProgram = e.approvalProgram, this.clearStateProgram = e.clearStateProgram, this.globalState = e.globalState, this.localStateSchema = e.localStateSchema, this.globalStateSchema = e.globalStateSchema, this.extraProgramPages = e.extraProgramPages;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return pi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["approv", this.approvalProgram],
      ["clearp", this.clearStateProgram],
      ["gs", ur(this.globalState, (e, t) => [e, t.toEncodingData()])],
      ["lsch", this.localStateSchema.toEncodingData()],
      ["gsch", this.globalStateSchema.toEncodingData()],
      ["epp", this.extraProgramPages]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AppParams: ${e}`);
    return new pi({
      approvalProgram: e.get("approv"),
      clearStateProgram: e.get("clearp"),
      globalState: ur(e.get("gs"), (t, n) => [t, gc.fromEncodingData(n)]),
      localStateSchema: mn.fromEncodingData(e.get("lsch")),
      globalStateSchema: mn.fromEncodingData(e.get("gsch")),
      extraProgramPages: Number(e.get("epp"))
    });
  }
}
pi.encodingSchema = new be(tt([
  { key: "approv", valueSchema: new ct() },
  // approvalProgram
  { key: "clearp", valueSchema: new ct() },
  // alearStateProgram
  {
    key: "gs",
    valueSchema: new Us(gc.encodingSchema)
  },
  // globalState
  { key: "lsch", valueSchema: mn.encodingSchema },
  // localStateSchema
  { key: "gsch", valueSchema: mn.encodingSchema },
  // globalStateSchema
  { key: "epp", valueSchema: new se() }
  // extraProgramPages
]));
class gi {
  constructor(e) {
    this.schema = e.schema, this.keyValue = e.keyValue;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return gi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["hsch", this.schema.toEncodingData()],
      ["tkv", ur(this.keyValue, (e, t) => [e, t.toEncodingData()])]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AppLocalState: ${e}`);
    return new gi({
      schema: mn.fromEncodingData(e.get("hsch")),
      keyValue: ur(e.get("tkv"), (t, n) => [t, gc.fromEncodingData(n)])
    });
  }
}
gi.encodingSchema = new be(tt([
  { key: "hsch", valueSchema: mn.encodingSchema },
  // schema
  {
    key: "tkv",
    // keyValue
    valueSchema: new Us(gc.encodingSchema)
  }
]));
class mi {
  constructor(e) {
    this.localState = e.localState, this.deleted = e.deleted;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return mi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      [
        "LocalState",
        this.localState ? this.localState.toEncodingData() : void 0
      ],
      ["Deleted", this.deleted]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AppLocalStateDelta: ${e}`);
    return new mi({
      localState: e.get("LocalState") ? gi.fromEncodingData(e.get("LocalState")) : void 0,
      deleted: e.get("Deleted")
    });
  }
}
mi.encodingSchema = new be(tt([
  {
    key: "LocalState",
    // localState
    valueSchema: new ne(gi.encodingSchema)
  },
  { key: "Deleted", valueSchema: new Ot() }
  // deleted
]));
class yi {
  constructor(e) {
    this.params = e.params, this.deleted = e.deleted;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return yi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Params", this.params ? this.params.toEncodingData() : void 0],
      ["Deleted", this.deleted]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AppParamsDelta: ${e}`);
    return new yi({
      params: e.get("Params") ? pi.fromEncodingData(e.get("Params")) : void 0,
      deleted: e.get("Deleted")
    });
  }
}
yi.encodingSchema = new be(tt([
  {
    key: "Params",
    // params
    valueSchema: new ne(pi.encodingSchema)
  },
  { key: "Deleted", valueSchema: new Ot() }
  // deleted
]));
class wi {
  constructor(e) {
    this.id = e.id, this.address = e.address, this.params = e.params, this.state = e.state;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return wi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Aidx", this.id],
      ["Addr", this.address],
      ["Params", this.params.toEncodingData()],
      ["State", this.state.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AppResourceRecord: ${e}`);
    return new wi({
      id: e.get("Aidx"),
      address: e.get("Addr"),
      params: yi.fromEncodingData(e.get("Params")),
      state: mi.fromEncodingData(e.get("State"))
    });
  }
}
wi.encodingSchema = new be(tt([
  { key: "Aidx", valueSchema: new se() },
  // id
  { key: "Addr", valueSchema: new Nt() },
  // address
  {
    key: "Params",
    // params
    valueSchema: yi.encodingSchema
  },
  {
    key: "State",
    // state
    valueSchema: mi.encodingSchema
  }
]));
let Ud = class H1 {
  constructor(e) {
    this.amount = e.amount, this.frozen = e.frozen;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return H1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["a", this.amount],
      ["f", this.frozen]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetHolding: ${e}`);
    return new H1({
      amount: e.get("a"),
      frozen: e.get("f")
    });
  }
};
Ud.encodingSchema = new be(tt([
  { key: "a", valueSchema: new se() },
  // amount
  { key: "f", valueSchema: new Ot() }
  // frozen
]));
class vi {
  constructor(e) {
    this.holding = e.holding, this.deleted = e.deleted;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return vi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Holding", this.holding ? this.holding.toEncodingData() : void 0],
      ["Deleted", this.deleted]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetHoldingDelta: ${e}`);
    return new vi({
      holding: e.get("Holding") ? Ud.fromEncodingData(e.get("Holding")) : void 0,
      deleted: e.get("Deleted")
    });
  }
}
vi.encodingSchema = new be(tt([
  {
    key: "Holding",
    // holding
    valueSchema: new ne(Ud.encodingSchema)
  },
  { key: "Deleted", valueSchema: new Ot() }
  // deleted
]));
let Vd = class q1 {
  constructor(e) {
    this.total = e.total, this.decimals = e.decimals, this.defaultFrozen = e.defaultFrozen, this.unitName = e.unitName, this.assetName = e.assetName, this.url = e.url, this.metadataHash = e.metadataHash, this.manager = e.manager, this.reserve = e.reserve, this.freeze = e.freeze, this.clawback = e.clawback;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return q1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["t", this.total],
      ["dc", this.decimals],
      ["df", this.defaultFrozen],
      ["un", this.unitName],
      ["an", this.assetName],
      ["au", this.url],
      ["am", this.metadataHash],
      ["m", this.manager],
      ["r", this.reserve],
      ["f", this.freeze],
      ["c", this.clawback]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetParams: ${e}`);
    return new q1({
      total: e.get("t"),
      decimals: e.get("dc"),
      defaultFrozen: e.get("df"),
      unitName: e.get("un"),
      assetName: e.get("an"),
      url: e.get("au"),
      metadataHash: e.get("am"),
      manager: e.get("m"),
      reserve: e.get("r"),
      freeze: e.get("f"),
      clawback: e.get("c")
    });
  }
};
Vd.encodingSchema = new be(tt([
  { key: "t", valueSchema: new se() },
  // total
  { key: "dc", valueSchema: new se() },
  // decimals
  { key: "df", valueSchema: new Ot() },
  // defaultFrozen
  {
    key: "un",
    // unitName
    valueSchema: new ne(new Yo())
  },
  {
    key: "an",
    // assetName
    valueSchema: new ne(new Yo())
  },
  {
    key: "au",
    // url
    valueSchema: new ne(new Yo())
  },
  { key: "am", valueSchema: new Vt(32) },
  // metadataHash
  { key: "m", valueSchema: new ne(new Nt()) },
  // manager
  { key: "r", valueSchema: new ne(new Nt()) },
  // reserve
  { key: "f", valueSchema: new ne(new Nt()) },
  // freeze
  { key: "c", valueSchema: new ne(new Nt()) }
  // clawback
]));
class _i {
  constructor(e) {
    this.params = e.params, this.deleted = e.deleted;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return _i.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Params", this.params ? this.params.toEncodingData() : void 0],
      ["Deleted", this.deleted]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetParamsDelta: ${e}`);
    return new _i({
      params: e.get("Params") ? Vd.fromEncodingData(e.get("Params")) : void 0,
      deleted: e.get("Deleted")
    });
  }
}
_i.encodingSchema = new be(tt([
  {
    key: "Params",
    // params
    valueSchema: new ne(Vd.encodingSchema)
  },
  { key: "Deleted", valueSchema: new Ot() }
  // deleted
]));
class bi {
  constructor(e) {
    this.id = e.id, this.address = e.address, this.params = e.params, this.holding = e.holding;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return bi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Aidx", this.id],
      ["Addr", this.address],
      ["Params", this.params.toEncodingData()],
      ["Holding", this.holding.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetResourceRecord: ${e}`);
    return new bi({
      id: e.get("Aidx"),
      address: e.get("Addr"),
      params: _i.fromEncodingData(e.get("Params")),
      holding: vi.fromEncodingData(e.get("Holding"))
    });
  }
}
bi.encodingSchema = new be(tt([
  { key: "Aidx", valueSchema: new se() },
  // id
  { key: "Addr", valueSchema: new Nt() },
  // address
  {
    key: "Params",
    // params
    valueSchema: _i.encodingSchema
  },
  {
    key: "Holding",
    // holding
    valueSchema: vi.encodingSchema
  }
]));
class Si {
  constructor(e) {
    this.voteID = e.voteID, this.selectionID = e.selectionID, this.stateProofID = e.stateProofID, this.voteFirstValid = e.voteFirstValid, this.voteLastValid = e.voteLastValid, this.voteKeyDilution = e.voteKeyDilution;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Si.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["VoteID", this.voteID],
      ["SelectionID", this.selectionID],
      ["StateProofID", this.stateProofID],
      ["VoteFirstValid", this.voteFirstValid],
      ["VoteLastValid", this.voteLastValid],
      ["VoteKeyDilution", this.voteKeyDilution]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded VotingData: ${e}`);
    return new Si({
      voteID: e.get("VoteID"),
      selectionID: e.get("SelectionID"),
      stateProofID: e.get("StateProofID"),
      voteFirstValid: e.get("VoteFirstValid"),
      voteLastValid: e.get("VoteLastValid"),
      voteKeyDilution: e.get("VoteKeyDilution")
    });
  }
}
Si.encodingSchema = new be(tt([
  {
    key: "VoteID",
    // voteID
    valueSchema: new Vt(32)
  },
  {
    key: "SelectionID",
    // selectionID
    valueSchema: new Vt(32)
  },
  {
    key: "StateProofID",
    // stateProofID
    valueSchema: new Vt(64)
  },
  {
    key: "VoteFirstValid",
    // voteFirstValid
    valueSchema: new se()
  },
  {
    key: "VoteLastValid",
    // voteLastValid
    valueSchema: new se()
  },
  {
    key: "VoteKeyDilution",
    // voteKeyDilution
    valueSchema: new se()
  }
]));
class Ei {
  constructor(e) {
    this.status = e.status, this.microAlgos = e.microAlgos, this.rewardsBase = e.rewardsBase, this.rewardedMicroAlgos = e.rewardedMicroAlgos, this.authAddr = e.authAddr, this.incentiveEligible = e.incentiveEligible, this.totalAppSchema = e.totalAppSchema, this.totalExtraAppPages = e.totalExtraAppPages, this.totalAppParams = e.totalAppParams, this.totalAppLocalStates = e.totalAppLocalStates, this.totalAssetParams = e.totalAssetParams, this.totalAssets = e.totalAssets, this.totalBoxes = e.totalBoxes, this.totalBoxBytes = e.totalBoxBytes, this.lastProposed = e.lastProposed, this.lastHeartbeat = e.lastHeartbeat;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ei.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Status", this.status],
      ["MicroAlgos", this.microAlgos],
      ["RewardsBase", this.rewardsBase],
      ["RewardedMicroAlgos", this.rewardedMicroAlgos],
      ["AuthAddr", this.authAddr],
      ["IncentiveEligible", this.incentiveEligible],
      ["TotalAppSchema", this.totalAppSchema.toEncodingData()],
      ["TotalExtraAppPages", this.totalExtraAppPages],
      ["TotalAppParams", this.totalAppParams],
      ["TotalAppLocalStates", this.totalAppLocalStates],
      ["TotalAssetParams", this.totalAssetParams],
      ["TotalAssets", this.totalAssets],
      ["TotalBoxes", this.totalBoxes],
      ["TotalBoxBytes", this.totalBoxBytes],
      ["LastProposed", this.lastProposed],
      ["LastHeartbeat", this.lastHeartbeat]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountBaseData: ${e}`);
    return new Ei({
      status: Number(e.get("Status")),
      microAlgos: e.get("MicroAlgos"),
      rewardsBase: e.get("RewardsBase"),
      rewardedMicroAlgos: e.get("RewardedMicroAlgos"),
      authAddr: e.get("AuthAddr"),
      incentiveEligible: e.get("IncentiveEligible"),
      totalAppSchema: mn.fromEncodingData(e.get("TotalAppSchema")),
      totalExtraAppPages: Number(e.get("TotalExtraAppPages")),
      totalAppParams: e.get("TotalAppParams"),
      totalAppLocalStates: e.get("TotalAppLocalStates"),
      totalAssetParams: e.get("TotalAssetParams"),
      totalAssets: e.get("TotalAssets"),
      totalBoxes: e.get("TotalBoxes"),
      totalBoxBytes: e.get("TotalBoxBytes"),
      lastProposed: e.get("LastProposed"),
      lastHeartbeat: e.get("LastHeartbeat")
    });
  }
}
Ei.encodingSchema = new be(tt([
  { key: "Status", valueSchema: new se() },
  // status
  { key: "MicroAlgos", valueSchema: new se() },
  // microAlgos
  { key: "RewardsBase", valueSchema: new se() },
  // rewardsBase
  {
    key: "RewardedMicroAlgos",
    // rewardedMicroAlgos
    valueSchema: new se()
  },
  { key: "AuthAddr", valueSchema: new Nt() },
  // authAddr
  {
    key: "IncentiveEligible",
    // incentiveEligible
    valueSchema: new Ot()
  },
  {
    key: "TotalAppSchema",
    // totalAppSchema
    valueSchema: mn.encodingSchema
  },
  {
    key: "TotalExtraAppPages",
    // totalExtraAppPages
    valueSchema: new se()
  },
  {
    key: "TotalAppParams",
    // totalAppParams
    valueSchema: new se()
  },
  {
    key: "TotalAppLocalStates",
    // totalAppLocalStates
    valueSchema: new se()
  },
  {
    key: "TotalAssetParams",
    // totalAssetParams
    valueSchema: new se()
  },
  { key: "TotalAssets", valueSchema: new se() },
  // totalAssets
  { key: "TotalBoxes", valueSchema: new se() },
  // totalBoxes
  {
    key: "TotalBoxBytes",
    // totalBoxBytes
    valueSchema: new se()
  },
  { key: "LastProposed", valueSchema: new se() },
  // lastProposed
  {
    key: "LastHeartbeat",
    // lastHeartbeat
    valueSchema: new se()
  }
]));
class xi {
  constructor(e) {
    this.accountBaseData = e.accountBaseData, this.votingData = e.votingData;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return xi.encodingSchema;
  }
  toEncodingData() {
    return zi(this.accountBaseData.toEncodingData(), this.votingData.toEncodingData());
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountData: ${e}`);
    return new xi({
      accountBaseData: Ei.fromEncodingData(e),
      votingData: Si.fromEncodingData(e)
    });
  }
}
xi.encodingSchema = new be(tt([
  {
    key: "",
    valueSchema: Ei.encodingSchema,
    embedded: !0
  },
  {
    key: "",
    valueSchema: Si.encodingSchema,
    embedded: !0
  }
]));
class ki {
  constructor(e) {
    this.addr = e.addr, this.accountData = e.accountData;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ki.encodingSchema;
  }
  toEncodingData() {
    return zi(/* @__PURE__ */ new Map([["Addr", this.addr]]), this.accountData.toEncodingData());
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BalanceRecord: ${e}`);
    return new ki({
      addr: e.get("Addr"),
      accountData: xi.fromEncodingData(e)
    });
  }
}
ki.encodingSchema = new be(tt([
  {
    key: "Addr",
    valueSchema: new Nt()
  },
  {
    key: "",
    valueSchema: xi.encodingSchema,
    embedded: !0
  }
]));
class Ai {
  constructor(e) {
    this.accounts = e.accounts, this.appResources = e.appResources, this.assetResources = e.assetResources;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ai.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Accts", this.accounts.map((e) => e.toEncodingData())],
      [
        "AppResources",
        this.appResources.length === 0 ? void 0 : this.appResources.map((e) => e.toEncodingData())
      ],
      [
        "AssetResources",
        this.assetResources.length === 0 ? void 0 : this.assetResources.map((e) => e.toEncodingData())
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountDeltas: ${e}`);
    return new Ai({
      accounts: (e.get("Accts") ?? []).map(ki.fromEncodingData),
      appResources: (e.get("AppResources") ?? []).map(wi.fromEncodingData),
      assetResources: (e.get("AssetResources") ?? []).map(bi.fromEncodingData)
    });
  }
}
Ai.encodingSchema = new be(tt([
  {
    key: "Accts",
    // accounts
    valueSchema: new We(ki.encodingSchema)
  },
  {
    key: "AppResources",
    // appResources
    valueSchema: new ne(new We(wi.encodingSchema))
  },
  {
    key: "AssetResources",
    // assetResources
    valueSchema: new ne(new We(bi.encodingSchema))
  }
]));
class Ci {
  constructor(e) {
    this.data = e.data, this.oldData = e.oldData;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ci.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Data", this.data],
      ["OldData", this.oldData]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded KvValueDelta: ${e}`);
    return new Ci({
      data: e.get("Data"),
      oldData: e.get("OldData")
    });
  }
}
Ci.encodingSchema = new be(tt([
  {
    key: "Data",
    valueSchema: new ne(new ct())
  },
  {
    key: "OldData",
    valueSchema: new ne(new ct())
  }
]));
class Di {
  constructor(e) {
    this.lastValid = e.lastValid, this.intra = e.intra;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Di.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["LastValid", this.lastValid],
      ["Intra", this.intra]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded IncludedTransactions: ${e}`);
    return new Di({
      lastValid: e.get("LastValid"),
      intra: Number(e.get("Intra"))
    });
  }
}
Di.encodingSchema = new be(tt([
  {
    key: "LastValid",
    valueSchema: new se()
  },
  {
    key: "Intra",
    valueSchema: new se()
  }
]));
class Mi {
  constructor(e) {
    this.creatableType = e.creatableType, this.created = e.created, this.creator = e.creator, this.ndeltas = e.ndeltas;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Mi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Ctype", this.creatableType],
      ["Created", this.created],
      ["Creator", this.creator],
      ["Ndeltas", this.ndeltas]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ModifiedCreatable: ${e}`);
    return new Mi({
      creatableType: Number(e.get("Ctype")),
      created: e.get("Created"),
      creator: e.get("Creator"),
      ndeltas: Number(e.get("Ndeltas"))
    });
  }
}
Mi.encodingSchema = new be(tt([
  {
    key: "Ctype",
    // creatableType
    valueSchema: new se()
  },
  {
    key: "Created",
    // created
    valueSchema: new Ot()
  },
  {
    key: "Creator",
    // creator
    valueSchema: new Nt()
  },
  {
    key: "Ndeltas",
    // ndeltas
    valueSchema: new se()
  }
]));
class Fn {
  constructor(e) {
    this.money = e.money, this.rewardUnits = e.rewardUnits;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Fn.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["mon", this.money],
      ["rwd", this.rewardUnits]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AlgoCount: ${e}`);
    return new Fn({
      money: e.get("mon"),
      rewardUnits: e.get("rwd")
    });
  }
}
Fn.encodingSchema = new be(tt([
  { key: "mon", valueSchema: new se() },
  // money
  { key: "rwd", valueSchema: new se() }
  // rewardUnits
]));
class Ri {
  constructor(e) {
    this.online = e.online, this.offline = e.offline, this.notParticipating = e.notParticipating, this.rewardsLevel = e.rewardsLevel;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ri.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["online", this.online.toEncodingData()],
      ["offline", this.offline.toEncodingData()],
      ["notpart", this.notParticipating.toEncodingData()],
      ["rwdlvl", this.rewardsLevel]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountTotals: ${e}`);
    return new Ri({
      online: Fn.fromEncodingData(e.get("online")),
      offline: Fn.fromEncodingData(e.get("offline")),
      notParticipating: Fn.fromEncodingData(e.get("notpart")),
      rewardsLevel: e.get("rwdlvl")
    });
  }
}
Ri.encodingSchema = new be(tt([
  { key: "online", valueSchema: Fn.encodingSchema },
  // online
  { key: "offline", valueSchema: Fn.encodingSchema },
  // offline
  { key: "notpart", valueSchema: Fn.encodingSchema },
  // notParticipating
  { key: "rwdlvl", valueSchema: new se() }
  // rewardsLevel
]));
class Ha {
  constructor(e) {
    this.accounts = e.accounts, this.kvMods = e.kvMods, this.txids = e.txids, this.txleases = e.txleases, this.creatables = e.creatables, this.blockHeader = e.blockHeader, this.stateProofNext = e.stateProofNext, this.prevTimestamp = e.prevTimestamp, this.totals = e.totals;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ha.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Accts", this.accounts.toEncodingData()],
      [
        "KvMods",
        this.kvMods.size === 0 ? void 0 : ur(this.kvMods, (e, t) => [
          e,
          t.toEncodingData()
        ])
      ],
      [
        "Txids",
        ur(this.txids, (e, t) => [e, t.toEncodingData()])
      ],
      ["Txleases", this.txleases.toEncodingData()],
      [
        "Creatables",
        this.creatables.size === 0 ? void 0 : ur(this.creatables, (e, t) => [
          e,
          t.toEncodingData()
        ])
      ],
      ["Hdr", this.blockHeader.toEncodingData()],
      ["StateProofNext", this.stateProofNext],
      ["PrevTimestamp", this.prevTimestamp],
      ["Totals", this.totals.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded LedgerStateDelta: ${e}`);
    return new Ha({
      accounts: Ai.fromEncodingData(e.get("Accts")),
      kvMods: ur(e.get("KvMods") ?? /* @__PURE__ */ new Map(), (t, n) => [t, Ci.fromEncodingData(n)]),
      txids: ur(e.get("Txids"), (t, n) => [t, Di.fromEncodingData(n)]),
      txleases: ca.fromEncodingData(e.get("Txleases")),
      creatables: ur(e.get("Creatables") ?? /* @__PURE__ */ new Map(), (t, n) => [t, Mi.fromEncodingData(n)]),
      blockHeader: za.fromEncodingData(e.get("Hdr")),
      stateProofNext: e.get("StateProofNext"),
      prevTimestamp: e.get("PrevTimestamp"),
      totals: Ri.fromEncodingData(e.get("Totals"))
    });
  }
}
Ha.encodingSchema = new be(tt([
  {
    key: "Accts",
    // accounts
    valueSchema: Ai.encodingSchema
  },
  {
    key: "KvMods",
    // kvMods
    valueSchema: new ne(new Us(Ci.encodingSchema))
  },
  {
    key: "Txids",
    // txids
    valueSchema: new yS(Di.encodingSchema)
  },
  {
    key: "Txleases",
    // txleases
    // Note: because txleases is currently just an UntypedSchema and we are expected to decode
    // null values for this field, we use OptionalSchema to coerce null values to undefined so
    // that the values can be properly omitted during encoding.
    valueSchema: new ne(new O5())
  },
  {
    key: "Creatables",
    // creatables
    valueSchema: new ne(new gu(Mi.encodingSchema))
  },
  {
    key: "Hdr",
    // blockHeader
    valueSchema: za.encodingSchema
  },
  {
    key: "StateProofNext",
    // stateProofNext
    valueSchema: new se()
  },
  {
    key: "PrevTimestamp",
    // prevTimestamp
    valueSchema: new se()
  },
  {
    key: "Totals",
    // totals
    valueSchema: Ri.encodingSchema
  }
]));
class xl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "address", valueSchema: new Xe(), omitEmpty: !0 }, { key: "amount", valueSchema: new se(), omitEmpty: !0 }, {
      key: "amount-without-pending-rewards",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "min-balance",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "pending-rewards",
      valueSchema: new se(),
      omitEmpty: !0
    }, { key: "rewards", valueSchema: new se(), omitEmpty: !0 }, { key: "round", valueSchema: new se(), omitEmpty: !0 }, { key: "status", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "total-apps-opted-in",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "total-assets-opted-in",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "total-created-apps",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "total-created-assets",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "apps-local-state",
      valueSchema: new ne(new We(vo.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "apps-total-extra-pages",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "apps-total-schema",
      valueSchema: new ne(Mn.encodingSchema),
      omitEmpty: !0
    }, {
      key: "assets",
      valueSchema: new ne(new We(bo.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "auth-addr",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "created-apps",
      valueSchema: new ne(new We(Ii.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "created-assets",
      valueSchema: new ne(new We(Ti.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "incentive-eligible",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "last-heartbeat",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "last-proposed",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "participation",
      valueSchema: new ne($s.encodingSchema),
      omitEmpty: !0
    }, {
      key: "reward-base",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "sig-type",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "total-box-bytes",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "total-boxes",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `Account` object.
   * @param address - the account public key
   * @param amount - (algo) total number of MicroAlgos in the account
   * @param amountWithoutPendingRewards - specifies the amount of MicroAlgos in the account, without the pending rewards.
   * @param minBalance - MicroAlgo balance required by the account.
   * The requirement grows based on asset and application usage.
   * @param pendingRewards - amount of MicroAlgos of pending rewards in this account.
   * @param rewards - (ern) total rewards of MicroAlgos the account has received, including pending
   * rewards.
   * @param round - The round for which this information is relevant.
   * @param status - (onl) delegation status of the account's MicroAlgos
   * * Offline - indicates that the associated account is delegated.
   * * Online - indicates that the associated account used as part of the delegation
   * pool.
   * * NotParticipating - indicates that the associated account is neither a
   * delegator nor a delegate.
   * @param totalAppsOptedIn - The count of all applications that have been opted in, equivalent to the count
   * of application local data (AppLocalState objects) stored in this account.
   * @param totalAssetsOptedIn - The count of all assets that have been opted in, equivalent to the count of
   * AssetHolding objects held by this account.
   * @param totalCreatedApps - The count of all apps (AppParams objects) created by this account.
   * @param totalCreatedAssets - The count of all assets (AssetParams objects) created by this account.
   * @param appsLocalState - (appl) applications local data stored in this account.
   * Note the raw object uses `map[int] -> AppLocalState` for this type.
   * @param appsTotalExtraPages - (teap) the sum of all extra application program pages for this account.
   * @param appsTotalSchema - (tsch) stores the sum of all of the local schemas and global schemas in this
   * account.
   * Note: the raw account uses `StateSchema` for this type.
   * @param assets - (asset) assets held by this account.
   * Note the raw object uses `map[int] -> AssetHolding` for this type.
   * @param authAddr - (spend) the address against which signing should be checked. If empty, the
   * address of the current account is used. This field can be updated in any
   * transaction by setting the RekeyTo field.
   * @param createdApps - (appp) parameters of applications created by this account including app global
   * data.
   * Note: the raw account uses `map[int] -> AppParams` for this type.
   * @param createdAssets - (apar) parameters of assets created by this account.
   * Note: the raw account uses `map[int] -> Asset` for this type.
   * @param incentiveEligible - Whether or not the account can receive block incentives if its balance is in
   * range at proposal time.
   * @param lastHeartbeat - The round in which this account last went online, or explicitly renewed their
   * online status.
   * @param lastProposed - The round in which this account last proposed the block.
   * @param participation - AccountParticipation describes the parameters used by this account in consensus
   * protocol.
   * @param rewardBase - (ebase) used as part of the rewards computation. Only applicable to accounts
   * which are participating.
   * @param sigType - Indicates what type of signature is used by this account, must be one of:
   * * sig
   * * msig
   * * lsig
   * @param totalBoxBytes - (tbxb) The total number of bytes used by this account's app's box keys and
   * values.
   * @param totalBoxes - (tbx) The number of existing boxes created by this account's app.
   */
  constructor({ address: e, amount: t, amountWithoutPendingRewards: n, minBalance: a, pendingRewards: o, rewards: i, round: s, status: l, totalAppsOptedIn: c, totalAssetsOptedIn: u, totalCreatedApps: d, totalCreatedAssets: w, appsLocalState: f, appsTotalExtraPages: A, appsTotalSchema: b, assets: g, authAddr: k, createdApps: v, createdAssets: C, incentiveEligible: W, lastHeartbeat: Z, lastProposed: D, participation: H, rewardBase: y, sigType: S, totalBoxBytes: _, totalBoxes: F }) {
    this.address = e, this.amount = ot(t), this.amountWithoutPendingRewards = ot(n), this.minBalance = ot(a), this.pendingRewards = ot(o), this.rewards = ot(i), this.round = ot(s), this.status = l, this.totalAppsOptedIn = et(c), this.totalAssetsOptedIn = et(u), this.totalCreatedApps = et(d), this.totalCreatedAssets = et(w), this.appsLocalState = f, this.appsTotalExtraPages = typeof A > "u" ? void 0 : et(A), this.appsTotalSchema = b, this.assets = g, this.authAddr = typeof k == "string" ? Bt.fromString(k) : k, this.createdApps = v, this.createdAssets = C, this.incentiveEligible = W, this.lastHeartbeat = typeof Z > "u" ? void 0 : et(Z), this.lastProposed = typeof D > "u" ? void 0 : et(D), this.participation = H, this.rewardBase = typeof y > "u" ? void 0 : ot(y), this.sigType = S, this.totalBoxBytes = typeof _ > "u" ? void 0 : et(_), this.totalBoxes = typeof F > "u" ? void 0 : et(F);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return xl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["address", this.address],
      ["amount", this.amount],
      ["amount-without-pending-rewards", this.amountWithoutPendingRewards],
      ["min-balance", this.minBalance],
      ["pending-rewards", this.pendingRewards],
      ["rewards", this.rewards],
      ["round", this.round],
      ["status", this.status],
      ["total-apps-opted-in", this.totalAppsOptedIn],
      ["total-assets-opted-in", this.totalAssetsOptedIn],
      ["total-created-apps", this.totalCreatedApps],
      ["total-created-assets", this.totalCreatedAssets],
      [
        "apps-local-state",
        typeof this.appsLocalState < "u" ? this.appsLocalState.map((e) => e.toEncodingData()) : void 0
      ],
      ["apps-total-extra-pages", this.appsTotalExtraPages],
      [
        "apps-total-schema",
        typeof this.appsTotalSchema < "u" ? this.appsTotalSchema.toEncodingData() : void 0
      ],
      [
        "assets",
        typeof this.assets < "u" ? this.assets.map((e) => e.toEncodingData()) : void 0
      ],
      [
        "auth-addr",
        typeof this.authAddr < "u" ? this.authAddr.toString() : void 0
      ],
      [
        "created-apps",
        typeof this.createdApps < "u" ? this.createdApps.map((e) => e.toEncodingData()) : void 0
      ],
      [
        "created-assets",
        typeof this.createdAssets < "u" ? this.createdAssets.map((e) => e.toEncodingData()) : void 0
      ],
      ["incentive-eligible", this.incentiveEligible],
      ["last-heartbeat", this.lastHeartbeat],
      ["last-proposed", this.lastProposed],
      [
        "participation",
        typeof this.participation < "u" ? this.participation.toEncodingData() : void 0
      ],
      ["reward-base", this.rewardBase],
      ["sig-type", this.sigType],
      ["total-box-bytes", this.totalBoxBytes],
      ["total-boxes", this.totalBoxes]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Account: ${e}`);
    return new xl({
      address: e.get("address"),
      amount: e.get("amount"),
      amountWithoutPendingRewards: e.get("amount-without-pending-rewards"),
      minBalance: e.get("min-balance"),
      pendingRewards: e.get("pending-rewards"),
      rewards: e.get("rewards"),
      round: e.get("round"),
      status: e.get("status"),
      totalAppsOptedIn: e.get("total-apps-opted-in"),
      totalAssetsOptedIn: e.get("total-assets-opted-in"),
      totalCreatedApps: e.get("total-created-apps"),
      totalCreatedAssets: e.get("total-created-assets"),
      appsLocalState: typeof e.get("apps-local-state") < "u" ? e.get("apps-local-state").map((t) => vo.fromEncodingData(t)) : void 0,
      appsTotalExtraPages: e.get("apps-total-extra-pages"),
      appsTotalSchema: typeof e.get("apps-total-schema") < "u" ? Mn.fromEncodingData(e.get("apps-total-schema")) : void 0,
      assets: typeof e.get("assets") < "u" ? e.get("assets").map((t) => bo.fromEncodingData(t)) : void 0,
      authAddr: e.get("auth-addr"),
      createdApps: typeof e.get("created-apps") < "u" ? e.get("created-apps").map((t) => Ii.fromEncodingData(t)) : void 0,
      createdAssets: typeof e.get("created-assets") < "u" ? e.get("created-assets").map((t) => Ti.fromEncodingData(t)) : void 0,
      incentiveEligible: e.get("incentive-eligible"),
      lastHeartbeat: e.get("last-heartbeat"),
      lastProposed: e.get("last-proposed"),
      participation: typeof e.get("participation") < "u" ? $s.fromEncodingData(e.get("participation")) : void 0,
      rewardBase: e.get("reward-base"),
      sigType: e.get("sig-type"),
      totalBoxBytes: e.get("total-box-bytes"),
      totalBoxes: e.get("total-boxes")
    });
  }
}
class kl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "round", valueSchema: new se(), omitEmpty: !0 }, {
      key: "app-local-state",
      valueSchema: new ne(vo.encodingSchema),
      omitEmpty: !0
    }, {
      key: "created-app",
      valueSchema: new ne(_o.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AccountApplicationResponse` object.
   * @param round - The round for which this information is relevant.
   * @param appLocalState - (appl) the application local data stored in this account.
   * The raw account uses `AppLocalState` for this type.
   * @param createdApp - (appp) parameters of the application created by this account including app
   * global data.
   * The raw account uses `AppParams` for this type.
   */
  constructor({ round: e, appLocalState: t, createdApp: n }) {
    this.round = ot(e), this.appLocalState = t, this.createdApp = n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return kl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["round", this.round],
      [
        "app-local-state",
        typeof this.appLocalState < "u" ? this.appLocalState.toEncodingData() : void 0
      ],
      [
        "created-app",
        typeof this.createdApp < "u" ? this.createdApp.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountApplicationResponse: ${e}`);
    return new kl({
      round: e.get("round"),
      appLocalState: typeof e.get("app-local-state") < "u" ? vo.fromEncodingData(e.get("app-local-state")) : void 0,
      createdApp: typeof e.get("created-app") < "u" ? _o.fromEncodingData(e.get("created-app")) : void 0
    });
  }
}
class Al {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "round", valueSchema: new se(), omitEmpty: !0 }, {
      key: "asset-holding",
      valueSchema: new ne(bo.encodingSchema),
      omitEmpty: !0
    }, {
      key: "created-asset",
      valueSchema: new ne(So.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AccountAssetResponse` object.
   * @param round - The round for which this information is relevant.
   * @param assetHolding - (asset) Details about the asset held by this account.
   * The raw account uses `AssetHolding` for this type.
   * @param createdAsset - (apar) parameters of the asset created by this account.
   * The raw account uses `AssetParams` for this type.
   */
  constructor({ round: e, assetHolding: t, createdAsset: n }) {
    this.round = ot(e), this.assetHolding = t, this.createdAsset = n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Al.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["round", this.round],
      [
        "asset-holding",
        typeof this.assetHolding < "u" ? this.assetHolding.toEncodingData() : void 0
      ],
      [
        "created-asset",
        typeof this.createdAsset < "u" ? this.createdAsset.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountAssetResponse: ${e}`);
    return new Al({
      round: e.get("round"),
      assetHolding: typeof e.get("asset-holding") < "u" ? bo.fromEncodingData(e.get("asset-holding")) : void 0,
      createdAsset: typeof e.get("created-asset") < "u" ? So.fromEncodingData(e.get("created-asset")) : void 0
    });
  }
}
class $s {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "selection-participation-key",
      valueSchema: new ct(),
      omitEmpty: !0
    }, {
      key: "vote-first-valid",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "vote-key-dilution",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "vote-last-valid",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "vote-participation-key",
      valueSchema: new ct(),
      omitEmpty: !0
    }, {
      key: "state-proof-key",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AccountParticipation` object.
   * @param selectionParticipationKey - (sel) Selection public key (if any) currently registered for this round.
   * @param voteFirstValid - (voteFst) First round for which this participation is valid.
   * @param voteKeyDilution - (voteKD) Number of subkeys in each batch of participation keys.
   * @param voteLastValid - (voteLst) Last round for which this participation is valid.
   * @param voteParticipationKey - (vote) root participation public key (if any) currently registered for this
   * round.
   * @param stateProofKey - (stprf) Root of the state proof key (if any)
   */
  constructor({ selectionParticipationKey: e, voteFirstValid: t, voteKeyDilution: n, voteLastValid: a, voteParticipationKey: o, stateProofKey: i }) {
    this.selectionParticipationKey = typeof e == "string" ? Tt(e) : e, this.voteFirstValid = ot(t), this.voteKeyDilution = ot(n), this.voteLastValid = ot(a), this.voteParticipationKey = typeof o == "string" ? Tt(o) : o, this.stateProofKey = typeof i == "string" ? Tt(i) : i;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return $s.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["selection-participation-key", this.selectionParticipationKey],
      ["vote-first-valid", this.voteFirstValid],
      ["vote-key-dilution", this.voteKeyDilution],
      ["vote-last-valid", this.voteLastValid],
      ["vote-participation-key", this.voteParticipationKey],
      ["state-proof-key", this.stateProofKey]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountParticipation: ${e}`);
    return new $s({
      selectionParticipationKey: e.get("selection-participation-key"),
      voteFirstValid: e.get("vote-first-valid"),
      voteKeyDilution: e.get("vote-key-dilution"),
      voteLastValid: e.get("vote-last-valid"),
      voteParticipationKey: e.get("vote-participation-key"),
      stateProofKey: e.get("state-proof-key")
    });
  }
}
class wo {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "address", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "delta",
      valueSchema: new We(la.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AccountStateDelta` object.
   * @param address -
   * @param delta - Application state delta.
   */
  constructor({ address: e, delta: t }) {
    this.address = e, this.delta = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return wo.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["address", this.address],
      ["delta", this.delta.map((e) => e.toEncodingData())]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AccountStateDelta: ${e}`);
    return new wo({
      address: e.get("address"),
      delta: (e.get("delta") ?? []).map((t) => la.fromEncodingData(t))
    });
  }
}
class Ii {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "id", valueSchema: new se(), omitEmpty: !0 }, {
      key: "params",
      valueSchema: _o.encodingSchema,
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `Application` object.
   * @param id - (appidx) application index.
   * @param params - (appparams) application parameters.
   */
  constructor({ id: e, params: t }) {
    this.id = ot(e), this.params = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ii.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["id", this.id],
      ["params", this.params.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Application: ${e}`);
    return new Ii({
      id: e.get("id"),
      params: _o.fromEncodingData(e.get("params") ?? /* @__PURE__ */ new Map())
    });
  }
}
class js {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "id", valueSchema: new se(), omitEmpty: !0 }, {
      key: "app-boxes",
      valueSchema: new ne(ta.encodingSchema),
      omitEmpty: !0
    }, {
      key: "app-globals",
      valueSchema: new ne(ta.encodingSchema),
      omitEmpty: !0
    }, {
      key: "app-locals",
      valueSchema: new ne(new We(ta.encodingSchema)),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationInitialStates` object.
   * @param id - Application index.
   * @param appBoxes - An application's global/local/box state.
   * @param appGlobals - An application's global/local/box state.
   * @param appLocals - An application's initial local states tied to different accounts.
   */
  constructor({ id: e, appBoxes: t, appGlobals: n, appLocals: a }) {
    this.id = ot(e), this.appBoxes = t, this.appGlobals = n, this.appLocals = a;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return js.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["id", this.id],
      [
        "app-boxes",
        typeof this.appBoxes < "u" ? this.appBoxes.toEncodingData() : void 0
      ],
      [
        "app-globals",
        typeof this.appGlobals < "u" ? this.appGlobals.toEncodingData() : void 0
      ],
      [
        "app-locals",
        typeof this.appLocals < "u" ? this.appLocals.map((e) => e.toEncodingData()) : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationInitialStates: ${e}`);
    return new js({
      id: e.get("id"),
      appBoxes: typeof e.get("app-boxes") < "u" ? ta.fromEncodingData(e.get("app-boxes")) : void 0,
      appGlobals: typeof e.get("app-globals") < "u" ? ta.fromEncodingData(e.get("app-globals")) : void 0,
      appLocals: typeof e.get("app-locals") < "u" ? e.get("app-locals").map((t) => ta.fromEncodingData(t)) : void 0
    });
  }
}
class ta {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "kvs",
      valueSchema: new We(qs.encodingSchema),
      omitEmpty: !0
    }, {
      key: "account",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationKVStorage` object.
   * @param kvs - Key-Value pairs representing application states.
   * @param account - The address of the account associated with the local state.
   */
  constructor({ kvs: e, account: t }) {
    this.kvs = e, this.account = typeof t == "string" ? Bt.fromString(t) : t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ta.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["kvs", this.kvs.map((e) => e.toEncodingData())],
      [
        "account",
        typeof this.account < "u" ? this.account.toString() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationKVStorage: ${e}`);
    return new ta({
      kvs: (e.get("kvs") ?? []).map((t) => qs.fromEncodingData(t)),
      account: e.get("account")
    });
  }
}
class Fs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "account", valueSchema: new Xe(), omitEmpty: !0 }, { key: "app", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationLocalReference` object.
   * @param account - Address of the account with the local state.
   * @param app - Application ID of the local state application.
   */
  constructor({ account: e, app: t }) {
    this.account = typeof e == "string" ? Bt.fromString(e) : e, this.app = ot(t);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Fs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["account", this.account.toString()],
      ["app", this.app]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationLocalReference: ${e}`);
    return new Fs({
      account: e.get("account"),
      app: e.get("app")
    });
  }
}
class vo {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "id", valueSchema: new se(), omitEmpty: !0 }, {
      key: "schema",
      valueSchema: Mn.encodingSchema,
      omitEmpty: !0
    }, {
      key: "key-value",
      valueSchema: new ne(new We(ko.encodingSchema)),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationLocalState` object.
   * @param id - The application which this local state is for.
   * @param schema - (hsch) schema.
   * @param keyValue - (tkv) storage.
   */
  constructor({ id: e, schema: t, keyValue: n }) {
    this.id = ot(e), this.schema = t, this.keyValue = n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return vo.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["id", this.id],
      ["schema", this.schema.toEncodingData()],
      [
        "key-value",
        typeof this.keyValue < "u" ? this.keyValue.map((e) => e.toEncodingData()) : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationLocalState: ${e}`);
    return new vo({
      id: e.get("id"),
      schema: Mn.fromEncodingData(e.get("schema") ?? /* @__PURE__ */ new Map()),
      keyValue: typeof e.get("key-value") < "u" ? e.get("key-value").map((t) => ko.fromEncodingData(t)) : void 0
    });
  }
}
class _o {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "approval-program",
      valueSchema: new ct(),
      omitEmpty: !0
    }, {
      key: "clear-state-program",
      valueSchema: new ct(),
      omitEmpty: !0
    }, { key: "creator", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "extra-program-pages",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "global-state",
      valueSchema: new ne(new We(ko.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "global-state-schema",
      valueSchema: new ne(Mn.encodingSchema),
      omitEmpty: !0
    }, {
      key: "local-state-schema",
      valueSchema: new ne(Mn.encodingSchema),
      omitEmpty: !0
    }, {
      key: "version",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationParams` object.
   * @param approvalProgram - (approv) approval program.
   * @param clearStateProgram - (clearp) approval program.
   * @param creator - The address that created this application. This is the address where the
   * parameters and global state for this application can be found.
   * @param extraProgramPages - (epp) the amount of extra program pages available to this app.
   * @param globalState - (gs) global state
   * @param globalStateSchema - (gsch) global schema
   * @param localStateSchema - (lsch) local schema
   * @param version - (v) the number of updates to the application programs
   */
  constructor({ approvalProgram: e, clearStateProgram: t, creator: n, extraProgramPages: a, globalState: o, globalStateSchema: i, localStateSchema: s, version: l }) {
    this.approvalProgram = typeof e == "string" ? Tt(e) : e, this.clearStateProgram = typeof t == "string" ? Tt(t) : t, this.creator = typeof n == "string" ? Bt.fromString(n) : n, this.extraProgramPages = typeof a > "u" ? void 0 : et(a), this.globalState = o, this.globalStateSchema = i, this.localStateSchema = s, this.version = typeof l > "u" ? void 0 : et(l);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return _o.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["approval-program", this.approvalProgram],
      ["clear-state-program", this.clearStateProgram],
      ["creator", this.creator.toString()],
      ["extra-program-pages", this.extraProgramPages],
      [
        "global-state",
        typeof this.globalState < "u" ? this.globalState.map((e) => e.toEncodingData()) : void 0
      ],
      [
        "global-state-schema",
        typeof this.globalStateSchema < "u" ? this.globalStateSchema.toEncodingData() : void 0
      ],
      [
        "local-state-schema",
        typeof this.localStateSchema < "u" ? this.localStateSchema.toEncodingData() : void 0
      ],
      ["version", this.version]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationParams: ${e}`);
    return new _o({
      approvalProgram: e.get("approval-program"),
      clearStateProgram: e.get("clear-state-program"),
      creator: e.get("creator"),
      extraProgramPages: e.get("extra-program-pages"),
      globalState: typeof e.get("global-state") < "u" ? e.get("global-state").map((t) => ko.fromEncodingData(t)) : void 0,
      globalStateSchema: typeof e.get("global-state-schema") < "u" ? Mn.fromEncodingData(e.get("global-state-schema")) : void 0,
      localStateSchema: typeof e.get("local-state-schema") < "u" ? Mn.fromEncodingData(e.get("local-state-schema")) : void 0,
      version: e.get("version")
    });
  }
}
class zs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "app-state-type",
      valueSchema: new Xe(),
      omitEmpty: !0
    }, { key: "key", valueSchema: new ct(), omitEmpty: !0 }, { key: "operation", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "account",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "new-value",
      valueSchema: new ne(Rn.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationStateOperation` object.
   * @param appStateType - Type of application state. Value `g` is **global state**, `l` is **local
   * state**, `b` is **boxes**.
   * @param key - The key (name) of the global/local/box state.
   * @param operation - Operation type. Value `w` is **write**, `d` is **delete**.
   * @param account - For local state changes, the address of the account associated with the local
   * state.
   * @param newValue - Represents an AVM value.
   */
  constructor({ appStateType: e, key: t, operation: n, account: a, newValue: o }) {
    this.appStateType = e, this.key = typeof t == "string" ? Tt(t) : t, this.operation = n, this.account = typeof a == "string" ? Bt.fromString(a) : a, this.newValue = o;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return zs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["app-state-type", this.appStateType],
      ["key", this.key],
      ["operation", this.operation],
      [
        "account",
        typeof this.account < "u" ? this.account.toString() : void 0
      ],
      [
        "new-value",
        typeof this.newValue < "u" ? this.newValue.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationStateOperation: ${e}`);
    return new zs({
      appStateType: e.get("app-state-type"),
      key: e.get("key"),
      operation: e.get("operation"),
      account: e.get("account"),
      newValue: typeof e.get("new-value") < "u" ? Rn.fromEncodingData(e.get("new-value")) : void 0
    });
  }
}
class Mn {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "num-byte-slice",
      valueSchema: new se(),
      omitEmpty: !0
    }, { key: "num-uint", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ApplicationStateSchema` object.
   * @param numByteSlice - (nbs) num of byte slices.
   * @param numUint - (nui) num of uints.
   */
  constructor({ numByteSlice: e, numUint: t }) {
    this.numByteSlice = et(e), this.numUint = et(t);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Mn.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["num-byte-slice", this.numByteSlice],
      ["num-uint", this.numUint]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ApplicationStateSchema: ${e}`);
    return new Mn({
      numByteSlice: e.get("num-byte-slice"),
      numUint: e.get("num-uint")
    });
  }
}
class Ti {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "index", valueSchema: new se(), omitEmpty: !0 }, {
      key: "params",
      valueSchema: So.encodingSchema,
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `Asset` object.
   * @param index - unique asset identifier
   * @param params - AssetParams specifies the parameters for an asset.
   * (apar) when part of an AssetConfig transaction.
   * Definition:
   * data/transactions/asset.go : AssetParams
   */
  constructor({ index: e, params: t }) {
    this.index = ot(e), this.params = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ti.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["index", this.index],
      ["params", this.params.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Asset: ${e}`);
    return new Ti({
      index: e.get("index"),
      params: So.fromEncodingData(e.get("params") ?? /* @__PURE__ */ new Map())
    });
  }
}
class bo {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "amount", valueSchema: new se(), omitEmpty: !0 }, { key: "asset-id", valueSchema: new se(), omitEmpty: !0 }, { key: "is-frozen", valueSchema: new Ot(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AssetHolding` object.
   * @param amount - (a) number of units held.
   * @param assetId - Asset ID of the holding.
   * @param isFrozen - (f) whether or not the holding is frozen.
   */
  constructor({ amount: e, assetId: t, isFrozen: n }) {
    this.amount = ot(e), this.assetId = ot(t), this.isFrozen = n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return bo.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["amount", this.amount],
      ["asset-id", this.assetId],
      ["is-frozen", this.isFrozen]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetHolding: ${e}`);
    return new bo({
      amount: e.get("amount"),
      assetId: e.get("asset-id"),
      isFrozen: e.get("is-frozen")
    });
  }
}
class Hs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "account", valueSchema: new Xe(), omitEmpty: !0 }, { key: "asset", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AssetHoldingReference` object.
   * @param account - Address of the account holding the asset.
   * @param asset - Asset ID of the holding.
   */
  constructor({ account: e, asset: t }) {
    this.account = typeof e == "string" ? Bt.fromString(e) : e, this.asset = ot(t);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Hs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["account", this.account.toString()],
      ["asset", this.asset]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetHoldingReference: ${e}`);
    return new Hs({
      account: e.get("account"),
      asset: e.get("asset")
    });
  }
}
class So {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "creator", valueSchema: new Xe(), omitEmpty: !0 }, { key: "decimals", valueSchema: new se(), omitEmpty: !0 }, { key: "total", valueSchema: new se(), omitEmpty: !0 }, {
      key: "clawback",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "default-frozen",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "freeze",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "manager",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "metadata-hash",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "name",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "name-b64",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "reserve",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "unit-name",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "unit-name-b64",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "url",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "url-b64",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AssetParams` object.
   * @param creator - The address that created this asset. This is the address where the parameters
   * for this asset can be found, and also the address where unwanted asset units can
   * be sent in the worst case.
   * @param decimals - (dc) The number of digits to use after the decimal point when displaying this
   * asset. If 0, the asset is not divisible. If 1, the base unit of the asset is in
   * tenths. If 2, the base unit of the asset is in hundredths, and so on. This value
   * must be between 0 and 19 (inclusive).
   * @param total - (t) The total number of units of this asset.
   * @param clawback - (c) Address of account used to clawback holdings of this asset. If empty,
   * clawback is not permitted.
   * @param defaultFrozen - (df) Whether holdings of this asset are frozen by default.
   * @param freeze - (f) Address of account used to freeze holdings of this asset. If empty, freezing
   * is not permitted.
   * @param manager - (m) Address of account used to manage the keys of this asset and to destroy it.
   * @param metadataHash - (am) A commitment to some unspecified asset metadata. The format of this
   * metadata is up to the application.
   * @param name - (an) Name of this asset, as supplied by the creator. Included only when the
   * asset name is composed of printable utf-8 characters.
   * @param nameB64 - Base64 encoded name of this asset, as supplied by the creator.
   * @param reserve - (r) Address of account holding reserve (non-minted) units of this asset.
   * @param unitName - (un) Name of a unit of this asset, as supplied by the creator. Included only
   * when the name of a unit of this asset is composed of printable utf-8 characters.
   * @param unitNameB64 - Base64 encoded name of a unit of this asset, as supplied by the creator.
   * @param url - (au) URL where more information about the asset can be retrieved. Included only
   * when the URL is composed of printable utf-8 characters.
   * @param urlB64 - Base64 encoded URL where more information about the asset can be retrieved.
   */
  constructor({ creator: e, decimals: t, total: n, clawback: a, defaultFrozen: o, freeze: i, manager: s, metadataHash: l, name: c, nameB64: u, reserve: d, unitName: w, unitNameB64: f, url: A, urlB64: b }) {
    this.creator = e, this.decimals = et(t), this.total = ot(n), this.clawback = a, this.defaultFrozen = o, this.freeze = i, this.manager = s, this.metadataHash = typeof l == "string" ? Tt(l) : l, this.name = c, this.nameB64 = typeof u == "string" ? Tt(u) : u, this.reserve = d, this.unitName = w, this.unitNameB64 = typeof f == "string" ? Tt(f) : f, this.url = A, this.urlB64 = typeof b == "string" ? Tt(b) : b;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return So.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["creator", this.creator],
      ["decimals", this.decimals],
      ["total", this.total],
      ["clawback", this.clawback],
      ["default-frozen", this.defaultFrozen],
      ["freeze", this.freeze],
      ["manager", this.manager],
      ["metadata-hash", this.metadataHash],
      ["name", this.name],
      ["name-b64", this.nameB64],
      ["reserve", this.reserve],
      ["unit-name", this.unitName],
      ["unit-name-b64", this.unitNameB64],
      ["url", this.url],
      ["url-b64", this.urlB64]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AssetParams: ${e}`);
    return new So({
      creator: e.get("creator"),
      decimals: e.get("decimals"),
      total: e.get("total"),
      clawback: e.get("clawback"),
      defaultFrozen: e.get("default-frozen"),
      freeze: e.get("freeze"),
      manager: e.get("manager"),
      metadataHash: e.get("metadata-hash"),
      name: e.get("name"),
      nameB64: e.get("name-b64"),
      reserve: e.get("reserve"),
      unitName: e.get("unit-name"),
      unitNameB64: e.get("unit-name-b64"),
      url: e.get("url"),
      urlB64: e.get("url-b64")
    });
  }
}
class qs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "key", valueSchema: new ct(), omitEmpty: !0 }, { key: "value", valueSchema: Rn.encodingSchema, omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AvmKeyValue` object.
   * @param key -
   * @param value - Represents an AVM value.
   */
  constructor({ key: e, value: t }) {
    this.key = typeof e == "string" ? Tt(e) : e, this.value = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return qs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["key", this.key],
      ["value", this.value.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AvmKeyValue: ${e}`);
    return new qs({
      key: e.get("key"),
      value: Rn.fromEncodingData(e.get("value") ?? /* @__PURE__ */ new Map())
    });
  }
}
class Rn {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "type", valueSchema: new se(), omitEmpty: !0 }, {
      key: "bytes",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "uint",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `AvmValue` object.
   * @param type - value type. Value `1` refers to **bytes**, value `2` refers to **uint64**
   * @param bytes - bytes value.
   * @param uint - uint value.
   */
  constructor({ type: e, bytes: t, uint: n }) {
    this.type = et(e), this.bytes = typeof t == "string" ? Tt(t) : t, this.uint = typeof n > "u" ? void 0 : ot(n);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Rn.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["type", this.type],
      ["bytes", this.bytes],
      ["uint", this.uint]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded AvmValue: ${e}`);
    return new Rn({
      type: e.get("type"),
      bytes: e.get("bytes"),
      uint: e.get("uint")
    });
  }
}
class Cl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "blockHash",
      valueSchema: new Xe(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BlockHashResponse` object.
   * @param blockhash - Block header hash.
   */
  constructor({ blockhash: e }) {
    this.blockhash = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Cl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["blockHash", this.blockhash]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BlockHashResponse: ${e}`);
    return new Cl({
      blockhash: e.get("blockHash")
    });
  }
}
class Dl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "block", valueSchema: j1.encodingSchema, omitEmpty: !0 }, {
      key: "cert",
      valueSchema: new ne(ca.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BlockResponse` object.
   * @param block - Block header data.
   * @param cert - Optional certificate object. This is only included when the format is set to
   * message pack.
   */
  constructor({ block: e, cert: t }) {
    this.block = e, this.cert = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Dl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["block", this.block.toEncodingData()],
      [
        "cert",
        typeof this.cert < "u" ? this.cert.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BlockResponse: ${e}`);
    return new Dl({
      block: j1.fromEncodingData(e.get("block") ?? /* @__PURE__ */ new Map()),
      cert: typeof e.get("cert") < "u" ? ca.fromEncodingData(e.get("cert")) : void 0
    });
  }
}
class Ml {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "blockTxids",
      valueSchema: new We(new Xe()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BlockTxidsResponse` object.
   * @param blocktxids - Block transaction IDs.
   */
  constructor({ blocktxids: e }) {
    this.blocktxids = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ml.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["blockTxids", this.blocktxids]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BlockTxidsResponse: ${e}`);
    return new Ml({
      blocktxids: e.get("blockTxids")
    });
  }
}
class Rl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "name", valueSchema: new ct(), omitEmpty: !0 }, { key: "round", valueSchema: new se(), omitEmpty: !0 }, { key: "value", valueSchema: new ct(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `Box` object.
   * @param name - The box name, base64 encoded
   * @param round - The round for which this information is relevant
   * @param value - The box value, base64 encoded.
   */
  constructor({ name: e, round: t, value: n }) {
    this.name = typeof e == "string" ? Tt(e) : e, this.round = ot(t), this.value = typeof n == "string" ? Tt(n) : n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Rl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["name", this.name],
      ["round", this.round],
      ["value", this.value]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Box: ${e}`);
    return new Rl({
      name: e.get("name"),
      round: e.get("round"),
      value: e.get("value")
    });
  }
}
class Ws {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "name",
      valueSchema: new ct(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BoxDescriptor` object.
   * @param name - Base64 encoded box name
   */
  constructor({ name: e }) {
    this.name = typeof e == "string" ? Tt(e) : e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ws.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["name", this.name]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BoxDescriptor: ${e}`);
    return new Ws({
      name: e.get("name")
    });
  }
}
class Ks {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "app", valueSchema: new se(), omitEmpty: !0 }, { key: "name", valueSchema: new ct(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BoxReference` object.
   * @param app - Application ID which this box belongs to
   * @param name - Base64 encoded box name
   */
  constructor({ app: e, name: t }) {
    this.app = ot(e), this.name = typeof t == "string" ? Tt(t) : t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ks.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["app", this.app],
      ["name", this.name]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BoxReference: ${e}`);
    return new Ks({
      app: e.get("app"),
      name: e.get("name")
    });
  }
}
class Il {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "boxes",
      valueSchema: new We(Ws.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BoxesResponse` object.
   * @param boxes -
   */
  constructor({ boxes: e }) {
    this.boxes = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Il.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["boxes", this.boxes.map((e) => e.toEncodingData())]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BoxesResponse: ${e}`);
    return new Il({
      boxes: (e.get("boxes") ?? []).map((t) => Ws.fromEncodingData(t))
    });
  }
}
class Ys {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "branch", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "build_number",
      valueSchema: new se(),
      omitEmpty: !0
    }, { key: "channel", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "commit_hash",
      valueSchema: new Xe(),
      omitEmpty: !0
    }, { key: "major", valueSchema: new se(), omitEmpty: !0 }, { key: "minor", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `BuildVersion` object.
   * @param branch -
   * @param buildNumber -
   * @param channel -
   * @param commitHash -
   * @param major -
   * @param minor -
   */
  constructor({ branch: e, buildNumber: t, channel: n, commitHash: a, major: o, minor: i }) {
    this.branch = e, this.buildNumber = et(t), this.channel = n, this.commitHash = a, this.major = et(o), this.minor = et(i);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ys.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["branch", this.branch],
      ["build_number", this.buildNumber],
      ["channel", this.channel],
      ["commit_hash", this.commitHash],
      ["major", this.major],
      ["minor", this.minor]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded BuildVersion: ${e}`);
    return new Ys({
      branch: e.get("branch"),
      buildNumber: e.get("build_number"),
      channel: e.get("channel"),
      commitHash: e.get("commit_hash"),
      major: e.get("major"),
      minor: e.get("minor")
    });
  }
}
class Tl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "hash", valueSchema: new Xe(), omitEmpty: !0 }, { key: "result", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "sourcemap",
      valueSchema: new ne(ca.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `CompileResponse` object.
   * @param hash - base32 SHA512_256 of program bytes (Address style)
   * @param result - base64 encoded program bytes
   * @param sourcemap - JSON of the source map
   */
  constructor({ hash: e, result: t, sourcemap: n }) {
    this.hash = e, this.result = t, this.sourcemap = n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Tl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["hash", this.hash],
      ["result", this.result],
      [
        "sourcemap",
        typeof this.sourcemap < "u" ? this.sourcemap.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded CompileResponse: ${e}`);
    return new Tl({
      hash: e.get("hash"),
      result: e.get("result"),
      sourcemap: typeof e.get("sourcemap") < "u" ? ca.fromEncodingData(e.get("sourcemap")) : void 0
    });
  }
}
class Ol {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "result",
      valueSchema: new Xe(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `DisassembleResponse` object.
   * @param result - disassembled Teal code
   */
  constructor({ result: e }) {
    this.result = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ol.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["result", this.result]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded DisassembleResponse: ${e}`);
    return new Ol({
      result: e.get("result")
    });
  }
}
class Pl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "error", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "protocol-version",
      valueSchema: new Xe(),
      omitEmpty: !0
    }, {
      key: "txns",
      valueSchema: new We(Gs.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `DryrunResponse` object.
   * @param error -
   * @param protocolVersion - Protocol version is the protocol version Dryrun was operated under.
   * @param txns -
   */
  constructor({ error: e, protocolVersion: t, txns: n }) {
    this.error = e, this.protocolVersion = t, this.txns = n;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Pl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["error", this.error],
      ["protocol-version", this.protocolVersion],
      ["txns", this.txns.map((e) => e.toEncodingData())]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded DryrunResponse: ${e}`);
    return new Pl({
      error: e.get("error"),
      protocolVersion: e.get("protocol-version"),
      txns: (e.get("txns") ?? []).map((t) => Gs.fromEncodingData(t))
    });
  }
}
class to {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "line", valueSchema: new se(), omitEmpty: !0 }, { key: "pc", valueSchema: new se(), omitEmpty: !0 }, {
      key: "stack",
      valueSchema: new We(oa.encodingSchema),
      omitEmpty: !0
    }, {
      key: "error",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "scratch",
      valueSchema: new ne(new We(oa.encodingSchema)),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `DryrunState` object.
   * @param line - Line number
   * @param pc - Program counter
   * @param stack -
   * @param error - Evaluation error if any
   * @param scratch -
   */
  constructor({ line: e, pc: t, stack: n, error: a, scratch: o }) {
    this.line = et(e), this.pc = et(t), this.stack = n, this.error = a, this.scratch = o;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return to.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["line", this.line],
      ["pc", this.pc],
      ["stack", this.stack.map((e) => e.toEncodingData())],
      ["error", this.error],
      [
        "scratch",
        typeof this.scratch < "u" ? this.scratch.map((e) => e.toEncodingData()) : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded DryrunState: ${e}`);
    return new to({
      line: e.get("line"),
      pc: e.get("pc"),
      stack: (e.get("stack") ?? []).map((t) => oa.fromEncodingData(t)),
      error: e.get("error"),
      scratch: typeof e.get("scratch") < "u" ? e.get("scratch").map((t) => oa.fromEncodingData(t)) : void 0
    });
  }
}
class Gs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "disassembly",
      valueSchema: new We(new Xe()),
      omitEmpty: !0
    }, {
      key: "app-call-messages",
      valueSchema: new ne(new We(new Xe())),
      omitEmpty: !0
    }, {
      key: "app-call-trace",
      valueSchema: new ne(new We(to.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "budget-added",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "budget-consumed",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "global-delta",
      valueSchema: new ne(new We(la.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "local-deltas",
      valueSchema: new ne(new We(wo.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "logic-sig-disassembly",
      valueSchema: new ne(new We(new Xe())),
      omitEmpty: !0
    }, {
      key: "logic-sig-messages",
      valueSchema: new ne(new We(new Xe())),
      omitEmpty: !0
    }, {
      key: "logic-sig-trace",
      valueSchema: new ne(new We(to.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "logs",
      valueSchema: new ne(new We(new ct())),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `DryrunTxnResult` object.
   * @param disassembly - Disassembled program line by line.
   * @param appCallMessages -
   * @param appCallTrace -
   * @param budgetAdded - Budget added during execution of app call transaction.
   * @param budgetConsumed - Budget consumed during execution of app call transaction.
   * @param globalDelta - Application state delta.
   * @param localDeltas -
   * @param logicSigDisassembly - Disassembled lsig program line by line.
   * @param logicSigMessages -
   * @param logicSigTrace -
   * @param logs -
   */
  constructor({ disassembly: e, appCallMessages: t, appCallTrace: n, budgetAdded: a, budgetConsumed: o, globalDelta: i, localDeltas: s, logicSigDisassembly: l, logicSigMessages: c, logicSigTrace: u, logs: d }) {
    this.disassembly = e, this.appCallMessages = t, this.appCallTrace = n, this.budgetAdded = typeof a > "u" ? void 0 : et(a), this.budgetConsumed = typeof o > "u" ? void 0 : et(o), this.globalDelta = i, this.localDeltas = s, this.logicSigDisassembly = l, this.logicSigMessages = c, this.logicSigTrace = u, this.logs = d;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Gs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["disassembly", this.disassembly],
      ["app-call-messages", this.appCallMessages],
      [
        "app-call-trace",
        typeof this.appCallTrace < "u" ? this.appCallTrace.map((e) => e.toEncodingData()) : void 0
      ],
      ["budget-added", this.budgetAdded],
      ["budget-consumed", this.budgetConsumed],
      [
        "global-delta",
        typeof this.globalDelta < "u" ? this.globalDelta.map((e) => e.toEncodingData()) : void 0
      ],
      [
        "local-deltas",
        typeof this.localDeltas < "u" ? this.localDeltas.map((e) => e.toEncodingData()) : void 0
      ],
      ["logic-sig-disassembly", this.logicSigDisassembly],
      ["logic-sig-messages", this.logicSigMessages],
      [
        "logic-sig-trace",
        typeof this.logicSigTrace < "u" ? this.logicSigTrace.map((e) => e.toEncodingData()) : void 0
      ],
      ["logs", this.logs]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded DryrunTxnResult: ${e}`);
    return new Gs({
      disassembly: e.get("disassembly"),
      appCallMessages: e.get("app-call-messages"),
      appCallTrace: typeof e.get("app-call-trace") < "u" ? e.get("app-call-trace").map((t) => to.fromEncodingData(t)) : void 0,
      budgetAdded: e.get("budget-added"),
      budgetConsumed: e.get("budget-consumed"),
      globalDelta: typeof e.get("global-delta") < "u" ? e.get("global-delta").map((t) => la.fromEncodingData(t)) : void 0,
      localDeltas: typeof e.get("local-deltas") < "u" ? e.get("local-deltas").map((t) => wo.fromEncodingData(t)) : void 0,
      logicSigDisassembly: e.get("logic-sig-disassembly"),
      logicSigMessages: e.get("logic-sig-messages"),
      logicSigTrace: typeof e.get("logic-sig-trace") < "u" ? e.get("logic-sig-trace").map((t) => to.fromEncodingData(t)) : void 0,
      logs: e.get("logs")
    });
  }
}
class Js {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "action", valueSchema: new se(), omitEmpty: !0 }, {
      key: "bytes",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "uint",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `EvalDelta` object.
   * @param action - (at) delta action.
   * @param bytes - (bs) bytes value.
   * @param uint - (ui) uint value.
   */
  constructor({ action: e, bytes: t, uint: n }) {
    this.action = et(e), this.bytes = t, this.uint = typeof n > "u" ? void 0 : ot(n);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Js.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["action", this.action],
      ["bytes", this.bytes],
      ["uint", this.uint]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded EvalDelta: ${e}`);
    return new Js({
      action: e.get("action"),
      bytes: e.get("bytes"),
      uint: e.get("uint")
    });
  }
}
class la {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "key", valueSchema: new Xe(), omitEmpty: !0 }, { key: "value", valueSchema: Js.encodingSchema, omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `EvalDeltaKeyValue` object.
   * @param key -
   * @param value - Represents a TEAL value delta.
   */
  constructor({ key: e, value: t }) {
    this.key = e, this.value = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return la.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["key", this.key],
      ["value", this.value.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded EvalDeltaKeyValue: ${e}`);
    return new la({
      key: e.get("key"),
      value: Js.fromEncodingData(e.get("value") ?? /* @__PURE__ */ new Map())
    });
  }
}
class Nl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "offset",
      valueSchema: new se(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `GetBlockTimeStampOffsetResponse` object.
   * @param offset - Timestamp offset in seconds.
   */
  constructor({ offset: e }) {
    this.offset = et(e);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Nl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["offset", this.offset]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded GetBlockTimeStampOffsetResponse: ${e}`);
    return new Nl({
      offset: e.get("offset")
    });
  }
}
class Bl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "round",
      valueSchema: new se(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `GetSyncRoundResponse` object.
   * @param round - The minimum sync round for the ledger.
   */
  constructor({ round: e }) {
    this.round = ot(e);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Bl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["round", this.round]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded GetSyncRoundResponse: ${e}`);
    return new Bl({
      round: e.get("round")
    });
  }
}
class Xs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "Delta",
      valueSchema: Ha.encodingSchema,
      omitEmpty: !0
    }, {
      key: "Ids",
      valueSchema: new We(new Xe()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `LedgerStateDeltaForTransactionGroup` object.
   * @param delta - Ledger StateDelta object
   * @param ids -
   */
  constructor({ delta: e, ids: t }) {
    this.delta = e, this.ids = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Xs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Delta", this.delta.toEncodingData()],
      ["Ids", this.ids]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded LedgerStateDeltaForTransactionGroup: ${e}`);
    return new Xs({
      delta: Ha.fromEncodingData(e.get("Delta") ?? /* @__PURE__ */ new Map()),
      ids: e.get("Ids")
    });
  }
}
let FS = class W1 {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "index", valueSchema: new se(), omitEmpty: !0 }, { key: "proof", valueSchema: new ct(), omitEmpty: !0 }, { key: "treedepth", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `LightBlockHeaderProof` object.
   * @param index - The index of the light block header in the vector commitment tree
   * @param proof - The encoded proof.
   * @param treedepth - Represents the depth of the tree that is being proven, i.e. the number of edges
   * from a leaf to the root.
   */
  constructor({ index: e, proof: t, treedepth: n }) {
    this.index = et(e), this.proof = typeof t == "string" ? Tt(t) : t, this.treedepth = et(n);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return W1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["index", this.index],
      ["proof", this.proof],
      ["treedepth", this.treedepth]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded LightBlockHeaderProof: ${e}`);
    return new W1({
      index: e.get("index"),
      proof: e.get("proof"),
      treedepth: e.get("treedepth")
    });
  }
};
class Zs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "catchup-time",
      valueSchema: new se(),
      omitEmpty: !0
    }, { key: "last-round", valueSchema: new se(), omitEmpty: !0 }, {
      key: "last-version",
      valueSchema: new Xe(),
      omitEmpty: !0
    }, {
      key: "next-version",
      valueSchema: new Xe(),
      omitEmpty: !0
    }, {
      key: "next-version-round",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "next-version-supported",
      valueSchema: new Ot(),
      omitEmpty: !0
    }, {
      key: "stopped-at-unsupported-round",
      valueSchema: new Ot(),
      omitEmpty: !0
    }, {
      key: "time-since-last-round",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "catchpoint",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "catchpoint-acquired-blocks",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-processed-accounts",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-processed-kvs",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-total-accounts",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-total-blocks",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-total-kvs",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-verified-accounts",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "catchpoint-verified-kvs",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "last-catchpoint",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "upgrade-delay",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "upgrade-next-protocol-vote-before",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "upgrade-no-votes",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "upgrade-node-vote",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "upgrade-vote-rounds",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "upgrade-votes",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "upgrade-votes-required",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "upgrade-yes-votes",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `NodeStatusResponse` object.
   * @param catchupTime - CatchupTime in nanoseconds
   * @param lastRound - LastRound indicates the last round seen
   * @param lastVersion - LastVersion indicates the last consensus version supported
   * @param nextVersion - NextVersion of consensus protocol to use
   * @param nextVersionRound - NextVersionRound is the round at which the next consensus version will apply
   * @param nextVersionSupported - NextVersionSupported indicates whether the next consensus version is supported
   * by this node
   * @param stoppedAtUnsupportedRound - StoppedAtUnsupportedRound indicates that the node does not support the new
   * rounds and has stopped making progress
   * @param timeSinceLastRound - TimeSinceLastRound in nanoseconds
   * @param catchpoint - The current catchpoint that is being caught up to
   * @param catchpointAcquiredBlocks - The number of blocks that have already been obtained by the node as part of the
   * catchup
   * @param catchpointProcessedAccounts - The number of accounts from the current catchpoint that have been processed so
   * far as part of the catchup
   * @param catchpointProcessedKvs - The number of key-values (KVs) from the current catchpoint that have been
   * processed so far as part of the catchup
   * @param catchpointTotalAccounts - The total number of accounts included in the current catchpoint
   * @param catchpointTotalBlocks - The total number of blocks that are required to complete the current catchpoint
   * catchup
   * @param catchpointTotalKvs - The total number of key-values (KVs) included in the current catchpoint
   * @param catchpointVerifiedAccounts - The number of accounts from the current catchpoint that have been verified so
   * far as part of the catchup
   * @param catchpointVerifiedKvs - The number of key-values (KVs) from the current catchpoint that have been
   * verified so far as part of the catchup
   * @param lastCatchpoint - The last catchpoint seen by the node
   * @param upgradeDelay - Upgrade delay
   * @param upgradeNextProtocolVoteBefore - Next protocol round
   * @param upgradeNoVotes - No votes cast for consensus upgrade
   * @param upgradeNodeVote - This node's upgrade vote
   * @param upgradeVoteRounds - Total voting rounds for current upgrade
   * @param upgradeVotes - Total votes cast for consensus upgrade
   * @param upgradeVotesRequired - Yes votes required for consensus upgrade
   * @param upgradeYesVotes - Yes votes cast for consensus upgrade
   */
  constructor({ catchupTime: e, lastRound: t, lastVersion: n, nextVersion: a, nextVersionRound: o, nextVersionSupported: i, stoppedAtUnsupportedRound: s, timeSinceLastRound: l, catchpoint: c, catchpointAcquiredBlocks: u, catchpointProcessedAccounts: d, catchpointProcessedKvs: w, catchpointTotalAccounts: f, catchpointTotalBlocks: A, catchpointTotalKvs: b, catchpointVerifiedAccounts: g, catchpointVerifiedKvs: k, lastCatchpoint: v, upgradeDelay: C, upgradeNextProtocolVoteBefore: W, upgradeNoVotes: Z, upgradeNodeVote: D, upgradeVoteRounds: H, upgradeVotes: y, upgradeVotesRequired: S, upgradeYesVotes: _ }) {
    this.catchupTime = ot(e), this.lastRound = ot(t), this.lastVersion = n, this.nextVersion = a, this.nextVersionRound = ot(o), this.nextVersionSupported = i, this.stoppedAtUnsupportedRound = s, this.timeSinceLastRound = ot(l), this.catchpoint = c, this.catchpointAcquiredBlocks = typeof u > "u" ? void 0 : et(u), this.catchpointProcessedAccounts = typeof d > "u" ? void 0 : et(d), this.catchpointProcessedKvs = typeof w > "u" ? void 0 : et(w), this.catchpointTotalAccounts = typeof f > "u" ? void 0 : et(f), this.catchpointTotalBlocks = typeof A > "u" ? void 0 : et(A), this.catchpointTotalKvs = typeof b > "u" ? void 0 : et(b), this.catchpointVerifiedAccounts = typeof g > "u" ? void 0 : et(g), this.catchpointVerifiedKvs = typeof k > "u" ? void 0 : et(k), this.lastCatchpoint = v, this.upgradeDelay = typeof C > "u" ? void 0 : ot(C), this.upgradeNextProtocolVoteBefore = typeof W > "u" ? void 0 : ot(W), this.upgradeNoVotes = typeof Z > "u" ? void 0 : et(Z), this.upgradeNodeVote = D, this.upgradeVoteRounds = typeof H > "u" ? void 0 : et(H), this.upgradeVotes = typeof y > "u" ? void 0 : et(y), this.upgradeVotesRequired = typeof S > "u" ? void 0 : et(S), this.upgradeYesVotes = typeof _ > "u" ? void 0 : et(_);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Zs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["catchup-time", this.catchupTime],
      ["last-round", this.lastRound],
      ["last-version", this.lastVersion],
      ["next-version", this.nextVersion],
      ["next-version-round", this.nextVersionRound],
      ["next-version-supported", this.nextVersionSupported],
      ["stopped-at-unsupported-round", this.stoppedAtUnsupportedRound],
      ["time-since-last-round", this.timeSinceLastRound],
      ["catchpoint", this.catchpoint],
      ["catchpoint-acquired-blocks", this.catchpointAcquiredBlocks],
      ["catchpoint-processed-accounts", this.catchpointProcessedAccounts],
      ["catchpoint-processed-kvs", this.catchpointProcessedKvs],
      ["catchpoint-total-accounts", this.catchpointTotalAccounts],
      ["catchpoint-total-blocks", this.catchpointTotalBlocks],
      ["catchpoint-total-kvs", this.catchpointTotalKvs],
      ["catchpoint-verified-accounts", this.catchpointVerifiedAccounts],
      ["catchpoint-verified-kvs", this.catchpointVerifiedKvs],
      ["last-catchpoint", this.lastCatchpoint],
      ["upgrade-delay", this.upgradeDelay],
      ["upgrade-next-protocol-vote-before", this.upgradeNextProtocolVoteBefore],
      ["upgrade-no-votes", this.upgradeNoVotes],
      ["upgrade-node-vote", this.upgradeNodeVote],
      ["upgrade-vote-rounds", this.upgradeVoteRounds],
      ["upgrade-votes", this.upgradeVotes],
      ["upgrade-votes-required", this.upgradeVotesRequired],
      ["upgrade-yes-votes", this.upgradeYesVotes]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded NodeStatusResponse: ${e}`);
    return new Zs({
      catchupTime: e.get("catchup-time"),
      lastRound: e.get("last-round"),
      lastVersion: e.get("last-version"),
      nextVersion: e.get("next-version"),
      nextVersionRound: e.get("next-version-round"),
      nextVersionSupported: e.get("next-version-supported"),
      stoppedAtUnsupportedRound: e.get("stopped-at-unsupported-round"),
      timeSinceLastRound: e.get("time-since-last-round"),
      catchpoint: e.get("catchpoint"),
      catchpointAcquiredBlocks: e.get("catchpoint-acquired-blocks"),
      catchpointProcessedAccounts: e.get("catchpoint-processed-accounts"),
      catchpointProcessedKvs: e.get("catchpoint-processed-kvs"),
      catchpointTotalAccounts: e.get("catchpoint-total-accounts"),
      catchpointTotalBlocks: e.get("catchpoint-total-blocks"),
      catchpointTotalKvs: e.get("catchpoint-total-kvs"),
      catchpointVerifiedAccounts: e.get("catchpoint-verified-accounts"),
      catchpointVerifiedKvs: e.get("catchpoint-verified-kvs"),
      lastCatchpoint: e.get("last-catchpoint"),
      upgradeDelay: e.get("upgrade-delay"),
      upgradeNextProtocolVoteBefore: e.get("upgrade-next-protocol-vote-before"),
      upgradeNoVotes: e.get("upgrade-no-votes"),
      upgradeNodeVote: e.get("upgrade-node-vote"),
      upgradeVoteRounds: e.get("upgrade-vote-rounds"),
      upgradeVotes: e.get("upgrade-votes"),
      upgradeVotesRequired: e.get("upgrade-votes-required"),
      upgradeYesVotes: e.get("upgrade-yes-votes")
    });
  }
}
class Ba {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "pool-error", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "txn",
      valueSchema: Jr.encodingSchema,
      omitEmpty: !0
    }, {
      key: "application-index",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "asset-closing-amount",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "asset-index",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "close-rewards",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "closing-amount",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "confirmed-round",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "global-state-delta",
      valueSchema: new ne(new We(la.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "inner-txns",
      valueSchema: new ne(new We(Ba.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "local-state-delta",
      valueSchema: new ne(new We(wo.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "logs",
      valueSchema: new ne(new We(new ct())),
      omitEmpty: !0
    }, {
      key: "receiver-rewards",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "sender-rewards",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `PendingTransactionResponse` object.
   * @param poolError - Indicates that the transaction was kicked out of this node's transaction pool
   * (and specifies why that happened). An empty string indicates the transaction
   * wasn't kicked out of this node's txpool due to an error.
   * @param txn - The raw signed transaction.
   * @param applicationIndex - The application index if the transaction was found and it created an
   * application.
   * @param assetClosingAmount - The number of the asset's unit that were transferred to the close-to address.
   * @param assetIndex - The asset index if the transaction was found and it created an asset.
   * @param closeRewards - Rewards in microalgos applied to the close remainder to account.
   * @param closingAmount - Closing amount for the transaction.
   * @param confirmedRound - The round where this transaction was confirmed, if present.
   * @param globalStateDelta - Global state key/value changes for the application being executed by this
   * transaction.
   * @param innerTxns - Inner transactions produced by application execution.
   * @param localStateDelta - Local state key/value changes for the application being executed by this
   * transaction.
   * @param logs - Logs for the application being executed by this transaction.
   * @param receiverRewards - Rewards in microalgos applied to the receiver account.
   * @param senderRewards - Rewards in microalgos applied to the sender account.
   */
  constructor({ poolError: e, txn: t, applicationIndex: n, assetClosingAmount: a, assetIndex: o, closeRewards: i, closingAmount: s, confirmedRound: l, globalStateDelta: c, innerTxns: u, localStateDelta: d, logs: w, receiverRewards: f, senderRewards: A }) {
    this.poolError = e, this.txn = t, this.applicationIndex = typeof n > "u" ? void 0 : ot(n), this.assetClosingAmount = typeof a > "u" ? void 0 : ot(a), this.assetIndex = typeof o > "u" ? void 0 : ot(o), this.closeRewards = typeof i > "u" ? void 0 : ot(i), this.closingAmount = typeof s > "u" ? void 0 : ot(s), this.confirmedRound = typeof l > "u" ? void 0 : ot(l), this.globalStateDelta = c, this.innerTxns = u, this.localStateDelta = d, this.logs = w, this.receiverRewards = typeof f > "u" ? void 0 : ot(f), this.senderRewards = typeof A > "u" ? void 0 : ot(A);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ba.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["pool-error", this.poolError],
      ["txn", this.txn.toEncodingData()],
      ["application-index", this.applicationIndex],
      ["asset-closing-amount", this.assetClosingAmount],
      ["asset-index", this.assetIndex],
      ["close-rewards", this.closeRewards],
      ["closing-amount", this.closingAmount],
      ["confirmed-round", this.confirmedRound],
      [
        "global-state-delta",
        typeof this.globalStateDelta < "u" ? this.globalStateDelta.map((e) => e.toEncodingData()) : void 0
      ],
      [
        "inner-txns",
        typeof this.innerTxns < "u" ? this.innerTxns.map((e) => e.toEncodingData()) : void 0
      ],
      [
        "local-state-delta",
        typeof this.localStateDelta < "u" ? this.localStateDelta.map((e) => e.toEncodingData()) : void 0
      ],
      ["logs", this.logs],
      ["receiver-rewards", this.receiverRewards],
      ["sender-rewards", this.senderRewards]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded PendingTransactionResponse: ${e}`);
    return new Ba({
      poolError: e.get("pool-error"),
      txn: Jr.fromEncodingData(e.get("txn") ?? /* @__PURE__ */ new Map()),
      applicationIndex: e.get("application-index"),
      assetClosingAmount: e.get("asset-closing-amount"),
      assetIndex: e.get("asset-index"),
      closeRewards: e.get("close-rewards"),
      closingAmount: e.get("closing-amount"),
      confirmedRound: e.get("confirmed-round"),
      globalStateDelta: typeof e.get("global-state-delta") < "u" ? e.get("global-state-delta").map((t) => la.fromEncodingData(t)) : void 0,
      innerTxns: typeof e.get("inner-txns") < "u" ? e.get("inner-txns").map((t) => Ba.fromEncodingData(t)) : void 0,
      localStateDelta: typeof e.get("local-state-delta") < "u" ? e.get("local-state-delta").map((t) => wo.fromEncodingData(t)) : void 0,
      logs: e.get("logs"),
      receiverRewards: e.get("receiver-rewards"),
      senderRewards: e.get("sender-rewards")
    });
  }
}
class Qs {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "top-transactions",
      valueSchema: new We(Jr.encodingSchema),
      omitEmpty: !0
    }, {
      key: "total-transactions",
      valueSchema: new se(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `PendingTransactionsResponse` object.
   * @param topTransactions - An array of signed transaction objects.
   * @param totalTransactions - Total number of transactions in the pool.
   */
  constructor({ topTransactions: e, totalTransactions: t }) {
    this.topTransactions = e, this.totalTransactions = et(t);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Qs.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["top-transactions", this.topTransactions.map((e) => e.toEncodingData())],
      ["total-transactions", this.totalTransactions]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded PendingTransactionsResponse: ${e}`);
    return new Qs({
      topTransactions: (e.get("top-transactions") ?? []).map((t) => Jr.fromEncodingData(t)),
      totalTransactions: e.get("total-transactions")
    });
  }
}
class Ll {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "txId",
      valueSchema: new Xe(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `PostTransactionsResponse` object.
   * @param txid - encoding of the transaction hash.
   */
  constructor({ txid: e }) {
    this.txid = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ll.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([["txId", this.txid]]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded PostTransactionsResponse: ${e}`);
    return new Ll({
      txid: e.get("txId")
    });
  }
}
class ec {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "new-value",
      valueSchema: Rn.encodingSchema,
      omitEmpty: !0
    }, { key: "slot", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `ScratchChange` object.
   * @param newValue - Represents an AVM value.
   * @param slot - The scratch slot written.
   */
  constructor({ newValue: e, slot: t }) {
    this.newValue = e, this.slot = et(t);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ec.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["new-value", this.newValue.toEncodingData()],
      ["slot", this.slot]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded ScratchChange: ${e}`);
    return new ec({
      newValue: Rn.fromEncodingData(e.get("new-value") ?? /* @__PURE__ */ new Map()),
      slot: e.get("slot")
    });
  }
}
class tc {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "app-initial-states",
      valueSchema: new ne(new We(js.encodingSchema)),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateInitialStates` object.
   * @param appInitialStates - The initial states of accessed application before simulation. The order of this
   * array is arbitrary.
   */
  constructor({ appInitialStates: e }) {
    this.appInitialStates = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return tc.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      [
        "app-initial-states",
        typeof this.appInitialStates < "u" ? this.appInitialStates.map((e) => e.toEncodingData()) : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateInitialStates: ${e}`);
    return new tc({
      appInitialStates: typeof e.get("app-initial-states") < "u" ? e.get("app-initial-states").map((t) => js.fromEncodingData(t)) : void 0
    });
  }
}
class Ul {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "txn-groups",
      valueSchema: new We(Oi.encodingSchema),
      omitEmpty: !0
    }, {
      key: "allow-empty-signatures",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "allow-more-logging",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "allow-unnamed-resources",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "exec-trace-config",
      valueSchema: new ne(Eo.encodingSchema),
      omitEmpty: !0
    }, {
      key: "extra-opcode-budget",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "fix-signers",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "round",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateRequest` object.
   * @param txnGroups - The transaction groups to simulate.
   * @param allowEmptySignatures - Allows transactions without signatures to be simulated as if they had correct
   * signatures.
   * @param allowMoreLogging - Lifts limits on log opcode usage during simulation.
   * @param allowUnnamedResources - Allows access to unnamed resources during simulation.
   * @param execTraceConfig - An object that configures simulation execution trace.
   * @param extraOpcodeBudget - Applies extra opcode budget during simulation for each transaction group.
   * @param fixSigners - If true, signers for transactions that are missing signatures will be fixed
   * during evaluation.
   * @param round - If provided, specifies the round preceding the simulation. State changes through
   * this round will be used to run this simulation. Usually only the 4 most recent
   * rounds will be available (controlled by the node config value MaxAcctLookback).
   * If not specified, defaults to the latest available round.
   */
  constructor({ txnGroups: e, allowEmptySignatures: t, allowMoreLogging: n, allowUnnamedResources: a, execTraceConfig: o, extraOpcodeBudget: i, fixSigners: s, round: l }) {
    this.txnGroups = e, this.allowEmptySignatures = t, this.allowMoreLogging = n, this.allowUnnamedResources = a, this.execTraceConfig = o, this.extraOpcodeBudget = typeof i > "u" ? void 0 : et(i), this.fixSigners = s, this.round = typeof l > "u" ? void 0 : ot(l);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Ul.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["txn-groups", this.txnGroups.map((e) => e.toEncodingData())],
      ["allow-empty-signatures", this.allowEmptySignatures],
      ["allow-more-logging", this.allowMoreLogging],
      ["allow-unnamed-resources", this.allowUnnamedResources],
      [
        "exec-trace-config",
        typeof this.execTraceConfig < "u" ? this.execTraceConfig.toEncodingData() : void 0
      ],
      ["extra-opcode-budget", this.extraOpcodeBudget],
      ["fix-signers", this.fixSigners],
      ["round", this.round]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateRequest: ${e}`);
    return new Ul({
      txnGroups: (e.get("txn-groups") ?? []).map((t) => Oi.fromEncodingData(t)),
      allowEmptySignatures: e.get("allow-empty-signatures"),
      allowMoreLogging: e.get("allow-more-logging"),
      allowUnnamedResources: e.get("allow-unnamed-resources"),
      execTraceConfig: typeof e.get("exec-trace-config") < "u" ? Eo.fromEncodingData(e.get("exec-trace-config")) : void 0,
      extraOpcodeBudget: e.get("extra-opcode-budget"),
      fixSigners: e.get("fix-signers"),
      round: e.get("round")
    });
  }
}
class Oi {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "txns",
      valueSchema: new We(Jr.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateRequestTransactionGroup` object.
   * @param txns - An atomic transaction group.
   */
  constructor({ txns: e }) {
    this.txns = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Oi.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["txns", this.txns.map((e) => e.toEncodingData())]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateRequestTransactionGroup: ${e}`);
    return new Oi({
      txns: (e.get("txns") ?? []).map((t) => Jr.fromEncodingData(t))
    });
  }
}
class Vl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "last-round", valueSchema: new se(), omitEmpty: !0 }, {
      key: "txn-groups",
      valueSchema: new We(rc.encodingSchema),
      omitEmpty: !0
    }, { key: "version", valueSchema: new se(), omitEmpty: !0 }, {
      key: "eval-overrides",
      valueSchema: new ne(ac.encodingSchema),
      omitEmpty: !0
    }, {
      key: "exec-trace-config",
      valueSchema: new ne(Eo.encodingSchema),
      omitEmpty: !0
    }, {
      key: "initial-states",
      valueSchema: new ne(tc.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateResponse` object.
   * @param lastRound - The round immediately preceding this simulation. State changes through this
   * round were used to run this simulation.
   * @param txnGroups - A result object for each transaction group that was simulated.
   * @param version - The version of this response object.
   * @param evalOverrides - The set of parameters and limits override during simulation. If this set of
   * parameters is present, then evaluation parameters may differ from standard
   * evaluation in certain ways.
   * @param execTraceConfig - An object that configures simulation execution trace.
   * @param initialStates - Initial states of resources that were accessed during simulation.
   */
  constructor({ lastRound: e, txnGroups: t, version: n, evalOverrides: a, execTraceConfig: o, initialStates: i }) {
    this.lastRound = ot(e), this.txnGroups = t, this.version = et(n), this.evalOverrides = a, this.execTraceConfig = o, this.initialStates = i;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Vl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["last-round", this.lastRound],
      ["txn-groups", this.txnGroups.map((e) => e.toEncodingData())],
      ["version", this.version],
      [
        "eval-overrides",
        typeof this.evalOverrides < "u" ? this.evalOverrides.toEncodingData() : void 0
      ],
      [
        "exec-trace-config",
        typeof this.execTraceConfig < "u" ? this.execTraceConfig.toEncodingData() : void 0
      ],
      [
        "initial-states",
        typeof this.initialStates < "u" ? this.initialStates.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateResponse: ${e}`);
    return new Vl({
      lastRound: e.get("last-round"),
      txnGroups: (e.get("txn-groups") ?? []).map((t) => rc.fromEncodingData(t)),
      version: e.get("version"),
      evalOverrides: typeof e.get("eval-overrides") < "u" ? ac.fromEncodingData(e.get("eval-overrides")) : void 0,
      execTraceConfig: typeof e.get("exec-trace-config") < "u" ? Eo.fromEncodingData(e.get("exec-trace-config")) : void 0,
      initialStates: typeof e.get("initial-states") < "u" ? tc.fromEncodingData(e.get("initial-states")) : void 0
    });
  }
}
class Eo {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "enable",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "scratch-change",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "stack-change",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "state-change",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateTraceConfig` object.
   * @param enable - A boolean option for opting in execution trace features simulation endpoint.
   * @param scratchChange - A boolean option enabling returning scratch slot changes together with execution
   * trace during simulation.
   * @param stackChange - A boolean option enabling returning stack changes together with execution trace
   * during simulation.
   * @param stateChange - A boolean option enabling returning application state changes (global, local,
   * and box changes) with the execution trace during simulation.
   */
  constructor({ enable: e, scratchChange: t, stackChange: n, stateChange: a }) {
    this.enable = e, this.scratchChange = t, this.stackChange = n, this.stateChange = a;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Eo.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["enable", this.enable],
      ["scratch-change", this.scratchChange],
      ["stack-change", this.stackChange],
      ["state-change", this.stateChange]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateTraceConfig: ${e}`);
    return new Eo({
      enable: e.get("enable"),
      scratchChange: e.get("scratch-change"),
      stackChange: e.get("stack-change"),
      stateChange: e.get("state-change")
    });
  }
}
class rc {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "txn-results",
      valueSchema: new We(nc.encodingSchema),
      omitEmpty: !0
    }, {
      key: "app-budget-added",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "app-budget-consumed",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "failed-at",
      valueSchema: new ne(new We(new se())),
      omitEmpty: !0
    }, {
      key: "failure-message",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "unnamed-resources-accessed",
      valueSchema: new ne(xo.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateTransactionGroupResult` object.
   * @param txnResults - Simulation result for individual transactions
   * @param appBudgetAdded - Total budget added during execution of app calls in the transaction group.
   * @param appBudgetConsumed - Total budget consumed during execution of app calls in the transaction group.
   * @param failedAt - If present, indicates which transaction in this group caused the failure. This
   * array represents the path to the failing transaction. Indexes are zero based,
   * the first element indicates the top-level transaction, and successive elements
   * indicate deeper inner transactions.
   * @param failureMessage - If present, indicates that the transaction group failed and specifies why that
   * happened
   * @param unnamedResourcesAccessed - These are resources that were accessed by this group that would normally have
   * caused failure, but were allowed in simulation. Depending on where this object
   * is in the response, the unnamed resources it contains may or may not qualify for
   * group resource sharing. If this is a field in SimulateTransactionGroupResult,
   * the resources do qualify, but if this is a field in SimulateTransactionResult,
   * they do not qualify. In order to make this group valid for actual submission,
   * resources that qualify for group sharing can be made available by any
   * transaction of the group; otherwise, resources must be placed in the same
   * transaction which accessed them.
   */
  constructor({ txnResults: e, appBudgetAdded: t, appBudgetConsumed: n, failedAt: a, failureMessage: o, unnamedResourcesAccessed: i }) {
    this.txnResults = e, this.appBudgetAdded = typeof t > "u" ? void 0 : et(t), this.appBudgetConsumed = typeof n > "u" ? void 0 : et(n), this.failedAt = typeof a > "u" ? void 0 : a.map(et), this.failureMessage = o, this.unnamedResourcesAccessed = i;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return rc.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["txn-results", this.txnResults.map((e) => e.toEncodingData())],
      ["app-budget-added", this.appBudgetAdded],
      ["app-budget-consumed", this.appBudgetConsumed],
      ["failed-at", this.failedAt],
      ["failure-message", this.failureMessage],
      [
        "unnamed-resources-accessed",
        typeof this.unnamedResourcesAccessed < "u" ? this.unnamedResourcesAccessed.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateTransactionGroupResult: ${e}`);
    return new rc({
      txnResults: (e.get("txn-results") ?? []).map((t) => nc.fromEncodingData(t)),
      appBudgetAdded: e.get("app-budget-added"),
      appBudgetConsumed: e.get("app-budget-consumed"),
      failedAt: e.get("failed-at"),
      failureMessage: e.get("failure-message"),
      unnamedResourcesAccessed: typeof e.get("unnamed-resources-accessed") < "u" ? xo.fromEncodingData(e.get("unnamed-resources-accessed")) : void 0
    });
  }
}
class nc {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "txn-result",
      valueSchema: Ba.encodingSchema,
      omitEmpty: !0
    }, {
      key: "app-budget-consumed",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "exec-trace",
      valueSchema: new ne(ro.encodingSchema),
      omitEmpty: !0
    }, {
      key: "fixed-signer",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "logic-sig-budget-consumed",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "unnamed-resources-accessed",
      valueSchema: new ne(xo.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateTransactionResult` object.
   * @param txnResult - Details about a pending transaction. If the transaction was recently confirmed,
   * includes confirmation details like the round and reward details.
   * @param appBudgetConsumed - Budget used during execution of an app call transaction. This value includes
   * budged used by inner app calls spawned by this transaction.
   * @param execTrace - The execution trace of calling an app or a logic sig, containing the inner app
   * call trace in a recursive way.
   * @param fixedSigner - The account that needed to sign this transaction when no signature was provided
   * and the provided signer was incorrect.
   * @param logicSigBudgetConsumed - Budget used during execution of a logic sig transaction.
   * @param unnamedResourcesAccessed - These are resources that were accessed by this group that would normally have
   * caused failure, but were allowed in simulation. Depending on where this object
   * is in the response, the unnamed resources it contains may or may not qualify for
   * group resource sharing. If this is a field in SimulateTransactionGroupResult,
   * the resources do qualify, but if this is a field in SimulateTransactionResult,
   * they do not qualify. In order to make this group valid for actual submission,
   * resources that qualify for group sharing can be made available by any
   * transaction of the group; otherwise, resources must be placed in the same
   * transaction which accessed them.
   */
  constructor({ txnResult: e, appBudgetConsumed: t, execTrace: n, fixedSigner: a, logicSigBudgetConsumed: o, unnamedResourcesAccessed: i }) {
    this.txnResult = e, this.appBudgetConsumed = typeof t > "u" ? void 0 : et(t), this.execTrace = n, this.fixedSigner = typeof a == "string" ? Bt.fromString(a) : a, this.logicSigBudgetConsumed = typeof o > "u" ? void 0 : et(o), this.unnamedResourcesAccessed = i;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return nc.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["txn-result", this.txnResult.toEncodingData()],
      ["app-budget-consumed", this.appBudgetConsumed],
      [
        "exec-trace",
        typeof this.execTrace < "u" ? this.execTrace.toEncodingData() : void 0
      ],
      [
        "fixed-signer",
        typeof this.fixedSigner < "u" ? this.fixedSigner.toString() : void 0
      ],
      ["logic-sig-budget-consumed", this.logicSigBudgetConsumed],
      [
        "unnamed-resources-accessed",
        typeof this.unnamedResourcesAccessed < "u" ? this.unnamedResourcesAccessed.toEncodingData() : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateTransactionResult: ${e}`);
    return new nc({
      txnResult: Ba.fromEncodingData(e.get("txn-result") ?? /* @__PURE__ */ new Map()),
      appBudgetConsumed: e.get("app-budget-consumed"),
      execTrace: typeof e.get("exec-trace") < "u" ? ro.fromEncodingData(e.get("exec-trace")) : void 0,
      fixedSigner: e.get("fixed-signer"),
      logicSigBudgetConsumed: e.get("logic-sig-budget-consumed"),
      unnamedResourcesAccessed: typeof e.get("unnamed-resources-accessed") < "u" ? xo.fromEncodingData(e.get("unnamed-resources-accessed")) : void 0
    });
  }
}
class xo {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "accounts",
      valueSchema: new ne(new We(new Xe())),
      omitEmpty: !0
    }, {
      key: "app-locals",
      valueSchema: new ne(new We(Fs.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "apps",
      valueSchema: new ne(new We(new se())),
      omitEmpty: !0
    }, {
      key: "asset-holdings",
      valueSchema: new ne(new We(Hs.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "assets",
      valueSchema: new ne(new We(new se())),
      omitEmpty: !0
    }, {
      key: "boxes",
      valueSchema: new ne(new We(Ks.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "extra-box-refs",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulateUnnamedResourcesAccessed` object.
   * @param accounts - The unnamed accounts that were referenced. The order of this array is arbitrary.
   * @param appLocals - The unnamed application local states that were referenced. The order of this
   * array is arbitrary.
   * @param apps - The unnamed applications that were referenced. The order of this array is
   * arbitrary.
   * @param assetHoldings - The unnamed asset holdings that were referenced. The order of this array is
   * arbitrary.
   * @param assets - The unnamed assets that were referenced. The order of this array is arbitrary.
   * @param boxes - The unnamed boxes that were referenced. The order of this array is arbitrary.
   * @param extraBoxRefs - The number of extra box references used to increase the IO budget. This is in
   * addition to the references defined in the input transaction group and any
   * referenced to unnamed boxes.
   */
  constructor({ accounts: e, appLocals: t, apps: n, assetHoldings: a, assets: o, boxes: i, extraBoxRefs: s }) {
    this.accounts = typeof e < "u" ? e.map((l) => typeof l == "string" ? Bt.fromString(l) : l) : void 0, this.appLocals = t, this.apps = typeof n > "u" ? void 0 : n.map(ot), this.assetHoldings = a, this.assets = typeof o > "u" ? void 0 : o.map(ot), this.boxes = i, this.extraBoxRefs = typeof s > "u" ? void 0 : et(s);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return xo.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      [
        "accounts",
        typeof this.accounts < "u" ? this.accounts.map((e) => e.toString()) : void 0
      ],
      [
        "app-locals",
        typeof this.appLocals < "u" ? this.appLocals.map((e) => e.toEncodingData()) : void 0
      ],
      ["apps", this.apps],
      [
        "asset-holdings",
        typeof this.assetHoldings < "u" ? this.assetHoldings.map((e) => e.toEncodingData()) : void 0
      ],
      ["assets", this.assets],
      [
        "boxes",
        typeof this.boxes < "u" ? this.boxes.map((e) => e.toEncodingData()) : void 0
      ],
      ["extra-box-refs", this.extraBoxRefs]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulateUnnamedResourcesAccessed: ${e}`);
    return new xo({
      accounts: e.get("accounts"),
      appLocals: typeof e.get("app-locals") < "u" ? e.get("app-locals").map((t) => Fs.fromEncodingData(t)) : void 0,
      apps: e.get("apps"),
      assetHoldings: typeof e.get("asset-holdings") < "u" ? e.get("asset-holdings").map((t) => Hs.fromEncodingData(t)) : void 0,
      assets: e.get("assets"),
      boxes: typeof e.get("boxes") < "u" ? e.get("boxes").map((t) => Ks.fromEncodingData(t)) : void 0,
      extraBoxRefs: e.get("extra-box-refs")
    });
  }
}
class ac {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "allow-empty-signatures",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "allow-unnamed-resources",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "extra-opcode-budget",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "fix-signers",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "max-log-calls",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "max-log-size",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulationEvalOverrides` object.
   * @param allowEmptySignatures - If true, transactions without signatures are allowed and simulated as if they
   * were properly signed.
   * @param allowUnnamedResources - If true, allows access to unnamed resources during simulation.
   * @param extraOpcodeBudget - The extra opcode budget added to each transaction group during simulation
   * @param fixSigners - If true, signers for transactions that are missing signatures will be fixed
   * during evaluation.
   * @param maxLogCalls - The maximum log calls one can make during simulation
   * @param maxLogSize - The maximum byte number to log during simulation
   */
  constructor({ allowEmptySignatures: e, allowUnnamedResources: t, extraOpcodeBudget: n, fixSigners: a, maxLogCalls: o, maxLogSize: i }) {
    this.allowEmptySignatures = e, this.allowUnnamedResources = t, this.extraOpcodeBudget = typeof n > "u" ? void 0 : et(n), this.fixSigners = a, this.maxLogCalls = typeof o > "u" ? void 0 : et(o), this.maxLogSize = typeof i > "u" ? void 0 : et(i);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ac.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["allow-empty-signatures", this.allowEmptySignatures],
      ["allow-unnamed-resources", this.allowUnnamedResources],
      ["extra-opcode-budget", this.extraOpcodeBudget],
      ["fix-signers", this.fixSigners],
      ["max-log-calls", this.maxLogCalls],
      ["max-log-size", this.maxLogSize]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulationEvalOverrides: ${e}`);
    return new ac({
      allowEmptySignatures: e.get("allow-empty-signatures"),
      allowUnnamedResources: e.get("allow-unnamed-resources"),
      extraOpcodeBudget: e.get("extra-opcode-budget"),
      fixSigners: e.get("fix-signers"),
      maxLogCalls: e.get("max-log-calls"),
      maxLogSize: e.get("max-log-size")
    });
  }
}
class ra {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "pc", valueSchema: new se(), omitEmpty: !0 }, {
      key: "scratch-changes",
      valueSchema: new ne(new We(ec.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "spawned-inners",
      valueSchema: new ne(new We(new se())),
      omitEmpty: !0
    }, {
      key: "stack-additions",
      valueSchema: new ne(new We(Rn.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "stack-pop-count",
      valueSchema: new ne(new se()),
      omitEmpty: !0
    }, {
      key: "state-changes",
      valueSchema: new ne(new We(zs.encodingSchema)),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulationOpcodeTraceUnit` object.
   * @param pc - The program counter of the current opcode being evaluated.
   * @param scratchChanges - The writes into scratch slots.
   * @param spawnedInners - The indexes of the traces for inner transactions spawned by this opcode, if any.
   * @param stackAdditions - The values added by this opcode to the stack.
   * @param stackPopCount - The number of deleted stack values by this opcode.
   * @param stateChanges - The operations against the current application's states.
   */
  constructor({ pc: e, scratchChanges: t, spawnedInners: n, stackAdditions: a, stackPopCount: o, stateChanges: i }) {
    this.pc = et(e), this.scratchChanges = t, this.spawnedInners = typeof n > "u" ? void 0 : n.map(et), this.stackAdditions = a, this.stackPopCount = typeof o > "u" ? void 0 : et(o), this.stateChanges = i;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ra.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["pc", this.pc],
      [
        "scratch-changes",
        typeof this.scratchChanges < "u" ? this.scratchChanges.map((e) => e.toEncodingData()) : void 0
      ],
      ["spawned-inners", this.spawnedInners],
      [
        "stack-additions",
        typeof this.stackAdditions < "u" ? this.stackAdditions.map((e) => e.toEncodingData()) : void 0
      ],
      ["stack-pop-count", this.stackPopCount],
      [
        "state-changes",
        typeof this.stateChanges < "u" ? this.stateChanges.map((e) => e.toEncodingData()) : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulationOpcodeTraceUnit: ${e}`);
    return new ra({
      pc: e.get("pc"),
      scratchChanges: typeof e.get("scratch-changes") < "u" ? e.get("scratch-changes").map((t) => ec.fromEncodingData(t)) : void 0,
      spawnedInners: e.get("spawned-inners"),
      stackAdditions: typeof e.get("stack-additions") < "u" ? e.get("stack-additions").map((t) => Rn.fromEncodingData(t)) : void 0,
      stackPopCount: e.get("stack-pop-count"),
      stateChanges: typeof e.get("state-changes") < "u" ? e.get("state-changes").map((t) => zs.fromEncodingData(t)) : void 0
    });
  }
}
class ro {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "approval-program-hash",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "approval-program-trace",
      valueSchema: new ne(new We(ra.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "clear-state-program-hash",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "clear-state-program-trace",
      valueSchema: new ne(new We(ra.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "clear-state-rollback",
      valueSchema: new ne(new Ot()),
      omitEmpty: !0
    }, {
      key: "clear-state-rollback-error",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    }, {
      key: "inner-trace",
      valueSchema: new ne(new We(ro.encodingSchema)),
      omitEmpty: !0
    }, {
      key: "logic-sig-hash",
      valueSchema: new ne(new ct()),
      omitEmpty: !0
    }, {
      key: "logic-sig-trace",
      valueSchema: new ne(new We(ra.encodingSchema)),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SimulationTransactionExecTrace` object.
   * @param approvalProgramHash - SHA512_256 hash digest of the approval program executed in transaction.
   * @param approvalProgramTrace - Program trace that contains a trace of opcode effects in an approval program.
   * @param clearStateProgramHash - SHA512_256 hash digest of the clear state program executed in transaction.
   * @param clearStateProgramTrace - Program trace that contains a trace of opcode effects in a clear state program.
   * @param clearStateRollback - If true, indicates that the clear state program failed and any persistent state
   * changes it produced should be reverted once the program exits.
   * @param clearStateRollbackError - The error message explaining why the clear state program failed. This field will
   * only be populated if clear-state-rollback is true and the failure was due to an
   * execution error.
   * @param innerTrace - An array of SimulationTransactionExecTrace representing the execution trace of
   * any inner transactions executed.
   * @param logicSigHash - SHA512_256 hash digest of the logic sig executed in transaction.
   * @param logicSigTrace - Program trace that contains a trace of opcode effects in a logic sig.
   */
  constructor({ approvalProgramHash: e, approvalProgramTrace: t, clearStateProgramHash: n, clearStateProgramTrace: a, clearStateRollback: o, clearStateRollbackError: i, innerTrace: s, logicSigHash: l, logicSigTrace: c }) {
    this.approvalProgramHash = typeof e == "string" ? Tt(e) : e, this.approvalProgramTrace = t, this.clearStateProgramHash = typeof n == "string" ? Tt(n) : n, this.clearStateProgramTrace = a, this.clearStateRollback = o, this.clearStateRollbackError = i, this.innerTrace = s, this.logicSigHash = typeof l == "string" ? Tt(l) : l, this.logicSigTrace = c;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ro.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["approval-program-hash", this.approvalProgramHash],
      [
        "approval-program-trace",
        typeof this.approvalProgramTrace < "u" ? this.approvalProgramTrace.map((e) => e.toEncodingData()) : void 0
      ],
      ["clear-state-program-hash", this.clearStateProgramHash],
      [
        "clear-state-program-trace",
        typeof this.clearStateProgramTrace < "u" ? this.clearStateProgramTrace.map((e) => e.toEncodingData()) : void 0
      ],
      ["clear-state-rollback", this.clearStateRollback],
      ["clear-state-rollback-error", this.clearStateRollbackError],
      [
        "inner-trace",
        typeof this.innerTrace < "u" ? this.innerTrace.map((e) => e.toEncodingData()) : void 0
      ],
      ["logic-sig-hash", this.logicSigHash],
      [
        "logic-sig-trace",
        typeof this.logicSigTrace < "u" ? this.logicSigTrace.map((e) => e.toEncodingData()) : void 0
      ]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SimulationTransactionExecTrace: ${e}`);
    return new ro({
      approvalProgramHash: e.get("approval-program-hash"),
      approvalProgramTrace: typeof e.get("approval-program-trace") < "u" ? e.get("approval-program-trace").map((t) => ra.fromEncodingData(t)) : void 0,
      clearStateProgramHash: e.get("clear-state-program-hash"),
      clearStateProgramTrace: typeof e.get("clear-state-program-trace") < "u" ? e.get("clear-state-program-trace").map((t) => ra.fromEncodingData(t)) : void 0,
      clearStateRollback: e.get("clear-state-rollback"),
      clearStateRollbackError: e.get("clear-state-rollback-error"),
      innerTrace: typeof e.get("inner-trace") < "u" ? e.get("inner-trace").map((t) => ro.fromEncodingData(t)) : void 0,
      logicSigHash: e.get("logic-sig-hash"),
      logicSigTrace: typeof e.get("logic-sig-trace") < "u" ? e.get("logic-sig-trace").map((t) => ra.fromEncodingData(t)) : void 0
    });
  }
}
let zS = class K1 {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "Message",
      valueSchema: oc.encodingSchema,
      omitEmpty: !0
    }, {
      key: "StateProof",
      valueSchema: new ct(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `StateProof` object.
   * @param message - Represents the message that the state proofs are attesting to.
   * @param stateproof - The encoded StateProof for the message.
   */
  constructor({ message: e, stateproof: t }) {
    this.message = e, this.stateproof = typeof t == "string" ? Tt(t) : t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return K1.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Message", this.message.toEncodingData()],
      ["StateProof", this.stateproof]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded StateProof: ${e}`);
    return new K1({
      message: oc.fromEncodingData(e.get("Message") ?? /* @__PURE__ */ new Map()),
      stateproof: e.get("StateProof")
    });
  }
};
class oc {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "BlockHeadersCommitment",
      valueSchema: new ct(),
      omitEmpty: !0
    }, {
      key: "FirstAttestedRound",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "LastAttestedRound",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "LnProvenWeight",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "VotersCommitment",
      valueSchema: new ct(),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `StateProofMessage` object.
   * @param blockheaderscommitment - The vector commitment root on all light block headers within a state proof
   * interval.
   * @param firstattestedround - The first round the message attests to.
   * @param lastattestedround - The last round the message attests to.
   * @param lnprovenweight - An integer value representing the natural log of the proven weight with 16 bits
   * of precision. This value would be used to verify the next state proof.
   * @param voterscommitment - The vector commitment root of the top N accounts to sign the next StateProof.
   */
  constructor({ blockheaderscommitment: e, firstattestedround: t, lastattestedround: n, lnprovenweight: a, voterscommitment: o }) {
    this.blockheaderscommitment = typeof e == "string" ? Tt(e) : e, this.firstattestedround = ot(t), this.lastattestedround = ot(n), this.lnprovenweight = ot(a), this.voterscommitment = typeof o == "string" ? Tt(o) : o;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return oc.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["BlockHeadersCommitment", this.blockheaderscommitment],
      ["FirstAttestedRound", this.firstattestedround],
      ["LastAttestedRound", this.lastattestedround],
      ["LnProvenWeight", this.lnprovenweight],
      ["VotersCommitment", this.voterscommitment]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded StateProofMessage: ${e}`);
    return new oc({
      blockheaderscommitment: e.get("BlockHeadersCommitment"),
      firstattestedround: e.get("FirstAttestedRound"),
      lastattestedround: e.get("LastAttestedRound"),
      lnprovenweight: e.get("LnProvenWeight"),
      voterscommitment: e.get("VotersCommitment")
    });
  }
}
class $l {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "current_round",
      valueSchema: new se(),
      omitEmpty: !0
    }, {
      key: "online-money",
      valueSchema: new se(),
      omitEmpty: !0
    }, { key: "total-money", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `SupplyResponse` object.
   * @param currentRound - Round
   * @param onlineMoney - OnlineMoney
   * @param totalMoney - TotalMoney
   */
  constructor({ currentRound: e, onlineMoney: t, totalMoney: n }) {
    this.currentRound = ot(e), this.onlineMoney = ot(t), this.totalMoney = ot(n);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return $l.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["current_round", this.currentRound],
      ["online-money", this.onlineMoney],
      ["total-money", this.totalMoney]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded SupplyResponse: ${e}`);
    return new $l({
      currentRound: e.get("current_round"),
      onlineMoney: e.get("online-money"),
      totalMoney: e.get("total-money")
    });
  }
}
class ko {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "key", valueSchema: new ct(), omitEmpty: !0 }, { key: "value", valueSchema: oa.encodingSchema, omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `TealKeyValue` object.
   * @param key -
   * @param value - Represents a TEAL value.
   */
  constructor({ key: e, value: t }) {
    this.key = typeof e == "string" ? Tt(e) : e, this.value = t;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return ko.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["key", this.key],
      ["value", this.value.toEncodingData()]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TealKeyValue: ${e}`);
    return new ko({
      key: e.get("key"),
      value: oa.fromEncodingData(e.get("value") ?? /* @__PURE__ */ new Map())
    });
  }
}
class oa {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "bytes", valueSchema: new ct(), omitEmpty: !0 }, { key: "type", valueSchema: new se(), omitEmpty: !0 }, { key: "uint", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `TealValue` object.
   * @param bytes - (tb) bytes value.
   * @param type - (tt) value type. Value `1` refers to **bytes**, value `2` refers to **uint**
   * @param uint - (ui) uint value.
   */
  constructor({ bytes: e, type: t, uint: n }) {
    this.bytes = typeof e == "string" ? Tt(e) : e, this.type = et(t), this.uint = ot(n);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return oa.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["bytes", this.bytes],
      ["type", this.type],
      ["uint", this.uint]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TealValue: ${e}`);
    return new oa({
      bytes: e.get("bytes"),
      type: e.get("type"),
      uint: e.get("uint")
    });
  }
}
class jl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "Deltas",
      valueSchema: new We(Xs.encodingSchema),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `TransactionGroupLedgerStateDeltasForRoundResponse` object.
   * @param deltas -
   */
  constructor({ deltas: e }) {
    this.deltas = e;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return jl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["Deltas", this.deltas.map((e) => e.toEncodingData())]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TransactionGroupLedgerStateDeltasForRoundResponse: ${e}`);
    return new jl({
      deltas: (e.get("Deltas") ?? []).map((t) => Xs.fromEncodingData(t))
    });
  }
}
class Fl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "consensus-version",
      valueSchema: new Xe(),
      omitEmpty: !0
    }, { key: "fee", valueSchema: new se(), omitEmpty: !0 }, {
      key: "genesis-hash",
      valueSchema: new ct(),
      omitEmpty: !0
    }, { key: "genesis-id", valueSchema: new Xe(), omitEmpty: !0 }, { key: "last-round", valueSchema: new se(), omitEmpty: !0 }, { key: "min-fee", valueSchema: new se(), omitEmpty: !0 })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `TransactionParametersResponse` object.
   * @param consensusVersion - ConsensusVersion indicates the consensus protocol version
   * as of LastRound.
   * @param fee - Fee is the suggested transaction fee
   * Fee is in units of micro-Algos per byte.
   * Fee may fall to zero but transactions must still have a fee of
   * at least MinTxnFee for the current network protocol.
   * @param genesisHash - GenesisHash is the hash of the genesis block.
   * @param genesisId - GenesisID is an ID listed in the genesis block.
   * @param lastRound - LastRound indicates the last round seen
   * @param minFee - The minimum transaction fee (not per byte) required for the
   * txn to validate for the current network protocol.
   */
  constructor({ consensusVersion: e, fee: t, genesisHash: n, genesisId: a, lastRound: o, minFee: i }) {
    this.consensusVersion = e, this.fee = ot(t), this.genesisHash = typeof n == "string" ? Tt(n) : n, this.genesisId = a, this.lastRound = ot(o), this.minFee = ot(i);
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Fl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["consensus-version", this.consensusVersion],
      ["fee", this.fee],
      ["genesis-hash", this.genesisHash],
      ["genesis-id", this.genesisId],
      ["last-round", this.lastRound],
      ["min-fee", this.minFee]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TransactionParametersResponse: ${e}`);
    return new Fl({
      consensusVersion: e.get("consensus-version"),
      fee: e.get("fee"),
      genesisHash: e.get("genesis-hash"),
      genesisId: e.get("genesis-id"),
      lastRound: e.get("last-round"),
      minFee: e.get("min-fee")
    });
  }
}
class zl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({ key: "idx", valueSchema: new se(), omitEmpty: !0 }, { key: "proof", valueSchema: new ct(), omitEmpty: !0 }, {
      key: "stibhash",
      valueSchema: new ct(),
      omitEmpty: !0
    }, { key: "treedepth", valueSchema: new se(), omitEmpty: !0 }, {
      key: "hashtype",
      valueSchema: new ne(new Xe()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `TransactionProofResponse` object.
   * @param idx - Index of the transaction in the block's payset.
   * @param proof - Proof of transaction membership.
   * @param stibhash - Hash of SignedTxnInBlock for verifying proof.
   * @param treedepth - Represents the depth of the tree that is being proven, i.e. the number of edges
   * from a leaf to the root.
   * @param hashtype - The type of hash function used to create the proof, must be one of:
   * * sha512_256
   * * sha256
   */
  constructor({ idx: e, proof: t, stibhash: n, treedepth: a, hashtype: o }) {
    this.idx = et(e), this.proof = typeof t == "string" ? Tt(t) : t, this.stibhash = typeof n == "string" ? Tt(n) : n, this.treedepth = et(a), this.hashtype = o;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return zl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["idx", this.idx],
      ["proof", this.proof],
      ["stibhash", this.stibhash],
      ["treedepth", this.treedepth],
      ["hashtype", this.hashtype]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded TransactionProofResponse: ${e}`);
    return new zl({
      idx: e.get("idx"),
      proof: e.get("proof"),
      stibhash: e.get("stibhash"),
      treedepth: e.get("treedepth"),
      hashtype: e.get("hashtype")
    });
  }
}
class Hl {
  static get encodingSchema() {
    return this.encodingSchemaValue || (this.encodingSchemaValue = new be([]), this.encodingSchemaValue.pushEntries({
      key: "build",
      valueSchema: Ys.encodingSchema,
      omitEmpty: !0
    }, {
      key: "genesis_hash_b64",
      valueSchema: new ct(),
      omitEmpty: !0
    }, { key: "genesis_id", valueSchema: new Xe(), omitEmpty: !0 }, {
      key: "versions",
      valueSchema: new We(new Xe()),
      omitEmpty: !0
    })), this.encodingSchemaValue;
  }
  /**
   * Creates a new `Version` object.
   * @param build -
   * @param genesisHashB64 -
   * @param genesisId -
   * @param versions -
   */
  constructor({ build: e, genesisHashB64: t, genesisId: n, versions: a }) {
    this.build = e, this.genesisHashB64 = typeof t == "string" ? Tt(t) : t, this.genesisId = n, this.versions = a;
  }
  // eslint-disable-next-line class-methods-use-this
  getEncodingSchema() {
    return Hl.encodingSchema;
  }
  toEncodingData() {
    return /* @__PURE__ */ new Map([
      ["build", this.build.toEncodingData()],
      ["genesis_hash_b64", this.genesisHashB64],
      ["genesis_id", this.genesisId],
      ["versions", this.versions]
    ]);
  }
  static fromEncodingData(e) {
    if (!(e instanceof Map))
      throw new Error(`Invalid decoded Version: ${e}`);
    return new Hl({
      build: Ys.fromEncodingData(e.get("build") ?? /* @__PURE__ */ new Map()),
      genesisHashB64: e.get("genesis_hash_b64"),
      genesisId: e.get("genesis_id"),
      versions: e.get("versions")
    });
  }
}
class Et {
  /**
   * @param client - HTTPClient object.
   */
  constructor(e) {
    this.c = e, this.query = {};
  }
  /**
   * Execute the request
   */
  executeRequest(e, t) {
    return this.c.get({
      relativePath: this.path(),
      query: this.query,
      requestHeaders: e,
      customOptions: t
    });
  }
  /**
   * Execute the request and decode the response.
   * @param headers - Additional headers to send in the request. Optional.
   * @param customOptions - Additional options to pass to the underlying BaseHTTPClient. For
   *   {@link URLTokenBaseHTTPClient}, which is the default client, this will be treated as
   *   additional options to pass to the network `fetch` method.
   * @returns A promise which resolves to the parsed response object.
   * @category JSONRequest
   */
  async do(e, t) {
    const n = await this.executeRequest(e, t);
    return this.prepare(n);
  }
  /**
   * Execute the request, but do not process the response data in any way.
   * @param headers - Additional headers to send in the request. Optional.
   * @param customOptions - Additional options to pass to the underlying BaseHTTPClient. For
   *   {@link URLTokenBaseHTTPClient}, which is the default client, this will be treated as
   *   additional options to pass to the network `fetch` method.
   * @returns A promise which resolves to the raw response data, exactly as returned by the server.
   * @category JSONRequest
   */
  async doRaw(e, t) {
    return (await this.executeRequest(e, t)).body;
  }
}
class HS extends Et {
  constructor(e, t) {
    super(e), this.account = t.toString();
  }
  path() {
    return `/v2/accounts/${this.account}`;
  }
  /**
   * Exclude assets and application data from results
   *
   * #### Example
   * ```typescript
   * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
   * const accountInfo = await algodClient.accountInformation(address)
   *        .exclude('all')
   *        .do();
   * ```
   *
   * @param round
   * @category query
   */
  exclude(e) {
    return this.query.exclude = e, this;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), xl);
  }
}
class qS extends Et {
  constructor(e, t, n) {
    super(e), this.account = t.toString(), this.assetID = BigInt(n);
  }
  path() {
    return `/v2/accounts/${this.account}/assets/${this.assetID}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Al);
  }
}
class WS extends Et {
  constructor(e, t, n) {
    super(e), this.account = t.toString(), this.applicationID = BigInt(n);
  }
  path() {
    return `/v2/accounts/${this.account}/applications/${this.applicationID}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), kl);
  }
}
class KS extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t), this.query = { format: "msgpack" };
  }
  path() {
    return `/v2/blocks/${this.round}`;
  }
  /**
   * If true, only the block header (exclusive of payset or certificate) may be included in response.
   *
   * #### Example
   * ```typescript
   *
   * const roundNumber = 41000000;
   *
   * const blockResponse = await algodClient
   *        .block(roundNumber)
   *        .headerOnly(true)
   *        .do();
   * ```
   *
   * @param headerOnly - the flag indicating whether exclusively return header in response
   * @category query
   */
  headerOnly(e) {
    return this.query["header-only"] = e, this;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, Dl);
  }
}
function V5(r = {}) {
  let e = r;
  return Object.keys(e).every((t) => t.toLowerCase() !== "content-type") && (e = { ...r }, e["Content-Type"] = "text/plain"), e;
}
class YS extends Et {
  constructor(e, t) {
    super(e), this.source = t;
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/teal/compile";
  }
  sourcemap(e = !0) {
    return this.query.sourcemap = e, this;
  }
  executeRequest(e, t) {
    const n = V5(e);
    return this.c.post({
      relativePath: this.path(),
      data: mo(this.source),
      query: this.query,
      requestHeaders: n,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Tl);
  }
}
class GS extends Et {
  constructor(e, t) {
    super(e), this.blob = pu(t);
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/teal/dryrun";
  }
  executeRequest(e, t) {
    const n = V5(e);
    return this.c.post({
      relativePath: this.path(),
      data: this.blob,
      requestHeaders: n,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Pl);
  }
}
class JS extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/genesis";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return e.getJSONText();
  }
}
class XS extends Et {
  constructor(e, t) {
    super(e), this.index = BigInt(t);
  }
  path() {
    return `/v2/assets/${this.index}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Ti);
  }
}
class ZS extends Et {
  constructor(e, t) {
    super(e), this.index = BigInt(t);
  }
  path() {
    return `/v2/applications/${this.index}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Ii);
  }
}
class QS extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t);
  }
  path() {
    return `/v2/blocks/${this.round}/hash`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Cl);
  }
}
class eE extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t);
  }
  path() {
    return `/v2/blocks/${this.round}/txids`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Ml);
  }
}
class tE extends Et {
  constructor(e, t, n) {
    super(e), this.index = BigInt(t);
    const a = Co(n);
    this.query.name = encodeURI(`b64:${a}`);
  }
  /**
   * @returns `/v2/applications/${index}/box`
   */
  path() {
    return `/v2/applications/${this.index}/box`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Rl);
  }
}
class rE extends Et {
  constructor(e, t) {
    super(e), this.index = BigInt(t), this.query.max = 0;
  }
  /**
   * @returns `/v2/applications/${index}/boxes`
   */
  path() {
    return `/v2/applications/${this.index}/boxes`;
  }
  /**
   * Limit results for pagination.
   *
   * #### Example
   * ```typescript
   * const maxResults = 20;
   * const boxesResult = await algodClient
   *        .GetApplicationBoxes(1234)
   *        .limit(maxResults)
   *        .do();
   * ```
   *
   * @param limit - maximum number of results to return.
   * @category query
   */
  max(e) {
    return this.query.max = e, this;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Il);
  }
}
class nE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/health";
  }
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  prepare(e) {
  }
}
class aE extends Et {
  constructor(e, t) {
    super(e), this.txid = t, this.query.format = "msgpack";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, Ba);
  }
  path() {
    return `/v2/transactions/pending/${this.txid}`;
  }
  // max sets the maximum number of txs to return
  max(e) {
    return this.query.max = e, this;
  }
}
class oE extends Et {
  constructor(e) {
    super(e), this.query.format = "msgpack";
  }
  /* eslint-disable class-methods-use-this */
  path() {
    return "/v2/transactions/pending";
  }
  prepare(e) {
    return gn(e.body, Qs);
  }
  /* eslint-enable class-methods-use-this */
  // max sets the maximum number of txs to return
  max(e) {
    return this.query.max = e, this;
  }
}
class iE extends Et {
  constructor(e, t) {
    super(e), this.address = t.toString(), this.query.format = "msgpack";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, Qs);
  }
  path() {
    return `/v2/accounts/${this.address}/transactions/pending`;
  }
  // max sets the maximum number of txs to return
  max(e) {
    return this.query.max = e, this;
  }
}
class sE extends Et {
  constructor(e, t, n) {
    super(e), this.txID = n, this.round = BigInt(t);
  }
  path() {
    return `/v2/blocks/${this.round}/transactions/${this.txID}/proof`;
  }
  /**
   * Exclude assets and application data from results
   * The type of hash function used to create the proof, must be one of: "sha512_256", "sha256"
   *
   * #### Example
   * ```typescript
   * const hashType = "sha256";
   * const round = 123456;
   * const txId = "abc123;
   * const txProof = await algodClient.getTransactionProof(round, txId)
   *        .hashType(hashType)
   *        .do();
   * ```
   *
   * @param hashType
   * @category query
   */
  hashType(e) {
    return this.query.hashtype = e, this;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), zl);
  }
}
function cE(r = {}) {
  let e = r;
  return Object.keys(e).every((t) => t.toLowerCase() !== "content-type") && (e = { ...r }, e["Content-Type"] = "application/x-binary"), e;
}
function s2(r) {
  return r && r.byteLength !== void 0;
}
class lE extends Et {
  constructor(e, t) {
    super(e);
    let n = t;
    if (Array.isArray(t)) {
      if (!t.every(s2))
        throw new TypeError("Array elements must be byte arrays");
      n = oo(...t);
    } else if (!s2(n))
      throw new TypeError("Argument must be byte array");
    this.txnBytesToPost = n;
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/transactions";
  }
  executeRequest(e, t) {
    const n = cE(e);
    return this.c.post({
      relativePath: this.path(),
      data: this.txnBytesToPost,
      requestHeaders: n,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Ll);
  }
}
class uE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/status";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Zs);
  }
}
class dE extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t);
  }
  path() {
    return `/v2/status/wait-for-block-after/${this.round}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Zs);
  }
}
class hE extends Et {
  /* eslint-disable class-methods-use-this */
  path() {
    return "/v2/transactions/params";
  }
  prepare(e) {
    const t = Zt(e.getJSONText(), Fl);
    return {
      flatFee: !1,
      fee: t.fee,
      firstValid: t.lastRound,
      lastValid: t.lastRound + BigInt(1e3),
      genesisID: t.genesisId,
      genesisHash: t.genesisHash,
      minFee: t.minFee,
      consensusVersion: t.consensusVersion
    };
  }
}
class fE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/ledger/supply";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), $l);
  }
}
class pE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/versions";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Hl);
  }
}
class gE extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t);
  }
  path() {
    return `/v2/blocks/${this.round}/lightheader/proof`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), FS);
  }
}
class mE extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t);
  }
  path() {
    return `/v2/stateproofs/${this.round}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), zS);
  }
}
class yE extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t);
  }
  path() {
    return `/v2/ledger/sync/${this.round}`;
  }
  executeRequest(e, t) {
    return this.c.post({
      relativePath: this.path(),
      data: null,
      requestHeaders: e,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  prepare(e) {
  }
}
class wE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/ledger/sync";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Bl);
  }
}
class vE extends Et {
  constructor(e, t) {
    super(e), this.offset = BigInt(t);
  }
  path() {
    return `/v2/devmode/blocks/offset/${this.offset}`;
  }
  executeRequest(e, t) {
    return this.c.post({
      relativePath: this.path(),
      data: null,
      requestHeaders: e,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  prepare(e) {
  }
}
class _E extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/devmode/blocks/offset";
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Nl);
  }
}
function bE(r = {}) {
  let e = r;
  return Object.keys(e).every((t) => t.toLowerCase() !== "content-type") && (e = { ...r }, e["Content-Type"] = "text/plain"), e;
}
class SE extends Et {
  constructor(e, t) {
    super(e), this.source = t;
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/teal/disassemble";
  }
  executeRequest(e, t) {
    const n = bE(e);
    return this.c.post({
      relativePath: this.path(),
      data: mo(this.source),
      query: this.query,
      requestHeaders: n,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return Zt(e.getJSONText(), Ol);
  }
}
function EE(r = {}) {
  let e = r;
  return Object.keys(e).every((t) => t.toLowerCase() !== "content-type") && (e = { ...r }, e["Content-Type"] = "application/msgpack"), e;
}
class xE extends Et {
  constructor(e, t) {
    super(e), this.query.format = "msgpack", this.requestBytes = pu(t);
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/transactions/simulate";
  }
  executeRequest(e, t) {
    const n = EE(e);
    return this.c.post({
      relativePath: this.path(),
      data: this.requestBytes,
      query: this.query,
      requestHeaders: n,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, Vl);
  }
}
class kE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/ready";
  }
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  prepare(e) {
  }
}
class AE extends Et {
  // eslint-disable-next-line class-methods-use-this
  path() {
    return "/v2/ledger/sync";
  }
  executeRequest(e, t) {
    return this.c.delete({
      relativePath: this.path(),
      data: void 0,
      requestHeaders: e,
      customOptions: t
    });
  }
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  prepare(e) {
  }
}
class CE extends Et {
  constructor(e, t) {
    super(e), this.id = t, this.query = { format: "msgpack" };
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return `/v2/deltas/txn/group/${this.id}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, Ha);
  }
}
class DE extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t), this.query = { format: "msgpack" };
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return `/v2/deltas/${this.round}`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, Ha);
  }
}
class ME extends Et {
  constructor(e, t) {
    super(e), this.round = BigInt(t), this.query = { format: "msgpack" };
  }
  // eslint-disable-next-line class-methods-use-this
  path() {
    return `/v2/deltas/${this.round}/txn/group`;
  }
  // eslint-disable-next-line class-methods-use-this
  prepare(e) {
    return gn(e.body, jl);
  }
}
class RE extends Db {
  /**
   * Create an AlgodClient from
   * * either a token, baseServer, port, and optional headers
   * * or a base client server for interoperability with external dApp wallets
   *
   * #### Example
   * ```typescript
   * const token  = "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
   * const server = "http://localhost";
   * const port   = 4001;
   * const algodClient = new algosdk.Algodv2(token, server, port);
   * ```
   * @remarks
   * The above configuration is for a sandbox private network.
   * For applications on production, you are encouraged to run your own node, or use an Algorand REST API provider with a dedicated API key.
   *
   * @param tokenOrBaseClient - The algod token from the Algorand node you are interacting with
   * @param baseServer - REST endpoint
   * @param port - Port number if specifically configured by the server
   * @param headers - Optional headers
   */
  constructor(e, t, n, a = {}) {
    super("X-Algo-API-Token", e, t, n, a);
  }
  /**
   * Returns OK if healthy.
   *
   * #### Example
   * ```typescript
   * await algodClient.healthCheck().do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-health)
   * @category GET
   */
  healthCheck() {
    return new nE(this.c);
  }
  /**
   * Retrieves the supported API versions, binary build versions, and genesis information.
   *
   * #### Example
   * ```typescript
   * const versionsDetails = await algodClient.versionsCheck().do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-versions)
   * @category GET
   */
  versionsCheck() {
    return new pE(this.c);
  }
  /**
   * Broadcasts a raw transaction to the network.
   *
   * #### Example
   * ```typescript
   * const { txid } = await algodClient.sendRawTransaction(signedTxns).do();
   * const result = await waitForConfirmation(algodClient, txid, 3);
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2transactions)
   *
   * @remarks
   * Often used with {@linkcode waitForConfirmation}
   * @param stxOrStxs - Signed transactions
   * @category POST
   */
  sendRawTransaction(e) {
    return new lE(this.c, e);
  }
  /**
   * Returns the given account's status, balance and spendable amounts.
   *
   * #### Example
   * ```typescript
   * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
   * const accountInfo = await algodClient.accountInformation(address).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddress)
   * @param account - The address of the account to look up.
   * @category GET
   */
  accountInformation(e) {
    return new HS(this.c, e);
  }
  /**
   * Returns the given account's asset information for a specific asset.
   *
   * #### Example
   * ```typescript
   * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
   * const index = 60553466;
   * const accountAssetInfo = await algodClient.accountAssetInformation(address, index).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddress)
   * @param account - The address of the account to look up.
   * @param index - The asset ID to look up.
   * @category GET
   */
  accountAssetInformation(e, t) {
    return new qS(this.c, e, t);
  }
  /**
   * Returns the given account's application information for a specific application.
   *
   * #### Example
   * ```typescript
   * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
   * const index = 60553466;
   * const accountInfo = await algodClient.accountApplicationInformation(address, index).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddress)
   * @param account - The address of the account to look up.
   * @param index - The application ID to look up.
   * @category GET
   */
  accountApplicationInformation(e, t) {
    return new WS(this.c, e, t);
  }
  /**
   * Gets the block info for the given round.
   *
   * #### Example
   * ```typescript
   * const roundNumber = 18038133;
   * const block = await algodClient.block(roundNumber).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksround)
   * @param roundNumber - The round number of the block to get.
   * @category GET
   */
  block(e) {
    return new KS(this.c, e);
  }
  /**
   * Get the block hash for the block on the given round.
   *
   * #### Example
   * ```typescript
   * const roundNumber = 18038133;
   * const block = await algodClient.getBlockHash(roundNumber).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksroundhash)
   * @param roundNumber - The round number of the block to get.
   * @category GET
   */
  getBlockHash(e) {
    return new QS(this.c, e);
  }
  /**
   * Get the top level transaction IDs for the block on the given round.
   *
   * #### Example
   * ```typescript
   * const roundNumber = 18038133;
   * const block = await algodClient.getBlockTxids(roundNumber).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksroundtxids)
   * @param roundNumber - The round number of the block to get.
   * @category GET
   */
  getBlockTxids(e) {
    return new eE(this.c, e);
  }
  /**
   * Returns the transaction information for a specific pending transaction.
   *
   * #### Example
   * ```typescript
   * const txId = "DRJS6R745A7GFVMXEXWP4TGVDGKW7VILFTA7HC2BR2GRLHNY5CTA";
   * const pending = await algodClient.pendingTransactionInformation(txId).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2transactionspendingtxid)
   *
   * @remarks
   * <br><br>
   * There are several cases when this might succeed:
   * - transaction committed (committed round > 0)
   * - transaction still in the pool (committed round = 0, pool error = "")
   * - transaction removed from pool due to error (committed round = 0, pool error != "")
   *
   * Or the transaction may have happened sufficiently long ago that the node no longer remembers it, and this will return an error.
   *
   * @param txid - The TxID string of the pending transaction to look up.
   * @category GET
   */
  pendingTransactionInformation(e) {
    return new aE(this.c, e);
  }
  /**
   * Returns the list of pending transactions in the pool, sorted by priority, in decreasing order, truncated at the end at MAX.
   * If MAX = 0, returns all pending transactions.
   *
   * #### Example 1
   * ```typescript
   * const pendingTxns = await algodClient.pendingTransactionsInformation().do();
   * ```
   *
   * #### Example 2
   * ```typescript
   * const maxTxns = 5;
   * const pendingTxns = await algodClient
   *     .pendingTransactionsInformation()
   *     .max(maxTxns)
   *     .do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2transactionspending)
   * @category GET
   */
  pendingTransactionsInformation() {
    return new oE(this.c);
  }
  /**
   * Returns the list of pending transactions sent by the address, sorted by priority, in decreasing order, truncated at the end at MAX.
   * If MAX = 0, returns all pending transactions.
   *
   * #### Example 1
   * ```typescript
   * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
   * const pendingTxnsByAddr = await algodClient.pendingTransactionByAddress(address).do();
   * ```
   *
   * #### Example 2
   * ```typescript
   * const maxTxns = 5;
   * const address = "XBYLS2E6YI6XXL5BWCAMOA4GTWHXWENZMX5UHXMRNWWUQ7BXCY5WC5TEPA";
   * const pendingTxns = await algodClient
   *     .pendingTransactionByAddress(address)
   *     .max(maxTxns)
   *     .do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2accountsaddresstransactionspending)
   * @param address - The address of the sender.
   * @category GET
   */
  pendingTransactionByAddress(e) {
    return new iE(this.c, e);
  }
  /**
   * Retrieves the StatusResponse from the running node.
   *
   * #### Example
   * ```typescript
   * const status = await algodClient.status().do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2status)
   * @category GET
   */
  status() {
    return new uE(this.c);
  }
  /**
   * Waits for a specific round to occur then returns the `StatusResponse` for that round.
   *
   * #### Example
   * ```typescript
   * const round = 18038133;
   * const statusAfterBlock = await algodClient.statusAfterBlock(round).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2statuswait-for-block-afterround)
   * @param round - The number of the round to wait for.
   * @category GET
   */
  statusAfterBlock(e) {
    return new dE(this.c, e);
  }
  /**
   * Returns the common needed parameters for a new transaction.
   *
   * #### Example
   * ```typescript
   * const suggestedParams = await algodClient.getTransactionParams().do();
   * const amountInMicroAlgos = algosdk.algosToMicroalgos(2); // 2 Algos
   * const unsignedTxn = algosdk.makePaymentTxnWithSuggestedParamsFromObject({
   *   sender: senderAddress,
   *   receiver: receiverAddress,
   *   amount: amountInMicroAlgos,
   *   suggestedParams: suggestedParams,
   * });
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2transactionsparams)
   *
   * @remarks
   * Often used with
   * {@linkcode makePaymentTxnWithSuggestedParamsFromObject}, {@linkcode algosToMicroalgos}
   * @category GET
   */
  getTransactionParams() {
    return new hE(this.c);
  }
  /**
   * Returns the supply details for the specified node's ledger.
   *
   * #### Example
   * ```typescript
   * const supplyDetails = await algodClient.supply().do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2ledgersupply)
   * @category GET
   */
  supply() {
    return new fE(this.c);
  }
  /**
   * Compiles TEAL source code to binary, returns base64 encoded program bytes and base32 SHA512_256 hash of program bytes (Address style).
   *
   * #### Example
   * ```typescript
   * const source = "TEAL SOURCE CODE";
   * const compiledSmartContract = await algodClient.compile(source).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2tealcompile)
   * @remarks
   * This endpoint is only enabled when a node's configuration file sets `EnableDeveloperAPI` to true.
   * @param source
   * @category POST
   */
  compile(e) {
    return new YS(this.c, e);
  }
  /**
   * Given the program bytes, return the TEAL source code in plain text.
   *
   * #### Example
   * ```typescript
   * const bytecode = "TEAL bytecode";
   * const disassembledSource = await algodClient.disassemble(bytecode).do();
   * ```
   *
   * @remarks This endpoint is only enabled when a node's configuration file sets EnableDeveloperAPI to true.
   * @param source
   */
  disassemble(e) {
    return new SE(this.c, e);
  }
  /**
   * Provides debugging information for a transaction (or group).
   *
   * Executes TEAL program(s) in context and returns debugging information about the execution. This endpoint is only enabled when a node's configureation file sets `EnableDeveloperAPI` to true.
   *
   * #### Example
   * ```typescript
   * const dryRunResult = await algodClient.dryrun(dr).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2tealdryrun)
   * @param dr
   * @category POST
   */
  dryrun(e) {
    return new GS(this.c, e);
  }
  /**
   * Given an asset ID, return asset information including creator, name, total supply and
   * special addresses.
   *
   * #### Example
   * ```typescript
   * const asset_id = 163650;
   * const asset = await algodClient.getAssetByID(asset_id).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2assetsasset-id)
   * @param index - The asset ID to look up.
   * @category GET
   */
  getAssetByID(e) {
    return new XS(this.c, e);
  }
  /**
   * Given an application ID, return the application information including creator, approval
   * and clear programs, global and local schemas, and global state.
   *
   * #### Example
   * ```typescript
   * const index = 60553466;
   * const app = await algodClient.getApplicationByID(index).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2applicationsapplication-id)
   * @param index - The application ID to look up.
   * @category GET
   */
  getApplicationByID(e) {
    return new ZS(this.c, e);
  }
  /**
   * Given an application ID and the box name (key), return the value stored in the box.
   *
   * #### Example
   * ```typescript
   * const index = 60553466;
   * const boxName = Buffer.from("foo");
   * const boxResponse = await algodClient.getApplicationBoxByName(index, boxName).do();
   * const boxValue = boxResponse.value;
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2applicationsapplication-idbox)
   * @param index - The application ID to look up.
   * @category GET
   */
  getApplicationBoxByName(e, t) {
    return new tE(this.c, e, t);
  }
  /**
   * Given an application ID, return all the box names associated with the app.
   *
   * #### Example
   * ```typescript
   * const index = 60553466;
   * const boxesResponse = await algodClient.getApplicationBoxes(index).max(3).do();
   * const boxNames = boxesResponse.boxes.map(box => box.name);
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2applicationsapplication-idboxes)
   * @param index - The application ID to look up.
   * @category GET
   */
  getApplicationBoxes(e) {
    return new rE(this.c, e);
  }
  /**
   * Returns the entire genesis file.
   *
   * #### Example
   * ```typescript
   * const genesis = await algodClient.genesis().do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-genesis)
   * @category GET
   */
  genesis() {
    return new JS(this.c);
  }
  /**
   * Returns a Merkle proof for a given transaction in a block.
   *
   * #### Example
   * ```typescript
   * const round = 18038133;
   * const txId = "MEUOC4RQJB23CQZRFRKYEI6WBO73VTTPST5A7B3S5OKBUY6LFUDA";
   * const proof = await algodClient.getTransactionProof(round, txId).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2blocksroundtransactionstxidproof)
   * @param round - The round in which the transaction appears.
   * @param txID - The transaction ID for which to generate a proof.
   * @category GET
   */
  getTransactionProof(e, t) {
    return new sE(this.c, e, t);
  }
  /**
   * Gets a proof for a given light block header inside a state proof commitment.
   *
   * #### Example
   * ```typescript
   * const round = 11111111;
   * const lightBlockHeaderProof = await algodClient.getLightBlockHeaderProof(round).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/v2#get-v2blocksroundlightheaderproof)
   * @param round
   */
  getLightBlockHeaderProof(e) {
    return new gE(this.c, e);
  }
  /**
   * Gets a state proof that covers a given round.
   *
   * #### Example
   * ```typescript
   * const round = 11111111;
   * const stateProof = await algodClient.getStateProof(round).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/v2#get-v2stateproofsround)
   * @param round
   */
  getStateProof(e) {
    return new mE(this.c, e);
  }
  /**
   * Simulate a list of a signed transaction objects being sent to the network.
   *
   * #### Example
   * ```typescript
   * const txn1 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn1Params);
   * const txn2 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn2Params);
   * const txgroup = algosdk.assignGroupID([txn1, txn2]);
   *
   * // Actually sign the first transaction
   * const signedTxn1 = txgroup[0].signTxn(senderSk).blob;
   * // Simulate does not require signed transactions -- use this method to encode an unsigned transaction
   * const signedTxn2 = algosdk.encodeUnsignedSimulateTransaction(txgroup[1]);
   *
   * const resp = await client.simulateRawTransactions([signedTxn1, signedTxn2]).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2transactionssimulate)
   * @param stxOrStxs
   * @category POST
   */
  simulateRawTransactions(e) {
    const t = [];
    if (Array.isArray(e))
      for (const a of e)
        t.push(gn(a, Jr));
    else
      t.push(gn(e, Jr));
    const n = new Ul({
      txnGroups: [
        new Oi({
          txns: t
        })
      ]
    });
    return this.simulateTransactions(n);
  }
  /**
   * Simulate transactions being sent to the network.
   *
   * #### Example
   * ```typescript
   * const txn1 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn1Params);
   * const txn2 = algosdk.makePaymentTxnWithSuggestedParamsFromObject(txn2Params);
   * const txgroup = algosdk.assignGroupID([txn1, txn2]);
   *
   * // Actually sign the first transaction
   * const signedTxn1 = txgroup[0].signTxn(senderSk).blob;
   * // Simulate does not require signed transactions -- use this method to encode an unsigned transaction
   * const signedTxn2 = algosdk.encodeUnsignedSimulateTransaction(txgroup[1]);
   *
   * const request = new modelsv2.SimulateRequest({
   *  txnGroups: [
   *    new modelsv2.SimulateRequestTransactionGroup({
   *       // Must decode the signed txn bytes into an object
   *       txns: [algosdk.decodeObj(signedTxn1), algosdk.decodeObj(signedTxn2)]
   *     }),
   *   ],
   * });
   * const resp = await client.simulateRawTransactions(request).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2transactionssimulate)
   * @param request
   * @category POST
   */
  simulateTransactions(e) {
    return new xE(this.c, e);
  }
  /**
   * Set the offset (in seconds) applied to the block timestamp when creating new blocks in devmode.
   *
   *  #### Example
   *  ```typesecript
   *  const offset = 60
   *  await client.setBlockOffsetTimestamp(offset).do();
   *  ```
   *
   [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2devmodeblocksoffsetoffset)
   * @param offset
   * @category POST
   */
  setBlockOffsetTimestamp(e) {
    return new vE(this.c, e);
  }
  /**
   * Get the offset (in seconds) applied to the block timestamp when creating new blocks in devmode.
   *
   *  #### Example
   *  ```typesecript
   *  const currentOffset = await client.getBlockOffsetTimestamp().do();
   *  ```
   *
   [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2devmodeblocksoffset)
   * @category GET
   */
  getBlockOffsetTimestamp() {
    return new _E(this.c);
  }
  /**
   * Set the sync round on the ledger (algod must have EnableFollowMode: true), restricting catchup.
   *
   *  #### Example
   *  ```typesecript
   *  const round = 10000
   *  await client.setSyncRound(round).do();
   *  ```
   *
   [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#post-v2ledgersyncround)
   * @param round
   * @category POST
   */
  setSyncRound(e) {
    return new yE(this.c, e);
  }
  /**
   * Un-Set the sync round on the ledger (algod must have EnableFollowMode: true), removing the restriction on catchup.
   *
   *  #### Example
   *  ```typesecript
   *  await client.unsetSyncRound().do();
   *  ```
   *
   [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#delete-v2ledgersync)
   * @category DELETE
   */
  unsetSyncRound() {
    return new AE(this.c);
  }
  /**
   * Get the current sync round on the ledger (algod must have EnableFollowMode: true).
   *
   *  #### Example
   *  ```typesecript
   *  const currentSyncRound = await client.getSyncRound().do();
   *  ```
   *
   [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2ledgersync)
   * @category GET
   */
  getSyncRound() {
    return new wE(this.c);
  }
  /**
   * Ready check which returns 200 OK if algod is healthy and caught up
   *
   *  #### Example
   *  ```typesecript
   *  await client.ready().do();
   *  ```
   *
   [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-ready)
   * @category GET
   */
  ready() {
    return new kE(this.c);
  }
  /**
   * GetLedgerStateDeltaForTransactionGroup returns the ledger delta for the txn group identified by id
   *
   * #### Example
   * ```typescript
   * const id = "ABC123";
   * await client.getLedgerStateDeltaForTransactionGroup(id).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2deltastxngroupid)
   * @param id txn ID or group ID to be searched for
   * @category GET
   */
  getLedgerStateDeltaForTransactionGroup(e) {
    return new CE(this.c, e);
  }
  /**
   * GetLedgerStateDelta returns the ledger delta for the entire round
   *
   * #### Example
   * ```typescript
   * const round = 12345;
   * await client.getLedgerStateDelta(round).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2deltasround)
   * @param round the round number to be searched for
   * @category GET
   */
  getLedgerStateDelta(e) {
    return new DE(this.c, e);
  }
  /**
   * GetTransactionGroupLedgerStateDeltasForRound returns all ledger deltas for txn groups in the provided round
   *
   * #### Example
   * ```typescript
   * const round = 12345;
   * await client.getTransactionGroupLedgerStateDeltasForRound(round).do();
   * ```
   *
   * [Response data schema details](https://developer.algorand.org/docs/rest-apis/algod/#get-v2deltasroundtxngroup)
   * @param round the round number to be searched for
   * @category GET
   */
  getTransactionGroupLedgerStateDeltasForRound(e) {
    return new ME(this.c, e);
  }
}
async function IE(r, e, t) {
  const n = await r.status().do();
  if (typeof n > "u")
    throw new Error("Unable to get node status");
  const a = n.lastRound + BigInt(1), o = a + BigInt(t);
  let i = a;
  for (; i < o; ) {
    let s = !1;
    try {
      const l = await r.pendingTransactionInformation(e).do();
      if (l.confirmedRound)
        return l;
      if (l.poolError)
        throw s = !0, new Error(`Transaction Rejected: ${l.poolError}`);
    } catch (l) {
      if (s)
        throw l;
    }
    await r.statusAfterBlock(i).do(), i += BigInt(1);
  }
  throw new Error(`Transaction not confirmed after ${t} rounds`);
}
new TextEncoder().encode("TG");
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("").forEach(function(r, e) {
});
var c2;
(function(r) {
  r.any = "txn", r.pay = "pay", r.keyreg = "keyreg", r.acfg = "acfg", r.axfer = "axfer", r.afrz = "afrz", r.appl = "appl";
})(c2 || (c2 = {}));
var l2;
(function(r) {
  r.account = "account", r.application = "application", r.asset = "asset";
})(l2 || (l2 = {}));
var u2;
(function(r) {
  r[r.BUILDING = 0] = "BUILDING", r[r.BUILT = 1] = "BUILT", r[r.SIGNED = 2] = "SIGNED", r[r.SUBMITTED = 3] = "SUBMITTED", r[r.COMMITTED = 4] = "COMMITTED";
})(u2 || (u2 = {}));
Uint8Array.from([77, 88]);
const $5 = class j5 extends qa {
  constructor({ chain: e, ...t }) {
    super(t), this._chain = e;
  }
  /**
   * public methods
   */
  _defaultNode() {
    return this._chain.transports().algods.nodes[this._chain.transports().algods.default] ?? null;
  }
  /**
   * public methods
   */
  /**
   * Retrieves account information for the provided address using the Algod client.
   *
   * @param {string} address - The address for which information is to be fetched.
   * @return {Promise<Account>} A promise that resolves to the account information.
   * @throws {FailedToFetchChainInformationError} Throws an error if the default algod node cannot be retrieved.
   * @public
   * @async
   */
  async accountInformation(e) {
    const t = this.algod();
    if (!t)
      throw new u1(
        `failed to get default algod node for chain "${this._chain.chainID()}"`
      );
    return await t.accountInformation(e).do();
  }
  algod() {
    const e = this._defaultNode();
    return e ? new RE(e.token ?? "", e.origin, e.port) : null;
  }
  /**
   * Get the associated chain.
   *
   * @returns {AVMChain} The AVM chain.
   * @public
   */
  chain() {
    return this._chain;
  }
  /**
   * Sends a transaction to the AVM blockchain, attaching a signature to the provided unsigned transaction. Once the
   * transaction is successfully submitted, the network is checked to confirm which block the transaction was added,
   * up to a maximum of 4 blocks.
   *
   * @param {Object} params - The parameters to send the transaction.
   * @param {Uint8Array} params.signature - The signature of the signed transaction.
   * @param {Uint8Array} params.transaction - The unsigned transaction.
   * @return {Promise<string>} The transaction ID of the successfully confirmed transaction.
   * @throws {FailedToFetchChainInformationError} If the default Algod node information cannot be fetched.
   * @throws {FailedToSendTransactionError} If the transaction could not be sent or was rejected by the network.
   * @public
   */
  async sendTransaction({
    signature: e,
    transaction: t
  }) {
    const n = `${j5.displayName}#sendTransaction`, a = this.algod();
    let o;
    if (!a)
      throw new u1(
        `failed to get default algod node for chain "${this._chain.chainID()}"`
      );
    o = RS(t);
    try {
      const { txid: i } = await a.sendRawTransaction(o.attachSignature(o.sender, e)).do(), { confirmedRound: s } = await IE(a, i, 4);
      return this._logger.debug(`${n} - transaction confirmed at round "${s}"`), i;
    } catch (i) {
      throw this._logger.error(`${n} -`, i), new R6(i.message);
    }
  }
  setChain(e) {
    this._chain = e;
  }
};
$5.displayName = "AVMAdapter";
let F5 = $5;
class TE extends qa {
  /**
   * public methods
   */
  /**
   * Sends a raw transaction to the specified AVM chain and waits for it to be confirmed after a maximum of 4 rounds.
   *
   * @param {BalanceParameters<CAIP002Namespace.Algorand | CAIP002Namespace.AVM>} parameters - The input parameters.
   * @param {EphemeralAccountStoreItem} parameters.account - The account to get the balance for.
   * @param {AVMChain} parameters.chain - The [CAIP-002]{@link https://chainagnostic.org/CAIPs/caip-2} AVM chain ID.
   * @param {number} [parameters.delay] - An optional delay to apply before sending request. Defaults to 0.
   * @return {Promise<Balance>} A promise that resolves to the transaction ID of the confirmed transaction.
   * @throws {FailedToFetchChainInformationError} If the default Algod node information cannot be fetched.
   * @public
   */
  async balance({
    account: e,
    chain: t,
    delay: n = 0
  }) {
    return new Promise((a, o) => {
      window.setTimeout(async () => {
        const i = new F5({
          chain: t,
          logger: this._logger
        });
        try {
          const { amount: s, round: l } = await i.accountInformation(
            rd.fromPublicKey(Dn.decode(e.key)).address()
          );
          return a({
            amount: String(s),
            block: String(l),
            lastUpdatedAt: (/* @__PURE__ */ new Date()).getTime().toString()
          });
        } catch (s) {
          return o(s);
        }
      }, n);
    });
  }
}
const z5 = class extends qa {
  constructor(e) {
    super(e), this._avmBalancesStrategy = new TE(e);
  }
  /**
   * public methods
   */
  /**
   * Delegates the fetching of the balance to the respective strategy.
   *
   * @param {BalanceParameters} parameters - The input parameters.
   * @param {EphemeralAccountStoreItem} parameters.account - The account to get the balance for.
   * @param {Chain} parameters.chain - The [CAIP-002]{@link https://chainagnostic.org/CAIPs/caip-2} chain ID to fetch the
   * balance from.
   * @param {number} [parameters.delay] - An optional delay to apply before sending request.
   * @returns {Promise<Balance>} A promise that resolves to account's balance information.
   * @throws {ChainNotSupportedError} If the chain is not supported.
   * @public
   */
  async balance(e) {
    switch (e.chain.namespace()) {
      case Ht.Algorand:
      case Ht.AVM:
        return await this._avmBalancesStrategy.balance(
          e
        );
      default:
        throw new Un(`namespace "${e.chain.namespace()}" not supported`);
    }
  }
};
z5.displayName = "BalancesContext";
let OE = z5;
const H5 = class q5 extends qa {
  constructor(e) {
    super(e), this._rawMessagePrefix = Vr.decode(q5.messagePrefix);
  }
  /**
   * private methods
   */
  /**
   * Signs the given message using the provided private key.
   *
   * The payload to be signed for AVM messages is the message prefixed with an "MX".
   *
   * @param {AVMSignMessageParameters} params - The input parameters.
   * @param {Uint8Array} params.privateKey - The private key used to sign the message.
   * @param {string | Uint8Array} params.message - A UTF-8 encoded message or raw bytes to sign.
   * @return {Uint8Array} The signature generated from the message signing.
   * @private
   */
  _signMessage({ message: e, privateKey: t }) {
    return sd.sign(
      Ds(this._rawMessagePrefix, typeof e == "string" ? Vr.decode(e) : e),
      t
    );
  }
  /**
   * public methods
   */
  async signMessage({
    account: e,
    message: t
  }) {
    switch (e.__type) {
      case Er.Connected:
        throw new M6("connected accounts not supported");
      case Er.Ephemeral:
        return this._signMessage({
          message: t,
          privateKey: e.keyData
        });
      default:
        throw new Qc("unknown account type");
    }
  }
};
H5.messagePrefix = "MX";
let PE = H5;
const W5 = class extends qa {
  constructor(e) {
    super(e), this._avmSignStrategy = new PE(e);
  }
  /**
   * public methods
   */
  /**
   * Delegates the sign message to the respective strategy. The delegated strategy will handle any connections to
   * external wallets, or if the account is ephemeral, it will sign the message using the chain's standardized method.
   *
   * @param {WithAccountStoreItem<WithChain<Record<'message', string | Uint8Array>>>} params - The input parameters.
   * @param {ConnectedAccountStoreItem | EphemeralAccountStoreItem} params.account - The account to use to sign.
   * @param {Chain} params.chain - The [CAIP-002]{@link https://chainagnostic.org/CAIPs/caip-2} chain ID to use to sign.
   * @param {string | Uint8Array} params.message - A UTF-8 encoded message or raw bytes to sign.
   * @returns {Promise<Uint8Array>} A promise that resolves to the signature of the signed message.
   * @throws {AccountDoesNotExistError} If the account type is invalid.
   * @throws {ChainNotSupportedError} If the chain is not supported.
   * @throws {FailedToSignError} If the account type is connected and failed to sign the message.
   * @public
   */
  async signMessage({
    account: e,
    chain: t,
    message: n
  }) {
    switch (t.namespace()) {
      case Ht.Algorand:
      case Ht.AVM:
        return await this._avmSignStrategy.signMessage({
          account: e,
          message: n
        });
      default:
        throw new Un(`namespace "${t.namespace()}" not supported`);
    }
  }
};
W5.displayName = "SignContext";
let NE = W5;
const Y1 = class K5 extends qa {
  constructor(e) {
    super(e), this._rawPrefix = Vr.decode(K5.transactionPrefix);
  }
  /**
   * private methods
   */
  /**
   * Signs the given transaction using the provided private key. The payload to be signed for AVM transactions are
   * prefixed with a "TX".
   *
   * @param {AVMSignRawTransactionParameters} params - The input parameters.
   * @param {Uint8Array} params.privateKey - The private key used to sign the transaction.
   * @param {Uint8Array} params.transaction - The raw transaction to be signed.
   * @return {Uint8Array} The signature generated from the transaction signing.
   * @private
   */
  _signTransaction({ privateKey: e, transaction: t }) {
    return sd.sign(Ds(this._rawPrefix, t), e);
  }
  /**
   * public methods
   */
  /**
   * Sends a raw transaction to the specified AVM chain and waits for it to be confirmed after a maximum of 4 rounds.
   *
   * @param {WithChain<Record<'signature' | 'transaction', Uint8Array>, Chain<CAIP002Namespace.Algorand | CAIP002Namespace.AVM>>} params - The input parameters.
   * @param {Chain<CAIP002Namespace.Algorand | CAIP002Namespace.AVM>} params.chain - The [CAIP-002]{@link https://chainagnostic.org/CAIPs/caip-2} AVM chain ID.
   * @param {Uint8Array} params.signature - The signature of the signed transaction.
   * @param {Uint8Array} params.transaction - The raw transaction data.
   * @return {Promise<string>} A promise that resolves to the transaction ID of the confirmed transaction.
   * @throws {FailedToFetchChainInformationError} If the default Algod node information cannot be fetched.
   * @throws {FailedToSendTransactionError} If the transaction failed to be submitted to the network, or the transaction
   * failed to be added to the round, after a maximum of 4 rounds.
   * @public
   */
  async sendRawTransaction({
    chain: e,
    signature: t,
    transaction: n
  }) {
    return await new F5({
      chain: e,
      logger: this._logger
    }).sendTransaction({
      signature: t,
      transaction: n
    });
  }
  async signRawTransactions(e) {
    const t = e.filter(
      ({ account: a }) => a.__type === Er.Ephemeral
    ), n = [];
    for (const { account: a, index: o, transaction: i } of t)
      n.push({
        error: null,
        index: o,
        signature: this._signTransaction({
          privateKey: a.keyData,
          transaction: i
        }),
        success: !0
      });
    return n;
  }
};
Y1.displayName = "AVMTransactionStrategy", Y1.transactionPrefix = "TX";
let BE = Y1;
const Y5 = class G5 extends qa {
  constructor(e) {
    super(e), this._avmTransactionStrategy = new BE(e);
  }
  /**
   * public methods
   */
  async sendRawTransaction(e) {
    try {
      switch (e.chain.namespace()) {
        case Ht.Algorand:
        case Ht.AVM:
          return {
            error: null,
            success: !0,
            transactionID: await this._avmTransactionStrategy.sendRawTransaction(
              e
            )
          };
        default:
          return {
            error: new Un(`chain "${e.chain.chainID()}" not supported`),
            success: !1,
            transactionID: null
          };
      }
    } catch (t) {
      return {
        error: t,
        success: !1,
        transactionID: null
      };
    }
  }
  async signRawTransactions(e) {
    const t = `${G5.displayName}#signRawTransactions`, n = e.reduce((o, i) => {
      let s;
      if (!i)
        return o;
      const { account: l, chain: c, index: u, transaction: d } = i;
      return s = o.get(c.namespace()) ?? null, s ? (o.set(c.namespace(), [
        ...s,
        {
          account: l,
          index: u,
          transaction: d
        }
      ]), o) : (o.set(c.namespace(), [
        {
          account: l,
          index: u,
          transaction: d
        }
      ]), o);
    }, /* @__PURE__ */ new Map()).entries();
    let a = [];
    for (const [o, i] of n)
      switch (o) {
        case Ht.Algorand:
        case Ht.AVM:
          a = [...a, ...await this._avmTransactionStrategy.signRawTransactions(i)];
          break;
        default:
          this._logger.warn(`${t}: namespace "${o}" not supported`), a = [
            ...a,
            ...i.map(({ index: s }) => ({
              error: new Un(`namespace "${o}" not supported`),
              index: s,
              signature: null,
              success: !1
            }))
          ];
          break;
      }
    return a;
  }
};
Y5.displayName = "TransactionContext";
let LE = Y5;
const J5 = class En extends qa {
  constructor({ chains: e, clientInformation: t, debug: n = !1, ...a }) {
    super(a), this._accountsStore = null, this._authenticationStore = null, this._pollingBalanceID = null, this._vault = null, this._chains = e, this._clientInformation = t, this._debug = n, this._appManager = new ob(a), this._balancesContext = new OE(a), this._signContext = new NE(a), this._listeners = /* @__PURE__ */ new Map(), this._transactionContext = new LE(a);
  }
  /**
   * private methods
   */
  /**
   * Generates a credential account in the wallet. The credential account is an account derived from the user's
   * credential; for passkeys, this is the key material returned from the passkey; for passwords this is the combination
   * of the username, password and hostname.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @returns {Promise<Account>} A promise that resolves to the generated credential account.
   * @throws {EncryptionError} If the account's private key failed to be encrypted.
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @private
   */
  async _generateCredentialAccountIfNoneExists() {
    var e;
    const t = `${En.displayName}#_generateCredentialAccountIfNoneExists`;
    let n, a, o, i, s, l, c, u, d, w;
    if (!this._accountsStore || !this._authenticationStore || !this._vault)
      throw new yr("not authenticated");
    switch (w = Ra(this._vault), a = await this._accountsStore.accounts(), o = this._chains.reduce(
      (f, A) => ({
        ...f,
        [A.chainID()]: {
          amount: "0",
          block: "0",
          lastUpdatedAt: "0"
        }
      }),
      {}
    ), (e = this._authenticationStore) == null ? void 0 : e.__type) {
      case wr.Passkey:
        if (c = await this._authenticationStore.store.passkey(), !c)
          throw new yr("not authenticated");
        return i = gl.create({
          method: wr.Passkey,
          passkeyCredentialID: c.credentialID
        }), d = await this._authenticationStore.store.derivePrivateKey(), l = Dn.encode(Ch(d)), n = a.find(
          (f) => f.__type === Er.Ephemeral && f.credentialID === i.toString() && f.key === l
        ) ?? null, n ? (this._logger.debug(
          `${t}: credential account "${l}" for user "${w}" using "${this._authenticationStore.__type}" already exists`
        ), {
          __type: n.__type,
          balances: n.balances,
          key: n.key,
          name: n.name,
          origin: n.origin
        }) : (s = await this._authenticationStore.store.encryptBytes(d), n = {
          __type: Er.Ephemeral,
          balances: o,
          credentialID: i.toString(),
          key: l,
          keyData: Dn.encode(s),
          name: w,
          origin: d1.Credential
        }, await this._accountsStore.upsert([n]), this._logger.debug(
          `${t}: created credential account "${l}" for user "${w}" using "${this._authenticationStore.__type}"`
        ), {
          __type: n.__type,
          balances: n.balances,
          key: n.key,
          name: n.name,
          origin: n.origin
        });
      case wr.Password:
        if (u = this._authenticationStore.store.password(), !u)
          throw new yr("not authenticated");
        return i = gl.create({
          method: wr.Password,
          password: u
        }), d = await this._authenticationStore.store.derivePrivateKey(), l = Dn.encode(Ch(d)), n = a.find(
          (f) => f.__type === Er.Ephemeral && f.credentialID === i.toString() && f.key === l
        ) ?? null, n ? (this._logger.debug(
          `${t}: credential account "${l}" for user "${w}" using "${this._authenticationStore.__type}" already exists`
        ), {
          __type: n.__type,
          balances: n.balances,
          key: n.key,
          name: n.name,
          origin: n.origin
        }) : (s = await this._authenticationStore.store.encryptBytes(d), n = {
          __type: Er.Ephemeral,
          balances: o,
          credentialID: i.toString(),
          key: l,
          keyData: Dn.encode(s),
          name: w,
          origin: d1.Credential
        }, await this._accountsStore.upsert([n]), this._logger.debug(
          `${t}: created credential account "${l}" for user "${w}" using "${this._authenticationStore.__type}"`
        ), {
          __type: n.__type,
          balances: n.balances,
          key: n.key,
          name: n.name,
          origin: n.origin
        });
      default:
        throw new yr("not authenticated");
    }
  }
  /**
   * Gets all the listeners by type.
   *
   * @param {ListenerTypes} type - The type of listeners to filter by.
   * @returns {[string, Listener<ListenerTypes>][]} An array of tuples whose first element will be the listener ID and
   * the second element will be the listener.
   * @private
   */
  _listenersByType(e) {
    return Array.from(this._listeners.entries()).filter(([t, { type: n }]) => n === e);
  }
  _startPollingBalances() {
    this._pollingBalanceID = window.setInterval(this._updateBalances.bind(this), km);
  }
  _stopPollingBalances() {
    this._pollingBalanceID && window.clearInterval(this._pollingBalanceID);
  }
  /**
   * Updates the balances for all the ephemeral accounts for each chain. A small delay is added between each fetch on
   * the same chain to avoid rate limits.
   *
   * On completion, a `kv:ev:accounts_updated` is sent to let the app know the application has been updated.
   *
   * @private
   * @async
   */
  async _updateBalances() {
    const e = `${En.displayName}#_updateBalances`;
    let t, n, a;
    if (!(!this._vault || !this._accountsStore)) {
      n = (await this._accountsStore.accounts()).filter(
        ({ __type: o }) => o === Er.Ephemeral
      );
      for (const o of this._chains)
        for (let i = 0; i < n.length; i++) {
          t = n[i];
          try {
            n[i].balances[o.chainID()] = await this._balancesContext.balance({
              account: t,
              chain: o,
              delay: i > 0 ? 0 : xm
              // for accounts on the same network, add a small delay to avoid rate limits
            });
          } catch (s) {
            this._logger.error(`${e}:`, s);
          }
        }
      await this._accountsStore.upsert(n), a = Ra(this._vault), this._logger.debug(`${e}: updated balances for user "${a}"`), window.dispatchEvent(new al(a));
    }
  }
  /**
   * public methods
   */
  /**
   * Gets a list of accounts within the vault.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @returns {Promise<Account[]>} A promise that resolves to the accounts stored in the vault.
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @public
   */
  async accounts() {
    let e;
    if (!this.isAuthenticated() || !this._accountsStore)
      throw new yr("not authenticated");
    return e = await this._accountsStore.accounts(), e.map(({ __type: t, key: n, name: a }) => ({
      __type: t,
      key: n,
      name: a
    }));
  }
  /**
   * Adds the new chain to the list of supported chains if it does not already exist, otherwise it updates the existing
   * chain by the CAIP-002 chain ID.
   *
   * @param {ChainConstructor} chain - The chain to be added.
   * @throws {FailedToFetchChainInformationError} If the chain failed to fetch the chain information.
   * @public
   */
  async addChain(e) {
    const t = `${En.displayName}#addChain`;
    let n, a;
    try {
      switch (e.namespace) {
        case Ht.Algorand:
        case Ht.AVM:
          n = await e.initialize();
          break;
        default:
          throw new Un(`chain "${e.namespace}" not supported`);
      }
    } catch (o) {
      throw o.isKatavaultError ? o : (this._logger.error(`${t}: failed to add chain "${e.displayName}" - `, o), new u1(o.message));
    }
    if (a = this._chains.findIndex((o) => o.chainID() === n.chainID()), a >= 0) {
      this._chains[a] = n;
      return;
    }
    this._chains.push(n);
  }
  /**
   * Opens up a modal to allow the user to choose how to authenticate.
   *
   * @throws {DecryptionError} If the stored challenge failed to be decrypted.
   * @throws {FailedToAuthenticatePasskeyError} If the authenticator did not return the public key credentials.
   * @throws {FailedToRegisterPasskeyError} If the public key credentials failed to be created on the authenticator.
   * @throws {InvalidPasswordError} If supplied password does not match the stored password.
   * @throws {PasskeyNotSupportedError} If the browser does not support WebAuthn or the authenticator does not support.
   * @throws {UserCanceledPasskeyRequestError} If the user canceled the request or the request timed out.
   * @throws {UserCanceledUIRequestError} If the user canceled the request.
   * @public
   */
  async authenticate() {
    const { authenticationStore: e, vault: t } = await this._appManager.renderAuthenticationApp({
      clientInformation: this._clientInformation,
      debug: this._debug
    });
    this._accountsStore = new Ma({
      logger: this._logger,
      vault: t
    }), this._authenticationStore = e, this._vault = t, await this._generateCredentialAccountIfNoneExists(), await this._updateBalances(), this._startPollingBalances();
  }
  /**
   * Authenticates with a passkey.
   *
   * @param {AuthenticateWithPasskeyParameters} params - The user information.
   * @param {string} params.username - A globally unique identifier for the user. This could be, for example, an email
   * address.
   * @throws {FailedToAuthenticatePasskeyError} If the authenticator did not return the public key credentials.
   * @throws {FailedToRegisterPasskeyError} If the public key credentials failed to be created on the authenticator.
   * @throws {PasskeyNotSupportedError} If the browser does not support WebAuthn or the authenticator does not support.
   * @throws {UserCanceledPasskeyRequestError} If the user canceled the request or the request timed out.
   * @public
   */
  async authenticateWithPasskey({ username: e }) {
    const t = await b1({
      logger: this._logger,
      username: e
    });
    this._authenticationStore = {
      __type: wr.Passkey,
      store: await l3({
        clientInformation: this._clientInformation,
        logger: this._logger,
        username: e,
        vault: t
      })
    }, this._accountsStore = new Ma({
      logger: this._logger,
      vault: t
    }), this._vault = t, await this._generateCredentialAccountIfNoneExists(), await this._updateBalances(), this._startPollingBalances();
  }
  /**
   * Authenticates with the supplied password.
   *
   * @param {AuthenticateWithPasswordParameters} params - The password and user information.
   * @param {string} params.password - The password.
   * @param {string} params.username - A globally unique identifier for the user. This could be, for example, an email
   * address.
   * @throws {DecryptionError} If the stored challenge failed to be decrypted.
   * @throws {InvalidPasswordError} If supplied password does not match the stored password.
   * @throws {PasswordTooWeakError} If this is a new sign-up, and the supplied password does not have enough entropy.
   * @public
   * @async
   */
  async authenticateWithPassword({ password: e, username: t }) {
    const n = await b1({
      logger: this._logger,
      username: t
    });
    this._authenticationStore = {
      __type: wr.Password,
      store: await u3({
        clientInformation: this._clientInformation,
        logger: this._logger,
        password: e,
        username: t,
        vault: n
      })
    }, this._accountsStore = new Ma({
      logger: this._logger,
      vault: n
    }), this._vault = n, await this._generateCredentialAccountIfNoneExists(), await this._updateBalances(), this._startPollingBalances();
  }
  /**
   * Gets the supported chains.
   *
   * @returns {Chain[]} The supported chains.
   * @public
   */
  chains() {
    return this._chains;
  }
  /**
   * Deletes all accounts, settings and data from the vault.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * 🚨 **WARNING:** Use with extreme caution. This is action is irreversible.
   *
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @public
   * @async
   */
  async clearVault() {
    const e = `${En.displayName}#clearVault`;
    let t;
    if (!this.isAuthenticated())
      throw new yr("not authenticated");
    this._stopPollingBalances(), [Vn.Authentication, Vn.Vault].forEach((n) => this._appManager.closeApp(n)), this._vault && (await this._vault.clear(zo), await this._vault.clear(hl), await this._vault.clear(bs), await this._vault.clear(fl), this._vault.close()), this._authenticationStore = null, this._accountsStore = null, this._vault = null, t = this._listenersByType("vault_cleared"), t.forEach(([n, a]) => a.callback()), this._logger.debug(`${e} - cleared vault`);
  }
  /**
   * Gets the holding accounts of the vault. If no holding accounts exist, a new one is created from the saved
   * credentials.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @returns {Promise<[Account, ...Account[]]>} A promise that resolves to the holding accounts stored in the vault.
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @throws {EncryptionError} If the account's private key failed to be encrypted.
   * @public
   */
  async holdingAccounts() {
    let e = (await this.accounts()).filter(({ __type: t }) => t === Er.Ephemeral);
    return e.length > 0 ? e : [await this._generateCredentialAccountIfNoneExists()];
  }
  /**
   * Checks if Katavault has been authenticated.
   *
   * @returns {boolean} True if Katavault is authenticated, false otherwise.
   * @public
   */
  isAuthenticated() {
    return !!this._authenticationStore;
  }
  /**
   * Logs the user out and closes the vault.
   *
   * @public
   */
  logout() {
    const e = `${En.displayName}#logout`;
    let t, n = null;
    this._stopPollingBalances(), [Vn.Authentication, Vn.Vault].forEach((a) => this._appManager.closeApp(a)), this._vault && (n = Ra(this._vault), this._vault.close()), this._authenticationStore = null, this._accountsStore = null, this._vault = null, n && window.dispatchEvent(new _7(n)), t = this._listenersByType("logout"), t.forEach(([a, o]) => o.callback()), this._logger.debug(`${e} - logged out`);
  }
  /**
   * Adds a listener to be invoked upon the event type.
   *
   * @param {'logout'} type - The event type.
   * @param {() => Promise<void> | void} callback - The callback to be invoked.
   * @returns {string} The ID for the listener.
   * @public
   */
  addListener(e, t) {
    const n = Z2();
    return this._listeners.set(n, {
      callback: t,
      type: e
    }), n;
  }
  /**
   * Opens the vault application.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @public
   */
  openVault() {
    let e;
    if (!this._authenticationStore || !this._vault)
      throw new yr("not authenticated");
    e = {
      authenticationStore: this._authenticationStore,
      chains: this._chains,
      onLogout: () => this.logout(),
      vault: this._vault
    }, (async () => await this._appManager.renderVaultApp({
      ...e,
      clientInformation: this._clientInformation,
      debug: this._debug
    }))();
  }
  /**
   * Removes the account from the vault for the specified key if it exists.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @param {string} key - The base58 encoded public key of the account to remove from the vault.
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @public
   */
  async removeAccountByKey(e) {
    const t = `${En.displayName}#removeAccountByKey`;
    let n;
    if (!this.isAuthenticated() || !this._vault)
      throw new yr("not authenticated");
    n = await (this._accountsStore ?? new Ma({
      logger: this._logger,
      vault: this._vault
    })).remove([e]), this._logger.debug(`${t}: removed accounts [${n.map((a) => `"${a}"`).join(",")}]`), window.dispatchEvent(new al(Ra(this._vault)));
  }
  /**
   * Removes all listeners.
   * @public
   */
  removeAllListeners() {
    const e = `${En.displayName}#_removeAllListeners`, t = this._listeners.size;
    this._listeners.clear(), this._logger.debug(`${e} - removed "${t}" listeners`);
  }
  /**
   * Removes a chain from the list of supported chains based on the CAIP-002 chain ID.
   *
   * @param {string} chainID - The CAIP-002 chain ID of the chain to be removed.
   * @public
   */
  removeChainByChainID(e) {
    this._chains = this._chains.filter((t) => t.chainID() !== e);
  }
  /**
   * Removes the listener by the supplied ID.
   *
   * @param {string} id - The ID of the listener to remove.
   * @returns {boolean} `true` of the listener existed, `false` otherwise.
   * @public
   */
  removeListener(e) {
    return this._listeners.delete(e);
  }
  /**
   * Sends a list of raw transactions, along with their signatures, to the specified chain. The corresponding array will
   * contain whether the transaction submission was successful, the transaction ID and an error if the transaction
   * submission was unsuccessful. The index of the result array will match that of the supplied transaction array.
   *
   * @param {SendRawTransactionParameters[]} parameters - An array containing the chain ID, the raw transaction and
   * the signature of the signed transaction.
   * @return {Promise<SendRawTransactionResult[]>} A promise that resolves to an array of results that will contain
   * whether the transaction submission was successful, the transaction ID and an error if the transaction submission was unsuccessful.
   * Each element's index in the result list corresponds to the supplied parameter list indices.
   * @public
   */
  async sendRawTransactions(e) {
    const t = `${En.displayName}#sendRawTransactions`, n = Array.from(
      { length: e.length },
      () => ({
        error: null,
        success: !1,
        transactionID: null
      })
    );
    let a;
    for (let o = 0; o < e.length; o++) {
      const { chainID: i, signature: s, transaction: l } = e[o];
      if (a = this._chains.find((c) => c.chainID() === i) ?? null, !a) {
        this._logger.warn(`${t}: chain "${i}", at transaction index "${o}", not supported`), n[o] = {
          error: new Un(`chain "${i}" not supported`),
          success: !1,
          transactionID: null
        };
        continue;
      }
      n[o] = await this._transactionContext.sendRawTransaction({
        chain: a,
        signature: s,
        transaction: l
      });
    }
    return n;
  }
  /**
   * Updates the name of an account by its key.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @param {SetAccountNameByKeyParameters} params - The key of the account and the new name to set.
   * @param {string} params.key - The base58 encoded public key of the account.
   * @param {string} params.name - The new name for the account.
   * @returns {Promise<Account>} A promise that resolves to the updated account.
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @throws {AccountDoesNotExistError} If the specified key does not exist in the vault.
   * @public
   */
  async setAccountNameByKey({ key: e, name: t }) {
    let n, a;
    if (!this.isAuthenticated() || !this._vault)
      throw new yr("not authenticated");
    if (a = this._accountsStore ?? new Ma({
      logger: this._logger,
      vault: this._vault
    }), n = await a.accountByKey(e), !n)
      throw new Qc(`account "${e}" does not exist`);
    return await a.upsert([
      {
        ...n,
        name: t
      }
    ]), window.dispatchEvent(new al(Ra(this._vault))), {
      __type: n.__type,
      key: e,
      name: t
    };
  }
  /**
   * Signs and sends an array of raw transactions using the appropriate account and chain. The corresponding array will
   * contain whether the transaction submission was successful, the transaction ID and an error if the transaction
   * submission was unsuccessful. The index of the result array will match that of the supplied transaction array.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @param {SignRawTransactionParameters[]} parameters - An array containing the base58 encoded account key, the chain
   * ID and the raw transaction to be signed.
   * @return {Promise<SendRawTransactionResult[]>} A promise that resolves to an array of results that will contain
   * whether the transaction signed and submitted was successfully, the transaction ID and an error if the transaction signing or submission was unsuccessful.
   * Each element's index in the result list corresponds to the supplied parameter list indices.
   * @throws {NotAuthenticatedError} If the user is not authenticated.
   * @public
   */
  async signAndSendRawTransactions(e) {
    const t = `${En.displayName}#signAndSendRawTransactions`;
    let n;
    if (!this.isAuthenticated() || !this._vault)
      throw new yr("not authenticated");
    return n = await this.signRawTransactions(e), await Promise.all(
      n.map(async ({ error: a, success: o, signature: i }, s) => {
        let l;
        if (a || !i || !o)
          return {
            error: a,
            success: o,
            transactionID: null
          };
        const { chainID: c, transaction: u } = e[s];
        return l = this._chains.find((d) => d.chainID() === c) ?? null, l ? await this._transactionContext.sendRawTransaction({
          chain: l,
          signature: i,
          transaction: u
        }) : (this._logger.warn(`${t}: chain "${c}", at transaction index "${s}", not supported`), {
          error: new Un(`chain "${c}" not supported`),
          success: !1,
          transactionID: null
        });
      })
    );
  }
  /**
   * Signs a message or some arbitrary bytes using the appropriate account and chain.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @param {SignMessageParameters} params - The input parameters.
   * @param {string} params.accountKey - The base58 public key of the account that will be used for signing.
   * @param {string} params.chainID - The CAIP-002 chain ID.
   * @param {Encoding} [params.encoding] - The output encoding of the signature. If no encoding is specified, the
   * signature will be as raw bytes (Uint8Array).
   * @param {string | Uint8Array} params.message - A UTF-8 encoded message or raw bytes to sign.
   * @returns {Promise<string | Uint8Array>} A promise that resolves to the signature of the signed message. If the
   * encoding parameter was specified, the signature will be encoded in that format, otherwise the signature will be in
   * raw bytes.
   * @throws {NotAuthenticatedError} If Katavault has not been authenticated.
   * @throws {ChainNotSupportedError} If the specified chain is not supported.
   * @throws {AccountDoesNotExistError} If the specified address does not exist in the vault.
   * @throws {AuthenticationMethodNotSupportedError} If the authentication method is not supported.
   * @throws {DecryptionError} If there was an issue with decryption, or if the key was encrypted with the incorrect
   * credentials.
   * @public
   */
  async signMessage({
    accountKey: e,
    chainID: t,
    encoding: n,
    message: a
  }) {
    var o;
    let i, s, l;
    if (!this._authenticationStore || !this._vault)
      throw new yr("not authenticated");
    if (s = this._chains.find((c) => c.chainID() === t) ?? null, !s)
      throw new Un(`chain "${t}" not supported`);
    if (i = await (this._accountsStore ?? new Ma({
      logger: this._logger,
      vault: this._vault
    })).accountByKey(e), !i)
      throw new Qc(`account "${e}" does not exist`);
    switch (l = await this._signContext.signMessage({
      account: i.__type === Er.Ephemeral ? await ((o = this._authenticationStore) == null ? void 0 : o.store.decryptEphemeralAccount(i)) : i,
      chain: s,
      message: a
    }), n) {
      case "base64":
        return cn.encode(l);
      case "hex":
        return Q1.encode(l);
      default:
        return l;
    }
  }
  /**
   * Signs an array of raw transactions using the appropriate account and chain. The corresponding array will
   * contain whether the transaction signing was successful, the signature (if successful) and an error if the
   * transaction signing was unsuccessful. The index of the result array will match that of the supplied transaction
   * array.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @param {SignRawTransactionParameters[]} parameters - An array containing the base58 encoded account key, the chain
   * ID and the raw transaction to be signed.
   * @return {Promise<SignRawTransactionResult[]>} A promise that resolves to an array of results that will contain
   * whether the transaction was signed successfully, the signature (if successful) and an error if the transaction
   * signing was unsuccessful. Each element's index in the result list corresponds to the supplied parameter list
   * indices.
   * @throws {NotAuthenticatedError} If the user is not authenticated.
   * @public
   */
  async signRawTransactions(e) {
    const t = `${En.displayName}#signRawTransactions`;
    let n, a, o, i, s;
    if (!this._authenticationStore || !this._vault)
      throw new yr("not authenticated");
    o = [], i = Array.from({ length: e.length }, () => ({
      error: null,
      signature: null,
      success: !1
    }));
    for (let l = 0; l < e.length; l++) {
      const { accountKey: c, chainID: u, transaction: d } = e[l];
      if (a = this._chains.find((w) => w.chainID() === u) ?? null, !a) {
        this._logger.warn(`${t}: chain "${u}", at transaction index "${l}", not supported`), i[l] = {
          error: new Un(`chain "${u}" not supported`),
          success: !1,
          signature: null
        };
        continue;
      }
      if (n = await (this._accountsStore ?? new Ma({
        logger: this._logger,
        vault: this._vault
      })).accountByKey(c), !n) {
        this._logger.warn(`account "${c}", at transaction index "${l}", does not exist`), i[l] = {
          error: new Qc(`account "${c}" does not exist`),
          success: !1,
          signature: null
        };
        continue;
      }
      o.push({
        account: n.__type === Er.Ephemeral ? await this._authenticationStore.store.decryptEphemeralAccount(n) : n,
        chain: a,
        index: l,
        transaction: d
      });
    }
    return s = await this._transactionContext.signRawTransactions(o), s.forEach(({ index: l, ...c }) => i[l] = c), i;
  }
  /**
   * Gets the username for the authenticated user or null if Katavault is not authenticated.
   *
   * ⚠️ **NOTE:** Requires authentication.
   *
   * @returns {string} The username of the logged-in user.
   * @throws {NotAuthenticatedError} If the user is not authenticated.
   */
  username() {
    if (!this._vault)
      throw new yr("not authenticated");
    return Ra(this._vault);
  }
};
J5.displayName = "Katavault";
let UE = J5;
const fr = X5({
  timestamp: 0,
  onUpdate: null,
  katavault: null
}), ux = ({ config: r, children: e }) => {
  const [t, n] = io(0), [a, o] = io(null), i = aa(() => n(Date.now()), [n]);
  return so(() => {
    (async () => (o(await t7(r)), n(Date.now())))();
  }, [r]), Z5(fr.Provider, {
    value: {
      timestamp: t,
      onUpdate: i,
      katavault: a
    }
  }, e);
}, VE = "NOT_INITIALIZED_ERROR";
class Dr extends hr {
  constructor() {
    super(...arguments), this.type = VE;
  }
}
function dx() {
  const { katavault: r } = vr(fr), [e, t] = io([]), n = aa(async () => {
    !r || !r.isAuthenticated() || t(await r.accounts());
  }, [t, r]), a = aa(
    async (o) => {
      !r || r.username() !== o.detail.username || await n();
    },
    [n, r]
  );
  return so(() => {
    (async () => await n())();
  }, []), so(() => (window.addEventListener(Gr.AccountsUpdated, a), () => window.removeEventListener(Gr.AccountsUpdated, a)), [a]), e;
}
function hx() {
  const { katavault: r } = vr(fr), [e, t] = io([]), n = aa(async () => {
    !r || !r.isAuthenticated() || t(await r.holdingAccounts());
  }, [t, r]), a = aa(
    async (o) => {
      !r || r.username() !== o.detail.username || await n();
    },
    [n, r]
  );
  return so(() => {
    (async () => await n())();
  }, []), so(() => (window.addEventListener(Gr.AccountsUpdated, a), () => window.removeEventListener(Gr.AccountsUpdated, a)), [a]), e;
}
function fx() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t, n) => {
    (async () => {
      var a, o, i;
      if (!e)
        return (a = n == null ? void 0 : n.onError) == null ? void 0 : a.call(n, new Dr("katavault not initialized"), t);
      try {
        return await e.removeAccountByKey(t), r == null || r(), (o = n == null ? void 0 : n.onSuccess) == null ? void 0 : o.call(n, void 0, t);
      } catch (s) {
        return (i = n == null ? void 0 : n.onError) == null ? void 0 : i.call(n, s, t);
      }
    })();
  };
}
function px() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t, n) => {
    (async () => {
      var o, i, s;
      let a;
      if (!e)
        return (o = n == null ? void 0 : n.onError) == null ? void 0 : o.call(n, new Dr("katavault not initialized"), t);
      try {
        return a = await e.setAccountNameByKey(t), r == null || r(), (i = n == null ? void 0 : n.onSuccess) == null ? void 0 : i.call(n, a, t);
      } catch (l) {
        return (s = n == null ? void 0 : n.onError) == null ? void 0 : s.call(n, l, t);
      }
    })();
  };
}
function gx() {
  const { onUpdate: r, katavault: e } = vr(fr), [t, n] = io(!1), [a, o] = io(!1), i = aa(
    (u) => {
      (async () => {
        var d, w, f;
        if (!e)
          return (d = u == null ? void 0 : u.onError) == null ? void 0 : d.call(u, new Dr("katavault not initialized"), void 0);
        o(!0);
        try {
          await e.authenticate(), r == null || r(), n(e.isAuthenticated()), (w = u == null ? void 0 : u.onSuccess) == null || w.call(u, void 0, void 0);
        } catch (A) {
          return (f = u == null ? void 0 : u.onError) == null ? void 0 : f.call(u, A, void 0);
        } finally {
          o(!1);
        }
      })();
    },
    [e, n, o]
  ), s = aa(
    (u, d) => {
      (async () => {
        var w, f, A;
        if (!e)
          return (w = d == null ? void 0 : d.onError) == null ? void 0 : w.call(d, new Dr("katavault not initialized"), u);
        o(!0);
        try {
          await e.authenticateWithPasskey(u), r == null || r(), n(e.isAuthenticated()), (f = d == null ? void 0 : d.onSuccess) == null || f.call(d, void 0, u);
        } catch (b) {
          return (A = d == null ? void 0 : d.onError) == null ? void 0 : A.call(d, b, u);
        } finally {
          o(!1);
        }
      })();
    },
    [e, n, o]
  ), l = aa(
    (u, d) => {
      (async () => {
        var w, f, A;
        if (!e)
          return (w = d == null ? void 0 : d.onError) == null ? void 0 : w.call(d, new Dr("katavault not initialized"), u);
        o(!0);
        try {
          await e.authenticateWithPassword(u), r == null || r(), n(e.isAuthenticated()), (f = d == null ? void 0 : d.onSuccess) == null || f.call(d, void 0, u);
        } catch (b) {
          return (A = d == null ? void 0 : d.onError) == null ? void 0 : A.call(d, b, u);
        } finally {
          o(!1);
        }
      })();
    },
    [e, n, o]
  ), c = aa(() => {
    e && n(e.isAuthenticated());
  }, [e, n]);
  return so(() => (window.addEventListener(Gr.Logout, c), () => window.removeEventListener(Gr.Logout, c)), [c]), {
    authenticate: i,
    authenticateWithPasskey: s,
    authenticateWithPassword: l,
    isAuthenticated: t,
    isAuthenticating: a
  };
}
function mx() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t) => {
    (async () => {
      var n, a, o;
      if (!e)
        return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), void 0);
      try {
        return e.logout(), r == null || r(), (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, void 0, void 0);
      } catch (i) {
        return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, void 0);
      }
    })();
  };
}
function yx() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t, n) => {
    (async () => {
      var a, o, i;
      if (!e)
        return (a = n == null ? void 0 : n.onError) == null ? void 0 : a.call(n, new Dr("katavault not initialized"), t);
      try {
        return await e.addChain(t), r == null || r(), (o = n == null ? void 0 : n.onSuccess) == null ? void 0 : o.call(n, void 0, t);
      } catch (s) {
        return (i = n == null ? void 0 : n.onError) == null ? void 0 : i.call(n, s, t);
      }
    })();
  };
}
function wx() {
  const { katavault: r, timestamp: e } = vr(fr), [t, n] = io([]);
  return so(() => {
    r && n(r.chains());
  }, [e]), t;
}
function vx() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t, n) => {
    (async () => {
      var a, o, i;
      if (!e)
        return (a = n == null ? void 0 : n.onError) == null ? void 0 : a.call(n, new Dr("katavault not initialized"), t);
      try {
        return e.removeChainByChainID(t), r == null || r(), (o = n == null ? void 0 : n.onSuccess) == null ? void 0 : o.call(n, void 0, t);
      } catch (s) {
        return (i = n == null ? void 0 : n.onError) == null ? void 0 : i.call(n, s, t);
      }
    })();
  };
}
function _x() {
  return vr(fr).katavault;
}
function bx() {
  const { katavault: r } = vr(fr);
  return (e, t) => {
    (async () => {
      var n, a, o;
      if (!r)
        return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), e);
      try {
        const i = await r.signMessage(e);
        return (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, i, e);
      } catch (i) {
        return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, e);
      }
    })();
  };
}
function Sx() {
  const { katavault: r } = vr(fr);
  return (e, t) => {
    (async () => {
      var n, a, o;
      if (!r)
        return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), e);
      try {
        const i = await r.sendRawTransactions(e);
        return (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, i, e);
      } catch (i) {
        return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, e);
      }
    })();
  };
}
function Ex() {
  const { katavault: r } = vr(fr);
  return (e, t) => {
    (async () => {
      var n, a, o;
      if (!r)
        return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), e);
      try {
        const i = await r.signAndSendRawTransactions(e);
        return (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, i, e);
      } catch (i) {
        return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, e);
      }
    })();
  };
}
function xx() {
  const { katavault: r } = vr(fr);
  return (e, t) => {
    (async () => {
      var n, a, o;
      if (!r)
        return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), e);
      try {
        const i = await r.signRawTransactions(e);
        return (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, i, e);
      } catch (i) {
        return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, e);
      }
    })();
  };
}
var $E = Object.defineProperty, jE = (r, e, t) => e in r ? $E(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, d2 = (r, e, t) => jE(r, typeof e != "symbol" ? e + "" : e, t);
const h2 = 65536;
class FE {
  constructor() {
    d2(this, "isAvailable", !1), d2(this, "isInstantiated", !1), typeof crypto < "u" && "getRandomValues" in crypto && (this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    const t = new Uint8Array(e);
    for (let n = 0; n < t.length; n += h2)
      crypto.getRandomValues(t.subarray(n, n + Math.min(t.length - n, h2)));
    return t;
  }
}
new FE();
function $d(r = "error") {
  const e = (t) => {
    switch (r) {
      case "error":
        return t === "error";
      case "warn":
        return t === "error" || t === "warn";
      case "info":
        return t === "error" || t === "warn" || t === "info";
      case "debug":
        return !0;
      default:
        return !1;
    }
  };
  return {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    debug: (t, ...n) => e("debug") && console.log(`\x1B[34m[DEBUG]\x1B[0m ${t}`, ...n),
    error: (t, ...n) => e("error") && console.log(`\x1B[31m[ERROR]\x1B[0m ${t}`, ...n),
    info: (t, ...n) => e("info") && console.log(`\x1B[37m[INFO]\x1B[0m ${t}`, ...n),
    success: (t, ...n) => e("info") && console.log(`\x1B[32m[SUCCESS]\x1B[0m ${t}`, ...n),
    warn: (t, ...n) => e("warn") && console.log(`\x1B[33m[WARN]\x1B[0m ${t}`, ...n)
    /* eslint-enable @typescript-eslint/no-explicit-any */
  };
}
function kx() {
  const { katavault: r } = vr(fr), e = G1(() => $d("error"), []);
  return (r == null ? void 0 : r.addListener) ?? (() => {
    const t = "katavault not initialized";
    throw e.error(`useAddListener - ${t}`), new Dr(t);
  });
}
function Ax() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t) => {
    (async () => {
      var n, a, o;
      if (!e)
        return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), void 0);
      try {
        return await e.clearVault(), r == null || r(), (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, void 0, void 0);
      } catch (i) {
        return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, void 0);
      }
    })();
  };
}
function Cx() {
  const { onUpdate: r, katavault: e } = vr(fr);
  return (t) => {
    var n, a, o;
    if (!e)
      return (n = t == null ? void 0 : t.onError) == null ? void 0 : n.call(t, new Dr("katavault not initialized"), void 0);
    try {
      return e.openVault(), r == null || r(), (a = t == null ? void 0 : t.onSuccess) == null ? void 0 : a.call(t, void 0, void 0);
    } catch (i) {
      return (o = t == null ? void 0 : t.onError) == null ? void 0 : o.call(t, i, void 0);
    }
  };
}
function Dx() {
  const { katavault: r } = vr(fr), e = G1(() => $d("error"), []);
  return (r == null ? void 0 : r.removeAllListeners) ?? (() => {
    const t = "katavault not initialized";
    throw e.error(`useAddListener - ${t}`), new Dr(t);
  });
}
function Mx() {
  const { katavault: r } = vr(fr), e = G1(() => $d("error"), []);
  return (r == null ? void 0 : r.removeListener) ?? (() => {
    const t = "katavault not initialized";
    throw e.error(`useAddListener - ${t}`), new Dr(t);
  });
}
export {
  fr as KatavaultContext,
  ux as KatavaultProvider,
  VE as NOT_INITIALIZED_ERROR,
  Dr as NotInitializedError,
  dx as useAccounts,
  yx as useAddChain,
  kx as useAddListener,
  gx as useAuthenticate,
  wx as useChains,
  Ax as useClearVault,
  hx as useHoldingAccounts,
  _x as useKatavault,
  mx as useLogout,
  Cx as useOpenVault,
  fx as useRemoveAccountByKey,
  Dx as useRemoveAllListeners,
  vx as useRemoveChainByChainID,
  Mx as useRemoveListener,
  Sx as useSendRawTransactions,
  px as useSetAccountNameByKey,
  Ex as useSignAndSendRawTransactions,
  bx as useSignMessage,
  xx as useSignRawTransactions
};
//# sourceMappingURL=index.js.map
